import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The built-in `Decimal` scalar type. */
  Decimal: any;
  /**
   * The `Long` scalar type represents non-fractional signed whole 64-bit numeric
   * values. Long can represent values between -(2^63) and 2^63 - 1.
   */
  Long: any;
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: any;
  UUID: any;
};

export type Account = {
  code?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type: AccountType;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
};

export type AccountDtoInput = {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type: AccountType;
  userId?: InputMaybe<Scalars['String']>;
};

export type AccountFilterInput = {
  and?: InputMaybe<Array<AccountFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccountFilterInput>>;
  type?: InputMaybe<AccountTypeOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type AccountSortInput = {
  code?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export enum AccountType {
  Customer = 'CUSTOMER',
  Money = 'MONEY',
  Supplier = 'SUPPLIER'
}

export type AccountTypeOperationFilterInput = {
  eq?: InputMaybe<AccountType>;
  in?: InputMaybe<Array<AccountType>>;
  neq?: InputMaybe<AccountType>;
  nin?: InputMaybe<Array<AccountType>>;
};

/** A connection to a list of items. */
export type AccountsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<AccountsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Account>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AccountsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Account>;
};

export type AddSubjectDtoInput = {
  acAddress?: InputMaybe<Scalars['String']>;
  acBuyer?: InputMaybe<Scalars['String']>;
  acName2?: InputMaybe<Scalars['String']>;
  acPayMethod?: InputMaybe<Scalars['String']>;
  acPin?: InputMaybe<Scalars['String']>;
  acPost?: InputMaybe<Scalars['String']>;
  acSkis?: InputMaybe<Scalars['String']>;
  acSubject: Scalars['String'];
  acSupplier?: InputMaybe<Scalars['String']>;
  acWayOfSale?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  docId?: InputMaybe<Scalars['Int']>;
};

export type AddTHeSetSubjContactAddressDtoInput = {
  acNote?: InputMaybe<Scalars['String']>;
  acPhone?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acType?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
};

export type AddTHeSetSubjContactDtoInput = {
  acActive?: InputMaybe<Scalars['String']>;
  acFunction?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acSurname?: InputMaybe<Scalars['String']>;
};

export type AddTMnDocumentDtoInput = {
  acStatus?: InputMaybe<Scalars['String']>;
  anClassifIcationQid?: InputMaybe<Scalars['Int']>;
  anMailBoxQid?: InputMaybe<Scalars['Int']>;
  anStorageQid?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  note?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AddTMnFileDtoInput = {
  fileContent?: InputMaybe<Array<Scalars['Byte']>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  tMnDocumentId: Scalars['Int'];
};

export enum AiSupportRunBudgetMode {
  Bounded = 'BOUNDED',
  RunUntilTerminal = 'RUN_UNTIL_TERMINAL'
}

export type AiSupportRunBudgetModeOperationFilterInput = {
  eq?: InputMaybe<AiSupportRunBudgetMode>;
  in?: InputMaybe<Array<AiSupportRunBudgetMode>>;
  neq?: InputMaybe<AiSupportRunBudgetMode>;
  nin?: InputMaybe<Array<AiSupportRunBudgetMode>>;
};

export type AllActiveAccountsDto = {
  customer?: Maybe<Array<Maybe<AllActiveAccountsDtoAccountDto>>>;
  money?: Maybe<Array<Maybe<AllActiveAccountsDtoAccountDto>>>;
  supplier?: Maybe<Array<Maybe<AllActiveAccountsDtoAccountDto>>>;
};

export type AllActiveAccountsDtoAccountDto = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  type: AccountType;
};

export type AnalysisBalanceForCustomerDto = {
  due: Scalars['Decimal'];
  period: Scalars['Decimal'];
};

export type AnalysisCurrencyTotal = {
  credit: Scalars['Decimal'];
  creditInCurrency: Scalars['Decimal'];
  currency?: Maybe<Scalars['String']>;
  debit: Scalars['Decimal'];
  debitInCurrency: Scalars['Decimal'];
  totalCredit: Scalars['Decimal'];
  totalCreditInCurrency: Scalars['Decimal'];
  totalDebit: Scalars['Decimal'];
  totalDebitInCurrency: Scalars['Decimal'];
  value: Scalars['Decimal'];
  valueInCurrency: Scalars['Decimal'];
};

export type AnalysisDocumentPerCustomerDto = {
  date: Scalars['DateTime'];
  document?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
};

export type AnalysisTotalsDto = {
  customer?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
  money?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
  supplier?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
};

export type AnalysisTotalsPerAccountDto = {
  account?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
};

export type AnalysisTotalsPerCustomerDto = {
  customer?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
};

export type ApplicationPacket = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  from: Scalars['DateTime'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  packet: ApplicationPacketEnum;
  to: Scalars['DateTime'];
};

export enum ApplicationPacketEnum {
  ActivityReports = 'ACTIVITY_REPORTS',
  BusinessAnalytics = 'BUSINESS_ANALYTICS',
  Declarations = 'DECLARATIONS',
  DmsNotifications = 'DMS_NOTIFICATIONS',
  Documents = 'DOCUMENTS',
  DynDnsHealthcheck = 'DYN_DNS_HEALTHCHECK',
  MarservisWorkOrders = 'MARSERVIS_WORK_ORDERS',
  OnixPhoneDocumentsOverview = 'ONIX_PHONE_DOCUMENTS_OVERVIEW',
  PantheonSubjectsSync = 'PANTHEON_SUBJECTS_SYNC',
  SettingsSynchronization = 'SETTINGS_SYNCHRONIZATION',
  Support = 'SUPPORT',
  TravelWarrants = 'TRAVEL_WARRANTS',
  TravelWarrants2 = 'TRAVEL_WARRANTS2',
  UserSynchronization = 'USER_SYNCHRONIZATION',
  WebDocuments = 'WEB_DOCUMENTS',
  WooCommerce = 'WOO_COMMERCE',
  WorkRecords = 'WORK_RECORDS',
  WorkRecords2 = 'WORK_RECORDS2'
}

export type ApplicationPacketEnumOperationFilterInput = {
  eq?: InputMaybe<ApplicationPacketEnum>;
  in?: InputMaybe<Array<ApplicationPacketEnum>>;
  neq?: InputMaybe<ApplicationPacketEnum>;
  nin?: InputMaybe<Array<ApplicationPacketEnum>>;
};

export type ApplicationPacketFilterInput = {
  and?: InputMaybe<Array<ApplicationPacketFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  from?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationPacketFilterInput>>;
  packet?: InputMaybe<ApplicationPacketEnumOperationFilterInput>;
  to?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type ApplicationRole = {
  concurrencyStamp?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['String']>;
  userRoles?: Maybe<Array<Maybe<ApplicationUserRole>>>;
};

export type ApplicationRoleFilterInput = {
  and?: InputMaybe<Array<ApplicationRoleFilterInput>>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationRoleFilterInput>>;
  userRoles?: InputMaybe<ListFilterInputTypeOfApplicationUserRoleFilterInput>;
};

export type ApplicationRoleSortInput = {
  concurrencyStamp?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  normalizedName?: InputMaybe<SortEnumType>;
};

export type ApplicationUser = {
  accessFailedCount: Scalars['Int'];
  accountingForUsers?: Maybe<Array<Maybe<ApplicationUser>>>;
  accountingUser?: Maybe<ApplicationUser>;
  accountingUserId?: Maybe<Scalars['String']>;
  alternativeUser?: Maybe<ApplicationUser>;
  alternativeUserId?: Maybe<Scalars['String']>;
  alternativeUsers?: Maybe<Array<Maybe<ApplicationUser>>>;
  assignedFiles?: Maybe<Array<Maybe<SavedFile>>>;
  automaticLogout: Scalars['TimeSpan'];
  bookStackTokenId?: Maybe<Scalars['String']>;
  bookStackTokenSecret?: Maybe<Scalars['String']>;
  ciscoPhoneAdminPath?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  concurrencyStamp?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  culture?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  deletedById?: Maybe<Scalars['String']>;
  deletedOn?: Maybe<Scalars['DateTime']>;
  documentTypeLinks?: Maybe<Array<Maybe<DocumentTypeLink>>>;
  documentTypePairs?: Maybe<Array<Maybe<DocumentTypePair>>>;
  documentTypes?: Maybe<Array<Maybe<DocumentType>>>;
  email?: Maybe<Scalars['String']>;
  emailConfirmed: Scalars['Boolean'];
  externalAuthRequestStates?: Maybe<Array<Maybe<ExternalAuthRequestState>>>;
  externalIdentities?: Maybe<Array<Maybe<ApplicationUserExternalIdentity>>>;
  fCMTokens?: Maybe<Array<Maybe<FcmToken>>>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDMSReferenceUser: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  lastDevice?: Maybe<Scalars['String']>;
  lastLicenseTakeover: Scalars['DateTime'];
  lastLogin: Scalars['DateTime'];
  lastName?: Maybe<Scalars['String']>;
  lastPlatform?: Maybe<Scalars['String']>;
  lastRequestSource?: Maybe<Scalars['String']>;
  lastTokenRefresh: Scalars['DateTime'];
  lastVersion?: Maybe<Scalars['String']>;
  licenseTakeoverCount: Scalars['Int'];
  lockoutEnabled: Scalars['Boolean'];
  lockoutEnd?: Maybe<Scalars['DateTime']>;
  migratedToNewServer?: Maybe<Scalars['Boolean']>;
  mobileSettings?: Maybe<MobileSettings>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  normalizedEmail?: Maybe<Scalars['String']>;
  normalizedUserName?: Maybe<Scalars['String']>;
  notificationDeliveryReport?: Maybe<Array<Maybe<NotificationDeliveryReport>>>;
  notifiedSupportTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  onixDesktopPantheonExePath?: Maybe<Scalars['String']>;
  onixDesktopPantheonExePathMac?: Maybe<Scalars['String']>;
  onixDesktopPantheonIniPath?: Maybe<Scalars['String']>;
  onixDesktopPantheonIniPathMac?: Maybe<Scalars['String']>;
  onixPhoneUserTasks?: Maybe<Array<Maybe<OnixPhoneUserTaskQueue>>>;
  pantheonUser?: Maybe<PantheonUser>;
  passwordHash?: Maybe<Scalars['String']>;
  permanentLoginToken?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberConfirmed: Scalars['Boolean'];
  pushedAppKey?: Maybe<Scalars['String']>;
  pushedAppSecret?: Maybe<Scalars['String']>;
  pushedTargetType?: Maybe<Scalars['String']>;
  responsibleAgentTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  responsibleForUsers?: Maybe<Array<Maybe<ApplicationUser>>>;
  responsibleUser?: Maybe<ApplicationUser>;
  responsibleUserId?: Maybe<Scalars['String']>;
  restoredBy?: Maybe<Scalars['String']>;
  restoredById?: Maybe<Scalars['String']>;
  restoredOn?: Maybe<Scalars['DateTime']>;
  securityStamp?: Maybe<Scalars['String']>;
  sentAsSupportTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  sentSupportTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  settingsMigratedToMultiSettings: Scalars['Boolean'];
  supportEmailAddress?: Maybe<Scalars['String']>;
  supportEmailPassword?: Maybe<Scalars['String']>;
  supportGroupMembers?: Maybe<Array<Maybe<SupportGroupMember>>>;
  supportNotifyOfNewMessages: Scalars['Boolean'];
  supportOpenAIExecutions?: Maybe<Array<Maybe<SupportOpenAiExecution>>>;
  supportSignature?: Maybe<Scalars['String']>;
  supportTimeLogRoundingMinutes?: Maybe<Scalars['Int']>;
  supportTimeLogsAlwaysNonBillable: Scalars['Boolean'];
  supportTopBarCountersOpenTicketList?: Maybe<Scalars['Boolean']>;
  teamViewerID?: Maybe<Scalars['String']>;
  teamViewerSyncEnabled: Scalars['Boolean'];
  teamViewerToken?: Maybe<Scalars['String']>;
  temporaryOwnerSupportTickets?: Maybe<Array<Maybe<SupportTicket>>>;
  timeZone?: Maybe<Scalars['String']>;
  twoFactorEnabled: Scalars['Boolean'];
  unreadUserSupportTicketMessages?: Maybe<Array<Maybe<UnreadUserSupportTicketMessage>>>;
  useNewDocumentFlow: Scalars['Boolean'];
  userAccessHash?: Maybe<Scalars['String']>;
  userArbitrarySettings?: Maybe<Array<Maybe<UserArbitrarySetting>>>;
  userName?: Maybe<Scalars['String']>;
  userRoles?: Maybe<Array<Maybe<ApplicationUserRole>>>;
  userSupportTickets?: Maybe<Array<Maybe<SupportTicket>>>;
  visualAttributesOverview?: Maybe<Scalars['String']>;
  wakaApiBaseUrl?: Maybe<Scalars['String']>;
  wakaApiKey?: Maybe<Scalars['String']>;
  wakaAuthors?: Maybe<Array<Maybe<ApplicationUserWakaAuthor>>>;
  wakaLastSyncAt?: Maybe<Scalars['DateTime']>;
  wakaLastSyncError?: Maybe<Scalars['String']>;
  wakaMachines?: Maybe<Array<Maybe<ApplicationUserWakaMachine>>>;
  wakaProjectMaps?: Maybe<Array<Maybe<ApplicationUserWakaProjectMap>>>;
  wakaSyncEnabled: Scalars['Boolean'];
  wakaTimeCommits?: Maybe<Array<Maybe<WakaTimeCommit>>>;
  wakaTimeWorklogs?: Maybe<Array<Maybe<WakaTimeWorklog>>>;
  webAppRouting?: Maybe<WebAppRoutingDto>;
  workRecordPeriods?: Maybe<Array<Maybe<WorkRecordPeriod>>>;
};


export type ApplicationUserAccountingForUsersArgs = {
  order?: InputMaybe<Array<ApplicationUserSortInput>>;
};


export type ApplicationUserAlternativeUsersArgs = {
  order?: InputMaybe<Array<ApplicationUserSortInput>>;
};


export type ApplicationUserDocumentTypeLinksArgs = {
  order?: InputMaybe<Array<DocumentTypeLinkSortInput>>;
  where?: InputMaybe<DocumentTypeLinkFilterInput>;
};


export type ApplicationUserDocumentTypePairsArgs = {
  order?: InputMaybe<Array<DocumentTypePairSortInput>>;
  where?: InputMaybe<DocumentTypePairFilterInput>;
};


export type ApplicationUserDocumentTypesArgs = {
  order?: InputMaybe<Array<DocumentTypeSortInput>>;
  where?: InputMaybe<DocumentTypeFilterInput>;
};


export type ApplicationUserOnixPhoneUserTasksArgs = {
  order?: InputMaybe<Array<OnixPhoneUserTaskQueueSortInput>>;
  where?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
};


export type ApplicationUserResponsibleAgentTicketMessagesArgs = {
  order?: InputMaybe<Array<SupportTicketMessageSortInput>>;
};


export type ApplicationUserResponsibleForUsersArgs = {
  order?: InputMaybe<Array<ApplicationUserSortInput>>;
};


export type ApplicationUserTemporaryOwnerSupportTicketsArgs = {
  order?: InputMaybe<Array<SupportTicketSortInput>>;
};


export type ApplicationUserUserArbitrarySettingsArgs = {
  order?: InputMaybe<Array<UserArbitrarySettingSortInput>>;
  where?: InputMaybe<UserArbitrarySettingFilterInput>;
};


export type ApplicationUserUserRolesArgs = {
  order?: InputMaybe<Array<ApplicationUserRoleSortInput>>;
};


export type ApplicationUserUserSupportTicketsArgs = {
  order?: InputMaybe<Array<SupportTicketSortInput>>;
};


export type ApplicationUserWorkRecordPeriodsArgs = {
  order?: InputMaybe<Array<WorkRecordPeriodSortInput>>;
};

export type ApplicationUserExternalIdentity = {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<ApplicationUser>;
  createdByUserId?: Maybe<Scalars['String']>;
  externalIdentity?: Maybe<ExternalIdentity>;
  externalIdentityId: Scalars['Int'];
  id: Scalars['Int'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
};

export type ApplicationUserExternalIdentityFilterInput = {
  and?: InputMaybe<Array<ApplicationUserExternalIdentityFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  createdByUser?: InputMaybe<ApplicationUserFilterInput>;
  createdByUserId?: InputMaybe<StringOperationFilterInput>;
  externalIdentity?: InputMaybe<ExternalIdentityFilterInput>;
  externalIdentityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastUsedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserExternalIdentityFilterInput>>;
};

export type ApplicationUserFilterInput = {
  accessFailedCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  accountingForUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  accountingUser?: InputMaybe<ApplicationUserFilterInput>;
  accountingUserId?: InputMaybe<StringOperationFilterInput>;
  alternativeUser?: InputMaybe<ApplicationUserFilterInput>;
  alternativeUserId?: InputMaybe<StringOperationFilterInput>;
  alternativeUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  and?: InputMaybe<Array<ApplicationUserFilterInput>>;
  assignedFiles?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  automaticLogout?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  bookStackTokenId?: InputMaybe<StringOperationFilterInput>;
  bookStackTokenSecret?: InputMaybe<StringOperationFilterInput>;
  ciscoPhoneAdminPath?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  culture?: InputMaybe<StringOperationFilterInput>;
  deletedBy?: InputMaybe<StringOperationFilterInput>;
  deletedById?: InputMaybe<StringOperationFilterInput>;
  deletedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  documentTypeLinks?: InputMaybe<ListFilterInputTypeOfDocumentTypeLinkFilterInput>;
  documentTypePairs?: InputMaybe<ListFilterInputTypeOfDocumentTypePairFilterInput>;
  documentTypes?: InputMaybe<ListFilterInputTypeOfDocumentTypeFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  externalAuthRequestStates?: InputMaybe<ListFilterInputTypeOfExternalAuthRequestStateFilterInput>;
  externalIdentities?: InputMaybe<ListFilterInputTypeOfApplicationUserExternalIdentityFilterInput>;
  fCMTokens?: InputMaybe<ListFilterInputTypeOfFcmTokenFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isDMSReferenceUser?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  lastDevice?: InputMaybe<StringOperationFilterInput>;
  lastLicenseTakeover?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  lastLogin?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  lastPlatform?: InputMaybe<StringOperationFilterInput>;
  lastRequestSource?: InputMaybe<StringOperationFilterInput>;
  lastTokenRefresh?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  lastVersion?: InputMaybe<StringOperationFilterInput>;
  licenseTakeoverCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  lockoutEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lockoutEnd?: InputMaybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  migratedToNewServer?: InputMaybe<BooleanOperationFilterInput>;
  mobileSettings?: InputMaybe<MobileSettingsFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  normalizedEmail?: InputMaybe<StringOperationFilterInput>;
  normalizedUserName?: InputMaybe<StringOperationFilterInput>;
  notificationDeliveryReport?: InputMaybe<ListFilterInputTypeOfNotificationDeliveryReportFilterInput>;
  notifiedSupportTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  onixDesktopPantheonExePath?: InputMaybe<StringOperationFilterInput>;
  onixDesktopPantheonExePathMac?: InputMaybe<StringOperationFilterInput>;
  onixDesktopPantheonIniPath?: InputMaybe<StringOperationFilterInput>;
  onixDesktopPantheonIniPathMac?: InputMaybe<StringOperationFilterInput>;
  onixPhoneUserTasks?: InputMaybe<ListFilterInputTypeOfOnixPhoneUserTaskQueueFilterInput>;
  or?: InputMaybe<Array<ApplicationUserFilterInput>>;
  pantheonUser?: InputMaybe<PantheonUserFilterInput>;
  passwordHash?: InputMaybe<StringOperationFilterInput>;
  permanentLoginToken?: InputMaybe<StringOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  phoneNumberConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  pushedAppKey?: InputMaybe<StringOperationFilterInput>;
  pushedAppSecret?: InputMaybe<StringOperationFilterInput>;
  pushedTargetType?: InputMaybe<StringOperationFilterInput>;
  responsibleAgentTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  responsibleForUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  responsibleUser?: InputMaybe<ApplicationUserFilterInput>;
  responsibleUserId?: InputMaybe<StringOperationFilterInput>;
  restoredBy?: InputMaybe<StringOperationFilterInput>;
  restoredById?: InputMaybe<StringOperationFilterInput>;
  restoredOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  securityStamp?: InputMaybe<StringOperationFilterInput>;
  sentAsSupportTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  sentSupportTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  settingsMigratedToMultiSettings?: InputMaybe<BooleanOperationFilterInput>;
  supportEmailAddress?: InputMaybe<StringOperationFilterInput>;
  supportEmailPassword?: InputMaybe<StringOperationFilterInput>;
  supportGroupMembers?: InputMaybe<ListFilterInputTypeOfSupportGroupMemberFilterInput>;
  supportNotifyOfNewMessages?: InputMaybe<BooleanOperationFilterInput>;
  supportOpenAIExecutions?: InputMaybe<ListFilterInputTypeOfSupportOpenAiExecutionFilterInput>;
  supportSignature?: InputMaybe<StringOperationFilterInput>;
  supportTimeLogRoundingMinutes?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTimeLogsAlwaysNonBillable?: InputMaybe<BooleanOperationFilterInput>;
  supportTopBarCountersOpenTicketList?: InputMaybe<BooleanOperationFilterInput>;
  teamViewerID?: InputMaybe<StringOperationFilterInput>;
  teamViewerSyncEnabled?: InputMaybe<BooleanOperationFilterInput>;
  teamViewerToken?: InputMaybe<StringOperationFilterInput>;
  temporaryOwnerSupportTickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
  twoFactorEnabled?: InputMaybe<BooleanOperationFilterInput>;
  unreadUserSupportTicketMessages?: InputMaybe<ListFilterInputTypeOfUnreadUserSupportTicketMessageFilterInput>;
  useNewDocumentFlow?: InputMaybe<BooleanOperationFilterInput>;
  userAccessHash?: InputMaybe<StringOperationFilterInput>;
  userArbitrarySettings?: InputMaybe<ListFilterInputTypeOfUserArbitrarySettingFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
  userRoles?: InputMaybe<ListFilterInputTypeOfApplicationUserRoleFilterInput>;
  userSupportTickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
  visualAttributesOverview?: InputMaybe<StringOperationFilterInput>;
  wakaApiBaseUrl?: InputMaybe<StringOperationFilterInput>;
  wakaApiKey?: InputMaybe<StringOperationFilterInput>;
  wakaAuthors?: InputMaybe<ListFilterInputTypeOfApplicationUserWakaAuthorFilterInput>;
  wakaLastSyncAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  wakaLastSyncError?: InputMaybe<StringOperationFilterInput>;
  wakaMachines?: InputMaybe<ListFilterInputTypeOfApplicationUserWakaMachineFilterInput>;
  wakaProjectMaps?: InputMaybe<ListFilterInputTypeOfApplicationUserWakaProjectMapFilterInput>;
  wakaSyncEnabled?: InputMaybe<BooleanOperationFilterInput>;
  wakaTimeCommits?: InputMaybe<ListFilterInputTypeOfWakaTimeCommitFilterInput>;
  wakaTimeWorklogs?: InputMaybe<ListFilterInputTypeOfWakaTimeWorklogFilterInput>;
  workRecordPeriods?: InputMaybe<ListFilterInputTypeOfWorkRecordPeriodFilterInput>;
};

export type ApplicationUserRole = {
  role?: Maybe<ApplicationRole>;
  roleId: Scalars['String'];
  user?: Maybe<ApplicationUser>;
  userId: Scalars['String'];
};

export type ApplicationUserRoleFilterInput = {
  and?: InputMaybe<Array<ApplicationUserRoleFilterInput>>;
  or?: InputMaybe<Array<ApplicationUserRoleFilterInput>>;
  role?: InputMaybe<ApplicationRoleFilterInput>;
  roleId?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type ApplicationUserRoleSortInput = {
  role?: InputMaybe<ApplicationRoleSortInput>;
  roleId?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type ApplicationUserSortInput = {
  accessFailedCount?: InputMaybe<SortEnumType>;
  accountingUser?: InputMaybe<ApplicationUserSortInput>;
  accountingUserId?: InputMaybe<SortEnumType>;
  alternativeUser?: InputMaybe<ApplicationUserSortInput>;
  alternativeUserId?: InputMaybe<SortEnumType>;
  automaticLogout?: InputMaybe<SortEnumType>;
  bookStackTokenId?: InputMaybe<SortEnumType>;
  bookStackTokenSecret?: InputMaybe<SortEnumType>;
  ciscoPhoneAdminPath?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  concurrencyStamp?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  culture?: InputMaybe<SortEnumType>;
  deletedBy?: InputMaybe<SortEnumType>;
  deletedById?: InputMaybe<SortEnumType>;
  deletedOn?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailConfirmed?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDMSReferenceUser?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  language?: InputMaybe<SortEnumType>;
  lastDevice?: InputMaybe<SortEnumType>;
  lastLicenseTakeover?: InputMaybe<SortEnumType>;
  lastLogin?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lastPlatform?: InputMaybe<SortEnumType>;
  lastRequestSource?: InputMaybe<SortEnumType>;
  lastTokenRefresh?: InputMaybe<SortEnumType>;
  lastVersion?: InputMaybe<SortEnumType>;
  licenseTakeoverCount?: InputMaybe<SortEnumType>;
  lockoutEnabled?: InputMaybe<SortEnumType>;
  lockoutEnd?: InputMaybe<SortEnumType>;
  migratedToNewServer?: InputMaybe<SortEnumType>;
  mobileSettings?: InputMaybe<MobileSettingsSortInput>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  normalizedUserName?: InputMaybe<SortEnumType>;
  onixDesktopPantheonExePath?: InputMaybe<SortEnumType>;
  onixDesktopPantheonExePathMac?: InputMaybe<SortEnumType>;
  onixDesktopPantheonIniPath?: InputMaybe<SortEnumType>;
  onixDesktopPantheonIniPathMac?: InputMaybe<SortEnumType>;
  pantheonUser?: InputMaybe<PantheonUserSortInput>;
  passwordHash?: InputMaybe<SortEnumType>;
  permanentLoginToken?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  phoneNumberConfirmed?: InputMaybe<SortEnumType>;
  pushedAppKey?: InputMaybe<SortEnumType>;
  pushedAppSecret?: InputMaybe<SortEnumType>;
  pushedTargetType?: InputMaybe<SortEnumType>;
  responsibleUser?: InputMaybe<ApplicationUserSortInput>;
  responsibleUserId?: InputMaybe<SortEnumType>;
  restoredBy?: InputMaybe<SortEnumType>;
  restoredById?: InputMaybe<SortEnumType>;
  restoredOn?: InputMaybe<SortEnumType>;
  securityStamp?: InputMaybe<SortEnumType>;
  settingsMigratedToMultiSettings?: InputMaybe<SortEnumType>;
  supportEmailAddress?: InputMaybe<SortEnumType>;
  supportEmailPassword?: InputMaybe<SortEnumType>;
  supportNotifyOfNewMessages?: InputMaybe<SortEnumType>;
  supportSignature?: InputMaybe<SortEnumType>;
  supportTimeLogRoundingMinutes?: InputMaybe<SortEnumType>;
  supportTimeLogsAlwaysNonBillable?: InputMaybe<SortEnumType>;
  supportTopBarCountersOpenTicketList?: InputMaybe<SortEnumType>;
  teamViewerID?: InputMaybe<SortEnumType>;
  teamViewerSyncEnabled?: InputMaybe<SortEnumType>;
  teamViewerToken?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
  twoFactorEnabled?: InputMaybe<SortEnumType>;
  useNewDocumentFlow?: InputMaybe<SortEnumType>;
  userAccessHash?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
  visualAttributesOverview?: InputMaybe<SortEnumType>;
  wakaApiBaseUrl?: InputMaybe<SortEnumType>;
  wakaApiKey?: InputMaybe<SortEnumType>;
  wakaLastSyncAt?: InputMaybe<SortEnumType>;
  wakaLastSyncError?: InputMaybe<SortEnumType>;
  wakaSyncEnabled?: InputMaybe<SortEnumType>;
};

export type ApplicationUserWakaAuthor = {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  kind: WakaTimeAuthorKind;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ApplicationUserWakaAuthorFilterInput = {
  and?: InputMaybe<Array<ApplicationUserWakaAuthorFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  kind?: InputMaybe<WakaTimeAuthorKindOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserWakaAuthorFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type ApplicationUserWakaMachine = {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  hostName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  machineId?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type ApplicationUserWakaMachineFilterInput = {
  and?: InputMaybe<Array<ApplicationUserWakaMachineFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  hostName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  machineId?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserWakaMachineFilterInput>>;
};

export type ApplicationUserWakaProjectMap = {
  active: Scalars['Boolean'];
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  externalProjectName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  internalProject?: Maybe<Project>;
  internalProjectId?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type ApplicationUserWakaProjectMapFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ApplicationUserWakaProjectMapFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  externalProjectName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  internalProject?: InputMaybe<ProjectFilterInput>;
  internalProjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationUserWakaProjectMapFilterInput>>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER'
}

export enum ArbitraryFieldEntryType {
  FtBoolean = 'FT_BOOLEAN',
  FtCurrency = 'FT_CURRENCY',
  FtDate = 'FT_DATE',
  FtInteger = 'FT_INTEGER',
  FtString = 'FT_STRING'
}

export enum ArbitraryFieldLocationEnum {
  AdditionalDocumentEntryField = 'ADDITIONAL_DOCUMENT_ENTRY_FIELD',
  AdditionalPdfHeaderField = 'ADDITIONAL_PDF_HEADER_FIELD',
  AfterHeaderCustomerAnalysis = 'AFTER_HEADER_CUSTOMER_ANALYSIS',
  AfterHeaderDocumentAnalysis = 'AFTER_HEADER_DOCUMENT_ANALYSIS',
  ArticlePickerItemListItemAfterPrice = 'ARTICLE_PICKER_ITEM_LIST_ITEM_AFTER_PRICE',
  FilterExistingMoveDocumentsBasedOnScannedModifierCharacter = 'FILTER_EXISTING_MOVE_DOCUMENTS_BASED_ON_SCANNED_MODIFIER_CHARACTER',
  FilterExistingOrderDocumentsBasedOnScannedModifierCharacter = 'FILTER_EXISTING_ORDER_DOCUMENTS_BASED_ON_SCANNED_MODIFIER_CHARACTER',
  NewDocumentCustomerError = 'NEW_DOCUMENT_CUSTOMER_ERROR',
  NewDocumentItemItemListAfterPrice = 'NEW_DOCUMENT_ITEM_ITEM_LIST_AFTER_PRICE',
  NewDocumentItemListAfterPrice = 'NEW_DOCUMENT_ITEM_LIST_AFTER_PRICE',
  NewDocumentItemListAfterQuantity = 'NEW_DOCUMENT_ITEM_LIST_AFTER_QUANTITY',
  NewDocumentItemPackageQuantity = 'NEW_DOCUMENT_ITEM_PACKAGE_QUANTITY',
  NewDocumentItemReplacement = 'NEW_DOCUMENT_ITEM_REPLACEMENT',
  OnAddNewDocumentItemShowError = 'ON_ADD_NEW_DOCUMENT_ITEM_SHOW_ERROR',
  OnAddNewDocumentItemShowWarning = 'ON_ADD_NEW_DOCUMENT_ITEM_SHOW_WARNING',
  OnSubmitDocumentShowError = 'ON_SUBMIT_DOCUMENT_SHOW_ERROR',
  OnSubmitDocumentShowWarning = 'ON_SUBMIT_DOCUMENT_SHOW_WARNING',
  PdfAnClerk = 'PDF_AN_CLERK',
  THeMoveListItemAfterPrice = 'T_HE_MOVE_LIST_ITEM_AFTER_PRICE',
  THeMoveListItemReplacement = 'T_HE_MOVE_LIST_ITEM_REPLACEMENT',
  THeOrderListItemAfterPrice = 'T_HE_ORDER_LIST_ITEM_AFTER_PRICE',
  THeOrderListItemReplacement = 'T_HE_ORDER_LIST_ITEM_REPLACEMENT'
}

export type AresDeploymentAres = {
  aresAcKey?: Maybe<Scalars['String']>;
  aresAcName?: Maybe<Scalars['String']>;
  aresDeploymentAresCompanyCurrentVersions?: Maybe<Array<Maybe<AresDeploymentAresCompanyCurrentVersion>>>;
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  aresVersion: Scalars['Decimal'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  executeSteps: Scalars['Boolean'];
  executionPhase?: Maybe<AresDeploymentExecutionPhase>;
  executionPhaseOrder?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isBoostrapExecutionAres: Scalars['Boolean'];
  isSQLExecutionAres: Scalars['Boolean'];
  isTestSuiteAres: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type AresDeploymentAresCompanyCurrentVersion = {
  aresAcKey?: Maybe<Scalars['String']>;
  aresDeploymentAres?: Maybe<AresDeploymentAres>;
  aresDeploymentAresId: Scalars['Int'];
  aresVersion?: Maybe<Scalars['Decimal']>;
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  forPantheonVersion?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type AresDeploymentAresCompanyCurrentVersionFilterInput = {
  and?: InputMaybe<Array<AresDeploymentAresCompanyCurrentVersionFilterInput>>;
  aresAcKey?: InputMaybe<StringOperationFilterInput>;
  aresDeploymentAres?: InputMaybe<AresDeploymentAresFilterInput>;
  aresDeploymentAresId?: InputMaybe<ComparableInt32OperationFilterInput>;
  aresVersion?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  forPantheonVersion?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentAresCompanyCurrentVersionFilterInput>>;
};

export type AresDeploymentAresFilterInput = {
  and?: InputMaybe<Array<AresDeploymentAresFilterInput>>;
  aresAcKey?: InputMaybe<StringOperationFilterInput>;
  aresAcName?: InputMaybe<StringOperationFilterInput>;
  aresDeploymentAresCompanyCurrentVersions?: InputMaybe<ListFilterInputTypeOfAresDeploymentAresCompanyCurrentVersionFilterInput>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  aresVersion?: InputMaybe<ComparableDecimalOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  executeSteps?: InputMaybe<BooleanOperationFilterInput>;
  executionPhase?: InputMaybe<NullableOfAresDeploymentExecutionPhaseOperationFilterInput>;
  executionPhaseOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isBoostrapExecutionAres?: InputMaybe<BooleanOperationFilterInput>;
  isSQLExecutionAres?: InputMaybe<BooleanOperationFilterInput>;
  isTestSuiteAres?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentAresFilterInput>>;
};

export enum AresDeploymentEnvironment {
  Production = 'PRODUCTION',
  Staging = 'STAGING',
  Testing = 'TESTING'
}

export type AresDeploymentEnvironmentOperationFilterInput = {
  eq?: InputMaybe<AresDeploymentEnvironment>;
  in?: InputMaybe<Array<AresDeploymentEnvironment>>;
  neq?: InputMaybe<AresDeploymentEnvironment>;
  nin?: InputMaybe<Array<AresDeploymentEnvironment>>;
};

export enum AresDeploymentExecutionPhase {
  Bootstrap = 'BOOTSTRAP',
  SqlExecution = 'SQL_EXECUTION',
  Standard = 'STANDARD',
  TestRefreshSetup = 'TEST_REFRESH_SETUP',
  TestSuite = 'TEST_SUITE',
  TestTeardown = 'TEST_TEARDOWN'
}

export type AresDeploymentGroup = {
  activityCheckSql?: Maybe<Scalars['String']>;
  areses?: Maybe<Array<Maybe<AresDeploymentAres>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  installationSteps?: Maybe<Array<Maybe<AresDeploymentGroupInstallationStep>>>;
  isBackgroundInstallable: Scalars['Boolean'];
  isInvoicedToAccounting: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  lastAresTestCompanySettingsId?: Maybe<Scalars['Int']>;
  lastAresTestRunAt?: Maybe<Scalars['DateTime']>;
  lastAresTestRunHash?: Maybe<Scalars['String']>;
  lastAresTestRunMessage?: Maybe<Scalars['String']>;
  lastAresTestRunPassed?: Maybe<Scalars['Boolean']>;
  lastSuccessfulAresTestHash?: Maybe<Scalars['String']>;
  lastSuccessfulAresTestRunAt?: Maybe<Scalars['DateTime']>;
  maxPantheonBuildNo?: Maybe<Scalars['Int']>;
  minPantheonBuildNo?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  onixPhoneSettings?: Maybe<Array<Maybe<AresDeploymentOnixPhoneSettings>>>;
  snapshots?: Maybe<Array<Maybe<AresDeploymentGroupSnapshot>>>;
  workflowDefinitions?: Maybe<Array<Maybe<AresDeploymentWorkflowDefinition>>>;
};

export type AresDeploymentGroupCompanyMapping = {
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deploymentEnvironment: AresDeploymentEnvironment;
  id: Scalars['Int'];
  installationStepPoints?: Maybe<Array<Maybe<AresDeploymentInstallationStepPoint>>>;
  isAresActive?: Maybe<Scalars['Boolean']>;
  lastAresActivityCheckAt?: Maybe<Scalars['DateTime']>;
  lastAresActivityCheckResult?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type AresDeploymentGroupCompanyMappingFilterInput = {
  and?: InputMaybe<Array<AresDeploymentGroupCompanyMappingFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deploymentEnvironment?: InputMaybe<AresDeploymentEnvironmentOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  installationStepPoints?: InputMaybe<ListFilterInputTypeOfAresDeploymentInstallationStepPointFilterInput>;
  isAresActive?: InputMaybe<BooleanOperationFilterInput>;
  lastAresActivityCheckAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastAresActivityCheckResult?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentGroupCompanyMappingFilterInput>>;
};

export type AresDeploymentGroupFilterInput = {
  activityCheckSql?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AresDeploymentGroupFilterInput>>;
  areses?: InputMaybe<ListFilterInputTypeOfAresDeploymentAresFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  installationSteps?: InputMaybe<ListFilterInputTypeOfAresDeploymentGroupInstallationStepFilterInput>;
  isBackgroundInstallable?: InputMaybe<BooleanOperationFilterInput>;
  isInvoicedToAccounting?: InputMaybe<BooleanOperationFilterInput>;
  isPublic?: InputMaybe<BooleanOperationFilterInput>;
  lastAresTestCompanySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastAresTestRunAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastAresTestRunHash?: InputMaybe<StringOperationFilterInput>;
  lastAresTestRunMessage?: InputMaybe<StringOperationFilterInput>;
  lastAresTestRunPassed?: InputMaybe<BooleanOperationFilterInput>;
  lastSuccessfulAresTestHash?: InputMaybe<StringOperationFilterInput>;
  lastSuccessfulAresTestRunAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  maxPantheonBuildNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  minPantheonBuildNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  onixPhoneSettings?: InputMaybe<ListFilterInputTypeOfAresDeploymentOnixPhoneSettingsFilterInput>;
  or?: InputMaybe<Array<AresDeploymentGroupFilterInput>>;
  snapshots?: InputMaybe<ListFilterInputTypeOfAresDeploymentGroupSnapshotFilterInput>;
  workflowDefinitions?: InputMaybe<ListFilterInputTypeOfAresDeploymentWorkflowDefinitionFilterInput>;
};

export type AresDeploymentGroupInstallationStep = {
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  aresDeploymentInstallationStepPoints?: Maybe<Array<Maybe<AresDeploymentInstallationStepPoint>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['TimeSpan']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  order?: Maybe<Scalars['Int']>;
  resetsOnInvoicing: Scalars['Boolean'];
  sumType?: Maybe<InvoiceSumType>;
  triggerType?: Maybe<DeploymentGroupStepTriggerType>;
  variableName?: Maybe<Scalars['String']>;
  variableType: InstallationVariableType;
};

export type AresDeploymentGroupInstallationStepFilterInput = {
  and?: InputMaybe<Array<AresDeploymentGroupInstallationStepFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  aresDeploymentInstallationStepPoints?: InputMaybe<ListFilterInputTypeOfAresDeploymentInstallationStepPointFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  duration?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentGroupInstallationStepFilterInput>>;
  order?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  resetsOnInvoicing?: InputMaybe<BooleanOperationFilterInput>;
  sumType?: InputMaybe<NullableOfInvoiceSumTypeOperationFilterInput>;
  triggerType?: InputMaybe<NullableOfDeploymentGroupStepTriggerTypeOperationFilterInput>;
  variableName?: InputMaybe<StringOperationFilterInput>;
  variableType?: InputMaybe<InstallationVariableTypeOperationFilterInput>;
};

export type AresDeploymentGroupSnapshot = {
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  installCount: Scalars['Int'];
  isProduction: Scalars['Boolean'];
  isStaging: Scalars['Boolean'];
  isTesting: Scalars['Boolean'];
  lastInstalledAt?: Maybe<Scalars['DateTime']>;
  lastPulledAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  payloadJson?: Maybe<Scalars['String']>;
  pullCount: Scalars['Int'];
  snapshotTakenAt: Scalars['DateTime'];
  sourceHash?: Maybe<Scalars['String']>;
  versionNo: Scalars['Int'];
};

export type AresDeploymentGroupSnapshotFilterInput = {
  and?: InputMaybe<Array<AresDeploymentGroupSnapshotFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  installCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  isProduction?: InputMaybe<BooleanOperationFilterInput>;
  isStaging?: InputMaybe<BooleanOperationFilterInput>;
  isTesting?: InputMaybe<BooleanOperationFilterInput>;
  lastInstalledAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastPulledAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentGroupSnapshotFilterInput>>;
  payloadJson?: InputMaybe<StringOperationFilterInput>;
  pullCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  snapshotTakenAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  sourceHash?: InputMaybe<StringOperationFilterInput>;
  versionNo?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type AresDeploymentInstallationStepPoint = {
  aresDeploymentGroupCompanyMapping?: Maybe<AresDeploymentGroupCompanyMapping>;
  aresDeploymentGroupCompanyMappingId?: Maybe<Scalars['Int']>;
  aresDeploymentGroupInstallationStep?: Maybe<AresDeploymentGroupInstallationStep>;
  aresDeploymentGroupInstallationStepId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  supportTicketTimeLog?: Maybe<SupportTicketTimeLog>;
  supportTicketTimeLogId?: Maybe<Scalars['Int']>;
  variableValue: Scalars['String'];
};

export type AresDeploymentInstallationStepPointFilterInput = {
  and?: InputMaybe<Array<AresDeploymentInstallationStepPointFilterInput>>;
  aresDeploymentGroupCompanyMapping?: InputMaybe<AresDeploymentGroupCompanyMappingFilterInput>;
  aresDeploymentGroupCompanyMappingId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aresDeploymentGroupInstallationStep?: InputMaybe<AresDeploymentGroupInstallationStepFilterInput>;
  aresDeploymentGroupInstallationStepId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentInstallationStepPointFilterInput>>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogFilterInput>;
  supportTicketTimeLogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  variableValue?: InputMaybe<StringOperationFilterInput>;
};

export type AresDeploymentOnixPhoneSettings = {
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type AresDeploymentOnixPhoneSettingsFilterInput = {
  and?: InputMaybe<Array<AresDeploymentOnixPhoneSettingsFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentOnixPhoneSettingsFilterInput>>;
};

export type AresDeploymentWorkflowDefinition = {
  acIdentify?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  aresDeploymentGroup?: Maybe<AresDeploymentGroup>;
  aresDeploymentGroupId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type AresDeploymentWorkflowDefinitionFilterInput = {
  acIdentify?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AresDeploymentWorkflowDefinitionFilterInput>>;
  aresDeploymentGroup?: InputMaybe<AresDeploymentGroupFilterInput>;
  aresDeploymentGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AresDeploymentWorkflowDefinitionFilterInput>>;
};

export type BaseMutation = {
  addSingleTHeOrderItem?: Maybe<THeOrderItem>;
  addSubject?: Maybe<THeSetSubj>;
  addTHeDoc?: Maybe<TrimWorkOrderTHeDocs>;
  addTHeMove?: Maybe<Scalars['String']>;
  addTHeMoveWithFixedRebates?: Maybe<Scalars['String']>;
  addTHeOrder?: Maybe<Scalars['String']>;
  addTHeOrderWithFixedRebates?: Maybe<Scalars['String']>;
  addTHeSetSubjContact?: Maybe<THeSetSubjContact>;
  addTHeSetSubjContactAddress?: Maybe<THeSetSubjContactAddress>;
  addTHfWoex?: Maybe<Scalars['String']>;
  addTHfWoexWithFixedRebates?: Maybe<Scalars['String']>;
  addTMnDocument?: Maybe<TMnDocument>;
  addTMnFile?: Maybe<TMnFile>;
  addWorkOrderImage?: Maybe<OkWorkOrderAnKeyResult>;
  addWorkOrderMaterial?: Maybe<OkWorkOrderAnNoResult>;
  addWorkOrderReception?: Maybe<OkWorkOrderAnNoResult>;
  addWorkOrderReclamation?: Maybe<OkWorkOrderAnNoResult>;
  addWorkOrderService?: Maybe<OkWorkOrderAnNoResult>;
  addWorkOrderSpec?: Maybe<OkWorkOrderAnNoResult>;
  attachBarcodeToIdent: Scalars['Boolean'];
  checkIfDocumentIsReserved: Scalars['Boolean'];
  classifyTMnDocument: Scalars['Boolean'];
  completePortalRegistration?: Maybe<PortalSignInResultDto>;
  confirmTMnDocuments: Scalars['Boolean'];
  createAccount: Scalars['Boolean'];
  createDraftFromDocument?: Maybe<WebDraftDto>;
  createMarservisWorkOrderItemWork: Scalars['Boolean'];
  createMcpApiKey?: Maybe<CreatedMcpApiKeyDto>;
  createMoveFromAnotherDocument?: Maybe<THeMove>;
  createMoveFromGenericDocument?: Maybe<THeMove>;
  createOrderFromAnotherDocument?: Maybe<THeOrder>;
  createOrderFromGenericDocument?: Maybe<THeOrder>;
  createPortalServiceKey?: Maybe<CreatedPortalServiceKeyDto>;
  createSavedFile?: Maybe<SavedFile>;
  createWoexFromAnotherDocument?: Maybe<THeMove>;
  createWoexFromGenericDocument?: Maybe<THeMove>;
  deleteAccount: Scalars['Boolean'];
  deleteAllCloudBackedUpKeyValueStorageEntries: Scalars['Boolean'];
  deleteFirebaseNotificationTokenForUser: Scalars['Boolean'];
  deleteMarservisWorkOrderItemWork: Scalars['Boolean'];
  deleteMyPortalAccount: Scalars['Boolean'];
  deleteSavedFile: Scalars['Int'];
  deleteTHeDoc?: Maybe<TrimWorkOrderTHeDocs>;
  deleteTHeSetSubjContact: Scalars['Boolean'];
  deleteTHeSetSubjContactAddress: Scalars['Boolean'];
  deleteTMnDocument: Scalars['Boolean'];
  deleteTMnFile: Scalars['Boolean'];
  deleteWorkOrderImage?: Maybe<OkWorkOrderAnKeyResult>;
  deleteWorkOrderMaterial?: Maybe<OkWorkOrderAnNoResult>;
  deleteWorkOrderReception?: Maybe<OkWorkOrderAnNoResult>;
  deleteWorkOrderReclamation?: Maybe<OkWorkOrderAnNoResult>;
  deleteWorkOrderService?: Maybe<OkWorkOrderAnNoResult>;
  deleteWorkOrderSpec?: Maybe<OkWorkOrderAnNoResult>;
  demoLogin?: Maybe<Scalars['String']>;
  discardWebDraft: Scalars['Boolean'];
  duplicateWorkOrder?: Maybe<THeMove>;
  endWorkOrder?: Maybe<OkWorkOrderAcKeyResult>;
  exchangeExternalAuthTicket?: Maybe<ExternalAuthExchangeResultDto>;
  fISBarcodeScanned: Scalars['Boolean'];
  finalizeDailyIncome: Scalars['Boolean'];
  finishDeliveryNotesControl: Scalars['Boolean'];
  finishDeliveryNotesControlPartial: Scalars['Boolean'];
  issueWebDraft?: Maybe<WebIssueResult>;
  licenseTakeOver?: Maybe<Scalars['String']>;
  login?: Maybe<Scalars['String']>;
  loginWithPermanentToken?: Maybe<Scalars['String']>;
  markMarservisWorkOrderItemAsFinished: MarservisWorkOrderItemStatusEnum;
  markOnixPhoneUserTaskQueue: Scalars['Boolean'];
  portalCreateTicket?: Maybe<PortalWriteResultDto>;
  portalMarkSeen: Scalars['Boolean'];
  portalReply?: Maybe<PortalWriteResultDto>;
  portalSetEmailCopies?: Maybe<PortalEmailPreferencesDto>;
  refreshToken?: Maybe<Scalars['String']>;
  registerFirebaseNotificationTokenForUser: Scalars['Boolean'];
  registerNewVersion?: Maybe<NewVersionDto>;
  rejectTMnDocuments: Scalars['Boolean'];
  removeTHeMoveItem: Scalars['Boolean'];
  removeTHeOrderItem: Scalars['Boolean'];
  removeTHfWoexItem: Scalars['Boolean'];
  resendWebDocumentEmail?: Maybe<WebDocumentEmailDto>;
  restartWebDraft?: Maybe<WebDraftDto>;
  retryWebDocumentFiscalization?: Maybe<WebFiscalRetryResult>;
  revokeMcpApiKey: Scalars['Boolean'];
  revokePortalServiceKey: Scalars['Boolean'];
  saveEInvoicePdfArtifact?: Maybe<EInvoicePdfArtifactAck>;
  saveSignedDocument: Scalars['Boolean'];
  saveSignedDocumentPagesOnly: Scalars['Boolean'];
  saveSignedDocumentWithPages: Scalars['Boolean'];
  saveWebDraft?: Maybe<WebDraftSaveResult>;
  saveWebListPreference?: Maybe<WebListPreferenceDto>;
  saveWebPreferences?: Maybe<WebPreferencesDto>;
  sendWebDocumentEmail?: Maybe<WebDocumentEmailDto>;
  setPassword: Scalars['Boolean'];
  setTHeMoveItemFieldValue: Scalars['Boolean'];
  setTHfWoexItemFieldValue: Scalars['Boolean'];
  startExternalLink?: Maybe<ExternalAuthStartResultDto>;
  startExternalLogin?: Maybe<ExternalAuthStartResultDto>;
  startMerDownload: Scalars['Boolean'];
  startPortalEmailSignIn?: Maybe<PortalSignInStartDto>;
  startWorkOrder?: Maybe<OkWorkOrderAcKeyResult>;
  submitKeyValueStorageChangeLog: Scalars['Boolean'];
  submitLURInvoice?: Maybe<Scalars['String']>;
  toggleMarservisWorkOrderItemItemFinished?: Maybe<MarservisWorkOrderItemItem>;
  unlinkExternalIdentity: Scalars['Boolean'];
  unlockWorkOrder: Scalars['Boolean'];
  unreserveDocument: Scalars['Boolean'];
  updateAccount: Scalars['Boolean'];
  updateDocumentType?: Maybe<DocumentType>;
  updateDocumentTypeV2: Scalars['Boolean'];
  updateMarservisWorkOrderItemWork: Scalars['Boolean'];
  updateMobileSettings?: Maybe<MobileSettings>;
  updateOxDmsxmlitem?: Maybe<Array<Maybe<OxDmsxmlitem>>>;
  updateSubject?: Maybe<THeSetSubj>;
  updateSubjectGeolocation: Scalars['Boolean'];
  updateTHeDoc?: Maybe<TrimWorkOrderTHeDocs>;
  updateTHeSetItem?: Maybe<THeSetItem>;
  updateTHeSetSubjContact?: Maybe<THeSetSubjContact>;
  updateTHeSetSubjContactAddress?: Maybe<THeSetSubjContactAddress>;
  updateTMnDocument?: Maybe<TMnDocument>;
  updateTMnFile?: Maybe<TMnFile>;
  updateWorkOrder?: Maybe<TrimWorkOrderQuery>;
  verifyDocument: Scalars['Boolean'];
  verifyPortalEmailCode?: Maybe<PortalSignInResultDto>;
};


export type BaseMutationAddSingleTHeOrderItemArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  item?: InputMaybe<CreateGenericDocumentItemDtoInput>;
};


export type BaseMutationAddSubjectArgs = {
  add?: InputMaybe<AddSubjectDtoInput>;
};


export type BaseMutationAddTHeDocArgs = {
  acPhoneUID?: InputMaybe<Scalars['String']>;
  acPicture?: InputMaybe<Array<Scalars['Byte']>>;
};


export type BaseMutationAddTHeMoveArgs = {
  docType: Scalars['Int'];
  move?: InputMaybe<SubmittingMoveViewModelInput>;
};


export type BaseMutationAddTHeMoveWithFixedRebatesArgs = {
  docType: Scalars['Int'];
  move?: InputMaybe<SubmittingMoveViewModelInput>;
};


export type BaseMutationAddTHeOrderArgs = {
  docType: Scalars['Int'];
  order?: InputMaybe<SubmittingOrderViewModelInput>;
};


export type BaseMutationAddTHeOrderWithFixedRebatesArgs = {
  docType: Scalars['Int'];
  order?: InputMaybe<SubmittingOrderViewModelInput>;
};


export type BaseMutationAddTHeSetSubjContactArgs = {
  dto?: InputMaybe<AddTHeSetSubjContactDtoInput>;
};


export type BaseMutationAddTHeSetSubjContactAddressArgs = {
  dto?: InputMaybe<AddTHeSetSubjContactAddressDtoInput>;
};


export type BaseMutationAddTHfWoexArgs = {
  docType: Scalars['Int'];
  move?: InputMaybe<SubmittingWoexViewModelInput>;
};


export type BaseMutationAddTHfWoexWithFixedRebatesArgs = {
  docType: Scalars['Int'];
  move?: InputMaybe<SubmittingWoexViewModelInput>;
};


export type BaseMutationAddTMnDocumentArgs = {
  documentTypeId: Scalars['Int'];
  dto?: InputMaybe<AddTMnDocumentDtoInput>;
};


export type BaseMutationAddTMnFileArgs = {
  documentTypeId?: InputMaybe<Scalars['Int']>;
  dto?: InputMaybe<AddTMnFileDtoInput>;
};


export type BaseMutationAddWorkOrderImageArgs = {
  data?: InputMaybe<TrimWorkOrderImageQueryInput>;
};


export type BaseMutationAddWorkOrderMaterialArgs = {
  data?: InputMaybe<SubmittingWorkOrderMaterialViewModelInput>;
};


export type BaseMutationAddWorkOrderReceptionArgs = {
  data?: InputMaybe<TrimWorkOrderReceptionQueryInput>;
};


export type BaseMutationAddWorkOrderReclamationArgs = {
  data?: InputMaybe<SubmittingWorkOrderMaterialViewModelInput>;
};


export type BaseMutationAddWorkOrderServiceArgs = {
  data?: InputMaybe<SubmittingWorkOrderMaterialViewModelInput>;
};


export type BaseMutationAddWorkOrderSpecArgs = {
  data?: InputMaybe<SubmittingWorkOrderWorkSpecViewModelInput>;
};


export type BaseMutationAttachBarcodeToIdentArgs = {
  acIdent?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  barcode?: InputMaybe<Scalars['String']>;
  packageQuantity?: InputMaybe<Scalars['Decimal']>;
};


export type BaseMutationCheckIfDocumentIsReservedArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  isMove: Scalars['Boolean'];
};


export type BaseMutationClassifyTMnDocumentArgs = {
  anQId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  dto?: InputMaybe<ClassifyTMnDocumentDtoInput>;
  targetClassificationQId: Scalars['Int'];
};


export type BaseMutationCompletePortalRegistrationArgs = {
  acceptTerms: Scalars['Boolean'];
  registrationTicket?: InputMaybe<Scalars['String']>;
};


export type BaseMutationConfirmTMnDocumentsArgs = {
  anQIds?: InputMaybe<Array<Scalars['Int']>>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
};


export type BaseMutationCreateAccountArgs = {
  dto?: InputMaybe<AccountDtoInput>;
};


export type BaseMutationCreateDraftFromDocumentArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  relation: DocumentRelationKind;
};


export type BaseMutationCreateMarservisWorkOrderItemWorkArgs = {
  work?: InputMaybe<MarservisWorkOrderItemWorkDtoInput>;
};


export type BaseMutationCreateMcpApiKeyArgs = {
  apiKey?: InputMaybe<CreateMcpApiKeyDtoInput>;
};


export type BaseMutationCreateMoveFromAnotherDocumentArgs = {
  dto?: InputMaybe<CreateGenericDocumentFromAnotherDtoInput>;
};


export type BaseMutationCreateMoveFromGenericDocumentArgs = {
  dto?: InputMaybe<CreateGenericDocumentDtoInput>;
};


export type BaseMutationCreateOrderFromAnotherDocumentArgs = {
  dto?: InputMaybe<CreateGenericDocumentFromAnotherDtoInput>;
};


export type BaseMutationCreateOrderFromGenericDocumentArgs = {
  dto?: InputMaybe<CreateGenericDocumentDtoInput>;
};


export type BaseMutationCreatePortalServiceKeyArgs = {
  serviceKey?: InputMaybe<CreatePortalServiceKeyDtoInput>;
};


export type BaseMutationCreateSavedFileArgs = {
  file?: InputMaybe<SavedFileDtoInput>;
};


export type BaseMutationCreateWoexFromAnotherDocumentArgs = {
  dto?: InputMaybe<CreateGenericDocumentFromAnotherDtoInput>;
};


export type BaseMutationCreateWoexFromGenericDocumentArgs = {
  dto?: InputMaybe<CreateGenericDocumentDtoInput>;
};


export type BaseMutationDeleteAccountArgs = {
  dto?: InputMaybe<AccountDtoInput>;
};


export type BaseMutationDeleteFirebaseNotificationTokenForUserArgs = {
  firebaseToken?: InputMaybe<Scalars['String']>;
};


export type BaseMutationDeleteMarservisWorkOrderItemWorkArgs = {
  work?: InputMaybe<MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput>;
};


export type BaseMutationDeleteMyPortalAccountArgs = {
  confirmation?: InputMaybe<Scalars['String']>;
};


export type BaseMutationDeleteSavedFileArgs = {
  fileId: Scalars['Int'];
};


export type BaseMutationDeleteTHeDocArgs = {
  anQId: Scalars['Int'];
};


export type BaseMutationDeleteTHeSetSubjContactArgs = {
  anQId: Scalars['Int'];
};


export type BaseMutationDeleteTHeSetSubjContactAddressArgs = {
  anQId: Scalars['Int'];
};


export type BaseMutationDeleteTMnDocumentArgs = {
  anQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
};


export type BaseMutationDeleteTMnFileArgs = {
  anQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
};


export type BaseMutationDeleteWorkOrderImageArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anKey: Scalars['Int'];
};


export type BaseMutationDeleteWorkOrderMaterialArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
};


export type BaseMutationDeleteWorkOrderReceptionArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
};


export type BaseMutationDeleteWorkOrderReclamationArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
};


export type BaseMutationDeleteWorkOrderServiceArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
};


export type BaseMutationDeleteWorkOrderSpecArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
};


export type BaseMutationDiscardWebDraftArgs = {
  id: Scalars['UUID'];
};


export type BaseMutationDuplicateWorkOrderArgs = {
  acKey?: InputMaybe<Scalars['String']>;
};


export type BaseMutationEndWorkOrderArgs = {
  data?: InputMaybe<SubmittingWorkOrderEndViewModelInput>;
};


export type BaseMutationExchangeExternalAuthTicketArgs = {
  selectedUserId?: InputMaybe<Scalars['String']>;
  takeLicense: Scalars['Boolean'];
  ticket?: InputMaybe<Scalars['String']>;
};


export type BaseMutationFIsBarcodeScannedArgs = {
  barcode?: InputMaybe<Scalars['String']>;
};


export type BaseMutationFinalizeDailyIncomeArgs = {
  acDocType?: InputMaybe<Scalars['String']>;
};


export type BaseMutationFinishDeliveryNotesControlArgs = {
  acKey?: InputMaybe<Scalars['String']>;
};


export type BaseMutationFinishDeliveryNotesControlPartialArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<PartialFinishDeliveryNotesItemDtoInput>>>;
};


export type BaseMutationIssueWebDraftArgs = {
  expectedTotal: Scalars['Decimal'];
  id: Scalars['UUID'];
};


export type BaseMutationLoginArgs = {
  loginModel?: InputMaybe<LoginModelInput>;
};


export type BaseMutationLoginWithPermanentTokenArgs = {
  permanentToken?: InputMaybe<Scalars['String']>;
};


export type BaseMutationMarkMarservisWorkOrderItemAsFinishedArgs = {
  id: Scalars['Int'];
};


export type BaseMutationMarkOnixPhoneUserTaskQueueArgs = {
  failed: Scalars['Boolean'];
  response?: InputMaybe<Scalars['String']>;
  taskId: Scalars['Int'];
};


export type BaseMutationPortalCreateTicketArgs = {
  contactId?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  uploadIds?: InputMaybe<Array<Scalars['UUID']>>;
};


export type BaseMutationPortalMarkSeenArgs = {
  messageId: Scalars['Int'];
  ticketId: Scalars['Int'];
};


export type BaseMutationPortalReplyArgs = {
  text?: InputMaybe<Scalars['String']>;
  ticketId: Scalars['Int'];
  uploadIds?: InputMaybe<Array<Scalars['UUID']>>;
};


export type BaseMutationPortalSetEmailCopiesArgs = {
  enabled: Scalars['Boolean'];
};


export type BaseMutationRegisterFirebaseNotificationTokenForUserArgs = {
  newFirebaseToken?: InputMaybe<Scalars['String']>;
  oldFirebaseToken?: InputMaybe<Scalars['String']>;
};


export type BaseMutationRegisterNewVersionArgs = {
  newVersionDto?: InputMaybe<NewVersionDtoInput>;
};


export type BaseMutationRejectTMnDocumentsArgs = {
  anQIds?: InputMaybe<Array<Scalars['Int']>>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
};


export type BaseMutationRemoveTHeMoveItemArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  docType: Scalars['Int'];
};


export type BaseMutationRemoveTHeOrderItemArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  docType: Scalars['Int'];
};


export type BaseMutationRemoveTHfWoexItemArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  docType: Scalars['Int'];
};


export type BaseMutationResendWebDocumentEmailArgs = {
  id: Scalars['UUID'];
};


export type BaseMutationRestartWebDraftArgs = {
  id: Scalars['UUID'];
};


export type BaseMutationRetryWebDocumentFiscalizationArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
};


export type BaseMutationRevokeMcpApiKeyArgs = {
  id: Scalars['Int'];
};


export type BaseMutationRevokePortalServiceKeyArgs = {
  id: Scalars['Int'];
};


export type BaseMutationSaveEInvoicePdfArtifactArgs = {
  input?: InputMaybe<SaveEInvoicePdfArtifactInput>;
};


export type BaseMutationSaveSignedDocumentArgs = {
  ackey?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Array<Scalars['Byte']>>;
  documentId?: InputMaybe<Scalars['Int']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  sendByCompanyOutboundEmail?: InputMaybe<Scalars['Boolean']>;
};


export type BaseMutationSaveSignedDocumentPagesOnlyArgs = {
  ackey?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<Array<InputMaybe<Array<Scalars['Byte']>>>>;
};


export type BaseMutationSaveSignedDocumentWithPagesArgs = {
  ackey?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Array<Scalars['Byte']>>;
  documentId?: InputMaybe<Scalars['Int']>;
  fileCategory?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<Array<InputMaybe<Array<Scalars['Byte']>>>>;
  sendByCompanyOutboundEmail?: InputMaybe<Scalars['Boolean']>;
};


export type BaseMutationSaveWebDraftArgs = {
  expectedVersion?: InputMaybe<Scalars['Long']>;
  input?: InputMaybe<WebDraftInput>;
};


export type BaseMutationSaveWebListPreferenceArgs = {
  input?: InputMaybe<SaveWebListPreferenceInput>;
};


export type BaseMutationSaveWebPreferencesArgs = {
  input?: InputMaybe<SaveWebPreferencesInput>;
};


export type BaseMutationSendWebDocumentEmailArgs = {
  input?: InputMaybe<WebDocumentEmailInput>;
};


export type BaseMutationSetPasswordArgs = {
  password?: InputMaybe<Scalars['String']>;
};


export type BaseMutationSetTHeMoveItemFieldValueArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  fieldName?: InputMaybe<Scalars['String']>;
  fieldValue?: InputMaybe<Scalars['String']>;
};


export type BaseMutationSetTHfWoexItemFieldValueArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  fieldName?: InputMaybe<Scalars['String']>;
  fieldValue?: InputMaybe<Scalars['String']>;
};


export type BaseMutationStartExternalLinkArgs = {
  appRedirectUri?: InputMaybe<Scalars['String']>;
  provider: ExternalAuthProvider;
};


export type BaseMutationStartExternalLoginArgs = {
  appRedirectUri?: InputMaybe<Scalars['String']>;
  provider: ExternalAuthProvider;
};


export type BaseMutationStartMerDownloadArgs = {
  documentTypeId?: InputMaybe<Scalars['Int']>;
};


export type BaseMutationStartPortalEmailSignInArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type BaseMutationStartWorkOrderArgs = {
  data?: InputMaybe<SubmittingWorkOrderViewModelInput>;
  docType: Scalars['Int'];
};


export type BaseMutationSubmitKeyValueStorageChangeLogArgs = {
  dto?: InputMaybe<KeyValueStorageChangeLogInput>;
};


export type BaseMutationSubmitLurInvoiceArgs = {
  docType: Scalars['Int'];
  invoice?: InputMaybe<SubmittingLurInvoiceViewModelInput>;
};


export type BaseMutationToggleMarservisWorkOrderItemItemFinishedArgs = {
  id: Scalars['Int'];
};


export type BaseMutationUnlinkExternalIdentityArgs = {
  externalIdentityId: Scalars['Int'];
};


export type BaseMutationUnlockWorkOrderArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
};


export type BaseMutationUnreserveDocumentArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  isMove: Scalars['Boolean'];
};


export type BaseMutationUpdateAccountArgs = {
  dto?: InputMaybe<AccountDtoInput>;
};


export type BaseMutationUpdateDocumentTypeArgs = {
  documentType?: InputMaybe<DocumentTypeUpdateDtoInput>;
  id: Scalars['Int'];
};


export type BaseMutationUpdateDocumentTypeV2Args = {
  documentType?: InputMaybe<DocumentTypeUpdateDtoV2Input>;
  id: Scalars['Int'];
};


export type BaseMutationUpdateMarservisWorkOrderItemWorkArgs = {
  work?: InputMaybe<MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput>;
};


export type BaseMutationUpdateMobileSettingsArgs = {
  mobileSettings?: InputMaybe<MobileSettingsUpdateDtoInput>;
};


export type BaseMutationUpdateOxDmsxmlitemArgs = {
  documentTypeId?: InputMaybe<Scalars['Int']>;
  dto?: InputMaybe<UpdateOxDmsxmlitemDtoInput>;
};


export type BaseMutationUpdateSubjectArgs = {
  update?: InputMaybe<UpdateSubjectDtoInput>;
};


export type BaseMutationUpdateSubjectGeolocationArgs = {
  acSubject?: InputMaybe<Scalars['String']>;
  anLatitude?: InputMaybe<Scalars['Decimal']>;
  anLongitude?: InputMaybe<Scalars['Decimal']>;
};


export type BaseMutationUpdateTHeDocArgs = {
  acPicture?: InputMaybe<Array<Scalars['Byte']>>;
  anQId: Scalars['Int'];
};


export type BaseMutationUpdateTHeSetItemArgs = {
  acIdent?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Scalars['Any']>;
};


export type BaseMutationUpdateTHeSetSubjContactArgs = {
  anQId: Scalars['Int'];
  dto?: InputMaybe<UpdateTHeSetSubjContactDtoInput>;
};


export type BaseMutationUpdateTHeSetSubjContactAddressArgs = {
  anQId: Scalars['Int'];
  dto?: InputMaybe<UpdateTHeSetSubjContactAddressDtoInput>;
};


export type BaseMutationUpdateTMnDocumentArgs = {
  anQId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  dto?: InputMaybe<UpdateTMnDocumentDtoInput>;
};


export type BaseMutationUpdateTMnFileArgs = {
  anQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
  dto?: InputMaybe<UpdateTMnFileDtoInput>;
};


export type BaseMutationUpdateWorkOrderArgs = {
  update?: InputMaybe<UpdateWorkOrderDtoInput>;
};


export type BaseMutationVerifyDocumentArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  documentId: Scalars['Int'];
};


export type BaseMutationVerifyPortalEmailCodeArgs = {
  challengeId: Scalars['UUID'];
  code?: InputMaybe<Scalars['String']>;
};

export type BaseQuery = {
  accounts?: Maybe<AccountsConnection>;
  adminFilterableDocumentTypes?: Maybe<Array<Maybe<DocumentType>>>;
  allActiveAccounts?: Maybe<AllActiveAccountsDto>;
  allTMnDocumentFiles?: Maybe<Array<Maybe<TMnFile>>>;
  analysisBalanceForCustomer?: Maybe<AnalysisBalanceForCustomerDto>;
  analysisDocumentsForCustomer?: Maybe<Array<Maybe<AnalysisDocumentPerCustomerDto>>>;
  analysisPerAccountForType?: Maybe<Array<Maybe<AnalysisTotalsPerAccountDto>>>;
  analysisPerCustomerForAccount?: Maybe<Array<Maybe<AnalysisTotalsPerCustomerDto>>>;
  analysisTotals?: Maybe<AnalysisTotalsDto>;
  analysisTotalsForType?: Maybe<Array<Maybe<AnalysisCurrencyTotal>>>;
  cloudBackedUpKeyValueStorageCount: Scalars['Int'];
  cloudBackedUpKeyValueStorageEntries?: Maybe<Array<Maybe<OnixPhoneKeyValueStorage>>>;
  dailyRecap: DailyRecapDto;
  dbFile?: Maybe<DbFile>;
  dmsXmlItemsForDocument?: Maybe<Array<Maybe<OxDmsxmlitem>>>;
  documentTypes?: Maybe<Array<Maybe<DocumentType>>>;
  eInvoiceDispatchByDocumentUid?: Maybe<EInvoiceDispatchDto>;
  eInvoicePreflight?: Maybe<EInvoicePreflightDto>;
  executeSingleResultQuery?: Maybe<SingleQueryResult>;
  executeTableQuery?: Maybe<QueryTableResult>;
  existingInventoryIdents?: Maybe<Array<Maybe<Scalars['String']>>>;
  externalAuthProviders?: Maybe<Array<ExternalAuthProvider>>;
  fiscalizationCertificateGateInfo?: Maybe<FiscalizationCertificateValidationResult>;
  healthCheck?: Maybe<Scalars['String']>;
  hostName?: Maybe<Scalars['String']>;
  itemsOffsetted?: Maybe<ItemCollectionSegment>;
  lURInvoiceListItems?: Maybe<LurInvoiceListItemsConnection>;
  lURInvoicePDF?: Maybe<THeMove>;
  loginAsAccountingUser?: Maybe<Scalars['String']>;
  loginAsAlternativeUser?: Maybe<Scalars['String']>;
  loginAsUser?: Maybe<Scalars['String']>;
  marservisMaterialsForItemGroup?: Maybe<Array<Maybe<MarservisMaterialReturnDto>>>;
  marservisUserWorkOrderAllItems?: Maybe<MarservisUserWorkOrderAllItemsConnection>;
  marservisUserWorkOrderItems?: Maybe<MarservisUserWorkOrderItemsConnection>;
  marservisUserWorkOrders?: Maybe<MarservisUserWorkOrdersConnection>;
  marservisWorkOrderItemItems?: Maybe<Array<Maybe<MarservisWorkOrderItemItem>>>;
  marservisWorkOrderItemStatus: MarservisWorkOrderItemStatusEnum;
  marservisWorkOrderItemWorks?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkWithoutFilesReturnDto>>>;
  marservisWorkOrderSavedFiles?: Maybe<Array<Maybe<MarservisSavedFile>>>;
  myExternalIdentities?: Maybe<Array<Maybe<ApplicationUserExternalIdentity>>>;
  myMcpApiKeyEntitlements?: Maybe<McpApiKeyEntitlementsDto>;
  myMcpApiKeys?: Maybe<Array<Maybe<McpApiKeyDto>>>;
  onixPhoneUserTaskQueue?: Maybe<Array<Maybe<OnixPhoneUserTaskQueue>>>;
  oxIOSPerSubject?: Maybe<Array<Maybe<OxIosPerSubject>>>;
  oxMerdownloadReports?: Maybe<Array<Maybe<OxMerdownloadReport>>>;
  oxScansPaged?: Maybe<OxScansPagedConnection>;
  paymentRecord?: Maybe<Array<Maybe<THeMovePaymentRecord>>>;
  pickersData?: Maybe<Array<KeyValuePairOfStringAndDictionaryOfStringAndString>>;
  plainTHeSetCustTariff?: Maybe<Array<Maybe<THeSetCustTariff>>>;
  plainTHeSetDelMet?: Maybe<Array<Maybe<THeSetDelMet>>>;
  plainTHeSetDocText?: Maybe<Array<Maybe<THeSetDocText>>>;
  plainTHeSetDuty?: Maybe<Array<Maybe<THeSetDuty>>>;
  plainTHeSetItem?: Maybe<Array<Maybe<THeSetItem>>>;
  plainTHeSetItemCateg?: Maybe<Array<Maybe<THeSetItemCateg>>>;
  plainTHeSetItemExtItemSubj?: Maybe<Array<Maybe<THeSetItemExtItemSubj>>>;
  plainTHeSetItemPriceForWrh?: Maybe<Array<Maybe<THeSetItemPriceForWrh>>>;
  plainTHeSetItemSnt?: Maybe<Array<Maybe<THeSetItemSnt>>>;
  plainTHeSetItemSntitem?: Maybe<Array<Maybe<THeSetItemSntitem>>>;
  plainTHeSetItemSntserialNo?: Maybe<Array<Maybe<THeSetItemSntserialNo>>>;
  plainTHeSetPayMet?: Maybe<Array<Maybe<THeSetPayMet>>>;
  plainTHeSetPostCode?: Maybe<Array<Maybe<THeSetPostCode>>>;
  plainTHeSetSubj?: Maybe<Array<Maybe<THeSetSubj>>>;
  plainTHeSetSubjContact?: Maybe<Array<Maybe<THeSetSubjContact>>>;
  plainTHeSetSubjContactAddress?: Maybe<Array<Maybe<THeSetSubjContactAddress>>>;
  plainTHeSetSubjPriceCateg?: Maybe<Array<Maybe<THeSetSubjPriceCateg>>>;
  plainTHeSetSubjPriceItem?: Maybe<Array<Maybe<THeSetSubjPriceItem>>>;
  plainTHeSetTax?: Maybe<Array<Maybe<THeSetTax>>>;
  plainTHeStock?: Maybe<Array<Maybe<THeStock>>>;
  plainTHeStockSerialNo?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  portalConfig?: Maybe<PortalConfigDto>;
  portalEmailPreferences?: Maybe<PortalEmailPreferencesDto>;
  portalMe?: Maybe<PortalMeDto>;
  portalMessageOriginal?: Maybe<PortalMessageOriginalDto>;
  portalServiceKeys?: Maybe<Array<Maybe<PortalServiceKeyDto>>>;
  portalTicket?: Maybe<PortalTicketThreadDto>;
  portalTickets?: Maybe<PortalTicketsResponse>;
  ready: Scalars['Boolean'];
  savedFile?: Maybe<SavedFile>;
  savedFiles?: Maybe<Array<Maybe<SavedFile>>>;
  savedFilesPaged?: Maybe<SavedFilesPagedConnection>;
  signedDocument?: Maybe<Array<Scalars['Byte']>>;
  singleTHeDoc?: Maybe<TrimWorkOrderTHeDocs>;
  singleTHeFa?: Maybe<THeFa>;
  singleTHeMove?: Maybe<THeMove>;
  singleTHeMoveSortable?: Maybe<THeMove>;
  singleTHeOrder?: Maybe<THeOrder>;
  singleTHeSetItem?: Maybe<THeSetItem>;
  singleTHeSetItemExtItemSubj?: Maybe<THeSetItemExtItemSubj>;
  singleTHeSetItemParametrized?: Maybe<THeSetItem>;
  singleTHeSetSubj?: Maybe<THeSetSubj>;
  singleTHfWoex?: Maybe<THfWoex>;
  singleTHfWoexSortable?: Maybe<THfWoex>;
  singleTMnDocumentsWithStatus?: Maybe<TMnDocumentWithStatus>;
  singleVHeMove?: Maybe<VHeMove>;
  singleVHeMoveFiscalisation?: Maybe<VHeMoveFiscalisation>;
  singleVHeMoveOut?: Maybe<VHeMoveOut>;
  softPOS7PayToken?: Maybe<SoftPos7PayTokenState>;
  subjektski?: Maybe<Array<Maybe<Subjektski>>>;
  tDeSetAccountPaged?: Maybe<TDeSetAccountPagedConnection>;
  tHeAcctTransItem?: Maybe<THeAcctTransItemConnection>;
  tHeCashRegItems?: Maybe<Array<Maybe<THeCashRegItem>>>;
  tHeCashRegPaged?: Maybe<THeCashRegPagedConnection>;
  tHeCostDrvPaged?: Maybe<THeCostDrvPagedConnection>;
  tHeDocs?: Maybe<Array<Maybe<TrimWorkOrderTHeDocs>>>;
  tHeFaPaged?: Maybe<THeFaPagedConnection>;
  tHeMove?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveDailyIncomeSummary?: Maybe<THeMoveDailyIncomeSummaryDto>;
  tHeMoveItem?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeMoveItemExciseOuts?: Maybe<Array<Maybe<THeMoveItemExciseOut>>>;
  tHeMoveItemFieldValue?: Maybe<Scalars['String']>;
  tHeMovePaged?: Maybe<THeMovePagedConnection>;
  tHeMovePagedParametrized?: Maybe<THeMovePagedParametrizedConnection>;
  tHeMovePagedParametrizedDto?: Maybe<THeMovePagedParametrizedDtoConnection>;
  tHeMoveSignature?: Maybe<Array<Scalars['Byte']>>;
  tHeOrder?: Maybe<Array<Maybe<THeOrder>>>;
  tHeOrderItem?: Maybe<Array<Maybe<THeOrderItem>>>;
  tHeOrderPaged?: Maybe<THeOrderPagedConnection>;
  tHeOrderPagedParametrized?: Maybe<THeOrderPagedParametrizedConnection>;
  tHeOrderPagedParametrizedDto?: Maybe<THeOrderPagedParametrizedDtoConnection>;
  tHeSetDelMet?: Maybe<Array<Maybe<THeSetDelMet>>>;
  tHeSetItem?: Maybe<Array<Maybe<THeSetItem>>>;
  tHeSetItemCategPaged?: Maybe<THeSetItemCategPagedConnection>;
  tHeSetItemCategPagedParametrized?: Maybe<THeSetItemCategPagedParametrizedConnection>;
  tHeSetItemPaged?: Maybe<THeSetItemPagedConnection>;
  tHeSetItemPagedParametrized?: Maybe<THeSetItemPagedParametrizedConnection>;
  tHeSetItemPagedParametrizedDto?: Maybe<THeSetItemPagedParametrizedDtoConnection>;
  tHeSetItemPagedParametrizedV2?: Maybe<THeSetItemPagedParametrizedV2Connection>;
  tHeSetItemPicture?: Maybe<Array<Scalars['Byte']>>;
  tHeSetPayMets?: Maybe<Array<Maybe<THeSetPayMet>>>;
  tHeSetPostCode?: Maybe<Array<Maybe<THeSetPostCode>>>;
  tHeSetPostCodePaged?: Maybe<THeSetPostCodePagedConnection>;
  tHeSetSubj?: Maybe<Array<Maybe<THeSetSubj>>>;
  tHeSetSubjContact?: Maybe<Array<Maybe<THeSetSubjContact>>>;
  tHeSetSubjContactAddress?: Maybe<Array<Maybe<THeSetSubjContactAddress>>>;
  tHeSetSubjContactPaged?: Maybe<THeSetSubjContactPagedConnection>;
  tHeSetSubjPaged?: Maybe<THeSetSubjPagedConnection>;
  tHeSetSubjPagedParametrized?: Maybe<THeSetSubjPagedParametrizedConnection>;
  tHeSetSubjPagedParametrizedDto?: Maybe<THeSetSubjPagedParametrizedDtoConnection>;
  tHeStock?: Maybe<Array<Maybe<THeStock>>>;
  tHeStockPaged?: Maybe<THeStockPagedConnection>;
  tHeStockSerialNos?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  tHeStockSerialNosPaged?: Maybe<THeStockSerialNosPagedConnection>;
  tHeStockSerialNosPagedParametrized?: Maybe<THeStockSerialNosPagedParametrizedConnection>;
  tHfWoex?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexItem?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexItemFieldValue?: Maybe<Scalars['String']>;
  tHfWoexPaged?: Maybe<THfWoexPagedConnection>;
  tHfWoexPagedParametrized?: Maybe<THfWoexPagedParametrizedConnection>;
  tHfWoexSignature?: Maybe<Array<Scalars['Byte']>>;
  tHrPrsnPaged?: Maybe<THrPrsnPagedConnection>;
  tMnClassificationMetaData?: Maybe<Array<Maybe<TMnSetClassificationMetaDatum>>>;
  tMnDocumentChatLogs?: Maybe<TMnDocumentChatLogsConnection>;
  tMnDocumentMetaData?: Maybe<Array<Maybe<TMnDocumentMetaDatum>>>;
  tMnDocuments?: Maybe<TMnDocumentsConnection>;
  tMnDocumentsCount: Scalars['Int'];
  tMnDocumentsWithStatus?: Maybe<TMnDocumentsWithStatusConnection>;
  tMnFiles?: Maybe<TMnFilesConnection>;
  tMnSetClassifications?: Maybe<Array<Maybe<TMnSetClassification>>>;
  tPaSysParam?: Maybe<Array<Maybe<TPaSysParam>>>;
  tPaUserPaged?: Maybe<TPaUserPagedConnection>;
  unfiscalizedDocumentCount: Scalars['Int'];
  unlinkedDocumentCountFromDocumentTypePair: Scalars['Int'];
  user?: Maybe<ApplicationUser>;
  userInfoVersionHash?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<ApplicationUser>>>;
  vOPSetDepts?: Maybe<Array<Maybe<VopSetDept>>>;
  vOPSetItemCategs?: Maybe<Array<Maybe<VopSetItemCateg>>>;
  vOPSetItemCategsPaged?: Maybe<VopSetItemCategsPagedConnection>;
  vOPSetItems?: Maybe<Array<Maybe<VopSetItem>>>;
  vOPSetItemsPaged?: Maybe<VopSetItemsPagedConnection>;
  vOpCashReg?: Maybe<VOpCashRegConnection>;
  vOpMoveBank?: Maybe<VOpMoveBank>;
  vOpSetBoatNamePaged?: Maybe<VOpSetBoatNamePagedConnection>;
  vOpSetBoatNames?: Maybe<Array<Maybe<VOpSetBoatName>>>;
  webAppSession?: Maybe<WebAppRoutingDto>;
  webCustomerBalance?: Maybe<WebCustomerBalanceDto>;
  webDailyIncome?: Maybe<WebDailyIncomeDto>;
  webDmsStatusCounts?: Maybe<Array<Maybe<WebDmsStatusCountDto>>>;
  webDocumentDetail?: Maybe<WebDocumentDetailDto>;
  webDocumentRoutePreview?: Maybe<EInvoicePreflightDto>;
  webDocumentStatuses?: Maybe<Array<Maybe<WebDocumentStatusDto>>>;
  webDraft?: Maybe<WebDraftDto>;
  webDrafts?: Maybe<Array<Maybe<WebDraftSummaryDto>>>;
  webEmailSettings?: Maybe<WebEmailSettingsDto>;
  webItemClassifications?: Maybe<Array<Maybe<WebItemClassificationDto>>>;
  webItemPrices?: Maybe<Array<Maybe<WebItemPrice>>>;
  webItemSearch?: Maybe<WebItemSearchConnection>;
  webMoveList?: Maybe<WebMoveListConnection>;
  webOrderList?: Maybe<WebOrderListConnection>;
  webPreferences?: Maybe<WebPreferencesDto>;
  webSubjectHistory?: Maybe<WebSubjectHistoryConnection>;
  webSubjectSearch?: Maybe<WebSubjectSearchConnection>;
  workOrder?: Maybe<WorkOrderStateViewModel>;
  workOrderPDF?: Maybe<ByteArrayDto>;
  workflowTasks?: Maybe<WorkflowTasksConnection>;
  workflowTasksCount: Scalars['Int'];
  zippedPlainTHeSetCustTariff?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetDelMet?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetDuty?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetItem?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetItemCateg?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetItemExtItemSubj?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetItemPriceForWrh?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetPayMet?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetPostCode?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetSubj?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetSubjPriceCateg?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetSubjPriceItem?: Maybe<ByteArrayDto>;
  zippedPlainTHeSetTax?: Maybe<ByteArrayDto>;
  zippedPlainTHeStock?: Maybe<ByteArrayDto>;
};


export type BaseQueryAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<AccountSortInput>>;
  where?: InputMaybe<AccountFilterInput>;
};


export type BaseQueryAdminFilterableDocumentTypesArgs = {
  order?: InputMaybe<Array<DocumentTypeSortInput>>;
  userId?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<DocumentTypeFilterInput>;
};


export type BaseQueryAllTMnDocumentFilesArgs = {
  anQId: Scalars['Int'];
  documentTypeId: Scalars['Int'];
  order?: InputMaybe<Array<TMnFileSortInput>>;
  where?: InputMaybe<TMnFileFilterInput>;
};


export type BaseQueryAnalysisBalanceForCustomerArgs = {
  customer?: InputMaybe<Scalars['String']>;
};


export type BaseQueryAnalysisDocumentsForCustomerArgs = {
  accountId: Scalars['Int'];
  customer?: InputMaybe<Scalars['String']>;
};


export type BaseQueryAnalysisPerAccountForTypeArgs = {
  type: AccountType;
};


export type BaseQueryAnalysisPerCustomerForAccountArgs = {
  accountId: Scalars['Int'];
};


export type BaseQueryAnalysisTotalsForTypeArgs = {
  type: AccountType;
};


export type BaseQueryCloudBackedUpKeyValueStorageCountArgs = {
  localIds?: InputMaybe<Array<KeyValuePairOfStringAndDateTimeInput>>;
};


export type BaseQueryDailyRecapArgs = {
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acDeptOut?: InputMaybe<Scalars['String']>;
  acIssuer?: InputMaybe<Scalars['String']>;
  acPrsn3?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  docType: Scalars['String'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};


export type BaseQueryDbFileArgs = {
  fileId: Scalars['Int'];
};


export type BaseQueryDmsXmlItemsForDocumentArgs = {
  anDocumentQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OxDmsxmlitemSortInput>>;
  where?: InputMaybe<OxDmsxmlitemFilterInput>;
};


export type BaseQueryEInvoiceDispatchByDocumentUidArgs = {
  documentUid?: InputMaybe<Scalars['String']>;
};


export type BaseQueryEInvoicePreflightArgs = {
  input?: InputMaybe<EInvoicePreflightInput>;
};


export type BaseQueryExecuteSingleResultQueryArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type BaseQueryExecuteTableQueryArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type BaseQueryExistingInventoryIdentsArgs = {
  documentId: Scalars['Int'];
};


export type BaseQueryItemsOffsettedArgs = {
  order?: InputMaybe<Array<ItemSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ItemFilterInput>;
};


export type BaseQueryLUrInvoiceListItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<LurInvoiceListItemDtoSortInput>>;
  where?: InputMaybe<LurInvoiceListItemDtoFilterInput>;
};


export type BaseQueryLUrInvoicePdfArgs = {
  acKey?: InputMaybe<Scalars['String']>;
};


export type BaseQueryLoginAsAccountingUserArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type BaseQueryLoginAsUserArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type BaseQueryMarservisMaterialsForItemGroupArgs = {
  itemGroupId: Scalars['Int'];
};


export type BaseQueryMarservisUserWorkOrderAllItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MarservisUserMobileWorkOrderItemDtoSortInput>>;
  where?: InputMaybe<MarservisUserMobileWorkOrderItemDtoFilterInput>;
};


export type BaseQueryMarservisUserWorkOrderItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MarservisUserMobileWorkOrderItemDtoSortInput>>;
  where?: InputMaybe<MarservisUserMobileWorkOrderItemDtoFilterInput>;
};


export type BaseQueryMarservisUserWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<MarservisLocalWorkOrderReturnDtoSortInput>>;
  where?: InputMaybe<MarservisLocalWorkOrderReturnDtoFilterInput>;
};


export type BaseQueryMarservisWorkOrderItemItemsArgs = {
  order?: InputMaybe<Array<MarservisWorkOrderItemItemSortInput>>;
  where?: InputMaybe<MarservisWorkOrderItemItemFilterInput>;
};


export type BaseQueryMarservisWorkOrderItemStatusArgs = {
  id: Scalars['Int'];
};


export type BaseQueryMarservisWorkOrderItemWorksArgs = {
  order?: InputMaybe<Array<MarservisWorkOrderItemWorkWithoutFilesReturnDtoSortInput>>;
  where?: InputMaybe<MarservisWorkOrderItemWorkWithoutFilesReturnDtoFilterInput>;
};


export type BaseQueryMarservisWorkOrderSavedFilesArgs = {
  order?: InputMaybe<Array<MarservisSavedFileSortInput>>;
  where?: InputMaybe<MarservisSavedFileFilterInput>;
};


export type BaseQueryOnixPhoneUserTaskQueueArgs = {
  order?: InputMaybe<Array<OnixPhoneUserTaskQueueSortInput>>;
  where?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
};


export type BaseQueryOxIosPerSubjectArgs = {
  order?: InputMaybe<Array<OxIosPerSubjectSortInput>>;
  where?: InputMaybe<OxIosPerSubjectFilterInput>;
};


export type BaseQueryOxMerdownloadReportsArgs = {
  documentTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<OxMerdownloadReportSortInput>>;
  where?: InputMaybe<OxMerdownloadReportFilterInput>;
};


export type BaseQueryOxScansPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyActive: Scalars['Boolean'];
  order?: InputMaybe<Array<OxPalletsViewSortInput>>;
  where?: InputMaybe<OxPalletsViewFilterInput>;
};


export type BaseQueryPaymentRecordArgs = {
  acKey?: InputMaybe<Scalars['String']>;
};


export type BaseQueryPickersDataArgs = {
  pickers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type BaseQueryPlainTHeSetCustTariffArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetCustTariffFilterInput>;
};


export type BaseQueryPlainTHeSetDelMetArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetDelMetFilterInput>;
};


export type BaseQueryPlainTHeSetDocTextArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetDocTextFilterInput>;
};


export type BaseQueryPlainTHeSetDutyArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetDutyFilterInput>;
};


export type BaseQueryPlainTHeSetItemArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemFilterInput>;
};


export type BaseQueryPlainTHeSetItemCategArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemCategFilterInput>;
};


export type BaseQueryPlainTHeSetItemExtItemSubjArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
};


export type BaseQueryPlainTHeSetItemPriceForWrhArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
};


export type BaseQueryPlainTHeSetItemSntArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemSntFilterInput>;
};


export type BaseQueryPlainTHeSetItemSntitemArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemSntitemFilterInput>;
};


export type BaseQueryPlainTHeSetItemSntserialNoArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetItemSntserialNoFilterInput>;
};


export type BaseQueryPlainTHeSetPayMetArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetPayMetFilterInput>;
};


export type BaseQueryPlainTHeSetPostCodeArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetPostCodeFilterInput>;
};


export type BaseQueryPlainTHeSetSubjArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjFilterInput>;
};


export type BaseQueryPlainTHeSetSubjContactArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjContactFilterInput>;
};


export type BaseQueryPlainTHeSetSubjContactAddressArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjContactAddressFilterInput>;
};


export type BaseQueryPlainTHeSetSubjPriceCategArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjPriceCategFilterInput>;
};


export type BaseQueryPlainTHeSetSubjPriceItemArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetSubjPriceItemFilterInput>;
};


export type BaseQueryPlainTHeSetTaxArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeSetTaxFilterInput>;
};


export type BaseQueryPlainTHeStockArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeStockFilterInput>;
};


export type BaseQueryPlainTHeStockSerialNoArgs = {
  adTimeChg: Scalars['DateTime'];
  where?: InputMaybe<THeStockSerialNoFilterInput>;
};


export type BaseQueryPortalMessageOriginalArgs = {
  messageId: Scalars['Int'];
  ticketId: Scalars['Int'];
};


export type BaseQueryPortalTicketArgs = {
  id: Scalars['Int'];
};


export type BaseQueryPortalTicketsArgs = {
  skip?: Scalars['Int'];
  status?: PortalTicketStatusFilter;
  take?: Scalars['Int'];
};


export type BaseQuerySavedFileArgs = {
  order?: InputMaybe<Array<SavedFileSortInput>>;
  where?: InputMaybe<SavedFileFilterInput>;
};


export type BaseQuerySavedFilesArgs = {
  order?: InputMaybe<Array<SavedFileSortInput>>;
  where?: InputMaybe<SavedFileFilterInput>;
};


export type BaseQuerySavedFilesPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<SavedFileSortInput>>;
  where?: InputMaybe<SavedFileFilterInput>;
};


export type BaseQuerySignedDocumentArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  fileCategory?: InputMaybe<Scalars['String']>;
};


export type BaseQuerySingleTHeDocArgs = {
  order?: InputMaybe<Array<TrimWorkOrderTHeDocsSortInput>>;
  where?: InputMaybe<TrimWorkOrderTHeDocsFilterInput>;
};


export type BaseQuerySingleTHeFaArgs = {
  where?: InputMaybe<THeFaFilterInput>;
};


export type BaseQuerySingleTHeMoveArgs = {
  where?: InputMaybe<THeMoveFilterInput>;
};


export type BaseQuerySingleTHeMoveSortableArgs = {
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
};


export type BaseQuerySingleTHeOrderArgs = {
  where?: InputMaybe<THeOrderFilterInput>;
};


export type BaseQuerySingleTHeSetItemArgs = {
  where?: InputMaybe<THeSetItemFilterInput>;
};


export type BaseQuerySingleTHeSetItemExtItemSubjArgs = {
  where?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
};


export type BaseQuerySingleTHeSetItemParametrizedArgs = {
  acWarehouse?: InputMaybe<Scalars['String']>;
  barcode?: InputMaybe<Scalars['String']>;
  ignoreWarehouse?: InputMaybe<Scalars['Boolean']>;
  showOnlyInStock?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<THeSetItemFilterInput>;
};


export type BaseQuerySingleTHeSetSubjArgs = {
  where?: InputMaybe<THeSetSubjFilterInput>;
};


export type BaseQuerySingleTHfWoexArgs = {
  where?: InputMaybe<THfWoexFilterInput>;
};


export type BaseQuerySingleTHfWoexSortableArgs = {
  order?: InputMaybe<Array<THfWoexSortInput>>;
  where?: InputMaybe<THfWoexFilterInput>;
};


export type BaseQuerySingleTMnDocumentsWithStatusArgs = {
  anQId: Scalars['Int'];
  documentTypeId?: InputMaybe<Scalars['Int']>;
};


export type BaseQuerySingleVHeMoveArgs = {
  where?: InputMaybe<VHeMoveFilterInput>;
};


export type BaseQuerySingleVHeMoveFiscalisationArgs = {
  where?: InputMaybe<VHeMoveFiscalisationFilterInput>;
};


export type BaseQuerySingleVHeMoveOutArgs = {
  where?: InputMaybe<VHeMoveOutFilterInput>;
};


export type BaseQuerySubjektskiArgs = {
  order?: InputMaybe<Array<SubjektskiSortInput>>;
  where?: InputMaybe<SubjektskiFilterInput>;
};


export type BaseQueryTDeSetAccountPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TDeSetAccountSortInput>>;
  where?: InputMaybe<TDeSetAccountFilterInput>;
};


export type BaseQueryTHeAcctTransItemArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeAcctTransItemSortInput>>;
  where?: InputMaybe<THeAcctTransItemFilterInput>;
};


export type BaseQueryTHeCashRegItemsArgs = {
  order?: InputMaybe<Array<THeCashRegItemSortInput>>;
  where?: InputMaybe<THeCashRegItemFilterInput>;
};


export type BaseQueryTHeCashRegPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeCashRegSortInput>>;
  where?: InputMaybe<THeCashRegFilterInput>;
};


export type BaseQueryTHeCostDrvPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeCostDrvSortInput>>;
  where?: InputMaybe<THeCostDrvFilterInput>;
};


export type BaseQueryTHeDocsArgs = {
  order?: InputMaybe<Array<TrimWorkOrderTHeDocsSortInput>>;
  where?: InputMaybe<TrimWorkOrderTHeDocsFilterInput>;
};


export type BaseQueryTHeFaPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeFaSortInput>>;
  where?: InputMaybe<THeFaFilterInput>;
};


export type BaseQueryTHeMoveArgs = {
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
};


export type BaseQueryTHeMoveDailyIncomeSummaryArgs = {
  acDocType?: InputMaybe<Scalars['String']>;
};


export type BaseQueryTHeMoveItemArgs = {
  order?: InputMaybe<Array<THeMoveItemSortInput>>;
  scannedModifierChar?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THeMoveItemFilterInput>;
};


export type BaseQueryTHeMoveItemExciseOutsArgs = {
  order?: InputMaybe<Array<THeMoveItemExciseOutSortInput>>;
  where?: InputMaybe<THeMoveItemExciseOutFilterInput>;
};


export type BaseQueryTHeMoveItemFieldValueArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  fieldName?: InputMaybe<Scalars['String']>;
};


export type BaseQueryTHeMovePagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
};


export type BaseQueryTHeMovePagedParametrizedArgs = {
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acDeptOut?: InputMaybe<Scalars['String']>;
  acDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acIssuer?: InputMaybe<Scalars['String']>;
  acKeys?: InputMaybe<Array<Scalars['String']>>;
  acPrsn3?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acVerifiedPrices?: InputMaybe<Scalars['String']>;
  acVerifyStatus?: InputMaybe<Scalars['String']>;
  adFieldDAIsNotNull?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anUserIns?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeMovePagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THeMoveFilterInput>;
};


export type BaseQueryTHeMovePagedParametrizedDtoArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dto?: InputMaybe<THeMovePagedParametrizedDtoInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
};


export type BaseQueryTHeMoveSignatureArgs = {
  acKey?: InputMaybe<Scalars['String']>;
};


export type BaseQueryTHeOrderArgs = {
  order?: InputMaybe<Array<THeOrderSortInput>>;
  where?: InputMaybe<THeOrderFilterInput>;
};


export type BaseQueryTHeOrderItemArgs = {
  order?: InputMaybe<Array<THeOrderItemSortInput>>;
  scannedModifierChar?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THeOrderItemFilterInput>;
};


export type BaseQueryTHeOrderPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeOrderSortInput>>;
  where?: InputMaybe<THeOrderFilterInput>;
};


export type BaseQueryTHeOrderPagedParametrizedArgs = {
  acConsignee?: InputMaybe<Scalars['String']>;
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acStatus?: InputMaybe<Scalars['String']>;
  acStatusIn?: InputMaybe<Array<Scalars['String']>>;
  acStatusNotIn?: InputMaybe<Array<Scalars['String']>>;
  after?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeOrderSortInput>>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeOrderPagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
  useDeliveryDeadline?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<THeOrderFilterInput>;
};


export type BaseQueryTHeOrderPagedParametrizedDtoArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dto?: InputMaybe<THeOrderPagedParametrizedDtoInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeOrderSortInput>>;
  where?: InputMaybe<THeOrderFilterInput>;
};


export type BaseQueryTHeSetDelMetArgs = {
  order?: InputMaybe<Array<THeSetDelMetSortInput>>;
  where?: InputMaybe<THeSetDelMetFilterInput>;
};


export type BaseQueryTHeSetItemArgs = {
  order?: InputMaybe<Array<THeSetItemSortInput>>;
  where?: InputMaybe<THeSetItemFilterInput>;
};


export type BaseQueryTHeSetItemCategPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemCategSortInput>>;
  where?: InputMaybe<THeSetItemCategFilterInput>;
};


export type BaseQueryTHeSetItemCategPagedParametrizedArgs = {
  acFieldsA?: InputMaybe<Scalars['String']>;
  acSetOfItem?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemCategSortInput>>;
  where?: InputMaybe<THeSetItemCategFilterInput>;
};


export type BaseQueryTHeSetItemPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemSortInput>>;
  where?: InputMaybe<THeSetItemFilterInput>;
};


export type BaseQueryTHeSetItemPagedParametrizedArgs = {
  acClassif?: InputMaybe<Scalars['String']>;
  acFieldsA?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemSortInput>>;
  where?: InputMaybe<THeSetItemFilterInput>;
};


export type BaseQueryTHeSetItemPagedParametrizedDtoArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dto?: InputMaybe<THeSetItemPagedDtoInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetItemSortInput>>;
  where?: InputMaybe<THeSetItemFilterInput>;
};


export type BaseQueryTHeSetItemPagedParametrizedV2Args = {
  acClassif?: InputMaybe<Scalars['String']>;
  acFieldsA?: InputMaybe<Scalars['String']>;
  acSetOfItem?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  docTypeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  ignoreWarehouse?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minStock?: InputMaybe<Scalars['Decimal']>;
  onlyWithCustomerContractPrices?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyInStock?: InputMaybe<Scalars['Boolean']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeSetItemPagedSortField>;
  where?: InputMaybe<THeSetItemFilterInput>;
};


export type BaseQueryTHeSetItemPictureArgs = {
  acIdent?: InputMaybe<Scalars['String']>;
};


export type BaseQueryTHeSetPayMetsArgs = {
  order?: InputMaybe<Array<THeSetPayMetSortInput>>;
  where?: InputMaybe<THeSetPayMetFilterInput>;
};


export type BaseQueryTHeSetPostCodeArgs = {
  order?: InputMaybe<Array<THeSetPostCodeSortInput>>;
  where?: InputMaybe<THeSetPostCodeFilterInput>;
};


export type BaseQueryTHeSetPostCodePagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetPostCodeSortInput>>;
  where?: InputMaybe<THeSetPostCodeFilterInput>;
};


export type BaseQueryTHeSetSubjArgs = {
  order?: InputMaybe<Array<THeSetSubjSortInput>>;
  where?: InputMaybe<THeSetSubjFilterInput>;
};


export type BaseQueryTHeSetSubjContactArgs = {
  order?: InputMaybe<Array<THeSetSubjContactSortInput>>;
  where?: InputMaybe<THeSetSubjContactFilterInput>;
};


export type BaseQueryTHeSetSubjContactAddressArgs = {
  order?: InputMaybe<Array<THeSetSubjContactAddressSortInput>>;
  where?: InputMaybe<THeSetSubjContactAddressFilterInput>;
};


export type BaseQueryTHeSetSubjContactPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetSubjContactSortInput>>;
  where?: InputMaybe<THeSetSubjContactFilterInput>;
};


export type BaseQueryTHeSetSubjPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetSubjSortInput>>;
  where?: InputMaybe<THeSetSubjFilterInput>;
};


export type BaseQueryTHeSetSubjPagedParametrizedArgs = {
  acBuyer?: InputMaybe<Scalars['String']>;
  acConsigneeInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acDeptInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acDeptOutInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acFieldSa?: InputMaybe<Scalars['String']>;
  acIssuerInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acPrsn3InDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acReceiverInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acSubject?: InputMaybe<Scalars['String']>;
  acSupplier?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anClerks?: InputMaybe<Array<Scalars['Int']>>;
  before?: InputMaybe<Scalars['String']>;
  byAcSkis?: InputMaybe<Scalars['String']>;
  byPrefix?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetSubjSortInput>>;
  where?: InputMaybe<THeSetSubjFilterInput>;
};


export type BaseQueryTHeSetSubjPagedParametrizedDtoArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dto?: InputMaybe<THeSetSubjPagedParametrizedDtoInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeSetSubjSortInput>>;
  where?: InputMaybe<THeSetSubjFilterInput>;
};


export type BaseQueryTHeStockArgs = {
  order?: InputMaybe<Array<THeStockSortInput>>;
  where?: InputMaybe<THeStockFilterInput>;
};


export type BaseQueryTHeStockPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeStockSortInput>>;
  where?: InputMaybe<THeStockFilterInput>;
};


export type BaseQueryTHeStockSerialNosArgs = {
  order?: InputMaybe<Array<THeStockSerialNoSortInput>>;
  where?: InputMaybe<THeStockSerialNoFilterInput>;
};


export type BaseQueryTHeStockSerialNosPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeStockSerialNoSortInput>>;
  where?: InputMaybe<THeStockSerialNoFilterInput>;
};


export type BaseQueryTHeStockSerialNosPagedParametrizedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeStockSerialNoSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THeStockSerialNoFilterInput>;
};


export type BaseQueryTHfWoexArgs = {
  order?: InputMaybe<Array<THfWoexSortInput>>;
  where?: InputMaybe<THfWoexFilterInput>;
};


export type BaseQueryTHfWoexItemArgs = {
  order?: InputMaybe<Array<THfWoexItemSortInput>>;
  scannedModifierChar?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THfWoexItemFilterInput>;
};


export type BaseQueryTHfWoexItemFieldValueArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
  fieldName?: InputMaybe<Scalars['String']>;
};


export type BaseQueryTHfWoexPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THfWoexSortInput>>;
  where?: InputMaybe<THfWoexFilterInput>;
};


export type BaseQueryTHfWoexPagedParametrizedArgs = {
  acConsignee?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acKeys?: InputMaybe<Array<Scalars['String']>>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acStatus?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  anUserIns?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THfWoexSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THfWoexPagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<THfWoexFilterInput>;
};


export type BaseQueryTHfWoexSignatureArgs = {
  acKey?: InputMaybe<Scalars['String']>;
};


export type BaseQueryTHrPrsnPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THrPrsnSortInput>>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<THrPrsnFilterInput>;
};


export type BaseQueryTMnClassificationMetaDataArgs = {
  order?: InputMaybe<Array<TMnSetClassificationMetaDatumSortInput>>;
  where?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
};


export type BaseQueryTMnDocumentChatLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  anDocumentQId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnDocumentChatLogSortInput>>;
  where?: InputMaybe<TMnDocumentChatLogFilterInput>;
};


export type BaseQueryTMnDocumentMetaDataArgs = {
  anDocumentQId?: InputMaybe<Scalars['Int']>;
  documentTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnDocumentMetaDatumSortInput>>;
  where?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
};


export type BaseQueryTMnDocumentsArgs = {
  acSubject?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  anClassificationQId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  byAnQid?: InputMaybe<Scalars['Int']>;
  dmsAcStatusIn?: InputMaybe<Array<Scalars['String']>>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnDocumentSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<Scalars['Boolean']>;
  showOnlyUnconfirmedDMSDocuments?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TMnDocumentFilterInput>;
};


export type BaseQueryTMnDocumentsCountArgs = {
  acSubject?: InputMaybe<Scalars['String']>;
  anClassificationQId?: InputMaybe<Scalars['Int']>;
  byAnQid?: InputMaybe<Scalars['Int']>;
  dmsAcStatusIn?: InputMaybe<Array<Scalars['String']>>;
  documentTypeId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<Scalars['Boolean']>;
  showOnlyUnconfirmedDMSDocuments?: InputMaybe<Scalars['Boolean']>;
};


export type BaseQueryTMnDocumentsWithStatusArgs = {
  acSubject?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  anClassificationQId?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  byAnQid?: InputMaybe<Scalars['Int']>;
  dmsAcStatusIn?: InputMaybe<Array<Scalars['String']>>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnDocumentWithStatusSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<Scalars['Boolean']>;
  showOnlyUnconfirmedDMSDocuments?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TMnDocumentWithStatusFilterInput>;
};


export type BaseQueryTMnFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byAnDocumentQId?: InputMaybe<Scalars['Int']>;
  byAnQId?: InputMaybe<Scalars['Int']>;
  byAnUserIns?: InputMaybe<Scalars['Int']>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TMnFileSortInput>>;
  search?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<TMnFileFilterInput>;
};


export type BaseQueryTMnSetClassificationsArgs = {
  order?: InputMaybe<Array<TMnSetClassificationSortInput>>;
  where?: InputMaybe<TMnSetClassificationFilterInput>;
};


export type BaseQueryTPaSysParamArgs = {
  order?: InputMaybe<Array<TPaSysParamSortInput>>;
  where?: InputMaybe<TPaSysParamFilterInput>;
};


export type BaseQueryTPaUserPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TPaUserSortInput>>;
  where?: InputMaybe<TPaUserFilterInput>;
};


export type BaseQueryUnfiscalizedDocumentCountArgs = {
  docId: Scalars['Int'];
};


export type BaseQueryUnlinkedDocumentCountFromDocumentTypePairArgs = {
  documentTypePairId: Scalars['Int'];
};


export type BaseQueryUsersArgs = {
  order?: InputMaybe<Array<ApplicationUserSortInput>>;
  where?: InputMaybe<ApplicationUserFilterInput>;
};


export type BaseQueryVOpSetDeptsArgs = {
  order?: InputMaybe<Array<VopSetDeptSortInput>>;
  where?: InputMaybe<VopSetDeptFilterInput>;
};


export type BaseQueryVOpSetItemCategsArgs = {
  order?: InputMaybe<Array<VopSetItemCategSortInput>>;
  where?: InputMaybe<VopSetItemCategFilterInput>;
};


export type BaseQueryVOpSetItemCategsPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<VopSetItemCategSortInput>>;
  where?: InputMaybe<VopSetItemCategFilterInput>;
};


export type BaseQueryVOpSetItemsArgs = {
  order?: InputMaybe<Array<VopSetItemSortInput>>;
  where?: InputMaybe<VopSetItemFilterInput>;
};


export type BaseQueryVOpSetItemsPagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<VopSetItemSortInput>>;
  where?: InputMaybe<VopSetItemFilterInput>;
};


export type BaseQueryVOpCashRegArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<VOpCashRegSortInput>>;
  where?: InputMaybe<VOpCashRegFilterInput>;
};


export type BaseQueryVOpMoveBankArgs = {
  acKey?: InputMaybe<Scalars['String']>;
};


export type BaseQueryVOpSetBoatNamePagedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<VOpSetBoatNameSortInput>>;
  where?: InputMaybe<VOpSetBoatNameFilterInput>;
};


export type BaseQueryVOpSetBoatNamesArgs = {
  order?: InputMaybe<Array<VOpSetBoatNameSortInput>>;
  where?: InputMaybe<VOpSetBoatNameFilterInput>;
};


export type BaseQueryWebCustomerBalanceArgs = {
  acSubject?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
};


export type BaseQueryWebDailyIncomeArgs = {
  documentTypeId: Scalars['Int'];
};


export type BaseQueryWebDmsStatusCountsArgs = {
  anClassificationQId?: InputMaybe<Scalars['Int']>;
  documentTypeId: Scalars['Int'];
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<Scalars['Boolean']>;
};


export type BaseQueryWebDocumentDetailArgs = {
  acKey?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
};


export type BaseQueryWebDocumentRoutePreviewArgs = {
  acPayMethod?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
};


export type BaseQueryWebDocumentStatusesArgs = {
  acKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  documentTypeId: Scalars['Int'];
};


export type BaseQueryWebDraftArgs = {
  id: Scalars['UUID'];
};


export type BaseQueryWebDraftsArgs = {
  documentTypeId: Scalars['Int'];
};


export type BaseQueryWebItemClassificationsArgs = {
  documentTypeId: Scalars['Int'];
};


export type BaseQueryWebItemPricesArgs = {
  customerAcSubject?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  documentTypeId: Scalars['Int'];
  idents?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  warehouseAcSubject?: InputMaybe<Scalars['String']>;
};


export type BaseQueryWebItemSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<WebItemSearchInput>;
  last?: InputMaybe<Scalars['Int']>;
};


export type BaseQueryWebMoveListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  filter?: InputMaybe<WebDocumentListFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  historyView: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
  where?: InputMaybe<THeMoveFilterInput>;
};


export type BaseQueryWebOrderListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  filter?: InputMaybe<WebDocumentListFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  historyView: Scalars['Boolean'];
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeOrderSortInput>>;
  where?: InputMaybe<THeOrderFilterInput>;
};


export type BaseQueryWebSubjectHistoryArgs = {
  acSubject?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dmsDocumentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<THeMoveSortInput>>;
};


export type BaseQueryWebSubjectSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<WebSubjectSearchInput>;
  last?: InputMaybe<Scalars['Int']>;
};


export type BaseQueryWorkOrderArgs = {
  acKey?: InputMaybe<Scalars['String']>;
};


export type BaseQueryWorkOrderPdfArgs = {
  acKey?: InputMaybe<Scalars['String']>;
};


export type BaseQueryWorkflowTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TPaWorkflowTaskInstanceSortInput>>;
  where?: InputMaybe<TPaWorkflowTaskInstanceFilterInput>;
};


export type BaseQueryZippedPlainTHeSetCustTariffArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetDelMetArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetDutyArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetItemArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetItemCategArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetItemExtItemSubjArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetItemPriceForWrhArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetPayMetArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetPostCodeArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetSubjArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetSubjPriceCategArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetSubjPriceItemArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeSetTaxArgs = {
  adTimeChg: Scalars['DateTime'];
};


export type BaseQueryZippedPlainTHeStockArgs = {
  adTimeChg: Scalars['DateTime'];
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type ByteArrayDto = {
  data?: Maybe<Array<Scalars['Byte']>>;
};

export enum CardPaymentProvider {
  None = 'NONE',
  SoftPos7PayErste = 'SOFT_POS7_PAY_ERSTE'
}

export type ClassifyTMnDocumentDtoInput = {
  metadata?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  note?: InputMaybe<Scalars['String']>;
  reclassifySubjectDocuments?: InputMaybe<Scalars['Boolean']>;
  rememberSubjectClassificationMapping?: InputMaybe<Scalars['Boolean']>;
  subjectClassificationAcSubject?: InputMaybe<Scalars['String']>;
};

export enum ClientEnum {
  AdrianaNautica = 'ADRIANA_NAUTICA',
  Cortina = 'CORTINA',
  Dimeglio = 'DIMEGLIO',
  Donar = 'DONAR',
  Mushrooms = 'MUSHROOMS',
  Onix = 'ONIX',
  Protech = 'PROTECH',
  Trim = 'TRIM'
}

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type Company = {
  accountingCompany?: Maybe<Company>;
  accountingCompanyId?: Maybe<Scalars['Int']>;
  alternateMainServerPrefix?: Maybe<Scalars['String']>;
  aresDeploymentAresCompanyCurrentVersions?: Maybe<Array<Maybe<AresDeploymentAresCompanyCurrentVersion>>>;
  aresDeploymentGroupCompanyMappings?: Maybe<Array<Maybe<AresDeploymentGroupCompanyMapping>>>;
  companyDatalabReferenceLinks?: Maybe<Array<Maybe<CompanyDatalabReferenceLink>>>;
  companyMachineUids?: Maybe<Array<Maybe<CompanyMachineUid>>>;
  companyMeshCentralGroupMappings?: Maybe<Array<Maybe<CompanyMeshCentralGroupMapping>>>;
  companyRunbookNotes?: Maybe<Array<Maybe<CompanyRunbookNote>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  companyTeamViewerContacts?: Maybe<Array<Maybe<CompanyTeamViewerContact>>>;
  companyTeamViewerDevices?: Maybe<Array<Maybe<CompanyTeamViewerDevice>>>;
  connectionSettings?: Maybe<Scalars['String']>;
  contactCompanies?: Maybe<Array<Maybe<ContactCompany>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  datalabReleaseLockdownRuns?: Maybe<Array<Maybe<DatalabReleaseLockdownRun>>>;
  description?: Maybe<Scalars['String']>;
  grunfAresSyncToken?: Maybe<Scalars['String']>;
  iBackupEventLogComputers?: Maybe<Array<Maybe<IBackupEventLogComputer>>>;
  id: Scalars['Int'];
  linkedCompanySettings?: Maybe<CompanySettings>;
  linkedCompanySettingsId?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  myEInvoiceSettings?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notOurCustomer: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  pantheonAcSubject?: Maybe<Scalars['String']>;
  pantheonBuyerType?: Maybe<Scalars['String']>;
  pantheonBuyerTypeName?: Maybe<Scalars['String']>;
  pantheonConnectionString?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  pantheonStatus?: Maybe<Scalars['String']>;
  pantheonSubscriber: Scalars['Boolean'];
  shouldHaveIBackup: Scalars['Boolean'];
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
};

export type CompanyDatalabReferenceLink = {
  company: Company;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  datalabReferenceCompany?: Maybe<DatalabReferenceCompany>;
  datalabReferenceCompanyId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isManual: Scalars['Boolean'];
  lastSuggestedAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  reviewedById?: Maybe<Scalars['String']>;
  status: CompanyDatalabReferenceLinkStatusEnum;
  suggestedReason?: Maybe<Scalars['String']>;
  suggestedScore?: Maybe<Scalars['Decimal']>;
};

export type CompanyDatalabReferenceLinkFilterInput = {
  and?: InputMaybe<Array<CompanyDatalabReferenceLinkFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  datalabReferenceCompany?: InputMaybe<DatalabReferenceCompanyFilterInput>;
  datalabReferenceCompanyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isManual?: InputMaybe<BooleanOperationFilterInput>;
  lastSuggestedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyDatalabReferenceLinkFilterInput>>;
  reviewedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  reviewedById?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<CompanyDatalabReferenceLinkStatusEnumOperationFilterInput>;
  suggestedReason?: InputMaybe<StringOperationFilterInput>;
  suggestedScore?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export enum CompanyDatalabReferenceLinkStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type CompanyDatalabReferenceLinkStatusEnumOperationFilterInput = {
  eq?: InputMaybe<CompanyDatalabReferenceLinkStatusEnum>;
  in?: InputMaybe<Array<CompanyDatalabReferenceLinkStatusEnum>>;
  neq?: InputMaybe<CompanyDatalabReferenceLinkStatusEnum>;
  nin?: InputMaybe<Array<CompanyDatalabReferenceLinkStatusEnum>>;
};

export type CompanyEmailForward = {
  bCC?: Maybe<Scalars['String']>;
  bodyFormat?: Maybe<Scalars['String']>;
  bodyParams?: Maybe<Scalars['String']>;
  cC?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  context: CompanyEmailForwardContextEnum;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  documentFilterSQL?: Maybe<Scalars['String']>;
  documentItemsFilterSQL?: Maybe<Scalars['String']>;
  documentType?: Maybe<DocumentType>;
  documentTypeId?: Maybe<Scalars['Int']>;
  documentTypeParams?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isBodyHtml: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  receivingEmail?: Maybe<Scalars['String']>;
  titleFormat?: Maybe<Scalars['String']>;
  titleParams?: Maybe<Scalars['String']>;
};

export enum CompanyEmailForwardContextEnum {
  AfterSavingDocument = 'AFTER_SAVING_DOCUMENT',
  AfterSavingSignedPdf = 'AFTER_SAVING_SIGNED_PDF'
}

export type CompanyEmailForwardContextEnumOperationFilterInput = {
  eq?: InputMaybe<CompanyEmailForwardContextEnum>;
  in?: InputMaybe<Array<CompanyEmailForwardContextEnum>>;
  neq?: InputMaybe<CompanyEmailForwardContextEnum>;
  nin?: InputMaybe<Array<CompanyEmailForwardContextEnum>>;
};

export type CompanyEmailForwardFilterInput = {
  and?: InputMaybe<Array<CompanyEmailForwardFilterInput>>;
  bCC?: InputMaybe<StringOperationFilterInput>;
  bodyFormat?: InputMaybe<StringOperationFilterInput>;
  bodyParams?: InputMaybe<StringOperationFilterInput>;
  cC?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  context?: InputMaybe<CompanyEmailForwardContextEnumOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  documentFilterSQL?: InputMaybe<StringOperationFilterInput>;
  documentItemsFilterSQL?: InputMaybe<StringOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  documentTypeParams?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isBodyHtml?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyEmailForwardFilterInput>>;
  receivingEmail?: InputMaybe<StringOperationFilterInput>;
  titleFormat?: InputMaybe<StringOperationFilterInput>;
  titleParams?: InputMaybe<StringOperationFilterInput>;
};

export type CompanyFilterInput = {
  accountingCompany?: InputMaybe<CompanyFilterInput>;
  accountingCompanyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  alternateMainServerPrefix?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CompanyFilterInput>>;
  aresDeploymentAresCompanyCurrentVersions?: InputMaybe<ListFilterInputTypeOfAresDeploymentAresCompanyCurrentVersionFilterInput>;
  aresDeploymentGroupCompanyMappings?: InputMaybe<ListFilterInputTypeOfAresDeploymentGroupCompanyMappingFilterInput>;
  companyDatalabReferenceLinks?: InputMaybe<ListFilterInputTypeOfCompanyDatalabReferenceLinkFilterInput>;
  companyMachineUids?: InputMaybe<ListFilterInputTypeOfCompanyMachineUidFilterInput>;
  companyMeshCentralGroupMappings?: InputMaybe<ListFilterInputTypeOfCompanyMeshCentralGroupMappingFilterInput>;
  companyRunbookNotes?: InputMaybe<ListFilterInputTypeOfCompanyRunbookNoteFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companyTeamViewerContacts?: InputMaybe<ListFilterInputTypeOfCompanyTeamViewerContactFilterInput>;
  companyTeamViewerDevices?: InputMaybe<ListFilterInputTypeOfCompanyTeamViewerDeviceFilterInput>;
  connectionSettings?: InputMaybe<StringOperationFilterInput>;
  contactCompanies?: InputMaybe<ListFilterInputTypeOfContactCompanyFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  datalabReleaseLockdownRuns?: InputMaybe<ListFilterInputTypeOfDatalabReleaseLockdownRunFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  grunfAresSyncToken?: InputMaybe<StringOperationFilterInput>;
  iBackupEventLogComputers?: InputMaybe<ListFilterInputTypeOfIBackupEventLogComputerFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  linkedCompanySettings?: InputMaybe<CompanySettingsFilterInput>;
  linkedCompanySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  myEInvoiceSettings?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notOurCustomer?: InputMaybe<BooleanOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
  pantheonAcSubject?: InputMaybe<StringOperationFilterInput>;
  pantheonBuyerType?: InputMaybe<StringOperationFilterInput>;
  pantheonBuyerTypeName?: InputMaybe<StringOperationFilterInput>;
  pantheonConnectionString?: InputMaybe<StringOperationFilterInput>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  pantheonStatus?: InputMaybe<StringOperationFilterInput>;
  pantheonSubscriber?: InputMaybe<BooleanOperationFilterInput>;
  shouldHaveIBackup?: InputMaybe<BooleanOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type CompanyMachineUid = {
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  database?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  machineUID?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type CompanyMachineUidFilterInput = {
  and?: InputMaybe<Array<CompanyMachineUidFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  database?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  machineUID?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyMachineUidFilterInput>>;
};

export type CompanyMeshCentralGroupMapping = {
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  meshCentralGroupId?: Maybe<Scalars['String']>;
  meshCentralGroupName?: Maybe<Scalars['String']>;
  meshCentralServerDeviceId?: Maybe<Scalars['String']>;
  meshCentralServerDeviceName?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  mssqlPort?: Maybe<Scalars['Int']>;
};

export type CompanyMeshCentralGroupMappingFilterInput = {
  and?: InputMaybe<Array<CompanyMeshCentralGroupMappingFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastSeenAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  meshCentralGroupId?: InputMaybe<StringOperationFilterInput>;
  meshCentralGroupName?: InputMaybe<StringOperationFilterInput>;
  meshCentralServerDeviceId?: InputMaybe<StringOperationFilterInput>;
  meshCentralServerDeviceName?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  mssqlPort?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<CompanyMeshCentralGroupMappingFilterInput>>;
};

export type CompanyRunbookNote = {
  attachments?: Maybe<Array<Maybe<SavedFile>>>;
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uniqueClientId?: Maybe<Scalars['String']>;
};

export type CompanyRunbookNoteFilterInput = {
  and?: InputMaybe<Array<CompanyRunbookNoteFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  content?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyRunbookNoteFilterInput>>;
  tags?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  uniqueClientId?: InputMaybe<StringOperationFilterInput>;
};

export type CompanyRunbookNoteSortInput = {
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  content?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  tags?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  uniqueClientId?: InputMaybe<SortEnumType>;
};

export type CompanySettings = {
  additionalBottomTextOnPrint?: Maybe<Scalars['String']>;
  aiSupportApiKey?: Maybe<Scalars['String']>;
  aiSupportDefaultTimeoutMinutes?: Maybe<Scalars['Int']>;
  aiSupportInvestigationModel?: Maybe<Scalars['String']>;
  aiSupportMaxInputTokensPerTurn?: Maybe<Scalars['Int']>;
  aiSupportMaxOutputTokensPerTurn?: Maybe<Scalars['Int']>;
  aiSupportMaxToolRounds?: Maybe<Scalars['Int']>;
  aiSupportReasoningEffort?: Maybe<Scalars['String']>;
  aiSupportRunBudgetMode: AiSupportRunBudgetMode;
  aiSupportTriageModel?: Maybe<Scalars['String']>;
  aiSupportVerbosity?: Maybe<Scalars['String']>;
  alternateMainServerPrefix?: Maybe<Scalars['String']>;
  applicationPackets?: Maybe<Array<Maybe<ApplicationPacket>>>;
  bookStackUrl?: Maybe<Scalars['String']>;
  client?: Maybe<ClientEnum>;
  companyDatalabReferenceLinks?: Maybe<Array<Maybe<CompanyDatalabReferenceLink>>>;
  companyDocumentsEmail?: Maybe<Scalars['String']>;
  companyEmailForwards?: Maybe<Array<Maybe<CompanyEmailForward>>>;
  companyGS1Prefix?: Maybe<Scalars['String']>;
  companyOutboundEmail?: Maybe<Scalars['String']>;
  companyOutboundEmailDisplayName?: Maybe<Scalars['String']>;
  companyOutboundEmailHost?: Maybe<Scalars['String']>;
  companyOutboundEmailPassword?: Maybe<Scalars['String']>;
  companyOutboundEmailPort: Scalars['Int'];
  companyOutboundEmailUseSSL: Scalars['Boolean'];
  companyOutboundEmailUseTLS: Scalars['Boolean'];
  companyOutboundEmailUser?: Maybe<Scalars['String']>;
  companySQLConnectionString?: Maybe<Scalars['String']>;
  companyStamp?: Maybe<Array<Scalars['Byte']>>;
  connectionName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  culture?: Maybe<Scalars['String']>;
  datalabBaseUrl?: Maybe<Scalars['String']>;
  datalabPassword?: Maybe<Scalars['String']>;
  datalabReferenceCompanies?: Maybe<Array<Maybe<DatalabReferenceCompany>>>;
  datalabReferencePartnerQuery?: Maybe<Scalars['String']>;
  datalabReleaseLockdownRuns?: Maybe<Array<Maybe<DatalabReleaseLockdownRun>>>;
  datalabSyncEnabled: Scalars['Boolean'];
  datalabUsername?: Maybe<Scalars['String']>;
  eInvoiceIssuerVatRegistered?: Maybe<Scalars['Boolean']>;
  expenseBearers?: Maybe<Array<Maybe<ExpenseBearer>>>;
  externalId?: Maybe<Scalars['String']>;
  fiscCertContent?: Maybe<Array<Scalars['Byte']>>;
  fiscCertIssuer?: Maybe<Scalars['String']>;
  fiscCertPassword?: Maybe<Scalars['String']>;
  fiscCertPrivateKey?: Maybe<Array<Scalars['Byte']>>;
  fiscCertSerialNumber?: Maybe<Scalars['String']>;
  grunfCompanyId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isMainAresDeploymentDatabase?: Maybe<Scalars['Boolean']>;
  isMainAresTestingDatabase?: Maybe<Scalars['Boolean']>;
  meshCentralPassword?: Maybe<Scalars['String']>;
  meshCentralServerUrl?: Maybe<Scalars['String']>;
  meshCentralUsername?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  onixPhoneEInvoiceEnabled?: Maybe<Scalars['Boolean']>;
  onixPhoneProxyDBCreated: Scalars['Boolean'];
  pantheonAcCompanyPrtTextA?: Maybe<Scalars['String']>;
  pantheonAcCompanyPrtTextB?: Maybe<Scalars['String']>;
  pantheonAcQtyInCodeCont?: Maybe<Scalars['String']>;
  pantheonAlsoUseNDigitBarcodes?: Maybe<Scalars['Int']>;
  pantheonAnDocKeyLenDocType: Scalars['Int'];
  pantheonAnDocKeyLenNumber: Scalars['Int'];
  pantheonAnGenerSubjNoFieldLen?: Maybe<Scalars['Int']>;
  pantheonAnGenerSubjNoLen?: Maybe<Scalars['Int']>;
  pantheonAnPrStNo: Scalars['Int'];
  pantheonAnQtyInCodeLen: Scalars['Int'];
  pantheonCompanyAddress?: Maybe<Scalars['String']>;
  pantheonCompanyImage?: Maybe<Array<Scalars['Byte']>>;
  pantheonCompanyName?: Maybe<Scalars['String']>;
  pantheonCompanyOnixPhoneSmallImage?: Maybe<Array<Scalars['Byte']>>;
  pantheonCompanyPIN?: Maybe<Scalars['String']>;
  primaryCurrency?: Maybe<Scalars['String']>;
  supportAutoReplyOnNewTicket: Scalars['Boolean'];
  supportAutoReplyOnNewTicketBody?: Maybe<Scalars['String']>;
  supportAutoReplyOnNewTicketSubject?: Maybe<Scalars['String']>;
  supportEmailAddress?: Maybe<Scalars['String']>;
  supportEmailPassword?: Maybe<Scalars['String']>;
  supportIBackupEmailAddress?: Maybe<Scalars['String']>;
  supportIBackupEmailPassword?: Maybe<Scalars['String']>;
  supportRedirectAllToSender: Scalars['Boolean'];
  supportTickets?: Maybe<Array<Maybe<SupportTicket>>>;
  synchronizations?: Maybe<Array<Maybe<Synchronization>>>;
  teamViewerClientId?: Maybe<Scalars['String']>;
  teamViewerClientSecret?: Maybe<Scalars['String']>;
  teamViewerGroupId?: Maybe<Scalars['String']>;
  teamViewerRefreshToken?: Maybe<Scalars['String']>;
  teamViewerScriptKey?: Maybe<Scalars['String']>;
  teamViewerToken?: Maybe<Scalars['String']>;
  tenant?: Maybe<OnixTenant>;
  testingFiscalisation?: Maybe<Scalars['Boolean']>;
  timeZone?: Maybe<Scalars['String']>;
  travelKilometers?: Maybe<Array<Maybe<TravelKilometers>>>;
  useSecondaryCurrency: Scalars['Boolean'];
  users?: Maybe<Array<Maybe<ApplicationUser>>>;
  wooCommerceKey?: Maybe<Scalars['String']>;
  wooCommerceLocation?: Maybe<Scalars['String']>;
  wooCommerceSecret?: Maybe<Scalars['String']>;
  workHours?: Maybe<Array<Maybe<CompanySettingsWorkHours>>>;
  workOrderItemsAdditionalReportData?: Maybe<OnixPhoneAdditionalReportData>;
  workOrderWorkerPickerIncludesInactiveWorkers: Scalars['Boolean'];
  workRecordCostTypes?: Maybe<Array<Maybe<WorkRecordCostType>>>;
  workRecordPeriods?: Maybe<Array<Maybe<WorkRecordPeriod>>>;
};

export type CompanySettingsFilterInput = {
  additionalBottomTextOnPrint?: InputMaybe<StringOperationFilterInput>;
  aiSupportApiKey?: InputMaybe<StringOperationFilterInput>;
  aiSupportDefaultTimeoutMinutes?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aiSupportInvestigationModel?: InputMaybe<StringOperationFilterInput>;
  aiSupportMaxInputTokensPerTurn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aiSupportMaxOutputTokensPerTurn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aiSupportMaxToolRounds?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  aiSupportReasoningEffort?: InputMaybe<StringOperationFilterInput>;
  aiSupportRunBudgetMode?: InputMaybe<AiSupportRunBudgetModeOperationFilterInput>;
  aiSupportTriageModel?: InputMaybe<StringOperationFilterInput>;
  aiSupportVerbosity?: InputMaybe<StringOperationFilterInput>;
  alternateMainServerPrefix?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CompanySettingsFilterInput>>;
  applicationPackets?: InputMaybe<ListFilterInputTypeOfApplicationPacketFilterInput>;
  bookStackUrl?: InputMaybe<StringOperationFilterInput>;
  client?: InputMaybe<NullableOfClientEnumOperationFilterInput>;
  companyDatalabReferenceLinks?: InputMaybe<ListFilterInputTypeOfCompanyDatalabReferenceLinkFilterInput>;
  companyDocumentsEmail?: InputMaybe<StringOperationFilterInput>;
  companyEmailForwards?: InputMaybe<ListFilterInputTypeOfCompanyEmailForwardFilterInput>;
  companyGS1Prefix?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmail?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmailDisplayName?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmailHost?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmailPassword?: InputMaybe<StringOperationFilterInput>;
  companyOutboundEmailPort?: InputMaybe<ComparableInt32OperationFilterInput>;
  companyOutboundEmailUseSSL?: InputMaybe<BooleanOperationFilterInput>;
  companyOutboundEmailUseTLS?: InputMaybe<BooleanOperationFilterInput>;
  companyOutboundEmailUser?: InputMaybe<StringOperationFilterInput>;
  companySQLConnectionString?: InputMaybe<StringOperationFilterInput>;
  companyStamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  connectionName?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  culture?: InputMaybe<StringOperationFilterInput>;
  datalabBaseUrl?: InputMaybe<StringOperationFilterInput>;
  datalabPassword?: InputMaybe<StringOperationFilterInput>;
  datalabReferenceCompanies?: InputMaybe<ListFilterInputTypeOfDatalabReferenceCompanyFilterInput>;
  datalabReferencePartnerQuery?: InputMaybe<StringOperationFilterInput>;
  datalabReleaseLockdownRuns?: InputMaybe<ListFilterInputTypeOfDatalabReleaseLockdownRunFilterInput>;
  datalabSyncEnabled?: InputMaybe<BooleanOperationFilterInput>;
  datalabUsername?: InputMaybe<StringOperationFilterInput>;
  eInvoiceIssuerVatRegistered?: InputMaybe<BooleanOperationFilterInput>;
  expenseBearers?: InputMaybe<ListFilterInputTypeOfExpenseBearerFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  fiscCertContent?: InputMaybe<ListComparableByteOperationFilterInput>;
  fiscCertIssuer?: InputMaybe<StringOperationFilterInput>;
  fiscCertPassword?: InputMaybe<StringOperationFilterInput>;
  fiscCertPrivateKey?: InputMaybe<ListComparableByteOperationFilterInput>;
  fiscCertSerialNumber?: InputMaybe<StringOperationFilterInput>;
  grunfCompanyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isMainAresDeploymentDatabase?: InputMaybe<BooleanOperationFilterInput>;
  isMainAresTestingDatabase?: InputMaybe<BooleanOperationFilterInput>;
  meshCentralPassword?: InputMaybe<StringOperationFilterInput>;
  meshCentralServerUrl?: InputMaybe<StringOperationFilterInput>;
  meshCentralUsername?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  onixPhoneEInvoiceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  onixPhoneProxyDBCreated?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CompanySettingsFilterInput>>;
  pantheonAcCompanyPrtTextA?: InputMaybe<StringOperationFilterInput>;
  pantheonAcCompanyPrtTextB?: InputMaybe<StringOperationFilterInput>;
  pantheonAcQtyInCodeCont?: InputMaybe<StringOperationFilterInput>;
  pantheonAlsoUseNDigitBarcodes?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pantheonAnDocKeyLenDocType?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonAnDocKeyLenNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonAnGenerSubjNoFieldLen?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pantheonAnGenerSubjNoLen?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pantheonAnPrStNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonAnQtyInCodeLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonCompanyAddress?: InputMaybe<StringOperationFilterInput>;
  pantheonCompanyImage?: InputMaybe<ListComparableByteOperationFilterInput>;
  pantheonCompanyName?: InputMaybe<StringOperationFilterInput>;
  pantheonCompanyOnixPhoneSmallImage?: InputMaybe<ListComparableByteOperationFilterInput>;
  pantheonCompanyPIN?: InputMaybe<StringOperationFilterInput>;
  primaryCurrency?: InputMaybe<StringOperationFilterInput>;
  supportAutoReplyOnNewTicket?: InputMaybe<BooleanOperationFilterInput>;
  supportAutoReplyOnNewTicketBody?: InputMaybe<StringOperationFilterInput>;
  supportAutoReplyOnNewTicketSubject?: InputMaybe<StringOperationFilterInput>;
  supportEmailAddress?: InputMaybe<StringOperationFilterInput>;
  supportEmailPassword?: InputMaybe<StringOperationFilterInput>;
  supportIBackupEmailAddress?: InputMaybe<StringOperationFilterInput>;
  supportIBackupEmailPassword?: InputMaybe<StringOperationFilterInput>;
  supportRedirectAllToSender?: InputMaybe<BooleanOperationFilterInput>;
  supportTickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
  synchronizations?: InputMaybe<ListFilterInputTypeOfSynchronizationFilterInput>;
  teamViewerClientId?: InputMaybe<StringOperationFilterInput>;
  teamViewerClientSecret?: InputMaybe<StringOperationFilterInput>;
  teamViewerGroupId?: InputMaybe<StringOperationFilterInput>;
  teamViewerRefreshToken?: InputMaybe<StringOperationFilterInput>;
  teamViewerScriptKey?: InputMaybe<StringOperationFilterInput>;
  teamViewerToken?: InputMaybe<StringOperationFilterInput>;
  tenant?: InputMaybe<NullableOfOnixTenantOperationFilterInput>;
  testingFiscalisation?: InputMaybe<BooleanOperationFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
  travelKilometers?: InputMaybe<ListFilterInputTypeOfTravelKilometersFilterInput>;
  useSecondaryCurrency?: InputMaybe<BooleanOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  wooCommerceKey?: InputMaybe<StringOperationFilterInput>;
  wooCommerceLocation?: InputMaybe<StringOperationFilterInput>;
  wooCommerceSecret?: InputMaybe<StringOperationFilterInput>;
  workHours?: InputMaybe<ListFilterInputTypeOfCompanySettingsWorkHoursFilterInput>;
  workOrderItemsAdditionalReportData?: InputMaybe<OnixPhoneAdditionalReportDataFilterInput>;
  workOrderWorkerPickerIncludesInactiveWorkers?: InputMaybe<BooleanOperationFilterInput>;
  workRecordCostTypes?: InputMaybe<ListFilterInputTypeOfWorkRecordCostTypeFilterInput>;
  workRecordPeriods?: InputMaybe<ListFilterInputTypeOfWorkRecordPeriodFilterInput>;
};

export type CompanySettingsSortInput = {
  additionalBottomTextOnPrint?: InputMaybe<SortEnumType>;
  aiSupportApiKey?: InputMaybe<SortEnumType>;
  aiSupportDefaultTimeoutMinutes?: InputMaybe<SortEnumType>;
  aiSupportInvestigationModel?: InputMaybe<SortEnumType>;
  aiSupportMaxInputTokensPerTurn?: InputMaybe<SortEnumType>;
  aiSupportMaxOutputTokensPerTurn?: InputMaybe<SortEnumType>;
  aiSupportMaxToolRounds?: InputMaybe<SortEnumType>;
  aiSupportReasoningEffort?: InputMaybe<SortEnumType>;
  aiSupportRunBudgetMode?: InputMaybe<SortEnumType>;
  aiSupportTriageModel?: InputMaybe<SortEnumType>;
  aiSupportVerbosity?: InputMaybe<SortEnumType>;
  alternateMainServerPrefix?: InputMaybe<SortEnumType>;
  bookStackUrl?: InputMaybe<SortEnumType>;
  client?: InputMaybe<SortEnumType>;
  companyDocumentsEmail?: InputMaybe<SortEnumType>;
  companyGS1Prefix?: InputMaybe<SortEnumType>;
  companyOutboundEmail?: InputMaybe<SortEnumType>;
  companyOutboundEmailDisplayName?: InputMaybe<SortEnumType>;
  companyOutboundEmailHost?: InputMaybe<SortEnumType>;
  companyOutboundEmailPassword?: InputMaybe<SortEnumType>;
  companyOutboundEmailPort?: InputMaybe<SortEnumType>;
  companyOutboundEmailUseSSL?: InputMaybe<SortEnumType>;
  companyOutboundEmailUseTLS?: InputMaybe<SortEnumType>;
  companyOutboundEmailUser?: InputMaybe<SortEnumType>;
  companySQLConnectionString?: InputMaybe<SortEnumType>;
  connectionName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  culture?: InputMaybe<SortEnumType>;
  datalabBaseUrl?: InputMaybe<SortEnumType>;
  datalabPassword?: InputMaybe<SortEnumType>;
  datalabReferencePartnerQuery?: InputMaybe<SortEnumType>;
  datalabSyncEnabled?: InputMaybe<SortEnumType>;
  datalabUsername?: InputMaybe<SortEnumType>;
  eInvoiceIssuerVatRegistered?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  fiscCertIssuer?: InputMaybe<SortEnumType>;
  fiscCertPassword?: InputMaybe<SortEnumType>;
  fiscCertSerialNumber?: InputMaybe<SortEnumType>;
  grunfCompanyId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isMainAresDeploymentDatabase?: InputMaybe<SortEnumType>;
  isMainAresTestingDatabase?: InputMaybe<SortEnumType>;
  meshCentralPassword?: InputMaybe<SortEnumType>;
  meshCentralServerUrl?: InputMaybe<SortEnumType>;
  meshCentralUsername?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  onixPhoneEInvoiceEnabled?: InputMaybe<SortEnumType>;
  onixPhoneProxyDBCreated?: InputMaybe<SortEnumType>;
  pantheonAcCompanyPrtTextA?: InputMaybe<SortEnumType>;
  pantheonAcCompanyPrtTextB?: InputMaybe<SortEnumType>;
  pantheonAcQtyInCodeCont?: InputMaybe<SortEnumType>;
  pantheonAlsoUseNDigitBarcodes?: InputMaybe<SortEnumType>;
  pantheonAnDocKeyLenDocType?: InputMaybe<SortEnumType>;
  pantheonAnDocKeyLenNumber?: InputMaybe<SortEnumType>;
  pantheonAnGenerSubjNoFieldLen?: InputMaybe<SortEnumType>;
  pantheonAnGenerSubjNoLen?: InputMaybe<SortEnumType>;
  pantheonAnPrStNo?: InputMaybe<SortEnumType>;
  pantheonAnQtyInCodeLen?: InputMaybe<SortEnumType>;
  pantheonCompanyAddress?: InputMaybe<SortEnumType>;
  pantheonCompanyName?: InputMaybe<SortEnumType>;
  pantheonCompanyPIN?: InputMaybe<SortEnumType>;
  primaryCurrency?: InputMaybe<SortEnumType>;
  supportAutoReplyOnNewTicket?: InputMaybe<SortEnumType>;
  supportAutoReplyOnNewTicketBody?: InputMaybe<SortEnumType>;
  supportAutoReplyOnNewTicketSubject?: InputMaybe<SortEnumType>;
  supportEmailAddress?: InputMaybe<SortEnumType>;
  supportEmailPassword?: InputMaybe<SortEnumType>;
  supportIBackupEmailAddress?: InputMaybe<SortEnumType>;
  supportIBackupEmailPassword?: InputMaybe<SortEnumType>;
  supportRedirectAllToSender?: InputMaybe<SortEnumType>;
  teamViewerClientId?: InputMaybe<SortEnumType>;
  teamViewerClientSecret?: InputMaybe<SortEnumType>;
  teamViewerGroupId?: InputMaybe<SortEnumType>;
  teamViewerRefreshToken?: InputMaybe<SortEnumType>;
  teamViewerScriptKey?: InputMaybe<SortEnumType>;
  teamViewerToken?: InputMaybe<SortEnumType>;
  tenant?: InputMaybe<SortEnumType>;
  testingFiscalisation?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
  useSecondaryCurrency?: InputMaybe<SortEnumType>;
  wooCommerceKey?: InputMaybe<SortEnumType>;
  wooCommerceLocation?: InputMaybe<SortEnumType>;
  wooCommerceSecret?: InputMaybe<SortEnumType>;
  workOrderItemsAdditionalReportData?: InputMaybe<OnixPhoneAdditionalReportDataSortInput>;
  workOrderWorkerPickerIncludesInactiveWorkers?: InputMaybe<SortEnumType>;
};

export type CompanySettingsWorkHours = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  day: DayOfWeek;
  endTime: Scalars['TimeSpan'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  startTime: Scalars['TimeSpan'];
};

export type CompanySettingsWorkHoursFilterInput = {
  and?: InputMaybe<Array<CompanySettingsWorkHoursFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  day?: InputMaybe<DayOfWeekOperationFilterInput>;
  endTime?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanySettingsWorkHoursFilterInput>>;
  startTime?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
};

export type CompanySortInput = {
  accountingCompany?: InputMaybe<CompanySortInput>;
  accountingCompanyId?: InputMaybe<SortEnumType>;
  alternateMainServerPrefix?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  connectionSettings?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  grunfAresSyncToken?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  linkedCompanySettings?: InputMaybe<CompanySettingsSortInput>;
  linkedCompanySettingsId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  myEInvoiceSettings?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notOurCustomer?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  pantheonAcSubject?: InputMaybe<SortEnumType>;
  pantheonBuyerType?: InputMaybe<SortEnumType>;
  pantheonBuyerTypeName?: InputMaybe<SortEnumType>;
  pantheonConnectionString?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  pantheonStatus?: InputMaybe<SortEnumType>;
  pantheonSubscriber?: InputMaybe<SortEnumType>;
  shouldHaveIBackup?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
};

export type CompanyTeamViewerContact = {
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  teamViewerContactDescription?: Maybe<Scalars['String']>;
  teamViewerContactID?: Maybe<Scalars['String']>;
  teamViewerContactName?: Maybe<Scalars['String']>;
};

export type CompanyTeamViewerContactFilterInput = {
  and?: InputMaybe<Array<CompanyTeamViewerContactFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CompanyTeamViewerContactFilterInput>>;
  teamViewerContactDescription?: InputMaybe<StringOperationFilterInput>;
  teamViewerContactID?: InputMaybe<StringOperationFilterInput>;
  teamViewerContactName?: InputMaybe<StringOperationFilterInput>;
};

export type CompanyTeamViewerDevice = {
  alias?: Maybe<Scalars['String']>;
  assignedTo: Scalars['Boolean'];
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deviceId?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  onlineState?: Maybe<Scalars['String']>;
  remoteControlId?: Maybe<Scalars['String']>;
  teamviewerId: Scalars['Int'];
};

export type CompanyTeamViewerDeviceFilterInput = {
  alias?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CompanyTeamViewerDeviceFilterInput>>;
  assignedTo?: InputMaybe<BooleanOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deviceId?: InputMaybe<StringOperationFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  onlineState?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CompanyTeamViewerDeviceFilterInput>>;
  remoteControlId?: InputMaybe<StringOperationFilterInput>;
  teamviewerId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ComparableByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']>;
  gt?: InputMaybe<Scalars['Byte']>;
  gte?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<Scalars['Byte']>>;
  lt?: InputMaybe<Scalars['Byte']>;
  lte?: InputMaybe<Scalars['Byte']>;
  neq?: InputMaybe<Scalars['Byte']>;
  ngt?: InputMaybe<Scalars['Byte']>;
  ngte?: InputMaybe<Scalars['Byte']>;
  nin?: InputMaybe<Array<Scalars['Byte']>>;
  nlt?: InputMaybe<Scalars['Byte']>;
  nlte?: InputMaybe<Scalars['Byte']>;
};

export type ComparableDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<Scalars['DateTime']>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type ComparableDecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<Scalars['Decimal']>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type ComparableDoubleOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<Scalars['Float']>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
};

export type ComparableGuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<Scalars['UUID']>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<Scalars['UUID']>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type ComparableInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<Scalars['Int']>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type ComparableInt64OperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<Scalars['Long']>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<Scalars['Long']>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

export type ComparableNullableOfByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']>;
  gt?: InputMaybe<Scalars['Byte']>;
  gte?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  lt?: InputMaybe<Scalars['Byte']>;
  lte?: InputMaybe<Scalars['Byte']>;
  neq?: InputMaybe<Scalars['Byte']>;
  ngt?: InputMaybe<Scalars['Byte']>;
  ngte?: InputMaybe<Scalars['Byte']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  nlt?: InputMaybe<Scalars['Byte']>;
  nlte?: InputMaybe<Scalars['Byte']>;
};

export type ComparableNullableOfDateTimeOffsetOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type ComparableNullableOfDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type ComparableNullableOfDecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type ComparableNullableOfDoubleOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
};

export type ComparableNullableOfGuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type ComparableNullableOfInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type ComparableNullableOfInt64OperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

export type ComparableNullableOfSingleOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
};

export type ComparableNullableOfTimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']>;
  gt?: InputMaybe<Scalars['TimeSpan']>;
  gte?: InputMaybe<Scalars['TimeSpan']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']>;
  lte?: InputMaybe<Scalars['TimeSpan']>;
  neq?: InputMaybe<Scalars['TimeSpan']>;
  ngt?: InputMaybe<Scalars['TimeSpan']>;
  ngte?: InputMaybe<Scalars['TimeSpan']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']>;
  nlte?: InputMaybe<Scalars['TimeSpan']>;
};

export type ComparableTimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']>;
  gt?: InputMaybe<Scalars['TimeSpan']>;
  gte?: InputMaybe<Scalars['TimeSpan']>;
  in?: InputMaybe<Array<Scalars['TimeSpan']>>;
  lt?: InputMaybe<Scalars['TimeSpan']>;
  lte?: InputMaybe<Scalars['TimeSpan']>;
  neq?: InputMaybe<Scalars['TimeSpan']>;
  ngt?: InputMaybe<Scalars['TimeSpan']>;
  ngte?: InputMaybe<Scalars['TimeSpan']>;
  nin?: InputMaybe<Array<Scalars['TimeSpan']>>;
  nlt?: InputMaybe<Scalars['TimeSpan']>;
  nlte?: InputMaybe<Scalars['TimeSpan']>;
};

export type Contact = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contactCompanies?: Maybe<Array<Maybe<ContactCompany>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deactivated: Scalars['Boolean'];
  emails?: Maybe<Array<Maybe<ContactEmail>>>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isIBackup: Scalars['Boolean'];
  isMaintenance: Scalars['Boolean'];
  isPromotionalEmailRecipient: Scalars['Boolean'];
  isSpam: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<ContactPhone>>>;
  tickets?: Maybe<Array<Maybe<SupportTicket>>>;
};

export type ContactCompany = {
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isPrimary: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type ContactCompanyFilterInput = {
  and?: InputMaybe<Array<ContactCompanyFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contact?: InputMaybe<ContactFilterInput>;
  contactId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ContactCompanyFilterInput>>;
};

export type ContactEmail = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contact?: Maybe<Contact>;
  contactId: Scalars['Int'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isPrimary: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  suppressNotificationEmails: Scalars['Boolean'];
};

export type ContactEmailFilterInput = {
  and?: InputMaybe<Array<ContactEmailFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contact?: InputMaybe<ContactFilterInput>;
  contactId?: InputMaybe<ComparableInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ContactEmailFilterInput>>;
  suppressNotificationEmails?: InputMaybe<BooleanOperationFilterInput>;
};

export type ContactEmailSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contact?: InputMaybe<ContactSortInput>;
  contactId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPrimary?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  suppressNotificationEmails?: InputMaybe<SortEnumType>;
};

export type ContactFilterInput = {
  and?: InputMaybe<Array<ContactFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactCompanies?: InputMaybe<ListFilterInputTypeOfContactCompanyFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deactivated?: InputMaybe<BooleanOperationFilterInput>;
  emails?: InputMaybe<ListFilterInputTypeOfContactEmailFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isIBackup?: InputMaybe<BooleanOperationFilterInput>;
  isMaintenance?: InputMaybe<BooleanOperationFilterInput>;
  isPromotionalEmailRecipient?: InputMaybe<BooleanOperationFilterInput>;
  isSpam?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  phoneNumbers?: InputMaybe<ListFilterInputTypeOfContactPhoneFilterInput>;
  tickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
};

export type ContactPhone = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ContactPhoneFilterInput = {
  and?: InputMaybe<Array<ContactPhoneFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contact?: InputMaybe<ContactFilterInput>;
  contactId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ContactPhoneFilterInput>>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
};

export type ContactSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  deactivated?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isIBackup?: InputMaybe<SortEnumType>;
  isMaintenance?: InputMaybe<SortEnumType>;
  isPromotionalEmailRecipient?: InputMaybe<SortEnumType>;
  isSpam?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
};

export type Country = {
  code?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
};

export type CountryFilterInput = {
  and?: InputMaybe<Array<CountryFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CountryFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type CountrySortInput = {
  code?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
};

export type CreateGenericDocumentDtoInput = {
  adDate?: InputMaybe<Scalars['DateTime']>;
  adDateDue?: InputMaybe<Scalars['DateTime']>;
  additionalEntryFields?: InputMaybe<Scalars['String']>;
  additionalFields?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  deliveryDeadlineDays?: InputMaybe<Scalars['Int']>;
  documentDate?: InputMaybe<Scalars['DateTime']>;
  documentPair?: InputMaybe<Scalars['Int']>;
  documentType: Scalars['Int'];
  eInvoiceContractVersion?: InputMaybe<Scalars['Int']>;
  expectedEInvoiceRoute?: InputMaybe<EInvoiceRoute>;
  fiscalBaseAmount?: InputMaybe<Scalars['Decimal']>;
  fiscalInternalNumber?: InputMaybe<Scalars['String']>;
  fiscalSequenceNumber?: InputMaybe<Scalars['Int']>;
  fiscalTotal?: InputMaybe<Scalars['Decimal']>;
  fiscalYear?: InputMaybe<Scalars['Int']>;
  items?: InputMaybe<Array<InputMaybe<CreateGenericDocumentItemDtoInput>>>;
  note?: InputMaybe<Scalars['String']>;
  originApplicationUserId?: InputMaybe<Scalars['String']>;
  originCompanySettingsId?: InputMaybe<Scalars['Int']>;
  originalDocument2Date?: InputMaybe<Scalars['DateTime']>;
  originalDocument2Number?: InputMaybe<Scalars['String']>;
  originalDocumentDate?: InputMaybe<Scalars['DateTime']>;
  originalDocumentNumber?: InputMaybe<Scalars['String']>;
  pantheonAcDelivery?: InputMaybe<Scalars['String']>;
  pantheonAcPayMethod?: InputMaybe<Scalars['String']>;
  pantheonAcWarehouse?: InputMaybe<Scalars['String']>;
  pantheonPayerAcSubject?: InputMaybe<Scalars['String']>;
  pantheonReceiverAcSubject?: InputMaybe<Scalars['String']>;
  pantheonReceivingAcWarehouse?: InputMaybe<Scalars['String']>;
  paymentProviderResponse?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
  signature?: InputMaybe<Array<Scalars['Byte']>>;
  uID?: InputMaybe<Scalars['String']>;
  zKI?: InputMaybe<Scalars['String']>;
};

export type CreateGenericDocumentFromAnotherDtoInput = {
  adDate?: InputMaybe<Scalars['DateTime']>;
  adDateDue?: InputMaybe<Scalars['DateTime']>;
  additionalEntryFields?: InputMaybe<Scalars['String']>;
  additionalFields?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  deliveryDeadlineDays?: InputMaybe<Scalars['Int']>;
  documentDate?: InputMaybe<Scalars['DateTime']>;
  documentPair?: InputMaybe<Scalars['Int']>;
  documentType: Scalars['Int'];
  eInvoiceContractVersion?: InputMaybe<Scalars['Int']>;
  expectedEInvoiceRoute?: InputMaybe<EInvoiceRoute>;
  fiscalBaseAmount?: InputMaybe<Scalars['Decimal']>;
  fiscalInternalNumber?: InputMaybe<Scalars['String']>;
  fiscalSequenceNumber?: InputMaybe<Scalars['Int']>;
  fiscalTotal?: InputMaybe<Scalars['Decimal']>;
  fiscalYear?: InputMaybe<Scalars['Int']>;
  items?: InputMaybe<Array<InputMaybe<CreateGenericDocumentFromAnotherItemDtoInput>>>;
  note?: InputMaybe<Scalars['String']>;
  originApplicationUserId?: InputMaybe<Scalars['String']>;
  originCompanySettingsId?: InputMaybe<Scalars['Int']>;
  originPantheonAcKey?: InputMaybe<Scalars['String']>;
  originPantheonAcKeyList?: InputMaybe<Array<Scalars['String']>>;
  originalDocument2Date?: InputMaybe<Scalars['DateTime']>;
  originalDocument2Number?: InputMaybe<Scalars['String']>;
  originalDocumentDate?: InputMaybe<Scalars['DateTime']>;
  originalDocumentNumber?: InputMaybe<Scalars['String']>;
  pantheonAcDelivery?: InputMaybe<Scalars['String']>;
  pantheonAcPayMethod?: InputMaybe<Scalars['String']>;
  pantheonAcWarehouse?: InputMaybe<Scalars['String']>;
  pantheonPayerAcSubject?: InputMaybe<Scalars['String']>;
  pantheonReceiverAcSubject?: InputMaybe<Scalars['String']>;
  pantheonReceivingAcWarehouse?: InputMaybe<Scalars['String']>;
  paymentProviderResponse?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
  signature?: InputMaybe<Array<Scalars['Byte']>>;
  uID?: InputMaybe<Scalars['String']>;
  updateExisting?: InputMaybe<Scalars['Boolean']>;
  zKI?: InputMaybe<Scalars['String']>;
};

export type CreateGenericDocumentFromAnotherItemDtoInput = {
  note?: InputMaybe<Scalars['String']>;
  originPantheonAnNo: Scalars['Int'];
  originPantheonDetails?: InputMaybe<Array<OriginPantheonItemDetailsInput>>;
  packQuantity: Scalars['Float'];
  pantheonAcIdent?: InputMaybe<Scalars['String']>;
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  scans?: InputMaybe<Array<CreateGenericDocumentItemDtoScanDtoInput>>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<CreateGenericDocumentItemDtoSerialDtoInput>>>;
};

export type CreateGenericDocumentItemDtoInput = {
  note?: InputMaybe<Scalars['String']>;
  packQuantity: Scalars['Float'];
  pantheonAcIdent?: InputMaybe<Scalars['String']>;
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  scans?: InputMaybe<Array<CreateGenericDocumentItemDtoScanDtoInput>>;
  serialNumber?: InputMaybe<Scalars['String']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<CreateGenericDocumentItemDtoSerialDtoInput>>>;
};

export type CreateGenericDocumentItemDtoScanDtoInput = {
  fullScanContent?: InputMaybe<Scalars['String']>;
  scanContent: Scalars['String'];
  scanDate: Scalars['DateTime'];
};

export type CreateGenericDocumentItemDtoSerialDtoInput = {
  dateDue: Scalars['DateTime'];
  pallet?: InputMaybe<CreateGenericDocumentItemDtoSerialDtoPalletDtoInput>;
  quantity: Scalars['Decimal'];
  relatedSSCC?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type CreateGenericDocumentItemDtoSerialDtoPalletDtoInput = {
  acRegion?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  sSCCCode?: InputMaybe<Scalars['String']>;
  shortCode: Scalars['String'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type CreateMcpApiKeyDtoInput = {
  expiresInDays?: InputMaybe<Scalars['Int']>;
  kind: McpApiKeyKind;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreatePortalServiceKeyDtoInput = {
  companySettingsId?: InputMaybe<Scalars['Int']>;
  expiresInDays?: InputMaybe<Scalars['Int']>;
  kind: PortalServiceKeyKind;
  name?: InputMaybe<Scalars['String']>;
};

export type CreatedMcpApiKeyDto = {
  apiKey?: Maybe<McpApiKeyDto>;
  key?: Maybe<Scalars['String']>;
};

export type CreatedPortalServiceKeyDto = {
  key?: Maybe<Scalars['String']>;
  serviceKey?: Maybe<PortalServiceKeyDto>;
};

export type Currency = {
  code?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  longName?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  unit: Scalars['Int'];
};

export type CurrencyFilterInput = {
  and?: InputMaybe<Array<CurrencyFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  longName?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CurrencyFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  unit?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CurrencySortInput = {
  code?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  longName?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
};

export type DailyRecapDto = {
  acKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  fromDate?: Maybe<Scalars['DateTime']>;
  fromDoc?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<DailyRecapDtoItemDto>>>;
  toDate?: Maybe<Scalars['DateTime']>;
  toDoc?: Maybe<Scalars['String']>;
};

export type DailyRecapDtoItemDto = {
  paid: Scalars['Decimal'];
  paymentType?: Maybe<Scalars['String']>;
};

export type DatalabReferenceCompany = {
  companyDatalabReferenceLinks?: Maybe<Array<Maybe<CompanyDatalabReferenceLink>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  detailUrl?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  firstSyncedAt: Scalars['DateTime'];
  id: Scalars['Int'];
  lastSyncedAt: Scalars['DateTime'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  normalizedName?: Maybe<Scalars['String']>;
  remoteKey?: Maybe<Scalars['String']>;
};

export type DatalabReferenceCompanyFilterInput = {
  and?: InputMaybe<Array<DatalabReferenceCompanyFilterInput>>;
  companyDatalabReferenceLinks?: InputMaybe<ListFilterInputTypeOfCompanyDatalabReferenceLinkFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  detailUrl?: InputMaybe<StringOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  firstSyncedAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastSyncedAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DatalabReferenceCompanyFilterInput>>;
  remoteKey?: InputMaybe<StringOperationFilterInput>;
};

export type DatalabReleaseLockdownRun = {
  company: Company;
  companyDatalabReferenceLink?: Maybe<CompanyDatalabReferenceLink>;
  companyDatalabReferenceLinkId?: Maybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completedOn?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deletedEntryCount: Scalars['Int'];
  errorText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobId?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  processedPopupCount: Scalars['Int'];
  saveTriggered: Scalars['Boolean'];
  startedOn?: Maybe<Scalars['DateTime']>;
  status: DatalabReleaseLockdownRunStatusEnum;
  summaryLog?: Maybe<Scalars['String']>;
  triggeredById?: Maybe<Scalars['String']>;
};

export type DatalabReleaseLockdownRunFilterInput = {
  and?: InputMaybe<Array<DatalabReleaseLockdownRunFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyDatalabReferenceLink?: InputMaybe<CompanyDatalabReferenceLinkFilterInput>;
  companyDatalabReferenceLinkId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deletedEntryCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  errorText?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  jobId?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DatalabReleaseLockdownRunFilterInput>>;
  processedPopupCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  saveTriggered?: InputMaybe<BooleanOperationFilterInput>;
  startedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  status?: InputMaybe<DatalabReleaseLockdownRunStatusEnumOperationFilterInput>;
  summaryLog?: InputMaybe<StringOperationFilterInput>;
  triggeredById?: InputMaybe<StringOperationFilterInput>;
};

export enum DatalabReleaseLockdownRunStatusEnum {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type DatalabReleaseLockdownRunStatusEnumOperationFilterInput = {
  eq?: InputMaybe<DatalabReleaseLockdownRunStatusEnum>;
  in?: InputMaybe<Array<DatalabReleaseLockdownRunStatusEnum>>;
  neq?: InputMaybe<DatalabReleaseLockdownRunStatusEnum>;
  nin?: InputMaybe<Array<DatalabReleaseLockdownRunStatusEnum>>;
};

export enum DateFilterType {
  CustomRange = 'CUSTOM_RANGE',
  LastMonth = 'LAST_MONTH',
  ThisMonth = 'THIS_MONTH',
  ThisWeek = 'THIS_WEEK',
  Today = 'TODAY',
  UntilToday = 'UNTIL_TODAY',
  Yesterday = 'YESTERDAY'
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DayOfWeekOperationFilterInput = {
  eq?: InputMaybe<DayOfWeek>;
  in?: InputMaybe<Array<DayOfWeek>>;
  neq?: InputMaybe<DayOfWeek>;
  nin?: InputMaybe<Array<DayOfWeek>>;
};

export type DbFile = {
  acKey?: Maybe<Scalars['String']>;
  content?: Maybe<Array<Scalars['Byte']>>;
  fileCategory?: Maybe<Scalars['String']>;
  fileId: Scalars['Int'];
  fileName?: Maybe<Scalars['String']>;
};

export type Department = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  items?: Maybe<Array<Maybe<Item>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
};

export type DepartmentFilterInput = {
  and?: InputMaybe<Array<DepartmentFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfItemFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DepartmentFilterInput>>;
};

export type DepartmentSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export enum DeploymentGroupStepTriggerType {
  OnInstall = 'ON_INSTALL'
}

export type DictionaryOfStringAndStringFilterInput = {
  and?: InputMaybe<Array<DictionaryOfStringAndStringFilterInput>>;
  capacity?: InputMaybe<ComparableInt32OperationFilterInput>;
  comparer?: InputMaybe<IEqualityComparerOfStringFilterInput>;
  count?: InputMaybe<ComparableInt32OperationFilterInput>;
  keys?: InputMaybe<ListStringOperationFilterInput>;
  or?: InputMaybe<Array<DictionaryOfStringAndStringFilterInput>>;
  values?: InputMaybe<ListStringOperationFilterInput>;
};

export type DmsRights = {
  classify: Scalars['Boolean'];
  confirm: Scalars['Boolean'];
  createDocument: Scalars['Boolean'];
  deleteDocument: Scalars['Boolean'];
  editMetadata: Scalars['Boolean'];
  editNote: Scalars['Boolean'];
  mapXmlItems: Scalars['Boolean'];
  ownFilesOnly: Scalars['Boolean'];
  pullEInvoices: Scalars['Boolean'];
  read: Scalars['Boolean'];
  removeFile: Scalars['Boolean'];
  replaceFile: Scalars['Boolean'];
  uploadFile: Scalars['Boolean'];
};

export enum DocumentDraftKind {
  Move = 'MOVE',
  Order = 'ORDER'
}

export enum DocumentDraftOrigin {
  OnixPhone = 'ONIX_PHONE',
  Web = 'WEB'
}

export enum DocumentDraftPriceSource {
  Contract = 'CONTRACT',
  Manual = 'MANUAL',
  Pantheon = 'PANTHEON'
}

export enum DocumentDraftStatus {
  Discarded = 'DISCARDED',
  Issued = 'ISSUED',
  Issuing = 'ISSUING',
  NotIssued = 'NOT_ISSUED',
  Open = 'OPEN'
}

export enum DocumentEmailDispatchStatus {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Sending = 'SENDING',
  Sent = 'SENT',
  Uncertain = 'UNCERTAIN'
}

export enum DocumentFunctionalityEnum {
  Approvals = 'APPROVALS',
  BaseWorkOrders = 'BASE_WORK_ORDERS',
  DeliveryNotes = 'DELIVERY_NOTES',
  DeliveryNotesControl = 'DELIVERY_NOTES_CONTROL',
  DeliveryNotesFromOrder = 'DELIVERY_NOTES_FROM_ORDER',
  DetachedOfflineDocuments = 'DETACHED_OFFLINE_DOCUMENTS',
  FisBarcodeScanning = 'FIS_BARCODE_SCANNING',
  FixedAssets = 'FIXED_ASSETS',
  Inventory = 'INVENTORY',
  Invoices = 'INVOICES',
  InvoiceDeliveryNotes = 'INVOICE_DELIVERY_NOTES',
  LurInvoice = 'LUR_INVOICE',
  MarservisUserWorkOrders = 'MARSERVIS_USER_WORK_ORDERS',
  Orders = 'ORDERS',
  PriceChangeRecords = 'PRICE_CHANGE_RECORDS',
  TmnDocumentsClassificationQueue = 'TMN_DOCUMENTS_CLASSIFICATION_QUEUE',
  TmnDocumentsDirect = 'TMN_DOCUMENTS_DIRECT',
  TmnDocumentsWeb = 'TMN_DOCUMENTS_WEB',
  Transfer = 'TRANSFER',
  WarehouseReceipt = 'WAREHOUSE_RECEIPT',
  Woex = 'WOEX',
  WorkFlowTasks = 'WORK_FLOW_TASKS',
  WorkOrdersOperative = 'WORK_ORDERS_OPERATIVE',
  WorkOrdersReception = 'WORK_ORDERS_RECEPTION'
}

export type DocumentFunctionalityEnumOperationFilterInput = {
  eq?: InputMaybe<DocumentFunctionalityEnum>;
  in?: InputMaybe<Array<DocumentFunctionalityEnum>>;
  neq?: InputMaybe<DocumentFunctionalityEnum>;
  nin?: InputMaybe<Array<DocumentFunctionalityEnum>>;
};

export enum DocumentPairFunctionalityEnum {
  Copy = 'COPY',
  Picking = 'PICKING'
}

export type DocumentPairFunctionalityEnumOperationFilterInput = {
  eq?: InputMaybe<DocumentPairFunctionalityEnum>;
  in?: InputMaybe<Array<DocumentPairFunctionalityEnum>>;
  neq?: InputMaybe<DocumentPairFunctionalityEnum>;
  nin?: InputMaybe<Array<DocumentPairFunctionalityEnum>>;
};

export enum DocumentRelationKind {
  Modify = 'MODIFY',
  None = 'NONE',
  Repeat = 'REPEAT',
  Storno = 'STORNO'
}

export type DocumentType = {
  acDocsOrderingOnPDF?: Maybe<Scalars['String']>;
  acFieldSFLabel?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName?: Maybe<Scalars['String']>;
  acLinkDocName1?: Maybe<Scalars['String']>;
  acLinkDocName2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acName3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acSetOfsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  acStatusIn?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acWorkPlace?: Maybe<Scalars['String']>;
  acceptedByFieldOnPrint?: Maybe<Scalars['String']>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  adDateDoc1EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc1PDFLabel?: Maybe<Scalars['String']>;
  adDateDoc2EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc2PDFLabel?: Maybe<Scalars['String']>;
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  adminAllowChangingItemPrice: Scalars['Boolean'];
  adminCanEditDocumentAfterSaving: Scalars['Boolean'];
  adminDefaultAcPriceRate?: Maybe<Scalars['String']>;
  adminDeleteItemsAfterDocumentIsSaved: Scalars['Boolean'];
  adminDocumentOnCreateMakeWarehouseReservation: Scalars['Boolean'];
  adminEmphasizeInStock: Scalars['Boolean'];
  adminForceAcPriceRate?: Maybe<Scalars['String']>;
  adminIgnoreRebate1: Scalars['Boolean'];
  adminIgnoreRebate2: Scalars['Boolean'];
  adminIgnoreRebate3: Scalars['Boolean'];
  adminItemQuantityMustBeInStock: Scalars['Boolean'];
  adminSavedRebatesForFinalRebate: Scalars['Boolean'];
  adminSendDocumentToCompanyDocumentEmail: Scalars['Boolean'];
  adminSerialNumbersAreNotAutomated?: Maybe<Scalars['Boolean']>;
  adminShowDailyIncome: Scalars['Boolean'];
  adminShowSubjectAdd: Scalars['Boolean'];
  adminUseAnWsPrice: Scalars['Boolean'];
  adminUseGenericDocumentsForMoveAndOrder: Scalars['Boolean'];
  adminUseSerialNumberForItems: Scalars['Boolean'];
  allowChangingWarehouse?: Maybe<Scalars['Boolean']>;
  allowDMSCRUDOnlyForUsersFiles?: Maybe<Scalars['Boolean']>;
  allowDMSConfirmation?: Maybe<Scalars['Boolean']>;
  allowDMSReclassification?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemArticlePicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemCostBearerPicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemDepartmentPicking?: Maybe<Scalars['Boolean']>;
  allowGenericDocumentTypeImageAttachments?: Maybe<Scalars['Boolean']>;
  allowManualVerifyFromDocumentOverview?: Maybe<Scalars['Boolean']>;
  allowModifyExistingDocuments: Scalars['Boolean'];
  allowPullingDMSEInvoicesFromService?: Maybe<Scalars['Boolean']>;
  allowSavingGeodecodedLocation?: Maybe<Scalars['Boolean']>;
  allowSelectingMultipleDocumentsToCreateFrom?: Maybe<Scalars['Boolean']>;
  allowSigningAfterDocumentIsSaved?: Maybe<Scalars['Boolean']>;
  alwaysShowTheseAcSetOfItem?: Maybe<Scalars['String']>;
  alwaysUpdatePriceAndRebateFromClient?: Maybe<Scalars['Boolean']>;
  appendToItemIfExists?: Maybe<Scalars['Boolean']>;
  arbitraryField1Label?: Maybe<Scalars['String']>;
  arbitraryField1Location?: Maybe<Scalars['String']>;
  arbitraryField1Value?: Maybe<Scalars['String']>;
  arbitraryFields: Array<DocumentTypeArbitraryField>;
  articleDontShowPriceAnyWhere: Scalars['Boolean'];
  articleDontShowStockAnyWhere: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchInitiallyLoadAll: Scalars['Boolean'];
  articleSearchRepeatLastSearch: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  articleSearchShowOnlyWhereAcClassifIsIn?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsAIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsBIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsCIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsDIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsEIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsFIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsGIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsHIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsIIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsJIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAdFielddAIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddBIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddCIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddDIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAnFieldnAIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnBIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnCIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnDIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnEIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnFIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnGIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnHIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnIIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnJIs?: Maybe<Scalars['Decimal']>;
  bluetoothPrintCopiesNumber: Scalars['Int'];
  cacheDuration: Scalars['Int'];
  cacheUseCacheForAnyResource: Scalars['Boolean'];
  cacheUseForArticleSearch: Scalars['Boolean'];
  cacheUseForCustomerSearch: Scalars['Boolean'];
  cacheUseForWarehouseSearch: Scalars['Boolean'];
  cardPaymentProvider?: Maybe<CardPaymentProvider>;
  changeDocumentStatusAfterCreated?: Maybe<Scalars['String']>;
  changeSourceDocumentStatusTo?: Maybe<Scalars['String']>;
  classifs2WhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  classifsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  clerkFieldOnPrint?: Maybe<Scalars['String']>;
  companyEmailDefaultEmail?: Maybe<Scalars['String']>;
  companyEmailForwards?: Maybe<Array<Maybe<CompanyEmailForward>>>;
  companyEmailPDFBCC?: Maybe<Scalars['String']>;
  companyEmailPDFCC?: Maybe<Scalars['String']>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: Maybe<Scalars['Boolean']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completeDeliveryStatus?: Maybe<Scalars['String']>;
  copyOnlyLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  copyOnlyThoseWithLeftOverQuantity0?: Maybe<Scalars['Boolean']>;
  copyingFromAnotherIsAShadowCopy?: Maybe<Scalars['Boolean']>;
  create: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  customContractPriceFilter?: Maybe<Scalars['Boolean']>;
  customerCodeAllowedKeys?: Maybe<Scalars['String']>;
  customerCodeFromAcSkis?: Maybe<Scalars['Boolean']>;
  customerCodeIsGenerated?: Maybe<Scalars['Boolean']>;
  dMSListFilterOnDefaultClassification?: Maybe<Scalars['Boolean']>;
  dateFilterType?: Maybe<DateFilterType>;
  defaultCustomerType?: Maybe<Scalars['String']>;
  defaultCustomerTypeFilter?: Maybe<Scalars['String']>;
  defaultMoveDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultMoveDocumentSortField?: Maybe<THeMovePagedSortField>;
  defaultOrderDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultOrderDocumentSortField?: Maybe<THeOrderPagedSortField>;
  defaultPaymentMethod?: Maybe<Scalars['String']>;
  defaultQuantity?: Maybe<Scalars['Decimal']>;
  defaultSubjectDaysForPaymentOnAdd?: Maybe<Scalars['Int']>;
  defaultSubjectPaymentMethodOnAdd?: Maybe<Scalars['String']>;
  defaultToThisCustomer?: Maybe<Scalars['String']>;
  defaultWoexDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultWoexDocumentSortField?: Maybe<THfWoexPagedSortField>;
  delete: Scalars['Boolean'];
  deliveryIsRequired?: Maybe<Scalars['Boolean']>;
  disableUsingShadowItemAsItemBase?: Maybe<Scalars['Boolean']>;
  disallowChangingCustomer: Scalars['Boolean'];
  disallowChangingItemQuantityOnSerialInput?: Maybe<Scalars['Boolean']>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: Maybe<Scalars['Boolean']>;
  disallowManualWarehouseSearch?: Maybe<Scalars['Boolean']>;
  disallowPickingCustomer: Scalars['Boolean'];
  dmsAcStatusIn?: Maybe<Scalars['String']>;
  doNotFilterDailyRecapByUserId?: Maybe<Scalars['Boolean']>;
  documentLinkType?: Maybe<Scalars['String']>;
  documentLinkTypeA?: Maybe<Scalars['String']>;
  documentLinkTypeB?: Maybe<Scalars['String']>;
  documentNote?: Maybe<Scalars['String']>;
  documentOnCreateMakeA4Print?: Maybe<Scalars['Boolean']>;
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  documentTopAdditionalText?: Maybe<Scalars['String']>;
  dontSaveIndividualPDFPages?: Maybe<Scalars['Boolean']>;
  existingInventoryCheckDays?: Maybe<Scalars['Int']>;
  fillReferentLineWithUserOnPrint?: Maybe<Scalars['Boolean']>;
  filterByAcDelivery: Scalars['Boolean'];
  filterByAcDept?: Maybe<Scalars['String']>;
  filterByAcDeptOut?: Maybe<Scalars['String']>;
  filterByAcType?: Maybe<Scalars['String']>;
  filterByAcVerifiedPrices?: Maybe<Scalars['String']>;
  filterByAcVerifyStatus?: Maybe<Scalars['String']>;
  filterByCurrentUserIdIsAnSigner1?: Maybe<Scalars['Boolean']>;
  filterMovesByThisAcIssuer?: Maybe<Scalars['String']>;
  filterMovesByThisAcReceiver?: Maybe<Scalars['String']>;
  filterOrdersByThisAcWarehouse?: Maybe<Scalars['String']>;
  filterReceiversByAcFieldSa?: Maybe<Scalars['String']>;
  fiscalizationQueueEntry?: Maybe<Array<Maybe<FiscalizationQueueEntry>>>;
  forceShowAvailableOnStock: Scalars['Boolean'];
  fromPairs?: Maybe<Array<Maybe<DocumentTypePair>>>;
  functionality: DocumentFunctionalityEnum;
  generatePrintTimeOnCreate: Scalars['Boolean'];
  groupAllCreatingDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupAllDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated: Scalars['Boolean'];
  headerClerkPDFLabel?: Maybe<Scalars['String']>;
  hideAcceptedByFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideClerkFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideCurrencyDateOnPrint?: Maybe<Scalars['Boolean']>;
  hideDMSMetadataEntryFields?: Maybe<Scalars['Boolean']>;
  hideDataForPaymentOnPrint?: Maybe<Scalars['Boolean']>;
  hideDocumentElements?: Maybe<Scalars['String']>;
  hideDocumentItemElements?: Maybe<Scalars['String']>;
  hideLeftOverQuantityOnPicking?: Maybe<Scalars['Boolean']>;
  hideNoteInNonHistoricalView?: Maybe<Scalars['Boolean']>;
  hidePayMethodOnPrint?: Maybe<Scalars['Boolean']>;
  hideQuantityEntry?: Maybe<Scalars['Boolean']>;
  hideVATRecapitulationOnPrint?: Maybe<Scalars['Boolean']>;
  hideWarehouseItemActions?: Maybe<Scalars['Boolean']>;
  hideWarehouseOverview?: Maybe<Scalars['Boolean']>;
  hideWarehouseSupplier?: Maybe<Scalars['Boolean']>;
  hideWorkOrderImages?: Maybe<Scalars['Boolean']>;
  hideWorkOrderMaterials?: Maybe<Scalars['Boolean']>;
  hideWorkOrderPlaceFromTo?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReception?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReclamations?: Maybe<Scalars['Boolean']>;
  hideWorkOrderServices?: Maybe<Scalars['Boolean']>;
  hideWorkOrderSpecications?: Maybe<Scalars['Boolean']>;
  highlightArticlePickerTextOnNextOpen?: Maybe<Scalars['Boolean']>;
  historyViewIgnoredFilters?: Maybe<Scalars['String']>;
  horizontalDoc12AndDates?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  ifAcPayMethodChooseThisDocumentType?: Maybe<Scalars['String']>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: Maybe<Scalars['Boolean']>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  ignoreQuantityInWholeDocument?: Maybe<Scalars['Boolean']>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: Maybe<Scalars['Boolean']>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: Maybe<Scalars['Boolean']>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isRetail?: Maybe<Scalars['Boolean']>;
  itemListShowDetailed: Scalars['Boolean'];
  jumpToEditAfterScanningItemWithBarcode: Scalars['Boolean'];
  keepAdDateDoc1And2Unrounded?: Maybe<Scalars['Boolean']>;
  labelDefinitionLocations: Array<LabelDefinitionLocation>;
  linkFrom?: Maybe<Array<Maybe<DocumentTypeLink>>>;
  linkTo?: Maybe<Array<Maybe<DocumentTypeLink>>>;
  makeDocumentLinks?: Maybe<Scalars['Boolean']>;
  makeSerialStockCheck?: Maybe<Scalars['Boolean']>;
  manualWorkOrderMaterial?: Maybe<Scalars['String']>;
  middleSignatureTextOnPrint?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifierCharacterLabel?: Maybe<Scalars['String']>;
  multipleEndDocumentsCaseToPickEndDocument?: Maybe<Scalars['String']>;
  mustFiscalize?: Maybe<Scalars['Boolean']>;
  newNewDocumentInputType?: Maybe<Scalars['Boolean']>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: Maybe<Scalars['Boolean']>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: Maybe<Scalars['Boolean']>;
  palletEntry?: Maybe<Scalars['Boolean']>;
  pantheonDirection: PantheonDocumentDirectionEnum;
  pantheonTable: PantheonDocumentTable;
  partialDeliveryStatus?: Maybe<Scalars['String']>;
  pdfSignWithoutGeneration?: Maybe<Scalars['Boolean']>;
  pickingShowConfirmationOnPick: Scalars['Boolean'];
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: Maybe<Scalars['Boolean']>;
  printDocumentTitleOverride?: Maybe<Scalars['String']>;
  printTicketNameOverride?: Maybe<Scalars['String']>;
  prioritisePackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  quantityDecimalPlaces: Scalars['Int'];
  read: Scalars['Boolean'];
  recommendToMakeCodebooksOffline?: Maybe<Scalars['Boolean']>;
  requireASignature: Scalars['Boolean'];
  reverseItemsList?: Maybe<Scalars['Boolean']>;
  saveUnsignedAsSignedPDF?: Maybe<Scalars['Boolean']>;
  sendB2BAsEInvoice?: Maybe<Scalars['Boolean']>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: Maybe<Scalars['Boolean']>;
  sendLeftoverShadowsWithZero?: Maybe<Scalars['Boolean']>;
  serialNumberDirectionIsInput?: Maybe<Scalars['Boolean']>;
  showAcDeliveryMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDeliveryOnDocumentList: Scalars['Boolean'];
  showAcDeptMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDescrOnPDFs?: Maybe<Scalars['Boolean']>;
  showAcDoc1?: Maybe<Scalars['Boolean']>;
  showAcDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAcDoc2?: Maybe<Scalars['Boolean']>;
  showAcDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAcIdentOnPrint?: Maybe<Scalars['Boolean']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: Maybe<Scalars['String']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: Maybe<Scalars['String']>;
  showAdDate?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAllDMSDocumentsForURAClassifications?: Maybe<Scalars['Boolean']>;
  showAllDocumentsNotOnlyAnUserIns?: Maybe<Scalars['Boolean']>;
  showAllItemsIgnoringWarehouse?: Maybe<Scalars['Boolean']>;
  showAnClerkAndAnNoteClerkIsOROperation?: Maybe<Scalars['Boolean']>;
  showArticlesGroupedByCodeButSeparate?: Maybe<Scalars['Boolean']>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: Maybe<Scalars['Boolean']>;
  showAttachSSCCButton?: Maybe<Scalars['Boolean']>;
  showBuyerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showContactEmailEntry?: Maybe<Scalars['Boolean']>;
  showContactEntry?: Maybe<Scalars['Boolean']>;
  showCostBearerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showCustomerName2AsPrimaryOnHeader?: Maybe<Scalars['Boolean']>;
  showCustomerOverview?: Maybe<Scalars['Boolean']>;
  showCustomersAcName2OnThermalPrint?: Maybe<Scalars['Boolean']>;
  showDMSXMLItems?: Maybe<Scalars['Boolean']>;
  showDeliveryDeadlineDays: Scalars['Boolean'];
  showDeliveryMethod: Scalars['Boolean'];
  showDepartmentAsReceiver: Scalars['Boolean'];
  showDepartmentOutAsReceiver: Scalars['Boolean'];
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: Maybe<Scalars['String']>;
  showDoc12AndTheirDatesOnDocumentList?: Maybe<Scalars['Boolean']>;
  showInventoryNumberOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showItalianLabelsOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAcCustomsTariffOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAnNetWeightOnPrint?: Maybe<Scalars['Boolean']>;
  showItemPicturesOnPrint?: Maybe<Scalars['Boolean']>;
  showLastNOrdersForCustomer?: Maybe<Scalars['Int']>;
  showLineNoteOnPrint: Scalars['Boolean'];
  showModifierCharacterPicker: Scalars['Boolean'];
  showNumberOfUnlinkedDocuments?: Maybe<Scalars['Boolean']>;
  showOnlyArticlesWithCustomerContractPrice: Scalars['Boolean'];
  showOnlyDMSDocumentsAssignedToMe?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyWOWhereCurrentUserSpecExists?: Maybe<Scalars['Boolean']>;
  showPackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  showPaymentMethod: Scalars['Boolean'];
  showQuantityPerUnitOfMeasureOnPrint?: Maybe<Scalars['Boolean']>;
  showQuantityTotalOnPrint?: Maybe<Scalars['Boolean']>;
  showReceiverOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showSerialNumberSearchForWorkOrders?: Maybe<Scalars['Boolean']>;
  showWOWorkersEntry?: Maybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  skipGS1BarcodeCheck: Scalars['Boolean'];
  stockViewLoadAllOnOpen: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  storeContactEmailArbitraryInField?: Maybe<Scalars['String']>;
  subjectDocumentListDocumentType?: Maybe<Scalars['String']>;
  subjectFieldForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  subjectFieldValueForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  syncPackagingWhenAddingNewItem: Scalars['Boolean'];
  tHrPrsnForOnlyOnixPhoneUsers?: Maybe<Scalars['Boolean']>;
  tMNAcDefaultStatus?: Maybe<Scalars['String']>;
  tMNAcDefaultSubject?: Maybe<Scalars['String']>;
  tMNAnClassifIcationQid?: Maybe<Scalars['Int']>;
  tMNAnMailBoxQid?: Maybe<Scalars['Int']>;
  tMNAnStorageQid?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSize?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeHeight?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeWidth?: Maybe<Scalars['Int']>;
  thermalPrintShowCompanyImage: Scalars['Boolean'];
  toPairs?: Maybe<Array<Maybe<DocumentTypePair>>>;
  transferAcDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAcDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferEnteredItemQuantityToSerialNumber?: Maybe<Scalars['Boolean']>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: Maybe<Scalars['Boolean']>;
  treatIdentAsBarcode?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  update: Scalars['Boolean'];
  updateHeadAndDeleteAllItemsOnCopy?: Maybe<Scalars['Boolean']>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: Maybe<Scalars['Boolean']>;
  useDeadlineDateOnOverview: Scalars['Boolean'];
  useSquareArticlePicker?: Maybe<Scalars['Boolean']>;
  useVerySmallMobileInterface?: Maybe<Scalars['Boolean']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  visualAttributes?: Maybe<Scalars['String']>;
  visualAttributesOverview?: Maybe<Scalars['String']>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  warehouseName?: Maybe<Scalars['String']>;
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  warehousePositionTHeSetItemFieldName?: Maybe<Scalars['String']>;
  warehouseShowPrices?: Maybe<Scalars['Boolean']>;
  warehouseViewFixedAcSubject?: Maybe<Scalars['String']>;
  webDmsRights?: Maybe<DmsRights>;
  whenAddingSubjectSetAnClerkToCurrentUser?: Maybe<Scalars['Boolean']>;
  workOrderCanBeUnlocked?: Maybe<Scalars['Boolean']>;
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
  workOrderSpecificationPrefillTime?: Maybe<Scalars['Boolean']>;
  workOrderSpecificationTimeNotRequired?: Maybe<Scalars['Boolean']>;
  workOrderUnlockableStatus?: Maybe<Scalars['String']>;
};


export type DocumentTypeArbitraryFieldsArgs = {
  order?: InputMaybe<Array<DocumentTypeArbitraryFieldSortInput>>;
};


export type DocumentTypeFiscalizationQueueEntryArgs = {
  order?: InputMaybe<Array<FiscalizationQueueEntrySortInput>>;
  where?: InputMaybe<FiscalizationQueueEntryFilterInput>;
};

export type DocumentTypeArbitraryField = {
  arbitraryFieldLocation?: Maybe<ArbitraryFieldLocationEnum>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  documentType?: Maybe<DocumentType>;
  documentTypeId: Scalars['Int'];
  fieldBaseValue?: Maybe<Scalars['String']>;
  fieldReference?: Maybe<Scalars['String']>;
  fieldRequired: Scalars['Boolean'];
  fieldType?: Maybe<ArbitraryFieldEntryType>;
  id: Scalars['Int'];
  jSValue?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  prefillFromField?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DocumentTypeArbitraryFieldFilterInput = {
  and?: InputMaybe<Array<DocumentTypeArbitraryFieldFilterInput>>;
  arbitraryFieldLocation?: InputMaybe<NullableOfArbitraryFieldLocationEnumOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  fieldBaseValue?: InputMaybe<StringOperationFilterInput>;
  fieldReference?: InputMaybe<StringOperationFilterInput>;
  fieldRequired?: InputMaybe<BooleanOperationFilterInput>;
  fieldType?: InputMaybe<NullableOfArbitraryFieldEntryTypeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  jSValue?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypeArbitraryFieldFilterInput>>;
  order?: InputMaybe<ComparableInt32OperationFilterInput>;
  prefillFromField?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type DocumentTypeArbitraryFieldSortInput = {
  arbitraryFieldLocation?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  documentType?: InputMaybe<DocumentTypeSortInput>;
  documentTypeId?: InputMaybe<SortEnumType>;
  fieldBaseValue?: InputMaybe<SortEnumType>;
  fieldReference?: InputMaybe<SortEnumType>;
  fieldRequired?: InputMaybe<SortEnumType>;
  fieldType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jSValue?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  prefillFromField?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export enum DocumentTypeEnum {
  Move = 'MOVE',
  Order = 'ORDER',
  WorkOrder = 'WORK_ORDER'
}

export type DocumentTypeEnumOperationFilterInput = {
  eq?: InputMaybe<DocumentTypeEnum>;
  in?: InputMaybe<Array<DocumentTypeEnum>>;
  neq?: InputMaybe<DocumentTypeEnum>;
  nin?: InputMaybe<Array<DocumentTypeEnum>>;
};

export type DocumentTypeFilterInput = {
  acDocsOrderingOnPDF?: InputMaybe<StringOperationFilterInput>;
  acFieldSFLabel?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName1?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acName3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  acStatusIn?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  acceptedByFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1PDFLabel?: InputMaybe<StringOperationFilterInput>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc2PDFLabel?: InputMaybe<StringOperationFilterInput>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<BooleanOperationFilterInput>;
  adminAllowChangingItemPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminCanEditDocumentAfterSaving?: InputMaybe<BooleanOperationFilterInput>;
  adminDefaultAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<BooleanOperationFilterInput>;
  adminEmphasizeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminForceAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminIgnoreRebate1?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate2?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate3?: InputMaybe<BooleanOperationFilterInput>;
  adminItemQuantityMustBeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminSavedRebatesForFinalRebate?: InputMaybe<BooleanOperationFilterInput>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<BooleanOperationFilterInput>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<BooleanOperationFilterInput>;
  adminShowDailyIncome?: InputMaybe<BooleanOperationFilterInput>;
  adminShowSubjectAdd?: InputMaybe<BooleanOperationFilterInput>;
  adminUseAnWsPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<BooleanOperationFilterInput>;
  adminUseSerialNumberForItems?: InputMaybe<BooleanOperationFilterInput>;
  allowChangingWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSConfirmation?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSReclassification?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemArticlePicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<BooleanOperationFilterInput>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<BooleanOperationFilterInput>;
  allowModifyExistingDocuments?: InputMaybe<BooleanOperationFilterInput>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<BooleanOperationFilterInput>;
  allowSavingGeodecodedLocation?: InputMaybe<BooleanOperationFilterInput>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<BooleanOperationFilterInput>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<StringOperationFilterInput>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DocumentTypeFilterInput>>;
  appendToItemIfExists?: InputMaybe<BooleanOperationFilterInput>;
  arbitraryField1Label?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Location?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Value?: InputMaybe<StringOperationFilterInput>;
  arbitraryFields?: InputMaybe<ListFilterInputTypeOfDocumentTypeArbitraryFieldFilterInput>;
  articleDontShowPriceAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleDontShowStockAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchAllowSearchingByClassification?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchInitiallyLoadAll?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchRepeatLastSearch?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bluetoothPrintCopiesNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheDuration?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheUseCacheForAnyResource?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForArticleSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForCustomerSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  cardPaymentProvider?: InputMaybe<NullableOfCardPaymentProviderOperationFilterInput>;
  changeDocumentStatusAfterCreated?: InputMaybe<StringOperationFilterInput>;
  changeSourceDocumentStatusTo?: InputMaybe<StringOperationFilterInput>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  clerkFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  companyEmailDefaultEmail?: InputMaybe<StringOperationFilterInput>;
  companyEmailForwards?: InputMaybe<ListFilterInputTypeOfCompanyEmailForwardFilterInput>;
  companyEmailPDFBCC?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFCC?: InputMaybe<StringOperationFilterInput>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completeDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  copyOnlyLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<BooleanOperationFilterInput>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<BooleanOperationFilterInput>;
  create?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customContractPriceFilter?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeAllowedKeys?: InputMaybe<StringOperationFilterInput>;
  customerCodeFromAcSkis?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeIsGenerated?: InputMaybe<BooleanOperationFilterInput>;
  dMSListFilterOnDefaultClassification?: InputMaybe<BooleanOperationFilterInput>;
  dateFilterType?: InputMaybe<NullableOfDateFilterTypeOperationFilterInput>;
  defaultCustomerType?: InputMaybe<StringOperationFilterInput>;
  defaultCustomerTypeFilter?: InputMaybe<StringOperationFilterInput>;
  defaultMoveDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultMoveDocumentSortField?: InputMaybe<NullableOfTHeMovePagedSortFieldOperationFilterInput>;
  defaultOrderDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultOrderDocumentSortField?: InputMaybe<NullableOfTHeOrderPagedSortFieldOperationFilterInput>;
  defaultPaymentMethod?: InputMaybe<StringOperationFilterInput>;
  defaultQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<StringOperationFilterInput>;
  defaultToThisCustomer?: InputMaybe<StringOperationFilterInput>;
  defaultWoexDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultWoexDocumentSortField?: InputMaybe<NullableOfTHfWoexPagedSortFieldOperationFilterInput>;
  delete?: InputMaybe<BooleanOperationFilterInput>;
  deliveryIsRequired?: InputMaybe<BooleanOperationFilterInput>;
  disableUsingShadowItemAsItemBase?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<BooleanOperationFilterInput>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<BooleanOperationFilterInput>;
  disallowManualWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  disallowPickingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  dmsAcStatusIn?: InputMaybe<StringOperationFilterInput>;
  doNotFilterDailyRecapByUserId?: InputMaybe<BooleanOperationFilterInput>;
  documentLinkType?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeA?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeB?: InputMaybe<StringOperationFilterInput>;
  documentNote?: InputMaybe<StringOperationFilterInput>;
  documentOnCreateMakeA4Print?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakePDF?: InputMaybe<BooleanOperationFilterInput>;
  documentTopAdditionalText?: InputMaybe<StringOperationFilterInput>;
  dontSaveIndividualPDFPages?: InputMaybe<BooleanOperationFilterInput>;
  existingInventoryCheckDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fillReferentLineWithUserOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDelivery?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDept?: InputMaybe<StringOperationFilterInput>;
  filterByAcDeptOut?: InputMaybe<StringOperationFilterInput>;
  filterByAcType?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<BooleanOperationFilterInput>;
  filterMovesByThisAcIssuer?: InputMaybe<StringOperationFilterInput>;
  filterMovesByThisAcReceiver?: InputMaybe<StringOperationFilterInput>;
  filterOrdersByThisAcWarehouse?: InputMaybe<StringOperationFilterInput>;
  filterReceiversByAcFieldSa?: InputMaybe<StringOperationFilterInput>;
  fiscalizationQueueEntry?: InputMaybe<ListFilterInputTypeOfFiscalizationQueueEntryFilterInput>;
  forceShowAvailableOnStock?: InputMaybe<BooleanOperationFilterInput>;
  fromPairs?: InputMaybe<ListFilterInputTypeOfDocumentTypePairFilterInput>;
  functionality?: InputMaybe<DocumentFunctionalityEnumOperationFilterInput>;
  generatePrintTimeOnCreate?: InputMaybe<BooleanOperationFilterInput>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<BooleanOperationFilterInput>;
  headerClerkPDFLabel?: InputMaybe<StringOperationFilterInput>;
  hideAcceptedByFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideClerkFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideCurrencyDateOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDMSMetadataEntryFields?: InputMaybe<BooleanOperationFilterInput>;
  hideDataForPaymentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDocumentElements?: InputMaybe<StringOperationFilterInput>;
  hideDocumentItemElements?: InputMaybe<StringOperationFilterInput>;
  hideLeftOverQuantityOnPicking?: InputMaybe<BooleanOperationFilterInput>;
  hideNoteInNonHistoricalView?: InputMaybe<BooleanOperationFilterInput>;
  hidePayMethodOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideQuantityEntry?: InputMaybe<BooleanOperationFilterInput>;
  hideVATRecapitulationOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseItemActions?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseOverview?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseSupplier?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderImages?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderMaterials?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderPlaceFromTo?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReception?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReclamations?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderServices?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderSpecications?: InputMaybe<BooleanOperationFilterInput>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<BooleanOperationFilterInput>;
  historyViewIgnoredFilters?: InputMaybe<StringOperationFilterInput>;
  horizontalDoc12AndDates?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<StringOperationFilterInput>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<BooleanOperationFilterInput>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  ignoreQuantityInWholeDocument?: InputMaybe<BooleanOperationFilterInput>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  isRetail?: InputMaybe<BooleanOperationFilterInput>;
  itemListShowDetailed?: InputMaybe<BooleanOperationFilterInput>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<BooleanOperationFilterInput>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<BooleanOperationFilterInput>;
  labelDefinitionLocations?: InputMaybe<ListFilterInputTypeOfLabelDefinitionLocationFilterInput>;
  linkFrom?: InputMaybe<ListFilterInputTypeOfDocumentTypeLinkFilterInput>;
  linkTo?: InputMaybe<ListFilterInputTypeOfDocumentTypeLinkFilterInput>;
  makeDocumentLinks?: InputMaybe<BooleanOperationFilterInput>;
  makeSerialStockCheck?: InputMaybe<BooleanOperationFilterInput>;
  manualWorkOrderMaterial?: InputMaybe<StringOperationFilterInput>;
  middleSignatureTextOnPrint?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifierCharacterLabel?: InputMaybe<StringOperationFilterInput>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<StringOperationFilterInput>;
  mustFiscalize?: InputMaybe<BooleanOperationFilterInput>;
  newNewDocumentInputType?: InputMaybe<BooleanOperationFilterInput>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<BooleanOperationFilterInput>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypeFilterInput>>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<BooleanOperationFilterInput>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<BooleanOperationFilterInput>;
  palletEntry?: InputMaybe<BooleanOperationFilterInput>;
  pantheonDirection?: InputMaybe<PantheonDocumentDirectionEnumOperationFilterInput>;
  pantheonTable?: InputMaybe<PantheonDocumentTableOperationFilterInput>;
  partialDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  pdfSignWithoutGeneration?: InputMaybe<BooleanOperationFilterInput>;
  pickingShowConfirmationOnPick?: InputMaybe<BooleanOperationFilterInput>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  printDocumentTitleOverride?: InputMaybe<StringOperationFilterInput>;
  printTicketNameOverride?: InputMaybe<StringOperationFilterInput>;
  prioritisePackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  quantityDecimalPlaces?: InputMaybe<ComparableInt32OperationFilterInput>;
  read?: InputMaybe<BooleanOperationFilterInput>;
  recommendToMakeCodebooksOffline?: InputMaybe<BooleanOperationFilterInput>;
  requireASignature?: InputMaybe<BooleanOperationFilterInput>;
  reverseItemsList?: InputMaybe<BooleanOperationFilterInput>;
  saveUnsignedAsSignedPDF?: InputMaybe<BooleanOperationFilterInput>;
  sendB2BAsEInvoice?: InputMaybe<BooleanOperationFilterInput>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<BooleanOperationFilterInput>;
  sendLeftoverShadowsWithZero?: InputMaybe<BooleanOperationFilterInput>;
  serialNumberDirectionIsInput?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDescrOnPDFs?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcIdentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<StringOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<StringOperationFilterInput>;
  showAdDate?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<BooleanOperationFilterInput>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<BooleanOperationFilterInput>;
  showAllItemsIgnoringWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<BooleanOperationFilterInput>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<BooleanOperationFilterInput>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<BooleanOperationFilterInput>;
  showAttachSSCCButton?: InputMaybe<BooleanOperationFilterInput>;
  showBuyerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showContactEmailEntry?: InputMaybe<BooleanOperationFilterInput>;
  showContactEntry?: InputMaybe<BooleanOperationFilterInput>;
  showCostBearerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerOverview?: InputMaybe<BooleanOperationFilterInput>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<BooleanOperationFilterInput>;
  showDMSXMLItems?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryDeadlineDays?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryMethod?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentOutAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<StringOperationFilterInput>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showInventoryNumberOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showItalianLabelsOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAnNetWeightOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemPicturesOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showLastNOrdersForCustomer?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  showLineNoteOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showModifierCharacterPicker?: InputMaybe<BooleanOperationFilterInput>;
  showNumberOfUnlinkedDocuments?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<BooleanOperationFilterInput>;
  showPackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  showPaymentMethod?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityTotalOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showReceiverOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showWOWorkersEntry?: InputMaybe<BooleanOperationFilterInput>;
  skipConfirmationOnShortcuts?: InputMaybe<BooleanOperationFilterInput>;
  skipGS1BarcodeCheck?: InputMaybe<BooleanOperationFilterInput>;
  stockViewLoadAllOnOpen?: InputMaybe<BooleanOperationFilterInput>;
  stockViewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  storeContactEmailArbitraryInField?: InputMaybe<StringOperationFilterInput>;
  subjectDocumentListDocumentType?: InputMaybe<StringOperationFilterInput>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  syncPackagingWhenAddingNewItem?: InputMaybe<BooleanOperationFilterInput>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<BooleanOperationFilterInput>;
  tMNAcDefaultStatus?: InputMaybe<StringOperationFilterInput>;
  tMNAcDefaultSubject?: InputMaybe<StringOperationFilterInput>;
  tMNAnClassifIcationQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnMailBoxQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnStorageQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSize?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintShowCompanyImage?: InputMaybe<BooleanOperationFilterInput>;
  toPairs?: InputMaybe<ListFilterInputTypeOfDocumentTypePairFilterInput>;
  transferAcDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAcDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<BooleanOperationFilterInput>;
  treatIdentAsBarcode?: InputMaybe<BooleanOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  update?: InputMaybe<BooleanOperationFilterInput>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<BooleanOperationFilterInput>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<BooleanOperationFilterInput>;
  useDeadlineDateOnOverview?: InputMaybe<BooleanOperationFilterInput>;
  useSquareArticlePicker?: InputMaybe<BooleanOperationFilterInput>;
  useVerySmallMobileInterface?: InputMaybe<BooleanOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  visualAttributes?: InputMaybe<StringOperationFilterInput>;
  visualAttributesOverview?: InputMaybe<StringOperationFilterInput>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  warehouseName?: InputMaybe<StringOperationFilterInput>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<StringOperationFilterInput>;
  warehouseShowPrices?: InputMaybe<BooleanOperationFilterInput>;
  warehouseViewFixedAcSubject?: InputMaybe<StringOperationFilterInput>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  workOrderCanBeUnlocked?: InputMaybe<BooleanOperationFilterInput>;
  workOrderPrintSpecificationDuration?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationPrefillTime?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<BooleanOperationFilterInput>;
  workOrderUnlockableStatus?: InputMaybe<StringOperationFilterInput>;
};

export type DocumentTypeLink = {
  acDocsOrderingOnPDF?: Maybe<Scalars['String']>;
  acFieldSFLabel?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName?: Maybe<Scalars['String']>;
  acLinkDocName1?: Maybe<Scalars['String']>;
  acLinkDocName2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acName3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acSetOfsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  acStatusIn?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acWorkPlace?: Maybe<Scalars['String']>;
  acceptedByFieldOnPrint?: Maybe<Scalars['String']>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  adDateDoc1EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc1PDFLabel?: Maybe<Scalars['String']>;
  adDateDoc2EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc2PDFLabel?: Maybe<Scalars['String']>;
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  adminAllowChangingItemPrice: Scalars['Boolean'];
  adminCanEditDocumentAfterSaving: Scalars['Boolean'];
  adminDefaultAcPriceRate?: Maybe<Scalars['String']>;
  adminDeleteItemsAfterDocumentIsSaved: Scalars['Boolean'];
  adminDocumentOnCreateMakeWarehouseReservation: Scalars['Boolean'];
  adminEmphasizeInStock: Scalars['Boolean'];
  adminForceAcPriceRate?: Maybe<Scalars['String']>;
  adminIgnoreRebate1: Scalars['Boolean'];
  adminIgnoreRebate2: Scalars['Boolean'];
  adminIgnoreRebate3: Scalars['Boolean'];
  adminItemQuantityMustBeInStock: Scalars['Boolean'];
  adminSavedRebatesForFinalRebate: Scalars['Boolean'];
  adminSendDocumentToCompanyDocumentEmail: Scalars['Boolean'];
  adminSerialNumbersAreNotAutomated?: Maybe<Scalars['Boolean']>;
  adminShowDailyIncome: Scalars['Boolean'];
  adminShowSubjectAdd: Scalars['Boolean'];
  adminUseAnWsPrice: Scalars['Boolean'];
  adminUseGenericDocumentsForMoveAndOrder: Scalars['Boolean'];
  adminUseSerialNumberForItems: Scalars['Boolean'];
  allowChangingWarehouse?: Maybe<Scalars['Boolean']>;
  allowDMSCRUDOnlyForUsersFiles?: Maybe<Scalars['Boolean']>;
  allowDMSConfirmation?: Maybe<Scalars['Boolean']>;
  allowDMSReclassification?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemArticlePicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemCostBearerPicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemDepartmentPicking?: Maybe<Scalars['Boolean']>;
  allowGenericDocumentTypeImageAttachments?: Maybe<Scalars['Boolean']>;
  allowManualVerifyFromDocumentOverview?: Maybe<Scalars['Boolean']>;
  allowModifyExistingDocuments: Scalars['Boolean'];
  allowPullingDMSEInvoicesFromService?: Maybe<Scalars['Boolean']>;
  allowSavingGeodecodedLocation?: Maybe<Scalars['Boolean']>;
  allowSelectingMultipleDocumentsToCreateFrom?: Maybe<Scalars['Boolean']>;
  allowSigningAfterDocumentIsSaved?: Maybe<Scalars['Boolean']>;
  alwaysShowTheseAcSetOfItem?: Maybe<Scalars['String']>;
  alwaysUpdatePriceAndRebateFromClient?: Maybe<Scalars['Boolean']>;
  appendToItemIfExists?: Maybe<Scalars['Boolean']>;
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  arbitraryField1Label?: Maybe<Scalars['String']>;
  arbitraryField1Location?: Maybe<Scalars['String']>;
  arbitraryField1Value?: Maybe<Scalars['String']>;
  arbitraryFields: Array<DocumentTypeArbitraryField>;
  articleDontShowPriceAnyWhere: Scalars['Boolean'];
  articleDontShowStockAnyWhere: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchInitiallyLoadAll: Scalars['Boolean'];
  articleSearchRepeatLastSearch: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  articleSearchShowOnlyWhereAcClassifIsIn?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsAIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsBIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsCIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsDIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsEIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsFIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsGIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsHIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsIIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsJIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAdFielddAIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddBIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddCIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddDIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAnFieldnAIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnBIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnCIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnDIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnEIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnFIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnGIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnHIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnIIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnJIs?: Maybe<Scalars['Decimal']>;
  bluetoothPrintCopiesNumber: Scalars['Int'];
  cacheDuration: Scalars['Int'];
  cacheUseCacheForAnyResource: Scalars['Boolean'];
  cacheUseForArticleSearch: Scalars['Boolean'];
  cacheUseForCustomerSearch: Scalars['Boolean'];
  cacheUseForWarehouseSearch: Scalars['Boolean'];
  cardPaymentProvider?: Maybe<CardPaymentProvider>;
  changeDocumentStatusAfterCreated?: Maybe<Scalars['String']>;
  changeSourceDocumentStatusTo?: Maybe<Scalars['String']>;
  classifs2WhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  classifsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  clerkFieldOnPrint?: Maybe<Scalars['String']>;
  companyEmailDefaultEmail?: Maybe<Scalars['String']>;
  companyEmailPDFBCC?: Maybe<Scalars['String']>;
  companyEmailPDFCC?: Maybe<Scalars['String']>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: Maybe<Scalars['Boolean']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completeDeliveryStatus?: Maybe<Scalars['String']>;
  copyOnlyLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  copyOnlyThoseWithLeftOverQuantity0?: Maybe<Scalars['Boolean']>;
  copyingFromAnotherIsAShadowCopy?: Maybe<Scalars['Boolean']>;
  create: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  customContractPriceFilter?: Maybe<Scalars['Boolean']>;
  customerCodeAllowedKeys?: Maybe<Scalars['String']>;
  customerCodeFromAcSkis?: Maybe<Scalars['Boolean']>;
  customerCodeIsGenerated?: Maybe<Scalars['Boolean']>;
  dMSListFilterOnDefaultClassification?: Maybe<Scalars['Boolean']>;
  dateFilterType?: Maybe<DateFilterType>;
  defaultCustomerType?: Maybe<Scalars['String']>;
  defaultCustomerTypeFilter?: Maybe<Scalars['String']>;
  defaultMoveDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultMoveDocumentSortField?: Maybe<THeMovePagedSortField>;
  defaultOrderDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultOrderDocumentSortField?: Maybe<THeOrderPagedSortField>;
  defaultPaymentMethod?: Maybe<Scalars['String']>;
  defaultQuantity?: Maybe<Scalars['Decimal']>;
  defaultSubjectDaysForPaymentOnAdd?: Maybe<Scalars['Int']>;
  defaultSubjectPaymentMethodOnAdd?: Maybe<Scalars['String']>;
  defaultToThisCustomer?: Maybe<Scalars['String']>;
  defaultWoexDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultWoexDocumentSortField?: Maybe<THfWoexPagedSortField>;
  delete: Scalars['Boolean'];
  deliveryIsRequired?: Maybe<Scalars['Boolean']>;
  disableUsingShadowItemAsItemBase?: Maybe<Scalars['Boolean']>;
  disallowChangingCustomer: Scalars['Boolean'];
  disallowChangingItemQuantityOnSerialInput?: Maybe<Scalars['Boolean']>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: Maybe<Scalars['Boolean']>;
  disallowManualWarehouseSearch?: Maybe<Scalars['Boolean']>;
  disallowPickingCustomer: Scalars['Boolean'];
  dmsAcStatusIn?: Maybe<Scalars['String']>;
  doNotFilterDailyRecapByUserId?: Maybe<Scalars['Boolean']>;
  documentLinkType?: Maybe<Scalars['String']>;
  documentLinkTypeA?: Maybe<Scalars['String']>;
  documentLinkTypeB?: Maybe<Scalars['String']>;
  documentNote?: Maybe<Scalars['String']>;
  documentOnCreateMakeA4Print?: Maybe<Scalars['Boolean']>;
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  documentTopAdditionalText?: Maybe<Scalars['String']>;
  dontSaveIndividualPDFPages?: Maybe<Scalars['Boolean']>;
  existingInventoryCheckDays?: Maybe<Scalars['Int']>;
  fillReferentLineWithUserOnPrint?: Maybe<Scalars['Boolean']>;
  filterByAcDelivery: Scalars['Boolean'];
  filterByAcDept?: Maybe<Scalars['String']>;
  filterByAcDeptOut?: Maybe<Scalars['String']>;
  filterByAcType?: Maybe<Scalars['String']>;
  filterByAcVerifiedPrices?: Maybe<Scalars['String']>;
  filterByAcVerifyStatus?: Maybe<Scalars['String']>;
  filterByCurrentUserIdIsAnSigner1?: Maybe<Scalars['Boolean']>;
  filterMovesByThisAcIssuer?: Maybe<Scalars['String']>;
  filterMovesByThisAcReceiver?: Maybe<Scalars['String']>;
  filterOrdersByThisAcWarehouse?: Maybe<Scalars['String']>;
  filterReceiversByAcFieldSa?: Maybe<Scalars['String']>;
  forceShowAvailableOnStock: Scalars['Boolean'];
  functionality: DocumentPairFunctionalityEnum;
  generatePrintTimeOnCreate: Scalars['Boolean'];
  groupAllCreatingDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupAllDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated: Scalars['Boolean'];
  headerClerkPDFLabel?: Maybe<Scalars['String']>;
  hideAcceptedByFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideClerkFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideCurrencyDateOnPrint?: Maybe<Scalars['Boolean']>;
  hideDMSMetadataEntryFields?: Maybe<Scalars['Boolean']>;
  hideDataForPaymentOnPrint?: Maybe<Scalars['Boolean']>;
  hideDocumentElements?: Maybe<Scalars['String']>;
  hideDocumentItemElements?: Maybe<Scalars['String']>;
  hideLeftOverQuantityOnPicking?: Maybe<Scalars['Boolean']>;
  hideNoteInNonHistoricalView?: Maybe<Scalars['Boolean']>;
  hidePayMethodOnPrint?: Maybe<Scalars['Boolean']>;
  hideQuantityEntry?: Maybe<Scalars['Boolean']>;
  hideVATRecapitulationOnPrint?: Maybe<Scalars['Boolean']>;
  hideWarehouseItemActions?: Maybe<Scalars['Boolean']>;
  hideWarehouseOverview?: Maybe<Scalars['Boolean']>;
  hideWarehouseSupplier?: Maybe<Scalars['Boolean']>;
  hideWorkOrderImages?: Maybe<Scalars['Boolean']>;
  hideWorkOrderMaterials?: Maybe<Scalars['Boolean']>;
  hideWorkOrderPlaceFromTo?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReception?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReclamations?: Maybe<Scalars['Boolean']>;
  hideWorkOrderServices?: Maybe<Scalars['Boolean']>;
  hideWorkOrderSpecications?: Maybe<Scalars['Boolean']>;
  highlightArticlePickerTextOnNextOpen?: Maybe<Scalars['Boolean']>;
  historyViewIgnoredFilters?: Maybe<Scalars['String']>;
  horizontalDoc12AndDates?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  ifAcPayMethodChooseThisDocumentType?: Maybe<Scalars['String']>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: Maybe<Scalars['Boolean']>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  ignoreQuantityInWholeDocument?: Maybe<Scalars['Boolean']>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: Maybe<Scalars['Boolean']>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: Maybe<Scalars['Boolean']>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isRetail?: Maybe<Scalars['Boolean']>;
  itemListShowDetailed: Scalars['Boolean'];
  jumpToEditAfterScanningItemWithBarcode: Scalars['Boolean'];
  keepAdDateDoc1And2Unrounded?: Maybe<Scalars['Boolean']>;
  labelDefinitionLocations: Array<LabelDefinitionLocation>;
  linkFrom?: Maybe<Array<Maybe<DocumentType>>>;
  linkTo?: Maybe<Array<Maybe<DocumentType>>>;
  makeDocumentLinks?: Maybe<Scalars['Boolean']>;
  makeSerialStockCheck?: Maybe<Scalars['Boolean']>;
  manualWorkOrderMaterial?: Maybe<Scalars['String']>;
  middleSignatureTextOnPrint?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifierCharacterLabel?: Maybe<Scalars['String']>;
  multipleEndDocumentsCaseToPickEndDocument?: Maybe<Scalars['String']>;
  mustFiscalize?: Maybe<Scalars['Boolean']>;
  newNewDocumentInputType?: Maybe<Scalars['Boolean']>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: Maybe<Scalars['Boolean']>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: Maybe<Scalars['Boolean']>;
  palletEntry?: Maybe<Scalars['Boolean']>;
  partialDeliveryStatus?: Maybe<Scalars['String']>;
  pdfSignWithoutGeneration?: Maybe<Scalars['Boolean']>;
  pickingShowConfirmationOnPick: Scalars['Boolean'];
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: Maybe<Scalars['Boolean']>;
  printDocumentTitleOverride?: Maybe<Scalars['String']>;
  printTicketNameOverride?: Maybe<Scalars['String']>;
  prioritisePackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  quantityDecimalPlaces: Scalars['Int'];
  read: Scalars['Boolean'];
  recommendToMakeCodebooksOffline?: Maybe<Scalars['Boolean']>;
  requireASignature: Scalars['Boolean'];
  reverseItemsList?: Maybe<Scalars['Boolean']>;
  saveUnsignedAsSignedPDF?: Maybe<Scalars['Boolean']>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: Maybe<Scalars['Boolean']>;
  sendLeftoverShadowsWithZero?: Maybe<Scalars['Boolean']>;
  serialNumberDirectionIsInput?: Maybe<Scalars['Boolean']>;
  showAcDeliveryMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDeliveryOnDocumentList: Scalars['Boolean'];
  showAcDeptMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDescrOnPDFs?: Maybe<Scalars['Boolean']>;
  showAcDoc1?: Maybe<Scalars['Boolean']>;
  showAcDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAcDoc2?: Maybe<Scalars['Boolean']>;
  showAcDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAcIdentOnPrint?: Maybe<Scalars['Boolean']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: Maybe<Scalars['String']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: Maybe<Scalars['String']>;
  showAdDate?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAllDMSDocumentsForURAClassifications?: Maybe<Scalars['Boolean']>;
  showAllDocumentsNotOnlyAnUserIns?: Maybe<Scalars['Boolean']>;
  showAllItemsIgnoringWarehouse?: Maybe<Scalars['Boolean']>;
  showAnClerkAndAnNoteClerkIsOROperation?: Maybe<Scalars['Boolean']>;
  showArticlesGroupedByCodeButSeparate?: Maybe<Scalars['Boolean']>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: Maybe<Scalars['Boolean']>;
  showAttachSSCCButton?: Maybe<Scalars['Boolean']>;
  showBuyerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showContactEmailEntry?: Maybe<Scalars['Boolean']>;
  showContactEntry?: Maybe<Scalars['Boolean']>;
  showCostBearerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showCustomerName2AsPrimaryOnHeader?: Maybe<Scalars['Boolean']>;
  showCustomerOverview?: Maybe<Scalars['Boolean']>;
  showCustomersAcName2OnThermalPrint?: Maybe<Scalars['Boolean']>;
  showDMSXMLItems?: Maybe<Scalars['Boolean']>;
  showDeliveryDeadlineDays: Scalars['Boolean'];
  showDeliveryMethod: Scalars['Boolean'];
  showDepartmentAsReceiver: Scalars['Boolean'];
  showDepartmentOutAsReceiver: Scalars['Boolean'];
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: Maybe<Scalars['String']>;
  showDoc12AndTheirDatesOnDocumentList?: Maybe<Scalars['Boolean']>;
  showInventoryNumberOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showItalianLabelsOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAcCustomsTariffOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAnNetWeightOnPrint?: Maybe<Scalars['Boolean']>;
  showItemPicturesOnPrint?: Maybe<Scalars['Boolean']>;
  showLastNOrdersForCustomer?: Maybe<Scalars['Int']>;
  showLineNoteOnPrint: Scalars['Boolean'];
  showModifierCharacterPicker: Scalars['Boolean'];
  showNumberOfUnlinkedDocuments?: Maybe<Scalars['Boolean']>;
  showOnlyArticlesWithCustomerContractPrice: Scalars['Boolean'];
  showOnlyDMSDocumentsAssignedToMe?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyWOWhereCurrentUserSpecExists?: Maybe<Scalars['Boolean']>;
  showPackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  showPaymentMethod: Scalars['Boolean'];
  showQuantityPerUnitOfMeasureOnPrint?: Maybe<Scalars['Boolean']>;
  showQuantityTotalOnPrint?: Maybe<Scalars['Boolean']>;
  showReceiverOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showSerialNumberSearchForWorkOrders?: Maybe<Scalars['Boolean']>;
  showWOWorkersEntry?: Maybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  skipGS1BarcodeCheck: Scalars['Boolean'];
  stockViewLoadAllOnOpen: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  storeContactEmailArbitraryInField?: Maybe<Scalars['String']>;
  subjectDocumentListDocumentType?: Maybe<Scalars['String']>;
  subjectFieldForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  subjectFieldValueForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  syncPackagingWhenAddingNewItem: Scalars['Boolean'];
  tHrPrsnForOnlyOnixPhoneUsers?: Maybe<Scalars['Boolean']>;
  tMNAcDefaultStatus?: Maybe<Scalars['String']>;
  tMNAcDefaultSubject?: Maybe<Scalars['String']>;
  tMNAnClassifIcationQid?: Maybe<Scalars['Int']>;
  tMNAnMailBoxQid?: Maybe<Scalars['Int']>;
  tMNAnStorageQid?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSize?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeHeight?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeWidth?: Maybe<Scalars['Int']>;
  thermalPrintShowCompanyImage: Scalars['Boolean'];
  transferAcDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAcDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferEnteredItemQuantityToSerialNumber?: Maybe<Scalars['Boolean']>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: Maybe<Scalars['Boolean']>;
  treatIdentAsBarcode?: Maybe<Scalars['Boolean']>;
  update: Scalars['Boolean'];
  updateHeadAndDeleteAllItemsOnCopy?: Maybe<Scalars['Boolean']>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: Maybe<Scalars['Boolean']>;
  useDeadlineDateOnOverview: Scalars['Boolean'];
  useLinkSettings: Scalars['Boolean'];
  useSquareArticlePicker?: Maybe<Scalars['Boolean']>;
  useVerySmallMobileInterface?: Maybe<Scalars['Boolean']>;
  visualAttributes?: Maybe<Scalars['String']>;
  visualAttributesOverview?: Maybe<Scalars['String']>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  warehouseName?: Maybe<Scalars['String']>;
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  warehousePositionTHeSetItemFieldName?: Maybe<Scalars['String']>;
  warehouseShowPrices?: Maybe<Scalars['Boolean']>;
  warehouseViewFixedAcSubject?: Maybe<Scalars['String']>;
  whenAddingSubjectSetAnClerkToCurrentUser?: Maybe<Scalars['Boolean']>;
  workOrderCanBeUnlocked?: Maybe<Scalars['Boolean']>;
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
  workOrderSpecificationPrefillTime?: Maybe<Scalars['Boolean']>;
  workOrderSpecificationTimeNotRequired?: Maybe<Scalars['Boolean']>;
  workOrderUnlockableStatus?: Maybe<Scalars['String']>;
};


export type DocumentTypeLinkArbitraryFieldsArgs = {
  order?: InputMaybe<Array<DocumentTypeArbitraryFieldSortInput>>;
};

export type DocumentTypeLinkFilterInput = {
  acDocsOrderingOnPDF?: InputMaybe<StringOperationFilterInput>;
  acFieldSFLabel?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName1?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acName3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  acStatusIn?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  acceptedByFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1PDFLabel?: InputMaybe<StringOperationFilterInput>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc2PDFLabel?: InputMaybe<StringOperationFilterInput>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<BooleanOperationFilterInput>;
  adminAllowChangingItemPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminCanEditDocumentAfterSaving?: InputMaybe<BooleanOperationFilterInput>;
  adminDefaultAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<BooleanOperationFilterInput>;
  adminEmphasizeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminForceAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminIgnoreRebate1?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate2?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate3?: InputMaybe<BooleanOperationFilterInput>;
  adminItemQuantityMustBeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminSavedRebatesForFinalRebate?: InputMaybe<BooleanOperationFilterInput>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<BooleanOperationFilterInput>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<BooleanOperationFilterInput>;
  adminShowDailyIncome?: InputMaybe<BooleanOperationFilterInput>;
  adminShowSubjectAdd?: InputMaybe<BooleanOperationFilterInput>;
  adminUseAnWsPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<BooleanOperationFilterInput>;
  adminUseSerialNumberForItems?: InputMaybe<BooleanOperationFilterInput>;
  allowChangingWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSConfirmation?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSReclassification?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemArticlePicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<BooleanOperationFilterInput>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<BooleanOperationFilterInput>;
  allowModifyExistingDocuments?: InputMaybe<BooleanOperationFilterInput>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<BooleanOperationFilterInput>;
  allowSavingGeodecodedLocation?: InputMaybe<BooleanOperationFilterInput>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<BooleanOperationFilterInput>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<StringOperationFilterInput>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DocumentTypeLinkFilterInput>>;
  appendToItemIfExists?: InputMaybe<BooleanOperationFilterInput>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Label?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Location?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Value?: InputMaybe<StringOperationFilterInput>;
  arbitraryFields?: InputMaybe<ListFilterInputTypeOfDocumentTypeArbitraryFieldFilterInput>;
  articleDontShowPriceAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleDontShowStockAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchAllowSearchingByClassification?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchInitiallyLoadAll?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchRepeatLastSearch?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bluetoothPrintCopiesNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheDuration?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheUseCacheForAnyResource?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForArticleSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForCustomerSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  cardPaymentProvider?: InputMaybe<NullableOfCardPaymentProviderOperationFilterInput>;
  changeDocumentStatusAfterCreated?: InputMaybe<StringOperationFilterInput>;
  changeSourceDocumentStatusTo?: InputMaybe<StringOperationFilterInput>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  clerkFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  companyEmailDefaultEmail?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFBCC?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFCC?: InputMaybe<StringOperationFilterInput>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completeDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  copyOnlyLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<BooleanOperationFilterInput>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<BooleanOperationFilterInput>;
  create?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customContractPriceFilter?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeAllowedKeys?: InputMaybe<StringOperationFilterInput>;
  customerCodeFromAcSkis?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeIsGenerated?: InputMaybe<BooleanOperationFilterInput>;
  dMSListFilterOnDefaultClassification?: InputMaybe<BooleanOperationFilterInput>;
  dateFilterType?: InputMaybe<NullableOfDateFilterTypeOperationFilterInput>;
  defaultCustomerType?: InputMaybe<StringOperationFilterInput>;
  defaultCustomerTypeFilter?: InputMaybe<StringOperationFilterInput>;
  defaultMoveDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultMoveDocumentSortField?: InputMaybe<NullableOfTHeMovePagedSortFieldOperationFilterInput>;
  defaultOrderDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultOrderDocumentSortField?: InputMaybe<NullableOfTHeOrderPagedSortFieldOperationFilterInput>;
  defaultPaymentMethod?: InputMaybe<StringOperationFilterInput>;
  defaultQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<StringOperationFilterInput>;
  defaultToThisCustomer?: InputMaybe<StringOperationFilterInput>;
  defaultWoexDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultWoexDocumentSortField?: InputMaybe<NullableOfTHfWoexPagedSortFieldOperationFilterInput>;
  delete?: InputMaybe<BooleanOperationFilterInput>;
  deliveryIsRequired?: InputMaybe<BooleanOperationFilterInput>;
  disableUsingShadowItemAsItemBase?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<BooleanOperationFilterInput>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<BooleanOperationFilterInput>;
  disallowManualWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  disallowPickingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  dmsAcStatusIn?: InputMaybe<StringOperationFilterInput>;
  doNotFilterDailyRecapByUserId?: InputMaybe<BooleanOperationFilterInput>;
  documentLinkType?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeA?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeB?: InputMaybe<StringOperationFilterInput>;
  documentNote?: InputMaybe<StringOperationFilterInput>;
  documentOnCreateMakeA4Print?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakePDF?: InputMaybe<BooleanOperationFilterInput>;
  documentTopAdditionalText?: InputMaybe<StringOperationFilterInput>;
  dontSaveIndividualPDFPages?: InputMaybe<BooleanOperationFilterInput>;
  existingInventoryCheckDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fillReferentLineWithUserOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDelivery?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDept?: InputMaybe<StringOperationFilterInput>;
  filterByAcDeptOut?: InputMaybe<StringOperationFilterInput>;
  filterByAcType?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<BooleanOperationFilterInput>;
  filterMovesByThisAcIssuer?: InputMaybe<StringOperationFilterInput>;
  filterMovesByThisAcReceiver?: InputMaybe<StringOperationFilterInput>;
  filterOrdersByThisAcWarehouse?: InputMaybe<StringOperationFilterInput>;
  filterReceiversByAcFieldSa?: InputMaybe<StringOperationFilterInput>;
  forceShowAvailableOnStock?: InputMaybe<BooleanOperationFilterInput>;
  functionality?: InputMaybe<DocumentPairFunctionalityEnumOperationFilterInput>;
  generatePrintTimeOnCreate?: InputMaybe<BooleanOperationFilterInput>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<BooleanOperationFilterInput>;
  headerClerkPDFLabel?: InputMaybe<StringOperationFilterInput>;
  hideAcceptedByFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideClerkFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideCurrencyDateOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDMSMetadataEntryFields?: InputMaybe<BooleanOperationFilterInput>;
  hideDataForPaymentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDocumentElements?: InputMaybe<StringOperationFilterInput>;
  hideDocumentItemElements?: InputMaybe<StringOperationFilterInput>;
  hideLeftOverQuantityOnPicking?: InputMaybe<BooleanOperationFilterInput>;
  hideNoteInNonHistoricalView?: InputMaybe<BooleanOperationFilterInput>;
  hidePayMethodOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideQuantityEntry?: InputMaybe<BooleanOperationFilterInput>;
  hideVATRecapitulationOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseItemActions?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseOverview?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseSupplier?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderImages?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderMaterials?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderPlaceFromTo?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReception?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReclamations?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderServices?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderSpecications?: InputMaybe<BooleanOperationFilterInput>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<BooleanOperationFilterInput>;
  historyViewIgnoredFilters?: InputMaybe<StringOperationFilterInput>;
  horizontalDoc12AndDates?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<StringOperationFilterInput>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<BooleanOperationFilterInput>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  ignoreQuantityInWholeDocument?: InputMaybe<BooleanOperationFilterInput>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  isRetail?: InputMaybe<BooleanOperationFilterInput>;
  itemListShowDetailed?: InputMaybe<BooleanOperationFilterInput>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<BooleanOperationFilterInput>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<BooleanOperationFilterInput>;
  labelDefinitionLocations?: InputMaybe<ListFilterInputTypeOfLabelDefinitionLocationFilterInput>;
  linkFrom?: InputMaybe<ListFilterInputTypeOfDocumentTypeFilterInput>;
  linkTo?: InputMaybe<ListFilterInputTypeOfDocumentTypeFilterInput>;
  makeDocumentLinks?: InputMaybe<BooleanOperationFilterInput>;
  makeSerialStockCheck?: InputMaybe<BooleanOperationFilterInput>;
  manualWorkOrderMaterial?: InputMaybe<StringOperationFilterInput>;
  middleSignatureTextOnPrint?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifierCharacterLabel?: InputMaybe<StringOperationFilterInput>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<StringOperationFilterInput>;
  mustFiscalize?: InputMaybe<BooleanOperationFilterInput>;
  newNewDocumentInputType?: InputMaybe<BooleanOperationFilterInput>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<BooleanOperationFilterInput>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypeLinkFilterInput>>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<BooleanOperationFilterInput>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<BooleanOperationFilterInput>;
  palletEntry?: InputMaybe<BooleanOperationFilterInput>;
  partialDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  pdfSignWithoutGeneration?: InputMaybe<BooleanOperationFilterInput>;
  pickingShowConfirmationOnPick?: InputMaybe<BooleanOperationFilterInput>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  printDocumentTitleOverride?: InputMaybe<StringOperationFilterInput>;
  printTicketNameOverride?: InputMaybe<StringOperationFilterInput>;
  prioritisePackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  quantityDecimalPlaces?: InputMaybe<ComparableInt32OperationFilterInput>;
  read?: InputMaybe<BooleanOperationFilterInput>;
  recommendToMakeCodebooksOffline?: InputMaybe<BooleanOperationFilterInput>;
  requireASignature?: InputMaybe<BooleanOperationFilterInput>;
  reverseItemsList?: InputMaybe<BooleanOperationFilterInput>;
  saveUnsignedAsSignedPDF?: InputMaybe<BooleanOperationFilterInput>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<BooleanOperationFilterInput>;
  sendLeftoverShadowsWithZero?: InputMaybe<BooleanOperationFilterInput>;
  serialNumberDirectionIsInput?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDescrOnPDFs?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcIdentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<StringOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<StringOperationFilterInput>;
  showAdDate?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<BooleanOperationFilterInput>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<BooleanOperationFilterInput>;
  showAllItemsIgnoringWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<BooleanOperationFilterInput>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<BooleanOperationFilterInput>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<BooleanOperationFilterInput>;
  showAttachSSCCButton?: InputMaybe<BooleanOperationFilterInput>;
  showBuyerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showContactEmailEntry?: InputMaybe<BooleanOperationFilterInput>;
  showContactEntry?: InputMaybe<BooleanOperationFilterInput>;
  showCostBearerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerOverview?: InputMaybe<BooleanOperationFilterInput>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<BooleanOperationFilterInput>;
  showDMSXMLItems?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryDeadlineDays?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryMethod?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentOutAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<StringOperationFilterInput>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showInventoryNumberOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showItalianLabelsOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAnNetWeightOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemPicturesOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showLastNOrdersForCustomer?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  showLineNoteOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showModifierCharacterPicker?: InputMaybe<BooleanOperationFilterInput>;
  showNumberOfUnlinkedDocuments?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<BooleanOperationFilterInput>;
  showPackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  showPaymentMethod?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityTotalOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showReceiverOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showWOWorkersEntry?: InputMaybe<BooleanOperationFilterInput>;
  skipConfirmationOnShortcuts?: InputMaybe<BooleanOperationFilterInput>;
  skipGS1BarcodeCheck?: InputMaybe<BooleanOperationFilterInput>;
  stockViewLoadAllOnOpen?: InputMaybe<BooleanOperationFilterInput>;
  stockViewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  storeContactEmailArbitraryInField?: InputMaybe<StringOperationFilterInput>;
  subjectDocumentListDocumentType?: InputMaybe<StringOperationFilterInput>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  syncPackagingWhenAddingNewItem?: InputMaybe<BooleanOperationFilterInput>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<BooleanOperationFilterInput>;
  tMNAcDefaultStatus?: InputMaybe<StringOperationFilterInput>;
  tMNAcDefaultSubject?: InputMaybe<StringOperationFilterInput>;
  tMNAnClassifIcationQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnMailBoxQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnStorageQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSize?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintShowCompanyImage?: InputMaybe<BooleanOperationFilterInput>;
  transferAcDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAcDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<BooleanOperationFilterInput>;
  treatIdentAsBarcode?: InputMaybe<BooleanOperationFilterInput>;
  update?: InputMaybe<BooleanOperationFilterInput>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<BooleanOperationFilterInput>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<BooleanOperationFilterInput>;
  useDeadlineDateOnOverview?: InputMaybe<BooleanOperationFilterInput>;
  useLinkSettings?: InputMaybe<BooleanOperationFilterInput>;
  useSquareArticlePicker?: InputMaybe<BooleanOperationFilterInput>;
  useVerySmallMobileInterface?: InputMaybe<BooleanOperationFilterInput>;
  visualAttributes?: InputMaybe<StringOperationFilterInput>;
  visualAttributesOverview?: InputMaybe<StringOperationFilterInput>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  warehouseName?: InputMaybe<StringOperationFilterInput>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<StringOperationFilterInput>;
  warehouseShowPrices?: InputMaybe<BooleanOperationFilterInput>;
  warehouseViewFixedAcSubject?: InputMaybe<StringOperationFilterInput>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  workOrderCanBeUnlocked?: InputMaybe<BooleanOperationFilterInput>;
  workOrderPrintSpecificationDuration?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationPrefillTime?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<BooleanOperationFilterInput>;
  workOrderUnlockableStatus?: InputMaybe<StringOperationFilterInput>;
};

export type DocumentTypeLinkSortInput = {
  acDocsOrderingOnPDF?: InputMaybe<SortEnumType>;
  acFieldSFLabel?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerName?: InputMaybe<SortEnumType>;
  acLinkDocName1?: InputMaybe<SortEnumType>;
  acLinkDocName2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acName3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  acStatusIn?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  acceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc1PDFLabel?: InputMaybe<SortEnumType>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc2PDFLabel?: InputMaybe<SortEnumType>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<SortEnumType>;
  adminAllowChangingItemPrice?: InputMaybe<SortEnumType>;
  adminCanEditDocumentAfterSaving?: InputMaybe<SortEnumType>;
  adminDefaultAcPriceRate?: InputMaybe<SortEnumType>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<SortEnumType>;
  adminEmphasizeInStock?: InputMaybe<SortEnumType>;
  adminForceAcPriceRate?: InputMaybe<SortEnumType>;
  adminIgnoreRebate1?: InputMaybe<SortEnumType>;
  adminIgnoreRebate2?: InputMaybe<SortEnumType>;
  adminIgnoreRebate3?: InputMaybe<SortEnumType>;
  adminItemQuantityMustBeInStock?: InputMaybe<SortEnumType>;
  adminSavedRebatesForFinalRebate?: InputMaybe<SortEnumType>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<SortEnumType>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<SortEnumType>;
  adminShowDailyIncome?: InputMaybe<SortEnumType>;
  adminShowSubjectAdd?: InputMaybe<SortEnumType>;
  adminUseAnWsPrice?: InputMaybe<SortEnumType>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<SortEnumType>;
  adminUseSerialNumberForItems?: InputMaybe<SortEnumType>;
  allowChangingWarehouse?: InputMaybe<SortEnumType>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<SortEnumType>;
  allowDMSConfirmation?: InputMaybe<SortEnumType>;
  allowDMSReclassification?: InputMaybe<SortEnumType>;
  allowDMSXMLItemArticlePicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<SortEnumType>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<SortEnumType>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<SortEnumType>;
  allowModifyExistingDocuments?: InputMaybe<SortEnumType>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<SortEnumType>;
  allowSavingGeodecodedLocation?: InputMaybe<SortEnumType>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<SortEnumType>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<SortEnumType>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<SortEnumType>;
  appendToItemIfExists?: InputMaybe<SortEnumType>;
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  arbitraryField1Label?: InputMaybe<SortEnumType>;
  arbitraryField1Location?: InputMaybe<SortEnumType>;
  arbitraryField1Value?: InputMaybe<SortEnumType>;
  articleDontShowPriceAnyWhere?: InputMaybe<SortEnumType>;
  articleDontShowStockAnyWhere?: InputMaybe<SortEnumType>;
  articleSearchAllowSearchingByClassification?: InputMaybe<SortEnumType>;
  articleSearchInitiallyLoadAll?: InputMaybe<SortEnumType>;
  articleSearchRepeatLastSearch?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyInStock?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<SortEnumType>;
  bluetoothPrintCopiesNumber?: InputMaybe<SortEnumType>;
  cacheDuration?: InputMaybe<SortEnumType>;
  cacheUseCacheForAnyResource?: InputMaybe<SortEnumType>;
  cacheUseForArticleSearch?: InputMaybe<SortEnumType>;
  cacheUseForCustomerSearch?: InputMaybe<SortEnumType>;
  cacheUseForWarehouseSearch?: InputMaybe<SortEnumType>;
  cardPaymentProvider?: InputMaybe<SortEnumType>;
  changeDocumentStatusAfterCreated?: InputMaybe<SortEnumType>;
  changeSourceDocumentStatusTo?: InputMaybe<SortEnumType>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  clerkFieldOnPrint?: InputMaybe<SortEnumType>;
  companyEmailDefaultEmail?: InputMaybe<SortEnumType>;
  companyEmailPDFBCC?: InputMaybe<SortEnumType>;
  companyEmailPDFCC?: InputMaybe<SortEnumType>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  completeDeliveryStatus?: InputMaybe<SortEnumType>;
  copyOnlyLeftOverQuantity?: InputMaybe<SortEnumType>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<SortEnumType>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<SortEnumType>;
  create?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customContractPriceFilter?: InputMaybe<SortEnumType>;
  customerCodeAllowedKeys?: InputMaybe<SortEnumType>;
  customerCodeFromAcSkis?: InputMaybe<SortEnumType>;
  customerCodeIsGenerated?: InputMaybe<SortEnumType>;
  dMSListFilterOnDefaultClassification?: InputMaybe<SortEnumType>;
  dateFilterType?: InputMaybe<SortEnumType>;
  defaultCustomerType?: InputMaybe<SortEnumType>;
  defaultCustomerTypeFilter?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortField?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortField?: InputMaybe<SortEnumType>;
  defaultPaymentMethod?: InputMaybe<SortEnumType>;
  defaultQuantity?: InputMaybe<SortEnumType>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<SortEnumType>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<SortEnumType>;
  defaultToThisCustomer?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortField?: InputMaybe<SortEnumType>;
  delete?: InputMaybe<SortEnumType>;
  deliveryIsRequired?: InputMaybe<SortEnumType>;
  disableUsingShadowItemAsItemBase?: InputMaybe<SortEnumType>;
  disallowChangingCustomer?: InputMaybe<SortEnumType>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<SortEnumType>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<SortEnumType>;
  disallowManualWarehouseSearch?: InputMaybe<SortEnumType>;
  disallowPickingCustomer?: InputMaybe<SortEnumType>;
  dmsAcStatusIn?: InputMaybe<SortEnumType>;
  doNotFilterDailyRecapByUserId?: InputMaybe<SortEnumType>;
  documentLinkType?: InputMaybe<SortEnumType>;
  documentLinkTypeA?: InputMaybe<SortEnumType>;
  documentLinkTypeB?: InputMaybe<SortEnumType>;
  documentNote?: InputMaybe<SortEnumType>;
  documentOnCreateMakeA4Print?: InputMaybe<SortEnumType>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<SortEnumType>;
  documentOnCreateMakePDF?: InputMaybe<SortEnumType>;
  documentTopAdditionalText?: InputMaybe<SortEnumType>;
  dontSaveIndividualPDFPages?: InputMaybe<SortEnumType>;
  existingInventoryCheckDays?: InputMaybe<SortEnumType>;
  fillReferentLineWithUserOnPrint?: InputMaybe<SortEnumType>;
  filterByAcDelivery?: InputMaybe<SortEnumType>;
  filterByAcDept?: InputMaybe<SortEnumType>;
  filterByAcDeptOut?: InputMaybe<SortEnumType>;
  filterByAcType?: InputMaybe<SortEnumType>;
  filterByAcVerifiedPrices?: InputMaybe<SortEnumType>;
  filterByAcVerifyStatus?: InputMaybe<SortEnumType>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<SortEnumType>;
  filterMovesByThisAcIssuer?: InputMaybe<SortEnumType>;
  filterMovesByThisAcReceiver?: InputMaybe<SortEnumType>;
  filterOrdersByThisAcWarehouse?: InputMaybe<SortEnumType>;
  filterReceiversByAcFieldSa?: InputMaybe<SortEnumType>;
  forceShowAvailableOnStock?: InputMaybe<SortEnumType>;
  functionality?: InputMaybe<SortEnumType>;
  generatePrintTimeOnCreate?: InputMaybe<SortEnumType>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<SortEnumType>;
  headerClerkPDFLabel?: InputMaybe<SortEnumType>;
  hideAcceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  hideClerkFieldOnPrint?: InputMaybe<SortEnumType>;
  hideCurrencyDateOnPrint?: InputMaybe<SortEnumType>;
  hideDMSMetadataEntryFields?: InputMaybe<SortEnumType>;
  hideDataForPaymentOnPrint?: InputMaybe<SortEnumType>;
  hideDocumentElements?: InputMaybe<SortEnumType>;
  hideDocumentItemElements?: InputMaybe<SortEnumType>;
  hideLeftOverQuantityOnPicking?: InputMaybe<SortEnumType>;
  hideNoteInNonHistoricalView?: InputMaybe<SortEnumType>;
  hidePayMethodOnPrint?: InputMaybe<SortEnumType>;
  hideQuantityEntry?: InputMaybe<SortEnumType>;
  hideVATRecapitulationOnPrint?: InputMaybe<SortEnumType>;
  hideWarehouseItemActions?: InputMaybe<SortEnumType>;
  hideWarehouseOverview?: InputMaybe<SortEnumType>;
  hideWarehouseSupplier?: InputMaybe<SortEnumType>;
  hideWorkOrderImages?: InputMaybe<SortEnumType>;
  hideWorkOrderMaterials?: InputMaybe<SortEnumType>;
  hideWorkOrderPlaceFromTo?: InputMaybe<SortEnumType>;
  hideWorkOrderReception?: InputMaybe<SortEnumType>;
  hideWorkOrderReclamations?: InputMaybe<SortEnumType>;
  hideWorkOrderServices?: InputMaybe<SortEnumType>;
  hideWorkOrderSpecications?: InputMaybe<SortEnumType>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<SortEnumType>;
  historyViewIgnoredFilters?: InputMaybe<SortEnumType>;
  horizontalDoc12AndDates?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<SortEnumType>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<SortEnumType>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<SortEnumType>;
  ignoreQuantityInWholeDocument?: InputMaybe<SortEnumType>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<SortEnumType>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<SortEnumType>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<SortEnumType>;
  isDisabled?: InputMaybe<SortEnumType>;
  isRetail?: InputMaybe<SortEnumType>;
  itemListShowDetailed?: InputMaybe<SortEnumType>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<SortEnumType>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<SortEnumType>;
  makeDocumentLinks?: InputMaybe<SortEnumType>;
  makeSerialStockCheck?: InputMaybe<SortEnumType>;
  manualWorkOrderMaterial?: InputMaybe<SortEnumType>;
  middleSignatureTextOnPrint?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifierCharacterLabel?: InputMaybe<SortEnumType>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<SortEnumType>;
  mustFiscalize?: InputMaybe<SortEnumType>;
  newNewDocumentInputType?: InputMaybe<SortEnumType>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<SortEnumType>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<SortEnumType>;
  palletEntry?: InputMaybe<SortEnumType>;
  partialDeliveryStatus?: InputMaybe<SortEnumType>;
  pdfSignWithoutGeneration?: InputMaybe<SortEnumType>;
  pickingShowConfirmationOnPick?: InputMaybe<SortEnumType>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<SortEnumType>;
  printDocumentTitleOverride?: InputMaybe<SortEnumType>;
  printTicketNameOverride?: InputMaybe<SortEnumType>;
  prioritisePackageQuantityEntryField?: InputMaybe<SortEnumType>;
  quantityDecimalPlaces?: InputMaybe<SortEnumType>;
  read?: InputMaybe<SortEnumType>;
  recommendToMakeCodebooksOffline?: InputMaybe<SortEnumType>;
  requireASignature?: InputMaybe<SortEnumType>;
  reverseItemsList?: InputMaybe<SortEnumType>;
  saveUnsignedAsSignedPDF?: InputMaybe<SortEnumType>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<SortEnumType>;
  sendLeftoverShadowsWithZero?: InputMaybe<SortEnumType>;
  serialNumberDirectionIsInput?: InputMaybe<SortEnumType>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeliveryOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDescrOnPDFs?: InputMaybe<SortEnumType>;
  showAcDoc1?: InputMaybe<SortEnumType>;
  showAcDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAcDoc2?: InputMaybe<SortEnumType>;
  showAcDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAcIdentOnPrint?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<SortEnumType>;
  showAdDate?: InputMaybe<SortEnumType>;
  showAdDateDoc1?: InputMaybe<SortEnumType>;
  showAdDateDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAdDateDoc2?: InputMaybe<SortEnumType>;
  showAdDateDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<SortEnumType>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<SortEnumType>;
  showAllItemsIgnoringWarehouse?: InputMaybe<SortEnumType>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<SortEnumType>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<SortEnumType>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<SortEnumType>;
  showAttachSSCCButton?: InputMaybe<SortEnumType>;
  showBuyerOnWorkOrders?: InputMaybe<SortEnumType>;
  showContactEmailEntry?: InputMaybe<SortEnumType>;
  showContactEntry?: InputMaybe<SortEnumType>;
  showCostBearerOnWorkOrders?: InputMaybe<SortEnumType>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<SortEnumType>;
  showCustomerOverview?: InputMaybe<SortEnumType>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<SortEnumType>;
  showDMSXMLItems?: InputMaybe<SortEnumType>;
  showDeliveryDeadlineDays?: InputMaybe<SortEnumType>;
  showDeliveryMethod?: InputMaybe<SortEnumType>;
  showDepartmentAsReceiver?: InputMaybe<SortEnumType>;
  showDepartmentOutAsReceiver?: InputMaybe<SortEnumType>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<SortEnumType>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<SortEnumType>;
  showInventoryNumberOnWorkOrders?: InputMaybe<SortEnumType>;
  showItalianLabelsOnPrint?: InputMaybe<SortEnumType>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<SortEnumType>;
  showItemAnNetWeightOnPrint?: InputMaybe<SortEnumType>;
  showItemPicturesOnPrint?: InputMaybe<SortEnumType>;
  showLastNOrdersForCustomer?: InputMaybe<SortEnumType>;
  showLineNoteOnPrint?: InputMaybe<SortEnumType>;
  showModifierCharacterPicker?: InputMaybe<SortEnumType>;
  showNumberOfUnlinkedDocuments?: InputMaybe<SortEnumType>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<SortEnumType>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<SortEnumType>;
  showPackageQuantityEntryField?: InputMaybe<SortEnumType>;
  showPaymentMethod?: InputMaybe<SortEnumType>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<SortEnumType>;
  showQuantityTotalOnPrint?: InputMaybe<SortEnumType>;
  showReceiverOnWorkOrders?: InputMaybe<SortEnumType>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<SortEnumType>;
  showWOWorkersEntry?: InputMaybe<SortEnumType>;
  skipConfirmationOnShortcuts?: InputMaybe<SortEnumType>;
  skipGS1BarcodeCheck?: InputMaybe<SortEnumType>;
  stockViewLoadAllOnOpen?: InputMaybe<SortEnumType>;
  stockViewShowOnlyInStock?: InputMaybe<SortEnumType>;
  storeContactEmailArbitraryInField?: InputMaybe<SortEnumType>;
  subjectDocumentListDocumentType?: InputMaybe<SortEnumType>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  syncPackagingWhenAddingNewItem?: InputMaybe<SortEnumType>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<SortEnumType>;
  tMNAcDefaultStatus?: InputMaybe<SortEnumType>;
  tMNAcDefaultSubject?: InputMaybe<SortEnumType>;
  tMNAnClassifIcationQid?: InputMaybe<SortEnumType>;
  tMNAnMailBoxQid?: InputMaybe<SortEnumType>;
  tMNAnStorageQid?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSize?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<SortEnumType>;
  thermalPrintShowCompanyImage?: InputMaybe<SortEnumType>;
  transferAcDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAcDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<SortEnumType>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<SortEnumType>;
  treatIdentAsBarcode?: InputMaybe<SortEnumType>;
  update?: InputMaybe<SortEnumType>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<SortEnumType>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<SortEnumType>;
  useDeadlineDateOnOverview?: InputMaybe<SortEnumType>;
  useLinkSettings?: InputMaybe<SortEnumType>;
  useSquareArticlePicker?: InputMaybe<SortEnumType>;
  useVerySmallMobileInterface?: InputMaybe<SortEnumType>;
  visualAttributes?: InputMaybe<SortEnumType>;
  visualAttributesOverview?: InputMaybe<SortEnumType>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  warehouseName?: InputMaybe<SortEnumType>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<SortEnumType>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<SortEnumType>;
  warehouseShowPrices?: InputMaybe<SortEnumType>;
  warehouseViewFixedAcSubject?: InputMaybe<SortEnumType>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<SortEnumType>;
  workOrderCanBeUnlocked?: InputMaybe<SortEnumType>;
  workOrderPrintSpecificationDuration?: InputMaybe<SortEnumType>;
  workOrderSpecificationPrefillTime?: InputMaybe<SortEnumType>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<SortEnumType>;
  workOrderUnlockableStatus?: InputMaybe<SortEnumType>;
};

export type DocumentTypePair = {
  acDocsOrderingOnPDF?: Maybe<Scalars['String']>;
  acFieldSFLabel?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName?: Maybe<Scalars['String']>;
  acLinkDocName1?: Maybe<Scalars['String']>;
  acLinkDocName2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acName3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acSetOfsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  acStatusIn?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acWorkPlace?: Maybe<Scalars['String']>;
  acceptedByFieldOnPrint?: Maybe<Scalars['String']>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  adDateDoc1EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc1PDFLabel?: Maybe<Scalars['String']>;
  adDateDoc2EntryIsTimeOnly?: Maybe<Scalars['Boolean']>;
  adDateDoc2PDFLabel?: Maybe<Scalars['String']>;
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  adminAllowChangingItemPrice: Scalars['Boolean'];
  adminCanEditDocumentAfterSaving: Scalars['Boolean'];
  adminDefaultAcPriceRate?: Maybe<Scalars['String']>;
  adminDeleteItemsAfterDocumentIsSaved: Scalars['Boolean'];
  adminDocumentOnCreateMakeWarehouseReservation: Scalars['Boolean'];
  adminEmphasizeInStock: Scalars['Boolean'];
  adminForceAcPriceRate?: Maybe<Scalars['String']>;
  adminIgnoreRebate1: Scalars['Boolean'];
  adminIgnoreRebate2: Scalars['Boolean'];
  adminIgnoreRebate3: Scalars['Boolean'];
  adminItemQuantityMustBeInStock: Scalars['Boolean'];
  adminSavedRebatesForFinalRebate: Scalars['Boolean'];
  adminSendDocumentToCompanyDocumentEmail: Scalars['Boolean'];
  adminSerialNumbersAreNotAutomated?: Maybe<Scalars['Boolean']>;
  adminShowDailyIncome: Scalars['Boolean'];
  adminShowSubjectAdd: Scalars['Boolean'];
  adminUseAnWsPrice: Scalars['Boolean'];
  adminUseGenericDocumentsForMoveAndOrder: Scalars['Boolean'];
  adminUseSerialNumberForItems: Scalars['Boolean'];
  allowChangingWarehouse?: Maybe<Scalars['Boolean']>;
  allowDMSCRUDOnlyForUsersFiles?: Maybe<Scalars['Boolean']>;
  allowDMSConfirmation?: Maybe<Scalars['Boolean']>;
  allowDMSReclassification?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemArticlePicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemCostBearerPicking?: Maybe<Scalars['Boolean']>;
  allowDMSXMLItemDepartmentPicking?: Maybe<Scalars['Boolean']>;
  allowGenericDocumentTypeImageAttachments?: Maybe<Scalars['Boolean']>;
  allowManualVerifyFromDocumentOverview?: Maybe<Scalars['Boolean']>;
  allowModifyExistingDocuments: Scalars['Boolean'];
  allowPullingDMSEInvoicesFromService?: Maybe<Scalars['Boolean']>;
  allowSavingGeodecodedLocation?: Maybe<Scalars['Boolean']>;
  allowSelectingMultipleDocumentsToCreateFrom?: Maybe<Scalars['Boolean']>;
  allowSigningAfterDocumentIsSaved?: Maybe<Scalars['Boolean']>;
  alwaysShowTheseAcSetOfItem?: Maybe<Scalars['String']>;
  alwaysUpdatePriceAndRebateFromClient?: Maybe<Scalars['Boolean']>;
  appendToItemIfExists?: Maybe<Scalars['Boolean']>;
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  arbitraryField1Label?: Maybe<Scalars['String']>;
  arbitraryField1Location?: Maybe<Scalars['String']>;
  arbitraryField1Value?: Maybe<Scalars['String']>;
  arbitraryFields: Array<DocumentTypeArbitraryField>;
  articleDontShowPriceAnyWhere: Scalars['Boolean'];
  articleDontShowStockAnyWhere: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchInitiallyLoadAll: Scalars['Boolean'];
  articleSearchRepeatLastSearch: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  articleSearchShowOnlyWhereAcClassifIsIn?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsAIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsBIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsCIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsDIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsEIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsFIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsGIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsHIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsIIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcFieldsJIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: Maybe<Scalars['String']>;
  articleSearchShowOnlyWhereAdFielddAIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddBIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddCIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAdFielddDIs?: Maybe<Scalars['DateTime']>;
  articleSearchShowOnlyWhereAnFieldnAIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnBIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnCIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnDIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnEIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnFIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnGIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnHIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnIIs?: Maybe<Scalars['Decimal']>;
  articleSearchShowOnlyWhereAnFieldnJIs?: Maybe<Scalars['Decimal']>;
  bluetoothPrintCopiesNumber: Scalars['Int'];
  cacheDuration: Scalars['Int'];
  cacheUseCacheForAnyResource: Scalars['Boolean'];
  cacheUseForArticleSearch: Scalars['Boolean'];
  cacheUseForCustomerSearch: Scalars['Boolean'];
  cacheUseForWarehouseSearch: Scalars['Boolean'];
  cardPaymentProvider?: Maybe<CardPaymentProvider>;
  changeDocumentStatusAfterCreated?: Maybe<Scalars['String']>;
  changeSourceDocumentStatusTo?: Maybe<Scalars['String']>;
  classifs2WhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  classifsWhichDontRequireScanningForPicking?: Maybe<Scalars['String']>;
  clerkFieldOnPrint?: Maybe<Scalars['String']>;
  companyEmailDefaultEmail?: Maybe<Scalars['String']>;
  companyEmailPDFBCC?: Maybe<Scalars['String']>;
  companyEmailPDFCC?: Maybe<Scalars['String']>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: Maybe<Scalars['Boolean']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completeDeliveryStatus?: Maybe<Scalars['String']>;
  copyOnlyLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  copyOnlyThoseWithLeftOverQuantity0?: Maybe<Scalars['Boolean']>;
  copyingFromAnotherIsAShadowCopy?: Maybe<Scalars['Boolean']>;
  create: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  customContractPriceFilter?: Maybe<Scalars['Boolean']>;
  customerCodeAllowedKeys?: Maybe<Scalars['String']>;
  customerCodeFromAcSkis?: Maybe<Scalars['Boolean']>;
  customerCodeIsGenerated?: Maybe<Scalars['Boolean']>;
  dMSListFilterOnDefaultClassification?: Maybe<Scalars['Boolean']>;
  dateFilterType?: Maybe<DateFilterType>;
  defaultCustomerType?: Maybe<Scalars['String']>;
  defaultCustomerTypeFilter?: Maybe<Scalars['String']>;
  defaultMoveDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultMoveDocumentSortField?: Maybe<THeMovePagedSortField>;
  defaultOrderDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultOrderDocumentSortField?: Maybe<THeOrderPagedSortField>;
  defaultPaymentMethod?: Maybe<Scalars['String']>;
  defaultQuantity?: Maybe<Scalars['Decimal']>;
  defaultSubjectDaysForPaymentOnAdd?: Maybe<Scalars['Int']>;
  defaultSubjectPaymentMethodOnAdd?: Maybe<Scalars['String']>;
  defaultToThisCustomer?: Maybe<Scalars['String']>;
  defaultWoexDocumentSortAscending?: Maybe<Scalars['Boolean']>;
  defaultWoexDocumentSortField?: Maybe<THfWoexPagedSortField>;
  delete: Scalars['Boolean'];
  deliveryIsRequired?: Maybe<Scalars['Boolean']>;
  disableUsingShadowItemAsItemBase?: Maybe<Scalars['Boolean']>;
  disallowChangingCustomer: Scalars['Boolean'];
  disallowChangingItemQuantityOnSerialInput?: Maybe<Scalars['Boolean']>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: Maybe<Scalars['Boolean']>;
  disallowManualWarehouseSearch?: Maybe<Scalars['Boolean']>;
  disallowPickingCustomer: Scalars['Boolean'];
  dmsAcStatusIn?: Maybe<Scalars['String']>;
  doNotFilterDailyRecapByUserId?: Maybe<Scalars['Boolean']>;
  documentLinkType?: Maybe<Scalars['String']>;
  documentLinkTypeA?: Maybe<Scalars['String']>;
  documentLinkTypeB?: Maybe<Scalars['String']>;
  documentNote?: Maybe<Scalars['String']>;
  documentOnCreateMakeA4Print?: Maybe<Scalars['Boolean']>;
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  documentTopAdditionalText?: Maybe<Scalars['String']>;
  dontSaveIndividualPDFPages?: Maybe<Scalars['Boolean']>;
  existingInventoryCheckDays?: Maybe<Scalars['Int']>;
  fillReferentLineWithUserOnPrint?: Maybe<Scalars['Boolean']>;
  filterByAcDelivery: Scalars['Boolean'];
  filterByAcDept?: Maybe<Scalars['String']>;
  filterByAcDeptOut?: Maybe<Scalars['String']>;
  filterByAcType?: Maybe<Scalars['String']>;
  filterByAcVerifiedPrices?: Maybe<Scalars['String']>;
  filterByAcVerifyStatus?: Maybe<Scalars['String']>;
  filterByCurrentUserIdIsAnSigner1?: Maybe<Scalars['Boolean']>;
  filterByUserOnAcIssuer: Scalars['Boolean'];
  filterByUserOnAcReceiver: Scalars['Boolean'];
  filterMovesByThisAcIssuer?: Maybe<Scalars['String']>;
  filterMovesByThisAcReceiver?: Maybe<Scalars['String']>;
  filterOrdersByThisAcWarehouse?: Maybe<Scalars['String']>;
  filterReceiversByAcFieldSa?: Maybe<Scalars['String']>;
  forceShowAvailableOnStock: Scalars['Boolean'];
  from?: Maybe<DocumentType>;
  fromId: Scalars['Int'];
  functionality: DocumentPairFunctionalityEnum;
  generatePrintTimeOnCreate: Scalars['Boolean'];
  groupAllCreatingDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupAllDocumentTypesAtThisPoint: Scalars['Boolean'];
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated: Scalars['Boolean'];
  headerClerkPDFLabel?: Maybe<Scalars['String']>;
  hideAcceptedByFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideClerkFieldOnPrint?: Maybe<Scalars['Boolean']>;
  hideCurrencyDateOnPrint?: Maybe<Scalars['Boolean']>;
  hideDMSMetadataEntryFields?: Maybe<Scalars['Boolean']>;
  hideDataForPaymentOnPrint?: Maybe<Scalars['Boolean']>;
  hideDocumentElements?: Maybe<Scalars['String']>;
  hideDocumentItemElements?: Maybe<Scalars['String']>;
  hideLeftOverQuantityOnPicking?: Maybe<Scalars['Boolean']>;
  hideNoteInNonHistoricalView?: Maybe<Scalars['Boolean']>;
  hidePayMethodOnPrint?: Maybe<Scalars['Boolean']>;
  hideQuantityEntry?: Maybe<Scalars['Boolean']>;
  hideVATRecapitulationOnPrint?: Maybe<Scalars['Boolean']>;
  hideWarehouseItemActions?: Maybe<Scalars['Boolean']>;
  hideWarehouseOverview?: Maybe<Scalars['Boolean']>;
  hideWarehouseSupplier?: Maybe<Scalars['Boolean']>;
  hideWorkOrderImages?: Maybe<Scalars['Boolean']>;
  hideWorkOrderMaterials?: Maybe<Scalars['Boolean']>;
  hideWorkOrderPlaceFromTo?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReception?: Maybe<Scalars['Boolean']>;
  hideWorkOrderReclamations?: Maybe<Scalars['Boolean']>;
  hideWorkOrderServices?: Maybe<Scalars['Boolean']>;
  hideWorkOrderSpecications?: Maybe<Scalars['Boolean']>;
  highlightArticlePickerTextOnNextOpen?: Maybe<Scalars['Boolean']>;
  historyViewIgnoredFilters?: Maybe<Scalars['String']>;
  horizontalDoc12AndDates?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  ifAcPayMethodChooseThisDocumentType?: Maybe<Scalars['String']>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: Maybe<Scalars['Boolean']>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: Maybe<Scalars['Boolean']>;
  ignoreQuantityInWholeDocument?: Maybe<Scalars['Boolean']>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: Maybe<Scalars['Boolean']>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: Maybe<Scalars['Boolean']>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isRetail?: Maybe<Scalars['Boolean']>;
  itemListShowDetailed: Scalars['Boolean'];
  jumpToEditAfterScanningItemWithBarcode: Scalars['Boolean'];
  keepAdDateDoc1And2Unrounded?: Maybe<Scalars['Boolean']>;
  labelDefinitionLocations: Array<LabelDefinitionLocation>;
  makeDocumentLinks?: Maybe<Scalars['Boolean']>;
  makeSerialStockCheck?: Maybe<Scalars['Boolean']>;
  manualWorkOrderMaterial?: Maybe<Scalars['String']>;
  middleSignatureTextOnPrint?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  modifierCharacterLabel?: Maybe<Scalars['String']>;
  multipleEndDocumentsCaseToPickEndDocument?: Maybe<Scalars['String']>;
  mustFiscalize?: Maybe<Scalars['Boolean']>;
  newNewDocumentInputType?: Maybe<Scalars['Boolean']>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: Maybe<Scalars['Boolean']>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: Maybe<Scalars['Boolean']>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: Maybe<Scalars['Boolean']>;
  palletEntry?: Maybe<Scalars['Boolean']>;
  partialDeliveryStatus?: Maybe<Scalars['String']>;
  pdfSignWithoutGeneration?: Maybe<Scalars['Boolean']>;
  pickingShowConfirmationOnPick: Scalars['Boolean'];
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: Maybe<Scalars['Boolean']>;
  printDocumentTitleOverride?: Maybe<Scalars['String']>;
  printTicketNameOverride?: Maybe<Scalars['String']>;
  prioritisePackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  quantityDecimalPlaces: Scalars['Int'];
  read: Scalars['Boolean'];
  recommendToMakeCodebooksOffline?: Maybe<Scalars['Boolean']>;
  requireASignature: Scalars['Boolean'];
  reverseItemsList?: Maybe<Scalars['Boolean']>;
  saveUnsignedAsSignedPDF?: Maybe<Scalars['Boolean']>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: Maybe<Scalars['Boolean']>;
  sendLeftoverShadowsWithZero?: Maybe<Scalars['Boolean']>;
  serialNumberDirectionIsInput?: Maybe<Scalars['Boolean']>;
  showAcDeliveryMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDeliveryOnDocumentList: Scalars['Boolean'];
  showAcDeptMobileFilterOnDocumentList: Scalars['Boolean'];
  showAcDescrOnPDFs?: Maybe<Scalars['Boolean']>;
  showAcDoc1?: Maybe<Scalars['Boolean']>;
  showAcDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAcDoc2?: Maybe<Scalars['Boolean']>;
  showAcDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAcIdentOnPrint?: Maybe<Scalars['Boolean']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: Maybe<Scalars['String']>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: Maybe<Scalars['String']>;
  showAdDate?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1?: Maybe<Scalars['Boolean']>;
  showAdDateDoc1OnPrint?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2?: Maybe<Scalars['Boolean']>;
  showAdDateDoc2OnPrint?: Maybe<Scalars['Boolean']>;
  showAllDMSDocumentsForURAClassifications?: Maybe<Scalars['Boolean']>;
  showAllDocumentsNotOnlyAnUserIns?: Maybe<Scalars['Boolean']>;
  showAllItemsIgnoringWarehouse?: Maybe<Scalars['Boolean']>;
  showAnClerkAndAnNoteClerkIsOROperation?: Maybe<Scalars['Boolean']>;
  showArticlesGroupedByCodeButSeparate?: Maybe<Scalars['Boolean']>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: Maybe<Scalars['Boolean']>;
  showAttachSSCCButton?: Maybe<Scalars['Boolean']>;
  showBuyerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showContactEmailEntry?: Maybe<Scalars['Boolean']>;
  showContactEntry?: Maybe<Scalars['Boolean']>;
  showCostBearerOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showCustomerName2AsPrimaryOnHeader?: Maybe<Scalars['Boolean']>;
  showCustomerOverview?: Maybe<Scalars['Boolean']>;
  showCustomersAcName2OnThermalPrint?: Maybe<Scalars['Boolean']>;
  showDMSXMLItems?: Maybe<Scalars['Boolean']>;
  showDeliveryDeadlineDays: Scalars['Boolean'];
  showDeliveryMethod: Scalars['Boolean'];
  showDepartmentAsReceiver: Scalars['Boolean'];
  showDepartmentOutAsReceiver: Scalars['Boolean'];
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: Maybe<Scalars['String']>;
  showDoc12AndTheirDatesOnDocumentList?: Maybe<Scalars['Boolean']>;
  showInventoryNumberOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showItalianLabelsOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAcCustomsTariffOnPrint?: Maybe<Scalars['Boolean']>;
  showItemAnNetWeightOnPrint?: Maybe<Scalars['Boolean']>;
  showItemPicturesOnPrint?: Maybe<Scalars['Boolean']>;
  showLastNOrdersForCustomer?: Maybe<Scalars['Int']>;
  showLineNoteOnPrint: Scalars['Boolean'];
  showModifierCharacterPicker: Scalars['Boolean'];
  showNumberOfUnlinkedDocuments?: Maybe<Scalars['Boolean']>;
  showOnlyArticlesWithCustomerContractPrice: Scalars['Boolean'];
  showOnlyDMSDocumentsAssignedToMe?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: Maybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: Maybe<Scalars['Boolean']>;
  showOnlyWOWhereCurrentUserSpecExists?: Maybe<Scalars['Boolean']>;
  showPackageQuantityEntryField?: Maybe<Scalars['Boolean']>;
  showPaymentMethod: Scalars['Boolean'];
  showQuantityPerUnitOfMeasureOnPrint?: Maybe<Scalars['Boolean']>;
  showQuantityTotalOnPrint?: Maybe<Scalars['Boolean']>;
  showReceiverOnWorkOrders?: Maybe<Scalars['Boolean']>;
  showSerialNumberSearchForWorkOrders?: Maybe<Scalars['Boolean']>;
  showWOWorkersEntry?: Maybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  skipGS1BarcodeCheck: Scalars['Boolean'];
  stockViewLoadAllOnOpen: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  storeContactEmailArbitraryInField?: Maybe<Scalars['String']>;
  subjectDocumentListDocumentType?: Maybe<Scalars['String']>;
  subjectFieldForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  subjectFieldValueForSSCCRequirementCheck?: Maybe<Scalars['String']>;
  syncPackagingWhenAddingNewItem: Scalars['Boolean'];
  tHrPrsnForOnlyOnixPhoneUsers?: Maybe<Scalars['Boolean']>;
  tMNAcDefaultStatus?: Maybe<Scalars['String']>;
  tMNAcDefaultSubject?: Maybe<Scalars['String']>;
  tMNAnClassifIcationQid?: Maybe<Scalars['Int']>;
  tMNAnMailBoxQid?: Maybe<Scalars['Int']>;
  tMNAnStorageQid?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSize?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeHeight?: Maybe<Scalars['Int']>;
  thermalPrintCompanyNameFontSizeWidth?: Maybe<Scalars['Int']>;
  thermalPrintShowCompanyImage: Scalars['Boolean'];
  to?: Maybe<DocumentType>;
  toId: Scalars['Int'];
  transferAcDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAcDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc1WhenCopying?: Maybe<Scalars['Boolean']>;
  transferAdDateDoc2WhenCopying?: Maybe<Scalars['Boolean']>;
  transferEnteredItemQuantityToSerialNumber?: Maybe<Scalars['Boolean']>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: Maybe<Scalars['Boolean']>;
  treatIdentAsBarcode?: Maybe<Scalars['Boolean']>;
  update: Scalars['Boolean'];
  updateHeadAndDeleteAllItemsOnCopy?: Maybe<Scalars['Boolean']>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: Maybe<Scalars['Boolean']>;
  useDeadlineDateOnOverview: Scalars['Boolean'];
  useSquareArticlePicker?: Maybe<Scalars['Boolean']>;
  useVerySmallMobileInterface?: Maybe<Scalars['Boolean']>;
  visualAttributes?: Maybe<Scalars['String']>;
  visualAttributesOverview?: Maybe<Scalars['String']>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: Maybe<Scalars['Boolean']>;
  warehouseName?: Maybe<Scalars['String']>;
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  warehousePositionTHeSetItemFieldName?: Maybe<Scalars['String']>;
  warehouseShowPrices?: Maybe<Scalars['Boolean']>;
  warehouseViewFixedAcSubject?: Maybe<Scalars['String']>;
  whenAddingSubjectSetAnClerkToCurrentUser?: Maybe<Scalars['Boolean']>;
  workOrderCanBeUnlocked?: Maybe<Scalars['Boolean']>;
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
  workOrderSpecificationPrefillTime?: Maybe<Scalars['Boolean']>;
  workOrderSpecificationTimeNotRequired?: Maybe<Scalars['Boolean']>;
  workOrderUnlockableStatus?: Maybe<Scalars['String']>;
};


export type DocumentTypePairArbitraryFieldsArgs = {
  order?: InputMaybe<Array<DocumentTypeArbitraryFieldSortInput>>;
};

export type DocumentTypePairFilterInput = {
  acDocsOrderingOnPDF?: InputMaybe<StringOperationFilterInput>;
  acFieldSFLabel?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName1?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acName3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  acStatusIn?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  acceptedByFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc1PDFLabel?: InputMaybe<StringOperationFilterInput>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<BooleanOperationFilterInput>;
  adDateDoc2PDFLabel?: InputMaybe<StringOperationFilterInput>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<BooleanOperationFilterInput>;
  adminAllowChangingItemPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminCanEditDocumentAfterSaving?: InputMaybe<BooleanOperationFilterInput>;
  adminDefaultAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<BooleanOperationFilterInput>;
  adminEmphasizeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminForceAcPriceRate?: InputMaybe<StringOperationFilterInput>;
  adminIgnoreRebate1?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate2?: InputMaybe<BooleanOperationFilterInput>;
  adminIgnoreRebate3?: InputMaybe<BooleanOperationFilterInput>;
  adminItemQuantityMustBeInStock?: InputMaybe<BooleanOperationFilterInput>;
  adminSavedRebatesForFinalRebate?: InputMaybe<BooleanOperationFilterInput>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<BooleanOperationFilterInput>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<BooleanOperationFilterInput>;
  adminShowDailyIncome?: InputMaybe<BooleanOperationFilterInput>;
  adminShowSubjectAdd?: InputMaybe<BooleanOperationFilterInput>;
  adminUseAnWsPrice?: InputMaybe<BooleanOperationFilterInput>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<BooleanOperationFilterInput>;
  adminUseSerialNumberForItems?: InputMaybe<BooleanOperationFilterInput>;
  allowChangingWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSConfirmation?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSReclassification?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemArticlePicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<BooleanOperationFilterInput>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<BooleanOperationFilterInput>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<BooleanOperationFilterInput>;
  allowModifyExistingDocuments?: InputMaybe<BooleanOperationFilterInput>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<BooleanOperationFilterInput>;
  allowSavingGeodecodedLocation?: InputMaybe<BooleanOperationFilterInput>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<BooleanOperationFilterInput>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<BooleanOperationFilterInput>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<StringOperationFilterInput>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DocumentTypePairFilterInput>>;
  appendToItemIfExists?: InputMaybe<BooleanOperationFilterInput>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Label?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Location?: InputMaybe<StringOperationFilterInput>;
  arbitraryField1Value?: InputMaybe<StringOperationFilterInput>;
  arbitraryFields?: InputMaybe<ListFilterInputTypeOfDocumentTypeArbitraryFieldFilterInput>;
  articleDontShowPriceAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleDontShowStockAnyWhere?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchAllowSearchingByClassification?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchInitiallyLoadAll?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchRepeatLastSearch?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<StringOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bluetoothPrintCopiesNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheDuration?: InputMaybe<ComparableInt32OperationFilterInput>;
  cacheUseCacheForAnyResource?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForArticleSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForCustomerSearch?: InputMaybe<BooleanOperationFilterInput>;
  cacheUseForWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  cardPaymentProvider?: InputMaybe<NullableOfCardPaymentProviderOperationFilterInput>;
  changeDocumentStatusAfterCreated?: InputMaybe<StringOperationFilterInput>;
  changeSourceDocumentStatusTo?: InputMaybe<StringOperationFilterInput>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<StringOperationFilterInput>;
  clerkFieldOnPrint?: InputMaybe<StringOperationFilterInput>;
  companyEmailDefaultEmail?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFBCC?: InputMaybe<StringOperationFilterInput>;
  companyEmailPDFCC?: InputMaybe<StringOperationFilterInput>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completeDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  copyOnlyLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<BooleanOperationFilterInput>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<BooleanOperationFilterInput>;
  create?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customContractPriceFilter?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeAllowedKeys?: InputMaybe<StringOperationFilterInput>;
  customerCodeFromAcSkis?: InputMaybe<BooleanOperationFilterInput>;
  customerCodeIsGenerated?: InputMaybe<BooleanOperationFilterInput>;
  dMSListFilterOnDefaultClassification?: InputMaybe<BooleanOperationFilterInput>;
  dateFilterType?: InputMaybe<NullableOfDateFilterTypeOperationFilterInput>;
  defaultCustomerType?: InputMaybe<StringOperationFilterInput>;
  defaultCustomerTypeFilter?: InputMaybe<StringOperationFilterInput>;
  defaultMoveDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultMoveDocumentSortField?: InputMaybe<NullableOfTHeMovePagedSortFieldOperationFilterInput>;
  defaultOrderDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultOrderDocumentSortField?: InputMaybe<NullableOfTHeOrderPagedSortFieldOperationFilterInput>;
  defaultPaymentMethod?: InputMaybe<StringOperationFilterInput>;
  defaultQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<StringOperationFilterInput>;
  defaultToThisCustomer?: InputMaybe<StringOperationFilterInput>;
  defaultWoexDocumentSortAscending?: InputMaybe<BooleanOperationFilterInput>;
  defaultWoexDocumentSortField?: InputMaybe<NullableOfTHfWoexPagedSortFieldOperationFilterInput>;
  delete?: InputMaybe<BooleanOperationFilterInput>;
  deliveryIsRequired?: InputMaybe<BooleanOperationFilterInput>;
  disableUsingShadowItemAsItemBase?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<BooleanOperationFilterInput>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<BooleanOperationFilterInput>;
  disallowManualWarehouseSearch?: InputMaybe<BooleanOperationFilterInput>;
  disallowPickingCustomer?: InputMaybe<BooleanOperationFilterInput>;
  dmsAcStatusIn?: InputMaybe<StringOperationFilterInput>;
  doNotFilterDailyRecapByUserId?: InputMaybe<BooleanOperationFilterInput>;
  documentLinkType?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeA?: InputMaybe<StringOperationFilterInput>;
  documentLinkTypeB?: InputMaybe<StringOperationFilterInput>;
  documentNote?: InputMaybe<StringOperationFilterInput>;
  documentOnCreateMakeA4Print?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<BooleanOperationFilterInput>;
  documentOnCreateMakePDF?: InputMaybe<BooleanOperationFilterInput>;
  documentTopAdditionalText?: InputMaybe<StringOperationFilterInput>;
  dontSaveIndividualPDFPages?: InputMaybe<BooleanOperationFilterInput>;
  existingInventoryCheckDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fillReferentLineWithUserOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDelivery?: InputMaybe<BooleanOperationFilterInput>;
  filterByAcDept?: InputMaybe<StringOperationFilterInput>;
  filterByAcDeptOut?: InputMaybe<StringOperationFilterInput>;
  filterByAcType?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  filterByAcVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<BooleanOperationFilterInput>;
  filterByUserOnAcIssuer?: InputMaybe<BooleanOperationFilterInput>;
  filterByUserOnAcReceiver?: InputMaybe<BooleanOperationFilterInput>;
  filterMovesByThisAcIssuer?: InputMaybe<StringOperationFilterInput>;
  filterMovesByThisAcReceiver?: InputMaybe<StringOperationFilterInput>;
  filterOrdersByThisAcWarehouse?: InputMaybe<StringOperationFilterInput>;
  filterReceiversByAcFieldSa?: InputMaybe<StringOperationFilterInput>;
  forceShowAvailableOnStock?: InputMaybe<BooleanOperationFilterInput>;
  from?: InputMaybe<DocumentTypeFilterInput>;
  fromId?: InputMaybe<ComparableInt32OperationFilterInput>;
  functionality?: InputMaybe<DocumentPairFunctionalityEnumOperationFilterInput>;
  generatePrintTimeOnCreate?: InputMaybe<BooleanOperationFilterInput>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<BooleanOperationFilterInput>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<BooleanOperationFilterInput>;
  headerClerkPDFLabel?: InputMaybe<StringOperationFilterInput>;
  hideAcceptedByFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideClerkFieldOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideCurrencyDateOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDMSMetadataEntryFields?: InputMaybe<BooleanOperationFilterInput>;
  hideDataForPaymentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideDocumentElements?: InputMaybe<StringOperationFilterInput>;
  hideDocumentItemElements?: InputMaybe<StringOperationFilterInput>;
  hideLeftOverQuantityOnPicking?: InputMaybe<BooleanOperationFilterInput>;
  hideNoteInNonHistoricalView?: InputMaybe<BooleanOperationFilterInput>;
  hidePayMethodOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideQuantityEntry?: InputMaybe<BooleanOperationFilterInput>;
  hideVATRecapitulationOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseItemActions?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseOverview?: InputMaybe<BooleanOperationFilterInput>;
  hideWarehouseSupplier?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderImages?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderMaterials?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderPlaceFromTo?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReception?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderReclamations?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderServices?: InputMaybe<BooleanOperationFilterInput>;
  hideWorkOrderSpecications?: InputMaybe<BooleanOperationFilterInput>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<BooleanOperationFilterInput>;
  historyViewIgnoredFilters?: InputMaybe<StringOperationFilterInput>;
  horizontalDoc12AndDates?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<StringOperationFilterInput>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<BooleanOperationFilterInput>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<BooleanOperationFilterInput>;
  ignoreQuantityInWholeDocument?: InputMaybe<BooleanOperationFilterInput>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  isRetail?: InputMaybe<BooleanOperationFilterInput>;
  itemListShowDetailed?: InputMaybe<BooleanOperationFilterInput>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<BooleanOperationFilterInput>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<BooleanOperationFilterInput>;
  labelDefinitionLocations?: InputMaybe<ListFilterInputTypeOfLabelDefinitionLocationFilterInput>;
  makeDocumentLinks?: InputMaybe<BooleanOperationFilterInput>;
  makeSerialStockCheck?: InputMaybe<BooleanOperationFilterInput>;
  manualWorkOrderMaterial?: InputMaybe<StringOperationFilterInput>;
  middleSignatureTextOnPrint?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifierCharacterLabel?: InputMaybe<StringOperationFilterInput>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<StringOperationFilterInput>;
  mustFiscalize?: InputMaybe<BooleanOperationFilterInput>;
  newNewDocumentInputType?: InputMaybe<BooleanOperationFilterInput>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<BooleanOperationFilterInput>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypePairFilterInput>>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<BooleanOperationFilterInput>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<BooleanOperationFilterInput>;
  palletEntry?: InputMaybe<BooleanOperationFilterInput>;
  partialDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  pdfSignWithoutGeneration?: InputMaybe<BooleanOperationFilterInput>;
  pickingShowConfirmationOnPick?: InputMaybe<BooleanOperationFilterInput>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  printDocumentTitleOverride?: InputMaybe<StringOperationFilterInput>;
  printTicketNameOverride?: InputMaybe<StringOperationFilterInput>;
  prioritisePackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  quantityDecimalPlaces?: InputMaybe<ComparableInt32OperationFilterInput>;
  read?: InputMaybe<BooleanOperationFilterInput>;
  recommendToMakeCodebooksOffline?: InputMaybe<BooleanOperationFilterInput>;
  requireASignature?: InputMaybe<BooleanOperationFilterInput>;
  reverseItemsList?: InputMaybe<BooleanOperationFilterInput>;
  saveUnsignedAsSignedPDF?: InputMaybe<BooleanOperationFilterInput>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<BooleanOperationFilterInput>;
  sendLeftoverShadowsWithZero?: InputMaybe<BooleanOperationFilterInput>;
  serialNumberDirectionIsInput?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeliveryOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showAcDescrOnPDFs?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAcDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcIdentOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<StringOperationFilterInput>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<StringOperationFilterInput>;
  showAdDate?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc1OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2?: InputMaybe<BooleanOperationFilterInput>;
  showAdDateDoc2OnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<BooleanOperationFilterInput>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<BooleanOperationFilterInput>;
  showAllItemsIgnoringWarehouse?: InputMaybe<BooleanOperationFilterInput>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<BooleanOperationFilterInput>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<BooleanOperationFilterInput>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<BooleanOperationFilterInput>;
  showAttachSSCCButton?: InputMaybe<BooleanOperationFilterInput>;
  showBuyerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showContactEmailEntry?: InputMaybe<BooleanOperationFilterInput>;
  showContactEntry?: InputMaybe<BooleanOperationFilterInput>;
  showCostBearerOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerOverview?: InputMaybe<BooleanOperationFilterInput>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<BooleanOperationFilterInput>;
  showDMSXMLItems?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryDeadlineDays?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryMethod?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDepartmentOutAsReceiver?: InputMaybe<BooleanOperationFilterInput>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<StringOperationFilterInput>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<BooleanOperationFilterInput>;
  showInventoryNumberOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showItalianLabelsOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemAnNetWeightOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showItemPicturesOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showLastNOrdersForCustomer?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  showLineNoteOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showModifierCharacterPicker?: InputMaybe<BooleanOperationFilterInput>;
  showNumberOfUnlinkedDocuments?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<BooleanOperationFilterInput>;
  showPackageQuantityEntryField?: InputMaybe<BooleanOperationFilterInput>;
  showPaymentMethod?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showQuantityTotalOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  showReceiverOnWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<BooleanOperationFilterInput>;
  showWOWorkersEntry?: InputMaybe<BooleanOperationFilterInput>;
  skipConfirmationOnShortcuts?: InputMaybe<BooleanOperationFilterInput>;
  skipGS1BarcodeCheck?: InputMaybe<BooleanOperationFilterInput>;
  stockViewLoadAllOnOpen?: InputMaybe<BooleanOperationFilterInput>;
  stockViewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  storeContactEmailArbitraryInField?: InputMaybe<StringOperationFilterInput>;
  subjectDocumentListDocumentType?: InputMaybe<StringOperationFilterInput>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<StringOperationFilterInput>;
  syncPackagingWhenAddingNewItem?: InputMaybe<BooleanOperationFilterInput>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<BooleanOperationFilterInput>;
  tMNAcDefaultStatus?: InputMaybe<StringOperationFilterInput>;
  tMNAcDefaultSubject?: InputMaybe<StringOperationFilterInput>;
  tMNAnClassifIcationQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnMailBoxQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tMNAnStorageQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSize?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thermalPrintShowCompanyImage?: InputMaybe<BooleanOperationFilterInput>;
  to?: InputMaybe<DocumentTypeFilterInput>;
  toId?: InputMaybe<ComparableInt32OperationFilterInput>;
  transferAcDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAcDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc1WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferAdDateDoc2WhenCopying?: InputMaybe<BooleanOperationFilterInput>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<BooleanOperationFilterInput>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<BooleanOperationFilterInput>;
  treatIdentAsBarcode?: InputMaybe<BooleanOperationFilterInput>;
  update?: InputMaybe<BooleanOperationFilterInput>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<BooleanOperationFilterInput>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<BooleanOperationFilterInput>;
  useDeadlineDateOnOverview?: InputMaybe<BooleanOperationFilterInput>;
  useSquareArticlePicker?: InputMaybe<BooleanOperationFilterInput>;
  useVerySmallMobileInterface?: InputMaybe<BooleanOperationFilterInput>;
  visualAttributes?: InputMaybe<StringOperationFilterInput>;
  visualAttributesOverview?: InputMaybe<StringOperationFilterInput>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<BooleanOperationFilterInput>;
  warehouseName?: InputMaybe<StringOperationFilterInput>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<BooleanOperationFilterInput>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<StringOperationFilterInput>;
  warehouseShowPrices?: InputMaybe<BooleanOperationFilterInput>;
  warehouseViewFixedAcSubject?: InputMaybe<StringOperationFilterInput>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<BooleanOperationFilterInput>;
  workOrderCanBeUnlocked?: InputMaybe<BooleanOperationFilterInput>;
  workOrderPrintSpecificationDuration?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationPrefillTime?: InputMaybe<BooleanOperationFilterInput>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<BooleanOperationFilterInput>;
  workOrderUnlockableStatus?: InputMaybe<StringOperationFilterInput>;
};

export type DocumentTypePairSortInput = {
  acDocsOrderingOnPDF?: InputMaybe<SortEnumType>;
  acFieldSFLabel?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerName?: InputMaybe<SortEnumType>;
  acLinkDocName1?: InputMaybe<SortEnumType>;
  acLinkDocName2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acName3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  acStatusIn?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  acceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc1PDFLabel?: InputMaybe<SortEnumType>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc2PDFLabel?: InputMaybe<SortEnumType>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<SortEnumType>;
  adminAllowChangingItemPrice?: InputMaybe<SortEnumType>;
  adminCanEditDocumentAfterSaving?: InputMaybe<SortEnumType>;
  adminDefaultAcPriceRate?: InputMaybe<SortEnumType>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<SortEnumType>;
  adminEmphasizeInStock?: InputMaybe<SortEnumType>;
  adminForceAcPriceRate?: InputMaybe<SortEnumType>;
  adminIgnoreRebate1?: InputMaybe<SortEnumType>;
  adminIgnoreRebate2?: InputMaybe<SortEnumType>;
  adminIgnoreRebate3?: InputMaybe<SortEnumType>;
  adminItemQuantityMustBeInStock?: InputMaybe<SortEnumType>;
  adminSavedRebatesForFinalRebate?: InputMaybe<SortEnumType>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<SortEnumType>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<SortEnumType>;
  adminShowDailyIncome?: InputMaybe<SortEnumType>;
  adminShowSubjectAdd?: InputMaybe<SortEnumType>;
  adminUseAnWsPrice?: InputMaybe<SortEnumType>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<SortEnumType>;
  adminUseSerialNumberForItems?: InputMaybe<SortEnumType>;
  allowChangingWarehouse?: InputMaybe<SortEnumType>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<SortEnumType>;
  allowDMSConfirmation?: InputMaybe<SortEnumType>;
  allowDMSReclassification?: InputMaybe<SortEnumType>;
  allowDMSXMLItemArticlePicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<SortEnumType>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<SortEnumType>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<SortEnumType>;
  allowModifyExistingDocuments?: InputMaybe<SortEnumType>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<SortEnumType>;
  allowSavingGeodecodedLocation?: InputMaybe<SortEnumType>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<SortEnumType>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<SortEnumType>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<SortEnumType>;
  appendToItemIfExists?: InputMaybe<SortEnumType>;
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  arbitraryField1Label?: InputMaybe<SortEnumType>;
  arbitraryField1Location?: InputMaybe<SortEnumType>;
  arbitraryField1Value?: InputMaybe<SortEnumType>;
  articleDontShowPriceAnyWhere?: InputMaybe<SortEnumType>;
  articleDontShowStockAnyWhere?: InputMaybe<SortEnumType>;
  articleSearchAllowSearchingByClassification?: InputMaybe<SortEnumType>;
  articleSearchInitiallyLoadAll?: InputMaybe<SortEnumType>;
  articleSearchRepeatLastSearch?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyInStock?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<SortEnumType>;
  bluetoothPrintCopiesNumber?: InputMaybe<SortEnumType>;
  cacheDuration?: InputMaybe<SortEnumType>;
  cacheUseCacheForAnyResource?: InputMaybe<SortEnumType>;
  cacheUseForArticleSearch?: InputMaybe<SortEnumType>;
  cacheUseForCustomerSearch?: InputMaybe<SortEnumType>;
  cacheUseForWarehouseSearch?: InputMaybe<SortEnumType>;
  cardPaymentProvider?: InputMaybe<SortEnumType>;
  changeDocumentStatusAfterCreated?: InputMaybe<SortEnumType>;
  changeSourceDocumentStatusTo?: InputMaybe<SortEnumType>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  clerkFieldOnPrint?: InputMaybe<SortEnumType>;
  companyEmailDefaultEmail?: InputMaybe<SortEnumType>;
  companyEmailPDFBCC?: InputMaybe<SortEnumType>;
  companyEmailPDFCC?: InputMaybe<SortEnumType>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  completeDeliveryStatus?: InputMaybe<SortEnumType>;
  copyOnlyLeftOverQuantity?: InputMaybe<SortEnumType>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<SortEnumType>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<SortEnumType>;
  create?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customContractPriceFilter?: InputMaybe<SortEnumType>;
  customerCodeAllowedKeys?: InputMaybe<SortEnumType>;
  customerCodeFromAcSkis?: InputMaybe<SortEnumType>;
  customerCodeIsGenerated?: InputMaybe<SortEnumType>;
  dMSListFilterOnDefaultClassification?: InputMaybe<SortEnumType>;
  dateFilterType?: InputMaybe<SortEnumType>;
  defaultCustomerType?: InputMaybe<SortEnumType>;
  defaultCustomerTypeFilter?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortField?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortField?: InputMaybe<SortEnumType>;
  defaultPaymentMethod?: InputMaybe<SortEnumType>;
  defaultQuantity?: InputMaybe<SortEnumType>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<SortEnumType>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<SortEnumType>;
  defaultToThisCustomer?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortField?: InputMaybe<SortEnumType>;
  delete?: InputMaybe<SortEnumType>;
  deliveryIsRequired?: InputMaybe<SortEnumType>;
  disableUsingShadowItemAsItemBase?: InputMaybe<SortEnumType>;
  disallowChangingCustomer?: InputMaybe<SortEnumType>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<SortEnumType>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<SortEnumType>;
  disallowManualWarehouseSearch?: InputMaybe<SortEnumType>;
  disallowPickingCustomer?: InputMaybe<SortEnumType>;
  dmsAcStatusIn?: InputMaybe<SortEnumType>;
  doNotFilterDailyRecapByUserId?: InputMaybe<SortEnumType>;
  documentLinkType?: InputMaybe<SortEnumType>;
  documentLinkTypeA?: InputMaybe<SortEnumType>;
  documentLinkTypeB?: InputMaybe<SortEnumType>;
  documentNote?: InputMaybe<SortEnumType>;
  documentOnCreateMakeA4Print?: InputMaybe<SortEnumType>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<SortEnumType>;
  documentOnCreateMakePDF?: InputMaybe<SortEnumType>;
  documentTopAdditionalText?: InputMaybe<SortEnumType>;
  dontSaveIndividualPDFPages?: InputMaybe<SortEnumType>;
  existingInventoryCheckDays?: InputMaybe<SortEnumType>;
  fillReferentLineWithUserOnPrint?: InputMaybe<SortEnumType>;
  filterByAcDelivery?: InputMaybe<SortEnumType>;
  filterByAcDept?: InputMaybe<SortEnumType>;
  filterByAcDeptOut?: InputMaybe<SortEnumType>;
  filterByAcType?: InputMaybe<SortEnumType>;
  filterByAcVerifiedPrices?: InputMaybe<SortEnumType>;
  filterByAcVerifyStatus?: InputMaybe<SortEnumType>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<SortEnumType>;
  filterByUserOnAcIssuer?: InputMaybe<SortEnumType>;
  filterByUserOnAcReceiver?: InputMaybe<SortEnumType>;
  filterMovesByThisAcIssuer?: InputMaybe<SortEnumType>;
  filterMovesByThisAcReceiver?: InputMaybe<SortEnumType>;
  filterOrdersByThisAcWarehouse?: InputMaybe<SortEnumType>;
  filterReceiversByAcFieldSa?: InputMaybe<SortEnumType>;
  forceShowAvailableOnStock?: InputMaybe<SortEnumType>;
  from?: InputMaybe<DocumentTypeSortInput>;
  fromId?: InputMaybe<SortEnumType>;
  functionality?: InputMaybe<SortEnumType>;
  generatePrintTimeOnCreate?: InputMaybe<SortEnumType>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<SortEnumType>;
  headerClerkPDFLabel?: InputMaybe<SortEnumType>;
  hideAcceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  hideClerkFieldOnPrint?: InputMaybe<SortEnumType>;
  hideCurrencyDateOnPrint?: InputMaybe<SortEnumType>;
  hideDMSMetadataEntryFields?: InputMaybe<SortEnumType>;
  hideDataForPaymentOnPrint?: InputMaybe<SortEnumType>;
  hideDocumentElements?: InputMaybe<SortEnumType>;
  hideDocumentItemElements?: InputMaybe<SortEnumType>;
  hideLeftOverQuantityOnPicking?: InputMaybe<SortEnumType>;
  hideNoteInNonHistoricalView?: InputMaybe<SortEnumType>;
  hidePayMethodOnPrint?: InputMaybe<SortEnumType>;
  hideQuantityEntry?: InputMaybe<SortEnumType>;
  hideVATRecapitulationOnPrint?: InputMaybe<SortEnumType>;
  hideWarehouseItemActions?: InputMaybe<SortEnumType>;
  hideWarehouseOverview?: InputMaybe<SortEnumType>;
  hideWarehouseSupplier?: InputMaybe<SortEnumType>;
  hideWorkOrderImages?: InputMaybe<SortEnumType>;
  hideWorkOrderMaterials?: InputMaybe<SortEnumType>;
  hideWorkOrderPlaceFromTo?: InputMaybe<SortEnumType>;
  hideWorkOrderReception?: InputMaybe<SortEnumType>;
  hideWorkOrderReclamations?: InputMaybe<SortEnumType>;
  hideWorkOrderServices?: InputMaybe<SortEnumType>;
  hideWorkOrderSpecications?: InputMaybe<SortEnumType>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<SortEnumType>;
  historyViewIgnoredFilters?: InputMaybe<SortEnumType>;
  horizontalDoc12AndDates?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<SortEnumType>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<SortEnumType>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<SortEnumType>;
  ignoreQuantityInWholeDocument?: InputMaybe<SortEnumType>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<SortEnumType>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<SortEnumType>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<SortEnumType>;
  isDisabled?: InputMaybe<SortEnumType>;
  isRetail?: InputMaybe<SortEnumType>;
  itemListShowDetailed?: InputMaybe<SortEnumType>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<SortEnumType>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<SortEnumType>;
  makeDocumentLinks?: InputMaybe<SortEnumType>;
  makeSerialStockCheck?: InputMaybe<SortEnumType>;
  manualWorkOrderMaterial?: InputMaybe<SortEnumType>;
  middleSignatureTextOnPrint?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifierCharacterLabel?: InputMaybe<SortEnumType>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<SortEnumType>;
  mustFiscalize?: InputMaybe<SortEnumType>;
  newNewDocumentInputType?: InputMaybe<SortEnumType>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<SortEnumType>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<SortEnumType>;
  palletEntry?: InputMaybe<SortEnumType>;
  partialDeliveryStatus?: InputMaybe<SortEnumType>;
  pdfSignWithoutGeneration?: InputMaybe<SortEnumType>;
  pickingShowConfirmationOnPick?: InputMaybe<SortEnumType>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<SortEnumType>;
  printDocumentTitleOverride?: InputMaybe<SortEnumType>;
  printTicketNameOverride?: InputMaybe<SortEnumType>;
  prioritisePackageQuantityEntryField?: InputMaybe<SortEnumType>;
  quantityDecimalPlaces?: InputMaybe<SortEnumType>;
  read?: InputMaybe<SortEnumType>;
  recommendToMakeCodebooksOffline?: InputMaybe<SortEnumType>;
  requireASignature?: InputMaybe<SortEnumType>;
  reverseItemsList?: InputMaybe<SortEnumType>;
  saveUnsignedAsSignedPDF?: InputMaybe<SortEnumType>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<SortEnumType>;
  sendLeftoverShadowsWithZero?: InputMaybe<SortEnumType>;
  serialNumberDirectionIsInput?: InputMaybe<SortEnumType>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeliveryOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDescrOnPDFs?: InputMaybe<SortEnumType>;
  showAcDoc1?: InputMaybe<SortEnumType>;
  showAcDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAcDoc2?: InputMaybe<SortEnumType>;
  showAcDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAcIdentOnPrint?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<SortEnumType>;
  showAdDate?: InputMaybe<SortEnumType>;
  showAdDateDoc1?: InputMaybe<SortEnumType>;
  showAdDateDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAdDateDoc2?: InputMaybe<SortEnumType>;
  showAdDateDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<SortEnumType>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<SortEnumType>;
  showAllItemsIgnoringWarehouse?: InputMaybe<SortEnumType>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<SortEnumType>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<SortEnumType>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<SortEnumType>;
  showAttachSSCCButton?: InputMaybe<SortEnumType>;
  showBuyerOnWorkOrders?: InputMaybe<SortEnumType>;
  showContactEmailEntry?: InputMaybe<SortEnumType>;
  showContactEntry?: InputMaybe<SortEnumType>;
  showCostBearerOnWorkOrders?: InputMaybe<SortEnumType>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<SortEnumType>;
  showCustomerOverview?: InputMaybe<SortEnumType>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<SortEnumType>;
  showDMSXMLItems?: InputMaybe<SortEnumType>;
  showDeliveryDeadlineDays?: InputMaybe<SortEnumType>;
  showDeliveryMethod?: InputMaybe<SortEnumType>;
  showDepartmentAsReceiver?: InputMaybe<SortEnumType>;
  showDepartmentOutAsReceiver?: InputMaybe<SortEnumType>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<SortEnumType>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<SortEnumType>;
  showInventoryNumberOnWorkOrders?: InputMaybe<SortEnumType>;
  showItalianLabelsOnPrint?: InputMaybe<SortEnumType>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<SortEnumType>;
  showItemAnNetWeightOnPrint?: InputMaybe<SortEnumType>;
  showItemPicturesOnPrint?: InputMaybe<SortEnumType>;
  showLastNOrdersForCustomer?: InputMaybe<SortEnumType>;
  showLineNoteOnPrint?: InputMaybe<SortEnumType>;
  showModifierCharacterPicker?: InputMaybe<SortEnumType>;
  showNumberOfUnlinkedDocuments?: InputMaybe<SortEnumType>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<SortEnumType>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<SortEnumType>;
  showPackageQuantityEntryField?: InputMaybe<SortEnumType>;
  showPaymentMethod?: InputMaybe<SortEnumType>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<SortEnumType>;
  showQuantityTotalOnPrint?: InputMaybe<SortEnumType>;
  showReceiverOnWorkOrders?: InputMaybe<SortEnumType>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<SortEnumType>;
  showWOWorkersEntry?: InputMaybe<SortEnumType>;
  skipConfirmationOnShortcuts?: InputMaybe<SortEnumType>;
  skipGS1BarcodeCheck?: InputMaybe<SortEnumType>;
  stockViewLoadAllOnOpen?: InputMaybe<SortEnumType>;
  stockViewShowOnlyInStock?: InputMaybe<SortEnumType>;
  storeContactEmailArbitraryInField?: InputMaybe<SortEnumType>;
  subjectDocumentListDocumentType?: InputMaybe<SortEnumType>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  syncPackagingWhenAddingNewItem?: InputMaybe<SortEnumType>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<SortEnumType>;
  tMNAcDefaultStatus?: InputMaybe<SortEnumType>;
  tMNAcDefaultSubject?: InputMaybe<SortEnumType>;
  tMNAnClassifIcationQid?: InputMaybe<SortEnumType>;
  tMNAnMailBoxQid?: InputMaybe<SortEnumType>;
  tMNAnStorageQid?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSize?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<SortEnumType>;
  thermalPrintShowCompanyImage?: InputMaybe<SortEnumType>;
  to?: InputMaybe<DocumentTypeSortInput>;
  toId?: InputMaybe<SortEnumType>;
  transferAcDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAcDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<SortEnumType>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<SortEnumType>;
  treatIdentAsBarcode?: InputMaybe<SortEnumType>;
  update?: InputMaybe<SortEnumType>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<SortEnumType>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<SortEnumType>;
  useDeadlineDateOnOverview?: InputMaybe<SortEnumType>;
  useSquareArticlePicker?: InputMaybe<SortEnumType>;
  useVerySmallMobileInterface?: InputMaybe<SortEnumType>;
  visualAttributes?: InputMaybe<SortEnumType>;
  visualAttributesOverview?: InputMaybe<SortEnumType>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  warehouseName?: InputMaybe<SortEnumType>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<SortEnumType>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<SortEnumType>;
  warehouseShowPrices?: InputMaybe<SortEnumType>;
  warehouseViewFixedAcSubject?: InputMaybe<SortEnumType>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<SortEnumType>;
  workOrderCanBeUnlocked?: InputMaybe<SortEnumType>;
  workOrderPrintSpecificationDuration?: InputMaybe<SortEnumType>;
  workOrderSpecificationPrefillTime?: InputMaybe<SortEnumType>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<SortEnumType>;
  workOrderUnlockableStatus?: InputMaybe<SortEnumType>;
};

export type DocumentTypeSortInput = {
  acDocsOrderingOnPDF?: InputMaybe<SortEnumType>;
  acFieldSFLabel?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerName?: InputMaybe<SortEnumType>;
  acLinkDocName1?: InputMaybe<SortEnumType>;
  acLinkDocName2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acName3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acSetOfsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  acStatusIn?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  acceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  accumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  adDateDoc1EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc1PDFLabel?: InputMaybe<SortEnumType>;
  adDateDoc2EntryIsTimeOnly?: InputMaybe<SortEnumType>;
  adDateDoc2PDFLabel?: InputMaybe<SortEnumType>;
  addingItemWarnIfQuantityMoreThanAvailable?: InputMaybe<SortEnumType>;
  adminAllowChangingItemPrice?: InputMaybe<SortEnumType>;
  adminCanEditDocumentAfterSaving?: InputMaybe<SortEnumType>;
  adminDefaultAcPriceRate?: InputMaybe<SortEnumType>;
  adminDeleteItemsAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  adminDocumentOnCreateMakeWarehouseReservation?: InputMaybe<SortEnumType>;
  adminEmphasizeInStock?: InputMaybe<SortEnumType>;
  adminForceAcPriceRate?: InputMaybe<SortEnumType>;
  adminIgnoreRebate1?: InputMaybe<SortEnumType>;
  adminIgnoreRebate2?: InputMaybe<SortEnumType>;
  adminIgnoreRebate3?: InputMaybe<SortEnumType>;
  adminItemQuantityMustBeInStock?: InputMaybe<SortEnumType>;
  adminSavedRebatesForFinalRebate?: InputMaybe<SortEnumType>;
  adminSendDocumentToCompanyDocumentEmail?: InputMaybe<SortEnumType>;
  adminSerialNumbersAreNotAutomated?: InputMaybe<SortEnumType>;
  adminShowDailyIncome?: InputMaybe<SortEnumType>;
  adminShowSubjectAdd?: InputMaybe<SortEnumType>;
  adminUseAnWsPrice?: InputMaybe<SortEnumType>;
  adminUseGenericDocumentsForMoveAndOrder?: InputMaybe<SortEnumType>;
  adminUseSerialNumberForItems?: InputMaybe<SortEnumType>;
  allowChangingWarehouse?: InputMaybe<SortEnumType>;
  allowDMSCRUDOnlyForUsersFiles?: InputMaybe<SortEnumType>;
  allowDMSConfirmation?: InputMaybe<SortEnumType>;
  allowDMSReclassification?: InputMaybe<SortEnumType>;
  allowDMSXMLItemArticlePicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemCostBearerPicking?: InputMaybe<SortEnumType>;
  allowDMSXMLItemDepartmentPicking?: InputMaybe<SortEnumType>;
  allowGenericDocumentTypeImageAttachments?: InputMaybe<SortEnumType>;
  allowManualVerifyFromDocumentOverview?: InputMaybe<SortEnumType>;
  allowModifyExistingDocuments?: InputMaybe<SortEnumType>;
  allowPullingDMSEInvoicesFromService?: InputMaybe<SortEnumType>;
  allowSavingGeodecodedLocation?: InputMaybe<SortEnumType>;
  allowSelectingMultipleDocumentsToCreateFrom?: InputMaybe<SortEnumType>;
  allowSigningAfterDocumentIsSaved?: InputMaybe<SortEnumType>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<SortEnumType>;
  alwaysUpdatePriceAndRebateFromClient?: InputMaybe<SortEnumType>;
  appendToItemIfExists?: InputMaybe<SortEnumType>;
  arbitraryField1Label?: InputMaybe<SortEnumType>;
  arbitraryField1Location?: InputMaybe<SortEnumType>;
  arbitraryField1Value?: InputMaybe<SortEnumType>;
  articleDontShowPriceAnyWhere?: InputMaybe<SortEnumType>;
  articleDontShowStockAnyWhere?: InputMaybe<SortEnumType>;
  articleSearchAllowSearchingByClassification?: InputMaybe<SortEnumType>;
  articleSearchInitiallyLoadAll?: InputMaybe<SortEnumType>;
  articleSearchRepeatLastSearch?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyInStock?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcFieldsJIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAcSetOfItemIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAdFielddDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnAIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnBIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnCIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnDIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnEIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnFIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnGIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnHIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnIIs?: InputMaybe<SortEnumType>;
  articleSearchShowOnlyWhereAnFieldnJIs?: InputMaybe<SortEnumType>;
  bluetoothPrintCopiesNumber?: InputMaybe<SortEnumType>;
  cacheDuration?: InputMaybe<SortEnumType>;
  cacheUseCacheForAnyResource?: InputMaybe<SortEnumType>;
  cacheUseForArticleSearch?: InputMaybe<SortEnumType>;
  cacheUseForCustomerSearch?: InputMaybe<SortEnumType>;
  cacheUseForWarehouseSearch?: InputMaybe<SortEnumType>;
  cardPaymentProvider?: InputMaybe<SortEnumType>;
  changeDocumentStatusAfterCreated?: InputMaybe<SortEnumType>;
  changeSourceDocumentStatusTo?: InputMaybe<SortEnumType>;
  classifs2WhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  classifsWhichDontRequireScanningForPicking?: InputMaybe<SortEnumType>;
  clerkFieldOnPrint?: InputMaybe<SortEnumType>;
  companyEmailDefaultEmail?: InputMaybe<SortEnumType>;
  companyEmailPDFBCC?: InputMaybe<SortEnumType>;
  companyEmailPDFCC?: InputMaybe<SortEnumType>;
  companyImageOnPDFsIsFullPageWidthAndReplacesHeader?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  completeDeliveryStatus?: InputMaybe<SortEnumType>;
  copyOnlyLeftOverQuantity?: InputMaybe<SortEnumType>;
  copyOnlyThoseWithLeftOverQuantity0?: InputMaybe<SortEnumType>;
  copyingFromAnotherIsAShadowCopy?: InputMaybe<SortEnumType>;
  create?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customContractPriceFilter?: InputMaybe<SortEnumType>;
  customerCodeAllowedKeys?: InputMaybe<SortEnumType>;
  customerCodeFromAcSkis?: InputMaybe<SortEnumType>;
  customerCodeIsGenerated?: InputMaybe<SortEnumType>;
  dMSListFilterOnDefaultClassification?: InputMaybe<SortEnumType>;
  dateFilterType?: InputMaybe<SortEnumType>;
  defaultCustomerType?: InputMaybe<SortEnumType>;
  defaultCustomerTypeFilter?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultMoveDocumentSortField?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultOrderDocumentSortField?: InputMaybe<SortEnumType>;
  defaultPaymentMethod?: InputMaybe<SortEnumType>;
  defaultQuantity?: InputMaybe<SortEnumType>;
  defaultSubjectDaysForPaymentOnAdd?: InputMaybe<SortEnumType>;
  defaultSubjectPaymentMethodOnAdd?: InputMaybe<SortEnumType>;
  defaultToThisCustomer?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortAscending?: InputMaybe<SortEnumType>;
  defaultWoexDocumentSortField?: InputMaybe<SortEnumType>;
  delete?: InputMaybe<SortEnumType>;
  deliveryIsRequired?: InputMaybe<SortEnumType>;
  disableUsingShadowItemAsItemBase?: InputMaybe<SortEnumType>;
  disallowChangingCustomer?: InputMaybe<SortEnumType>;
  disallowChangingItemQuantityOnSerialInput?: InputMaybe<SortEnumType>;
  disallowCreatingDocumentForSubjectWithDueUnpaidDocuments?: InputMaybe<SortEnumType>;
  disallowManualWarehouseSearch?: InputMaybe<SortEnumType>;
  disallowPickingCustomer?: InputMaybe<SortEnumType>;
  dmsAcStatusIn?: InputMaybe<SortEnumType>;
  doNotFilterDailyRecapByUserId?: InputMaybe<SortEnumType>;
  documentLinkType?: InputMaybe<SortEnumType>;
  documentLinkTypeA?: InputMaybe<SortEnumType>;
  documentLinkTypeB?: InputMaybe<SortEnumType>;
  documentNote?: InputMaybe<SortEnumType>;
  documentOnCreateMakeA4Print?: InputMaybe<SortEnumType>;
  documentOnCreateMakeBluetoothPrint?: InputMaybe<SortEnumType>;
  documentOnCreateMakePDF?: InputMaybe<SortEnumType>;
  documentTopAdditionalText?: InputMaybe<SortEnumType>;
  dontSaveIndividualPDFPages?: InputMaybe<SortEnumType>;
  existingInventoryCheckDays?: InputMaybe<SortEnumType>;
  fillReferentLineWithUserOnPrint?: InputMaybe<SortEnumType>;
  filterByAcDelivery?: InputMaybe<SortEnumType>;
  filterByAcDept?: InputMaybe<SortEnumType>;
  filterByAcDeptOut?: InputMaybe<SortEnumType>;
  filterByAcType?: InputMaybe<SortEnumType>;
  filterByAcVerifiedPrices?: InputMaybe<SortEnumType>;
  filterByAcVerifyStatus?: InputMaybe<SortEnumType>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<SortEnumType>;
  filterMovesByThisAcIssuer?: InputMaybe<SortEnumType>;
  filterMovesByThisAcReceiver?: InputMaybe<SortEnumType>;
  filterOrdersByThisAcWarehouse?: InputMaybe<SortEnumType>;
  filterReceiversByAcFieldSa?: InputMaybe<SortEnumType>;
  forceShowAvailableOnStock?: InputMaybe<SortEnumType>;
  functionality?: InputMaybe<SortEnumType>;
  generatePrintTimeOnCreate?: InputMaybe<SortEnumType>;
  groupAllCreatingDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupAllDocumentTypesAtThisPoint?: InputMaybe<SortEnumType>;
  groupDocumentTypesFromWhichThisDocumentTypeIsCreated?: InputMaybe<SortEnumType>;
  headerClerkPDFLabel?: InputMaybe<SortEnumType>;
  hideAcceptedByFieldOnPrint?: InputMaybe<SortEnumType>;
  hideClerkFieldOnPrint?: InputMaybe<SortEnumType>;
  hideCurrencyDateOnPrint?: InputMaybe<SortEnumType>;
  hideDMSMetadataEntryFields?: InputMaybe<SortEnumType>;
  hideDataForPaymentOnPrint?: InputMaybe<SortEnumType>;
  hideDocumentElements?: InputMaybe<SortEnumType>;
  hideDocumentItemElements?: InputMaybe<SortEnumType>;
  hideLeftOverQuantityOnPicking?: InputMaybe<SortEnumType>;
  hideNoteInNonHistoricalView?: InputMaybe<SortEnumType>;
  hidePayMethodOnPrint?: InputMaybe<SortEnumType>;
  hideQuantityEntry?: InputMaybe<SortEnumType>;
  hideVATRecapitulationOnPrint?: InputMaybe<SortEnumType>;
  hideWarehouseItemActions?: InputMaybe<SortEnumType>;
  hideWarehouseOverview?: InputMaybe<SortEnumType>;
  hideWarehouseSupplier?: InputMaybe<SortEnumType>;
  hideWorkOrderImages?: InputMaybe<SortEnumType>;
  hideWorkOrderMaterials?: InputMaybe<SortEnumType>;
  hideWorkOrderPlaceFromTo?: InputMaybe<SortEnumType>;
  hideWorkOrderReception?: InputMaybe<SortEnumType>;
  hideWorkOrderReclamations?: InputMaybe<SortEnumType>;
  hideWorkOrderServices?: InputMaybe<SortEnumType>;
  hideWorkOrderSpecications?: InputMaybe<SortEnumType>;
  highlightArticlePickerTextOnNextOpen?: InputMaybe<SortEnumType>;
  historyViewIgnoredFilters?: InputMaybe<SortEnumType>;
  horizontalDoc12AndDates?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ifAcPayMethodChooseThisDocumentType?: InputMaybe<SortEnumType>;
  ifBarcodeHasPackageQuantityUseItInsteadOfAnUmtoUm2?: InputMaybe<SortEnumType>;
  ifCopyingFromOrderUpdateLeftOverQuantity?: InputMaybe<SortEnumType>;
  ignoreQuantityInWholeDocument?: InputMaybe<SortEnumType>;
  initiallyShowOnlyUnconfirmedDMSDocuments?: InputMaybe<SortEnumType>;
  insteadOfAcIdentTryToShowReceiversCodeAcCodeOnPrint?: InputMaybe<SortEnumType>;
  insteadOfIdentsAcNameTryToShowReceiversCodeAcNameOnPrint?: InputMaybe<SortEnumType>;
  isDisabled?: InputMaybe<SortEnumType>;
  isRetail?: InputMaybe<SortEnumType>;
  itemListShowDetailed?: InputMaybe<SortEnumType>;
  jumpToEditAfterScanningItemWithBarcode?: InputMaybe<SortEnumType>;
  keepAdDateDoc1And2Unrounded?: InputMaybe<SortEnumType>;
  makeDocumentLinks?: InputMaybe<SortEnumType>;
  makeSerialStockCheck?: InputMaybe<SortEnumType>;
  manualWorkOrderMaterial?: InputMaybe<SortEnumType>;
  middleSignatureTextOnPrint?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  modifierCharacterLabel?: InputMaybe<SortEnumType>;
  multipleEndDocumentsCaseToPickEndDocument?: InputMaybe<SortEnumType>;
  mustFiscalize?: InputMaybe<SortEnumType>;
  newNewDocumentInputType?: InputMaybe<SortEnumType>;
  onlyCostBearerNoReceiverOrCustomerPickingAllowed?: InputMaybe<SortEnumType>;
  onlyShowSubjectsWhereLoggedInUserIsReferent?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcIssuer?: InputMaybe<SortEnumType>;
  orderAcWarehouseIsCopiedToMoveAcReceiver?: InputMaybe<SortEnumType>;
  palletEntry?: InputMaybe<SortEnumType>;
  pantheonDirection?: InputMaybe<SortEnumType>;
  pantheonTable?: InputMaybe<SortEnumType>;
  partialDeliveryStatus?: InputMaybe<SortEnumType>;
  pdfSignWithoutGeneration?: InputMaybe<SortEnumType>;
  pickingShowConfirmationOnPick?: InputMaybe<SortEnumType>;
  prefillNewSerialNumberEntryWithTheLastAlreadyEnteredSerialNumber?: InputMaybe<SortEnumType>;
  printDocumentTitleOverride?: InputMaybe<SortEnumType>;
  printTicketNameOverride?: InputMaybe<SortEnumType>;
  prioritisePackageQuantityEntryField?: InputMaybe<SortEnumType>;
  quantityDecimalPlaces?: InputMaybe<SortEnumType>;
  read?: InputMaybe<SortEnumType>;
  recommendToMakeCodebooksOffline?: InputMaybe<SortEnumType>;
  requireASignature?: InputMaybe<SortEnumType>;
  reverseItemsList?: InputMaybe<SortEnumType>;
  saveUnsignedAsSignedPDF?: InputMaybe<SortEnumType>;
  sendB2BAsEInvoice?: InputMaybe<SortEnumType>;
  sendDocumentPDFToContactUsingCompanyOutboundEmail?: InputMaybe<SortEnumType>;
  sendLeftoverShadowsWithZero?: InputMaybe<SortEnumType>;
  serialNumberDirectionIsInput?: InputMaybe<SortEnumType>;
  showAcDeliveryMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeliveryOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDeptMobileFilterOnDocumentList?: InputMaybe<SortEnumType>;
  showAcDescrOnPDFs?: InputMaybe<SortEnumType>;
  showAcDoc1?: InputMaybe<SortEnumType>;
  showAcDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAcDoc2?: InputMaybe<SortEnumType>;
  showAcDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAcIdentOnPrint?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderLabel?: InputMaybe<SortEnumType>;
  showAcKeyAndAcDoc1FromDocumentsLinkWithTypeInHeaderOnPrint?: InputMaybe<SortEnumType>;
  showAdDate?: InputMaybe<SortEnumType>;
  showAdDateDoc1?: InputMaybe<SortEnumType>;
  showAdDateDoc1OnPrint?: InputMaybe<SortEnumType>;
  showAdDateDoc2?: InputMaybe<SortEnumType>;
  showAdDateDoc2OnPrint?: InputMaybe<SortEnumType>;
  showAllDMSDocumentsForURAClassifications?: InputMaybe<SortEnumType>;
  showAllDocumentsNotOnlyAnUserIns?: InputMaybe<SortEnumType>;
  showAllItemsIgnoringWarehouse?: InputMaybe<SortEnumType>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<SortEnumType>;
  showArticlesGroupedByCodeButSeparate?: InputMaybe<SortEnumType>;
  showAsCriticalErrorIfItemDoesNotExistOnSourceDocument?: InputMaybe<SortEnumType>;
  showAttachSSCCButton?: InputMaybe<SortEnumType>;
  showBuyerOnWorkOrders?: InputMaybe<SortEnumType>;
  showContactEmailEntry?: InputMaybe<SortEnumType>;
  showContactEntry?: InputMaybe<SortEnumType>;
  showCostBearerOnWorkOrders?: InputMaybe<SortEnumType>;
  showCustomerName2AsPrimaryOnHeader?: InputMaybe<SortEnumType>;
  showCustomerOverview?: InputMaybe<SortEnumType>;
  showCustomersAcName2OnThermalPrint?: InputMaybe<SortEnumType>;
  showDMSXMLItems?: InputMaybe<SortEnumType>;
  showDeliveryDeadlineDays?: InputMaybe<SortEnumType>;
  showDeliveryMethod?: InputMaybe<SortEnumType>;
  showDepartmentAsReceiver?: InputMaybe<SortEnumType>;
  showDepartmentOutAsReceiver?: InputMaybe<SortEnumType>;
  showDoc1FromItemsLinkedWithTypeItemDocLinkTypeOnPrint?: InputMaybe<SortEnumType>;
  showDoc12AndTheirDatesOnDocumentList?: InputMaybe<SortEnumType>;
  showInventoryNumberOnWorkOrders?: InputMaybe<SortEnumType>;
  showItalianLabelsOnPrint?: InputMaybe<SortEnumType>;
  showItemAcCustomsTariffOnPrint?: InputMaybe<SortEnumType>;
  showItemAnNetWeightOnPrint?: InputMaybe<SortEnumType>;
  showItemPicturesOnPrint?: InputMaybe<SortEnumType>;
  showLastNOrdersForCustomer?: InputMaybe<SortEnumType>;
  showLineNoteOnPrint?: InputMaybe<SortEnumType>;
  showModifierCharacterPicker?: InputMaybe<SortEnumType>;
  showNumberOfUnlinkedDocuments?: InputMaybe<SortEnumType>;
  showOnlyArticlesWithCustomerContractPrice?: InputMaybe<SortEnumType>;
  showOnlyDMSDocumentsAssignedToMe?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<SortEnumType>;
  showOnlyDocumentsWhereAnNoteClerkIsCurrentUser?: InputMaybe<SortEnumType>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<SortEnumType>;
  showPackageQuantityEntryField?: InputMaybe<SortEnumType>;
  showPaymentMethod?: InputMaybe<SortEnumType>;
  showQuantityPerUnitOfMeasureOnPrint?: InputMaybe<SortEnumType>;
  showQuantityTotalOnPrint?: InputMaybe<SortEnumType>;
  showReceiverOnWorkOrders?: InputMaybe<SortEnumType>;
  showSerialNumberSearchForWorkOrders?: InputMaybe<SortEnumType>;
  showWOWorkersEntry?: InputMaybe<SortEnumType>;
  skipConfirmationOnShortcuts?: InputMaybe<SortEnumType>;
  skipGS1BarcodeCheck?: InputMaybe<SortEnumType>;
  stockViewLoadAllOnOpen?: InputMaybe<SortEnumType>;
  stockViewShowOnlyInStock?: InputMaybe<SortEnumType>;
  storeContactEmailArbitraryInField?: InputMaybe<SortEnumType>;
  subjectDocumentListDocumentType?: InputMaybe<SortEnumType>;
  subjectFieldForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  subjectFieldValueForSSCCRequirementCheck?: InputMaybe<SortEnumType>;
  syncPackagingWhenAddingNewItem?: InputMaybe<SortEnumType>;
  tHrPrsnForOnlyOnixPhoneUsers?: InputMaybe<SortEnumType>;
  tMNAcDefaultStatus?: InputMaybe<SortEnumType>;
  tMNAcDefaultSubject?: InputMaybe<SortEnumType>;
  tMNAnClassifIcationQid?: InputMaybe<SortEnumType>;
  tMNAnMailBoxQid?: InputMaybe<SortEnumType>;
  tMNAnStorageQid?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSize?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeHeight?: InputMaybe<SortEnumType>;
  thermalPrintCompanyNameFontSizeWidth?: InputMaybe<SortEnumType>;
  thermalPrintShowCompanyImage?: InputMaybe<SortEnumType>;
  transferAcDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAcDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc1WhenCopying?: InputMaybe<SortEnumType>;
  transferAdDateDoc2WhenCopying?: InputMaybe<SortEnumType>;
  transferEnteredItemQuantityToSerialNumber?: InputMaybe<SortEnumType>;
  transferLeftOverQuantityAfterShadowCopyIntoQuantityField?: InputMaybe<SortEnumType>;
  treatIdentAsBarcode?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  update?: InputMaybe<SortEnumType>;
  updateHeadAndDeleteAllItemsOnCopy?: InputMaybe<SortEnumType>;
  useBarcodeQuantityOnlyIfOfSameUnitOfMeasureAsIdent?: InputMaybe<SortEnumType>;
  useDeadlineDateOnOverview?: InputMaybe<SortEnumType>;
  useSquareArticlePicker?: InputMaybe<SortEnumType>;
  useVerySmallMobileInterface?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  visualAttributes?: InputMaybe<SortEnumType>;
  visualAttributesOverview?: InputMaybe<SortEnumType>;
  visuallyAccumulateQuantityOnDocumentWhenMultipleSourceDocuments?: InputMaybe<SortEnumType>;
  warehouseName?: InputMaybe<SortEnumType>;
  warehouseOverviewShowOnlyInStock?: InputMaybe<SortEnumType>;
  warehousePositionTHeSetItemFieldName?: InputMaybe<SortEnumType>;
  warehouseShowPrices?: InputMaybe<SortEnumType>;
  warehouseViewFixedAcSubject?: InputMaybe<SortEnumType>;
  whenAddingSubjectSetAnClerkToCurrentUser?: InputMaybe<SortEnumType>;
  workOrderCanBeUnlocked?: InputMaybe<SortEnumType>;
  workOrderPrintSpecificationDuration?: InputMaybe<SortEnumType>;
  workOrderSpecificationPrefillTime?: InputMaybe<SortEnumType>;
  workOrderSpecificationTimeNotRequired?: InputMaybe<SortEnumType>;
  workOrderUnlockableStatus?: InputMaybe<SortEnumType>;
};

export type DocumentTypeUpdateDtoInput = {
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchInitiallyLoadAll: Scalars['Boolean'];
  articleSearchRepeatLastSearch: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  articleSearchShowOnlyWhereAcFieldsAIs?: InputMaybe<Scalars['String']>;
  bluetoothPrintCopiesNumber: Scalars['Int'];
  cacheDuration: Scalars['Int'];
  cacheUseCacheForAnyResource: Scalars['Boolean'];
  cacheUseForArticleSearch: Scalars['Boolean'];
  cacheUseForCustomerSearch: Scalars['Boolean'];
  cacheUseForWarehouseSearch: Scalars['Boolean'];
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  itemListShowDetailed: Scalars['Boolean'];
  pickingShowConfirmationOnPick: Scalars['Boolean'];
  quantityDecimalPlaces: Scalars['Int'];
  sendB2BAsEInvoice?: InputMaybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  stockViewLoadAllOnOpen: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
};

export type DocumentTypeUpdateDtoV2Input = {
  addingItemWarnIfQuantityMoreThanAvailable: Scalars['Boolean'];
  articleSearchAllowSearchingByClassification: Scalars['Boolean'];
  articleSearchShowOnlyInStock: Scalars['Boolean'];
  bluetoothPrintCopiesNumber: Scalars['Int'];
  documentOnCreateMakeBluetoothPrint: Scalars['Boolean'];
  documentOnCreateMakePDF: Scalars['Boolean'];
  itemListShowDetailed: Scalars['Boolean'];
  quantityDecimalPlaces: Scalars['Int'];
  sendB2BAsEInvoice?: InputMaybe<Scalars['Boolean']>;
  skipConfirmationOnShortcuts: Scalars['Boolean'];
  stockViewShowOnlyInStock: Scalars['Boolean'];
  warehouseOverviewShowOnlyInStock: Scalars['Boolean'];
  workOrderPrintSpecificationDuration: Scalars['Boolean'];
};

export type EInvoiceDispatchDto = {
  acKey?: Maybe<Scalars['String']>;
  artifactId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  dispatchId: Scalars['UUID'];
  documentUid: Scalars['String'];
  exchange: EInvoiceExchangeOutcome;
  firstFailureAt?: Maybe<Scalars['DateTime']>;
  fiscalization: EInvoiceFiscalizationOutcome;
  fiscalizedAt?: Maybe<Scalars['DateTime']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  nextAttemptAt?: Maybe<Scalars['DateTime']>;
  pdfByteLength?: Maybe<Scalars['Int']>;
  pdfSha256?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  stage: EInvoiceStage;
  state: EInvoiceQueueState;
  updatedAt: Scalars['DateTime'];
};

export type EInvoiceDocumentStatusDto = {
  exchange: EInvoiceExchangeOutcome;
  fiscalization: EInvoiceFiscalizationOutcome;
  hasFailure: Scalars['Boolean'];
  reasonCode?: Maybe<Scalars['String']>;
  stage: EInvoiceStage;
  state: EInvoiceQueueState;
};

export enum EInvoiceExchangeOutcome {
  Accepted = 'ACCEPTED',
  DefinitivelyNotAccepted = 'DEFINITIVELY_NOT_ACCEPTED',
  NotAttempted = 'NOT_ATTEMPTED',
  Uncertain = 'UNCERTAIN'
}

export enum EInvoiceFiscalizationOutcome {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type EInvoicePdfArtifactAck = {
  artifactId: Scalars['UUID'];
  byteLength: Scalars['Int'];
  dispatch?: Maybe<EInvoiceDispatchDto>;
  sha256?: Maybe<Scalars['String']>;
};

export type EInvoicePreflightDto = {
  contractVersion: Scalars['Int'];
  errors: Array<Scalars['String']>;
  maxPdfBytes: Scalars['Int'];
  reasonCode?: Maybe<Scalars['String']>;
  requiresF1Signing: Scalars['Boolean'];
  route: EInvoiceRoute;
};

export type EInvoicePreflightInput = {
  buyerCode?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  documentUid?: InputMaybe<Scalars['String']>;
  eInvoiceContractVersion?: InputMaybe<Scalars['Int']>;
  originApplicationUserId?: InputMaybe<Scalars['String']>;
  originCompanySettingsId: Scalars['Int'];
  pairId?: InputMaybe<Scalars['Int']>;
  paymentMethodCode?: InputMaybe<Scalars['String']>;
  sourceAcKey?: InputMaybe<Scalars['String']>;
  updateExisting: Scalars['Boolean'];
};

export enum EInvoiceQueueState {
  AwaitingCommit = 'AWAITING_COMMIT',
  AwaitingFiscalization = 'AWAITING_FISCALIZATION',
  AwaitingPdf = 'AWAITING_PDF',
  Completed = 'COMPLETED',
  NeedsAttention = 'NEEDS_ATTENTION',
  NotIssued = 'NOT_ISSUED',
  Processing = 'PROCESSING',
  Ready = 'READY',
  ReconcileRequired = 'RECONCILE_REQUIRED',
  RetryPending = 'RETRY_PENDING'
}

export enum EInvoiceRoute {
  F1 = 'F1',
  F2 = 'F2',
  LegacyManual = 'LEGACY_MANUAL',
  NotApplicable = 'NOT_APPLICABLE'
}

export enum EInvoiceStage {
  Commit = 'COMMIT',
  Fiscalization = 'FISCALIZATION',
  Pdf = 'PDF',
  ProviderExchange = 'PROVIDER_EXCHANGE',
  Xml = 'XML'
}

export type ExpenseBearer = {
  active: Scalars['Boolean'];
  allowance: Scalars['Float'];
  bearer?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  consignee?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  receiver?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
};

export type ExpenseBearerFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  allowance?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<ExpenseBearerFilterInput>>;
  bearer?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  consignee?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExpenseBearerFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  place?: InputMaybe<StringOperationFilterInput>;
  receiver?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type ExpenseBearerSortInput = {
  active?: InputMaybe<SortEnumType>;
  allowance?: InputMaybe<SortEnumType>;
  bearer?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  consignee?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  place?: InputMaybe<SortEnumType>;
  receiver?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
};

export type ExternalAuthAccountChoiceDto = {
  companyName?: Maybe<Scalars['String']>;
  companySettingsId?: Maybe<Scalars['Int']>;
  userId: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
};

export type ExternalAuthExchangeResultDto = {
  accountChoices: Array<ExternalAuthAccountChoiceDto>;
  portalRegistrationDisplayName?: Maybe<Scalars['String']>;
  portalRegistrationEmail?: Maybe<Scalars['String']>;
  portalRegistrationTicket?: Maybe<Scalars['String']>;
  requiresAccountSelection: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

export enum ExternalAuthFlowKind {
  Link = 'LINK',
  Login = 'LOGIN'
}

export type ExternalAuthFlowKindOperationFilterInput = {
  eq?: InputMaybe<ExternalAuthFlowKind>;
  in?: InputMaybe<Array<ExternalAuthFlowKind>>;
  neq?: InputMaybe<ExternalAuthFlowKind>;
  nin?: InputMaybe<Array<ExternalAuthFlowKind>>;
};

export enum ExternalAuthProvider {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

export type ExternalAuthProviderOperationFilterInput = {
  eq?: InputMaybe<ExternalAuthProvider>;
  in?: InputMaybe<Array<ExternalAuthProvider>>;
  neq?: InputMaybe<ExternalAuthProvider>;
  nin?: InputMaybe<Array<ExternalAuthProvider>>;
};

export type ExternalAuthRequestState = {
  appRedirectUri?: Maybe<Scalars['String']>;
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  consumedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  flowKind: ExternalAuthFlowKind;
  id: Scalars['Int'];
  provider: ExternalAuthProvider;
  stateHash: Scalars['String'];
};

export type ExternalAuthRequestStateFilterInput = {
  and?: InputMaybe<Array<ExternalAuthRequestStateFilterInput>>;
  appRedirectUri?: InputMaybe<StringOperationFilterInput>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  consumedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  expiresAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  flowKind?: InputMaybe<ExternalAuthFlowKindOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ExternalAuthRequestStateFilterInput>>;
  provider?: InputMaybe<ExternalAuthProviderOperationFilterInput>;
  stateHash?: InputMaybe<StringOperationFilterInput>;
};

export type ExternalAuthStartResultDto = {
  url?: Maybe<Scalars['String']>;
};

export type ExternalAuthTicket = {
  consumedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  externalIdentity?: Maybe<ExternalIdentity>;
  externalIdentityId: Scalars['Int'];
  id: Scalars['Int'];
  ticketHash?: Maybe<Scalars['String']>;
};

export type ExternalAuthTicketFilterInput = {
  and?: InputMaybe<Array<ExternalAuthTicketFilterInput>>;
  consumedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  expiresAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  externalIdentity?: InputMaybe<ExternalIdentityFilterInput>;
  externalIdentityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ExternalAuthTicketFilterInput>>;
  ticketHash?: InputMaybe<StringOperationFilterInput>;
};

export type ExternalIdentity = {
  applicationUsers?: Maybe<Array<Maybe<ApplicationUserExternalIdentity>>>;
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  externalAuthTickets?: Maybe<Array<Maybe<ExternalAuthTicket>>>;
  id: Scalars['Int'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  provider: ExternalAuthProvider;
  providerSubject?: Maybe<Scalars['String']>;
  providerTenantId?: Maybe<Scalars['String']>;
  verifiedEmail?: Maybe<Scalars['String']>;
};

export type ExternalIdentityFilterInput = {
  and?: InputMaybe<Array<ExternalIdentityFilterInput>>;
  applicationUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserExternalIdentityFilterInput>;
  createdAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  externalAuthTickets?: InputMaybe<ListFilterInputTypeOfExternalAuthTicketFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastUsedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ExternalIdentityFilterInput>>;
  provider?: InputMaybe<ExternalAuthProviderOperationFilterInput>;
  providerSubject?: InputMaybe<StringOperationFilterInput>;
  providerTenantId?: InputMaybe<StringOperationFilterInput>;
  verifiedEmail?: InputMaybe<StringOperationFilterInput>;
};

export type FcmToken = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notificationDeliveryReport?: Maybe<Array<Maybe<NotificationDeliveryReport>>>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
};

export type FcmTokenFilterInput = {
  and?: InputMaybe<Array<FcmTokenFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notificationDeliveryReport?: InputMaybe<ListFilterInputTypeOfNotificationDeliveryReportFilterInput>;
  or?: InputMaybe<Array<FcmTokenFilterInput>>;
  token?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export enum FiscalDataSource {
  Client = 'CLIENT',
  Server = 'SERVER'
}

export type FiscalDataSourceOperationFilterInput = {
  eq?: InputMaybe<FiscalDataSource>;
  in?: InputMaybe<Array<FiscalDataSource>>;
  neq?: InputMaybe<FiscalDataSource>;
  nin?: InputMaybe<Array<FiscalDataSource>>;
};

export type FiscalizationCertificateValidationResult = {
  error?: Maybe<Scalars['String']>;
  notAfterUtc?: Maybe<Scalars['DateTime']>;
  notBeforeUtc?: Maybe<Scalars['DateTime']>;
};

export type FiscalizationQueueEntry = {
  acKey?: Maybe<Scalars['String']>;
  alreadyTriedFiscalizing: Scalars['Boolean'];
  documentType?: Maybe<DocumentType>;
  documentTypeId: Scalars['Int'];
  fiscalBaseAmount?: Maybe<Scalars['Decimal']>;
  fiscalDataSource: FiscalDataSource;
  fiscalInternalNumber?: Maybe<Scalars['String']>;
  fiscalSequenceNumber?: Maybe<Scalars['Int']>;
  fiscalTotal?: Maybe<Scalars['Decimal']>;
  fiscalYear?: Maybe<Scalars['Int']>;
  fiscalizationError?: Maybe<Scalars['String']>;
  fiscalized: Scalars['Boolean'];
  id: Scalars['Int'];
  jir?: Maybe<Scalars['String']>;
  requestData?: Maybe<Scalars['String']>;
  systemError?: Maybe<Scalars['String']>;
  uID?: Maybe<Scalars['String']>;
  xML?: Maybe<Scalars['String']>;
  zKI?: Maybe<Scalars['String']>;
};

export type FiscalizationQueueEntryFilterInput = {
  acKey?: InputMaybe<StringOperationFilterInput>;
  alreadyTriedFiscalizing?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<FiscalizationQueueEntryFilterInput>>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  fiscalBaseAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fiscalDataSource?: InputMaybe<FiscalDataSourceOperationFilterInput>;
  fiscalInternalNumber?: InputMaybe<StringOperationFilterInput>;
  fiscalSequenceNumber?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fiscalTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fiscalYear?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fiscalizationError?: InputMaybe<StringOperationFilterInput>;
  fiscalized?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  jir?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FiscalizationQueueEntryFilterInput>>;
  requestData?: InputMaybe<StringOperationFilterInput>;
  systemError?: InputMaybe<StringOperationFilterInput>;
  uID?: InputMaybe<StringOperationFilterInput>;
  xML?: InputMaybe<StringOperationFilterInput>;
  zKI?: InputMaybe<StringOperationFilterInput>;
};

export type FiscalizationQueueEntrySortInput = {
  acKey?: InputMaybe<SortEnumType>;
  alreadyTriedFiscalizing?: InputMaybe<SortEnumType>;
  documentType?: InputMaybe<DocumentTypeSortInput>;
  documentTypeId?: InputMaybe<SortEnumType>;
  fiscalBaseAmount?: InputMaybe<SortEnumType>;
  fiscalDataSource?: InputMaybe<SortEnumType>;
  fiscalInternalNumber?: InputMaybe<SortEnumType>;
  fiscalSequenceNumber?: InputMaybe<SortEnumType>;
  fiscalTotal?: InputMaybe<SortEnumType>;
  fiscalYear?: InputMaybe<SortEnumType>;
  fiscalizationError?: InputMaybe<SortEnumType>;
  fiscalized?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jir?: InputMaybe<SortEnumType>;
  requestData?: InputMaybe<SortEnumType>;
  systemError?: InputMaybe<SortEnumType>;
  uID?: InputMaybe<SortEnumType>;
  xML?: InputMaybe<SortEnumType>;
  zKI?: InputMaybe<SortEnumType>;
};

export type IBackupEventLogComputer = {
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
};

export type IBackupEventLogComputerFilterInput = {
  and?: InputMaybe<Array<IBackupEventLogComputerFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IBackupEventLogComputerFilterInput>>;
};

export type IEqualityComparerOfStringFilterInput = {
  and?: InputMaybe<Array<IEqualityComparerOfStringFilterInput>>;
  or?: InputMaybe<Array<IEqualityComparerOfStringFilterInput>>;
};

export enum InstallationVariableType {
  Boolean = 'BOOLEAN',
  DateTime = 'DATE_TIME',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  String = 'STRING'
}

export type InstallationVariableTypeOperationFilterInput = {
  eq?: InputMaybe<InstallationVariableType>;
  in?: InputMaybe<Array<InstallationVariableType>>;
  neq?: InputMaybe<InstallationVariableType>;
  nin?: InputMaybe<Array<InstallationVariableType>>;
};

export enum InvoiceSumType {
  Count = 'COUNT',
  DurationSum = 'DURATION_SUM'
}

export type Item = {
  code?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  itemGroupItems?: Maybe<Array<Maybe<ItemGroupItem>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
};

export type ItemCollectionSegment = {
  items?: Maybe<Array<Maybe<Item>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ItemFilterInput = {
  and?: InputMaybe<Array<ItemFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  department?: InputMaybe<DepartmentFilterInput>;
  departmentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemGroupItems?: InputMaybe<ListFilterInputTypeOfItemGroupItemFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type ItemGroup = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  itemGroupItems?: Maybe<Array<Maybe<ItemGroupItem>>>;
  itemGroupMaterials?: Maybe<Array<Maybe<MarservisItemGroupMaterial>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
};

export type ItemGroupFilterInput = {
  and?: InputMaybe<Array<ItemGroupFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemGroupItems?: InputMaybe<ListFilterInputTypeOfItemGroupItemFilterInput>;
  itemGroupMaterials?: InputMaybe<ListFilterInputTypeOfMarservisItemGroupMaterialFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ItemGroupFilterInput>>;
};

export type ItemGroupItem = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  item?: Maybe<Item>;
  itemGroup?: Maybe<ItemGroup>;
  itemGroupId: Scalars['Int'];
  itemId: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type ItemGroupItemFilterInput = {
  and?: InputMaybe<Array<ItemGroupItemFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  item?: InputMaybe<ItemFilterInput>;
  itemGroup?: InputMaybe<ItemGroupFilterInput>;
  itemGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ItemGroupItemFilterInput>>;
};

export type ItemGroupSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type ItemSortInput = {
  code?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  department?: InputMaybe<DepartmentSortInput>;
  departmentId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
};

export type KeyValuePairOfStringAndDateTimeInput = {
  key: Scalars['String'];
  value: Scalars['DateTime'];
};

export type KeyValuePairOfStringAndDictionaryOfStringAndString = {
  key: Scalars['String'];
  value: Array<KeyValuePairOfStringAndString>;
};

export type KeyValuePairOfStringAndString = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KeyValuePairOfStringAndStringInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KeyValueStorageChangeLogInput = {
  added?: InputMaybe<Array<InputMaybe<OnixPhoneKeyValueStorageInput>>>;
  deleted?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updated?: InputMaybe<Array<InputMaybe<OnixPhoneKeyValueStorageInput>>>;
};

export type LurInvoiceListItemDto = {
  acCurrency?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acHrFiskalNumber?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acVerifiedPrices?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk: Scalars['Int'];
  anForPay: Scalars['Decimal'];
};

export type LurInvoiceListItemDtoFilterInput = {
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acHrFiskalNumber?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableInt32OperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<LurInvoiceListItemDtoFilterInput>>;
  or?: InputMaybe<Array<LurInvoiceListItemDtoFilterInput>>;
};

export type LurInvoiceListItemDtoSortInput = {
  acCurrency?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDoc1?: InputMaybe<SortEnumType>;
  acDoc2?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acHrFiskalNumber?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPrsn3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acVerifiedPrices?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anForPay?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LurInvoiceListItemsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<LurInvoiceListItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LurInvoiceListItemDto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type LurInvoiceListItemsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LurInvoiceListItemDto>;
};

export type LabelComposition = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  sVGTemplate?: Maybe<Scalars['String']>;
};

export type LabelCompositionFilterInput = {
  and?: InputMaybe<Array<LabelCompositionFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LabelCompositionFilterInput>>;
  sVGTemplate?: InputMaybe<StringOperationFilterInput>;
};

export enum LabelContinuousOrSingleSheetEnum {
  Continuous = 'CONTINUOUS',
  SingleSheet = 'SINGLE_SHEET'
}

export type LabelContinuousOrSingleSheetEnumOperationFilterInput = {
  eq?: InputMaybe<LabelContinuousOrSingleSheetEnum>;
  in?: InputMaybe<Array<LabelContinuousOrSingleSheetEnum>>;
  neq?: InputMaybe<LabelContinuousOrSingleSheetEnum>;
  nin?: InputMaybe<Array<LabelContinuousOrSingleSheetEnum>>;
};

export type LabelDefinition = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  continuousOrSingleSheet: LabelContinuousOrSingleSheetEnum;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lHDist: Scalars['Int'];
  lHeight: Scalars['Int'];
  lLeft: Scalars['Int'];
  lPHeight: Scalars['Int'];
  lPWidth: Scalars['Int'];
  lUpper: Scalars['Int'];
  lVDist: Scalars['Int'];
  lWidth: Scalars['Int'];
  manufacturer?: Maybe<Scalars['String']>;
  manufacturerId?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  nCols: Scalars['Int'];
  nRows: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type LabelDefinitionFilterInput = {
  and?: InputMaybe<Array<LabelDefinitionFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  continuousOrSingleSheet?: InputMaybe<LabelContinuousOrSingleSheetEnumOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lHDist?: InputMaybe<ComparableInt32OperationFilterInput>;
  lHeight?: InputMaybe<ComparableInt32OperationFilterInput>;
  lLeft?: InputMaybe<ComparableInt32OperationFilterInput>;
  lPHeight?: InputMaybe<ComparableInt32OperationFilterInput>;
  lPWidth?: InputMaybe<ComparableInt32OperationFilterInput>;
  lUpper?: InputMaybe<ComparableInt32OperationFilterInput>;
  lVDist?: InputMaybe<ComparableInt32OperationFilterInput>;
  lWidth?: InputMaybe<ComparableInt32OperationFilterInput>;
  manufacturer?: InputMaybe<StringOperationFilterInput>;
  manufacturerId?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  nCols?: InputMaybe<ComparableInt32OperationFilterInput>;
  nRows?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LabelDefinitionFilterInput>>;
};

export type LabelDefinitionLocation = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  documentType?: Maybe<DocumentType>;
  documentTypeId: Scalars['Int'];
  id: Scalars['Int'];
  labelComposition?: Maybe<LabelComposition>;
  labelCompositionId?: Maybe<Scalars['Int']>;
  labelDefinition?: Maybe<LabelDefinition>;
  labelDefinitionId: Scalars['Int'];
  location: LabelDefinitionLocationEnum;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export enum LabelDefinitionLocationEnum {
  WarehouseOverview = 'WAREHOUSE_OVERVIEW'
}

export type LabelDefinitionLocationEnumOperationFilterInput = {
  eq?: InputMaybe<LabelDefinitionLocationEnum>;
  in?: InputMaybe<Array<LabelDefinitionLocationEnum>>;
  neq?: InputMaybe<LabelDefinitionLocationEnum>;
  nin?: InputMaybe<Array<LabelDefinitionLocationEnum>>;
};

export type LabelDefinitionLocationFilterInput = {
  and?: InputMaybe<Array<LabelDefinitionLocationFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeFilterInput>;
  documentTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  labelComposition?: InputMaybe<LabelCompositionFilterInput>;
  labelCompositionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  labelDefinition?: InputMaybe<LabelDefinitionFilterInput>;
  labelDefinitionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  location?: InputMaybe<LabelDefinitionLocationEnumOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<LabelDefinitionLocationFilterInput>>;
};

export type ListComparableByteOperationFilterInput = {
  all?: InputMaybe<ComparableByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ComparableByteOperationFilterInput>;
  some?: InputMaybe<ComparableByteOperationFilterInput>;
};

export type ListFilterInputTypeOfApplicationPacketFilterInput = {
  all?: InputMaybe<ApplicationPacketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationPacketFilterInput>;
  some?: InputMaybe<ApplicationPacketFilterInput>;
};

export type ListFilterInputTypeOfApplicationUserExternalIdentityFilterInput = {
  all?: InputMaybe<ApplicationUserExternalIdentityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserExternalIdentityFilterInput>;
  some?: InputMaybe<ApplicationUserExternalIdentityFilterInput>;
};

export type ListFilterInputTypeOfApplicationUserFilterInput = {
  all?: InputMaybe<ApplicationUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserFilterInput>;
  some?: InputMaybe<ApplicationUserFilterInput>;
};

export type ListFilterInputTypeOfApplicationUserRoleFilterInput = {
  all?: InputMaybe<ApplicationUserRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserRoleFilterInput>;
  some?: InputMaybe<ApplicationUserRoleFilterInput>;
};

export type ListFilterInputTypeOfApplicationUserWakaAuthorFilterInput = {
  all?: InputMaybe<ApplicationUserWakaAuthorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserWakaAuthorFilterInput>;
  some?: InputMaybe<ApplicationUserWakaAuthorFilterInput>;
};

export type ListFilterInputTypeOfApplicationUserWakaMachineFilterInput = {
  all?: InputMaybe<ApplicationUserWakaMachineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserWakaMachineFilterInput>;
  some?: InputMaybe<ApplicationUserWakaMachineFilterInput>;
};

export type ListFilterInputTypeOfApplicationUserWakaProjectMapFilterInput = {
  all?: InputMaybe<ApplicationUserWakaProjectMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ApplicationUserWakaProjectMapFilterInput>;
  some?: InputMaybe<ApplicationUserWakaProjectMapFilterInput>;
};

export type ListFilterInputTypeOfAresDeploymentAresCompanyCurrentVersionFilterInput = {
  all?: InputMaybe<AresDeploymentAresCompanyCurrentVersionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentAresCompanyCurrentVersionFilterInput>;
  some?: InputMaybe<AresDeploymentAresCompanyCurrentVersionFilterInput>;
};

export type ListFilterInputTypeOfAresDeploymentAresFilterInput = {
  all?: InputMaybe<AresDeploymentAresFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentAresFilterInput>;
  some?: InputMaybe<AresDeploymentAresFilterInput>;
};

export type ListFilterInputTypeOfAresDeploymentGroupCompanyMappingFilterInput = {
  all?: InputMaybe<AresDeploymentGroupCompanyMappingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentGroupCompanyMappingFilterInput>;
  some?: InputMaybe<AresDeploymentGroupCompanyMappingFilterInput>;
};

export type ListFilterInputTypeOfAresDeploymentGroupInstallationStepFilterInput = {
  all?: InputMaybe<AresDeploymentGroupInstallationStepFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentGroupInstallationStepFilterInput>;
  some?: InputMaybe<AresDeploymentGroupInstallationStepFilterInput>;
};

export type ListFilterInputTypeOfAresDeploymentGroupSnapshotFilterInput = {
  all?: InputMaybe<AresDeploymentGroupSnapshotFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentGroupSnapshotFilterInput>;
  some?: InputMaybe<AresDeploymentGroupSnapshotFilterInput>;
};

export type ListFilterInputTypeOfAresDeploymentInstallationStepPointFilterInput = {
  all?: InputMaybe<AresDeploymentInstallationStepPointFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentInstallationStepPointFilterInput>;
  some?: InputMaybe<AresDeploymentInstallationStepPointFilterInput>;
};

export type ListFilterInputTypeOfAresDeploymentOnixPhoneSettingsFilterInput = {
  all?: InputMaybe<AresDeploymentOnixPhoneSettingsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentOnixPhoneSettingsFilterInput>;
  some?: InputMaybe<AresDeploymentOnixPhoneSettingsFilterInput>;
};

export type ListFilterInputTypeOfAresDeploymentWorkflowDefinitionFilterInput = {
  all?: InputMaybe<AresDeploymentWorkflowDefinitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AresDeploymentWorkflowDefinitionFilterInput>;
  some?: InputMaybe<AresDeploymentWorkflowDefinitionFilterInput>;
};

export type ListFilterInputTypeOfCompanyDatalabReferenceLinkFilterInput = {
  all?: InputMaybe<CompanyDatalabReferenceLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyDatalabReferenceLinkFilterInput>;
  some?: InputMaybe<CompanyDatalabReferenceLinkFilterInput>;
};

export type ListFilterInputTypeOfCompanyEmailForwardFilterInput = {
  all?: InputMaybe<CompanyEmailForwardFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyEmailForwardFilterInput>;
  some?: InputMaybe<CompanyEmailForwardFilterInput>;
};

export type ListFilterInputTypeOfCompanyMachineUidFilterInput = {
  all?: InputMaybe<CompanyMachineUidFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyMachineUidFilterInput>;
  some?: InputMaybe<CompanyMachineUidFilterInput>;
};

export type ListFilterInputTypeOfCompanyMeshCentralGroupMappingFilterInput = {
  all?: InputMaybe<CompanyMeshCentralGroupMappingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyMeshCentralGroupMappingFilterInput>;
  some?: InputMaybe<CompanyMeshCentralGroupMappingFilterInput>;
};

export type ListFilterInputTypeOfCompanyRunbookNoteFilterInput = {
  all?: InputMaybe<CompanyRunbookNoteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyRunbookNoteFilterInput>;
  some?: InputMaybe<CompanyRunbookNoteFilterInput>;
};

export type ListFilterInputTypeOfCompanySettingsWorkHoursFilterInput = {
  all?: InputMaybe<CompanySettingsWorkHoursFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanySettingsWorkHoursFilterInput>;
  some?: InputMaybe<CompanySettingsWorkHoursFilterInput>;
};

export type ListFilterInputTypeOfCompanyTeamViewerContactFilterInput = {
  all?: InputMaybe<CompanyTeamViewerContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyTeamViewerContactFilterInput>;
  some?: InputMaybe<CompanyTeamViewerContactFilterInput>;
};

export type ListFilterInputTypeOfCompanyTeamViewerDeviceFilterInput = {
  all?: InputMaybe<CompanyTeamViewerDeviceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CompanyTeamViewerDeviceFilterInput>;
  some?: InputMaybe<CompanyTeamViewerDeviceFilterInput>;
};

export type ListFilterInputTypeOfContactCompanyFilterInput = {
  all?: InputMaybe<ContactCompanyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ContactCompanyFilterInput>;
  some?: InputMaybe<ContactCompanyFilterInput>;
};

export type ListFilterInputTypeOfContactEmailFilterInput = {
  all?: InputMaybe<ContactEmailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ContactEmailFilterInput>;
  some?: InputMaybe<ContactEmailFilterInput>;
};

export type ListFilterInputTypeOfContactPhoneFilterInput = {
  all?: InputMaybe<ContactPhoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ContactPhoneFilterInput>;
  some?: InputMaybe<ContactPhoneFilterInput>;
};

export type ListFilterInputTypeOfDatalabReferenceCompanyFilterInput = {
  all?: InputMaybe<DatalabReferenceCompanyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DatalabReferenceCompanyFilterInput>;
  some?: InputMaybe<DatalabReferenceCompanyFilterInput>;
};

export type ListFilterInputTypeOfDatalabReleaseLockdownRunFilterInput = {
  all?: InputMaybe<DatalabReleaseLockdownRunFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DatalabReleaseLockdownRunFilterInput>;
  some?: InputMaybe<DatalabReleaseLockdownRunFilterInput>;
};

export type ListFilterInputTypeOfDocumentTypeArbitraryFieldFilterInput = {
  all?: InputMaybe<DocumentTypeArbitraryFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentTypeArbitraryFieldFilterInput>;
  some?: InputMaybe<DocumentTypeArbitraryFieldFilterInput>;
};

export type ListFilterInputTypeOfDocumentTypeFilterInput = {
  all?: InputMaybe<DocumentTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentTypeFilterInput>;
  some?: InputMaybe<DocumentTypeFilterInput>;
};

export type ListFilterInputTypeOfDocumentTypeLinkFilterInput = {
  all?: InputMaybe<DocumentTypeLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentTypeLinkFilterInput>;
  some?: InputMaybe<DocumentTypeLinkFilterInput>;
};

export type ListFilterInputTypeOfDocumentTypePairFilterInput = {
  all?: InputMaybe<DocumentTypePairFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentTypePairFilterInput>;
  some?: InputMaybe<DocumentTypePairFilterInput>;
};

export type ListFilterInputTypeOfExpenseBearerFilterInput = {
  all?: InputMaybe<ExpenseBearerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ExpenseBearerFilterInput>;
  some?: InputMaybe<ExpenseBearerFilterInput>;
};

export type ListFilterInputTypeOfExternalAuthRequestStateFilterInput = {
  all?: InputMaybe<ExternalAuthRequestStateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ExternalAuthRequestStateFilterInput>;
  some?: InputMaybe<ExternalAuthRequestStateFilterInput>;
};

export type ListFilterInputTypeOfExternalAuthTicketFilterInput = {
  all?: InputMaybe<ExternalAuthTicketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ExternalAuthTicketFilterInput>;
  some?: InputMaybe<ExternalAuthTicketFilterInput>;
};

export type ListFilterInputTypeOfFcmTokenFilterInput = {
  all?: InputMaybe<FcmTokenFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FcmTokenFilterInput>;
  some?: InputMaybe<FcmTokenFilterInput>;
};

export type ListFilterInputTypeOfFiscalizationQueueEntryFilterInput = {
  all?: InputMaybe<FiscalizationQueueEntryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FiscalizationQueueEntryFilterInput>;
  some?: InputMaybe<FiscalizationQueueEntryFilterInput>;
};

export type ListFilterInputTypeOfIBackupEventLogComputerFilterInput = {
  all?: InputMaybe<IBackupEventLogComputerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<IBackupEventLogComputerFilterInput>;
  some?: InputMaybe<IBackupEventLogComputerFilterInput>;
};

export type ListFilterInputTypeOfItemFilterInput = {
  all?: InputMaybe<ItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ItemFilterInput>;
  some?: InputMaybe<ItemFilterInput>;
};

export type ListFilterInputTypeOfItemGroupItemFilterInput = {
  all?: InputMaybe<ItemGroupItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ItemGroupItemFilterInput>;
  some?: InputMaybe<ItemGroupItemFilterInput>;
};

export type ListFilterInputTypeOfLabelDefinitionLocationFilterInput = {
  all?: InputMaybe<LabelDefinitionLocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LabelDefinitionLocationFilterInput>;
  some?: InputMaybe<LabelDefinitionLocationFilterInput>;
};

export type ListFilterInputTypeOfMarservisItemGroupMaterialFilterInput = {
  all?: InputMaybe<MarservisItemGroupMaterialFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisItemGroupMaterialFilterInput>;
  some?: InputMaybe<MarservisItemGroupMaterialFilterInput>;
};

export type ListFilterInputTypeOfMarservisWorkOrderItemFilterInput = {
  all?: InputMaybe<MarservisWorkOrderItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemFilterInput>;
};

export type ListFilterInputTypeOfMarservisWorkOrderItemItemFilterInput = {
  all?: InputMaybe<MarservisWorkOrderItemItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemItemFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemItemFilterInput>;
};

export type ListFilterInputTypeOfMarservisWorkOrderItemWorkFilterInput = {
  all?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
};

export type ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialFilterInput = {
  all?: InputMaybe<MarservisWorkOrderItemWorkMaterialFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemWorkMaterialFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemWorkMaterialFilterInput>;
};

export type ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialInputDtoFilterInput = {
  all?: InputMaybe<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>;
};

export type ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialReturnDtoFilterInput = {
  all?: InputMaybe<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
  some?: InputMaybe<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
};

export type ListFilterInputTypeOfNotificationDeliveryReportFilterInput = {
  all?: InputMaybe<NotificationDeliveryReportFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<NotificationDeliveryReportFilterInput>;
  some?: InputMaybe<NotificationDeliveryReportFilterInput>;
};

export type ListFilterInputTypeOfOnixPhoneUserTaskQueueFilterInput = {
  all?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
  some?: InputMaybe<OnixPhoneUserTaskQueueFilterInput>;
};

export type ListFilterInputTypeOfSavedFileFilterInput = {
  all?: InputMaybe<SavedFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SavedFileFilterInput>;
  some?: InputMaybe<SavedFileFilterInput>;
};

export type ListFilterInputTypeOfSupportGroupMemberFilterInput = {
  all?: InputMaybe<SupportGroupMemberFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportGroupMemberFilterInput>;
  some?: InputMaybe<SupportGroupMemberFilterInput>;
};

export type ListFilterInputTypeOfSupportOpenAiExecutionFilterInput = {
  all?: InputMaybe<SupportOpenAiExecutionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportOpenAiExecutionFilterInput>;
  some?: InputMaybe<SupportOpenAiExecutionFilterInput>;
};

export type ListFilterInputTypeOfSupportTicketFilterInput = {
  all?: InputMaybe<SupportTicketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportTicketFilterInput>;
  some?: InputMaybe<SupportTicketFilterInput>;
};

export type ListFilterInputTypeOfSupportTicketMessageFilterInput = {
  all?: InputMaybe<SupportTicketMessageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportTicketMessageFilterInput>;
  some?: InputMaybe<SupportTicketMessageFilterInput>;
};

export type ListFilterInputTypeOfSupportTicketTimeLogFilterInput = {
  all?: InputMaybe<SupportTicketTimeLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportTicketTimeLogFilterInput>;
  some?: InputMaybe<SupportTicketTimeLogFilterInput>;
};

export type ListFilterInputTypeOfSupportTicketTodoFilterInput = {
  all?: InputMaybe<SupportTicketTodoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SupportTicketTodoFilterInput>;
  some?: InputMaybe<SupportTicketTodoFilterInput>;
};

export type ListFilterInputTypeOfSynchronizationFilterInput = {
  all?: InputMaybe<SynchronizationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SynchronizationFilterInput>;
  some?: InputMaybe<SynchronizationFilterInput>;
};

export type ListFilterInputTypeOfTHeCashRegItemFilterInput = {
  all?: InputMaybe<THeCashRegItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeCashRegItemFilterInput>;
  some?: InputMaybe<THeCashRegItemFilterInput>;
};

export type ListFilterInputTypeOfTHeCostDrvFilterInput = {
  all?: InputMaybe<THeCostDrvFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeCostDrvFilterInput>;
  some?: InputMaybe<THeCostDrvFilterInput>;
};

export type ListFilterInputTypeOfTHeLinkMoveItemMoveItemFilterInput = {
  all?: InputMaybe<THeLinkMoveItemMoveItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeLinkMoveItemMoveItemFilterInput>;
  some?: InputMaybe<THeLinkMoveItemMoveItemFilterInput>;
};

export type ListFilterInputTypeOfTHeLinkMoveItemOrderItemFilterInput = {
  all?: InputMaybe<THeLinkMoveItemOrderItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeLinkMoveItemOrderItemFilterInput>;
  some?: InputMaybe<THeLinkMoveItemOrderItemFilterInput>;
};

export type ListFilterInputTypeOfTHeLinkMoveMoveFilterInput = {
  all?: InputMaybe<THeLinkMoveMoveFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeLinkMoveMoveFilterInput>;
  some?: InputMaybe<THeLinkMoveMoveFilterInput>;
};

export type ListFilterInputTypeOfTHeMoveFilterInput = {
  all?: InputMaybe<THeMoveFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveFilterInput>;
  some?: InputMaybe<THeMoveFilterInput>;
};

export type ListFilterInputTypeOfTHeMoveItemExciseFilterInput = {
  all?: InputMaybe<THeMoveItemExciseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveItemExciseFilterInput>;
  some?: InputMaybe<THeMoveItemExciseFilterInput>;
};

export type ListFilterInputTypeOfTHeMoveItemExciseOutFilterInput = {
  all?: InputMaybe<THeMoveItemExciseOutFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveItemExciseOutFilterInput>;
  some?: InputMaybe<THeMoveItemExciseOutFilterInput>;
};

export type ListFilterInputTypeOfTHeMoveItemFilterInput = {
  all?: InputMaybe<THeMoveItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveItemFilterInput>;
  some?: InputMaybe<THeMoveItemFilterInput>;
};

export type ListFilterInputTypeOfTHeMoveItemSerialNoFilterInput = {
  all?: InputMaybe<THeMoveItemSerialNoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMoveItemSerialNoFilterInput>;
  some?: InputMaybe<THeMoveItemSerialNoFilterInput>;
};

export type ListFilterInputTypeOfTHeMovePaymentRecordFilterInput = {
  all?: InputMaybe<THeMovePaymentRecordFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeMovePaymentRecordFilterInput>;
  some?: InputMaybe<THeMovePaymentRecordFilterInput>;
};

export type ListFilterInputTypeOfTHeOrderFilterInput = {
  all?: InputMaybe<THeOrderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeOrderFilterInput>;
  some?: InputMaybe<THeOrderFilterInput>;
};

export type ListFilterInputTypeOfTHeOrderItemFilterInput = {
  all?: InputMaybe<THeOrderItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeOrderItemFilterInput>;
  some?: InputMaybe<THeOrderItemFilterInput>;
};

export type ListFilterInputTypeOfTHeSetCustTariffFilterInput = {
  all?: InputMaybe<THeSetCustTariffFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetCustTariffFilterInput>;
  some?: InputMaybe<THeSetCustTariffFilterInput>;
};

export type ListFilterInputTypeOfTHeSetCustTariffSaleExFilterInput = {
  all?: InputMaybe<THeSetCustTariffSaleExFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetCustTariffSaleExFilterInput>;
  some?: InputMaybe<THeSetCustTariffSaleExFilterInput>;
};

export type ListFilterInputTypeOfTHeSetItemExciseFilterInput = {
  all?: InputMaybe<THeSetItemExciseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemExciseFilterInput>;
  some?: InputMaybe<THeSetItemExciseFilterInput>;
};

export type ListFilterInputTypeOfTHeSetItemExtItemSubjFilterInput = {
  all?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
  some?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
};

export type ListFilterInputTypeOfTHeSetItemFilterInput = {
  all?: InputMaybe<THeSetItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemFilterInput>;
  some?: InputMaybe<THeSetItemFilterInput>;
};

export type ListFilterInputTypeOfTHeSetItemPriceForWrhFilterInput = {
  all?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
  some?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
};

export type ListFilterInputTypeOfTHeSetItemSntitemFilterInput = {
  all?: InputMaybe<THeSetItemSntitemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemSntitemFilterInput>;
  some?: InputMaybe<THeSetItemSntitemFilterInput>;
};

export type ListFilterInputTypeOfTHeSetItemSntserialNoFilterInput = {
  all?: InputMaybe<THeSetItemSntserialNoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetItemSntserialNoFilterInput>;
  some?: InputMaybe<THeSetItemSntserialNoFilterInput>;
};

export type ListFilterInputTypeOfTHeSetSubjContactAddressFilterInput = {
  all?: InputMaybe<THeSetSubjContactAddressFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjContactAddressFilterInput>;
  some?: InputMaybe<THeSetSubjContactAddressFilterInput>;
};

export type ListFilterInputTypeOfTHeSetSubjContactFilterInput = {
  all?: InputMaybe<THeSetSubjContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjContactFilterInput>;
  some?: InputMaybe<THeSetSubjContactFilterInput>;
};

export type ListFilterInputTypeOfTHeSetSubjFilterInput = {
  all?: InputMaybe<THeSetSubjFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjFilterInput>;
  some?: InputMaybe<THeSetSubjFilterInput>;
};

export type ListFilterInputTypeOfTHeSetSubjPriceCategFilterInput = {
  all?: InputMaybe<THeSetSubjPriceCategFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjPriceCategFilterInput>;
  some?: InputMaybe<THeSetSubjPriceCategFilterInput>;
};

export type ListFilterInputTypeOfTHeSetSubjPriceItemFilterInput = {
  all?: InputMaybe<THeSetSubjPriceItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetSubjPriceItemFilterInput>;
  some?: InputMaybe<THeSetSubjPriceItemFilterInput>;
};

export type ListFilterInputTypeOfTHeSetTaxFilterInput = {
  all?: InputMaybe<THeSetTaxFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSetTaxFilterInput>;
  some?: InputMaybe<THeSetTaxFilterInput>;
};

export type ListFilterInputTypeOfTHeStockFilterInput = {
  all?: InputMaybe<THeStockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeStockFilterInput>;
  some?: InputMaybe<THeStockFilterInput>;
};

export type ListFilterInputTypeOfTHeStockSerialNoFilterInput = {
  all?: InputMaybe<THeStockSerialNoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeStockSerialNoFilterInput>;
  some?: InputMaybe<THeStockSerialNoFilterInput>;
};

export type ListFilterInputTypeOfTHeSubjTypeFilterInput = {
  all?: InputMaybe<THeSubjTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THeSubjTypeFilterInput>;
  some?: InputMaybe<THeSubjTypeFilterInput>;
};

export type ListFilterInputTypeOfTHfPlanFilterInput = {
  all?: InputMaybe<THfPlanFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THfPlanFilterInput>;
  some?: InputMaybe<THfPlanFilterInput>;
};

export type ListFilterInputTypeOfTHfWoexFilterInput = {
  all?: InputMaybe<THfWoexFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THfWoexFilterInput>;
  some?: InputMaybe<THfWoexFilterInput>;
};

export type ListFilterInputTypeOfTHfWoexItemFilterInput = {
  all?: InputMaybe<THfWoexItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THfWoexItemFilterInput>;
  some?: InputMaybe<THfWoexItemFilterInput>;
};

export type ListFilterInputTypeOfTHfWoexItemSerialNoFilterInput = {
  all?: InputMaybe<THfWoexItemSerialNoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THfWoexItemSerialNoFilterInput>;
  some?: InputMaybe<THfWoexItemSerialNoFilterInput>;
};

export type ListFilterInputTypeOfTHrLinkTrvlTrvlFilterInput = {
  all?: InputMaybe<THrLinkTrvlTrvlFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrLinkTrvlTrvlFilterInput>;
  some?: InputMaybe<THrLinkTrvlTrvlFilterInput>;
};

export type ListFilterInputTypeOfTHrPrsnStatusFilterInput = {
  all?: InputMaybe<THrPrsnStatusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrPrsnStatusFilterInput>;
  some?: InputMaybe<THrPrsnStatusFilterInput>;
};

export type ListFilterInputTypeOfTHrTrvlFilterInput = {
  all?: InputMaybe<THrTrvlFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrTrvlFilterInput>;
  some?: InputMaybe<THrTrvlFilterInput>;
};

export type ListFilterInputTypeOfTHrTrvlItemExpWithAttachmentFilterInput = {
  all?: InputMaybe<THrTrvlItemExpWithAttachmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrTrvlItemExpWithAttachmentFilterInput>;
  some?: InputMaybe<THrTrvlItemExpWithAttachmentFilterInput>;
};

export type ListFilterInputTypeOfTHrTrvlItemFilterInput = {
  all?: InputMaybe<THrTrvlItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<THrTrvlItemFilterInput>;
  some?: InputMaybe<THrTrvlItemFilterInput>;
};

export type ListFilterInputTypeOfTMnDocumentChatLogFilterInput = {
  all?: InputMaybe<TMnDocumentChatLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnDocumentChatLogFilterInput>;
  some?: InputMaybe<TMnDocumentChatLogFilterInput>;
};

export type ListFilterInputTypeOfTMnDocumentFilterInput = {
  all?: InputMaybe<TMnDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnDocumentFilterInput>;
  some?: InputMaybe<TMnDocumentFilterInput>;
};

export type ListFilterInputTypeOfTMnDocumentMetaDatumFilterInput = {
  all?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
  some?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
};

export type ListFilterInputTypeOfTMnFileFilterInput = {
  all?: InputMaybe<TMnFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnFileFilterInput>;
  some?: InputMaybe<TMnFileFilterInput>;
};

export type ListFilterInputTypeOfTMnLinkDocumentsWfFilterInput = {
  all?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
  some?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
};

export type ListFilterInputTypeOfTMnMailboxFilterInput = {
  all?: InputMaybe<TMnMailboxFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnMailboxFilterInput>;
  some?: InputMaybe<TMnMailboxFilterInput>;
};

export type ListFilterInputTypeOfTMnSetClassificationFilterInput = {
  all?: InputMaybe<TMnSetClassificationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnSetClassificationFilterInput>;
  some?: InputMaybe<TMnSetClassificationFilterInput>;
};

export type ListFilterInputTypeOfTMnSetClassificationMetaDatumFilterInput = {
  all?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
  some?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
};

export type ListFilterInputTypeOfTPaSetDocTypeStatFilterInput = {
  all?: InputMaybe<TPaSetDocTypeStatFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TPaSetDocTypeStatFilterInput>;
  some?: InputMaybe<TPaSetDocTypeStatFilterInput>;
};

export type ListFilterInputTypeOfTeamViewerSessionFilterInput = {
  all?: InputMaybe<TeamViewerSessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TeamViewerSessionFilterInput>;
  some?: InputMaybe<TeamViewerSessionFilterInput>;
};

export type ListFilterInputTypeOfTravelKilometersFilterInput = {
  all?: InputMaybe<TravelKilometersFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TravelKilometersFilterInput>;
  some?: InputMaybe<TravelKilometersFilterInput>;
};

export type ListFilterInputTypeOfTravelWarrantItemFilterInput = {
  all?: InputMaybe<TravelWarrantItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TravelWarrantItemFilterInput>;
  some?: InputMaybe<TravelWarrantItemFilterInput>;
};

export type ListFilterInputTypeOfTrimTHeMoveRmaworkSpecFilterInput = {
  all?: InputMaybe<TrimTHeMoveRmaworkSpecFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TrimTHeMoveRmaworkSpecFilterInput>;
  some?: InputMaybe<TrimTHeMoveRmaworkSpecFilterInput>;
};

export type ListFilterInputTypeOfUnreadUserSupportTicketMessageFilterInput = {
  all?: InputMaybe<UnreadUserSupportTicketMessageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UnreadUserSupportTicketMessageFilterInput>;
  some?: InputMaybe<UnreadUserSupportTicketMessageFilterInput>;
};

export type ListFilterInputTypeOfUserArbitrarySettingFilterInput = {
  all?: InputMaybe<UserArbitrarySettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserArbitrarySettingFilterInput>;
  some?: InputMaybe<UserArbitrarySettingFilterInput>;
};

export type ListFilterInputTypeOfWakaTimeCommitFilterInput = {
  all?: InputMaybe<WakaTimeCommitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WakaTimeCommitFilterInput>;
  some?: InputMaybe<WakaTimeCommitFilterInput>;
};

export type ListFilterInputTypeOfWakaTimeWorklogFilterInput = {
  all?: InputMaybe<WakaTimeWorklogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WakaTimeWorklogFilterInput>;
  some?: InputMaybe<WakaTimeWorklogFilterInput>;
};

export type ListFilterInputTypeOfWikiEntryCategoryFilterInput = {
  all?: InputMaybe<WikiEntryCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WikiEntryCategoryFilterInput>;
  some?: InputMaybe<WikiEntryCategoryFilterInput>;
};

export type ListFilterInputTypeOfWikiEntryFilterInput = {
  all?: InputMaybe<WikiEntryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WikiEntryFilterInput>;
  some?: InputMaybe<WikiEntryFilterInput>;
};

export type ListFilterInputTypeOfWikiEntryTagFilterInput = {
  all?: InputMaybe<WikiEntryTagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WikiEntryTagFilterInput>;
  some?: InputMaybe<WikiEntryTagFilterInput>;
};

export type ListFilterInputTypeOfWorkRecordCostTypeFilterInput = {
  all?: InputMaybe<WorkRecordCostTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkRecordCostTypeFilterInput>;
  some?: InputMaybe<WorkRecordCostTypeFilterInput>;
};

export type ListFilterInputTypeOfWorkRecordFilterInput = {
  all?: InputMaybe<WorkRecordFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkRecordFilterInput>;
  some?: InputMaybe<WorkRecordFilterInput>;
};

export type ListFilterInputTypeOfWorkRecordPeriodFilterInput = {
  all?: InputMaybe<WorkRecordPeriodFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkRecordPeriodFilterInput>;
  some?: InputMaybe<WorkRecordPeriodFilterInput>;
};

export type ListFilterInputTypeOfWorkRecordWorkHoursFilterInput = {
  all?: InputMaybe<WorkRecordWorkHoursFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkRecordWorkHoursFilterInput>;
  some?: InputMaybe<WorkRecordWorkHoursFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LocationStructureInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type LoginModelInput = {
  password: Scalars['String'];
  takeLicense?: InputMaybe<Scalars['Boolean']>;
  userNameOrEmail: Scalars['String'];
};

export type MarservisItemGroupMaterial = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  itemGroup?: Maybe<ItemGroup>;
  itemGroupId: Scalars['Int'];
  material?: Maybe<MarservisMaterial>;
  materialId: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
};

export type MarservisItemGroupMaterialFilterInput = {
  and?: InputMaybe<Array<MarservisItemGroupMaterialFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemGroup?: InputMaybe<ItemGroupFilterInput>;
  itemGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  material?: InputMaybe<MarservisMaterialFilterInput>;
  materialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<MarservisItemGroupMaterialFilterInput>>;
};

export type MarservisLocalWorkOrderReturnDto = {
  date: Scalars['DateTime'];
  dateEnd: Scalars['DateTime'];
  documentNumber: Scalars['Int'];
  hasFiles: Scalars['Boolean'];
  hasMaterials: Scalars['Boolean'];
  hasUserFiles: Scalars['Boolean'];
  hasUserNotes: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  project?: Maybe<MarservisLocalWorkOrderReturnProjectDto>;
  projectId: Scalars['Int'];
  status: MarservisWorkOrderStatusEnum;
  subject?: Maybe<MarservisLocalWorkOrderReturnSubjectDto>;
  subjectId?: Maybe<Scalars['Int']>;
};

export type MarservisLocalWorkOrderReturnDtoFilterInput = {
  and?: InputMaybe<Array<MarservisLocalWorkOrderReturnDtoFilterInput>>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dateEnd?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  documentNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  hasFiles?: InputMaybe<BooleanOperationFilterInput>;
  hasMaterials?: InputMaybe<BooleanOperationFilterInput>;
  hasUserFiles?: InputMaybe<BooleanOperationFilterInput>;
  hasUserNotes?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisLocalWorkOrderReturnDtoFilterInput>>;
  project?: InputMaybe<MarservisLocalWorkOrderReturnProjectDtoFilterInput>;
  projectId?: InputMaybe<ComparableInt32OperationFilterInput>;
  status?: InputMaybe<MarservisWorkOrderStatusEnumOperationFilterInput>;
  subject?: InputMaybe<MarservisLocalWorkOrderReturnSubjectDtoFilterInput>;
  subjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type MarservisLocalWorkOrderReturnDtoSortInput = {
  date?: InputMaybe<SortEnumType>;
  dateEnd?: InputMaybe<SortEnumType>;
  documentNumber?: InputMaybe<SortEnumType>;
  hasFiles?: InputMaybe<SortEnumType>;
  hasMaterials?: InputMaybe<SortEnumType>;
  hasUserFiles?: InputMaybe<SortEnumType>;
  hasUserNotes?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  project?: InputMaybe<MarservisLocalWorkOrderReturnProjectDtoSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<MarservisLocalWorkOrderReturnSubjectDtoSortInput>;
  subjectId?: InputMaybe<SortEnumType>;
};

export type MarservisLocalWorkOrderReturnProjectDto = {
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<MarservisLocalWorkOrderReturnProjectDtoSubjectDto>;
};

export type MarservisLocalWorkOrderReturnProjectDtoFilterInput = {
  and?: InputMaybe<Array<MarservisLocalWorkOrderReturnProjectDtoFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisLocalWorkOrderReturnProjectDtoFilterInput>>;
  subject?: InputMaybe<MarservisLocalWorkOrderReturnProjectDtoSubjectDtoFilterInput>;
};

export type MarservisLocalWorkOrderReturnProjectDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<MarservisLocalWorkOrderReturnProjectDtoSubjectDtoSortInput>;
};

export type MarservisLocalWorkOrderReturnProjectDtoSubjectDto = {
  shortName?: Maybe<Scalars['String']>;
};

export type MarservisLocalWorkOrderReturnProjectDtoSubjectDtoFilterInput = {
  and?: InputMaybe<Array<MarservisLocalWorkOrderReturnProjectDtoSubjectDtoFilterInput>>;
  or?: InputMaybe<Array<MarservisLocalWorkOrderReturnProjectDtoSubjectDtoFilterInput>>;
  shortName?: InputMaybe<StringOperationFilterInput>;
};

export type MarservisLocalWorkOrderReturnProjectDtoSubjectDtoSortInput = {
  shortName?: InputMaybe<SortEnumType>;
};

export type MarservisLocalWorkOrderReturnSubjectDto = {
  id: Scalars['Int'];
  longName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

export type MarservisLocalWorkOrderReturnSubjectDtoFilterInput = {
  and?: InputMaybe<Array<MarservisLocalWorkOrderReturnSubjectDtoFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  longName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisLocalWorkOrderReturnSubjectDtoFilterInput>>;
  shortName?: InputMaybe<StringOperationFilterInput>;
};

export type MarservisLocalWorkOrderReturnSubjectDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  longName?: InputMaybe<SortEnumType>;
  shortName?: InputMaybe<SortEnumType>;
};

export type MarservisMaterial = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  itemGroupMaterials?: Maybe<Array<Maybe<MarservisItemGroupMaterial>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  normalizedName?: Maybe<Scalars['String']>;
  normalizedUnitOfMeasure?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  workUsages?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkMaterial>>>;
};

export type MarservisMaterialFilterInput = {
  and?: InputMaybe<Array<MarservisMaterialFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemGroupMaterials?: InputMaybe<ListFilterInputTypeOfMarservisItemGroupMaterialFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  normalizedName?: InputMaybe<StringOperationFilterInput>;
  normalizedUnitOfMeasure?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisMaterialFilterInput>>;
  unitOfMeasure?: InputMaybe<StringOperationFilterInput>;
  workUsages?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialFilterInput>;
};

export type MarservisMaterialReturnDto = {
  id: Scalars['Int'];
  name: Scalars['String'];
  unitOfMeasure: Scalars['String'];
};

export type MarservisSavedFile = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  workOrderId?: Maybe<Scalars['String']>;
};

export type MarservisSavedFileFilterInput = {
  and?: InputMaybe<Array<MarservisSavedFileFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisSavedFileFilterInput>>;
  workOrderId?: InputMaybe<StringOperationFilterInput>;
};

export type MarservisSavedFileSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  workOrderId?: InputMaybe<SortEnumType>;
};

export type MarservisUserMobileWorkOrderItemDto = {
  deadlineDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  itemCode?: Maybe<Scalars['String']>;
  itemGroupId?: Maybe<Scalars['Int']>;
  itemGroupName?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['Int']>;
  itemName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['Int']>;
  projectName?: Maybe<Scalars['String']>;
  status: MarservisWorkOrderItemStatusEnum;
  subjectId?: Maybe<Scalars['Int']>;
  subjectLongName?: Maybe<Scalars['String']>;
  subjectShortName?: Maybe<Scalars['String']>;
  unfinishedItems?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  workOrderDateEnd?: Maybe<Scalars['DateTime']>;
  workOrderId?: Maybe<Scalars['String']>;
  workOrderLocation?: Maybe<Scalars['String']>;
  workOrderStatus?: Maybe<MarservisWorkOrderStatusEnum>;
};

export type MarservisUserMobileWorkOrderItemDtoFilterInput = {
  and?: InputMaybe<Array<MarservisUserMobileWorkOrderItemDtoFilterInput>>;
  deadlineDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  itemGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  itemGroupName?: InputMaybe<StringOperationFilterInput>;
  itemId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  itemName?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisUserMobileWorkOrderItemDtoFilterInput>>;
  projectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  projectName?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<MarservisWorkOrderItemStatusEnumOperationFilterInput>;
  subjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  subjectLongName?: InputMaybe<StringOperationFilterInput>;
  subjectShortName?: InputMaybe<StringOperationFilterInput>;
  unfinishedItems?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  workOrderDateEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  workOrderId?: InputMaybe<StringOperationFilterInput>;
  workOrderLocation?: InputMaybe<StringOperationFilterInput>;
  workOrderStatus?: InputMaybe<NullableOfMarservisWorkOrderStatusEnumOperationFilterInput>;
};

export type MarservisUserMobileWorkOrderItemDtoSortInput = {
  deadlineDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  itemCode?: InputMaybe<SortEnumType>;
  itemGroupId?: InputMaybe<SortEnumType>;
  itemGroupName?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  itemName?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
  projectName?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  subjectId?: InputMaybe<SortEnumType>;
  subjectLongName?: InputMaybe<SortEnumType>;
  subjectShortName?: InputMaybe<SortEnumType>;
  unfinishedItems?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  workOrderDateEnd?: InputMaybe<SortEnumType>;
  workOrderId?: InputMaybe<SortEnumType>;
  workOrderLocation?: InputMaybe<SortEnumType>;
  workOrderStatus?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MarservisUserWorkOrderAllItemsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<MarservisUserWorkOrderAllItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<MarservisUserMobileWorkOrderItemDto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MarservisUserWorkOrderAllItemsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MarservisUserMobileWorkOrderItemDto>;
};

/** A connection to a list of items. */
export type MarservisUserWorkOrderItemsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<MarservisUserWorkOrderItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<MarservisUserMobileWorkOrderItemDto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MarservisUserWorkOrderItemsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MarservisUserMobileWorkOrderItemDto>;
};

/** A connection to a list of items. */
export type MarservisUserWorkOrdersConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<MarservisUserWorkOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<MarservisLocalWorkOrderReturnDto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MarservisUserWorkOrdersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MarservisLocalWorkOrderReturnDto>;
};

export type MarservisWorkOrder = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  dateEnd: Scalars['DateTime'];
  documentNumber: Scalars['Int'];
  files?: Maybe<Array<Maybe<SavedFile>>>;
  id?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<MarservisWorkOrderItem>>>;
  location?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  projectId: Scalars['Int'];
  status: MarservisWorkOrderStatusEnum;
};

export type MarservisWorkOrderFilterInput = {
  and?: InputMaybe<Array<MarservisWorkOrderFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dateEnd?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  documentNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  files?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<ComparableInt32OperationFilterInput>;
  status?: InputMaybe<MarservisWorkOrderStatusEnumOperationFilterInput>;
};

export type MarservisWorkOrderItem = {
  billableTime: Scalars['TimeSpan'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deadlineDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  item?: Maybe<Item>;
  itemGroup?: Maybe<ItemGroup>;
  itemGroupId?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<MarservisWorkOrderItemItem>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  status: MarservisWorkOrderItemStatusEnum;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  workOrder?: Maybe<MarservisWorkOrder>;
  workOrderId?: Maybe<Scalars['String']>;
  works?: Maybe<Array<Maybe<MarservisWorkOrderItemWork>>>;
};

export type MarservisWorkOrderItemFilterInput = {
  and?: InputMaybe<Array<MarservisWorkOrderItemFilterInput>>;
  billableTime?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deadlineDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  item?: InputMaybe<ItemFilterInput>;
  itemGroup?: InputMaybe<ItemGroupFilterInput>;
  itemGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  itemId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemItemFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemFilterInput>>;
  status?: InputMaybe<MarservisWorkOrderItemStatusEnumOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  workOrder?: InputMaybe<MarservisWorkOrderFilterInput>;
  workOrderId?: InputMaybe<StringOperationFilterInput>;
  works?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkFilterInput>;
};

export type MarservisWorkOrderItemItem = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  finished: Scalars['Boolean'];
  id: Scalars['Int'];
  item?: Maybe<Item>;
  itemId: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  workOrderItem?: Maybe<MarservisWorkOrderItem>;
  workOrderItemId: Scalars['Int'];
};

export type MarservisWorkOrderItemItemFilterInput = {
  and?: InputMaybe<Array<MarservisWorkOrderItemItemFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  finished?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  item?: InputMaybe<ItemFilterInput>;
  itemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemItemFilterInput>>;
  workOrderItem?: InputMaybe<MarservisWorkOrderItemFilterInput>;
  workOrderItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type MarservisWorkOrderItemItemSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  finished?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  item?: InputMaybe<ItemSortInput>;
  itemId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  workOrderItem?: InputMaybe<MarservisWorkOrderItemSortInput>;
  workOrderItemId?: InputMaybe<SortEnumType>;
};

export type MarservisWorkOrderItemSortInput = {
  billableTime?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  deadlineDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  item?: InputMaybe<ItemSortInput>;
  itemGroup?: InputMaybe<ItemGroupSortInput>;
  itemGroupId?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  workOrder?: InputMaybe<MarservisWorkOrderSortInput>;
  workOrderId?: InputMaybe<SortEnumType>;
};

export enum MarservisWorkOrderItemStatusEnum {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  NotDone = 'NOT_DONE'
}

export type MarservisWorkOrderItemStatusEnumOperationFilterInput = {
  eq?: InputMaybe<MarservisWorkOrderItemStatusEnum>;
  in?: InputMaybe<Array<MarservisWorkOrderItemStatusEnum>>;
  neq?: InputMaybe<MarservisWorkOrderItemStatusEnum>;
  nin?: InputMaybe<Array<MarservisWorkOrderItemStatusEnum>>;
};

export type MarservisWorkOrderItemWork = {
  cause?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  files?: Maybe<Array<Maybe<SavedFile>>>;
  id: Scalars['Int'];
  materialUsageDetails?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkMaterialReturnDto>>>;
  materialUsages?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkMaterial>>>;
  materials?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  remedy?: Maybe<Scalars['String']>;
  time: Scalars['TimeSpan'];
  workOrderItem?: Maybe<MarservisWorkOrderItem>;
  workOrderItemId: Scalars['Int'];
};

export type MarservisWorkOrderItemWorkDtoInput = {
  cause?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  materialUsages?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialInputDtoInput>>;
  materials?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  remedy?: InputMaybe<Scalars['String']>;
  time: Scalars['TimeSpan'];
  uniqueClientId?: InputMaybe<Scalars['String']>;
  workOrderItemId: Scalars['Int'];
};

export type MarservisWorkOrderItemWorkFilterInput = {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkFilterInput>>;
  cause?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  files?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  materialUsageDetails?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
  materialUsages?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialFilterInput>;
  materials?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkFilterInput>>;
  remedy?: InputMaybe<StringOperationFilterInput>;
  time?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  workOrderItem?: InputMaybe<MarservisWorkOrderItemFilterInput>;
  workOrderItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type MarservisWorkOrderItemWorkMaterial = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  material?: Maybe<MarservisMaterial>;
  materialId: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  quantity: Scalars['Decimal'];
  workOrderItemWork?: Maybe<MarservisWorkOrderItemWork>;
  workOrderItemWorkId: Scalars['Int'];
};

export type MarservisWorkOrderItemWorkMaterialFilterInput = {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  material?: InputMaybe<MarservisMaterialFilterInput>;
  materialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialFilterInput>>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  workOrderItemWork?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
  workOrderItemWorkId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type MarservisWorkOrderItemWorkMaterialInputDto = {
  materialId: Scalars['Int'];
  quantity: Scalars['Decimal'];
};

export type MarservisWorkOrderItemWorkMaterialInputDtoFilterInput = {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>>;
  materialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialInputDtoFilterInput>>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
};

export type MarservisWorkOrderItemWorkMaterialInputDtoInput = {
  materialId: Scalars['Int'];
  quantity: Scalars['Decimal'];
};

export type MarservisWorkOrderItemWorkMaterialReturnDto = {
  id: Scalars['Int'];
  materialId: Scalars['Int'];
  materialName?: Maybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
  unitOfMeasure?: Maybe<Scalars['String']>;
};

export type MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput = {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  materialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  materialName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  unitOfMeasure?: InputMaybe<StringOperationFilterInput>;
};

export type MarservisWorkOrderItemWorkMaterialReturnDtoInput = {
  id: Scalars['Int'];
  materialId: Scalars['Int'];
  materialName?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
  unitOfMeasure?: InputMaybe<Scalars['String']>;
};

export type MarservisWorkOrderItemWorkSortInput = {
  cause?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  materials?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  remedy?: InputMaybe<SortEnumType>;
  time?: InputMaybe<SortEnumType>;
  workOrderItem?: InputMaybe<MarservisWorkOrderItemSortInput>;
  workOrderItemId?: InputMaybe<SortEnumType>;
};

export type MarservisWorkOrderItemWorkWithoutFilesReturnDto = {
  cause?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  materialUsageDetails?: Maybe<Array<Maybe<MarservisWorkOrderItemWorkMaterialReturnDto>>>;
  materialUsages?: Maybe<Array<MarservisWorkOrderItemWorkMaterialInputDto>>;
  materials?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  remedy?: Maybe<Scalars['String']>;
  time: Scalars['TimeSpan'];
  workOrderItemId: Scalars['Int'];
};

export type MarservisWorkOrderItemWorkWithoutFilesReturnDtoFilterInput = {
  and?: InputMaybe<Array<MarservisWorkOrderItemWorkWithoutFilesReturnDtoFilterInput>>;
  cause?: InputMaybe<StringOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  materialUsageDetails?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialReturnDtoFilterInput>;
  materialUsages?: InputMaybe<ListFilterInputTypeOfMarservisWorkOrderItemWorkMaterialInputDtoFilterInput>;
  materials?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MarservisWorkOrderItemWorkWithoutFilesReturnDtoFilterInput>>;
  remedy?: InputMaybe<StringOperationFilterInput>;
  time?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  workOrderItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput = {
  cause?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  materialUsageDetails?: InputMaybe<Array<InputMaybe<MarservisWorkOrderItemWorkMaterialReturnDtoInput>>>;
  materialUsages?: InputMaybe<Array<MarservisWorkOrderItemWorkMaterialInputDtoInput>>;
  materials?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  remedy?: InputMaybe<Scalars['String']>;
  time: Scalars['TimeSpan'];
  workOrderItemId: Scalars['Int'];
};

export type MarservisWorkOrderItemWorkWithoutFilesReturnDtoSortInput = {
  cause?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  materials?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  remedy?: InputMaybe<SortEnumType>;
  time?: InputMaybe<SortEnumType>;
  workOrderItemId?: InputMaybe<SortEnumType>;
};

export type MarservisWorkOrderSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  dateEnd?: InputMaybe<SortEnumType>;
  documentNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export enum MarservisWorkOrderStatusEnum {
  Done = 'DONE',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  NotDone = 'NOT_DONE'
}

export type MarservisWorkOrderStatusEnumOperationFilterInput = {
  eq?: InputMaybe<MarservisWorkOrderStatusEnum>;
  in?: InputMaybe<Array<MarservisWorkOrderStatusEnum>>;
  neq?: InputMaybe<MarservisWorkOrderStatusEnum>;
  nin?: InputMaybe<Array<MarservisWorkOrderStatusEnum>>;
};

export type McpApiKeyDto = {
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  keyPrefix?: Maybe<Scalars['String']>;
  kind: McpApiKeyKind;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  revokedAt?: Maybe<Scalars['DateTime']>;
};

export type McpApiKeyEntitlementsDto = {
  canCreateOnixServerKey: Scalars['Boolean'];
  canCreateSupportKey: Scalars['Boolean'];
  onixServerPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  supportPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum McpApiKeyKind {
  OnixServer = 'ONIX_SERVER',
  Support = 'SUPPORT'
}

export type MobileSettings = {
  a4PrinterURL?: Maybe<Scalars['String']>;
  bluetoothPrinterAddress?: Maybe<Scalars['String']>;
  bluetoothPrinterArbitrarySettings?: Maybe<Array<KeyValuePairOfStringAndString>>;
  bluetoothPrinterBoldMode?: Maybe<Scalars['Boolean']>;
  bluetoothPrinterName?: Maybe<Scalars['String']>;
  bluetoothPrinterPaperWidth?: Maybe<Scalars['Int']>;
  bluetoothPrinterPrintSpeed?: Maybe<Scalars['Int']>;
  bluetoothPrinterType?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  detailedLogging?: Maybe<Scalars['Boolean']>;
  featureFlag?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  mobileMenuV3?: Maybe<Scalars['Boolean']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  thermalPrinterPrintVerticalPDF417?: Maybe<Scalars['Boolean']>;
  useDarkTheme: Scalars['Boolean'];
  useDocumentTypeCodesInTitles?: Maybe<Scalars['Boolean']>;
  useFilteredOfflineCodebooks?: Maybe<Scalars['Boolean']>;
  useKeyboardBarcodeScanner?: Maybe<Scalars['Boolean']>;
  useListViewOnPickers: Scalars['Boolean'];
  useOnlyShortcuts: Scalars['Boolean'];
  useTabletMode?: Maybe<Scalars['Boolean']>;
  useWiderColumns?: Maybe<Scalars['Boolean']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  userMobileMenuV4?: Maybe<Scalars['Boolean']>;
};

export type MobileSettingsFilterInput = {
  a4PrinterURL?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<MobileSettingsFilterInput>>;
  bluetoothPrinterAddress?: InputMaybe<StringOperationFilterInput>;
  bluetoothPrinterArbitrarySettings?: InputMaybe<DictionaryOfStringAndStringFilterInput>;
  bluetoothPrinterBoldMode?: InputMaybe<BooleanOperationFilterInput>;
  bluetoothPrinterName?: InputMaybe<StringOperationFilterInput>;
  bluetoothPrinterPaperWidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bluetoothPrinterPrintSpeed?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bluetoothPrinterType?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  detailedLogging?: InputMaybe<BooleanOperationFilterInput>;
  featureFlag?: InputMaybe<BooleanOperationFilterInput>;
  language?: InputMaybe<StringOperationFilterInput>;
  mobileMenuV3?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<MobileSettingsFilterInput>>;
  thermalPrinterPrintVerticalPDF417?: InputMaybe<BooleanOperationFilterInput>;
  useDarkTheme?: InputMaybe<BooleanOperationFilterInput>;
  useDocumentTypeCodesInTitles?: InputMaybe<BooleanOperationFilterInput>;
  useFilteredOfflineCodebooks?: InputMaybe<BooleanOperationFilterInput>;
  useKeyboardBarcodeScanner?: InputMaybe<BooleanOperationFilterInput>;
  useListViewOnPickers?: InputMaybe<BooleanOperationFilterInput>;
  useOnlyShortcuts?: InputMaybe<BooleanOperationFilterInput>;
  useTabletMode?: InputMaybe<BooleanOperationFilterInput>;
  useWiderColumns?: InputMaybe<BooleanOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  userMobileMenuV4?: InputMaybe<BooleanOperationFilterInput>;
};

export type MobileSettingsSortInput = {
  a4PrinterURL?: InputMaybe<SortEnumType>;
  bluetoothPrinterAddress?: InputMaybe<SortEnumType>;
  bluetoothPrinterBoldMode?: InputMaybe<SortEnumType>;
  bluetoothPrinterName?: InputMaybe<SortEnumType>;
  bluetoothPrinterPaperWidth?: InputMaybe<SortEnumType>;
  bluetoothPrinterPrintSpeed?: InputMaybe<SortEnumType>;
  bluetoothPrinterType?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  detailedLogging?: InputMaybe<SortEnumType>;
  featureFlag?: InputMaybe<SortEnumType>;
  language?: InputMaybe<SortEnumType>;
  mobileMenuV3?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  thermalPrinterPrintVerticalPDF417?: InputMaybe<SortEnumType>;
  useDarkTheme?: InputMaybe<SortEnumType>;
  useDocumentTypeCodesInTitles?: InputMaybe<SortEnumType>;
  useFilteredOfflineCodebooks?: InputMaybe<SortEnumType>;
  useKeyboardBarcodeScanner?: InputMaybe<SortEnumType>;
  useListViewOnPickers?: InputMaybe<SortEnumType>;
  useOnlyShortcuts?: InputMaybe<SortEnumType>;
  useTabletMode?: InputMaybe<SortEnumType>;
  useWiderColumns?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  userMobileMenuV4?: InputMaybe<SortEnumType>;
};

export type MobileSettingsUpdateDtoInput = {
  a4PrinterURL?: InputMaybe<Scalars['String']>;
  bluetoothPrinterAddress?: InputMaybe<Scalars['String']>;
  bluetoothPrinterArbitrarySettings?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  bluetoothPrinterBoldMode?: InputMaybe<Scalars['Boolean']>;
  bluetoothPrinterName?: InputMaybe<Scalars['String']>;
  bluetoothPrinterPaperWidth?: InputMaybe<Scalars['Int']>;
  bluetoothPrinterPrintSpeed?: InputMaybe<Scalars['Int']>;
  bluetoothPrinterType?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  thermalPrinterPrintVerticalPDF417?: InputMaybe<Scalars['Boolean']>;
  useDarkTheme: Scalars['Boolean'];
  useDocumentTypeCodesInTitles?: InputMaybe<Scalars['Boolean']>;
  useListViewOnPickers: Scalars['Boolean'];
  useOnlyShortcuts: Scalars['Boolean'];
  useTabletMode?: InputMaybe<Scalars['Boolean']>;
  useWiderColumns?: InputMaybe<Scalars['Boolean']>;
};

export type NewVersionDto = {
  platform?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type NewVersionDtoInput = {
  platform?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type NotificationDeliveryReport = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  fCMToken?: Maybe<FcmToken>;
  fCMTokenId: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notificationType?: Maybe<Scalars['String']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
};

export type NotificationDeliveryReportFilterInput = {
  and?: InputMaybe<Array<NotificationDeliveryReportFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  fCMToken?: InputMaybe<FcmTokenFilterInput>;
  fCMTokenId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notificationType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NotificationDeliveryReportFilterInput>>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export enum NotificationType {
  AgentFinishedTaskOnTicket = 'AGENT_FINISHED_TASK_ON_TICKET',
  AiInvestigationUpdate = 'AI_INVESTIGATION_UPDATE',
  ChatGptTicketRecommendation = 'CHAT_GPT_TICKET_RECOMMENDATION',
  ContactResponded = 'CONTACT_RESPONDED',
  NewSupportTicket = 'NEW_SUPPORT_TICKET',
  NewTask = 'NEW_TASK',
  UserMentionedYou = 'USER_MENTIONED_YOU'
}

export type NotificationTypeOperationFilterInput = {
  eq?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  neq?: InputMaybe<NotificationType>;
  nin?: InputMaybe<Array<NotificationType>>;
};

export type NullableOfArbitraryFieldEntryTypeOperationFilterInput = {
  eq?: InputMaybe<ArbitraryFieldEntryType>;
  in?: InputMaybe<Array<InputMaybe<ArbitraryFieldEntryType>>>;
  neq?: InputMaybe<ArbitraryFieldEntryType>;
  nin?: InputMaybe<Array<InputMaybe<ArbitraryFieldEntryType>>>;
};

export type NullableOfArbitraryFieldLocationEnumOperationFilterInput = {
  eq?: InputMaybe<ArbitraryFieldLocationEnum>;
  in?: InputMaybe<Array<InputMaybe<ArbitraryFieldLocationEnum>>>;
  neq?: InputMaybe<ArbitraryFieldLocationEnum>;
  nin?: InputMaybe<Array<InputMaybe<ArbitraryFieldLocationEnum>>>;
};

export type NullableOfAresDeploymentExecutionPhaseOperationFilterInput = {
  eq?: InputMaybe<AresDeploymentExecutionPhase>;
  in?: InputMaybe<Array<InputMaybe<AresDeploymentExecutionPhase>>>;
  neq?: InputMaybe<AresDeploymentExecutionPhase>;
  nin?: InputMaybe<Array<InputMaybe<AresDeploymentExecutionPhase>>>;
};

export type NullableOfCardPaymentProviderOperationFilterInput = {
  eq?: InputMaybe<CardPaymentProvider>;
  in?: InputMaybe<Array<InputMaybe<CardPaymentProvider>>>;
  neq?: InputMaybe<CardPaymentProvider>;
  nin?: InputMaybe<Array<InputMaybe<CardPaymentProvider>>>;
};

export type NullableOfClientEnumOperationFilterInput = {
  eq?: InputMaybe<ClientEnum>;
  in?: InputMaybe<Array<InputMaybe<ClientEnum>>>;
  neq?: InputMaybe<ClientEnum>;
  nin?: InputMaybe<Array<InputMaybe<ClientEnum>>>;
};

export type NullableOfDateFilterTypeOperationFilterInput = {
  eq?: InputMaybe<DateFilterType>;
  in?: InputMaybe<Array<InputMaybe<DateFilterType>>>;
  neq?: InputMaybe<DateFilterType>;
  nin?: InputMaybe<Array<InputMaybe<DateFilterType>>>;
};

export type NullableOfDeploymentGroupStepTriggerTypeOperationFilterInput = {
  eq?: InputMaybe<DeploymentGroupStepTriggerType>;
  in?: InputMaybe<Array<InputMaybe<DeploymentGroupStepTriggerType>>>;
  neq?: InputMaybe<DeploymentGroupStepTriggerType>;
  nin?: InputMaybe<Array<InputMaybe<DeploymentGroupStepTriggerType>>>;
};

export type NullableOfInvoiceSumTypeOperationFilterInput = {
  eq?: InputMaybe<InvoiceSumType>;
  in?: InputMaybe<Array<InputMaybe<InvoiceSumType>>>;
  neq?: InputMaybe<InvoiceSumType>;
  nin?: InputMaybe<Array<InputMaybe<InvoiceSumType>>>;
};

export type NullableOfMarservisWorkOrderStatusEnumOperationFilterInput = {
  eq?: InputMaybe<MarservisWorkOrderStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<MarservisWorkOrderStatusEnum>>>;
  neq?: InputMaybe<MarservisWorkOrderStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<MarservisWorkOrderStatusEnum>>>;
};

export type NullableOfOnixTenantOperationFilterInput = {
  eq?: InputMaybe<OnixTenant>;
  in?: InputMaybe<Array<InputMaybe<OnixTenant>>>;
  neq?: InputMaybe<OnixTenant>;
  nin?: InputMaybe<Array<InputMaybe<OnixTenant>>>;
};

export type NullableOfSupportAiThreadItemPhaseOperationFilterInput = {
  eq?: InputMaybe<SupportAiThreadItemPhase>;
  in?: InputMaybe<Array<InputMaybe<SupportAiThreadItemPhase>>>;
  neq?: InputMaybe<SupportAiThreadItemPhase>;
  nin?: InputMaybe<Array<InputMaybe<SupportAiThreadItemPhase>>>;
};

export type NullableOfSupportAiThreadItemRoleOperationFilterInput = {
  eq?: InputMaybe<SupportAiThreadItemRole>;
  in?: InputMaybe<Array<InputMaybe<SupportAiThreadItemRole>>>;
  neq?: InputMaybe<SupportAiThreadItemRole>;
  nin?: InputMaybe<Array<InputMaybe<SupportAiThreadItemRole>>>;
};

export type NullableOfTHeMovePagedSortFieldOperationFilterInput = {
  eq?: InputMaybe<THeMovePagedSortField>;
  in?: InputMaybe<Array<InputMaybe<THeMovePagedSortField>>>;
  neq?: InputMaybe<THeMovePagedSortField>;
  nin?: InputMaybe<Array<InputMaybe<THeMovePagedSortField>>>;
};

export type NullableOfTHeOrderPagedSortFieldOperationFilterInput = {
  eq?: InputMaybe<THeOrderPagedSortField>;
  in?: InputMaybe<Array<InputMaybe<THeOrderPagedSortField>>>;
  neq?: InputMaybe<THeOrderPagedSortField>;
  nin?: InputMaybe<Array<InputMaybe<THeOrderPagedSortField>>>;
};

export type NullableOfTHfWoexPagedSortFieldOperationFilterInput = {
  eq?: InputMaybe<THfWoexPagedSortField>;
  in?: InputMaybe<Array<InputMaybe<THfWoexPagedSortField>>>;
  neq?: InputMaybe<THfWoexPagedSortField>;
  nin?: InputMaybe<Array<InputMaybe<THfWoexPagedSortField>>>;
};

export type OfficialVehicle = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isDeactivated: Scalars['Boolean'];
  makeAndModel?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonId?: Maybe<Scalars['String']>;
  registration?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
};

export type OfficialVehicleFilterInput = {
  and?: InputMaybe<Array<OfficialVehicleFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeactivated?: InputMaybe<BooleanOperationFilterInput>;
  makeAndModel?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OfficialVehicleFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  registration?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type OfficialVehicleSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeactivated?: InputMaybe<SortEnumType>;
  makeAndModel?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  registration?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
};

export type OkWorkOrderAcKeyResult = {
  acKey?: Maybe<Scalars['String']>;
};

export type OkWorkOrderAnKeyResult = {
  acKey?: Maybe<Scalars['String']>;
  anKey: Scalars['Long'];
};

export type OkWorkOrderAnNoResult = {
  acKey?: Maybe<Scalars['String']>;
  anNo: Scalars['Int'];
};

export type OnixPhoneAdditionalReportData = {
  jsonSchema?: Maybe<Scalars['String']>;
  reportAddCompanySignature: Scalars['Boolean'];
  reportBccAddress?: Maybe<Scalars['String']>;
  reportTitle?: Maybe<Scalars['String']>;
  reportUserSignatureText?: Maybe<Scalars['String']>;
  reportUserSignsTheDocument: Scalars['Boolean'];
  uISchema?: Maybe<Scalars['String']>;
};

export type OnixPhoneAdditionalReportDataFilterInput = {
  and?: InputMaybe<Array<OnixPhoneAdditionalReportDataFilterInput>>;
  jsonSchema?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OnixPhoneAdditionalReportDataFilterInput>>;
  reportAddCompanySignature?: InputMaybe<BooleanOperationFilterInput>;
  reportBccAddress?: InputMaybe<StringOperationFilterInput>;
  reportTitle?: InputMaybe<StringOperationFilterInput>;
  reportUserSignatureText?: InputMaybe<StringOperationFilterInput>;
  reportUserSignsTheDocument?: InputMaybe<BooleanOperationFilterInput>;
  uISchema?: InputMaybe<StringOperationFilterInput>;
};

export type OnixPhoneAdditionalReportDataSortInput = {
  jsonSchema?: InputMaybe<SortEnumType>;
  reportAddCompanySignature?: InputMaybe<SortEnumType>;
  reportBccAddress?: InputMaybe<SortEnumType>;
  reportTitle?: InputMaybe<SortEnumType>;
  reportUserSignatureText?: InputMaybe<SortEnumType>;
  reportUserSignsTheDocument?: InputMaybe<SortEnumType>;
  uISchema?: InputMaybe<SortEnumType>;
};

export type OnixPhoneKeyValueStorage = {
  context?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDeletable?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userDocId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Scalars['Byte']>>;
  version?: Maybe<Scalars['String']>;
};

export type OnixPhoneKeyValueStorageInput = {
  context?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDeletable?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userDocId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Array<Scalars['Byte']>>;
  version?: InputMaybe<Scalars['String']>;
};

export enum OnixPhoneUserTaskEnum {
  ExecuteSqLiteSql = 'EXECUTE_SQ_LITE_SQL',
  ShowMessageToUser = 'SHOW_MESSAGE_TO_USER',
  UpdateUserSettings = 'UPDATE_USER_SETTINGS',
  UploadSqLiteDatabase = 'UPLOAD_SQ_LITE_DATABASE'
}

export type OnixPhoneUserTaskEnumOperationFilterInput = {
  eq?: InputMaybe<OnixPhoneUserTaskEnum>;
  in?: InputMaybe<Array<OnixPhoneUserTaskEnum>>;
  neq?: InputMaybe<OnixPhoneUserTaskEnum>;
  nin?: InputMaybe<Array<OnixPhoneUserTaskEnum>>;
};

export type OnixPhoneUserTaskQueue = {
  campaignId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  failed: Scalars['Boolean'];
  id: Scalars['Int'];
  isCompleted: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  nofityAdminOnCompletion: Scalars['Boolean'];
  response?: Maybe<Scalars['String']>;
  task: OnixPhoneUserTaskEnum;
  taskData?: Maybe<Scalars['String']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
};

export type OnixPhoneUserTaskQueueFilterInput = {
  and?: InputMaybe<Array<OnixPhoneUserTaskQueueFilterInput>>;
  campaignId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  failed?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isCompleted?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  nofityAdminOnCompletion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OnixPhoneUserTaskQueueFilterInput>>;
  response?: InputMaybe<StringOperationFilterInput>;
  task?: InputMaybe<OnixPhoneUserTaskEnumOperationFilterInput>;
  taskData?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  validFrom?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  validTo?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
};

export type OnixPhoneUserTaskQueueSortInput = {
  campaignId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  failed?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isCompleted?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  nofityAdminOnCompletion?: InputMaybe<SortEnumType>;
  response?: InputMaybe<SortEnumType>;
  task?: InputMaybe<SortEnumType>;
  taskData?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  validFrom?: InputMaybe<SortEnumType>;
  validTo?: InputMaybe<SortEnumType>;
};

export enum OnixTenant {
  Cak = 'CAK',
  Cortina = 'CORTINA',
  Danieli = 'DANIELI',
  Dimeglio = 'DIMEGLIO',
  Eikonstudio = 'EIKONSTUDIO',
  Euronewpack = 'EURONEWPACK',
  KastavGrupa = 'KASTAV_GRUPA',
  Kompakt = 'KOMPAKT',
  Linea = 'LINEA',
  LuckaUpravaRovinj = 'LUCKA_UPRAVA_ROVINJ',
  Marservis = 'MARSERVIS',
  Montraker = 'MONTRAKER',
  Mushrooms = 'MUSHROOMS',
  None = 'NONE',
  Onix = 'ONIX',
  Orcus = 'ORCUS',
  Oso = 'OSO',
  Protech = 'PROTECH',
  RitosaTrgovine = 'RITOSA_TRGOVINE',
  Sistema = 'SISTEMA',
  Sklad = 'SKLAD',
  SkladProfili = 'SKLAD_PROFILI',
  Tapess = 'TAPESS',
  TehnolineObrt = 'TEHNOLINE_OBRT',
  TehnolineTelekom = 'TEHNOLINE_TELEKOM',
  Trim = 'TRIM'
}

export type OriginPantheonItemDetailsInput = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo: Scalars['Int'];
};

export type OxDmsxmlitem = {
  acCode?: Maybe<Scalars['String']>;
  acCostBearer?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDescription?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentName?: Maybe<Scalars['String']>;
  acJoinReason?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anDocumentQid: Scalars['Int'];
  anForPay?: Maybe<Scalars['Decimal']>;
  anId?: Maybe<Scalars['Int']>;
  anPrice?: Maybe<Scalars['Decimal']>;
  anQty?: Maybe<Scalars['Decimal']>;
  anRebate?: Maybe<Scalars['Decimal']>;
  anRebate1?: Maybe<Scalars['Decimal']>;
  anVat?: Maybe<Scalars['Decimal']>;
  anVatamount?: Maybe<Scalars['Decimal']>;
  anVatbase?: Maybe<Scalars['Decimal']>;
};

export type OxDmsxmlitemFilterInput = {
  acCode?: InputMaybe<StringOperationFilterInput>;
  acCostBearer?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDescription?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentName?: InputMaybe<StringOperationFilterInput>;
  acJoinReason?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anForPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRebate1?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anVatamount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anVatbase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<OxDmsxmlitemFilterInput>>;
  or?: InputMaybe<Array<OxDmsxmlitemFilterInput>>;
};

export type OxDmsxmlitemSortInput = {
  acCode?: InputMaybe<SortEnumType>;
  acCostBearer?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDescription?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentName?: InputMaybe<SortEnumType>;
  acJoinReason?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  anDocumentQid?: InputMaybe<SortEnumType>;
  anForPay?: InputMaybe<SortEnumType>;
  anId?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRebate1?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  anVatamount?: InputMaybe<SortEnumType>;
  anVatbase?: InputMaybe<SortEnumType>;
};

export type OxIosPerSubject = {
  acCurrency?: Maybe<Scalars['String']>;
  acHrfiskalNumber?: Maybe<Scalars['String']>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acName2?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  adDateDue: Scalars['DateTime'];
  adDateInv: Scalars['DateTime'];
  anCredit: Scalars['Decimal'];
  anDebit: Scalars['Decimal'];
  saldo: Scalars['Decimal'];
};

export type OxIosPerSubjectFilterInput = {
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acHrfiskalNumber?: InputMaybe<StringOperationFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acName2?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adDateInv?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  anCredit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDebit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<OxIosPerSubjectFilterInput>>;
  or?: InputMaybe<Array<OxIosPerSubjectFilterInput>>;
  saldo?: InputMaybe<ComparableDecimalOperationFilterInput>;
};

export type OxIosPerSubjectSortInput = {
  acCurrency?: InputMaybe<SortEnumType>;
  acHrfiskalNumber?: InputMaybe<SortEnumType>;
  acLinkDoc?: InputMaybe<SortEnumType>;
  acName2?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  adDateDue?: InputMaybe<SortEnumType>;
  adDateInv?: InputMaybe<SortEnumType>;
  anCredit?: InputMaybe<SortEnumType>;
  anDebit?: InputMaybe<SortEnumType>;
  saldo?: InputMaybe<SortEnumType>;
};

export type OxMerdownloadReport = {
  acReportStatus?: Maybe<Scalars['String']>;
  acReportType?: Maybe<Scalars['String']>;
  brojDokumenta?: Maybe<Scalars['String']>;
  dmsoznaka?: Maybe<Scalars['String']>;
  greska?: Maybe<Scalars['String']>;
  imeFirme?: Maybe<Scalars['String']>;
  oibfirme?: Maybe<Scalars['String']>;
  subjekt?: Maybe<Scalars['String']>;
  tipDokumenta?: Maybe<Scalars['String']>;
  vrijemeSlanja?: Maybe<Scalars['DateTime']>;
};

export type OxMerdownloadReportFilterInput = {
  acReportStatus?: InputMaybe<StringOperationFilterInput>;
  acReportType?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OxMerdownloadReportFilterInput>>;
  brojDokumenta?: InputMaybe<StringOperationFilterInput>;
  dmsoznaka?: InputMaybe<StringOperationFilterInput>;
  greska?: InputMaybe<StringOperationFilterInput>;
  imeFirme?: InputMaybe<StringOperationFilterInput>;
  oibfirme?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OxMerdownloadReportFilterInput>>;
  subjekt?: InputMaybe<StringOperationFilterInput>;
  tipDokumenta?: InputMaybe<StringOperationFilterInput>;
  vrijemeSlanja?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
};

export type OxMerdownloadReportSortInput = {
  acReportStatus?: InputMaybe<SortEnumType>;
  acReportType?: InputMaybe<SortEnumType>;
  brojDokumenta?: InputMaybe<SortEnumType>;
  dmsoznaka?: InputMaybe<SortEnumType>;
  greska?: InputMaybe<SortEnumType>;
  imeFirme?: InputMaybe<SortEnumType>;
  oibfirme?: InputMaybe<SortEnumType>;
  subjekt?: InputMaybe<SortEnumType>;
  tipDokumenta?: InputMaybe<SortEnumType>;
  vrijemeSlanja?: InputMaybe<SortEnumType>;
};

export type OxPalletsView = {
  acCode?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acPrsn3Name?: Maybe<Scalars['String']>;
  acPrsn3Region?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acReceiverRegion?: Maybe<Scalars['String']>;
  acSscc?: Maybe<Scalars['String']>;
  acSsccNormalized?: Maybe<Scalars['String']>;
  acUserName?: Maybe<Scalars['String']>;
  adDate: Scalars['DateTime'];
  adDateOnly?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserId: Scalars['Int'];
};

export type OxPalletsViewFilterInput = {
  acCode?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Name?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Region?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acReceiverRegion?: InputMaybe<StringOperationFilterInput>;
  acSscc?: InputMaybe<StringOperationFilterInput>;
  acSsccNormalized?: InputMaybe<StringOperationFilterInput>;
  acUserName?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adDateOnly?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<OxPalletsViewFilterInput>>;
  or?: InputMaybe<Array<OxPalletsViewFilterInput>>;
};

export type OxPalletsViewSortInput = {
  acCode?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyView?: InputMaybe<SortEnumType>;
  acPrsn3?: InputMaybe<SortEnumType>;
  acPrsn3Name?: InputMaybe<SortEnumType>;
  acPrsn3Region?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acReceiverRegion?: InputMaybe<SortEnumType>;
  acSscc?: InputMaybe<SortEnumType>;
  acSsccNormalized?: InputMaybe<SortEnumType>;
  acUserName?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateOnly?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type OxScansPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<OxScansPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<OxPalletsView>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OxScansPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OxPalletsView>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export enum PantheonDocumentDirectionEnum {
  In = 'IN',
  Out = 'OUT'
}

export type PantheonDocumentDirectionEnumOperationFilterInput = {
  eq?: InputMaybe<PantheonDocumentDirectionEnum>;
  in?: InputMaybe<Array<PantheonDocumentDirectionEnum>>;
  neq?: InputMaybe<PantheonDocumentDirectionEnum>;
  nin?: InputMaybe<Array<PantheonDocumentDirectionEnum>>;
};

export enum PantheonDocumentTable {
  THeMove = 'T_HE_MOVE',
  THeOrder = 'T_HE_ORDER'
}

export type PantheonDocumentTableOperationFilterInput = {
  eq?: InputMaybe<PantheonDocumentTable>;
  in?: InputMaybe<Array<PantheonDocumentTable>>;
  neq?: InputMaybe<PantheonDocumentTable>;
  nin?: InputMaybe<Array<PantheonDocumentTable>>;
};

export type PantheonUser = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  encodedUserId?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonAcDelivery?: Maybe<Scalars['String']>;
  pantheonAcName?: Maybe<Scalars['String']>;
  pantheonAcRegNo?: Maybe<Scalars['String']>;
  pantheonAcUserId?: Maybe<Scalars['String']>;
  pantheonAcWorker?: Maybe<Scalars['String']>;
  pantheonAnUserId: Scalars['Int'];
  pantheonPIN?: Maybe<Scalars['String']>;
  pantheonPrsnStatus: Scalars['Boolean'];
  pantheonSignature?: Maybe<Array<Scalars['Byte']>>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
};

export type PantheonUserFilterInput = {
  and?: InputMaybe<Array<PantheonUserFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  encodedUserId?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PantheonUserFilterInput>>;
  pantheonAcDelivery?: InputMaybe<StringOperationFilterInput>;
  pantheonAcName?: InputMaybe<StringOperationFilterInput>;
  pantheonAcRegNo?: InputMaybe<StringOperationFilterInput>;
  pantheonAcUserId?: InputMaybe<StringOperationFilterInput>;
  pantheonAcWorker?: InputMaybe<StringOperationFilterInput>;
  pantheonAnUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  pantheonPIN?: InputMaybe<StringOperationFilterInput>;
  pantheonPrsnStatus?: InputMaybe<BooleanOperationFilterInput>;
  pantheonSignature?: InputMaybe<ListComparableByteOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type PantheonUserSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  encodedUserId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  pantheonAcDelivery?: InputMaybe<SortEnumType>;
  pantheonAcName?: InputMaybe<SortEnumType>;
  pantheonAcRegNo?: InputMaybe<SortEnumType>;
  pantheonAcUserId?: InputMaybe<SortEnumType>;
  pantheonAcWorker?: InputMaybe<SortEnumType>;
  pantheonAnUserId?: InputMaybe<SortEnumType>;
  pantheonPIN?: InputMaybe<SortEnumType>;
  pantheonPrsnStatus?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type PantheonVersion = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  downloadPath?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['String']>;
  versionFormatted?: Maybe<Scalars['String']>;
};

export type PantheonVersionFilterInput = {
  and?: InputMaybe<Array<PantheonVersionFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  downloadPath?: InputMaybe<StringOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PantheonVersionFilterInput>>;
  version?: InputMaybe<StringOperationFilterInput>;
  versionFormatted?: InputMaybe<StringOperationFilterInput>;
};

export type PantheonVersionSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  downloadPath?: InputMaybe<SortEnumType>;
  group?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
  versionFormatted?: InputMaybe<SortEnumType>;
};

export type PartialFinishDeliveryNotesItemDtoInput = {
  acIdent?: InputMaybe<Scalars['String']>;
  anQty: Scalars['Decimal'];
};

export type PersonalVehicle = {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  makeAndModel?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  registration?: Maybe<Scalars['String']>;
};

export type PersonalVehicleFilterInput = {
  and?: InputMaybe<Array<PersonalVehicleFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  makeAndModel?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PersonalVehicleFilterInput>>;
  registration?: InputMaybe<StringOperationFilterInput>;
};

export type PersonalVehicleSortInput = {
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  makeAndModel?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  registration?: InputMaybe<SortEnumType>;
};

export type PortalAttachmentDto = {
  contentType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type PortalConfigDto = {
  enabled: Scalars['Boolean'];
  showEntryPoints: Scalars['Boolean'];
};

export type PortalEmailPreferencesDto = {
  available: Scalars['Boolean'];
  emailCopiesEnabled: Scalars['Boolean'];
};

export enum PortalEmailStatus {
  Missing = 'MISSING',
  Shared = 'SHARED',
  Unconfirmed = 'UNCONFIRMED',
  Verified = 'VERIFIED'
}

export type PortalLinkedContactDto = {
  contactId: Scalars['Int'];
  displayName?: Maybe<Scalars['String']>;
};

export type PortalMeDto = {
  companyScope: Scalars['Boolean'];
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailStatus: PortalEmailStatus;
  linkedContacts?: Maybe<Array<Maybe<PortalLinkedContactDto>>>;
  portalOnly: Scalars['Boolean'];
  unreadCount?: Maybe<Scalars['Int']>;
};

export enum PortalMessageDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type PortalMessageDto = {
  attachments?: Maybe<Array<Maybe<PortalAttachmentDto>>>;
  authorDisplayName?: Maybe<Scalars['String']>;
  direction: PortalMessageDirection;
  id: Scalars['Int'];
  plainText?: Maybe<Scalars['String']>;
  safeHtml?: Maybe<Scalars['String']>;
  sentOn?: Maybe<Scalars['DateTime']>;
};

export type PortalMessageOriginalDto = {
  id: Scalars['Int'];
  plainText?: Maybe<Scalars['String']>;
  safeHtml?: Maybe<Scalars['String']>;
};

export type PortalServiceKeyDto = {
  companySettingsId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  keyPrefix?: Maybe<Scalars['String']>;
  kind: PortalServiceKeyKind;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
};

export enum PortalServiceKeyKind {
  Callback = 'CALLBACK',
  Service = 'SERVICE'
}

export type PortalSignInResultDto = {
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  registrationTicket?: Maybe<Scalars['String']>;
  requiresRegistration: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

export type PortalSignInStartDto = {
  challengeId: Scalars['UUID'];
};

export enum PortalTicketStatus {
  InProgress = 'IN_PROGRESS',
  Resolved = 'RESOLVED',
  WaitingForCustomer = 'WAITING_FOR_CUSTOMER'
}

export enum PortalTicketStatusFilter {
  All = 'ALL',
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type PortalTicketSummaryDto = {
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastActivityOn?: Maybe<Scalars['DateTime']>;
  lastPublicMessageId?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['String']>;
  status: PortalTicketStatus;
  title: Scalars['String'];
  unread: Scalars['Boolean'];
};

export type PortalTicketThreadDto = {
  messages?: Maybe<Array<Maybe<PortalMessageDto>>>;
  ticket?: Maybe<PortalTicketSummaryDto>;
};

export type PortalTicketsResponse = {
  items?: Maybe<Array<Maybe<PortalTicketSummaryDto>>>;
  total: Scalars['Int'];
};

export type PortalWriteResultDto = {
  messageId: Scalars['Int'];
  ticketId: Scalars['Int'];
};

export type Project = {
  billable: Scalars['Boolean'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dueDate: Scalars['DateTime'];
  engineModel?: Maybe<Scalars['String']>;
  engineSerialNumber?: Maybe<Scalars['String']>;
  finished: Scalars['Boolean'];
  hINNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoice: Scalars['Boolean'];
  model?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  subject?: Maybe<Subject>;
  subjectId?: Maybe<Scalars['Int']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  tickets?: Maybe<Array<Maybe<SupportTicket>>>;
  transmissionModel?: Maybe<Scalars['String']>;
  transmissionSerialNumber?: Maybe<Scalars['String']>;
};

export type ProjectFilterInput = {
  and?: InputMaybe<Array<ProjectFilterInput>>;
  billable?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  dueDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  engineModel?: InputMaybe<StringOperationFilterInput>;
  engineSerialNumber?: InputMaybe<StringOperationFilterInput>;
  finished?: InputMaybe<BooleanOperationFilterInput>;
  hINNumber?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  invoice?: InputMaybe<BooleanOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  tickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
  transmissionModel?: InputMaybe<StringOperationFilterInput>;
  transmissionSerialNumber?: InputMaybe<StringOperationFilterInput>;
};

export type ProjectSortInput = {
  billable?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  dueDate?: InputMaybe<SortEnumType>;
  engineModel?: InputMaybe<SortEnumType>;
  engineSerialNumber?: InputMaybe<SortEnumType>;
  finished?: InputMaybe<SortEnumType>;
  hINNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invoice?: InputMaybe<SortEnumType>;
  model?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SubjectSortInput>;
  subjectId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  transmissionModel?: InputMaybe<SortEnumType>;
  transmissionSerialNumber?: InputMaybe<SortEnumType>;
};

export type QueryResultColumn = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type QueryResultRow = {
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryResultSet = {
  columns?: Maybe<Array<Maybe<QueryResultColumn>>>;
  rows?: Maybe<Array<Maybe<QueryResultRow>>>;
};

export type QueryTableResult = {
  query?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<QueryResultSet>>>;
};

export type SaveEInvoicePdfArtifactInput = {
  byteLength: Scalars['Int'];
  contentBase64?: InputMaybe<Scalars['String']>;
  dispatchId: Scalars['UUID'];
  documentUid?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  originApplicationUserId?: InputMaybe<Scalars['String']>;
  originCompanySettingsId: Scalars['Int'];
  sha256?: InputMaybe<Scalars['String']>;
};

export type SaveWebListPreferenceInput = {
  customerAcSubject?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateRange?: InputMaybe<DateFilterType>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  departmentAcSubject?: InputMaybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  keyFrom?: InputMaybe<Scalars['String']>;
  keyTo?: InputMaybe<Scalars['String']>;
  onlyMine?: InputMaybe<Scalars['Boolean']>;
  touchOnly: Scalars['Boolean'];
};

export type SaveWebPreferencesInput = {
  language?: InputMaybe<Scalars['String']>;
  sidebarCollapsed: Scalars['Boolean'];
  sidebarMode: WebSidebarMode;
  theme?: InputMaybe<WebThemePreference>;
};

export type SavedFile = {
  cID?: Maybe<Scalars['String']>;
  codeMagicArtifact: Scalars['Boolean'];
  companyDocument?: Maybe<Company>;
  companyDocumentId?: Maybe<Scalars['Int']>;
  companyRunbookNote?: Maybe<CompanyRunbookNote>;
  companyRunbookNoteId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contentDisposition?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fTP: Scalars['Boolean'];
  id: Scalars['Int'];
  isProblemSubmission: Scalars['Boolean'];
  local: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  onixPantheonDMS: Scalars['Boolean'];
  path?: Maybe<Scalars['String']>;
  public: Scalars['Boolean'];
  savedFileContent?: Maybe<SavedFileContent>;
  savedFileContentId?: Maybe<Scalars['UUID']>;
  serverPath?: Maybe<Scalars['String']>;
  supportAiThreadItem?: Maybe<SupportAiThreadItem>;
  supportAiThreadItemId?: Maybe<Scalars['Long']>;
  supportAiThreadMessage?: Maybe<SupportAiThreadMessage>;
  supportAiThreadMessageId?: Maybe<Scalars['Int']>;
  supportTicketMessage?: Maybe<SupportTicketMessage>;
  supportTicketMessageId?: Maybe<Scalars['Int']>;
  supportTicketTimeLog?: Maybe<SupportTicketTimeLog>;
  supportTicketTimeLogId?: Maybe<Scalars['Int']>;
  travelWarrantItem?: Maybe<TravelWarrantItem>;
  travelWarrantItemId?: Maybe<Scalars['Int']>;
  uniqueClientId?: Maybe<Scalars['String']>;
  uploadedByUserId?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<ApplicationUser>>>;
  wikiEntry?: Maybe<WikiEntry>;
  wikiEntryId?: Maybe<Scalars['Int']>;
  workOrder?: Maybe<MarservisWorkOrder>;
  workOrderId?: Maybe<Scalars['String']>;
  workOrderItemWork?: Maybe<MarservisWorkOrderItemWork>;
  workOrderItemWorkId?: Maybe<Scalars['Int']>;
};

export type SavedFileContent = {
  content?: Maybe<Array<Scalars['Byte']>>;
  id: Scalars['UUID'];
};

export type SavedFileContentFilterInput = {
  and?: InputMaybe<Array<SavedFileContentFilterInput>>;
  content?: InputMaybe<ListComparableByteOperationFilterInput>;
  id?: InputMaybe<ComparableGuidOperationFilterInput>;
  or?: InputMaybe<Array<SavedFileContentFilterInput>>;
};

export type SavedFileContentSortInput = {
  id?: InputMaybe<SortEnumType>;
};

export type SavedFileDtoInput = {
  additionalDirectorySegments?: InputMaybe<Scalars['String']>;
  contentDisposition?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Array<Scalars['Byte']>>;
  description?: InputMaybe<Scalars['String']>;
  isProblemSubmission?: InputMaybe<Scalars['Boolean']>;
  keepOriginalExtension?: InputMaybe<Scalars['Boolean']>;
  maxDim: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  nameOverride?: InputMaybe<Scalars['String']>;
  prependOriginalFileName?: InputMaybe<Scalars['Boolean']>;
  publicImage: Scalars['Boolean'];
  savedFileProperty?: InputMaybe<Scalars['String']>;
  savedFilePropertyValue?: InputMaybe<Scalars['String']>;
  skipProblemSubmissionForwarding?: InputMaybe<Scalars['Boolean']>;
  uniqueClientId?: InputMaybe<Scalars['String']>;
};

export type SavedFileFilterInput = {
  and?: InputMaybe<Array<SavedFileFilterInput>>;
  cID?: InputMaybe<StringOperationFilterInput>;
  codeMagicArtifact?: InputMaybe<BooleanOperationFilterInput>;
  companyDocument?: InputMaybe<CompanyFilterInput>;
  companyDocumentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companyRunbookNote?: InputMaybe<CompanyRunbookNoteFilterInput>;
  companyRunbookNoteId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contentDisposition?: InputMaybe<StringOperationFilterInput>;
  contentType?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  fTP?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isProblemSubmission?: InputMaybe<BooleanOperationFilterInput>;
  local?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  onixPantheonDMS?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SavedFileFilterInput>>;
  path?: InputMaybe<StringOperationFilterInput>;
  public?: InputMaybe<BooleanOperationFilterInput>;
  savedFileContent?: InputMaybe<SavedFileContentFilterInput>;
  savedFileContentId?: InputMaybe<ComparableNullableOfGuidOperationFilterInput>;
  serverPath?: InputMaybe<StringOperationFilterInput>;
  supportAiThreadItem?: InputMaybe<SupportAiThreadItemFilterInput>;
  supportAiThreadItemId?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  supportAiThreadMessage?: InputMaybe<SupportAiThreadMessageFilterInput>;
  supportAiThreadMessageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTicketMessage?: InputMaybe<SupportTicketMessageFilterInput>;
  supportTicketMessageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogFilterInput>;
  supportTicketTimeLogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  travelWarrantItem?: InputMaybe<TravelWarrantItemFilterInput>;
  travelWarrantItemId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  uniqueClientId?: InputMaybe<StringOperationFilterInput>;
  uploadedByUserId?: InputMaybe<StringOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  wikiEntry?: InputMaybe<WikiEntryFilterInput>;
  wikiEntryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  workOrder?: InputMaybe<MarservisWorkOrderFilterInput>;
  workOrderId?: InputMaybe<StringOperationFilterInput>;
  workOrderItemWork?: InputMaybe<MarservisWorkOrderItemWorkFilterInput>;
  workOrderItemWorkId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type SavedFileSortInput = {
  cID?: InputMaybe<SortEnumType>;
  codeMagicArtifact?: InputMaybe<SortEnumType>;
  companyDocument?: InputMaybe<CompanySortInput>;
  companyDocumentId?: InputMaybe<SortEnumType>;
  companyRunbookNote?: InputMaybe<CompanyRunbookNoteSortInput>;
  companyRunbookNoteId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contentDisposition?: InputMaybe<SortEnumType>;
  contentType?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  fTP?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isProblemSubmission?: InputMaybe<SortEnumType>;
  local?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  onixPantheonDMS?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
  public?: InputMaybe<SortEnumType>;
  savedFileContent?: InputMaybe<SavedFileContentSortInput>;
  savedFileContentId?: InputMaybe<SortEnumType>;
  serverPath?: InputMaybe<SortEnumType>;
  supportAiThreadItem?: InputMaybe<SupportAiThreadItemSortInput>;
  supportAiThreadItemId?: InputMaybe<SortEnumType>;
  supportAiThreadMessage?: InputMaybe<SupportAiThreadMessageSortInput>;
  supportAiThreadMessageId?: InputMaybe<SortEnumType>;
  supportTicketMessage?: InputMaybe<SupportTicketMessageSortInput>;
  supportTicketMessageId?: InputMaybe<SortEnumType>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogSortInput>;
  supportTicketTimeLogId?: InputMaybe<SortEnumType>;
  travelWarrantItem?: InputMaybe<TravelWarrantItemSortInput>;
  travelWarrantItemId?: InputMaybe<SortEnumType>;
  uniqueClientId?: InputMaybe<SortEnumType>;
  uploadedByUserId?: InputMaybe<SortEnumType>;
  wikiEntry?: InputMaybe<WikiEntrySortInput>;
  wikiEntryId?: InputMaybe<SortEnumType>;
  workOrder?: InputMaybe<MarservisWorkOrderSortInput>;
  workOrderId?: InputMaybe<SortEnumType>;
  workOrderItemWork?: InputMaybe<MarservisWorkOrderItemWorkSortInput>;
  workOrderItemWorkId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SavedFilesPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<SavedFilesPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<SavedFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SavedFilesPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SavedFile>;
};

export type SingleQueryResult = {
  column?: Maybe<QueryResultColumn>;
  value?: Maybe<Scalars['String']>;
};

export type SoftPos7PayTokenState = {
  expiresAtUtc: Scalars['DateTime'];
  idToken?: Maybe<Scalars['String']>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subject = {
  address?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contactName?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  longName?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  vATID?: Maybe<Scalars['String']>;
  vATIDPrefix?: Maybe<Scalars['String']>;
};

export type SubjectFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<SubjectFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  longName?: InputMaybe<StringOperationFilterInput>;
  mail?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SubjectFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  shortName?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  vATID?: InputMaybe<StringOperationFilterInput>;
  vATIDPrefix?: InputMaybe<StringOperationFilterInput>;
};

export type SubjectSortInput = {
  address?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountrySortInput>;
  countryId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  longName?: InputMaybe<SortEnumType>;
  mail?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  shortName?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  vATID?: InputMaybe<SortEnumType>;
  vATIDPrefix?: InputMaybe<SortEnumType>;
};

export type Subjektski = {
  datumspre?: Maybe<Scalars['DateTime']>;
  datumzap?: Maybe<Scalars['DateTime']>;
  naziv?: Maybe<Scalars['String']>;
  naziv2?: Maybe<Scalars['String']>;
  skis?: Maybe<Scalars['String']>;
  userspre?: Maybe<Scalars['Int']>;
  userzap?: Maybe<Scalars['Int']>;
};

export type SubjektskiFilterInput = {
  and?: InputMaybe<Array<SubjektskiFilterInput>>;
  datumspre?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  datumzap?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  naziv?: InputMaybe<StringOperationFilterInput>;
  naziv2?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SubjektskiFilterInput>>;
  skis?: InputMaybe<StringOperationFilterInput>;
  userspre?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userzap?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type SubjektskiSortInput = {
  datumspre?: InputMaybe<SortEnumType>;
  datumzap?: InputMaybe<SortEnumType>;
  naziv?: InputMaybe<SortEnumType>;
  naziv2?: InputMaybe<SortEnumType>;
  skis?: InputMaybe<SortEnumType>;
  userspre?: InputMaybe<SortEnumType>;
  userzap?: InputMaybe<SortEnumType>;
};

export type SubmittingLurInvoiceCustomerInput = {
  acSubject?: InputMaybe<Scalars['String']>;
};

export type SubmittingLurInvoiceItemInput = {
  acIdent?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anPrice: Scalars['Float'];
  anRebate: Scalars['Float'];
  boatLength: Scalars['Float'];
  numberOfDays: Scalars['Int'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
};

export type SubmittingLurInvoiceViewModelInput = {
  berth?: InputMaybe<Scalars['String']>;
  boatLength?: InputMaybe<Scalars['Decimal']>;
  boatName?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<SubmittingLurInvoiceCustomerInput>;
  date: Scalars['DateTime'];
  department?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  moveItems?: InputMaybe<Array<InputMaybe<SubmittingLurInvoiceItemInput>>>;
  note?: InputMaybe<Scalars['String']>;
  payMethod?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
  uID?: InputMaybe<Scalars['String']>;
};

export type SubmittingMoveCustomerInput = {
  acSubject?: InputMaybe<Scalars['String']>;
};

export type SubmittingMoveItemInput = {
  acIdent?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anPackQuantity: Scalars['Float'];
  anPrice: Scalars['Float'];
  anRebate: Scalars['Float'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
};

export type SubmittingMoveViewModelInput = {
  customer?: InputMaybe<SubmittingMoveCustomerInput>;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  existingAcKey?: InputMaybe<Scalars['String']>;
  moveItems?: InputMaybe<Array<InputMaybe<SubmittingMoveItemInput>>>;
  note?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
};

export type SubmittingOrderCustomerInput = {
  acSubject?: InputMaybe<Scalars['String']>;
};

export type SubmittingOrderItemInput = {
  acIdent?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anPrice: Scalars['Float'];
  anRebate: Scalars['Float'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
};

export type SubmittingOrderViewModelInput = {
  customer?: InputMaybe<SubmittingOrderCustomerInput>;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  orderItems?: InputMaybe<Array<InputMaybe<SubmittingOrderItemInput>>>;
};

export type SubmittingWoexCustomerInput = {
  acSubject?: InputMaybe<Scalars['String']>;
};

export type SubmittingWoexItemInput = {
  acIdent?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anPackQuantity: Scalars['Float'];
  anPrice: Scalars['Float'];
  anRebate: Scalars['Float'];
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
};

export type SubmittingWoexViewModelInput = {
  customer?: InputMaybe<SubmittingWoexCustomerInput>;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  existingAcKey?: InputMaybe<Scalars['String']>;
  moveItems?: InputMaybe<Array<InputMaybe<SubmittingWoexItemInput>>>;
  note?: InputMaybe<Scalars['String']>;
  printTime?: InputMaybe<Scalars['DateTime']>;
};

export type SubmittingWorkOrderEndViewModelInput = {
  acDoc1?: InputMaybe<Scalars['String']>;
  acDoc1Date?: InputMaybe<Scalars['DateTime']>;
  acDoc2?: InputMaybe<Scalars['String']>;
  acDoc2Date?: InputMaybe<Scalars['DateTime']>;
  acFieldSF?: InputMaybe<Scalars['String']>;
  acKey?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  endingMileage: Scalars['Decimal'];
  location?: InputMaybe<LocationStructureInput>;
  note?: InputMaybe<Scalars['String']>;
  signatory?: InputMaybe<Scalars['String']>;
  signature?: InputMaybe<Array<Scalars['Byte']>>;
  startingMileage: Scalars['Decimal'];
};

export type SubmittingWorkOrderMaterialViewModelInput = {
  acIdent?: InputMaybe<Scalars['String']>;
  acKey?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acSerialNo?: InputMaybe<Scalars['String']>;
  anNo?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Decimal'];
};

export type SubmittingWorkOrderTHeCostDrvInput = {
  acClassif?: InputMaybe<Scalars['String']>;
  acConsignee?: InputMaybe<Scalars['String']>;
  acCostDrv?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acFieldSa?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acStatus?: InputMaybe<Scalars['String']>;
  anFieldNa?: InputMaybe<Scalars['Decimal']>;
};

export type SubmittingWorkOrderTHeSetSubjInput = {
  acActive?: InputMaybe<Scalars['String']>;
  acAddress?: InputMaybe<Scalars['String']>;
  acBuyer?: InputMaybe<Scalars['String']>;
  acCountry?: InputMaybe<Scalars['String']>;
  acName2?: InputMaybe<Scalars['String']>;
  acPayer?: InputMaybe<Scalars['String']>;
  acPhone?: InputMaybe<Scalars['String']>;
  acPin?: InputMaybe<Scalars['String']>;
  acPost?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acVatCodePrefix?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anRebate: Scalars['Decimal'];
};

export type SubmittingWorkOrderViewModelInput = {
  acDoc1?: InputMaybe<Scalars['String']>;
  acDoc1Date?: InputMaybe<Scalars['DateTime']>;
  acDoc2?: InputMaybe<Scalars['String']>;
  acDoc2Date?: InputMaybe<Scalars['DateTime']>;
  acFieldSF?: InputMaybe<Scalars['String']>;
  buyer?: InputMaybe<SubmittingWorkOrderTHeSetSubjInput>;
  buyerPayer?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  costBearer?: InputMaybe<SubmittingWorkOrderTHeCostDrvInput>;
  documentType?: InputMaybe<Scalars['String']>;
  endingMileage: Scalars['Decimal'];
  location?: InputMaybe<LocationStructureInput>;
  note?: InputMaybe<Scalars['String']>;
  otherAcWorkers?: InputMaybe<Array<Scalars['String']>>;
  signatory?: InputMaybe<Scalars['String']>;
  startingMileage: Scalars['Decimal'];
  uID?: InputMaybe<Scalars['String']>;
  zeroAcKey?: InputMaybe<Scalars['String']>;
};

export type SubmittingWorkOrderWorkSpecViewModelInput = {
  acKey?: InputMaybe<Scalars['String']>;
  anNo?: InputMaybe<Scalars['Int']>;
  from: Scalars['DateTime'];
  ident?: InputMaybe<Scalars['String']>;
  kilometers: Scalars['Float'];
  location?: InputMaybe<LocationStructureInput>;
  note?: InputMaybe<Scalars['String']>;
  to: Scalars['DateTime'];
  worker?: InputMaybe<Scalars['String']>;
};

export type SupportAiThreadItem = {
  attachments: Array<SavedFile>;
  body?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  completedOn?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  errorCode?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  kind: SupportAiThreadItemKind;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  parentItemId?: Maybe<Scalars['Long']>;
  payloadJson?: Maybe<Scalars['String']>;
  phase?: Maybe<SupportAiThreadItemPhase>;
  providerItemId?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['Int']>;
  revision: Scalars['Int'];
  role?: Maybe<SupportAiThreadItemRole>;
  runId?: Maybe<Scalars['Int']>;
  sequence: Scalars['Long'];
  sourceKey?: Maybe<Scalars['String']>;
  startedOn?: Maybe<Scalars['DateTime']>;
  status: SupportAiThreadItemStatus;
  summary?: Maybe<Scalars['String']>;
  threadId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  toolCallId?: Maybe<Scalars['Int']>;
};

export type SupportAiThreadItemFilterInput = {
  and?: InputMaybe<Array<SupportAiThreadItemFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  body?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  errorCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt64OperationFilterInput>;
  kind?: InputMaybe<SupportAiThreadItemKindOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SupportAiThreadItemFilterInput>>;
  parentItemId?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  payloadJson?: InputMaybe<StringOperationFilterInput>;
  phase?: InputMaybe<NullableOfSupportAiThreadItemPhaseOperationFilterInput>;
  providerItemId?: InputMaybe<StringOperationFilterInput>;
  questionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  revision?: InputMaybe<ComparableInt32OperationFilterInput>;
  role?: InputMaybe<NullableOfSupportAiThreadItemRoleOperationFilterInput>;
  runId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sequence?: InputMaybe<ComparableInt64OperationFilterInput>;
  sourceKey?: InputMaybe<StringOperationFilterInput>;
  startedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  status?: InputMaybe<SupportAiThreadItemStatusOperationFilterInput>;
  summary?: InputMaybe<StringOperationFilterInput>;
  threadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  toolCallId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export enum SupportAiThreadItemKind {
  ApprovalDecision = 'APPROVAL_DECISION',
  ApprovalRequest = 'APPROVAL_REQUEST',
  Artifact = 'ARTIFACT',
  AssistantMessage = 'ASSISTANT_MESSAGE',
  Question = 'QUESTION',
  ReasoningSummary = 'REASONING_SUMMARY',
  SystemNotice = 'SYSTEM_NOTICE',
  ToolCall = 'TOOL_CALL',
  UserMessage = 'USER_MESSAGE'
}

export type SupportAiThreadItemKindOperationFilterInput = {
  eq?: InputMaybe<SupportAiThreadItemKind>;
  in?: InputMaybe<Array<SupportAiThreadItemKind>>;
  neq?: InputMaybe<SupportAiThreadItemKind>;
  nin?: InputMaybe<Array<SupportAiThreadItemKind>>;
};

export enum SupportAiThreadItemPhase {
  Commentary = 'COMMENTARY',
  FinalAnswer = 'FINAL_ANSWER'
}

export enum SupportAiThreadItemRole {
  Assistant = 'ASSISTANT',
  System = 'SYSTEM',
  User = 'USER'
}

export type SupportAiThreadItemSortInput = {
  body?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  completedOn?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  errorCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  parentItemId?: InputMaybe<SortEnumType>;
  payloadJson?: InputMaybe<SortEnumType>;
  phase?: InputMaybe<SortEnumType>;
  providerItemId?: InputMaybe<SortEnumType>;
  questionId?: InputMaybe<SortEnumType>;
  revision?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  runId?: InputMaybe<SortEnumType>;
  sequence?: InputMaybe<SortEnumType>;
  sourceKey?: InputMaybe<SortEnumType>;
  startedOn?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  summary?: InputMaybe<SortEnumType>;
  threadId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  toolCallId?: InputMaybe<SortEnumType>;
};

export enum SupportAiThreadItemStatus {
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type SupportAiThreadItemStatusOperationFilterInput = {
  eq?: InputMaybe<SupportAiThreadItemStatus>;
  in?: InputMaybe<Array<SupportAiThreadItemStatus>>;
  neq?: InputMaybe<SupportAiThreadItemStatus>;
  nin?: InputMaybe<Array<SupportAiThreadItemStatus>>;
};

export type SupportAiThreadMessage = {
  attachments: Array<SavedFile>;
  authorKind: SupportAiVisibleMessageAuthorKind;
  body: Scalars['String'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  firstUsedByRunId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  kind: SupportAiVisibleMessageKind;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  payloadJson?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['Int']>;
  runId?: Maybe<Scalars['Int']>;
  secondaryBody?: Maybe<Scalars['String']>;
  sourceKey?: Maybe<Scalars['String']>;
  threadId: Scalars['Int'];
};

export type SupportAiThreadMessageFilterInput = {
  and?: InputMaybe<Array<SupportAiThreadMessageFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  authorKind?: InputMaybe<SupportAiVisibleMessageAuthorKindOperationFilterInput>;
  body?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  firstUsedByRunId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  kind?: InputMaybe<SupportAiVisibleMessageKindOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SupportAiThreadMessageFilterInput>>;
  payloadJson?: InputMaybe<StringOperationFilterInput>;
  questionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  runId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  secondaryBody?: InputMaybe<StringOperationFilterInput>;
  sourceKey?: InputMaybe<StringOperationFilterInput>;
  threadId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SupportAiThreadMessageSortInput = {
  authorKind?: InputMaybe<SortEnumType>;
  body?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  firstUsedByRunId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kind?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  payloadJson?: InputMaybe<SortEnumType>;
  questionId?: InputMaybe<SortEnumType>;
  runId?: InputMaybe<SortEnumType>;
  secondaryBody?: InputMaybe<SortEnumType>;
  sourceKey?: InputMaybe<SortEnumType>;
  threadId?: InputMaybe<SortEnumType>;
};

export enum SupportAiVisibleMessageAuthorKind {
  Ai = 'AI',
  System = 'SYSTEM',
  User = 'USER'
}

export type SupportAiVisibleMessageAuthorKindOperationFilterInput = {
  eq?: InputMaybe<SupportAiVisibleMessageAuthorKind>;
  in?: InputMaybe<Array<SupportAiVisibleMessageAuthorKind>>;
  neq?: InputMaybe<SupportAiVisibleMessageAuthorKind>;
  nin?: InputMaybe<Array<SupportAiVisibleMessageAuthorKind>>;
};

export enum SupportAiVisibleMessageKind {
  Conclusion = 'CONCLUSION',
  DatabaseGrantRequest = 'DATABASE_GRANT_REQUEST',
  Error = 'ERROR',
  Question = 'QUESTION',
  Reply = 'REPLY',
  Resume = 'RESUME',
  Status = 'STATUS',
  UserComment = 'USER_COMMENT'
}

export type SupportAiVisibleMessageKindOperationFilterInput = {
  eq?: InputMaybe<SupportAiVisibleMessageKind>;
  in?: InputMaybe<Array<SupportAiVisibleMessageKind>>;
  neq?: InputMaybe<SupportAiVisibleMessageKind>;
  nin?: InputMaybe<Array<SupportAiVisibleMessageKind>>;
};

export type SupportGroup = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  members?: Maybe<Array<Maybe<SupportGroupMember>>>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  receivesProblemSubmissions: Scalars['Boolean'];
  supportTickets?: Maybe<Array<Maybe<SupportTicket>>>;
};

export type SupportGroupFilterInput = {
  and?: InputMaybe<Array<SupportGroupFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  members?: InputMaybe<ListFilterInputTypeOfSupportGroupMemberFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportGroupFilterInput>>;
  receivesProblemSubmissions?: InputMaybe<BooleanOperationFilterInput>;
  supportTickets?: InputMaybe<ListFilterInputTypeOfSupportTicketFilterInput>;
};

export type SupportGroupMember = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  supportGroup?: Maybe<SupportGroup>;
  supportGroupId: Scalars['Int'];
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
};

export type SupportGroupMemberFilterInput = {
  and?: InputMaybe<Array<SupportGroupMemberFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SupportGroupMemberFilterInput>>;
  supportGroup?: InputMaybe<SupportGroupFilterInput>;
  supportGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type SupportGroupSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  receivesProblemSubmissions?: InputMaybe<SortEnumType>;
};

export type SupportOpenAiExecution = {
  context: SupportOpenAiExecutionContextEnum;
  forUser?: Maybe<ApplicationUser>;
  forUserId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  message?: Maybe<SupportTicketMessage>;
  messageId?: Maybe<Scalars['Int']>;
  openAIMessage: Scalars['String'];
  openAIRequest: Scalars['String'];
  openAIResponse: Scalars['String'];
  ticket?: Maybe<SupportTicket>;
  ticketId?: Maybe<Scalars['Int']>;
};

export enum SupportOpenAiExecutionContextEnum {
  DetermineRecommendedUserForTicket = 'DETERMINE_RECOMMENDED_USER_FOR_TICKET'
}

export type SupportOpenAiExecutionContextEnumOperationFilterInput = {
  eq?: InputMaybe<SupportOpenAiExecutionContextEnum>;
  in?: InputMaybe<Array<SupportOpenAiExecutionContextEnum>>;
  neq?: InputMaybe<SupportOpenAiExecutionContextEnum>;
  nin?: InputMaybe<Array<SupportOpenAiExecutionContextEnum>>;
};

export type SupportOpenAiExecutionFilterInput = {
  and?: InputMaybe<Array<SupportOpenAiExecutionFilterInput>>;
  context?: InputMaybe<SupportOpenAiExecutionContextEnumOperationFilterInput>;
  forUser?: InputMaybe<ApplicationUserFilterInput>;
  forUserId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  message?: InputMaybe<SupportTicketMessageFilterInput>;
  messageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  openAIMessage?: InputMaybe<StringOperationFilterInput>;
  openAIRequest?: InputMaybe<StringOperationFilterInput>;
  openAIResponse?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportOpenAiExecutionFilterInput>>;
  ticket?: InputMaybe<SupportTicketFilterInput>;
  ticketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export enum SupportPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export type SupportPriorityEnumOperationFilterInput = {
  eq?: InputMaybe<SupportPriorityEnum>;
  in?: InputMaybe<Array<SupportPriorityEnum>>;
  neq?: InputMaybe<SupportPriorityEnum>;
  nin?: InputMaybe<Array<SupportPriorityEnum>>;
};

export enum SupportSourceEnum {
  Email = 'EMAIL',
  OnixPhone = 'ONIX_PHONE',
  Phone = 'PHONE',
  Portal = 'PORTAL',
  System = 'SYSTEM'
}

export type SupportSourceEnumOperationFilterInput = {
  eq?: InputMaybe<SupportSourceEnum>;
  in?: InputMaybe<Array<SupportSourceEnum>>;
  neq?: InputMaybe<SupportSourceEnum>;
  nin?: InputMaybe<Array<SupportSourceEnum>>;
};

export enum SupportStatusEnum {
  Closed = 'CLOSED',
  ForReview = 'FOR_REVIEW',
  InProgress = 'IN_PROGRESS',
  IBackup = 'I_BACKUP',
  Maintenance = 'MAINTENANCE',
  Open = 'OPEN',
  PantheonUpgrade = 'PANTHEON_UPGRADE',
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
  Spam = 'SPAM',
  WaitingForOffer = 'WAITING_FOR_OFFER'
}

export type SupportStatusEnumOperationFilterInput = {
  eq?: InputMaybe<SupportStatusEnum>;
  in?: InputMaybe<Array<SupportStatusEnum>>;
  neq?: InputMaybe<SupportStatusEnum>;
  nin?: InputMaybe<Array<SupportStatusEnum>>;
};

export type SupportTicket = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contactCompanyCompany?: Maybe<Company>;
  contactCompanyCompanyId?: Maybe<Scalars['Int']>;
  contactCompanyContact?: Maybe<Contact>;
  contactCompanyContactId?: Maybe<Scalars['Int']>;
  contactEmail?: Maybe<ContactEmail>;
  contactEmailId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  dateDue?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  messagesDeleted: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  offerNumber?: Maybe<Scalars['String']>;
  offerTypeDefault: Scalars['Boolean'];
  originalSender?: Maybe<Scalars['String']>;
  pantheonVersion?: Maybe<PantheonVersion>;
  pantheonVersionId?: Maybe<Scalars['Int']>;
  priority: SupportPriorityEnum;
  problemSubmissionSourceKey?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']>;
  reportedByApplicationUser?: Maybe<ApplicationUser>;
  reportedByApplicationUserId?: Maybe<Scalars['String']>;
  showProjectFeatures: Scalars['Boolean'];
  source: SupportSourceEnum;
  status: SupportStatusEnum;
  supportGroup?: Maybe<SupportGroup>;
  supportGroupId?: Maybe<Scalars['Int']>;
  supportOpenAIExecutions?: Maybe<Array<Maybe<SupportOpenAiExecution>>>;
  supportTicketMessages?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  supportTicketTimeLogs?: Maybe<Array<Maybe<SupportTicketTimeLog>>>;
  supportTicketTodos?: Maybe<Array<Maybe<SupportTicketTodo>>>;
  teamViewerSessions?: Maybe<Array<Maybe<TeamViewerSession>>>;
  temporaryOwner?: Maybe<ApplicationUser>;
  temporaryOwnerId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
  wakaTimeWorklogs?: Maybe<Array<Maybe<WakaTimeWorklog>>>;
};

export type SupportTicketFilterInput = {
  and?: InputMaybe<Array<SupportTicketFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactCompanyCompany?: InputMaybe<CompanyFilterInput>;
  contactCompanyCompanyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactCompanyContact?: InputMaybe<ContactFilterInput>;
  contactCompanyContactId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactEmail?: InputMaybe<ContactEmailFilterInput>;
  contactEmailId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  messagesDeleted?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  offerNumber?: InputMaybe<StringOperationFilterInput>;
  offerTypeDefault?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SupportTicketFilterInput>>;
  originalSender?: InputMaybe<StringOperationFilterInput>;
  pantheonVersion?: InputMaybe<PantheonVersionFilterInput>;
  pantheonVersionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  priority?: InputMaybe<SupportPriorityEnumOperationFilterInput>;
  problemSubmissionSourceKey?: InputMaybe<StringOperationFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reportedByApplicationUser?: InputMaybe<ApplicationUserFilterInput>;
  reportedByApplicationUserId?: InputMaybe<StringOperationFilterInput>;
  showProjectFeatures?: InputMaybe<BooleanOperationFilterInput>;
  source?: InputMaybe<SupportSourceEnumOperationFilterInput>;
  status?: InputMaybe<SupportStatusEnumOperationFilterInput>;
  supportGroup?: InputMaybe<SupportGroupFilterInput>;
  supportGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportOpenAIExecutions?: InputMaybe<ListFilterInputTypeOfSupportOpenAiExecutionFilterInput>;
  supportTicketMessages?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  supportTicketTimeLogs?: InputMaybe<ListFilterInputTypeOfSupportTicketTimeLogFilterInput>;
  supportTicketTodos?: InputMaybe<ListFilterInputTypeOfSupportTicketTodoFilterInput>;
  teamViewerSessions?: InputMaybe<ListFilterInputTypeOfTeamViewerSessionFilterInput>;
  temporaryOwner?: InputMaybe<ApplicationUserFilterInput>;
  temporaryOwnerId?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  wakaTimeWorklogs?: InputMaybe<ListFilterInputTypeOfWakaTimeWorklogFilterInput>;
};

export type SupportTicketMessage = {
  attachments?: Maybe<Array<Maybe<SavedFile>>>;
  cCEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  codexTaskId?: Maybe<Scalars['String']>;
  codexTaskLastSeenOn?: Maybe<Scalars['DateTime']>;
  codexTaskWorkedOn?: Maybe<Scalars['DateTime']>;
  collapsed: Scalars['Boolean'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  customerHasSeen?: Maybe<Scalars['Boolean']>;
  customerHasSeenAt?: Maybe<Scalars['DateTime']>;
  globalMessageId?: Maybe<Scalars['String']>;
  globalMessageReplyId?: Maybe<Scalars['String']>;
  helpBookId?: Maybe<Scalars['Int']>;
  helpId?: Maybe<Scalars['Int']>;
  helpLink?: Maybe<Scalars['String']>;
  helpTitle?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inbound: Scalars['Boolean'];
  internalCommunicationTo?: Maybe<SupportTicketMessage>;
  internalCommunicationToId?: Maybe<Scalars['Int']>;
  internalCommunications?: Maybe<Array<Maybe<SupportTicketMessage>>>;
  isQueryExecution: Scalars['Boolean'];
  isTask: Scalars['Boolean'];
  isTaskDone: Scalars['Boolean'];
  messageId: Scalars['Long'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notifyEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  notifyUsers?: Maybe<Array<Maybe<ApplicationUser>>>;
  originalCCs?: Maybe<Scalars['String']>;
  originalReceiver?: Maybe<Scalars['String']>;
  originalReceiverName?: Maybe<Scalars['String']>;
  originalSender?: Maybe<Scalars['String']>;
  originalSenderName?: Maybe<Scalars['String']>;
  originalSubject?: Maybe<Scalars['String']>;
  outbound: Scalars['Boolean'];
  private: Scalars['Boolean'];
  remoteContentSavedFileId?: Maybe<Scalars['Int']>;
  responsibleAgent?: Maybe<ApplicationUser>;
  responsibleAgentId?: Maybe<Scalars['String']>;
  scheduledSendOn?: Maybe<Scalars['DateTime']>;
  sentAs?: Maybe<ApplicationUser>;
  sentAsId?: Maybe<Scalars['String']>;
  sentBy?: Maybe<ApplicationUser>;
  sentById?: Maybe<Scalars['String']>;
  supportAiRunId?: Maybe<Scalars['Int']>;
  supportAiThreadId?: Maybe<Scalars['Int']>;
  supportOpenAIExecutions?: Maybe<Array<Maybe<SupportOpenAiExecution>>>;
  taskDue?: Maybe<Scalars['DateTime']>;
  taskStart?: Maybe<Scalars['DateTime']>;
  textContent?: Maybe<Scalars['String']>;
  ticket?: Maybe<SupportTicket>;
  ticketId?: Maybe<Scalars['Int']>;
  unreadUserSupportTicketMessage?: Maybe<Array<Maybe<UnreadUserSupportTicketMessage>>>;
};

export type SupportTicketMessageFilterInput = {
  and?: InputMaybe<Array<SupportTicketMessageFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  cCEmails?: InputMaybe<ListStringOperationFilterInput>;
  codexTaskId?: InputMaybe<StringOperationFilterInput>;
  codexTaskLastSeenOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  codexTaskWorkedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  collapsed?: InputMaybe<BooleanOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  content?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customerHasSeen?: InputMaybe<BooleanOperationFilterInput>;
  customerHasSeenAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  globalMessageId?: InputMaybe<StringOperationFilterInput>;
  globalMessageReplyId?: InputMaybe<StringOperationFilterInput>;
  helpBookId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  helpId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  helpLink?: InputMaybe<StringOperationFilterInput>;
  helpTitle?: InputMaybe<StringOperationFilterInput>;
  htmlContent?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inbound?: InputMaybe<BooleanOperationFilterInput>;
  internalCommunicationTo?: InputMaybe<SupportTicketMessageFilterInput>;
  internalCommunicationToId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  internalCommunications?: InputMaybe<ListFilterInputTypeOfSupportTicketMessageFilterInput>;
  isQueryExecution?: InputMaybe<BooleanOperationFilterInput>;
  isTask?: InputMaybe<BooleanOperationFilterInput>;
  isTaskDone?: InputMaybe<BooleanOperationFilterInput>;
  messageId?: InputMaybe<ComparableInt64OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notifyEmails?: InputMaybe<ListStringOperationFilterInput>;
  notifyUsers?: InputMaybe<ListFilterInputTypeOfApplicationUserFilterInput>;
  or?: InputMaybe<Array<SupportTicketMessageFilterInput>>;
  originalCCs?: InputMaybe<StringOperationFilterInput>;
  originalReceiver?: InputMaybe<StringOperationFilterInput>;
  originalReceiverName?: InputMaybe<StringOperationFilterInput>;
  originalSender?: InputMaybe<StringOperationFilterInput>;
  originalSenderName?: InputMaybe<StringOperationFilterInput>;
  originalSubject?: InputMaybe<StringOperationFilterInput>;
  outbound?: InputMaybe<BooleanOperationFilterInput>;
  private?: InputMaybe<BooleanOperationFilterInput>;
  remoteContentSavedFileId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  responsibleAgent?: InputMaybe<ApplicationUserFilterInput>;
  responsibleAgentId?: InputMaybe<StringOperationFilterInput>;
  scheduledSendOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  sentAs?: InputMaybe<ApplicationUserFilterInput>;
  sentAsId?: InputMaybe<StringOperationFilterInput>;
  sentBy?: InputMaybe<ApplicationUserFilterInput>;
  sentById?: InputMaybe<StringOperationFilterInput>;
  supportAiRunId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportAiThreadId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportOpenAIExecutions?: InputMaybe<ListFilterInputTypeOfSupportOpenAiExecutionFilterInput>;
  taskDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  taskStart?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  textContent?: InputMaybe<StringOperationFilterInput>;
  ticket?: InputMaybe<SupportTicketFilterInput>;
  ticketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  unreadUserSupportTicketMessage?: InputMaybe<ListFilterInputTypeOfUnreadUserSupportTicketMessageFilterInput>;
};

export type SupportTicketMessageSortInput = {
  codexTaskId?: InputMaybe<SortEnumType>;
  codexTaskLastSeenOn?: InputMaybe<SortEnumType>;
  codexTaskWorkedOn?: InputMaybe<SortEnumType>;
  collapsed?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  content?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customerHasSeen?: InputMaybe<SortEnumType>;
  customerHasSeenAt?: InputMaybe<SortEnumType>;
  globalMessageId?: InputMaybe<SortEnumType>;
  globalMessageReplyId?: InputMaybe<SortEnumType>;
  helpBookId?: InputMaybe<SortEnumType>;
  helpId?: InputMaybe<SortEnumType>;
  helpLink?: InputMaybe<SortEnumType>;
  helpTitle?: InputMaybe<SortEnumType>;
  htmlContent?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inbound?: InputMaybe<SortEnumType>;
  internalCommunicationTo?: InputMaybe<SupportTicketMessageSortInput>;
  internalCommunicationToId?: InputMaybe<SortEnumType>;
  isQueryExecution?: InputMaybe<SortEnumType>;
  isTask?: InputMaybe<SortEnumType>;
  isTaskDone?: InputMaybe<SortEnumType>;
  messageId?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  originalCCs?: InputMaybe<SortEnumType>;
  originalReceiver?: InputMaybe<SortEnumType>;
  originalReceiverName?: InputMaybe<SortEnumType>;
  originalSender?: InputMaybe<SortEnumType>;
  originalSenderName?: InputMaybe<SortEnumType>;
  originalSubject?: InputMaybe<SortEnumType>;
  outbound?: InputMaybe<SortEnumType>;
  private?: InputMaybe<SortEnumType>;
  remoteContentSavedFileId?: InputMaybe<SortEnumType>;
  responsibleAgent?: InputMaybe<ApplicationUserSortInput>;
  responsibleAgentId?: InputMaybe<SortEnumType>;
  scheduledSendOn?: InputMaybe<SortEnumType>;
  sentAs?: InputMaybe<ApplicationUserSortInput>;
  sentAsId?: InputMaybe<SortEnumType>;
  sentBy?: InputMaybe<ApplicationUserSortInput>;
  sentById?: InputMaybe<SortEnumType>;
  supportAiRunId?: InputMaybe<SortEnumType>;
  supportAiThreadId?: InputMaybe<SortEnumType>;
  taskDue?: InputMaybe<SortEnumType>;
  taskStart?: InputMaybe<SortEnumType>;
  textContent?: InputMaybe<SortEnumType>;
  ticket?: InputMaybe<SupportTicketSortInput>;
  ticketId?: InputMaybe<SortEnumType>;
};

export type SupportTicketSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contactCompanyCompany?: InputMaybe<CompanySortInput>;
  contactCompanyCompanyId?: InputMaybe<SortEnumType>;
  contactCompanyContact?: InputMaybe<ContactSortInput>;
  contactCompanyContactId?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<ContactEmailSortInput>;
  contactEmailId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  dateDue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  messagesDeleted?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  offerNumber?: InputMaybe<SortEnumType>;
  offerTypeDefault?: InputMaybe<SortEnumType>;
  originalSender?: InputMaybe<SortEnumType>;
  pantheonVersion?: InputMaybe<PantheonVersionSortInput>;
  pantheonVersionId?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  problemSubmissionSourceKey?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  reportedByApplicationUser?: InputMaybe<ApplicationUserSortInput>;
  reportedByApplicationUserId?: InputMaybe<SortEnumType>;
  showProjectFeatures?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  supportGroup?: InputMaybe<SupportGroupSortInput>;
  supportGroupId?: InputMaybe<SortEnumType>;
  temporaryOwner?: InputMaybe<ApplicationUserSortInput>;
  temporaryOwnerId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type SupportTicketTimeLog = {
  agent?: Maybe<ApplicationUser>;
  agentId?: Maybe<Scalars['String']>;
  billable: Scalars['Boolean'];
  billableTime: Scalars['TimeSpan'];
  codexCumulativeDurationMs?: Maybe<Scalars['Long']>;
  codexSnapshotAtUtc?: Maybe<Scalars['DateTime']>;
  codexTaskId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  exportedOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  invoice: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  projectPhase?: Maybe<Scalars['String']>;
  technicalNote?: Maybe<Scalars['String']>;
  ticket?: Maybe<SupportTicket>;
  ticketId?: Maybe<Scalars['Int']>;
  time: Scalars['TimeSpan'];
  type?: Maybe<Scalars['String']>;
  workOutsideWorkingHours: Scalars['Boolean'];
};

export type SupportTicketTimeLogFilterInput = {
  agent?: InputMaybe<ApplicationUserFilterInput>;
  agentId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<SupportTicketTimeLogFilterInput>>;
  billable?: InputMaybe<BooleanOperationFilterInput>;
  billableTime?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  codexCumulativeDurationMs?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  codexSnapshotAtUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  codexTaskId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  exportedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  invoice?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupportTicketTimeLogFilterInput>>;
  projectPhase?: InputMaybe<StringOperationFilterInput>;
  technicalNote?: InputMaybe<StringOperationFilterInput>;
  ticket?: InputMaybe<SupportTicketFilterInput>;
  ticketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  time?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  workOutsideWorkingHours?: InputMaybe<BooleanOperationFilterInput>;
};

export type SupportTicketTimeLogSortInput = {
  agent?: InputMaybe<ApplicationUserSortInput>;
  agentId?: InputMaybe<SortEnumType>;
  billable?: InputMaybe<SortEnumType>;
  billableTime?: InputMaybe<SortEnumType>;
  codexCumulativeDurationMs?: InputMaybe<SortEnumType>;
  codexSnapshotAtUtc?: InputMaybe<SortEnumType>;
  codexTaskId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  exportedOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invoice?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  projectPhase?: InputMaybe<SortEnumType>;
  technicalNote?: InputMaybe<SortEnumType>;
  ticket?: InputMaybe<SupportTicketSortInput>;
  ticketId?: InputMaybe<SortEnumType>;
  time?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  workOutsideWorkingHours?: InputMaybe<SortEnumType>;
};

export type SupportTicketTodo = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  dateTime: Scalars['DateTime'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  notified: Scalars['Boolean'];
  ticket?: Maybe<SupportTicket>;
  ticketId: Scalars['Int'];
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
};

export type SupportTicketTodoFilterInput = {
  and?: InputMaybe<Array<SupportTicketTodoFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dateTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  notified?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SupportTicketTodoFilterInput>>;
  ticket?: InputMaybe<SupportTicketFilterInput>;
  ticketId?: InputMaybe<ComparableInt32OperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type Synchronization = {
  added: Scalars['Int'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  deleted: Scalars['Int'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  resource?: Maybe<Scalars['String']>;
  time: Scalars['DateTime'];
  updated: Scalars['Int'];
};

export type SynchronizationFilterInput = {
  added?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<SynchronizationFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deleted?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SynchronizationFilterInput>>;
  resource?: InputMaybe<StringOperationFilterInput>;
  time?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  updated?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TDeSetAccount = {
  acAcct?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPermitPost?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anPlanId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type TDeSetAccountFilterInput = {
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPermitPost?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anPlanId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TDeSetAccountFilterInput>>;
  or?: InputMaybe<Array<TDeSetAccountFilterInput>>;
};

/** A connection to a list of items. */
export type TDeSetAccountPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<TDeSetAccountPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TDeSetAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TDeSetAccountPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TDeSetAccount>;
};

export type TDeSetAccountSortInput = {
  acAcct?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPermitPost?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anPlanId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeAcctTransItem = {
  acAcct?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  adDateDoc: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anCredit: Scalars['Decimal'];
  anDebit: Scalars['Decimal'];
  anNo: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  anValCredit: Scalars['Decimal'];
  anValDebit: Scalars['Decimal'];
};

/** A connection to a list of items. */
export type THeAcctTransItemConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeAcctTransItemEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeAcctTransItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeAcctTransItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeAcctTransItem>;
};

export type THeAcctTransItemFilterInput = {
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  adDateDoc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anCredit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDebit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValCredit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anValDebit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeAcctTransItemFilterInput>>;
  or?: InputMaybe<Array<THeAcctTransItemFilterInput>>;
};

export type THeAcctTransItemSortInput = {
  acAcct?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acLinkDoc?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  adDateDoc?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anCredit?: InputMaybe<SortEnumType>;
  anDebit?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValCredit?: InputMaybe<SortEnumType>;
  anValDebit?: InputMaybe<SortEnumType>;
};

export type THeCashReg = {
  acCurrency?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acLocked?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anDocNo?: Maybe<Scalars['Int']>;
  anDocYear: Scalars['Int'];
  anPaid: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anRefund: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  tHeCashRegItems?: Maybe<Array<Maybe<THeCashRegItem>>>;
};

export type THeCashRegFilterInput = {
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLocked?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDocNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDocYear?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPaid?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRefund?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeCashRegFilterInput>>;
  or?: InputMaybe<Array<THeCashRegFilterInput>>;
  tHeCashRegItems?: InputMaybe<ListFilterInputTypeOfTHeCashRegItemFilterInput>;
};

export type THeCashRegItem = {
  acAcct?: Maybe<Scalars['String']>;
  acCostDrv?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeCashReg>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayMethodNavigation?: Maybe<THeSetPayMet>;
  acTrvlType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anAmount: Scalars['Decimal'];
  anEventTypeId?: Maybe<Scalars['Int']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeCashRegItemFilterInput = {
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeCashRegFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetFilterInput>;
  acTrvlType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anEventTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeCashRegItemFilterInput>>;
  or?: InputMaybe<Array<THeCashRegItemFilterInput>>;
};

export type THeCashRegItemSortInput = {
  acAcct?: InputMaybe<SortEnumType>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeCashRegSortInput>;
  acLinkDoc?: InputMaybe<SortEnumType>;
  acLnkKey?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetSortInput>;
  acTrvlType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anAmount?: InputMaybe<SortEnumType>;
  anEventTypeId?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type THeCashRegPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeCashRegPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeCashReg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeCashRegPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeCashReg>;
};

export type THeCashRegSortInput = {
  acCurrency?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDoc1?: InputMaybe<SortEnumType>;
  acDoc2?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acLocked?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateDoc1?: InputMaybe<SortEnumType>;
  adDateDoc2?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anDocNo?: InputMaybe<SortEnumType>;
  anDocYear?: InputMaybe<SortEnumType>;
  anPaid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anRefund?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
};

export type THeCostDrv = {
  acClassif?: Maybe<Scalars['String']>;
  acConsignee?: Maybe<Scalars['String']>;
  acConsigneeNavigation?: Maybe<THeSetSubj>;
  acCostDrv?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acFieldSa?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeMove?: Maybe<Array<Maybe<THeMove>>>;
  tHfPlans?: Maybe<Array<Maybe<THfPlan>>>;
  tHfWoexes?: Maybe<Array<Maybe<THfWoex>>>;
};

export type THeCostDrvFilterInput = {
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acConsignee?: InputMaybe<StringOperationFilterInput>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeCostDrvFilterInput>>;
  or?: InputMaybe<Array<THeCostDrvFilterInput>>;
  tHeMove?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHfPlans?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfWoexes?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
};

/** A connection to a list of items. */
export type THeCostDrvPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeCostDrvPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeCostDrv>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeCostDrvPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeCostDrv>;
};

export type THeCostDrvSortInput = {
  acClassif?: InputMaybe<SortEnumType>;
  acConsignee?: InputMaybe<SortEnumType>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjSortInput>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeFa = {
  acActive?: Maybe<Scalars['String']>;
  acCarRegNo?: Maybe<Scalars['String']>;
  acCompanyCar?: Maybe<Scalars['String']>;
  acInventNum?: Maybe<Scalars['String']>;
  acIsRented?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acSuppCarRegNo?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acVtsid?: Maybe<Scalars['String']>;
  adDateOfAcq?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQty: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeFaFilterInput = {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acCompanyCar?: InputMaybe<StringOperationFilterInput>;
  acInventNum?: InputMaybe<StringOperationFilterInput>;
  acIsRented?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acSuppCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acVtsid?: InputMaybe<StringOperationFilterInput>;
  adDateOfAcq?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeFaFilterInput>>;
  or?: InputMaybe<Array<THeFaFilterInput>>;
};

/** A connection to a list of items. */
export type THeFaPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeFaPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeFa>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeFaPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeFa>;
};

export type THeFaSortInput = {
  acActive?: InputMaybe<SortEnumType>;
  acCarRegNo?: InputMaybe<SortEnumType>;
  acCompanyCar?: InputMaybe<SortEnumType>;
  acInventNum?: InputMaybe<SortEnumType>;
  acIsRented?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acSuppCarRegNo?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acVtsid?: InputMaybe<SortEnumType>;
  adDateOfAcq?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeLinkMoveItemMoveItem = {
  a?: Maybe<THeMoveItem>;
  aNavigation?: Maybe<THeMoveItem>;
  acKey?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acTypeA?: Maybe<Scalars['String']>;
  acTypeB?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLnkNo: Scalars['Int'];
  anMoveItemChildQid: Scalars['Int'];
  anMoveItemParentQid: Scalars['Int'];
  anNo: Scalars['Int'];
  anQty: Scalars['Float'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeLinkMoveItemMoveItemFilterInput = {
  a?: InputMaybe<THeMoveItemFilterInput>;
  aNavigation?: InputMaybe<THeMoveItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeA?: InputMaybe<StringOperationFilterInput>;
  acTypeB?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anMoveItemChildQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anMoveItemParentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeLinkMoveItemMoveItemFilterInput>>;
  or?: InputMaybe<Array<THeLinkMoveItemMoveItemFilterInput>>;
};

export type THeLinkMoveItemOrderItem = {
  a?: Maybe<THeMoveItem>;
  aNavigation?: Maybe<THeOrderItem>;
  acKey?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acTypeA?: Maybe<Scalars['String']>;
  acTypeB?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLnkNo: Scalars['Int'];
  anMoveItemQid: Scalars['Int'];
  anNo: Scalars['Int'];
  anOrderItemQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeLinkMoveItemOrderItemFilterInput = {
  a?: InputMaybe<THeMoveItemFilterInput>;
  aNavigation?: InputMaybe<THeOrderItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeA?: InputMaybe<StringOperationFilterInput>;
  acTypeB?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anMoveItemQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anOrderItemQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeLinkMoveItemOrderItemFilterInput>>;
  or?: InputMaybe<Array<THeLinkMoveItemOrderItemFilterInput>>;
};

export type THeLinkMoveMove = {
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acLnkKey?: Maybe<Scalars['String']>;
  acLnkKeyNavigation?: Maybe<THeMove>;
  acType?: Maybe<Scalars['String']>;
  acTypeA?: Maybe<Scalars['String']>;
  acTypeB?: Maybe<Scalars['String']>;
  acValue?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFieldNa: Scalars['Float'];
  anFieldNb: Scalars['Float'];
  anLnkNo: Scalars['Int'];
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeLinkMoveMoveFilterInput = {
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeA?: InputMaybe<StringOperationFilterInput>;
  acTypeB?: InputMaybe<StringOperationFilterInput>;
  acValue?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeLinkMoveMoveFilterInput>>;
  or?: InputMaybe<Array<THeLinkMoveMoveFilterInput>>;
};

export type THeMove = {
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acCostDrvOut?: Maybe<Scalars['String']>;
  acCostDrvOutNavigation?: Maybe<THeCostDrv>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDeliveryNavigation?: Maybe<THeSetDelMet>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acDeptOut?: Maybe<Scalars['String']>;
  acDeptOutNavigation?: Maybe<THeSetSubj>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acFieldSA?: Maybe<Scalars['String']>;
  acFieldSF?: Maybe<Scalars['String']>;
  acFieldSJ?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFiscStatus?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerNavigation?: Maybe<THeSetSubj>;
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acNote2?: Maybe<Scalars['String']>;
  acParity?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayMethodNavigation?: Maybe<THeSetPayMet>;
  acPosted?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acPrsn3Navigation?: Maybe<THeSetSubj>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverNavigation?: Maybe<THeSetSubj>;
  acVerifiedPrices?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adDateDue?: Maybe<Scalars['DateTime']>;
  adDateTimePrint?: Maybe<Scalars['DateTime']>;
  adFieldDA?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anClerkNavigation?: Maybe<THeSetSubjContact>;
  anDiscount: Scalars['Decimal'];
  anFieldNA?: Maybe<Scalars['Decimal']>;
  anFieldNB?: Maybe<Scalars['Decimal']>;
  anFieldNc?: Maybe<Scalars['Decimal']>;
  anFieldNd?: Maybe<Scalars['Decimal']>;
  anFieldNe?: Maybe<Scalars['Decimal']>;
  anFieldNf?: Maybe<Scalars['Decimal']>;
  anFieldNg?: Maybe<Scalars['Decimal']>;
  anFieldNh?: Maybe<Scalars['Decimal']>;
  anFieldNi?: Maybe<Scalars['Decimal']>;
  anFieldNj?: Maybe<Scalars['Decimal']>;
  anForPay: Scalars['Decimal'];
  anNoteClerk?: Maybe<Scalars['Int']>;
  anNoteClerkNavigation?: Maybe<THeSetSubjContact>;
  anQid: Scalars['Int'];
  anRebate: Scalars['Decimal'];
  anSigner1?: Maybe<Scalars['Int']>;
  anSigner2?: Maybe<Scalars['Int']>;
  anSigner3?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  anVat: Scalars['Decimal'];
  eInvoiceStatus?: Maybe<EInvoiceDocumentStatusDto>;
  tHeLinkMoveMoveAcKeyNavigation?: Maybe<Array<Maybe<THeLinkMoveMove>>>;
  tHeLinkMoveMoveAcLnkKeyNavigation?: Maybe<Array<Maybe<THeLinkMoveMove>>>;
  tHeMoveFiscalisation?: Maybe<THeMoveFiscalisation>;
  tHeMoveItem?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeMoveItemExciseOuts?: Maybe<Array<Maybe<THeMoveItemExciseOut>>>;
  tHeMoveItemExcises?: Maybe<Array<Maybe<THeMoveItemExcise>>>;
  tHeMovePaymentRecords?: Maybe<Array<Maybe<THeMovePaymentRecord>>>;
  tHeMoveRmaworkSpecs?: Maybe<Array<Maybe<TrimTHeMoveRmaworkSpec>>>;
};

export type THeMoveDailyIncomeDto = {
  anForPay: Scalars['Decimal'];
  payMethodName?: Maybe<Scalars['String']>;
};

export type THeMoveDailyIncomeSummaryDto = {
  fromDate?: Maybe<Scalars['DateTime']>;
  fromDoc?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<THeMoveDailyIncomeDto>>>;
  toDate?: Maybe<Scalars['DateTime']>;
  toDoc?: Maybe<Scalars['Int']>;
};

export type THeMoveFilterInput = {
  acContactPrsn?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn3?: InputMaybe<StringOperationFilterInput>;
  acCostDrvOut?: InputMaybe<StringOperationFilterInput>;
  acCostDrvOutNavigation?: InputMaybe<THeCostDrvFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDeliveryNavigation?: InputMaybe<THeSetDelMetFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDeptOut?: InputMaybe<StringOperationFilterInput>;
  acDeptOutNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acFieldSA?: InputMaybe<StringOperationFilterInput>;
  acFieldSF?: InputMaybe<StringOperationFilterInput>;
  acFieldSJ?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFiscStatus?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acNote2?: InputMaybe<StringOperationFilterInput>;
  acParity?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetFilterInput>;
  acPosted?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Navigation?: InputMaybe<THeSetSubjFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  acVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateTimePrint?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDA?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNA?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNB?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anNoteClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNoteClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSigner1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeMoveFilterInput>>;
  or?: InputMaybe<Array<THeMoveFilterInput>>;
  tHeLinkMoveMoveAcKeyNavigation?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveMoveFilterInput>;
  tHeLinkMoveMoveAcLnkKeyNavigation?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveMoveFilterInput>;
  tHeMoveFiscalisation?: InputMaybe<THeMoveFiscalisationFilterInput>;
  tHeMoveItem?: InputMaybe<ListFilterInputTypeOfTHeMoveItemFilterInput>;
  tHeMoveItemExciseOuts?: InputMaybe<ListFilterInputTypeOfTHeMoveItemExciseOutFilterInput>;
  tHeMoveItemExcises?: InputMaybe<ListFilterInputTypeOfTHeMoveItemExciseFilterInput>;
  tHeMovePaymentRecords?: InputMaybe<ListFilterInputTypeOfTHeMovePaymentRecordFilterInput>;
  tHeMoveRmaworkSpecs?: InputMaybe<ListFilterInputTypeOfTrimTHeMoveRmaworkSpecFilterInput>;
};

export type THeMoveFiscalisation = {
  acBarcode?: Maybe<Scalars['String']>;
  acCustomTemplate?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acError?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acJir?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acWorkPlace?: Maybe<Scalars['String']>;
  acYearInv?: Maybe<Scalars['String']>;
  acZik?: Maybe<Scalars['String']>;
  adFiscalDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFiscVersion: Scalars['Int'];
  anFiscalDevice: Scalars['Int'];
  anFiscalNumber: Scalars['Int'];
  anQid?: Maybe<Scalars['Int']>;
  anQidTemplate?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeMoveFiscalisationFilterInput = {
  acBarcode?: InputMaybe<StringOperationFilterInput>;
  acCustomTemplate?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acError?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acJir?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  acYearInv?: InputMaybe<StringOperationFilterInput>;
  acZik?: InputMaybe<StringOperationFilterInput>;
  adFiscalDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFiscVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFiscalDevice?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFiscalNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidTemplate?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeMoveFiscalisationFilterInput>>;
  or?: InputMaybe<Array<THeMoveFiscalisationFilterInput>>;
};

export type THeMoveFiscalisationSortInput = {
  acBarcode?: InputMaybe<SortEnumType>;
  acCustomTemplate?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acError?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acJir?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeMoveSortInput>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  acYearInv?: InputMaybe<SortEnumType>;
  acZik?: InputMaybe<SortEnumType>;
  adFiscalDate?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anFiscVersion?: InputMaybe<SortEnumType>;
  anFiscalDevice?: InputMaybe<SortEnumType>;
  anFiscalNumber?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQidTemplate?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeMoveItem = {
  acCostDrv?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acUM2?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acVatcode?: Maybe<Scalars['String']>;
  acVatcodeNavigation?: Maybe<THeSetTax>;
  acVatcodeTr?: Maybe<Scalars['String']>;
  acVatcodeTrNavigation?: Maybe<THeSetTax>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDimWeight: Scalars['Float'];
  anExcise: Scalars['Float'];
  anExciseInc?: Maybe<Scalars['Float']>;
  anExciseIncP?: Maybe<Scalars['Float']>;
  anExciseNotInc?: Maybe<Scalars['Float']>;
  anExciseNotIncP?: Maybe<Scalars['Float']>;
  anExciseP: Scalars['Float'];
  anInRtprice: Scalars['Float'];
  anNo: Scalars['Int'];
  anPackQty: Scalars['Decimal'];
  anPrice: Scalars['Float'];
  anPriceCurrency: Scalars['Float'];
  anPvdiscount: Scalars['Decimal'];
  anPvexcise: Scalars['Decimal'];
  anPvforPay: Scalars['Decimal'];
  anPvocbeatShare: Scalars['Decimal'];
  anPvocbeatShareWoExc: Scalars['Decimal'];
  anPvocdirectCost: Scalars['Decimal'];
  anPvocdiscount: Scalars['Decimal'];
  anPvocduty: Scalars['Decimal'];
  anPvocexcise: Scalars['Decimal'];
  anPvocfixPriceDiff: Scalars['Decimal'];
  anPvocforPay: Scalars['Decimal'];
  anPvocforPayWoExc: Scalars['Decimal'];
  anPvocincVat: Scalars['Decimal'];
  anPvocincVatwoExc: Scalars['Decimal'];
  anPvocnonBeatShare: Scalars['Decimal'];
  anPvocnonBeatShareWoExc: Scalars['Decimal'];
  anPvocstockValue: Scalars['Decimal'];
  anPvocsuppExcise: Scalars['Decimal'];
  anPvocsuppExciseIncSv: Scalars['Decimal'];
  anPvocsuppExciseIncVb: Scalars['Decimal'];
  anPvocsuppExciseIncVbincSuppForPay?: Maybe<Scalars['Decimal']>;
  anPvocsuppExciseNonIncVb: Scalars['Decimal'];
  anPvocsuppExciseNonIncVbincSuppForPay?: Maybe<Scalars['Decimal']>;
  anPvoctransport: Scalars['Decimal'];
  anPvocvalue: Scalars['Decimal'];
  anPvocvat: Scalars['Decimal'];
  anPvocvatbase: Scalars['Decimal'];
  anPvocvatbaseWoExc: Scalars['Decimal'];
  anPvvalue?: Maybe<Scalars['Decimal']>;
  anPvvat: Scalars['Decimal'];
  anPvvatbase?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anRebate: Scalars['Float'];
  anRebate1: Scalars['Float'];
  anRebate2: Scalars['Float'];
  anRebate3: Scalars['Float'];
  anRetailPrice: Scalars['Decimal'];
  anRtprice: Scalars['Float'];
  anUserIns?: Maybe<Scalars['Int']>;
  anVat: Scalars['Float'];
  anWarrenty: Scalars['Int'];
  tHeLinkMoveItemMoveItemANavigations?: Maybe<Array<Maybe<THeLinkMoveItemMoveItem>>>;
  tHeLinkMoveItemMoveItemAs?: Maybe<Array<Maybe<THeLinkMoveItemMoveItem>>>;
  tHeLinkMoveItemOrderItem?: Maybe<Array<Maybe<THeLinkMoveItemOrderItem>>>;
  tHeMoveItemExciseOut?: Maybe<THeMoveItemExciseOut>;
  tHeMoveItemSerialNo?: Maybe<Array<Maybe<THeMoveItemSerialNo>>>;
};

export type THeMoveItemExcise = {
  acBaseType?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acInCalcRvc?: Maybe<Scalars['String']>;
  acIncBase?: Maybe<Scalars['String']>;
  acIncStockValue?: Maybe<Scalars['String']>;
  acIncSuppForPay?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acTransportCalcType?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anNoCost: Scalars['Int'];
  anPvocvalue: Scalars['Decimal'];
  anPvvalue: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anQty?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Float'];
  anValuePercent: Scalars['Float'];
};

export type THeMoveItemExciseFilterInput = {
  acBaseType?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acInCalcRvc?: InputMaybe<StringOperationFilterInput>;
  acIncBase?: InputMaybe<StringOperationFilterInput>;
  acIncStockValue?: InputMaybe<StringOperationFilterInput>;
  acIncSuppForPay?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acTransportCalcType?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNoCost?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPvocvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anValuePercent?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeMoveItemExciseFilterInput>>;
  or?: InputMaybe<Array<THeMoveItemExciseFilterInput>>;
};

export type THeMoveItemExciseOut = {
  acBaseType?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acInCalcRvc?: Maybe<Scalars['String']>;
  acIncBase?: Maybe<Scalars['String']>;
  acIncStockValue?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acSetOfTaxNavigation?: Maybe<THeSetDuty>;
  acTransportCalcType?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anNoCost: Scalars['Int'];
  anPvocvalue: Scalars['Decimal'];
  anPvvalue: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anQty?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Float'];
  anValuePercent: Scalars['Float'];
  tHeMoveItemNavigation?: Maybe<THeMoveItem>;
};

export type THeMoveItemExciseOutFilterInput = {
  acBaseType?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acInCalcRvc?: InputMaybe<StringOperationFilterInput>;
  acIncBase?: InputMaybe<StringOperationFilterInput>;
  acIncStockValue?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutyFilterInput>;
  acTransportCalcType?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNoCost?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPvocvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anValuePercent?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeMoveItemExciseOutFilterInput>>;
  or?: InputMaybe<Array<THeMoveItemExciseOutFilterInput>>;
  tHeMoveItemNavigation?: InputMaybe<THeMoveItemFilterInput>;
};

export type THeMoveItemExciseOutSortInput = {
  acBaseType?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acInCalcRvc?: InputMaybe<SortEnumType>;
  acIncBase?: InputMaybe<SortEnumType>;
  acIncStockValue?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeMoveSortInput>;
  acSetOfTax?: InputMaybe<SortEnumType>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutySortInput>;
  acTransportCalcType?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anNoCost?: InputMaybe<SortEnumType>;
  anPvocvalue?: InputMaybe<SortEnumType>;
  anPvvalue?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
  anValuePercent?: InputMaybe<SortEnumType>;
  tHeMoveItemNavigation?: InputMaybe<THeMoveItemSortInput>;
};

export type THeMoveItemFilterInput = {
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acUM2?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  acVatcodeNavigation?: InputMaybe<THeSetTaxFilterInput>;
  acVatcodeTr?: InputMaybe<StringOperationFilterInput>;
  acVatcodeTrNavigation?: InputMaybe<THeSetTaxFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDimWeight?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExcise?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExciseInc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseIncP?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseNotInc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseNotIncP?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anInRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPackQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPriceCurrency?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPvdiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvexcise?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvforPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocbeatShare?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocbeatShareWoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocdirectCost?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocdiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocduty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocexcise?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocfixPriceDiff?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocforPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocforPayWoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocincVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocincVatwoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocnonBeatShare?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocnonBeatShareWoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocstockValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExcise?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExciseIncSv?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExciseIncVb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExciseIncVbincSuppForPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocsuppExciseNonIncVb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocsuppExciseNonIncVbincSuppForPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvoctransport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocvalue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocvat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocvatbase?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvocvatbaseWoExc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvvalue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvvat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPvvatbase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate1?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate2?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate3?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRetailPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVat?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWarrenty?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeMoveItemFilterInput>>;
  or?: InputMaybe<Array<THeMoveItemFilterInput>>;
  tHeLinkMoveItemMoveItemANavigations?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveItemMoveItemFilterInput>;
  tHeLinkMoveItemMoveItemAs?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveItemMoveItemFilterInput>;
  tHeLinkMoveItemOrderItem?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveItemOrderItemFilterInput>;
  tHeMoveItemExciseOut?: InputMaybe<THeMoveItemExciseOutFilterInput>;
  tHeMoveItemSerialNo?: InputMaybe<ListFilterInputTypeOfTHeMoveItemSerialNoFilterInput>;
};

export type THeMoveItemSerialNo = {
  a?: Maybe<THeMoveItem>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acPackage?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSnwotype?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adDateDue: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anPackQty?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anStockPrice?: Maybe<Scalars['Float']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeMoveItemSerialNoFilterInput = {
  a?: InputMaybe<THeMoveItemFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acPackage?: InputMaybe<StringOperationFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acSnwotype?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPackQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anStockPrice?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeMoveItemSerialNoFilterInput>>;
  or?: InputMaybe<Array<THeMoveItemSerialNoFilterInput>>;
};

export type THeMoveItemSortInput = {
  acCostDrv?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeMoveSortInput>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acUM2?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acVatcode?: InputMaybe<SortEnumType>;
  acVatcodeNavigation?: InputMaybe<THeSetTaxSortInput>;
  acVatcodeTr?: InputMaybe<SortEnumType>;
  acVatcodeTrNavigation?: InputMaybe<THeSetTaxSortInput>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDimWeight?: InputMaybe<SortEnumType>;
  anExcise?: InputMaybe<SortEnumType>;
  anExciseInc?: InputMaybe<SortEnumType>;
  anExciseIncP?: InputMaybe<SortEnumType>;
  anExciseNotInc?: InputMaybe<SortEnumType>;
  anExciseNotIncP?: InputMaybe<SortEnumType>;
  anExciseP?: InputMaybe<SortEnumType>;
  anInRtprice?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anPackQty?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anPriceCurrency?: InputMaybe<SortEnumType>;
  anPvdiscount?: InputMaybe<SortEnumType>;
  anPvexcise?: InputMaybe<SortEnumType>;
  anPvforPay?: InputMaybe<SortEnumType>;
  anPvocbeatShare?: InputMaybe<SortEnumType>;
  anPvocbeatShareWoExc?: InputMaybe<SortEnumType>;
  anPvocdirectCost?: InputMaybe<SortEnumType>;
  anPvocdiscount?: InputMaybe<SortEnumType>;
  anPvocduty?: InputMaybe<SortEnumType>;
  anPvocexcise?: InputMaybe<SortEnumType>;
  anPvocfixPriceDiff?: InputMaybe<SortEnumType>;
  anPvocforPay?: InputMaybe<SortEnumType>;
  anPvocforPayWoExc?: InputMaybe<SortEnumType>;
  anPvocincVat?: InputMaybe<SortEnumType>;
  anPvocincVatwoExc?: InputMaybe<SortEnumType>;
  anPvocnonBeatShare?: InputMaybe<SortEnumType>;
  anPvocnonBeatShareWoExc?: InputMaybe<SortEnumType>;
  anPvocstockValue?: InputMaybe<SortEnumType>;
  anPvocsuppExcise?: InputMaybe<SortEnumType>;
  anPvocsuppExciseIncSv?: InputMaybe<SortEnumType>;
  anPvocsuppExciseIncVb?: InputMaybe<SortEnumType>;
  anPvocsuppExciseIncVbincSuppForPay?: InputMaybe<SortEnumType>;
  anPvocsuppExciseNonIncVb?: InputMaybe<SortEnumType>;
  anPvocsuppExciseNonIncVbincSuppForPay?: InputMaybe<SortEnumType>;
  anPvoctransport?: InputMaybe<SortEnumType>;
  anPvocvalue?: InputMaybe<SortEnumType>;
  anPvocvat?: InputMaybe<SortEnumType>;
  anPvocvatbase?: InputMaybe<SortEnumType>;
  anPvocvatbaseWoExc?: InputMaybe<SortEnumType>;
  anPvvalue?: InputMaybe<SortEnumType>;
  anPvvat?: InputMaybe<SortEnumType>;
  anPvvatbase?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRebate1?: InputMaybe<SortEnumType>;
  anRebate2?: InputMaybe<SortEnumType>;
  anRebate3?: InputMaybe<SortEnumType>;
  anRetailPrice?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  anWarrenty?: InputMaybe<SortEnumType>;
  tHeMoveItemExciseOut?: InputMaybe<THeMoveItemExciseOutSortInput>;
};

/** A connection to a list of items. */
export type THeMovePagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeMovePagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeMovePagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
};

/** A connection to a list of items. */
export type THeMovePagedParametrizedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeMovePagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type THeMovePagedParametrizedDtoConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeMovePagedParametrizedDtoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeMovePagedParametrizedDtoEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
};

export type THeMovePagedParametrizedDtoInput = {
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acDeptOut?: InputMaybe<Scalars['String']>;
  acDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acIssuer?: InputMaybe<Scalars['String']>;
  acKeys?: InputMaybe<Array<Scalars['String']>>;
  acPrsn3?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acVerifiedPrices?: InputMaybe<Scalars['String']>;
  acVerifyStatus?: InputMaybe<Scalars['String']>;
  acWorker?: InputMaybe<Scalars['String']>;
  adFieldDAIsNotNull?: InputMaybe<Scalars['Boolean']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anUserIns?: InputMaybe<Scalars['Int']>;
  filterByCurrentUserIdIsAnSigner1?: InputMaybe<Scalars['Boolean']>;
  filterMovesByThisAcIssuer?: InputMaybe<Scalars['String']>;
  filterMovesByThisAcReceiver?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyDocumentsWhereAnClerkIsOnReceiverOrIssuer?: InputMaybe<Scalars['Boolean']>;
  showOnlyWOWhereCurrentUserSpecExists?: InputMaybe<Scalars['Boolean']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeMovePagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
};

/** An edge in a connection. */
export type THeMovePagedParametrizedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
};

export enum THeMovePagedSortField {
  AcContactPrsn = 'AC_CONTACT_PRSN',
  AcContactPrsn3 = 'AC_CONTACT_PRSN3',
  AcDelivery = 'AC_DELIVERY',
  AcDept = 'AC_DEPT',
  AcDeptOut = 'AC_DEPT_OUT',
  AcDoc1 = 'AC_DOC1',
  AcDoc2 = 'AC_DOC2',
  AcDocType = 'AC_DOC_TYPE',
  AcIssuer = 'AC_ISSUER',
  AcKey = 'AC_KEY',
  AcNote = 'AC_NOTE',
  AcPrsn3 = 'AC_PRSN3',
  AcReceiver = 'AC_RECEIVER',
  AcVerifyStatus = 'AC_VERIFY_STATUS',
  AdDate = 'AD_DATE',
  AdDateDoc1 = 'AD_DATE_DOC1',
  AdDateDoc2 = 'AD_DATE_DOC2',
  AnClerk = 'AN_CLERK'
}

export type THeMovePaymentRecord = {
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  paymentResponse?: Maybe<Scalars['String']>;
  tHeMove?: Maybe<THeMove>;
  tHeMoveAcKey?: Maybe<Scalars['String']>;
};

export type THeMovePaymentRecordFilterInput = {
  and?: InputMaybe<Array<THeMovePaymentRecordFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<THeMovePaymentRecordFilterInput>>;
  paymentResponse?: InputMaybe<StringOperationFilterInput>;
  tHeMove?: InputMaybe<THeMoveFilterInput>;
  tHeMoveAcKey?: InputMaybe<StringOperationFilterInput>;
};

export type THeMoveSortInput = {
  acContactPrsn?: InputMaybe<SortEnumType>;
  acContactPrsn3?: InputMaybe<SortEnumType>;
  acCostDrvOut?: InputMaybe<SortEnumType>;
  acCostDrvOutNavigation?: InputMaybe<THeCostDrvSortInput>;
  acCurrency?: InputMaybe<SortEnumType>;
  acDelivery?: InputMaybe<SortEnumType>;
  acDeliveryNavigation?: InputMaybe<THeSetDelMetSortInput>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDeptOut?: InputMaybe<SortEnumType>;
  acDeptOutNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDoc1?: InputMaybe<SortEnumType>;
  acDoc2?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acFieldSA?: InputMaybe<SortEnumType>;
  acFieldSF?: InputMaybe<SortEnumType>;
  acFieldSJ?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFiscStatus?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerNavigation?: InputMaybe<THeSetSubjSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acNote2?: InputMaybe<SortEnumType>;
  acParity?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetSortInput>;
  acPosted?: InputMaybe<SortEnumType>;
  acPrsn3?: InputMaybe<SortEnumType>;
  acPrsn3Navigation?: InputMaybe<THeSetSubjSortInput>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverNavigation?: InputMaybe<THeSetSubjSortInput>;
  acVerifiedPrices?: InputMaybe<SortEnumType>;
  acVerifyStatus?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateDoc1?: InputMaybe<SortEnumType>;
  adDateDoc2?: InputMaybe<SortEnumType>;
  adDateDue?: InputMaybe<SortEnumType>;
  adDateTimePrint?: InputMaybe<SortEnumType>;
  adFieldDA?: InputMaybe<SortEnumType>;
  adFieldDb?: InputMaybe<SortEnumType>;
  adFieldDc?: InputMaybe<SortEnumType>;
  adFieldDd?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anDiscount?: InputMaybe<SortEnumType>;
  anFieldNA?: InputMaybe<SortEnumType>;
  anFieldNB?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anForPay?: InputMaybe<SortEnumType>;
  anNoteClerk?: InputMaybe<SortEnumType>;
  anNoteClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anQid?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anSigner1?: InputMaybe<SortEnumType>;
  anSigner2?: InputMaybe<SortEnumType>;
  anSigner3?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  tHeMoveFiscalisation?: InputMaybe<THeMoveFiscalisationSortInput>;
};

export type THeOrder = {
  acConsignee?: Maybe<Scalars['String']>;
  acConsigneeNavigation?: Maybe<THeSetSubj>;
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDeliveryNavigation?: Maybe<THeSetDelMet>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acParity?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayMethodNavigation?: Maybe<THeSetPayMet>;
  acPriceRate?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverNavigation?: Maybe<THeSetSubj>;
  acStatus?: Maybe<Scalars['String']>;
  acStatusNavigation?: Maybe<TPaSetDocTypeStat>;
  acWarehouse?: Maybe<Scalars['String']>;
  acWayOfSale?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adDateValid?: Maybe<Scalars['DateTime']>;
  adDeliveryDate?: Maybe<Scalars['DateTime']>;
  adDeliveryDeadline?: Maybe<Scalars['DateTime']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anClerkNavigation?: Maybe<THeSetSubjContact>;
  anDaysForPayment: Scalars['Int'];
  anDaysForValid: Scalars['Int'];
  anDeliveryDays: Scalars['Int'];
  anDiscount: Scalars['Decimal'];
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anFieldNb?: Maybe<Scalars['Decimal']>;
  anFieldNc?: Maybe<Scalars['Decimal']>;
  anFieldNd?: Maybe<Scalars['Decimal']>;
  anFieldNe?: Maybe<Scalars['Decimal']>;
  anFieldNf?: Maybe<Scalars['Decimal']>;
  anFieldNg?: Maybe<Scalars['Decimal']>;
  anFieldNh?: Maybe<Scalars['Decimal']>;
  anFieldNi?: Maybe<Scalars['Decimal']>;
  anFieldNj?: Maybe<Scalars['Decimal']>;
  anForPay: Scalars['Decimal'];
  anNoteClerk?: Maybe<Scalars['Int']>;
  anNoteClerkNavigation?: Maybe<THeSetSubjContact>;
  anRoundItem: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  anVat: Scalars['Decimal'];
  tHeOrderItem?: Maybe<Array<Maybe<THeOrderItem>>>;
  warehouse?: Maybe<THeSetSubj>;
};


export type THeOrderTHeOrderItemArgs = {
  order?: InputMaybe<Array<THeOrderItemSortInput>>;
};

export type THeOrderFilterInput = {
  acConsignee?: InputMaybe<StringOperationFilterInput>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acContactPrsn?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn3?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDeliveryNavigation?: InputMaybe<THeSetDelMetFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acParity?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetFilterInput>;
  acPriceRate?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acStatusNavigation?: InputMaybe<TPaSetDocTypeStatFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateValid?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDeliveryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDeliveryDeadline?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anDaysForPayment?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDaysForValid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDeliveryDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anNoteClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNoteClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anRoundItem?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeOrderFilterInput>>;
  or?: InputMaybe<Array<THeOrderFilterInput>>;
  tHeOrderItem?: InputMaybe<ListFilterInputTypeOfTHeOrderItemFilterInput>;
};

export type THeOrderItem = {
  acCostDrv?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeOrder>;
  acLnkKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acOrigin?: Maybe<Scalars['String']>;
  acPriority?: Maybe<Scalars['String']>;
  acUM2?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUmconverted?: Maybe<Scalars['String']>;
  acVatcode?: Maybe<Scalars['String']>;
  adDeliveryDate?: Maybe<Scalars['DateTime']>;
  adDeliveryDeadline?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDimVolume: Scalars['Float'];
  anDimWeight: Scalars['Float'];
  anDimWeightBrutto: Scalars['Float'];
  anExcise: Scalars['Float'];
  anExciseInc?: Maybe<Scalars['Float']>;
  anExciseIncP?: Maybe<Scalars['Float']>;
  anExciseNotInc?: Maybe<Scalars['Float']>;
  anExciseNotIncP?: Maybe<Scalars['Float']>;
  anExciseP: Scalars['Float'];
  anLastprice?: Maybe<Scalars['Float']>;
  anLnkNo: Scalars['Int'];
  anNo: Scalars['Int'];
  anPackQty: Scalars['Decimal'];
  anPrice: Scalars['Float'];
  anPriceCurrency?: Maybe<Scalars['Decimal']>;
  anPvdiscount?: Maybe<Scalars['Decimal']>;
  anPvexcise?: Maybe<Scalars['Decimal']>;
  anPvforPay?: Maybe<Scalars['Decimal']>;
  anPvocdiscount?: Maybe<Scalars['Decimal']>;
  anPvocexcise?: Maybe<Scalars['Decimal']>;
  anPvocforPay?: Maybe<Scalars['Decimal']>;
  anPvocvalue?: Maybe<Scalars['Decimal']>;
  anPvocvat?: Maybe<Scalars['Decimal']>;
  anPvocvatbase?: Maybe<Scalars['Decimal']>;
  anPvvalue?: Maybe<Scalars['Decimal']>;
  anPvvat?: Maybe<Scalars['Decimal']>;
  anPvvatbase?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anQtyConverted?: Maybe<Scalars['Decimal']>;
  anQtyDispDoc: Scalars['Decimal'];
  anRebate: Scalars['Float'];
  anRebate1: Scalars['Float'];
  anRebate2: Scalars['Float'];
  anRebate3: Scalars['Float'];
  anReserved: Scalars['Decimal'];
  anRetailPrice: Scalars['Decimal'];
  anRtprice?: Maybe<Scalars['Decimal']>;
  anSalePrice: Scalars['Decimal'];
  anUmdecPlaces?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anVariant: Scalars['Byte'];
  anVat: Scalars['Float'];
  tHeLinkMoveItemOrderItem?: Maybe<Array<Maybe<THeLinkMoveItemOrderItem>>>;
};

export type THeOrderItemFilterInput = {
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeOrderFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acOrigin?: InputMaybe<StringOperationFilterInput>;
  acPriority?: InputMaybe<StringOperationFilterInput>;
  acUM2?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUmconverted?: InputMaybe<StringOperationFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  adDeliveryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDeliveryDeadline?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDimVolume?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDimWeight?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDimWeightBrutto?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExcise?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExciseInc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseIncP?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseNotInc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseNotIncP?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anExciseP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anLastprice?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPackQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPriceCurrency?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvdiscount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvexcise?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvforPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocdiscount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocexcise?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocforPay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocvalue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocvat?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvocvatbase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvvalue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvvat?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPvvatbase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQtyConverted?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQtyDispDoc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate1?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate2?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRebate3?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anReserved?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRetailPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUmdecPlaces?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVariant?: InputMaybe<ComparableByteOperationFilterInput>;
  anVat?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeOrderItemFilterInput>>;
  or?: InputMaybe<Array<THeOrderItemFilterInput>>;
  tHeLinkMoveItemOrderItem?: InputMaybe<ListFilterInputTypeOfTHeLinkMoveItemOrderItemFilterInput>;
};

export type THeOrderItemSortInput = {
  acCostDrv?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THeOrderSortInput>;
  acLnkKey?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acOrigin?: InputMaybe<SortEnumType>;
  acPriority?: InputMaybe<SortEnumType>;
  acUM2?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUmconverted?: InputMaybe<SortEnumType>;
  acVatcode?: InputMaybe<SortEnumType>;
  adDeliveryDate?: InputMaybe<SortEnumType>;
  adDeliveryDeadline?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDimVolume?: InputMaybe<SortEnumType>;
  anDimWeight?: InputMaybe<SortEnumType>;
  anDimWeightBrutto?: InputMaybe<SortEnumType>;
  anExcise?: InputMaybe<SortEnumType>;
  anExciseInc?: InputMaybe<SortEnumType>;
  anExciseIncP?: InputMaybe<SortEnumType>;
  anExciseNotInc?: InputMaybe<SortEnumType>;
  anExciseNotIncP?: InputMaybe<SortEnumType>;
  anExciseP?: InputMaybe<SortEnumType>;
  anLastprice?: InputMaybe<SortEnumType>;
  anLnkNo?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anPackQty?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anPriceCurrency?: InputMaybe<SortEnumType>;
  anPvdiscount?: InputMaybe<SortEnumType>;
  anPvexcise?: InputMaybe<SortEnumType>;
  anPvforPay?: InputMaybe<SortEnumType>;
  anPvocdiscount?: InputMaybe<SortEnumType>;
  anPvocexcise?: InputMaybe<SortEnumType>;
  anPvocforPay?: InputMaybe<SortEnumType>;
  anPvocvalue?: InputMaybe<SortEnumType>;
  anPvocvat?: InputMaybe<SortEnumType>;
  anPvocvatbase?: InputMaybe<SortEnumType>;
  anPvvalue?: InputMaybe<SortEnumType>;
  anPvvat?: InputMaybe<SortEnumType>;
  anPvvatbase?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anQtyConverted?: InputMaybe<SortEnumType>;
  anQtyDispDoc?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRebate1?: InputMaybe<SortEnumType>;
  anRebate2?: InputMaybe<SortEnumType>;
  anRebate3?: InputMaybe<SortEnumType>;
  anReserved?: InputMaybe<SortEnumType>;
  anRetailPrice?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anSalePrice?: InputMaybe<SortEnumType>;
  anUmdecPlaces?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVariant?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type THeOrderPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeOrderPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeOrderPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeOrder>;
};

/** A connection to a list of items. */
export type THeOrderPagedParametrizedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeOrderPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type THeOrderPagedParametrizedDtoConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeOrderPagedParametrizedDtoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeOrderPagedParametrizedDtoEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeOrder>;
};

export type THeOrderPagedParametrizedDtoInput = {
  acConsignee?: InputMaybe<Scalars['String']>;
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acReceiver?: InputMaybe<Scalars['String']>;
  acStatus?: InputMaybe<Scalars['String']>;
  acStatusIn?: InputMaybe<Array<Scalars['String']>>;
  acStatusNotIn?: InputMaybe<Array<Scalars['String']>>;
  anClerk?: InputMaybe<Scalars['Int']>;
  filterOrdersByThisAcWarehouse?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  scannedModifierChar?: InputMaybe<Scalars['String']>;
  showAnClerkAndAnNoteClerkIsOROperation?: InputMaybe<Scalars['Boolean']>;
  showOnlyDocumentsWhereAnClerkIs?: InputMaybe<Scalars['Int']>;
  showOnlyDocumentsWhereAnNoteClerkIs?: InputMaybe<Scalars['Int']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeOrderPagedSortField>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
  useDeliveryDeadline?: InputMaybe<Scalars['Boolean']>;
};

/** An edge in a connection. */
export type THeOrderPagedParametrizedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeOrder>;
};

export enum THeOrderPagedSortField {
  AcConsignee = 'AC_CONSIGNEE',
  AcContactPrsn = 'AC_CONTACT_PRSN',
  AcContactPrsn3 = 'AC_CONTACT_PRSN3',
  AcDelivery = 'AC_DELIVERY',
  AcDept = 'AC_DEPT',
  AcDoc1 = 'AC_DOC1',
  AcDoc2 = 'AC_DOC2',
  AcDocType = 'AC_DOC_TYPE',
  AcKey = 'AC_KEY',
  AcNote = 'AC_NOTE',
  AcStatus = 'AC_STATUS',
  AdDate = 'AD_DATE',
  AdDateDoc1 = 'AD_DATE_DOC1',
  AdDateDoc2 = 'AD_DATE_DOC2',
  AdDateValid = 'AD_DATE_VALID',
  AdDeliveryDeadline = 'AD_DELIVERY_DEADLINE',
  AnClerk = 'AN_CLERK',
  AnDeliveryDays = 'AN_DELIVERY_DAYS'
}

export type THeOrderSortInput = {
  acConsignee?: InputMaybe<SortEnumType>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjSortInput>;
  acContactPrsn?: InputMaybe<SortEnumType>;
  acContactPrsn3?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acDelivery?: InputMaybe<SortEnumType>;
  acDeliveryNavigation?: InputMaybe<THeSetDelMetSortInput>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDoc1?: InputMaybe<SortEnumType>;
  acDoc2?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSf?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFieldSj?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acParity?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetSortInput>;
  acPriceRate?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverNavigation?: InputMaybe<THeSetSubjSortInput>;
  acStatus?: InputMaybe<SortEnumType>;
  acStatusNavigation?: InputMaybe<TPaSetDocTypeStatSortInput>;
  acWarehouse?: InputMaybe<SortEnumType>;
  acWayOfSale?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateDoc1?: InputMaybe<SortEnumType>;
  adDateDoc2?: InputMaybe<SortEnumType>;
  adDateValid?: InputMaybe<SortEnumType>;
  adDeliveryDate?: InputMaybe<SortEnumType>;
  adDeliveryDeadline?: InputMaybe<SortEnumType>;
  adFieldDa?: InputMaybe<SortEnumType>;
  adFieldDb?: InputMaybe<SortEnumType>;
  adFieldDc?: InputMaybe<SortEnumType>;
  adFieldDd?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anDaysForPayment?: InputMaybe<SortEnumType>;
  anDaysForValid?: InputMaybe<SortEnumType>;
  anDeliveryDays?: InputMaybe<SortEnumType>;
  anDiscount?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anForPay?: InputMaybe<SortEnumType>;
  anNoteClerk?: InputMaybe<SortEnumType>;
  anNoteClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anRoundItem?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
};

export type THeSetCustTariff = {
  acAcctEdchaInvoInCr?: Maybe<Scalars['String']>;
  acAcctEdchaInvoOutCr?: Maybe<Scalars['String']>;
  acAffilDept?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acDisabled?: Maybe<Scalars['String']>;
  acEeequipment?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPreloman?: Maybe<Scalars['String']>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acSetOfTaxNavigation?: Maybe<THeSetDuty>;
  acSuperiorCustTariff?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anExcisePercent: Scalars['Decimal'];
  anExciseValue: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anRate: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetCustTariffSaleExes?: Maybe<Array<Maybe<THeSetCustTariffSaleEx>>>;
  tHeSetItems?: Maybe<Array<Maybe<THeSetItem>>>;
};


export type THeSetCustTariffTHeSetCustTariffSaleExesArgs = {
  order?: InputMaybe<Array<THeSetCustTariffSaleExSortInput>>;
  where?: InputMaybe<THeSetCustTariffSaleExFilterInput>;
};

export type THeSetCustTariffFilterInput = {
  acAcctEdchaInvoInCr?: InputMaybe<StringOperationFilterInput>;
  acAcctEdchaInvoOutCr?: InputMaybe<StringOperationFilterInput>;
  acAffilDept?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acDisabled?: InputMaybe<StringOperationFilterInput>;
  acEeequipment?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPreloman?: InputMaybe<StringOperationFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutyFilterInput>;
  acSuperiorCustTariff?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anExcisePercent?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anExciseValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetCustTariffFilterInput>>;
  or?: InputMaybe<Array<THeSetCustTariffFilterInput>>;
  tHeSetCustTariffSaleExes?: InputMaybe<ListFilterInputTypeOfTHeSetCustTariffSaleExFilterInput>;
  tHeSetItems?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
};

export type THeSetCustTariffSaleEx = {
  acAcctEdchaInvoInCr?: Maybe<Scalars['String']>;
  acAcctEdchaInvoOutCr?: Maybe<Scalars['String']>;
  acBaseType?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acCustTariffNavigation?: Maybe<THeSetCustTariff>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  adDate: Scalars['DateTime'];
  adDateTo?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anExcisePercent: Scalars['Decimal'];
  anExciseValue: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anRate?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeSetCustTariffSaleExFilterInput = {
  acAcctEdchaInvoInCr?: InputMaybe<StringOperationFilterInput>;
  acAcctEdchaInvoOutCr?: InputMaybe<StringOperationFilterInput>;
  acBaseType?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acCustTariffNavigation?: InputMaybe<THeSetCustTariffFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adDateTo?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anExcisePercent?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anExciseValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetCustTariffSaleExFilterInput>>;
  or?: InputMaybe<Array<THeSetCustTariffSaleExFilterInput>>;
};

export type THeSetCustTariffSaleExSortInput = {
  acAcctEdchaInvoInCr?: InputMaybe<SortEnumType>;
  acAcctEdchaInvoOutCr?: InputMaybe<SortEnumType>;
  acBaseType?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acCustTariffNavigation?: InputMaybe<THeSetCustTariffSortInput>;
  acSetOfTax?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateTo?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anExcisePercent?: InputMaybe<SortEnumType>;
  anExciseValue?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anRate?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetCustTariffSortInput = {
  acAcctEdchaInvoInCr?: InputMaybe<SortEnumType>;
  acAcctEdchaInvoOutCr?: InputMaybe<SortEnumType>;
  acAffilDept?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acDescr?: InputMaybe<SortEnumType>;
  acDisabled?: InputMaybe<SortEnumType>;
  acEeequipment?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPreloman?: InputMaybe<SortEnumType>;
  acSetOfTax?: InputMaybe<SortEnumType>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutySortInput>;
  acSuperiorCustTariff?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anExcisePercent?: InputMaybe<SortEnumType>;
  anExciseValue?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anRate?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetDelMet = {
  acActive?: Maybe<Scalars['String']>;
  acAtactive?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acTransport?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeMove?: Maybe<Array<Maybe<THeMove>>>;
  tHeOrder?: Maybe<Array<Maybe<THeOrder>>>;
};

export type THeSetDelMetFilterInput = {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAtactive?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acTransport?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetDelMetFilterInput>>;
  or?: InputMaybe<Array<THeSetDelMetFilterInput>>;
  tHeMove?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeOrder?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
};

export type THeSetDelMetSortInput = {
  acActive?: InputMaybe<SortEnumType>;
  acAtactive?: InputMaybe<SortEnumType>;
  acDelivery?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acTransport?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetDocText = {
  acActive?: Maybe<Scalars['String']>;
  acDesc?: Maybe<Scalars['String']>;
  acEdocument?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acStatement?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetTaxes?: Maybe<Array<Maybe<THeSetTax>>>;
};

export type THeSetDocTextFilterInput = {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acDesc?: InputMaybe<StringOperationFilterInput>;
  acEdocument?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acStatement?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetDocTextFilterInput>>;
  or?: InputMaybe<Array<THeSetDocTextFilterInput>>;
  tHeSetTaxes?: InputMaybe<ListFilterInputTypeOfTHeSetTaxFilterInput>;
};

export type THeSetDocTextSortInput = {
  acActive?: InputMaybe<SortEnumType>;
  acDesc?: InputMaybe<SortEnumType>;
  acEdocument?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acStatement?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetDuty = {
  acDutyType?: Maybe<Scalars['String']>;
  acHrdeposit?: Maybe<Scalars['String']>;
  acHrspendTax?: Maybe<Scalars['String']>;
  acHrsubType?: Maybe<Scalars['String']>;
  acInCalcRvc?: Maybe<Scalars['String']>;
  acIncBase?: Maybe<Scalars['String']>;
  acIncStockValue?: Maybe<Scalars['String']>;
  acIncSuppForPay?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acSetOfTax?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeMoveItemExciseOuts?: Maybe<Array<Maybe<THeMoveItemExciseOut>>>;
  tHeSetCustTariffs?: Maybe<Array<Maybe<THeSetCustTariff>>>;
  tHeSetItemExcise?: Maybe<Array<Maybe<THeSetItemExcise>>>;
};

export type THeSetDutyFilterInput = {
  acDutyType?: InputMaybe<StringOperationFilterInput>;
  acHrdeposit?: InputMaybe<StringOperationFilterInput>;
  acHrspendTax?: InputMaybe<StringOperationFilterInput>;
  acHrsubType?: InputMaybe<StringOperationFilterInput>;
  acInCalcRvc?: InputMaybe<StringOperationFilterInput>;
  acIncBase?: InputMaybe<StringOperationFilterInput>;
  acIncStockValue?: InputMaybe<StringOperationFilterInput>;
  acIncSuppForPay?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetDutyFilterInput>>;
  or?: InputMaybe<Array<THeSetDutyFilterInput>>;
  tHeMoveItemExciseOuts?: InputMaybe<ListFilterInputTypeOfTHeMoveItemExciseOutFilterInput>;
  tHeSetCustTariffs?: InputMaybe<ListFilterInputTypeOfTHeSetCustTariffFilterInput>;
  tHeSetItemExcise?: InputMaybe<ListFilterInputTypeOfTHeSetItemExciseFilterInput>;
};

export type THeSetDutySortInput = {
  acDutyType?: InputMaybe<SortEnumType>;
  acHrdeposit?: InputMaybe<SortEnumType>;
  acHrspendTax?: InputMaybe<SortEnumType>;
  acHrsubType?: InputMaybe<SortEnumType>;
  acInCalcRvc?: InputMaybe<SortEnumType>;
  acIncBase?: InputMaybe<SortEnumType>;
  acIncStockValue?: InputMaybe<SortEnumType>;
  acIncSuppForPay?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acSetOfTax?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetItem = {
  abIcon?: Maybe<Array<Scalars['Byte']>>;
  acAcct?: Maybe<Scalars['String']>;
  acAcctBuyVasale?: Maybe<Scalars['String']>;
  acAcctIncome?: Maybe<Scalars['String']>;
  acAcctNotTaxDeduct?: Maybe<Scalars['String']>;
  acActive?: Maybe<Scalars['String']>;
  acBackPacking?: Maybe<Scalars['String']>;
  acBst?: Maybe<Scalars['String']>;
  acBullId?: Maybe<Scalars['String']>;
  acClassProdByAct?: Maybe<Scalars['String']>;
  acClassif?: Maybe<Scalars['String']>;
  acClassif2?: Maybe<Scalars['String']>;
  acClassifNavigation?: Maybe<THeSetItemCateg>;
  acCode?: Maybe<Scalars['String']>;
  acColumn?: Maybe<Scalars['String']>;
  acColumnNavigation?: Maybe<THeSetItemSnt>;
  acCostDrv?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acCustTariffNavigation?: Maybe<THeSetCustTariff>;
  acDateDue?: Maybe<Scalars['String']>;
  acDeclarForOrigin?: Maybe<Scalars['String']>;
  acDeclarForOriginType?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acDocTypeIssue?: Maybe<Scalars['String']>;
  acDocTypeOrdSupp?: Maybe<Scalars['String']>;
  acDocTypeProd?: Maybe<Scalars['String']>;
  acDroe?: Maybe<Scalars['String']>;
  acDroesubject?: Maybe<Scalars['String']>;
  acEnableChgPrSt?: Maybe<Scalars['String']>;
  acEnvrmntCost?: Maybe<Scalars['String']>;
  acEvidence?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acFieldsA?: Maybe<Scalars['String']>;
  acFormula?: Maybe<Scalars['String']>;
  acFormulaRt?: Maybe<Scalars['String']>;
  acHttppath?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acInFlowOutFlow?: Maybe<Scalars['String']>;
  acIsReturnPack?: Maybe<Scalars['String']>;
  acMakeCalc?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acOrderTransInMf?: Maybe<Scalars['String']>;
  acOrigin?: Maybe<Scalars['String']>;
  acPackSlopak?: Maybe<Scalars['String']>;
  acPackSlopaktype?: Maybe<Scalars['String']>;
  acPackagingType?: Maybe<Scalars['String']>;
  acPacking?: Maybe<Scalars['String']>;
  acPicture?: Maybe<Array<Scalars['Byte']>>;
  acPosprinterId?: Maybe<Scalars['String']>;
  acPrstPrice?: Maybe<Scalars['String']>;
  acPrstUmtime?: Maybe<Scalars['String']>;
  acPurchCurr?: Maybe<Scalars['String']>;
  acQtyInCode?: Maybe<Scalars['String']>;
  acQtyNotToKol?: Maybe<Scalars['String']>;
  acReportDeclar?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSerialnoDueType?: Maybe<Scalars['String']>;
  acSetOfItem?: Maybe<Scalars['String']>;
  acSetOfItemNavigation?: Maybe<THeSetItemType>;
  acShowAtena?: Maybe<Scalars['String']>;
  acStandardize?: Maybe<Scalars['String']>;
  acSupplier?: Maybe<Scalars['String']>;
  acTechProcedure?: Maybe<Scalars['String']>;
  acTransferredWs?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUm2?: Maybe<Scalars['String']>;
  acUm2Navigation?: Maybe<THeSetUm>;
  acUm3?: Maybe<Scalars['String']>;
  acUmNavigation?: Maybe<THeSetUm>;
  acUmdim1?: Maybe<Scalars['String']>;
  acUmdim2?: Maybe<Scalars['String']>;
  acUmmarkLabel?: Maybe<Scalars['String']>;
  acUmseries?: Maybe<Scalars['String']>;
  acUsedTyre?: Maybe<Scalars['String']>;
  acVatCodeNavigation?: Maybe<THeSetTax>;
  acVatcode?: Maybe<Scalars['String']>;
  acVatcodeLow?: Maybe<Scalars['String']>;
  acVatcodeReceive?: Maybe<Scalars['String']>;
  acVehiclePart?: Maybe<Scalars['String']>;
  acWastePack?: Maybe<Scalars['String']>;
  acWeighableItem?: Maybe<Scalars['String']>;
  acWstEeequip?: Maybe<Scalars['String']>;
  adDiscountBegin?: Maybe<Scalars['DateTime']>;
  adDiscountEnd?: Maybe<Scalars['DateTime']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adPrStCheckTime?: Maybe<Scalars['DateTime']>;
  adPrStInsertTime?: Maybe<Scalars['DateTime']>;
  adPrStUpdateTime?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anAllowedInvShort: Scalars['Decimal'];
  anAllowedWastage?: Maybe<Scalars['Decimal']>;
  anBeatShare: Scalars['Float'];
  anBuyPrice: Scalars['Float'];
  anBuyRebate2?: Maybe<Scalars['Float']>;
  anBuyRebate3?: Maybe<Scalars['Float']>;
  anColorCode?: Maybe<Scalars['Int']>;
  anDeliveryDeadline: Scalars['Int'];
  anDimDepth: Scalars['Decimal'];
  anDimHeight: Scalars['Decimal'];
  anDimWeight: Scalars['Decimal'];
  anDimWeightBrutto: Scalars['Decimal'];
  anDimWidth: Scalars['Decimal'];
  anDirectCost: Scalars['Float'];
  anDiscount: Scalars['Decimal'];
  anDiscountPrice: Scalars['Decimal'];
  anDiscountPriceRt: Scalars['Decimal'];
  anDuty: Scalars['Float'];
  anExcise: Scalars['Float'];
  anExciseP: Scalars['Float'];
  anFieldNa: Scalars['Decimal'];
  anFieldNb: Scalars['Decimal'];
  anFieldNc: Scalars['Decimal'];
  anFieldNd: Scalars['Decimal'];
  anFieldNe: Scalars['Decimal'];
  anFieldNf: Scalars['Decimal'];
  anFieldNg: Scalars['Decimal'];
  anFieldNh: Scalars['Decimal'];
  anFieldNi: Scalars['Decimal'];
  anFieldNj: Scalars['Decimal'];
  anFixPriceDiff: Scalars['Float'];
  anIncTax: Scalars['Float'];
  anMaxRebate: Scalars['Decimal'];
  anMaxStock: Scalars['Decimal'];
  anMinMargin: Scalars['Decimal'];
  anMinStock: Scalars['Decimal'];
  anMonthDue?: Maybe<Scalars['Int']>;
  anOptStock: Scalars['Decimal'];
  anOrderMinQty: Scalars['Decimal'];
  anOrderOptQty: Scalars['Decimal'];
  anPackWasteWeight?: Maybe<Scalars['Decimal']>;
  anPackWeight?: Maybe<Scalars['Decimal']>;
  anPlucode?: Maybe<Scalars['Int']>;
  anPlucode2?: Maybe<Scalars['Long']>;
  anPosQtyStep?: Maybe<Scalars['Decimal']>;
  anPosqty: Scalars['Decimal'];
  anPrStCheckUserId?: Maybe<Scalars['Int']>;
  anPrStDailyQty: Scalars['Decimal'];
  anPrStInsertUserId?: Maybe<Scalars['Int']>;
  anPrStOptimalQty: Scalars['Decimal'];
  anPrStPrice: Scalars['Float'];
  anPrStPriceP: Scalars['Float'];
  anPrStUpdateUserId?: Maybe<Scalars['Int']>;
  anPrStVariantValid: Scalars['Byte'];
  anPrice: Scalars['Float'];
  anPriceSupp: Scalars['Float'];
  anProdPrice?: Maybe<Scalars['Float']>;
  anPrstTime?: Maybe<Scalars['Float']>;
  anPurExciseA: Scalars['Float'];
  anPurExciseE: Scalars['Float'];
  anPurExciseT: Scalars['Float'];
  anQid: Scalars['Int'];
  anQtyInCodeDecPlace: Scalars['Int'];
  anQtyMarkLabel?: Maybe<Scalars['Decimal']>;
  anQtySeries: Scalars['Decimal'];
  anRebate: Scalars['Float'];
  anRtPrice: Scalars['Float'];
  anRtprice: Scalars['Float'];
  anRtpriceP: Scalars['Float'];
  anSalePrice: Scalars['Decimal'];
  anSaleRebate2?: Maybe<Scalars['Float']>;
  anSaleRebate3?: Maybe<Scalars['Float']>;
  anSubClassif: Scalars['Float'];
  anTransport: Scalars['Float'];
  anUmtoDeclarReport: Scalars['Decimal'];
  anUmtoUm2: Scalars['Decimal'];
  anUmtoUm3: Scalars['Decimal'];
  anUnionDeadline: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anVat: Scalars['Decimal'];
  anVatreceive: Scalars['Decimal'];
  anWarrenty: Scalars['Int'];
  anWasteQty: Scalars['Decimal'];
  anWsprice: Scalars['Float'];
  anWsprice2: Scalars['Float'];
  anWsprice2P: Scalars['Float'];
  anWspriceP: Scalars['Float'];
  pHE_SearchContrctPrice?: Maybe<PHe_SearchContrctPriceDto>;
  tHeMoveItem?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeMoveItemSerialNo?: Maybe<Array<Maybe<THeMoveItemSerialNo>>>;
  tHeOrderItem?: Maybe<Array<Maybe<THeOrderItem>>>;
  tHeSetItemExcises?: Maybe<Array<Maybe<THeSetItemExcise>>>;
  tHeSetItemExtItemSubj?: Maybe<Array<Maybe<THeSetItemExtItemSubj>>>;
  tHeSetItemPriceForWrh?: Maybe<Array<Maybe<THeSetItemPriceForWrh>>>;
  tHeSetSubjPriceItem?: Maybe<Array<Maybe<THeSetSubjPriceItem>>>;
  tHeStock?: Maybe<Array<Maybe<THeStock>>>;
  tHeStockSerialNos?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  tHfWoexAcIdentNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexAcLnkPrStIdentParentNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexAcScrapIdentNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexItemAcIdentNavigations?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexItemAcScrapIdentNavigations?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexItemSerialNos?: Maybe<Array<Maybe<THfWoexItemSerialNo>>>;
};


export type THeSetItemAcClassifNavigationArgs = {
  where?: InputMaybe<THeSetItemCategFilterInput>;
};


export type THeSetItemPHe_SearchContrctPriceArgs = {
  classif2: Scalars['Boolean'];
  date: Scalars['DateTime'];
  priceList?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};


export type THeSetItemTHeMoveItemArgs = {
  order?: InputMaybe<Array<THeMoveItemSortInput>>;
  where?: InputMaybe<THeMoveItemFilterInput>;
};


export type THeSetItemTHeOrderItemArgs = {
  order?: InputMaybe<Array<THeOrderItemSortInput>>;
  where?: InputMaybe<THeOrderItemFilterInput>;
};


export type THeSetItemTHeSetItemExtItemSubjArgs = {
  where?: InputMaybe<THeSetItemExtItemSubjFilterInput>;
};


export type THeSetItemTHeSetItemPriceForWrhArgs = {
  where?: InputMaybe<THeSetItemPriceForWrhFilterInput>;
};


export type THeSetItemTHeSetSubjPriceItemArgs = {
  order?: InputMaybe<Array<THeSetSubjPriceItemSortInput>>;
  where?: InputMaybe<THeSetSubjPriceItemFilterInput>;
};


export type THeSetItemTHeStockArgs = {
  where?: InputMaybe<THeStockFilterInput>;
};


export type THeSetItemTHeStockSerialNosArgs = {
  where?: InputMaybe<THeStockSerialNoFilterInput>;
};

export type THeSetItemCateg = {
  abIcon?: Maybe<Array<Scalars['Byte']>>;
  acAcct?: Maybe<Scalars['String']>;
  acAcctIncome?: Maybe<Scalars['String']>;
  acActive?: Maybe<Scalars['String']>;
  acAtdescPos?: Maybe<Scalars['String']>;
  acAtorder?: Maybe<Scalars['String']>;
  acClassFillMethod?: Maybe<Scalars['String']>;
  acClassif?: Maybe<Scalars['String']>;
  acColumn?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acDroe?: Maybe<Scalars['String']>;
  acDroesubject?: Maybe<Scalars['String']>;
  acEnvrmntCost?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acFormula?: Maybe<Scalars['String']>;
  acMakeCalc?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPackSlopak?: Maybe<Scalars['String']>;
  acPackSlopaktype?: Maybe<Scalars['String']>;
  acPacking?: Maybe<Scalars['String']>;
  acPicture?: Maybe<Array<Scalars['Byte']>>;
  acPosprinterId?: Maybe<Scalars['String']>;
  acPrStC1?: Maybe<Scalars['String']>;
  acPrStC2?: Maybe<Scalars['String']>;
  acPrStC3?: Maybe<Scalars['String']>;
  acPrStC4?: Maybe<Scalars['String']>;
  acPrStC8?: Maybe<Scalars['String']>;
  acPrStMatQtyFormula?: Maybe<Scalars['String']>;
  acPrStMatScrapIdent?: Maybe<Scalars['String']>;
  acPrStMatUm?: Maybe<Scalars['String']>;
  acPrStOprDelayType?: Maybe<Scalars['String']>;
  acPrStOprEtadditive?: Maybe<Scalars['String']>;
  acPrStOprIncomeGrp?: Maybe<Scalars['String']>;
  acPrStOprOperationType?: Maybe<Scalars['String']>;
  acPrStOprQtyFormula?: Maybe<Scalars['String']>;
  acPrStOprResursId?: Maybe<Scalars['String']>;
  acPrStOprRuleId?: Maybe<Scalars['String']>;
  acPrStOprUm?: Maybe<Scalars['String']>;
  acPrStOprUm3?: Maybe<Scalars['String']>;
  acPrStOprUmtime?: Maybe<Scalars['String']>;
  acPriceCalcMethod?: Maybe<Scalars['String']>;
  acPurchCurr?: Maybe<Scalars['String']>;
  acQtyNotToKol?: Maybe<Scalars['String']>;
  acRbuyRebate2?: Maybe<Scalars['String']>;
  acRbuyRebate3?: Maybe<Scalars['String']>;
  acRduty?: Maybe<Scalars['String']>;
  acRnepstr?: Maybe<Scalars['String']>;
  acRprStPrice?: Maybe<Scalars['String']>;
  acRprStPriceP?: Maybe<Scalars['String']>;
  acRrebate?: Maybe<Scalars['String']>;
  acRrtprice?: Maybe<Scalars['String']>;
  acRrtpriceP?: Maybe<Scalars['String']>;
  acRsaleRebate2?: Maybe<Scalars['String']>;
  acRsaleRebate3?: Maybe<Scalars['String']>;
  acRtransport?: Maybe<Scalars['String']>;
  acRvrdavek?: Maybe<Scalars['String']>;
  acRwsprice?: Maybe<Scalars['String']>;
  acRwsprice2?: Maybe<Scalars['String']>;
  acRwsprice2P?: Maybe<Scalars['String']>;
  acRwspriceP?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSetOfItem?: Maybe<Scalars['String']>;
  acShowAtena?: Maybe<Scalars['String']>;
  acShowAtenaDesc?: Maybe<Scalars['String']>;
  acSuprClassif?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUm2?: Maybe<Scalars['String']>;
  acUmdim1?: Maybe<Scalars['String']>;
  acUmdim2?: Maybe<Scalars['String']>;
  acUmmarkLabel?: Maybe<Scalars['String']>;
  acVatcode?: Maybe<Scalars['String']>;
  acVatcodeLow?: Maybe<Scalars['String']>;
  acWayBillDescr?: Maybe<Scalars['String']>;
  adDiscountBegin?: Maybe<Scalars['DateTime']>;
  adDiscountEnd?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anAllowedInvShort: Scalars['Decimal'];
  anBeatShare: Scalars['Float'];
  anBuyRebate2?: Maybe<Scalars['Decimal']>;
  anBuyRebate3?: Maybe<Scalars['Decimal']>;
  anColorCode?: Maybe<Scalars['Int']>;
  anDeliveryDeadline: Scalars['Int'];
  anDimDepth: Scalars['Decimal'];
  anDimHeight: Scalars['Decimal'];
  anDimWeight: Scalars['Decimal'];
  anDimWeightBrutto: Scalars['Decimal'];
  anDimWidth: Scalars['Decimal'];
  anDirectCost: Scalars['Decimal'];
  anDiscount: Scalars['Decimal'];
  anDuty: Scalars['Decimal'];
  anFieldNa: Scalars['Decimal'];
  anFieldNb: Scalars['Decimal'];
  anFieldNc: Scalars['Decimal'];
  anFieldNd: Scalars['Decimal'];
  anFieldNe: Scalars['Decimal'];
  anFieldNf: Scalars['Decimal'];
  anFieldNg: Scalars['Decimal'];
  anFieldNh: Scalars['Decimal'];
  anFieldNi: Scalars['Decimal'];
  anFieldNj: Scalars['Decimal'];
  anIncTax: Scalars['Decimal'];
  anMaxRebate: Scalars['Decimal'];
  anMaxRebatePos: Scalars['Decimal'];
  anMaxstock: Scalars['Decimal'];
  anMinMargin: Scalars['Decimal'];
  anMinMarginCateg: Scalars['Decimal'];
  anMinstock: Scalars['Decimal'];
  anOptStock: Scalars['Decimal'];
  anPosqty: Scalars['Decimal'];
  anPrStC5?: Maybe<Scalars['Float']>;
  anPrStC6?: Maybe<Scalars['Float']>;
  anPrStC7?: Maybe<Scalars['Float']>;
  anPrStMatBatch?: Maybe<Scalars['Float']>;
  anPrStMatQty1?: Maybe<Scalars['Float']>;
  anPrStMatQtyBase?: Maybe<Scalars['Int']>;
  anPrStMatScrapPrc?: Maybe<Scalars['Float']>;
  anPrStMatScrapQty?: Maybe<Scalars['Float']>;
  anPrStMatVariantSubLvl?: Maybe<Scalars['Byte']>;
  anPrStMatWastePrc?: Maybe<Scalars['Float']>;
  anPrStMatWasteQty?: Maybe<Scalars['Float']>;
  anPrStOprBatch?: Maybe<Scalars['Float']>;
  anPrStOprNoOfWrk?: Maybe<Scalars['Float']>;
  anPrStOprOptimalQty?: Maybe<Scalars['Float']>;
  anPrStOprQty1?: Maybe<Scalars['Float']>;
  anPrStOprQty2?: Maybe<Scalars['Float']>;
  anPrStOprQty3?: Maybe<Scalars['Float']>;
  anPrStOprQtyBase?: Maybe<Scalars['Int']>;
  anPrStOprQtyBase3?: Maybe<Scalars['Int']>;
  anPrStPrice: Scalars['Float'];
  anPrStPriceP: Scalars['Decimal'];
  anPurExciseA: Scalars['Float'];
  anPurExciseE: Scalars['Float'];
  anPurExciseT: Scalars['Float'];
  anQid: Scalars['Int'];
  anQtyMarkLabel?: Maybe<Scalars['Decimal']>;
  anRebate: Scalars['Decimal'];
  anRtprice: Scalars['Float'];
  anRtpriceP: Scalars['Decimal'];
  anSaleRebate2?: Maybe<Scalars['Decimal']>;
  anSaleRebate3?: Maybe<Scalars['Decimal']>;
  anSequence: Scalars['Int'];
  anTransport: Scalars['Decimal'];
  anUmtoUm2?: Maybe<Scalars['Float']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWarrenty: Scalars['Int'];
  anWsprice: Scalars['Float'];
  anWsprice2: Scalars['Float'];
  anWsprice2P: Scalars['Decimal'];
  anWspriceP: Scalars['Decimal'];
  tHeSetItemAcClassifNavigations?: Maybe<Array<Maybe<THeSetItem>>>;
  tHeSetSubjPriceCategs?: Maybe<Array<Maybe<THeSetSubjPriceCateg>>>;
};


export type THeSetItemCategTHeSetItemAcClassifNavigationsArgs = {
  where?: InputMaybe<THeSetItemFilterInput>;
};


export type THeSetItemCategTHeSetSubjPriceCategsArgs = {
  where?: InputMaybe<THeSetSubjPriceCategFilterInput>;
};

export type THeSetItemCategFilterInput = {
  abIcon?: InputMaybe<ListComparableByteOperationFilterInput>;
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acAcctIncome?: InputMaybe<StringOperationFilterInput>;
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAtdescPos?: InputMaybe<StringOperationFilterInput>;
  acAtorder?: InputMaybe<StringOperationFilterInput>;
  acClassFillMethod?: InputMaybe<StringOperationFilterInput>;
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acDroe?: InputMaybe<StringOperationFilterInput>;
  acDroesubject?: InputMaybe<StringOperationFilterInput>;
  acEnvrmntCost?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acFormula?: InputMaybe<StringOperationFilterInput>;
  acMakeCalc?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPackSlopak?: InputMaybe<StringOperationFilterInput>;
  acPackSlopaktype?: InputMaybe<StringOperationFilterInput>;
  acPacking?: InputMaybe<StringOperationFilterInput>;
  acPicture?: InputMaybe<ListComparableByteOperationFilterInput>;
  acPosprinterId?: InputMaybe<StringOperationFilterInput>;
  acPrStC1?: InputMaybe<StringOperationFilterInput>;
  acPrStC2?: InputMaybe<StringOperationFilterInput>;
  acPrStC3?: InputMaybe<StringOperationFilterInput>;
  acPrStC4?: InputMaybe<StringOperationFilterInput>;
  acPrStC8?: InputMaybe<StringOperationFilterInput>;
  acPrStMatQtyFormula?: InputMaybe<StringOperationFilterInput>;
  acPrStMatScrapIdent?: InputMaybe<StringOperationFilterInput>;
  acPrStMatUm?: InputMaybe<StringOperationFilterInput>;
  acPrStOprDelayType?: InputMaybe<StringOperationFilterInput>;
  acPrStOprEtadditive?: InputMaybe<StringOperationFilterInput>;
  acPrStOprIncomeGrp?: InputMaybe<StringOperationFilterInput>;
  acPrStOprOperationType?: InputMaybe<StringOperationFilterInput>;
  acPrStOprQtyFormula?: InputMaybe<StringOperationFilterInput>;
  acPrStOprResursId?: InputMaybe<StringOperationFilterInput>;
  acPrStOprRuleId?: InputMaybe<StringOperationFilterInput>;
  acPrStOprUm?: InputMaybe<StringOperationFilterInput>;
  acPrStOprUm3?: InputMaybe<StringOperationFilterInput>;
  acPrStOprUmtime?: InputMaybe<StringOperationFilterInput>;
  acPriceCalcMethod?: InputMaybe<StringOperationFilterInput>;
  acPurchCurr?: InputMaybe<StringOperationFilterInput>;
  acQtyNotToKol?: InputMaybe<StringOperationFilterInput>;
  acRbuyRebate2?: InputMaybe<StringOperationFilterInput>;
  acRbuyRebate3?: InputMaybe<StringOperationFilterInput>;
  acRduty?: InputMaybe<StringOperationFilterInput>;
  acRnepstr?: InputMaybe<StringOperationFilterInput>;
  acRprStPrice?: InputMaybe<StringOperationFilterInput>;
  acRprStPriceP?: InputMaybe<StringOperationFilterInput>;
  acRrebate?: InputMaybe<StringOperationFilterInput>;
  acRrtprice?: InputMaybe<StringOperationFilterInput>;
  acRrtpriceP?: InputMaybe<StringOperationFilterInput>;
  acRsaleRebate2?: InputMaybe<StringOperationFilterInput>;
  acRsaleRebate3?: InputMaybe<StringOperationFilterInput>;
  acRtransport?: InputMaybe<StringOperationFilterInput>;
  acRvrdavek?: InputMaybe<StringOperationFilterInput>;
  acRwsprice?: InputMaybe<StringOperationFilterInput>;
  acRwsprice2?: InputMaybe<StringOperationFilterInput>;
  acRwsprice2P?: InputMaybe<StringOperationFilterInput>;
  acRwspriceP?: InputMaybe<StringOperationFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acSetOfItem?: InputMaybe<StringOperationFilterInput>;
  acShowAtena?: InputMaybe<StringOperationFilterInput>;
  acShowAtenaDesc?: InputMaybe<StringOperationFilterInput>;
  acSuprClassif?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUm2?: InputMaybe<StringOperationFilterInput>;
  acUmdim1?: InputMaybe<StringOperationFilterInput>;
  acUmdim2?: InputMaybe<StringOperationFilterInput>;
  acUmmarkLabel?: InputMaybe<StringOperationFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  acVatcodeLow?: InputMaybe<StringOperationFilterInput>;
  acWayBillDescr?: InputMaybe<StringOperationFilterInput>;
  adDiscountBegin?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDiscountEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anAllowedInvShort?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anBeatShare?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anBuyRebate2?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anBuyRebate3?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anColorCode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDeliveryDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDimDepth?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimHeight?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWeight?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWeightBrutto?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWidth?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDirectCost?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDuty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anIncTax?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMaxRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMaxRebatePos?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMaxstock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinMargin?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinMarginCateg?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinstock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anOptStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPosqty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrStC5?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStC6?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStC7?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatBatch?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatQty1?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatQtyBase?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStMatScrapPrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatScrapQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatVariantSubLvl?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anPrStMatWastePrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStMatWasteQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprBatch?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprNoOfWrk?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprOptimalQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprQty1?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprQty2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprQty3?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrStOprQtyBase?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStOprQtyBase3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPrStPriceP?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPurExciseA?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPurExciseE?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPurExciseT?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQtyMarkLabel?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRtpriceP?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSaleRebate2?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anSaleRebate3?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anSequence?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTransport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUmtoUm2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWarrenty?: InputMaybe<ComparableInt32OperationFilterInput>;
  anWsprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWsprice2?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWsprice2P?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anWspriceP?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemCategFilterInput>>;
  or?: InputMaybe<Array<THeSetItemCategFilterInput>>;
  tHeSetItemAcClassifNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
  tHeSetSubjPriceCategs?: InputMaybe<ListFilterInputTypeOfTHeSetSubjPriceCategFilterInput>;
};

/** A connection to a list of items. */
export type THeSetItemCategPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemCategPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItemCateg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeSetItemCategPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItemCateg>;
};

/** A connection to a list of items. */
export type THeSetItemCategPagedParametrizedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemCategPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItemCateg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeSetItemCategPagedParametrizedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItemCateg>;
};

export type THeSetItemCategSortInput = {
  acAcct?: InputMaybe<SortEnumType>;
  acAcctIncome?: InputMaybe<SortEnumType>;
  acActive?: InputMaybe<SortEnumType>;
  acAtdescPos?: InputMaybe<SortEnumType>;
  acAtorder?: InputMaybe<SortEnumType>;
  acClassFillMethod?: InputMaybe<SortEnumType>;
  acClassif?: InputMaybe<SortEnumType>;
  acColumn?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acDescr?: InputMaybe<SortEnumType>;
  acDroe?: InputMaybe<SortEnumType>;
  acDroesubject?: InputMaybe<SortEnumType>;
  acEnvrmntCost?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSf?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFieldSj?: InputMaybe<SortEnumType>;
  acFormula?: InputMaybe<SortEnumType>;
  acMakeCalc?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPackSlopak?: InputMaybe<SortEnumType>;
  acPackSlopaktype?: InputMaybe<SortEnumType>;
  acPacking?: InputMaybe<SortEnumType>;
  acPosprinterId?: InputMaybe<SortEnumType>;
  acPrStC1?: InputMaybe<SortEnumType>;
  acPrStC2?: InputMaybe<SortEnumType>;
  acPrStC3?: InputMaybe<SortEnumType>;
  acPrStC4?: InputMaybe<SortEnumType>;
  acPrStC8?: InputMaybe<SortEnumType>;
  acPrStMatQtyFormula?: InputMaybe<SortEnumType>;
  acPrStMatScrapIdent?: InputMaybe<SortEnumType>;
  acPrStMatUm?: InputMaybe<SortEnumType>;
  acPrStOprDelayType?: InputMaybe<SortEnumType>;
  acPrStOprEtadditive?: InputMaybe<SortEnumType>;
  acPrStOprIncomeGrp?: InputMaybe<SortEnumType>;
  acPrStOprOperationType?: InputMaybe<SortEnumType>;
  acPrStOprQtyFormula?: InputMaybe<SortEnumType>;
  acPrStOprResursId?: InputMaybe<SortEnumType>;
  acPrStOprRuleId?: InputMaybe<SortEnumType>;
  acPrStOprUm?: InputMaybe<SortEnumType>;
  acPrStOprUm3?: InputMaybe<SortEnumType>;
  acPrStOprUmtime?: InputMaybe<SortEnumType>;
  acPriceCalcMethod?: InputMaybe<SortEnumType>;
  acPurchCurr?: InputMaybe<SortEnumType>;
  acQtyNotToKol?: InputMaybe<SortEnumType>;
  acRbuyRebate2?: InputMaybe<SortEnumType>;
  acRbuyRebate3?: InputMaybe<SortEnumType>;
  acRduty?: InputMaybe<SortEnumType>;
  acRnepstr?: InputMaybe<SortEnumType>;
  acRprStPrice?: InputMaybe<SortEnumType>;
  acRprStPriceP?: InputMaybe<SortEnumType>;
  acRrebate?: InputMaybe<SortEnumType>;
  acRrtprice?: InputMaybe<SortEnumType>;
  acRrtpriceP?: InputMaybe<SortEnumType>;
  acRsaleRebate2?: InputMaybe<SortEnumType>;
  acRsaleRebate3?: InputMaybe<SortEnumType>;
  acRtransport?: InputMaybe<SortEnumType>;
  acRvrdavek?: InputMaybe<SortEnumType>;
  acRwsprice?: InputMaybe<SortEnumType>;
  acRwsprice2?: InputMaybe<SortEnumType>;
  acRwsprice2P?: InputMaybe<SortEnumType>;
  acRwspriceP?: InputMaybe<SortEnumType>;
  acSerialNo?: InputMaybe<SortEnumType>;
  acSetOfItem?: InputMaybe<SortEnumType>;
  acShowAtena?: InputMaybe<SortEnumType>;
  acShowAtenaDesc?: InputMaybe<SortEnumType>;
  acSuprClassif?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUm2?: InputMaybe<SortEnumType>;
  acUmdim1?: InputMaybe<SortEnumType>;
  acUmdim2?: InputMaybe<SortEnumType>;
  acUmmarkLabel?: InputMaybe<SortEnumType>;
  acVatcode?: InputMaybe<SortEnumType>;
  acVatcodeLow?: InputMaybe<SortEnumType>;
  acWayBillDescr?: InputMaybe<SortEnumType>;
  adDiscountBegin?: InputMaybe<SortEnumType>;
  adDiscountEnd?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anAllowedInvShort?: InputMaybe<SortEnumType>;
  anBeatShare?: InputMaybe<SortEnumType>;
  anBuyRebate2?: InputMaybe<SortEnumType>;
  anBuyRebate3?: InputMaybe<SortEnumType>;
  anColorCode?: InputMaybe<SortEnumType>;
  anDeliveryDeadline?: InputMaybe<SortEnumType>;
  anDimDepth?: InputMaybe<SortEnumType>;
  anDimHeight?: InputMaybe<SortEnumType>;
  anDimWeight?: InputMaybe<SortEnumType>;
  anDimWeightBrutto?: InputMaybe<SortEnumType>;
  anDimWidth?: InputMaybe<SortEnumType>;
  anDirectCost?: InputMaybe<SortEnumType>;
  anDiscount?: InputMaybe<SortEnumType>;
  anDuty?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anIncTax?: InputMaybe<SortEnumType>;
  anMaxRebate?: InputMaybe<SortEnumType>;
  anMaxRebatePos?: InputMaybe<SortEnumType>;
  anMaxstock?: InputMaybe<SortEnumType>;
  anMinMargin?: InputMaybe<SortEnumType>;
  anMinMarginCateg?: InputMaybe<SortEnumType>;
  anMinstock?: InputMaybe<SortEnumType>;
  anOptStock?: InputMaybe<SortEnumType>;
  anPosqty?: InputMaybe<SortEnumType>;
  anPrStC5?: InputMaybe<SortEnumType>;
  anPrStC6?: InputMaybe<SortEnumType>;
  anPrStC7?: InputMaybe<SortEnumType>;
  anPrStMatBatch?: InputMaybe<SortEnumType>;
  anPrStMatQty1?: InputMaybe<SortEnumType>;
  anPrStMatQtyBase?: InputMaybe<SortEnumType>;
  anPrStMatScrapPrc?: InputMaybe<SortEnumType>;
  anPrStMatScrapQty?: InputMaybe<SortEnumType>;
  anPrStMatVariantSubLvl?: InputMaybe<SortEnumType>;
  anPrStMatWastePrc?: InputMaybe<SortEnumType>;
  anPrStMatWasteQty?: InputMaybe<SortEnumType>;
  anPrStOprBatch?: InputMaybe<SortEnumType>;
  anPrStOprNoOfWrk?: InputMaybe<SortEnumType>;
  anPrStOprOptimalQty?: InputMaybe<SortEnumType>;
  anPrStOprQty1?: InputMaybe<SortEnumType>;
  anPrStOprQty2?: InputMaybe<SortEnumType>;
  anPrStOprQty3?: InputMaybe<SortEnumType>;
  anPrStOprQtyBase?: InputMaybe<SortEnumType>;
  anPrStOprQtyBase3?: InputMaybe<SortEnumType>;
  anPrStPrice?: InputMaybe<SortEnumType>;
  anPrStPriceP?: InputMaybe<SortEnumType>;
  anPurExciseA?: InputMaybe<SortEnumType>;
  anPurExciseE?: InputMaybe<SortEnumType>;
  anPurExciseT?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQtyMarkLabel?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anRtpriceP?: InputMaybe<SortEnumType>;
  anSaleRebate2?: InputMaybe<SortEnumType>;
  anSaleRebate3?: InputMaybe<SortEnumType>;
  anSequence?: InputMaybe<SortEnumType>;
  anTransport?: InputMaybe<SortEnumType>;
  anUmtoUm2?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anWarrenty?: InputMaybe<SortEnumType>;
  anWsprice?: InputMaybe<SortEnumType>;
  anWsprice2?: InputMaybe<SortEnumType>;
  anWsprice2P?: InputMaybe<SortEnumType>;
  anWspriceP?: InputMaybe<SortEnumType>;
};

export type THeSetItemExcise = {
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acSetOfTax?: Maybe<Scalars['String']>;
  acSetOfTaxNavigation?: Maybe<THeSetDuty>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Float'];
  anValuePercent: Scalars['Float'];
};

export type THeSetItemExciseFilterInput = {
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acSetOfTax?: InputMaybe<StringOperationFilterInput>;
  acSetOfTaxNavigation?: InputMaybe<THeSetDutyFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anValuePercent?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemExciseFilterInput>>;
  or?: InputMaybe<Array<THeSetItemExciseFilterInput>>;
};

export type THeSetItemExtItemSubj = {
  acCode?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acName?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  packageQuantity?: Maybe<Scalars['Decimal']>;
};

export type THeSetItemExtItemSubjFilterInput = {
  acCode?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemExtItemSubjFilterInput>>;
  or?: InputMaybe<Array<THeSetItemExtItemSubjFilterInput>>;
  packageQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type THeSetItemFilterInput = {
  abIcon?: InputMaybe<ListComparableByteOperationFilterInput>;
  acAcct?: InputMaybe<StringOperationFilterInput>;
  acAcctBuyVasale?: InputMaybe<StringOperationFilterInput>;
  acAcctIncome?: InputMaybe<StringOperationFilterInput>;
  acAcctNotTaxDeduct?: InputMaybe<StringOperationFilterInput>;
  acActive?: InputMaybe<StringOperationFilterInput>;
  acBackPacking?: InputMaybe<StringOperationFilterInput>;
  acBst?: InputMaybe<StringOperationFilterInput>;
  acBullId?: InputMaybe<StringOperationFilterInput>;
  acClassProdByAct?: InputMaybe<StringOperationFilterInput>;
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acClassif2?: InputMaybe<StringOperationFilterInput>;
  acClassifNavigation?: InputMaybe<THeSetItemCategFilterInput>;
  acCode?: InputMaybe<StringOperationFilterInput>;
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acColumnNavigation?: InputMaybe<THeSetItemSntFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acCustTariffNavigation?: InputMaybe<THeSetCustTariffFilterInput>;
  acDateDue?: InputMaybe<StringOperationFilterInput>;
  acDeclarForOrigin?: InputMaybe<StringOperationFilterInput>;
  acDeclarForOriginType?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acDocTypeIssue?: InputMaybe<StringOperationFilterInput>;
  acDocTypeOrdSupp?: InputMaybe<StringOperationFilterInput>;
  acDocTypeProd?: InputMaybe<StringOperationFilterInput>;
  acDroe?: InputMaybe<StringOperationFilterInput>;
  acDroesubject?: InputMaybe<StringOperationFilterInput>;
  acEnableChgPrSt?: InputMaybe<StringOperationFilterInput>;
  acEnvrmntCost?: InputMaybe<StringOperationFilterInput>;
  acEvidence?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acFieldsA?: InputMaybe<StringOperationFilterInput>;
  acFormula?: InputMaybe<StringOperationFilterInput>;
  acFormulaRt?: InputMaybe<StringOperationFilterInput>;
  acHttppath?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acInFlowOutFlow?: InputMaybe<StringOperationFilterInput>;
  acIsReturnPack?: InputMaybe<StringOperationFilterInput>;
  acMakeCalc?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acOrderTransInMf?: InputMaybe<StringOperationFilterInput>;
  acOrigin?: InputMaybe<StringOperationFilterInput>;
  acPackSlopak?: InputMaybe<StringOperationFilterInput>;
  acPackSlopaktype?: InputMaybe<StringOperationFilterInput>;
  acPackagingType?: InputMaybe<StringOperationFilterInput>;
  acPacking?: InputMaybe<StringOperationFilterInput>;
  acPicture?: InputMaybe<ListComparableByteOperationFilterInput>;
  acPosprinterId?: InputMaybe<StringOperationFilterInput>;
  acPrstPrice?: InputMaybe<StringOperationFilterInput>;
  acPrstUmtime?: InputMaybe<StringOperationFilterInput>;
  acPurchCurr?: InputMaybe<StringOperationFilterInput>;
  acQtyInCode?: InputMaybe<StringOperationFilterInput>;
  acQtyNotToKol?: InputMaybe<StringOperationFilterInput>;
  acReportDeclar?: InputMaybe<StringOperationFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acSerialnoDueType?: InputMaybe<StringOperationFilterInput>;
  acSetOfItem?: InputMaybe<StringOperationFilterInput>;
  acSetOfItemNavigation?: InputMaybe<THeSetItemTypeFilterInput>;
  acShowAtena?: InputMaybe<StringOperationFilterInput>;
  acStandardize?: InputMaybe<StringOperationFilterInput>;
  acSupplier?: InputMaybe<StringOperationFilterInput>;
  acTechProcedure?: InputMaybe<StringOperationFilterInput>;
  acTransferredWs?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUm2?: InputMaybe<StringOperationFilterInput>;
  acUm2Navigation?: InputMaybe<THeSetUmFilterInput>;
  acUm3?: InputMaybe<StringOperationFilterInput>;
  acUmNavigation?: InputMaybe<THeSetUmFilterInput>;
  acUmdim1?: InputMaybe<StringOperationFilterInput>;
  acUmdim2?: InputMaybe<StringOperationFilterInput>;
  acUmmarkLabel?: InputMaybe<StringOperationFilterInput>;
  acUmseries?: InputMaybe<StringOperationFilterInput>;
  acUsedTyre?: InputMaybe<StringOperationFilterInput>;
  acVatCodeNavigation?: InputMaybe<THeSetTaxFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  acVatcodeLow?: InputMaybe<StringOperationFilterInput>;
  acVatcodeReceive?: InputMaybe<StringOperationFilterInput>;
  acVehiclePart?: InputMaybe<StringOperationFilterInput>;
  acWastePack?: InputMaybe<StringOperationFilterInput>;
  acWeighableItem?: InputMaybe<StringOperationFilterInput>;
  acWstEeequip?: InputMaybe<StringOperationFilterInput>;
  adDiscountBegin?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDiscountEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPrStCheckTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPrStInsertTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPrStUpdateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anAllowedInvShort?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anAllowedWastage?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anBeatShare?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anBuyPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anBuyRebate2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anBuyRebate3?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anColorCode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDeliveryDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDimDepth?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimHeight?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWeight?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWeightBrutto?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDimWidth?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDirectCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDiscountPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDiscountPriceRt?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDuty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExcise?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExciseP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFixPriceDiff?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anIncTax?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anMaxRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMaxStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinMargin?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMonthDue?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOptStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anOrderMinQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anOrderOptQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPackWasteWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPackWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPlucode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPlucode2?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  anPosQtyStep?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPosqty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrStCheckUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStDailyQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrStInsertUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStOptimalQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anPrStPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPrStPriceP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPrStUpdateUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPrStVariantValid?: InputMaybe<ComparableByteOperationFilterInput>;
  anPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPriceSupp?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anProdPrice?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrstTime?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPurExciseA?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPurExciseE?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPurExciseT?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQtyInCodeDecPlace?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQtyMarkLabel?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQtySeries?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRtPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anRtpriceP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSaleRebate2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anSaleRebate3?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anSubClassif?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anTransport?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anUmtoDeclarReport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUmtoUm2?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUmtoUm3?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUnionDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatreceive?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anWarrenty?: InputMaybe<ComparableInt32OperationFilterInput>;
  anWasteQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anWsprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWsprice2?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWsprice2P?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anWspriceP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemFilterInput>>;
  or?: InputMaybe<Array<THeSetItemFilterInput>>;
  tHeMoveItem?: InputMaybe<ListFilterInputTypeOfTHeMoveItemFilterInput>;
  tHeMoveItemSerialNo?: InputMaybe<ListFilterInputTypeOfTHeMoveItemSerialNoFilterInput>;
  tHeOrderItem?: InputMaybe<ListFilterInputTypeOfTHeOrderItemFilterInput>;
  tHeSetItemExcises?: InputMaybe<ListFilterInputTypeOfTHeSetItemExciseFilterInput>;
  tHeSetItemExtItemSubj?: InputMaybe<ListFilterInputTypeOfTHeSetItemExtItemSubjFilterInput>;
  tHeSetItemPriceForWrh?: InputMaybe<ListFilterInputTypeOfTHeSetItemPriceForWrhFilterInput>;
  tHeSetSubjPriceItem?: InputMaybe<ListFilterInputTypeOfTHeSetSubjPriceItemFilterInput>;
  tHeStock?: InputMaybe<ListFilterInputTypeOfTHeStockFilterInput>;
  tHeStockSerialNos?: InputMaybe<ListFilterInputTypeOfTHeStockSerialNoFilterInput>;
  tHfWoexAcIdentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexAcLnkPrStIdentParentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexAcScrapIdentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexItemAcIdentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHfWoexItemAcScrapIdentNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHfWoexItemSerialNos?: InputMaybe<ListFilterInputTypeOfTHfWoexItemSerialNoFilterInput>;
};

/** A connection to a list of items. */
export type THeSetItemPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type THeSetItemPagedDtoInput = {
  acClassif?: InputMaybe<Scalars['String']>;
  acFieldsA?: InputMaybe<Scalars['String']>;
  acSetOfItem?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  alwaysShowTheseAcSetOfItem?: InputMaybe<Scalars['String']>;
  articleSearchShowOnlyWhereAcClassifIsIn?: InputMaybe<Scalars['String']>;
  customContractPriceFilter?: InputMaybe<Scalars['Boolean']>;
  docTypeId?: InputMaybe<Scalars['Int']>;
  ignoreWarehouse?: InputMaybe<Scalars['Boolean']>;
  minStock?: InputMaybe<Scalars['Decimal']>;
  onlyWithCustomerContractPrices?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  showOnlyInStock?: InputMaybe<Scalars['Boolean']>;
  sortDescending?: InputMaybe<Scalars['Boolean']>;
  sortField?: InputMaybe<THeSetItemPagedSortField>;
};

/** An edge in a connection. */
export type THeSetItemPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
};

/** A connection to a list of items. */
export type THeSetItemPagedParametrizedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type THeSetItemPagedParametrizedDtoConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemPagedParametrizedDtoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeSetItemPagedParametrizedDtoEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
};

/** An edge in a connection. */
export type THeSetItemPagedParametrizedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
};

/** A connection to a list of items. */
export type THeSetItemPagedParametrizedV2Connection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetItemPagedParametrizedV2Edge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeSetItemPagedParametrizedV2Edge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
};

export enum THeSetItemPagedSortField {
  AcClassif = 'AC_CLASSIF',
  AcClassif2 = 'AC_CLASSIF2',
  AcDept = 'AC_DEPT',
  AcIdent = 'AC_IDENT',
  AcName = 'AC_NAME',
  AcNote = 'AC_NOTE',
  AcSetOfItem = 'AC_SET_OF_ITEM',
  AcSupplier = 'AC_SUPPLIER'
}

export type THeSetItemPriceForWrh = {
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acWarehouse?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anBuyPrice?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anRtprice: Scalars['Float'];
  anSalePrice: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeSetItemPriceForWrhFilterInput = {
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anBuyPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemPriceForWrhFilterInput>>;
  or?: InputMaybe<Array<THeSetItemPriceForWrhFilterInput>>;
};

export type THeSetItemSnt = {
  acColumn?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetItemSntitems?: Maybe<Array<Maybe<THeSetItemSntitem>>>;
  tHeSetItemSntserialNos?: Maybe<Array<Maybe<THeSetItemSntserialNo>>>;
  tHeSetItems?: Maybe<Array<Maybe<THeSetItem>>>;
};

export type THeSetItemSntFilterInput = {
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemSntFilterInput>>;
  or?: InputMaybe<Array<THeSetItemSntFilterInput>>;
  tHeSetItemSntitems?: InputMaybe<ListFilterInputTypeOfTHeSetItemSntitemFilterInput>;
  tHeSetItemSntserialNos?: InputMaybe<ListFilterInputTypeOfTHeSetItemSntserialNoFilterInput>;
  tHeSetItems?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
};

export type THeSetItemSntSortInput = {
  acColumn?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetItemSntitem = {
  acColumn?: Maybe<Scalars['String']>;
  acColumnNavigation?: Maybe<THeSetItemSnt>;
  acSerialNo?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anSeqNo?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeSetItemSntitemFilterInput = {
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acColumnNavigation?: InputMaybe<THeSetItemSntFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anSeqNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemSntitemFilterInput>>;
  or?: InputMaybe<Array<THeSetItemSntitemFilterInput>>;
};

export type THeSetItemSntserialNo = {
  acColumn?: Maybe<Scalars['String']>;
  acColumnNavigation?: Maybe<THeSetItemSnt>;
  acHandling?: Maybe<Scalars['String']>;
  acInternal?: Maybe<Scalars['String']>;
  acMessage?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acRequireEnter?: Maybe<Scalars['String']>;
  acSignForEmpty?: Maybe<Scalars['String']>;
  acSqlcontrol?: Maybe<Scalars['String']>;
  acSqlselect?: Maybe<Scalars['String']>;
  acSqlselectDefault?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLen: Scalars['Int'];
  anNameLength: Scalars['Int'];
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  gS1FieldFormat?: Maybe<Scalars['String']>;
  gS1FieldMask?: Maybe<Scalars['String']>;
  gS1FieldType?: Maybe<Scalars['String']>;
  gS1Mapping?: Maybe<Scalars['String']>;
};

export type THeSetItemSntserialNoFilterInput = {
  acColumn?: InputMaybe<StringOperationFilterInput>;
  acColumnNavigation?: InputMaybe<THeSetItemSntFilterInput>;
  acHandling?: InputMaybe<StringOperationFilterInput>;
  acInternal?: InputMaybe<StringOperationFilterInput>;
  acMessage?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acRequireEnter?: InputMaybe<StringOperationFilterInput>;
  acSignForEmpty?: InputMaybe<StringOperationFilterInput>;
  acSqlcontrol?: InputMaybe<StringOperationFilterInput>;
  acSqlselect?: InputMaybe<StringOperationFilterInput>;
  acSqlselectDefault?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNameLength?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemSntserialNoFilterInput>>;
  gS1FieldFormat?: InputMaybe<StringOperationFilterInput>;
  gS1FieldMask?: InputMaybe<StringOperationFilterInput>;
  gS1FieldType?: InputMaybe<StringOperationFilterInput>;
  gS1Mapping?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<THeSetItemSntserialNoFilterInput>>;
};

export type THeSetItemSortInput = {
  acAcct?: InputMaybe<SortEnumType>;
  acAcctBuyVasale?: InputMaybe<SortEnumType>;
  acAcctIncome?: InputMaybe<SortEnumType>;
  acAcctNotTaxDeduct?: InputMaybe<SortEnumType>;
  acActive?: InputMaybe<SortEnumType>;
  acBackPacking?: InputMaybe<SortEnumType>;
  acBst?: InputMaybe<SortEnumType>;
  acBullId?: InputMaybe<SortEnumType>;
  acClassProdByAct?: InputMaybe<SortEnumType>;
  acClassif?: InputMaybe<SortEnumType>;
  acClassif2?: InputMaybe<SortEnumType>;
  acClassifNavigation?: InputMaybe<THeSetItemCategSortInput>;
  acCode?: InputMaybe<SortEnumType>;
  acColumn?: InputMaybe<SortEnumType>;
  acColumnNavigation?: InputMaybe<THeSetItemSntSortInput>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acCustTariffNavigation?: InputMaybe<THeSetCustTariffSortInput>;
  acDateDue?: InputMaybe<SortEnumType>;
  acDeclarForOrigin?: InputMaybe<SortEnumType>;
  acDeclarForOriginType?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDescr?: InputMaybe<SortEnumType>;
  acDocTypeIssue?: InputMaybe<SortEnumType>;
  acDocTypeOrdSupp?: InputMaybe<SortEnumType>;
  acDocTypeProd?: InputMaybe<SortEnumType>;
  acDroe?: InputMaybe<SortEnumType>;
  acDroesubject?: InputMaybe<SortEnumType>;
  acEnableChgPrSt?: InputMaybe<SortEnumType>;
  acEnvrmntCost?: InputMaybe<SortEnumType>;
  acEvidence?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSf?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFieldSj?: InputMaybe<SortEnumType>;
  acFieldsA?: InputMaybe<SortEnumType>;
  acFormula?: InputMaybe<SortEnumType>;
  acFormulaRt?: InputMaybe<SortEnumType>;
  acHttppath?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acInFlowOutFlow?: InputMaybe<SortEnumType>;
  acIsReturnPack?: InputMaybe<SortEnumType>;
  acMakeCalc?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acOrderTransInMf?: InputMaybe<SortEnumType>;
  acOrigin?: InputMaybe<SortEnumType>;
  acPackSlopak?: InputMaybe<SortEnumType>;
  acPackSlopaktype?: InputMaybe<SortEnumType>;
  acPackagingType?: InputMaybe<SortEnumType>;
  acPacking?: InputMaybe<SortEnumType>;
  acPosprinterId?: InputMaybe<SortEnumType>;
  acPrstPrice?: InputMaybe<SortEnumType>;
  acPrstUmtime?: InputMaybe<SortEnumType>;
  acPurchCurr?: InputMaybe<SortEnumType>;
  acQtyInCode?: InputMaybe<SortEnumType>;
  acQtyNotToKol?: InputMaybe<SortEnumType>;
  acReportDeclar?: InputMaybe<SortEnumType>;
  acSerialNo?: InputMaybe<SortEnumType>;
  acSerialnoDueType?: InputMaybe<SortEnumType>;
  acSetOfItem?: InputMaybe<SortEnumType>;
  acSetOfItemNavigation?: InputMaybe<THeSetItemTypeSortInput>;
  acShowAtena?: InputMaybe<SortEnumType>;
  acStandardize?: InputMaybe<SortEnumType>;
  acSupplier?: InputMaybe<SortEnumType>;
  acTechProcedure?: InputMaybe<SortEnumType>;
  acTransferredWs?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUm2?: InputMaybe<SortEnumType>;
  acUm2Navigation?: InputMaybe<THeSetUmSortInput>;
  acUm3?: InputMaybe<SortEnumType>;
  acUmNavigation?: InputMaybe<THeSetUmSortInput>;
  acUmdim1?: InputMaybe<SortEnumType>;
  acUmdim2?: InputMaybe<SortEnumType>;
  acUmmarkLabel?: InputMaybe<SortEnumType>;
  acUmseries?: InputMaybe<SortEnumType>;
  acUsedTyre?: InputMaybe<SortEnumType>;
  acVatCodeNavigation?: InputMaybe<THeSetTaxSortInput>;
  acVatcode?: InputMaybe<SortEnumType>;
  acVatcodeLow?: InputMaybe<SortEnumType>;
  acVatcodeReceive?: InputMaybe<SortEnumType>;
  acVehiclePart?: InputMaybe<SortEnumType>;
  acWastePack?: InputMaybe<SortEnumType>;
  acWeighableItem?: InputMaybe<SortEnumType>;
  acWstEeequip?: InputMaybe<SortEnumType>;
  adDiscountBegin?: InputMaybe<SortEnumType>;
  adDiscountEnd?: InputMaybe<SortEnumType>;
  adFieldDa?: InputMaybe<SortEnumType>;
  adFieldDb?: InputMaybe<SortEnumType>;
  adFieldDc?: InputMaybe<SortEnumType>;
  adFieldDd?: InputMaybe<SortEnumType>;
  adPrStCheckTime?: InputMaybe<SortEnumType>;
  adPrStInsertTime?: InputMaybe<SortEnumType>;
  adPrStUpdateTime?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anAllowedInvShort?: InputMaybe<SortEnumType>;
  anAllowedWastage?: InputMaybe<SortEnumType>;
  anBeatShare?: InputMaybe<SortEnumType>;
  anBuyPrice?: InputMaybe<SortEnumType>;
  anBuyRebate2?: InputMaybe<SortEnumType>;
  anBuyRebate3?: InputMaybe<SortEnumType>;
  anColorCode?: InputMaybe<SortEnumType>;
  anDeliveryDeadline?: InputMaybe<SortEnumType>;
  anDimDepth?: InputMaybe<SortEnumType>;
  anDimHeight?: InputMaybe<SortEnumType>;
  anDimWeight?: InputMaybe<SortEnumType>;
  anDimWeightBrutto?: InputMaybe<SortEnumType>;
  anDimWidth?: InputMaybe<SortEnumType>;
  anDirectCost?: InputMaybe<SortEnumType>;
  anDiscount?: InputMaybe<SortEnumType>;
  anDiscountPrice?: InputMaybe<SortEnumType>;
  anDiscountPriceRt?: InputMaybe<SortEnumType>;
  anDuty?: InputMaybe<SortEnumType>;
  anExcise?: InputMaybe<SortEnumType>;
  anExciseP?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anFixPriceDiff?: InputMaybe<SortEnumType>;
  anIncTax?: InputMaybe<SortEnumType>;
  anMaxRebate?: InputMaybe<SortEnumType>;
  anMaxStock?: InputMaybe<SortEnumType>;
  anMinMargin?: InputMaybe<SortEnumType>;
  anMinStock?: InputMaybe<SortEnumType>;
  anMonthDue?: InputMaybe<SortEnumType>;
  anOptStock?: InputMaybe<SortEnumType>;
  anOrderMinQty?: InputMaybe<SortEnumType>;
  anOrderOptQty?: InputMaybe<SortEnumType>;
  anPackWasteWeight?: InputMaybe<SortEnumType>;
  anPackWeight?: InputMaybe<SortEnumType>;
  anPlucode?: InputMaybe<SortEnumType>;
  anPlucode2?: InputMaybe<SortEnumType>;
  anPosQtyStep?: InputMaybe<SortEnumType>;
  anPosqty?: InputMaybe<SortEnumType>;
  anPrStCheckUserId?: InputMaybe<SortEnumType>;
  anPrStDailyQty?: InputMaybe<SortEnumType>;
  anPrStInsertUserId?: InputMaybe<SortEnumType>;
  anPrStOptimalQty?: InputMaybe<SortEnumType>;
  anPrStPrice?: InputMaybe<SortEnumType>;
  anPrStPriceP?: InputMaybe<SortEnumType>;
  anPrStUpdateUserId?: InputMaybe<SortEnumType>;
  anPrStVariantValid?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anPriceSupp?: InputMaybe<SortEnumType>;
  anProdPrice?: InputMaybe<SortEnumType>;
  anPrstTime?: InputMaybe<SortEnumType>;
  anPurExciseA?: InputMaybe<SortEnumType>;
  anPurExciseE?: InputMaybe<SortEnumType>;
  anPurExciseT?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQtyInCodeDecPlace?: InputMaybe<SortEnumType>;
  anQtyMarkLabel?: InputMaybe<SortEnumType>;
  anQtySeries?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anRtPrice?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anRtpriceP?: InputMaybe<SortEnumType>;
  anSalePrice?: InputMaybe<SortEnumType>;
  anSaleRebate2?: InputMaybe<SortEnumType>;
  anSaleRebate3?: InputMaybe<SortEnumType>;
  anSubClassif?: InputMaybe<SortEnumType>;
  anTransport?: InputMaybe<SortEnumType>;
  anUmtoDeclarReport?: InputMaybe<SortEnumType>;
  anUmtoUm2?: InputMaybe<SortEnumType>;
  anUmtoUm3?: InputMaybe<SortEnumType>;
  anUnionDeadline?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  anVatreceive?: InputMaybe<SortEnumType>;
  anWarrenty?: InputMaybe<SortEnumType>;
  anWasteQty?: InputMaybe<SortEnumType>;
  anWsprice?: InputMaybe<SortEnumType>;
  anWsprice2?: InputMaybe<SortEnumType>;
  anWsprice2P?: InputMaybe<SortEnumType>;
  anWspriceP?: InputMaybe<SortEnumType>;
};

export type THeSetItemType = {
  acGoodsAsService?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acServiceAsGoods?: Maybe<Scalars['String']>;
  acSetOfItem?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFarmType?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetItems?: Maybe<Array<Maybe<THeSetItem>>>;
};

export type THeSetItemTypeFilterInput = {
  acGoodsAsService?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acServiceAsGoods?: InputMaybe<StringOperationFilterInput>;
  acSetOfItem?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFarmType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetItemTypeFilterInput>>;
  or?: InputMaybe<Array<THeSetItemTypeFilterInput>>;
  tHeSetItems?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
};

export type THeSetItemTypeSortInput = {
  acGoodsAsService?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acServiceAsGoods?: InputMaybe<SortEnumType>;
  acSetOfItem?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anFarmType?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetPayMet = {
  acFiscalGroup?: Maybe<Scalars['String']>;
  acIsPosTerminal?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPaymentType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  tHeCashRegItems?: Maybe<Array<Maybe<THeCashRegItem>>>;
  tHeMove?: Maybe<Array<Maybe<THeMove>>>;
  tHeOrder?: Maybe<Array<Maybe<THeOrder>>>;
  tHeSetSubjAcPayMethodNavigations?: Maybe<Array<Maybe<THeSetSubj>>>;
};

export type THeSetPayMetFilterInput = {
  acFiscalGroup?: InputMaybe<StringOperationFilterInput>;
  acIsPosTerminal?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPaymentType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetPayMetFilterInput>>;
  or?: InputMaybe<Array<THeSetPayMetFilterInput>>;
  tHeCashRegItems?: InputMaybe<ListFilterInputTypeOfTHeCashRegItemFilterInput>;
  tHeMove?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeOrder?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeSetSubjAcPayMethodNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
};

export type THeSetPayMetSortInput = {
  acFiscalGroup?: InputMaybe<SortEnumType>;
  acIsPosTerminal?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPaymentType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetPostCode = {
  acName?: Maybe<Scalars['String']>;
  acPost?: Maybe<Scalars['String']>;
  acRegion?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLatitude?: Maybe<Scalars['Decimal']>;
  anLongitude?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetSubjAcPostNavigation?: Maybe<Array<Maybe<THeSetSubj>>>;
};

export type THeSetPostCodeFilterInput = {
  acName?: InputMaybe<StringOperationFilterInput>;
  acPost?: InputMaybe<StringOperationFilterInput>;
  acRegion?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLatitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLongitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetPostCodeFilterInput>>;
  or?: InputMaybe<Array<THeSetPostCodeFilterInput>>;
  tHeSetSubjAcPostNavigation?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
};

/** A connection to a list of items. */
export type THeSetPostCodePagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetPostCodePagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetPostCode>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeSetPostCodePagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetPostCode>;
};

export type THeSetPostCodeSortInput = {
  acName?: InputMaybe<SortEnumType>;
  acPost?: InputMaybe<SortEnumType>;
  acRegion?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anLatitude?: InputMaybe<SortEnumType>;
  anLongitude?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetSubj = {
  acActive?: Maybe<Scalars['String']>;
  acAddress?: Maybe<Scalars['String']>;
  acBuyer?: Maybe<Scalars['String']>;
  acBuyerLimitCtrl?: Maybe<Scalars['String']>;
  acCode?: Maybe<Scalars['String']>;
  acCountry?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acFax?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acHttpPath?: Maybe<Scalars['String']>;
  acName2?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayMethodNavigation?: Maybe<THeSetPayMet>;
  acPayer?: Maybe<Scalars['String']>;
  acPayerNavigation?: Maybe<THeSetSubj>;
  acPhone?: Maybe<Scalars['String']>;
  acPin?: Maybe<Scalars['String']>;
  acPost?: Maybe<Scalars['String']>;
  acPostNavigation?: Maybe<THeSetPostCode>;
  acPriceRate?: Maybe<Scalars['String']>;
  acSkis?: Maybe<Scalars['String']>;
  acSubjTypeBuyer?: Maybe<Scalars['String']>;
  acSubjTypeBuyerNavigation?: Maybe<THeSetSubjType>;
  acSubjTypeSupp?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSupplier?: Maybe<Scalars['String']>;
  acVatCodePrefix?: Maybe<Scalars['String']>;
  acWarehouse?: Maybe<Scalars['String']>;
  acWayOfSale?: Maybe<Scalars['String']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anClerkNavigation?: Maybe<THeSetSubjContact>;
  anDaysForPayment: Scalars['Int'];
  anFieldNa: Scalars['Decimal'];
  anFieldNb: Scalars['Decimal'];
  anFieldNc: Scalars['Decimal'];
  anFieldNd: Scalars['Decimal'];
  anFieldNe: Scalars['Decimal'];
  anFieldNf: Scalars['Decimal'];
  anFieldNg: Scalars['Decimal'];
  anFieldNh: Scalars['Decimal'];
  anFieldNi: Scalars['Decimal'];
  anFieldNj: Scalars['Decimal'];
  anLatitude?: Maybe<Scalars['Decimal']>;
  anLimit?: Maybe<Scalars['Decimal']>;
  anLongitude?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anRebate: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
  inverseAcPayerNavigation?: Maybe<Array<Maybe<THeSetSubj>>>;
  tHeCostDrvAcConsigneeNavigation?: Maybe<Array<Maybe<THeCostDrv>>>;
  tHeCostDrvAcDeptNavigation?: Maybe<Array<Maybe<THeCostDrv>>>;
  tHeMoveAcDeptNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAcDeptOutNavigations?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAcIssuerNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAcPrsn3Navigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAcReceiverNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeOrderAcConsigneeNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeOrderAcDeptNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeOrderAcReceiverNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeSetSubjContactAcSubjectNavigations?: Maybe<Array<Maybe<THeSetSubjContact>>>;
  tHeSetSubjPriceCategs?: Maybe<Array<Maybe<THeSetSubjPriceCateg>>>;
  tHeSetSubjPriceItem?: Maybe<Array<Maybe<THeSetSubjPriceItem>>>;
  tHeStockRes?: Maybe<Array<Maybe<THeStock>>>;
  tHeSubjTypes?: Maybe<Array<Maybe<THeSubjType>>>;
  tHfPlanAcConsigneeNavigations?: Maybe<Array<Maybe<THfPlan>>>;
  tHfPlanAcDeptNavigations?: Maybe<Array<Maybe<THfPlan>>>;
  tHfPlanAcReceiverNavigations?: Maybe<Array<Maybe<THfPlan>>>;
  tHfWoexAcConsigneeNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexAcDeptNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexAcReceiverNavigations?: Maybe<Array<Maybe<THfWoex>>>;
  tHfWoexItems?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHrPrsnAcWorkerNavigation?: Maybe<THrPrsn>;
};


export type THeSetSubjAnClerkNavigationArgs = {
  where?: InputMaybe<THeSetSubjContactFilterInput>;
};


export type THeSetSubjTHeSetSubjContactAcSubjectNavigationsArgs = {
  where?: InputMaybe<THeSetSubjContactFilterInput>;
};


export type THeSetSubjTHeSetSubjPriceCategsArgs = {
  where?: InputMaybe<THeSetSubjPriceCategFilterInput>;
};

export type THeSetSubjContact = {
  acActive?: Maybe<Scalars['String']>;
  acAdditPersonMark?: Maybe<Scalars['String']>;
  acAgencySignedBy?: Maybe<Scalars['String']>;
  acAppl?: Maybe<Scalars['String']>;
  acAtcalendar?: Maybe<Scalars['String']>;
  acAtcash?: Maybe<Scalars['String']>;
  acAtinvoice?: Maybe<Scalars['String']>;
  acAtorder?: Maybe<Scalars['String']>;
  acAtstock?: Maybe<Scalars['String']>;
  acBankBranch?: Maybe<Scalars['String']>;
  acCerPub?: Maybe<Scalars['String']>;
  acCerTime?: Maybe<Scalars['String']>;
  acCode?: Maybe<Scalars['String']>;
  acDefLang?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acForeigner?: Maybe<Scalars['String']>;
  acFunction?: Maybe<Scalars['String']>;
  acLangId?: Maybe<Scalars['String']>;
  acLicDataBase?: Maybe<Scalars['String']>;
  acMiddle?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPassword?: Maybe<Scalars['String']>;
  acPersonal?: Maybe<Scalars['String']>;
  acPhoto?: Maybe<Array<Scalars['Byte']>>;
  acPin?: Maybe<Scalars['String']>;
  acPost?: Maybe<Scalars['String']>;
  acPrefix?: Maybe<Scalars['String']>;
  acProfile?: Maybe<Scalars['String']>;
  acRegNo?: Maybe<Scalars['String']>;
  acSignature?: Maybe<Array<Scalars['Byte']>>;
  acSubject?: Maybe<Scalars['String']>;
  acSubjectNavigation?: Maybe<THeSetSubj>;
  acSurname?: Maybe<Scalars['String']>;
  acUserId?: Maybe<Scalars['String']>;
  acWebUserId?: Maybe<Scalars['String']>;
  acWorkerContact?: Maybe<Scalars['String']>;
  adBday?: Maybe<Scalars['DateTime']>;
  adGdprconfirm?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anMaxRebate?: Maybe<Scalars['Float']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserGroup?: Maybe<Scalars['Int']>;
  anUserId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
  tHeMoveAnClerkNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeMoveAnNoteClerkNavigation?: Maybe<Array<Maybe<THeMove>>>;
  tHeOrderAnClerkNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeOrderAnNoteClerkNavigation?: Maybe<Array<Maybe<THeOrder>>>;
  tHeSetSubjAnClerkNavigation?: Maybe<Array<Maybe<THeSetSubj>>>;
  tHeSetSubjContactAddresses?: Maybe<Array<Maybe<THeSetSubjContactAddress>>>;
  tHfPlans?: Maybe<Array<Maybe<THfPlan>>>;
  tMnDocumentChatLogs?: Maybe<Array<Maybe<TMnDocumentChatLog>>>;
};


export type THeSetSubjContactTHeSetSubjContactAddressesArgs = {
  where?: InputMaybe<THeSetSubjContactAddressFilterInput>;
};

export type THeSetSubjContactAddress = {
  acNote?: Maybe<Scalars['String']>;
  acPhone?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSubjectAnNoNavigation?: Maybe<THeSetSubjContact>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anSubNo: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeSetSubjContactAddressFilterInput = {
  acNote?: InputMaybe<StringOperationFilterInput>;
  acPhone?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSubjectAnNoNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anSubNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjContactAddressFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjContactAddressFilterInput>>;
};

export type THeSetSubjContactAddressSortInput = {
  acNote?: InputMaybe<SortEnumType>;
  acPhone?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acSubjectAnNoNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  acType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anSubNo?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetSubjContactFilterInput = {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAdditPersonMark?: InputMaybe<StringOperationFilterInput>;
  acAgencySignedBy?: InputMaybe<StringOperationFilterInput>;
  acAppl?: InputMaybe<StringOperationFilterInput>;
  acAtcalendar?: InputMaybe<StringOperationFilterInput>;
  acAtcash?: InputMaybe<StringOperationFilterInput>;
  acAtinvoice?: InputMaybe<StringOperationFilterInput>;
  acAtorder?: InputMaybe<StringOperationFilterInput>;
  acAtstock?: InputMaybe<StringOperationFilterInput>;
  acBankBranch?: InputMaybe<StringOperationFilterInput>;
  acCerPub?: InputMaybe<StringOperationFilterInput>;
  acCerTime?: InputMaybe<StringOperationFilterInput>;
  acCode?: InputMaybe<StringOperationFilterInput>;
  acDefLang?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acForeigner?: InputMaybe<StringOperationFilterInput>;
  acFunction?: InputMaybe<StringOperationFilterInput>;
  acLangId?: InputMaybe<StringOperationFilterInput>;
  acLicDataBase?: InputMaybe<StringOperationFilterInput>;
  acMiddle?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPassword?: InputMaybe<StringOperationFilterInput>;
  acPersonal?: InputMaybe<StringOperationFilterInput>;
  acPhoto?: InputMaybe<ListComparableByteOperationFilterInput>;
  acPin?: InputMaybe<StringOperationFilterInput>;
  acPost?: InputMaybe<StringOperationFilterInput>;
  acPrefix?: InputMaybe<StringOperationFilterInput>;
  acProfile?: InputMaybe<StringOperationFilterInput>;
  acRegNo?: InputMaybe<StringOperationFilterInput>;
  acSignature?: InputMaybe<ListComparableByteOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSubjectNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acSurname?: InputMaybe<StringOperationFilterInput>;
  acUserId?: InputMaybe<StringOperationFilterInput>;
  acWebUserId?: InputMaybe<StringOperationFilterInput>;
  acWorkerContact?: InputMaybe<StringOperationFilterInput>;
  adBday?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adGdprconfirm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anMaxRebate?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserGroup?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjContactFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjContactFilterInput>>;
  tHeMoveAnClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAnNoteClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeOrderAnClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeOrderAnNoteClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeSetSubjAnClerkNavigation?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
  tHeSetSubjContactAddresses?: InputMaybe<ListFilterInputTypeOfTHeSetSubjContactAddressFilterInput>;
  tHfPlans?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tMnDocumentChatLogs?: InputMaybe<ListFilterInputTypeOfTMnDocumentChatLogFilterInput>;
};

/** A connection to a list of items. */
export type THeSetSubjContactPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetSubjContactPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubjContact>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeSetSubjContactPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubjContact>;
};

export type THeSetSubjContactSortInput = {
  acActive?: InputMaybe<SortEnumType>;
  acAdditPersonMark?: InputMaybe<SortEnumType>;
  acAgencySignedBy?: InputMaybe<SortEnumType>;
  acAppl?: InputMaybe<SortEnumType>;
  acAtcalendar?: InputMaybe<SortEnumType>;
  acAtcash?: InputMaybe<SortEnumType>;
  acAtinvoice?: InputMaybe<SortEnumType>;
  acAtorder?: InputMaybe<SortEnumType>;
  acAtstock?: InputMaybe<SortEnumType>;
  acBankBranch?: InputMaybe<SortEnumType>;
  acCerPub?: InputMaybe<SortEnumType>;
  acCerTime?: InputMaybe<SortEnumType>;
  acCode?: InputMaybe<SortEnumType>;
  acDefLang?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acForeigner?: InputMaybe<SortEnumType>;
  acFunction?: InputMaybe<SortEnumType>;
  acLangId?: InputMaybe<SortEnumType>;
  acLicDataBase?: InputMaybe<SortEnumType>;
  acMiddle?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPassword?: InputMaybe<SortEnumType>;
  acPersonal?: InputMaybe<SortEnumType>;
  acPin?: InputMaybe<SortEnumType>;
  acPost?: InputMaybe<SortEnumType>;
  acPrefix?: InputMaybe<SortEnumType>;
  acProfile?: InputMaybe<SortEnumType>;
  acRegNo?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acSubjectNavigation?: InputMaybe<THeSetSubjSortInput>;
  acSurname?: InputMaybe<SortEnumType>;
  acUserId?: InputMaybe<SortEnumType>;
  acWebUserId?: InputMaybe<SortEnumType>;
  acWorkerContact?: InputMaybe<SortEnumType>;
  adBday?: InputMaybe<SortEnumType>;
  adGdprconfirm?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anMaxRebate?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserGroup?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetSubjFilterInput = {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAddress?: InputMaybe<StringOperationFilterInput>;
  acBuyer?: InputMaybe<StringOperationFilterInput>;
  acBuyerLimitCtrl?: InputMaybe<StringOperationFilterInput>;
  acCode?: InputMaybe<StringOperationFilterInput>;
  acCountry?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acFax?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acHttpPath?: InputMaybe<StringOperationFilterInput>;
  acName2?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetFilterInput>;
  acPayer?: InputMaybe<StringOperationFilterInput>;
  acPayerNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acPhone?: InputMaybe<StringOperationFilterInput>;
  acPin?: InputMaybe<StringOperationFilterInput>;
  acPost?: InputMaybe<StringOperationFilterInput>;
  acPostNavigation?: InputMaybe<THeSetPostCodeFilterInput>;
  acPriceRate?: InputMaybe<StringOperationFilterInput>;
  acSkis?: InputMaybe<StringOperationFilterInput>;
  acSubjTypeBuyer?: InputMaybe<StringOperationFilterInput>;
  acSubjTypeBuyerNavigation?: InputMaybe<THeSetSubjTypeFilterInput>;
  acSubjTypeSupp?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSupplier?: InputMaybe<StringOperationFilterInput>;
  acVatCodePrefix?: InputMaybe<StringOperationFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale?: InputMaybe<StringOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anDaysForPayment?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anLatitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLimit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLongitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjFilterInput>>;
  inverseAcPayerNavigation?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
  or?: InputMaybe<Array<THeSetSubjFilterInput>>;
  tHeCostDrvAcConsigneeNavigation?: InputMaybe<ListFilterInputTypeOfTHeCostDrvFilterInput>;
  tHeCostDrvAcDeptNavigation?: InputMaybe<ListFilterInputTypeOfTHeCostDrvFilterInput>;
  tHeMoveAcDeptNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAcDeptOutNavigations?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAcIssuerNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAcPrsn3Navigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeMoveAcReceiverNavigation?: InputMaybe<ListFilterInputTypeOfTHeMoveFilterInput>;
  tHeOrderAcConsigneeNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeOrderAcDeptNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeOrderAcReceiverNavigation?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
  tHeSetSubjContactAcSubjectNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetSubjContactFilterInput>;
  tHeSetSubjPriceCategs?: InputMaybe<ListFilterInputTypeOfTHeSetSubjPriceCategFilterInput>;
  tHeSetSubjPriceItem?: InputMaybe<ListFilterInputTypeOfTHeSetSubjPriceItemFilterInput>;
  tHeStockRes?: InputMaybe<ListFilterInputTypeOfTHeStockFilterInput>;
  tHeSubjTypes?: InputMaybe<ListFilterInputTypeOfTHeSubjTypeFilterInput>;
  tHfPlanAcConsigneeNavigations?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfPlanAcDeptNavigations?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfPlanAcReceiverNavigations?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfWoexAcConsigneeNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexAcDeptNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexAcReceiverNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tHfWoexItems?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHrPrsnAcWorkerNavigation?: InputMaybe<THrPrsnFilterInput>;
};

/** A connection to a list of items. */
export type THeSetSubjPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetSubjPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubj>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeSetSubjPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubj>;
};

/** A connection to a list of items. */
export type THeSetSubjPagedParametrizedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetSubjPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubj>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type THeSetSubjPagedParametrizedDtoConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeSetSubjPagedParametrizedDtoEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubj>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeSetSubjPagedParametrizedDtoEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubj>;
};

export type THeSetSubjPagedParametrizedDtoInput = {
  acBuyer?: InputMaybe<Scalars['String']>;
  acConsigneeInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acDept?: InputMaybe<Scalars['String']>;
  acDeptInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acDeptOutInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acFieldSa?: InputMaybe<Scalars['String']>;
  acIssuerInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acPayer?: InputMaybe<Scalars['String']>;
  acPrsn3InDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acReceiverInDocTypes?: InputMaybe<Array<Scalars['String']>>;
  acSubject?: InputMaybe<Scalars['String']>;
  acSupplier?: InputMaybe<Scalars['String']>;
  acWarehouse?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anClerks?: InputMaybe<Array<Scalars['Int']>>;
  byAcSkis?: InputMaybe<Scalars['String']>;
  byPrefix?: InputMaybe<Scalars['String']>;
};

/** An edge in a connection. */
export type THeSetSubjPagedParametrizedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubj>;
};

export type THeSetSubjPriceCateg = {
  acClassif?: Maybe<Scalars['String']>;
  acClassifNavigation?: Maybe<THeSetItemCateg>;
  acCurrency?: Maybe<Scalars['String']>;
  acFormula?: Maybe<Scalars['String']>;
  acInvoInOut?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acSetOf?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSubjectNavigation?: Maybe<THeSetSubj>;
  acType?: Maybe<Scalars['String']>;
  adDateEnd?: Maybe<Scalars['DateTime']>;
  adDateStart: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDeliveryDeadline: Scalars['Int'];
  anPaymentDeadline: Scalars['Int'];
  anPrice: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anRebate: Scalars['Decimal'];
  anRebate2: Scalars['Decimal'];
  anRebate3: Scalars['Decimal'];
  anSalePrice?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeSetSubjPriceCategFilterInput = {
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acClassifNavigation?: InputMaybe<THeSetItemCategFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acFormula?: InputMaybe<StringOperationFilterInput>;
  acInvoInOut?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acSetOf?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSubjectNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adDateEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateStart?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDeliveryDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPaymentDeadline?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate2?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRebate3?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjPriceCategFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjPriceCategFilterInput>>;
};

export type THeSetSubjPriceItem = {
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acInvoInOut?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSubjectNavigation?: Maybe<THeSetSubj>;
  adDateEnd?: Maybe<Scalars['DateTime']>;
  adDateStart: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anPrice: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anRebate: Scalars['Decimal'];
  anSalePrice?: Maybe<Scalars['Decimal']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeSetSubjPriceItemFilterInput = {
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acInvoInOut?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSubjectNavigation?: InputMaybe<THeSetSubjFilterInput>;
  adDateEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateStart?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSalePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjPriceItemFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjPriceItemFilterInput>>;
};

export type THeSetSubjPriceItemSortInput = {
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acInvoInOut?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acSubjectNavigation?: InputMaybe<THeSetSubjSortInput>;
  adDateEnd?: InputMaybe<SortEnumType>;
  adDateStart?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anSalePrice?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeSetSubjSortInput = {
  acActive?: InputMaybe<SortEnumType>;
  acAddress?: InputMaybe<SortEnumType>;
  acBuyer?: InputMaybe<SortEnumType>;
  acBuyerLimitCtrl?: InputMaybe<SortEnumType>;
  acCode?: InputMaybe<SortEnumType>;
  acCountry?: InputMaybe<SortEnumType>;
  acCurrency?: InputMaybe<SortEnumType>;
  acDelivery?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acFax?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFieldSf?: InputMaybe<SortEnumType>;
  acFieldSg?: InputMaybe<SortEnumType>;
  acFieldSh?: InputMaybe<SortEnumType>;
  acFieldSi?: InputMaybe<SortEnumType>;
  acFieldSj?: InputMaybe<SortEnumType>;
  acHttpPath?: InputMaybe<SortEnumType>;
  acName2?: InputMaybe<SortEnumType>;
  acPayMethod?: InputMaybe<SortEnumType>;
  acPayMethodNavigation?: InputMaybe<THeSetPayMetSortInput>;
  acPayer?: InputMaybe<SortEnumType>;
  acPayerNavigation?: InputMaybe<THeSetSubjSortInput>;
  acPhone?: InputMaybe<SortEnumType>;
  acPin?: InputMaybe<SortEnumType>;
  acPost?: InputMaybe<SortEnumType>;
  acPostNavigation?: InputMaybe<THeSetPostCodeSortInput>;
  acPriceRate?: InputMaybe<SortEnumType>;
  acSkis?: InputMaybe<SortEnumType>;
  acSubjTypeBuyer?: InputMaybe<SortEnumType>;
  acSubjTypeBuyerNavigation?: InputMaybe<THeSetSubjTypeSortInput>;
  acSubjTypeSupp?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acSupplier?: InputMaybe<SortEnumType>;
  acVatCodePrefix?: InputMaybe<SortEnumType>;
  acWarehouse?: InputMaybe<SortEnumType>;
  acWayOfSale?: InputMaybe<SortEnumType>;
  adFieldDa?: InputMaybe<SortEnumType>;
  adFieldDb?: InputMaybe<SortEnumType>;
  adFieldDc?: InputMaybe<SortEnumType>;
  adFieldDd?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anDaysForPayment?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFieldNd?: InputMaybe<SortEnumType>;
  anFieldNe?: InputMaybe<SortEnumType>;
  anFieldNf?: InputMaybe<SortEnumType>;
  anFieldNg?: InputMaybe<SortEnumType>;
  anFieldNh?: InputMaybe<SortEnumType>;
  anFieldNi?: InputMaybe<SortEnumType>;
  anFieldNj?: InputMaybe<SortEnumType>;
  anLatitude?: InputMaybe<SortEnumType>;
  anLimit?: InputMaybe<SortEnumType>;
  anLongitude?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  tHrPrsnAcWorkerNavigation?: InputMaybe<THrPrsnSortInput>;
};

export type THeSetSubjType = {
  acName?: Maybe<Scalars['String']>;
  acSubjType?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  tHeSetSubjAcSubjTypeBuyerNavigations?: Maybe<Array<Maybe<THeSetSubj>>>;
};

export type THeSetSubjTypeFilterInput = {
  acName?: InputMaybe<StringOperationFilterInput>;
  acSubjType?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<THeSetSubjTypeFilterInput>>;
  or?: InputMaybe<Array<THeSetSubjTypeFilterInput>>;
  tHeSetSubjAcSubjTypeBuyerNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetSubjFilterInput>;
};

export type THeSetSubjTypeSortInput = {
  acName?: InputMaybe<SortEnumType>;
  acSubjType?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
};

export type THeSetTax = {
  acAcctCr?: Maybe<Scalars['String']>;
  acAcctInclVatcr?: Maybe<Scalars['String']>;
  acAcctInclVatdb?: Maybe<Scalars['String']>;
  acActive?: Maybe<Scalars['String']>;
  acAnnulment?: Maybe<Scalars['String']>;
  acAsls?: Maybe<Scalars['String']>;
  acBadDebt?: Maybe<Scalars['String']>;
  acBanato?: Maybe<Scalars['String']>;
  acBefReg?: Maybe<Scalars['String']>;
  acDebitCreditNote?: Maybe<Scalars['String']>;
  acDeductibility?: Maybe<Scalars['String']>;
  acDistSaleEu?: Maybe<Scalars['String']>;
  acDistingVat?: Maybe<Scalars['String']>;
  acElectronicServ?: Maybe<Scalars['String']>;
  acExemptions?: Maybe<Scalars['String']>;
  acFa?: Maybe<Scalars['String']>;
  acFaownUsage?: Maybe<Scalars['String']>;
  acField37?: Maybe<Scalars['String']>;
  acFiscalCode?: Maybe<Scalars['String']>;
  acFoodDonation?: Maybe<Scalars['String']>;
  acFreed?: Maybe<Scalars['String']>;
  acHideRecapitulation?: Maybe<Scalars['String']>;
  acInitialStock?: Maybe<Scalars['String']>;
  acInternationalShipping?: Maybe<Scalars['String']>;
  acIntlTrans?: Maybe<Scalars['String']>;
  acInvestive?: Maybe<Scalars['String']>;
  acIpafond?: Maybe<Scalars['String']>;
  acIsService?: Maybe<Scalars['String']>;
  acIsVatcalc?: Maybe<Scalars['String']>;
  acIsVatcount?: Maybe<Scalars['String']>;
  acLegalTransactions?: Maybe<Scalars['String']>;
  acLicenses?: Maybe<Scalars['String']>;
  acLumpCompen?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNewTransportMeans?: Maybe<Scalars['String']>;
  acNonChargable?: Maybe<Scalars['String']>;
  acOtherPayFreed?: Maybe<Scalars['String']>;
  acOtherPreliminary?: Maybe<Scalars['String']>;
  acOtherServices?: Maybe<Scalars['String']>;
  acOverallAssets?: Maybe<Scalars['String']>;
  acPartialTax?: Maybe<Scalars['String']>;
  acPrintPosOnDocs?: Maybe<Scalars['String']>;
  acPublicInterest?: Maybe<Scalars['String']>;
  acRealEstate?: Maybe<Scalars['String']>;
  acScrap?: Maybe<Scalars['String']>;
  acSerExpDisp?: Maybe<Scalars['String']>;
  acShipping?: Maybe<Scalars['String']>;
  acShowVatdeducInreceive?: Maybe<Scalars['String']>;
  acSpecSchema?: Maybe<Scalars['String']>;
  acStatement?: Maybe<Scalars['String']>;
  acStatementNavigation?: Maybe<THeSetDocText>;
  acSyntheticsGoods?: Maybe<Scalars['String']>;
  acTaxDebt?: Maybe<Scalars['String']>;
  acTourismAgency?: Maybe<Scalars['String']>;
  acTypeOfVatRate?: Maybe<Scalars['String']>;
  acUnauthVat?: Maybe<Scalars['String']>;
  acUsedGoods?: Maybe<Scalars['String']>;
  acUsedMotorVehicle?: Maybe<Scalars['String']>;
  acVatadjustments?: Maybe<Scalars['String']>;
  acVatafterDeduction?: Maybe<Scalars['String']>;
  acVatcalcReceiver?: Maybe<Scalars['String']>;
  acVatcode?: Maybe<Scalars['String']>;
  acVateu?: Maybe<Scalars['String']>;
  acVatnoCode?: Maybe<Scalars['String']>;
  acVatnotAdmit?: Maybe<Scalars['String']>;
  acVatpost?: Maybe<Scalars['String']>;
  acVatrefund?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anVat: Scalars['Decimal'];
  anVatpdv?: Maybe<Scalars['Decimal']>;
  tHeMoveItemAcVatcodeNavigations?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeMoveItemAcVatcodeTrNavigations?: Maybe<Array<Maybe<THeMoveItem>>>;
  tHeSetItemAcVatcodeNavigations?: Maybe<Array<Maybe<THeSetItem>>>;
};

export type THeSetTaxFilterInput = {
  acAcctCr?: InputMaybe<StringOperationFilterInput>;
  acAcctInclVatcr?: InputMaybe<StringOperationFilterInput>;
  acAcctInclVatdb?: InputMaybe<StringOperationFilterInput>;
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAnnulment?: InputMaybe<StringOperationFilterInput>;
  acAsls?: InputMaybe<StringOperationFilterInput>;
  acBadDebt?: InputMaybe<StringOperationFilterInput>;
  acBanato?: InputMaybe<StringOperationFilterInput>;
  acBefReg?: InputMaybe<StringOperationFilterInput>;
  acDebitCreditNote?: InputMaybe<StringOperationFilterInput>;
  acDeductibility?: InputMaybe<StringOperationFilterInput>;
  acDistSaleEu?: InputMaybe<StringOperationFilterInput>;
  acDistingVat?: InputMaybe<StringOperationFilterInput>;
  acElectronicServ?: InputMaybe<StringOperationFilterInput>;
  acExemptions?: InputMaybe<StringOperationFilterInput>;
  acFa?: InputMaybe<StringOperationFilterInput>;
  acFaownUsage?: InputMaybe<StringOperationFilterInput>;
  acField37?: InputMaybe<StringOperationFilterInput>;
  acFiscalCode?: InputMaybe<StringOperationFilterInput>;
  acFoodDonation?: InputMaybe<StringOperationFilterInput>;
  acFreed?: InputMaybe<StringOperationFilterInput>;
  acHideRecapitulation?: InputMaybe<StringOperationFilterInput>;
  acInitialStock?: InputMaybe<StringOperationFilterInput>;
  acInternationalShipping?: InputMaybe<StringOperationFilterInput>;
  acIntlTrans?: InputMaybe<StringOperationFilterInput>;
  acInvestive?: InputMaybe<StringOperationFilterInput>;
  acIpafond?: InputMaybe<StringOperationFilterInput>;
  acIsService?: InputMaybe<StringOperationFilterInput>;
  acIsVatcalc?: InputMaybe<StringOperationFilterInput>;
  acIsVatcount?: InputMaybe<StringOperationFilterInput>;
  acLegalTransactions?: InputMaybe<StringOperationFilterInput>;
  acLicenses?: InputMaybe<StringOperationFilterInput>;
  acLumpCompen?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNewTransportMeans?: InputMaybe<StringOperationFilterInput>;
  acNonChargable?: InputMaybe<StringOperationFilterInput>;
  acOtherPayFreed?: InputMaybe<StringOperationFilterInput>;
  acOtherPreliminary?: InputMaybe<StringOperationFilterInput>;
  acOtherServices?: InputMaybe<StringOperationFilterInput>;
  acOverallAssets?: InputMaybe<StringOperationFilterInput>;
  acPartialTax?: InputMaybe<StringOperationFilterInput>;
  acPrintPosOnDocs?: InputMaybe<StringOperationFilterInput>;
  acPublicInterest?: InputMaybe<StringOperationFilterInput>;
  acRealEstate?: InputMaybe<StringOperationFilterInput>;
  acScrap?: InputMaybe<StringOperationFilterInput>;
  acSerExpDisp?: InputMaybe<StringOperationFilterInput>;
  acShipping?: InputMaybe<StringOperationFilterInput>;
  acShowVatdeducInreceive?: InputMaybe<StringOperationFilterInput>;
  acSpecSchema?: InputMaybe<StringOperationFilterInput>;
  acStatement?: InputMaybe<StringOperationFilterInput>;
  acStatementNavigation?: InputMaybe<THeSetDocTextFilterInput>;
  acSyntheticsGoods?: InputMaybe<StringOperationFilterInput>;
  acTaxDebt?: InputMaybe<StringOperationFilterInput>;
  acTourismAgency?: InputMaybe<StringOperationFilterInput>;
  acTypeOfVatRate?: InputMaybe<StringOperationFilterInput>;
  acUnauthVat?: InputMaybe<StringOperationFilterInput>;
  acUsedGoods?: InputMaybe<StringOperationFilterInput>;
  acUsedMotorVehicle?: InputMaybe<StringOperationFilterInput>;
  acVatadjustments?: InputMaybe<StringOperationFilterInput>;
  acVatafterDeduction?: InputMaybe<StringOperationFilterInput>;
  acVatcalcReceiver?: InputMaybe<StringOperationFilterInput>;
  acVatcode?: InputMaybe<StringOperationFilterInput>;
  acVateu?: InputMaybe<StringOperationFilterInput>;
  acVatnoCode?: InputMaybe<StringOperationFilterInput>;
  acVatnotAdmit?: InputMaybe<StringOperationFilterInput>;
  acVatpost?: InputMaybe<StringOperationFilterInput>;
  acVatrefund?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatpdv?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<THeSetTaxFilterInput>>;
  or?: InputMaybe<Array<THeSetTaxFilterInput>>;
  tHeMoveItemAcVatcodeNavigations?: InputMaybe<ListFilterInputTypeOfTHeMoveItemFilterInput>;
  tHeMoveItemAcVatcodeTrNavigations?: InputMaybe<ListFilterInputTypeOfTHeMoveItemFilterInput>;
  tHeSetItemAcVatcodeNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
};

export type THeSetTaxSortInput = {
  acAcctCr?: InputMaybe<SortEnumType>;
  acAcctInclVatcr?: InputMaybe<SortEnumType>;
  acAcctInclVatdb?: InputMaybe<SortEnumType>;
  acActive?: InputMaybe<SortEnumType>;
  acAnnulment?: InputMaybe<SortEnumType>;
  acAsls?: InputMaybe<SortEnumType>;
  acBadDebt?: InputMaybe<SortEnumType>;
  acBanato?: InputMaybe<SortEnumType>;
  acBefReg?: InputMaybe<SortEnumType>;
  acDebitCreditNote?: InputMaybe<SortEnumType>;
  acDeductibility?: InputMaybe<SortEnumType>;
  acDistSaleEu?: InputMaybe<SortEnumType>;
  acDistingVat?: InputMaybe<SortEnumType>;
  acElectronicServ?: InputMaybe<SortEnumType>;
  acExemptions?: InputMaybe<SortEnumType>;
  acFa?: InputMaybe<SortEnumType>;
  acFaownUsage?: InputMaybe<SortEnumType>;
  acField37?: InputMaybe<SortEnumType>;
  acFiscalCode?: InputMaybe<SortEnumType>;
  acFoodDonation?: InputMaybe<SortEnumType>;
  acFreed?: InputMaybe<SortEnumType>;
  acHideRecapitulation?: InputMaybe<SortEnumType>;
  acInitialStock?: InputMaybe<SortEnumType>;
  acInternationalShipping?: InputMaybe<SortEnumType>;
  acIntlTrans?: InputMaybe<SortEnumType>;
  acInvestive?: InputMaybe<SortEnumType>;
  acIpafond?: InputMaybe<SortEnumType>;
  acIsService?: InputMaybe<SortEnumType>;
  acIsVatcalc?: InputMaybe<SortEnumType>;
  acIsVatcount?: InputMaybe<SortEnumType>;
  acLegalTransactions?: InputMaybe<SortEnumType>;
  acLicenses?: InputMaybe<SortEnumType>;
  acLumpCompen?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acNewTransportMeans?: InputMaybe<SortEnumType>;
  acNonChargable?: InputMaybe<SortEnumType>;
  acOtherPayFreed?: InputMaybe<SortEnumType>;
  acOtherPreliminary?: InputMaybe<SortEnumType>;
  acOtherServices?: InputMaybe<SortEnumType>;
  acOverallAssets?: InputMaybe<SortEnumType>;
  acPartialTax?: InputMaybe<SortEnumType>;
  acPrintPosOnDocs?: InputMaybe<SortEnumType>;
  acPublicInterest?: InputMaybe<SortEnumType>;
  acRealEstate?: InputMaybe<SortEnumType>;
  acScrap?: InputMaybe<SortEnumType>;
  acSerExpDisp?: InputMaybe<SortEnumType>;
  acShipping?: InputMaybe<SortEnumType>;
  acShowVatdeducInreceive?: InputMaybe<SortEnumType>;
  acSpecSchema?: InputMaybe<SortEnumType>;
  acStatement?: InputMaybe<SortEnumType>;
  acStatementNavigation?: InputMaybe<THeSetDocTextSortInput>;
  acSyntheticsGoods?: InputMaybe<SortEnumType>;
  acTaxDebt?: InputMaybe<SortEnumType>;
  acTourismAgency?: InputMaybe<SortEnumType>;
  acTypeOfVatRate?: InputMaybe<SortEnumType>;
  acUnauthVat?: InputMaybe<SortEnumType>;
  acUsedGoods?: InputMaybe<SortEnumType>;
  acUsedMotorVehicle?: InputMaybe<SortEnumType>;
  acVatadjustments?: InputMaybe<SortEnumType>;
  acVatafterDeduction?: InputMaybe<SortEnumType>;
  acVatcalcReceiver?: InputMaybe<SortEnumType>;
  acVatcode?: InputMaybe<SortEnumType>;
  acVateu?: InputMaybe<SortEnumType>;
  acVatnoCode?: InputMaybe<SortEnumType>;
  acVatnotAdmit?: InputMaybe<SortEnumType>;
  acVatpost?: InputMaybe<SortEnumType>;
  acVatrefund?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVat?: InputMaybe<SortEnumType>;
  anVatpdv?: InputMaybe<SortEnumType>;
};

export type THeSetUm = {
  acFiscalCode?: Maybe<Scalars['String']>;
  acInterUm?: Maybe<Scalars['String']>;
  acInterUm2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acStdUm?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUmoriginal?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDecPlaces: Scalars['Decimal'];
  anMinValue?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeSetItemAcUm2Navigations?: Maybe<Array<Maybe<THeSetItem>>>;
  tHeSetItemAcUmNavigations?: Maybe<Array<Maybe<THeSetItem>>>;
  tHfWoexItemAcUm3Navigations?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexItemAcUmNavigations?: Maybe<Array<Maybe<THfWoexItem>>>;
  tHfWoexes?: Maybe<Array<Maybe<THfWoex>>>;
};

export type THeSetUmFilterInput = {
  acFiscalCode?: InputMaybe<StringOperationFilterInput>;
  acInterUm?: InputMaybe<StringOperationFilterInput>;
  acInterUm2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acStdUm?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUmoriginal?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDecPlaces?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSetUmFilterInput>>;
  or?: InputMaybe<Array<THeSetUmFilterInput>>;
  tHeSetItemAcUm2Navigations?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
  tHeSetItemAcUmNavigations?: InputMaybe<ListFilterInputTypeOfTHeSetItemFilterInput>;
  tHfWoexItemAcUm3Navigations?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHfWoexItemAcUmNavigations?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
  tHfWoexes?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
};

export type THeSetUmSortInput = {
  acFiscalCode?: InputMaybe<SortEnumType>;
  acInterUm?: InputMaybe<SortEnumType>;
  acInterUm2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acStdUm?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUmoriginal?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDecPlaces?: InputMaybe<SortEnumType>;
  anMinValue?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THeStock = {
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acWarehouse?: Maybe<Scalars['String']>;
  acWarehouseNavigation?: Maybe<THeSetSubj>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLastPrice: Scalars['Float'];
  anMaxStock: Scalars['Decimal'];
  anMinStock: Scalars['Decimal'];
  anOptStock: Scalars['Decimal'];
  anQid: Scalars['Int'];
  anReserved: Scalars['Decimal'];
  anStock: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Float'];
};

export type THeStockFilterInput = {
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  acWarehouseNavigation?: InputMaybe<THeSetSubjFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLastPrice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anMaxStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anMinStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anOptStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anReserved?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THeStockFilterInput>>;
  or?: InputMaybe<Array<THeStockFilterInput>>;
};

/** A connection to a list of items. */
export type THeStockPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeStockPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeStock>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeStockPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeStock>;
};

export type THeStockSerialNo = {
  acFree?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acSerialNo?: Maybe<Scalars['String']>;
  acWarehouse?: Maybe<Scalars['String']>;
  adDateDue: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anReserved: Scalars['Decimal'];
  anStock: Scalars['Decimal'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THeStockSerialNoFilterInput = {
  acFree?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acWarehouse?: InputMaybe<StringOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anReserved?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anStock?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeStockSerialNoFilterInput>>;
  or?: InputMaybe<Array<THeStockSerialNoFilterInput>>;
};

export type THeStockSerialNoSortInput = {
  acFree?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acSerialNo?: InputMaybe<SortEnumType>;
  acWarehouse?: InputMaybe<SortEnumType>;
  adDateDue?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anReserved?: InputMaybe<SortEnumType>;
  anStock?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type THeStockSerialNosPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeStockSerialNosPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeStockSerialNosPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeStockSerialNo>;
};

/** A connection to a list of items. */
export type THeStockSerialNosPagedParametrizedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THeStockSerialNosPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeStockSerialNo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THeStockSerialNosPagedParametrizedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeStockSerialNo>;
};

export type THeStockSortInput = {
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acWarehouse?: InputMaybe<SortEnumType>;
  acWarehouseNavigation?: InputMaybe<THeSetSubjSortInput>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anLastPrice?: InputMaybe<SortEnumType>;
  anMaxStock?: InputMaybe<SortEnumType>;
  anMinStock?: InputMaybe<SortEnumType>;
  anOptStock?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anReserved?: InputMaybe<SortEnumType>;
  anStock?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValue?: InputMaybe<SortEnumType>;
};

export type THeSubjType = {
  acSubjType?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQId: Scalars['Int'];
  anSortNo?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  subjTypeNavigation?: Maybe<THeSetSubjType>;
  subject?: Maybe<THeSetSubj>;
};

export type THeSubjTypeFilterInput = {
  acSubjType?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anSortNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THeSubjTypeFilterInput>>;
  or?: InputMaybe<Array<THeSubjTypeFilterInput>>;
  subjTypeNavigation?: InputMaybe<THeSetSubjTypeFilterInput>;
  subject?: InputMaybe<THeSetSubjFilterInput>;
};

export type THfPlan = {
  acConsignee?: Maybe<Scalars['String']>;
  acConsigneeNavigation?: Maybe<THeSetSubj>;
  acCostDrv?: Maybe<Scalars['String']>;
  acCostDrvNavigation?: Maybe<THeCostDrv>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acDescr?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeNavigation?: Maybe<TPaSetDocType>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acParentPlan?: Maybe<Scalars['String']>;
  acParentPlanNavigation?: Maybe<THfPlan>;
  acPlannedBom?: Maybe<Scalars['String']>;
  acPlannedCap?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverNavigation?: Maybe<THeSetSubj>;
  acScheduled?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adPlannedBomtime?: Maybe<Scalars['DateTime']>;
  adPlannedCapTime?: Maybe<Scalars['DateTime']>;
  adSchedEndTime?: Maybe<Scalars['DateTime']>;
  adSchedStartTime?: Maybe<Scalars['DateTime']>;
  adScheduledTime?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk: Scalars['Int'];
  anClerkNavigation?: Maybe<THeSetSubjContact>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  inverseAcParentPlanNavigation?: Maybe<Array<Maybe<THfPlan>>>;
  tHfWoexes?: Maybe<Array<Maybe<THfWoex>>>;
};

export type THfPlanFilterInput = {
  acConsignee?: InputMaybe<StringOperationFilterInput>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acCostDrvNavigation?: InputMaybe<THeCostDrvFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acParentPlan?: InputMaybe<StringOperationFilterInput>;
  acParentPlanNavigation?: InputMaybe<THfPlanFilterInput>;
  acPlannedBom?: InputMaybe<StringOperationFilterInput>;
  acPlannedCap?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acScheduled?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPlannedBomtime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adPlannedCapTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedEndTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedStartTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adScheduledTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClerk?: InputMaybe<ComparableInt32OperationFilterInput>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THfPlanFilterInput>>;
  inverseAcParentPlanNavigation?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  or?: InputMaybe<Array<THfPlanFilterInput>>;
  tHfWoexes?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
};

export type THfPlanSortInput = {
  acConsignee?: InputMaybe<SortEnumType>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjSortInput>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acCostDrvNavigation?: InputMaybe<THeCostDrvSortInput>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDescr?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyView?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acParentPlan?: InputMaybe<SortEnumType>;
  acParentPlanNavigation?: InputMaybe<THfPlanSortInput>;
  acPlannedBom?: InputMaybe<SortEnumType>;
  acPlannedCap?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverNavigation?: InputMaybe<THeSetSubjSortInput>;
  acScheduled?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adPlannedBomtime?: InputMaybe<SortEnumType>;
  adPlannedCapTime?: InputMaybe<SortEnumType>;
  adSchedEndTime?: InputMaybe<SortEnumType>;
  adSchedStartTime?: InputMaybe<SortEnumType>;
  adScheduledTime?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anClerkNavigation?: InputMaybe<THeSetSubjContactSortInput>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THfWoex = {
  acBuyOrdId?: Maybe<Scalars['String']>;
  acConsignee?: Maybe<Scalars['String']>;
  acConsigneeNavigation?: Maybe<THeSetSubj>;
  acCostDrv?: Maybe<Scalars['String']>;
  acCostDrvNavigation?: Maybe<THeCostDrv>;
  acCreateFrom?: Maybe<Scalars['String']>;
  acCropType?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDeptNavigation?: Maybe<THeSetSubj>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeNavigation?: Maybe<TPaSetDocType>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acLnkPrStIdentParent?: Maybe<Scalars['String']>;
  acLnkPrStIdentParentNavigation?: Maybe<THeSetItem>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acParentWo?: Maybe<Scalars['String']>;
  acPlan?: Maybe<THfPlan>;
  acPlanId?: Maybe<Scalars['String']>;
  acProdVariant?: Maybe<Scalars['String']>;
  acReceiveFinished?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverNavigation?: Maybe<THeSetSubj>;
  acReversal?: Maybe<Scalars['String']>;
  acScrapIdent?: Maybe<Scalars['String']>;
  acScrapIdentNavigation?: Maybe<THeSetItem>;
  acStatus?: Maybe<Scalars['String']>;
  acStatusMf?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUmNavigation?: Maybe<THeSetUm>;
  adDate?: Maybe<Scalars['DateTime']>;
  adLnkDate?: Maybe<Scalars['DateTime']>;
  adSchedEndTime?: Maybe<Scalars['DateTime']>;
  adSchedStartTime?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  adWofinishDate?: Maybe<Scalars['DateTime']>;
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anLnkNo?: Maybe<Scalars['Int']>;
  anLnkPrStNo?: Maybe<Scalars['Int']>;
  anLnkPrStNoParent?: Maybe<Scalars['Int']>;
  anLnkPrStSubNo?: Maybe<Scalars['Int']>;
  anNo?: Maybe<Scalars['Int']>;
  anParentWoqty?: Maybe<Scalars['Decimal']>;
  anPlanQty?: Maybe<Scalars['Decimal']>;
  anPlanScrapQty?: Maybe<Scalars['Decimal']>;
  anPlanWasteQty?: Maybe<Scalars['Decimal']>;
  anPriority: Scalars['Byte'];
  anProducedQty?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQidCa?: Maybe<Scalars['Int']>;
  anQtySeries?: Maybe<Scalars['Decimal']>;
  anRepairQty?: Maybe<Scalars['Float']>;
  anScrapQty?: Maybe<Scalars['Decimal']>;
  anSntransfer?: Maybe<Scalars['Byte']>;
  anThroTime?: Maybe<Scalars['Float']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWasteQty?: Maybe<Scalars['Decimal']>;
  anWorkTime?: Maybe<Scalars['Float']>;
  tHfWoexItems?: Maybe<Array<Maybe<THfWoexItem>>>;
};

export type THfWoexFilterInput = {
  acBuyOrdId?: InputMaybe<StringOperationFilterInput>;
  acConsignee?: InputMaybe<StringOperationFilterInput>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acCostDrvNavigation?: InputMaybe<THeCostDrvFilterInput>;
  acCreateFrom?: InputMaybe<StringOperationFilterInput>;
  acCropType?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acLnkPrStIdentParent?: InputMaybe<StringOperationFilterInput>;
  acLnkPrStIdentParentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acParentWo?: InputMaybe<StringOperationFilterInput>;
  acPlan?: InputMaybe<THfPlanFilterInput>;
  acPlanId?: InputMaybe<StringOperationFilterInput>;
  acProdVariant?: InputMaybe<StringOperationFilterInput>;
  acReceiveFinished?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acReversal?: InputMaybe<StringOperationFilterInput>;
  acScrapIdent?: InputMaybe<StringOperationFilterInput>;
  acScrapIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acStatusMf?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUmNavigation?: InputMaybe<THeSetUmFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adLnkDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedEndTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedStartTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adWofinishDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLnkPrStNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLnkPrStNoParent?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLnkPrStSubNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anParentWoqty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPlanQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPlanScrapQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPlanWasteQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPriority?: InputMaybe<ComparableByteOperationFilterInput>;
  anProducedQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQidCa?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQtySeries?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRepairQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anScrapQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anSntransfer?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anThroTime?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWasteQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anWorkTime?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THfWoexFilterInput>>;
  or?: InputMaybe<Array<THfWoexFilterInput>>;
  tHfWoexItems?: InputMaybe<ListFilterInputTypeOfTHfWoexItemFilterInput>;
};

export type THfWoexItem = {
  acAgriculturalReason?: Maybe<Scalars['String']>;
  acAutoPrepType?: Maybe<Scalars['String']>;
  acDelayType?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFixedResource?: Maybe<Scalars['String']>;
  acFixedTime?: Maybe<Scalars['String']>;
  acGroupResursId?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acIssueFinished?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerNavigation?: Maybe<THeSetSubj>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THfWoex>;
  acKeyView?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acOperationType?: Maybe<Scalars['String']>;
  acOrigin?: Maybe<Scalars['String']>;
  acPhenologicalPhase?: Maybe<Scalars['String']>;
  acQtyFormula?: Maybe<Scalars['String']>;
  acRuleId?: Maybe<Scalars['String']>;
  acScrapIdent?: Maybe<Scalars['String']>;
  acScrapIdentNavigation?: Maybe<THeSetItem>;
  acTaskState?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  acUm3?: Maybe<Scalars['String']>;
  acUm3Navigation?: Maybe<THeSetUm>;
  acUmNavigation?: Maybe<THeSetUm>;
  acUmtime?: Maybe<Scalars['String']>;
  adEarliestStartTime?: Maybe<Scalars['DateTime']>;
  adLatestEndTime?: Maybe<Scalars['DateTime']>;
  adSchedEndTime?: Maybe<Scalars['DateTime']>;
  adSchedStartTime?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anActive?: Maybe<Scalars['Byte']>;
  anBatch?: Maybe<Scalars['Float']>;
  anDelayQty?: Maybe<Scalars['Float']>;
  anFieldNa?: Maybe<Scalars['Float']>;
  anFieldNax?: Maybe<Scalars['Float']>;
  anFieldNb?: Maybe<Scalars['Float']>;
  anFieldNc?: Maybe<Scalars['Float']>;
  anFixedScrapQty: Scalars['Float'];
  anFixedWasteQty: Scalars['Float'];
  anNo: Scalars['Int'];
  anPlanQty: Scalars['Float'];
  anPlanScrapQty?: Maybe<Scalars['Float']>;
  anPlanWasteQty?: Maybe<Scalars['Float']>;
  anPrcValue?: Maybe<Scalars['Float']>;
  anPrice?: Maybe<Scalars['Float']>;
  anQid: Scalars['Int'];
  anQidFertType?: Maybe<Scalars['Int']>;
  anQty?: Maybe<Scalars['Float']>;
  anQty1?: Maybe<Scalars['Float']>;
  anQty3?: Maybe<Scalars['Float']>;
  anQtyBase?: Maybe<Scalars['Int']>;
  anQtyBase3?: Maybe<Scalars['Int']>;
  anQtySe?: Maybe<Scalars['Float']>;
  anRebate?: Maybe<Scalars['Float']>;
  anScrapPrc?: Maybe<Scalars['Float']>;
  anScrapQty?: Maybe<Scalars['Float']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anVariant: Scalars['Byte'];
  anVariantSubLvl?: Maybe<Scalars['Byte']>;
  anWastePrc?: Maybe<Scalars['Float']>;
  anWasteQty?: Maybe<Scalars['Float']>;
  anWasteQtySe?: Maybe<Scalars['Float']>;
  tHfWoexItemSerialNos?: Maybe<Array<Maybe<THfWoexItemSerialNo>>>;
};

export type THfWoexItemFilterInput = {
  acAgriculturalReason?: InputMaybe<StringOperationFilterInput>;
  acAutoPrepType?: InputMaybe<StringOperationFilterInput>;
  acDelayType?: InputMaybe<StringOperationFilterInput>;
  acDescr?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFixedResource?: InputMaybe<StringOperationFilterInput>;
  acFixedTime?: InputMaybe<StringOperationFilterInput>;
  acGroupResursId?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acIssueFinished?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerNavigation?: InputMaybe<THeSetSubjFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THfWoexFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acOperationType?: InputMaybe<StringOperationFilterInput>;
  acOrigin?: InputMaybe<StringOperationFilterInput>;
  acPhenologicalPhase?: InputMaybe<StringOperationFilterInput>;
  acQtyFormula?: InputMaybe<StringOperationFilterInput>;
  acRuleId?: InputMaybe<StringOperationFilterInput>;
  acScrapIdent?: InputMaybe<StringOperationFilterInput>;
  acScrapIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acTaskState?: InputMaybe<StringOperationFilterInput>;
  acUm?: InputMaybe<StringOperationFilterInput>;
  acUm3?: InputMaybe<StringOperationFilterInput>;
  acUm3Navigation?: InputMaybe<THeSetUmFilterInput>;
  acUmNavigation?: InputMaybe<THeSetUmFilterInput>;
  acUmtime?: InputMaybe<StringOperationFilterInput>;
  adEarliestStartTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adLatestEndTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedEndTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSchedStartTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anActive?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anBatch?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anDelayQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFieldNax?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFixedScrapQty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anFixedWasteQty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPlanQty?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anPlanScrapQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPlanWasteQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrcValue?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPrice?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQidFertType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anQty1?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anQty3?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anQtyBase?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQtyBase3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQtySe?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anRebate?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anScrapPrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anScrapQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anVariant?: InputMaybe<ComparableByteOperationFilterInput>;
  anVariantSubLvl?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anWastePrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anWasteQty?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anWasteQtySe?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  and?: InputMaybe<Array<THfWoexItemFilterInput>>;
  or?: InputMaybe<Array<THfWoexItemFilterInput>>;
  tHfWoexItemSerialNos?: InputMaybe<ListFilterInputTypeOfTHfWoexItemSerialNoFilterInput>;
};

export type THfWoexItemSerialNo = {
  a?: Maybe<THfWoexItem>;
  acIdent?: Maybe<Scalars['String']>;
  acIdentNavigation?: Maybe<THeSetItem>;
  acKey?: Maybe<Scalars['String']>;
  acPackage?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSnwotype?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adDateDue: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anMultiIssueId: Scalars['Int'];
  anNo: Scalars['Int'];
  anPackQty?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anQty: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THfWoexItemSerialNoFilterInput = {
  a?: InputMaybe<THfWoexItemFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acIdentNavigation?: InputMaybe<THeSetItemFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acPackage?: InputMaybe<StringOperationFilterInput>;
  acSerialNo?: InputMaybe<StringOperationFilterInput>;
  acSnwotype?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anMultiIssueId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPackQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THfWoexItemSerialNoFilterInput>>;
  or?: InputMaybe<Array<THfWoexItemSerialNoFilterInput>>;
};

export type THfWoexItemSortInput = {
  acAgriculturalReason?: InputMaybe<SortEnumType>;
  acAutoPrepType?: InputMaybe<SortEnumType>;
  acDelayType?: InputMaybe<SortEnumType>;
  acDescr?: InputMaybe<SortEnumType>;
  acFieldSa?: InputMaybe<SortEnumType>;
  acFieldSb?: InputMaybe<SortEnumType>;
  acFieldSc?: InputMaybe<SortEnumType>;
  acFieldSd?: InputMaybe<SortEnumType>;
  acFieldSe?: InputMaybe<SortEnumType>;
  acFixedResource?: InputMaybe<SortEnumType>;
  acFixedTime?: InputMaybe<SortEnumType>;
  acGroupResursId?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acIssueFinished?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerNavigation?: InputMaybe<THeSetSubjSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyNavigation?: InputMaybe<THfWoexSortInput>;
  acKeyView?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acOperationType?: InputMaybe<SortEnumType>;
  acOrigin?: InputMaybe<SortEnumType>;
  acPhenologicalPhase?: InputMaybe<SortEnumType>;
  acQtyFormula?: InputMaybe<SortEnumType>;
  acRuleId?: InputMaybe<SortEnumType>;
  acScrapIdent?: InputMaybe<SortEnumType>;
  acScrapIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acTaskState?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUm3?: InputMaybe<SortEnumType>;
  acUm3Navigation?: InputMaybe<THeSetUmSortInput>;
  acUmNavigation?: InputMaybe<THeSetUmSortInput>;
  acUmtime?: InputMaybe<SortEnumType>;
  adEarliestStartTime?: InputMaybe<SortEnumType>;
  adLatestEndTime?: InputMaybe<SortEnumType>;
  adSchedEndTime?: InputMaybe<SortEnumType>;
  adSchedStartTime?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anActive?: InputMaybe<SortEnumType>;
  anBatch?: InputMaybe<SortEnumType>;
  anDelayQty?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anFieldNax?: InputMaybe<SortEnumType>;
  anFieldNb?: InputMaybe<SortEnumType>;
  anFieldNc?: InputMaybe<SortEnumType>;
  anFixedScrapQty?: InputMaybe<SortEnumType>;
  anFixedWasteQty?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anPlanQty?: InputMaybe<SortEnumType>;
  anPlanScrapQty?: InputMaybe<SortEnumType>;
  anPlanWasteQty?: InputMaybe<SortEnumType>;
  anPrcValue?: InputMaybe<SortEnumType>;
  anPrice?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQidFertType?: InputMaybe<SortEnumType>;
  anQty?: InputMaybe<SortEnumType>;
  anQty1?: InputMaybe<SortEnumType>;
  anQty3?: InputMaybe<SortEnumType>;
  anQtyBase?: InputMaybe<SortEnumType>;
  anQtyBase3?: InputMaybe<SortEnumType>;
  anQtySe?: InputMaybe<SortEnumType>;
  anRebate?: InputMaybe<SortEnumType>;
  anScrapPrc?: InputMaybe<SortEnumType>;
  anScrapQty?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anVariant?: InputMaybe<SortEnumType>;
  anVariantSubLvl?: InputMaybe<SortEnumType>;
  anWastePrc?: InputMaybe<SortEnumType>;
  anWasteQty?: InputMaybe<SortEnumType>;
  anWasteQtySe?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type THfWoexPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THfWoexPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THfWoex>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THfWoexPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THfWoex>;
};

/** A connection to a list of items. */
export type THfWoexPagedParametrizedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THfWoexPagedParametrizedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THfWoex>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THfWoexPagedParametrizedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THfWoex>;
};

export enum THfWoexPagedSortField {
  AcConsignee = 'AC_CONSIGNEE',
  AcDept = 'AC_DEPT',
  AcDocType = 'AC_DOC_TYPE',
  AcIdent = 'AC_IDENT',
  AcKey = 'AC_KEY',
  AcNote = 'AC_NOTE',
  AcReceiver = 'AC_RECEIVER',
  AcScrapIdent = 'AC_SCRAP_IDENT',
  AcStatus = 'AC_STATUS',
  AdDate = 'AD_DATE',
  AdSchedEndTime = 'AD_SCHED_END_TIME',
  AdSchedStartTime = 'AD_SCHED_START_TIME',
  AdWofinishDate = 'AD_WOFINISH_DATE',
  AnPriority = 'AN_PRIORITY'
}

export type THfWoexSortInput = {
  acBuyOrdId?: InputMaybe<SortEnumType>;
  acConsignee?: InputMaybe<SortEnumType>;
  acConsigneeNavigation?: InputMaybe<THeSetSubjSortInput>;
  acCostDrv?: InputMaybe<SortEnumType>;
  acCostDrvNavigation?: InputMaybe<THeCostDrvSortInput>;
  acCreateFrom?: InputMaybe<SortEnumType>;
  acCropType?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acDeptNavigation?: InputMaybe<THeSetSubjSortInput>;
  acDocType?: InputMaybe<SortEnumType>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeSortInput>;
  acIdent?: InputMaybe<SortEnumType>;
  acIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acKey?: InputMaybe<SortEnumType>;
  acKeyView?: InputMaybe<SortEnumType>;
  acLnkKey?: InputMaybe<SortEnumType>;
  acLnkPrStIdentParent?: InputMaybe<SortEnumType>;
  acLnkPrStIdentParentNavigation?: InputMaybe<THeSetItemSortInput>;
  acName?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acParentWo?: InputMaybe<SortEnumType>;
  acPlan?: InputMaybe<THfPlanSortInput>;
  acPlanId?: InputMaybe<SortEnumType>;
  acProdVariant?: InputMaybe<SortEnumType>;
  acReceiveFinished?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverNavigation?: InputMaybe<THeSetSubjSortInput>;
  acReversal?: InputMaybe<SortEnumType>;
  acScrapIdent?: InputMaybe<SortEnumType>;
  acScrapIdentNavigation?: InputMaybe<THeSetItemSortInput>;
  acStatus?: InputMaybe<SortEnumType>;
  acStatusMf?: InputMaybe<SortEnumType>;
  acUm?: InputMaybe<SortEnumType>;
  acUmNavigation?: InputMaybe<THeSetUmSortInput>;
  adDate?: InputMaybe<SortEnumType>;
  adLnkDate?: InputMaybe<SortEnumType>;
  adSchedEndTime?: InputMaybe<SortEnumType>;
  adSchedStartTime?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  adWofinishDate?: InputMaybe<SortEnumType>;
  anFieldNa?: InputMaybe<SortEnumType>;
  anLnkNo?: InputMaybe<SortEnumType>;
  anLnkPrStNo?: InputMaybe<SortEnumType>;
  anLnkPrStNoParent?: InputMaybe<SortEnumType>;
  anLnkPrStSubNo?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  anParentWoqty?: InputMaybe<SortEnumType>;
  anPlanQty?: InputMaybe<SortEnumType>;
  anPlanScrapQty?: InputMaybe<SortEnumType>;
  anPlanWasteQty?: InputMaybe<SortEnumType>;
  anPriority?: InputMaybe<SortEnumType>;
  anProducedQty?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anQidCa?: InputMaybe<SortEnumType>;
  anQtySeries?: InputMaybe<SortEnumType>;
  anRepairQty?: InputMaybe<SortEnumType>;
  anScrapQty?: InputMaybe<SortEnumType>;
  anSntransfer?: InputMaybe<SortEnumType>;
  anThroTime?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anWasteQty?: InputMaybe<SortEnumType>;
  anWorkTime?: InputMaybe<SortEnumType>;
};

export type THrLinkTrvlTrvl = {
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THrTrvl>;
  acLnkKey?: Maybe<Scalars['String']>;
  acLnkKeyNavigation?: Maybe<THrTrvl>;
  acType?: Maybe<Scalars['String']>;
  acTypeA?: Maybe<Scalars['String']>;
  acTypeB?: Maybe<Scalars['String']>;
  acValue?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anFieldNa: Scalars['Float'];
  anFieldNb: Scalars['Float'];
  anLnkNo: Scalars['Int'];
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THrLinkTrvlTrvlFilterInput = {
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THrTrvlFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKeyNavigation?: InputMaybe<THrTrvlFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeA?: InputMaybe<StringOperationFilterInput>;
  acTypeB?: InputMaybe<StringOperationFilterInput>;
  acValue?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anLnkNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrLinkTrvlTrvlFilterInput>>;
  or?: InputMaybe<Array<THrLinkTrvlTrvlFilterInput>>;
};

export type THrPrsn = {
  acActive?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acRegNo?: Maybe<Scalars['String']>;
  acSurname?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  acWorkerNavigation?: Maybe<THeSetSubj>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHrPrsnStatuses?: Maybe<Array<Maybe<THrPrsnStatus>>>;
  tHrTrvls?: Maybe<Array<Maybe<THrTrvl>>>;
};

export type THrPrsnFilterInput = {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acRegNo?: InputMaybe<StringOperationFilterInput>;
  acSurname?: InputMaybe<StringOperationFilterInput>;
  acWorker?: InputMaybe<StringOperationFilterInput>;
  acWorkerNavigation?: InputMaybe<THeSetSubjFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrPrsnFilterInput>>;
  or?: InputMaybe<Array<THrPrsnFilterInput>>;
  tHrPrsnStatuses?: InputMaybe<ListFilterInputTypeOfTHrPrsnStatusFilterInput>;
  tHrTrvls?: InputMaybe<ListFilterInputTypeOfTHrTrvlFilterInput>;
};

/** A connection to a list of items. */
export type THrPrsnPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<THrPrsnPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THrPrsn>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type THrPrsnPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THrPrsn>;
};

export type THrPrsnSortInput = {
  acActive?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acRegNo?: InputMaybe<SortEnumType>;
  acSurname?: InputMaybe<SortEnumType>;
  acWorker?: InputMaybe<SortEnumType>;
  acWorkerNavigation?: InputMaybe<THeSetSubjSortInput>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type THrPrsnStatus = {
  acStatus?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  acWorkerNavigation?: Maybe<THrPrsn>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type THrPrsnStatusFilterInput = {
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acWorker?: InputMaybe<StringOperationFilterInput>;
  acWorkerNavigation?: InputMaybe<THrPrsnFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrPrsnStatusFilterInput>>;
  or?: InputMaybe<Array<THrPrsnStatusFilterInput>>;
};

export type THrTrvl = {
  acApproved?: Maybe<Scalars['String']>;
  acBnkAcctType?: Maybe<Scalars['String']>;
  acCarRegNo?: Maybe<Scalars['String']>;
  acCode1?: Maybe<Scalars['String']>;
  acCode2?: Maybe<Scalars['String']>;
  acCode3?: Maybe<Scalars['String']>;
  acCompanyCar?: Maybe<Scalars['String']>;
  acConfrm?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acForeignDoc?: Maybe<Scalars['String']>;
  acInsertedFrom?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acPayer?: Maybe<Scalars['String']>;
  acPlaceFinish?: Maybe<Scalars['String']>;
  acPlaceStart?: Maybe<Scalars['String']>;
  acPosted?: Maybe<Scalars['String']>;
  acPrivatCar?: Maybe<Scalars['String']>;
  acRefNo1?: Maybe<Scalars['String']>;
  acRefNo2?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acSumHours?: Maybe<Scalars['String']>;
  acUpnRfcode?: Maybe<Scalars['String']>;
  acUpnRfcodeA?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  acVersion?: Maybe<Scalars['String']>;
  acViacle?: Maybe<Scalars['String']>;
  acViacleType?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  acWorkerNavigation?: Maybe<THrPrsn>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateCalc?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anApprovedBy: Scalars['Int'];
  anBnkAcctNo?: Maybe<Scalars['Int']>;
  anBnkAcctNoComp?: Maybe<Scalars['Int']>;
  anIrisShow?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anTrvl01?: Maybe<Scalars['Decimal']>;
  anTrvl02?: Maybe<Scalars['Decimal']>;
  anTrvl03?: Maybe<Scalars['Decimal']>;
  anTrvl04?: Maybe<Scalars['Decimal']>;
  anTrvl05?: Maybe<Scalars['Decimal']>;
  anTrvl06?: Maybe<Scalars['Decimal']>;
  anTrvl07?: Maybe<Scalars['Decimal']>;
  anTrvl08?: Maybe<Scalars['Decimal']>;
  anTrvl09?: Maybe<Scalars['Decimal']>;
  anTrvl10?: Maybe<Scalars['Decimal']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anjobId?: Maybe<Scalars['Int']>;
  tHrLinkTrvlTrvlAcKeyNavigations?: Maybe<Array<Maybe<THrLinkTrvlTrvl>>>;
  tHrLinkTrvlTrvlAcLnkKeyNavigations?: Maybe<Array<Maybe<THrLinkTrvlTrvl>>>;
  tHrTrvlItems?: Maybe<Array<Maybe<THrTrvlItem>>>;
};

export type THrTrvlFilterInput = {
  acApproved?: InputMaybe<StringOperationFilterInput>;
  acBnkAcctType?: InputMaybe<StringOperationFilterInput>;
  acCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acCode1?: InputMaybe<StringOperationFilterInput>;
  acCode2?: InputMaybe<StringOperationFilterInput>;
  acCode3?: InputMaybe<StringOperationFilterInput>;
  acCompanyCar?: InputMaybe<StringOperationFilterInput>;
  acConfrm?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acForeignDoc?: InputMaybe<StringOperationFilterInput>;
  acInsertedFrom?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acPayer?: InputMaybe<StringOperationFilterInput>;
  acPlaceFinish?: InputMaybe<StringOperationFilterInput>;
  acPlaceStart?: InputMaybe<StringOperationFilterInput>;
  acPosted?: InputMaybe<StringOperationFilterInput>;
  acPrivatCar?: InputMaybe<StringOperationFilterInput>;
  acRefNo1?: InputMaybe<StringOperationFilterInput>;
  acRefNo2?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acSumHours?: InputMaybe<StringOperationFilterInput>;
  acUpnRfcode?: InputMaybe<StringOperationFilterInput>;
  acUpnRfcodeA?: InputMaybe<StringOperationFilterInput>;
  acVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  acVersion?: InputMaybe<StringOperationFilterInput>;
  acViacle?: InputMaybe<StringOperationFilterInput>;
  acViacleType?: InputMaybe<StringOperationFilterInput>;
  acWorker?: InputMaybe<StringOperationFilterInput>;
  acWorkerNavigation?: InputMaybe<THrPrsnFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateCalc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anApprovedBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  anBnkAcctNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anBnkAcctNoComp?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anIrisShow?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTrvl01?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl02?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl03?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl04?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl05?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl06?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl07?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl08?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl09?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anTrvl10?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrTrvlFilterInput>>;
  anjobId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<THrTrvlFilterInput>>;
  tHrLinkTrvlTrvlAcKeyNavigations?: InputMaybe<ListFilterInputTypeOfTHrLinkTrvlTrvlFilterInput>;
  tHrLinkTrvlTrvlAcLnkKeyNavigations?: InputMaybe<ListFilterInputTypeOfTHrLinkTrvlTrvlFilterInput>;
  tHrTrvlItems?: InputMaybe<ListFilterInputTypeOfTHrTrvlItemFilterInput>;
};

export type THrTrvlItem = {
  acBreakfast?: Maybe<Scalars['String']>;
  acCarRegNo?: Maybe<Scalars['String']>;
  acCity?: Maybe<Scalars['String']>;
  acCostDrv?: Maybe<Scalars['String']>;
  acCountry?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acCurrencyKm?: Maybe<Scalars['String']>;
  acDailyAllow?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDinner?: Maybe<Scalars['String']>;
  acGeoJson?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THrTrvl>;
  acLocoDriving?: Maybe<Scalars['String']>;
  acLunch?: Maybe<Scalars['String']>;
  acNotInCurrency?: Maybe<Scalars['String']>;
  acNotInCurrencyKm?: Maybe<Scalars['String']>;
  acOrder?: Maybe<Scalars['String']>;
  acPost?: Maybe<Scalars['String']>;
  acRetNote?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acSuppCarRegNo?: Maybe<Scalars['String']>;
  acSuppViacle?: Maybe<Scalars['String']>;
  acViacle?: Maybe<Scalars['String']>;
  adDateHourFrom?: Maybe<Scalars['DateTime']>;
  adDateHourTo?: Maybe<Scalars['DateTime']>;
  anDayAllowNo?: Maybe<Scalars['Float']>;
  anFxrate?: Maybe<Scalars['Decimal']>;
  anFxrateKm?: Maybe<Scalars['Decimal']>;
  anKm?: Maybe<Scalars['Int']>;
  anKmcounterAfter?: Maybe<Scalars['Int']>;
  anKmcounterBefore?: Maybe<Scalars['Int']>;
  anLimitPriceKm?: Maybe<Scalars['Int']>;
  anNo: Scalars['Int'];
  anPrice500Km?: Maybe<Scalars['Decimal']>;
  anPriceDailyAllow?: Maybe<Scalars['Float']>;
  anPriceFieldBonus?: Maybe<Scalars['Float']>;
  anPriceKm?: Maybe<Scalars['Decimal']>;
  anQid?: Maybe<Scalars['Int']>;
  tHrTrvlItemExps?: Maybe<Array<Maybe<THrTrvlItemExpWithAttachment>>>;
};

export type THrTrvlItemExpWithAttachment = {
  a?: Maybe<THrTrvlItem>;
  acAcctDb?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acIrek?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acLinkDoc?: Maybe<Scalars['String']>;
  acNotForPayment?: Maybe<Scalars['String']>;
  acNotInCurrency?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  adDateCost?: Maybe<Scalars['DateTime']>;
  anCostNo: Scalars['Int'];
  anFxrate?: Maybe<Scalars['Decimal']>;
  anNo: Scalars['Int'];
  anPriceCurrency?: Maybe<Scalars['Decimal']>;
  anQid: Scalars['Int'];
  anType?: Maybe<Scalars['Int']>;
};

export type THrTrvlItemExpWithAttachmentFilterInput = {
  a?: InputMaybe<THrTrvlItemFilterInput>;
  acAcctDb?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acIrek?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acLinkDoc?: InputMaybe<StringOperationFilterInput>;
  acNotForPayment?: InputMaybe<StringOperationFilterInput>;
  acNotInCurrency?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  adDateCost?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anCostNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFxrate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPriceCurrency?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrTrvlItemExpWithAttachmentFilterInput>>;
  or?: InputMaybe<Array<THrTrvlItemExpWithAttachmentFilterInput>>;
};

export type THrTrvlItemFilterInput = {
  acBreakfast?: InputMaybe<StringOperationFilterInput>;
  acCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acCity?: InputMaybe<StringOperationFilterInput>;
  acCostDrv?: InputMaybe<StringOperationFilterInput>;
  acCountry?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acCurrencyKm?: InputMaybe<StringOperationFilterInput>;
  acDailyAllow?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDinner?: InputMaybe<StringOperationFilterInput>;
  acGeoJson?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THrTrvlFilterInput>;
  acLocoDriving?: InputMaybe<StringOperationFilterInput>;
  acLunch?: InputMaybe<StringOperationFilterInput>;
  acNotInCurrency?: InputMaybe<StringOperationFilterInput>;
  acNotInCurrencyKm?: InputMaybe<StringOperationFilterInput>;
  acOrder?: InputMaybe<StringOperationFilterInput>;
  acPost?: InputMaybe<StringOperationFilterInput>;
  acRetNote?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acSuppCarRegNo?: InputMaybe<StringOperationFilterInput>;
  acSuppViacle?: InputMaybe<StringOperationFilterInput>;
  acViacle?: InputMaybe<StringOperationFilterInput>;
  adDateHourFrom?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateHourTo?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDayAllowNo?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anFxrate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFxrateKm?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anKm?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anKmcounterAfter?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anKmcounterBefore?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLimitPriceKm?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anPrice500Km?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anPriceDailyAllow?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPriceFieldBonus?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anPriceKm?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<THrTrvlItemFilterInput>>;
  or?: InputMaybe<Array<THrTrvlItemFilterInput>>;
  tHrTrvlItemExps?: InputMaybe<ListFilterInputTypeOfTHrTrvlItemExpWithAttachmentFilterInput>;
};

export type TMnDocument = {
  acDeleted?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeNavigation?: Maybe<TPaSetDocType>;
  acGuid: Scalars['UUID'];
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acTitle?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDue?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClassifIcationQ?: Maybe<TMnSetClassification>;
  anClassifIcationQid: Scalars['Int'];
  anClerk?: Maybe<Scalars['Int']>;
  anMailBoxQ?: Maybe<TMnMailbox>;
  anMailBoxQid?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anStorageQ?: Maybe<TMnStorage>;
  anStorageQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnDocumentChatLogs?: Maybe<Array<Maybe<TMnDocumentChatLog>>>;
  tMnDocumentMetaData?: Maybe<Array<Maybe<TMnDocumentMetaDatum>>>;
  tMnFiles?: Maybe<Array<Maybe<TMnFile>>>;
  tMnLinkDocumentsWfs?: Maybe<Array<Maybe<TMnLinkDocumentsWf>>>;
};


export type TMnDocumentTMnDocumentMetaDataArgs = {
  where?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
};


export type TMnDocumentTMnFilesArgs = {
  where?: InputMaybe<TMnFileFilterInput>;
};


export type TMnDocumentTMnLinkDocumentsWfsArgs = {
  where?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
};

export type TMnDocumentChatLog = {
  acMessage?: Maybe<Scalars['String']>;
  adDateCreated: Scalars['DateTime'];
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDocumentQ?: Maybe<TMnDocument>;
  anDocumentQid: Scalars['Int'];
  anQid: Scalars['Int'];
  anUser?: Maybe<THeSetSubjContact>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type TMnDocumentChatLogFilterInput = {
  acMessage?: InputMaybe<StringOperationFilterInput>;
  adDateCreated?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDocumentQ?: InputMaybe<TMnDocumentFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUser?: InputMaybe<THeSetSubjContactFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnDocumentChatLogFilterInput>>;
  or?: InputMaybe<Array<TMnDocumentChatLogFilterInput>>;
};

export type TMnDocumentChatLogSortInput = {
  acMessage?: InputMaybe<SortEnumType>;
  adDateCreated?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDocumentQ?: InputMaybe<TMnDocumentSortInput>;
  anDocumentQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUser?: InputMaybe<THeSetSubjContactSortInput>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TMnDocumentChatLogsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<TMnDocumentChatLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TMnDocumentChatLog>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TMnDocumentChatLogsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TMnDocumentChatLog>;
};

export type TMnDocumentFilterInput = {
  acDeleted?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeFilterInput>;
  acGuid?: InputMaybe<ComparableGuidOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acTitle?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClassifIcationQ?: InputMaybe<TMnSetClassificationFilterInput>;
  anClassifIcationQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anMailBoxQ?: InputMaybe<TMnMailboxFilterInput>;
  anMailBoxQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anStorageQ?: InputMaybe<TMnStorageFilterInput>;
  anStorageQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnDocumentFilterInput>>;
  or?: InputMaybe<Array<TMnDocumentFilterInput>>;
  tMnDocumentChatLogs?: InputMaybe<ListFilterInputTypeOfTMnDocumentChatLogFilterInput>;
  tMnDocumentMetaData?: InputMaybe<ListFilterInputTypeOfTMnDocumentMetaDatumFilterInput>;
  tMnFiles?: InputMaybe<ListFilterInputTypeOfTMnFileFilterInput>;
  tMnLinkDocumentsWfs?: InputMaybe<ListFilterInputTypeOfTMnLinkDocumentsWfFilterInput>;
};

export type TMnDocumentMetaDatum = {
  acValue?: Maybe<Scalars['String']>;
  acValue2?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClassificationMetaQ?: Maybe<TMnSetClassificationMetaDatum>;
  anClassificationMetaQid: Scalars['Int'];
  anDocumentQ?: Maybe<TMnDocument>;
  anDocumentQid: Scalars['Int'];
  anQid: Scalars['Int'];
  anTaskInst?: Maybe<TPaWorkflowTaskInstance>;
  anTaskInstId?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type TMnDocumentMetaDatumFilterInput = {
  acValue?: InputMaybe<StringOperationFilterInput>;
  acValue2?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClassificationMetaQ?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
  anClassificationMetaQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDocumentQ?: InputMaybe<TMnDocumentFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTaskInst?: InputMaybe<TPaWorkflowTaskInstanceFilterInput>;
  anTaskInstId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnDocumentMetaDatumFilterInput>>;
  or?: InputMaybe<Array<TMnDocumentMetaDatumFilterInput>>;
};

export type TMnDocumentMetaDatumSortInput = {
  acValue?: InputMaybe<SortEnumType>;
  acValue2?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClassificationMetaQ?: InputMaybe<TMnSetClassificationMetaDatumSortInput>;
  anClassificationMetaQid?: InputMaybe<SortEnumType>;
  anDocumentQ?: InputMaybe<TMnDocumentSortInput>;
  anDocumentQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anTaskInst?: InputMaybe<TPaWorkflowTaskInstanceSortInput>;
  anTaskInstId?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type TMnDocumentSortInput = {
  acDeleted?: InputMaybe<SortEnumType>;
  acDocType?: InputMaybe<SortEnumType>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeSortInput>;
  acGuid?: InputMaybe<SortEnumType>;
  acKey?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acTitle?: InputMaybe<SortEnumType>;
  adDate?: InputMaybe<SortEnumType>;
  adDateDue?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClassifIcationQ?: InputMaybe<TMnSetClassificationSortInput>;
  anClassifIcationQid?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anMailBoxQ?: InputMaybe<TMnMailboxSortInput>;
  anMailBoxQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anStorageQ?: InputMaybe<TMnStorageSortInput>;
  anStorageQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type TMnDocumentWithStatus = {
  document?: Maybe<TMnDocument>;
  status?: Maybe<TPaSetDocTypeStat>;
};

export type TMnDocumentWithStatusFilterInput = {
  and?: InputMaybe<Array<TMnDocumentWithStatusFilterInput>>;
  document?: InputMaybe<TMnDocumentFilterInput>;
  or?: InputMaybe<Array<TMnDocumentWithStatusFilterInput>>;
  status?: InputMaybe<TPaSetDocTypeStatFilterInput>;
};

export type TMnDocumentWithStatusSortInput = {
  document?: InputMaybe<TMnDocumentSortInput>;
  status?: InputMaybe<TPaSetDocTypeStatSortInput>;
};

/** A connection to a list of items. */
export type TMnDocumentsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<TMnDocumentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TMnDocument>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TMnDocumentsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TMnDocument>;
};

/** A connection to a list of items. */
export type TMnDocumentsWithStatusConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<TMnDocumentsWithStatusEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TMnDocumentWithStatus>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TMnDocumentsWithStatusEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TMnDocumentWithStatus>;
};

export type TMnFile = {
  acFileGuid: Scalars['UUID'];
  acFileName?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDocumentQ?: Maybe<TMnDocument>;
  anDocumentQid: Scalars['Int'];
  anFileSize?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnFileLocal?: Maybe<TMnFileLocal>;
};

export type TMnFileFilterInput = {
  acFileGuid?: InputMaybe<ComparableGuidOperationFilterInput>;
  acFileName?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDocumentQ?: InputMaybe<TMnDocumentFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anFileSize?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnFileFilterInput>>;
  or?: InputMaybe<Array<TMnFileFilterInput>>;
  tMnFileLocal?: InputMaybe<TMnFileLocalFilterInput>;
};

export type TMnFileLocal = {
  externalFileIdentifier?: Maybe<Scalars['String']>;
  onixFileContent?: Maybe<Array<Scalars['Byte']>>;
  onixFileIdentifier: Scalars['UUID'];
  tMnFile?: Maybe<TMnFile>;
  tMnFileId?: Maybe<Scalars['Int']>;
};

export type TMnFileLocalFilterInput = {
  and?: InputMaybe<Array<TMnFileLocalFilterInput>>;
  externalFileIdentifier?: InputMaybe<StringOperationFilterInput>;
  onixFileContent?: InputMaybe<ListComparableByteOperationFilterInput>;
  onixFileIdentifier?: InputMaybe<ComparableGuidOperationFilterInput>;
  or?: InputMaybe<Array<TMnFileLocalFilterInput>>;
  tMnFile?: InputMaybe<TMnFileFilterInput>;
  tMnFileId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type TMnFileLocalSortInput = {
  externalFileIdentifier?: InputMaybe<SortEnumType>;
  onixFileIdentifier?: InputMaybe<SortEnumType>;
  tMnFile?: InputMaybe<TMnFileSortInput>;
  tMnFileId?: InputMaybe<SortEnumType>;
};

export type TMnFileSortInput = {
  acFileGuid?: InputMaybe<SortEnumType>;
  acFileName?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDocumentQ?: InputMaybe<TMnDocumentSortInput>;
  anDocumentQid?: InputMaybe<SortEnumType>;
  anFileSize?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  tMnFileLocal?: InputMaybe<TMnFileLocalSortInput>;
};

/** A connection to a list of items. */
export type TMnFilesConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<TMnFilesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TMnFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TMnFilesEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TMnFile>;
};

export type TMnLinkDocumentsWf = {
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDocumentQ?: Maybe<TMnDocument>;
  anDocumentQid: Scalars['Int'];
  anQid: Scalars['Int'];
  anTaskInst?: Maybe<TPaWorkflowTaskInstance>;
  anTaskInstId: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWorkInstId?: Maybe<Scalars['Int']>;
};

export type TMnLinkDocumentsWfFilterInput = {
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDocumentQ?: InputMaybe<TMnDocumentFilterInput>;
  anDocumentQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTaskInst?: InputMaybe<TPaWorkflowTaskInstanceFilterInput>;
  anTaskInstId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkInstId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnLinkDocumentsWfFilterInput>>;
  or?: InputMaybe<Array<TMnLinkDocumentsWfFilterInput>>;
};

export type TMnMailbox = {
  acDocTypeIssue?: Maybe<Scalars['String']>;
  acDocTypeOrder?: Maybe<Scalars['String']>;
  acGuid: Scalars['UUID'];
  acIcon?: Maybe<Scalars['String']>;
  acIdentify?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClassificationQ?: Maybe<TMnSetClassification>;
  anClassificationQid?: Maybe<Scalars['Int']>;
  anDirection?: Maybe<Scalars['Int']>;
  anLoginsQid?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anTransferId?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnDocuments?: Maybe<Array<Maybe<TMnDocument>>>;
};

export type TMnMailboxFilterInput = {
  acDocTypeIssue?: InputMaybe<StringOperationFilterInput>;
  acDocTypeOrder?: InputMaybe<StringOperationFilterInput>;
  acGuid?: InputMaybe<ComparableGuidOperationFilterInput>;
  acIcon?: InputMaybe<StringOperationFilterInput>;
  acIdentify?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClassificationQ?: InputMaybe<TMnSetClassificationFilterInput>;
  anClassificationQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anDirection?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anLoginsQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTransferId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnMailboxFilterInput>>;
  or?: InputMaybe<Array<TMnMailboxFilterInput>>;
  tMnDocuments?: InputMaybe<ListFilterInputTypeOfTMnDocumentFilterInput>;
};

export type TMnMailboxSortInput = {
  acDocTypeIssue?: InputMaybe<SortEnumType>;
  acDocTypeOrder?: InputMaybe<SortEnumType>;
  acGuid?: InputMaybe<SortEnumType>;
  acIcon?: InputMaybe<SortEnumType>;
  acIdentify?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClassificationQ?: InputMaybe<TMnSetClassificationSortInput>;
  anClassificationQid?: InputMaybe<SortEnumType>;
  anDirection?: InputMaybe<SortEnumType>;
  anLoginsQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anTransferId?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type TMnSetClassification = {
  acDocKind?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acTypeDesc?: Maybe<Scalars['String']>;
  acValidType?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anCbid?: Maybe<Scalars['Int']>;
  anCbtopId?: Maybe<Scalars['Int']>;
  anClerk?: Maybe<Scalars['Int']>;
  anEscalation: Scalars['Int'];
  anQid: Scalars['Int'];
  anStorageQ?: Maybe<TMnStorage>;
  anStorageQid: Scalars['Int'];
  anTop?: Maybe<TMnSetClassification>;
  anTopId?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValidValue?: Maybe<Scalars['Int']>;
  anWorkflowElapsedId?: Maybe<Scalars['Int']>;
  anWorkflowId?: Maybe<Scalars['Int']>;
  inverseAnTop?: Maybe<Array<Maybe<TMnSetClassification>>>;
  tMnDocuments?: Maybe<Array<Maybe<TMnDocument>>>;
  tMnMailboxes?: Maybe<Array<Maybe<TMnMailbox>>>;
  tMnSetClassificationMetaData?: Maybe<Array<Maybe<TMnSetClassificationMetaDatum>>>;
};


export type TMnSetClassificationInverseAnTopArgs = {
  where?: InputMaybe<TMnSetClassificationFilterInput>;
};


export type TMnSetClassificationTMnDocumentsArgs = {
  where?: InputMaybe<TMnDocumentFilterInput>;
};


export type TMnSetClassificationTMnSetClassificationMetaDataArgs = {
  where?: InputMaybe<TMnSetClassificationMetaDatumFilterInput>;
};

export type TMnSetClassificationFilterInput = {
  acDocKind?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acTypeDesc?: InputMaybe<StringOperationFilterInput>;
  acValidType?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anCbid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anCbtopId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anEscalation?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anStorageQ?: InputMaybe<TMnStorageFilterInput>;
  anStorageQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTop?: InputMaybe<TMnSetClassificationFilterInput>;
  anTopId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValidValue?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkflowElapsedId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkflowId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnSetClassificationFilterInput>>;
  inverseAnTop?: InputMaybe<ListFilterInputTypeOfTMnSetClassificationFilterInput>;
  or?: InputMaybe<Array<TMnSetClassificationFilterInput>>;
  tMnDocuments?: InputMaybe<ListFilterInputTypeOfTMnDocumentFilterInput>;
  tMnMailboxes?: InputMaybe<ListFilterInputTypeOfTMnMailboxFilterInput>;
  tMnSetClassificationMetaData?: InputMaybe<ListFilterInputTypeOfTMnSetClassificationMetaDatumFilterInput>;
};

export type TMnSetClassificationMetaDatum = {
  acDefaultValue?: Maybe<Scalars['String']>;
  acDisplayName?: Maybe<Scalars['String']>;
  acDocumentFieldSync?: Maybe<Scalars['String']>;
  acHint?: Maybe<Scalars['String']>;
  acMandatory?: Maybe<Scalars['String']>;
  acSetter?: Maybe<Scalars['String']>;
  acSetterDataType?: Maybe<Scalars['String']>;
  acVarName?: Maybe<Scalars['String']>;
  acVisible?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClassificationQ?: Maybe<TMnSetClassification>;
  anClassificationQid: Scalars['Int'];
  anQid: Scalars['Int'];
  anSequence?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnDocumentMetaData?: Maybe<Array<Maybe<TMnDocumentMetaDatum>>>;
};

export type TMnSetClassificationMetaDatumFilterInput = {
  acDefaultValue?: InputMaybe<StringOperationFilterInput>;
  acDisplayName?: InputMaybe<StringOperationFilterInput>;
  acDocumentFieldSync?: InputMaybe<StringOperationFilterInput>;
  acHint?: InputMaybe<StringOperationFilterInput>;
  acMandatory?: InputMaybe<StringOperationFilterInput>;
  acSetter?: InputMaybe<StringOperationFilterInput>;
  acSetterDataType?: InputMaybe<StringOperationFilterInput>;
  acVarName?: InputMaybe<StringOperationFilterInput>;
  acVisible?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anClassificationQ?: InputMaybe<TMnSetClassificationFilterInput>;
  anClassificationQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anSequence?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnSetClassificationMetaDatumFilterInput>>;
  or?: InputMaybe<Array<TMnSetClassificationMetaDatumFilterInput>>;
  tMnDocumentMetaData?: InputMaybe<ListFilterInputTypeOfTMnDocumentMetaDatumFilterInput>;
};

export type TMnSetClassificationMetaDatumSortInput = {
  acDefaultValue?: InputMaybe<SortEnumType>;
  acDisplayName?: InputMaybe<SortEnumType>;
  acDocumentFieldSync?: InputMaybe<SortEnumType>;
  acHint?: InputMaybe<SortEnumType>;
  acMandatory?: InputMaybe<SortEnumType>;
  acSetter?: InputMaybe<SortEnumType>;
  acSetterDataType?: InputMaybe<SortEnumType>;
  acVarName?: InputMaybe<SortEnumType>;
  acVisible?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anClassificationQ?: InputMaybe<TMnSetClassificationSortInput>;
  anClassificationQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anSequence?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type TMnSetClassificationSortInput = {
  acDocKind?: InputMaybe<SortEnumType>;
  acNote?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acTypeDesc?: InputMaybe<SortEnumType>;
  acValidType?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anCbid?: InputMaybe<SortEnumType>;
  anCbtopId?: InputMaybe<SortEnumType>;
  anClerk?: InputMaybe<SortEnumType>;
  anEscalation?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anStorageQ?: InputMaybe<TMnStorageSortInput>;
  anStorageQid?: InputMaybe<SortEnumType>;
  anTop?: InputMaybe<TMnSetClassificationSortInput>;
  anTopId?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anValidValue?: InputMaybe<SortEnumType>;
  anWorkflowElapsedId?: InputMaybe<SortEnumType>;
  anWorkflowId?: InputMaybe<SortEnumType>;
};

export type TMnStorage = {
  acDescription?: Maybe<Scalars['String']>;
  acGuid: Scalars['UUID'];
  acIdentify?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acUrl?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anLoginsQid?: Maybe<Scalars['Int']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tMnDocuments?: Maybe<Array<Maybe<TMnDocument>>>;
  tMnSetClassifications?: Maybe<Array<Maybe<TMnSetClassification>>>;
};

export type TMnStorageFilterInput = {
  acDescription?: InputMaybe<StringOperationFilterInput>;
  acGuid?: InputMaybe<ComparableGuidOperationFilterInput>;
  acIdentify?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acUrl?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anLoginsQid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TMnStorageFilterInput>>;
  or?: InputMaybe<Array<TMnStorageFilterInput>>;
  tMnDocuments?: InputMaybe<ListFilterInputTypeOfTMnDocumentFilterInput>;
  tMnSetClassifications?: InputMaybe<ListFilterInputTypeOfTMnSetClassificationFilterInput>;
};

export type TMnStorageSortInput = {
  acDescription?: InputMaybe<SortEnumType>;
  acGuid?: InputMaybe<SortEnumType>;
  acIdentify?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acUrl?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anLoginsQid?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type TPaSetDocType = {
  acDocType?: Maybe<Scalars['String']>;
  acFiscalDevice?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName?: Maybe<Scalars['String']>;
  acLinkDocName1?: Maybe<Scalars['String']>;
  acLinkDocName2?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acName3?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName?: Maybe<Scalars['String']>;
  acRmashowWorkSpec?: Maybe<Scalars['String']>;
  acSetOf?: Maybe<Scalars['String']>;
  acType?: Maybe<Scalars['String']>;
  acWorkPlace?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anUserIns?: Maybe<Scalars['Int']>;
  documentType: DocumentTypeEnum;
  tHfPlans?: Maybe<Array<Maybe<THfPlan>>>;
  tHfWoexes?: Maybe<Array<Maybe<THfWoex>>>;
  tMnDocuments?: Maybe<Array<Maybe<TMnDocument>>>;
  tPaSetDocTypeStats?: Maybe<Array<Maybe<TPaSetDocTypeStat>>>;
};


export type TPaSetDocTypeTMnDocumentsArgs = {
  where?: InputMaybe<TMnDocumentFilterInput>;
};


export type TPaSetDocTypeTPaSetDocTypeStatsArgs = {
  where?: InputMaybe<TPaSetDocTypeStatFilterInput>;
};

export type TPaSetDocTypeFilterInput = {
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acFiscalDevice?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName1?: InputMaybe<StringOperationFilterInput>;
  acLinkDocName2?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acName3?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName?: InputMaybe<StringOperationFilterInput>;
  acRmashowWorkSpec?: InputMaybe<StringOperationFilterInput>;
  acSetOf?: InputMaybe<StringOperationFilterInput>;
  acType?: InputMaybe<StringOperationFilterInput>;
  acWorkPlace?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaSetDocTypeFilterInput>>;
  documentType?: InputMaybe<DocumentTypeEnumOperationFilterInput>;
  or?: InputMaybe<Array<TPaSetDocTypeFilterInput>>;
  tHfPlans?: InputMaybe<ListFilterInputTypeOfTHfPlanFilterInput>;
  tHfWoexes?: InputMaybe<ListFilterInputTypeOfTHfWoexFilterInput>;
  tMnDocuments?: InputMaybe<ListFilterInputTypeOfTMnDocumentFilterInput>;
  tPaSetDocTypeStats?: InputMaybe<ListFilterInputTypeOfTPaSetDocTypeStatFilterInput>;
};

export type TPaSetDocTypeSortInput = {
  acDocType?: InputMaybe<SortEnumType>;
  acFiscalDevice?: InputMaybe<SortEnumType>;
  acIssuer?: InputMaybe<SortEnumType>;
  acIssuerName?: InputMaybe<SortEnumType>;
  acLinkDocName1?: InputMaybe<SortEnumType>;
  acLinkDocName2?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acName3?: InputMaybe<SortEnumType>;
  acReceiver?: InputMaybe<SortEnumType>;
  acReceiverName?: InputMaybe<SortEnumType>;
  acRmashowWorkSpec?: InputMaybe<SortEnumType>;
  acSetOf?: InputMaybe<SortEnumType>;
  acType?: InputMaybe<SortEnumType>;
  acWorkPlace?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  documentType?: InputMaybe<SortEnumType>;
};

export type TPaSetDocTypeStat = {
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeNavigation?: Maybe<TPaSetDocType>;
  acFinished?: Maybe<Scalars['String']>;
  acFreeStock?: Maybe<Scalars['String']>;
  acIsIssueAllowdOpenBills?: Maybe<Scalars['String']>;
  acLimitControl?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  tHeOrders?: Maybe<Array<Maybe<THeOrder>>>;
};

export type TPaSetDocTypeStatFilterInput = {
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeFilterInput>;
  acFinished?: InputMaybe<StringOperationFilterInput>;
  acFreeStock?: InputMaybe<StringOperationFilterInput>;
  acIsIssueAllowdOpenBills?: InputMaybe<StringOperationFilterInput>;
  acLimitControl?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaSetDocTypeStatFilterInput>>;
  or?: InputMaybe<Array<TPaSetDocTypeStatFilterInput>>;
  tHeOrders?: InputMaybe<ListFilterInputTypeOfTHeOrderFilterInput>;
};

export type TPaSetDocTypeStatSortInput = {
  acDocType?: InputMaybe<SortEnumType>;
  acDocTypeNavigation?: InputMaybe<TPaSetDocTypeSortInput>;
  acFinished?: InputMaybe<SortEnumType>;
  acFreeStock?: InputMaybe<SortEnumType>;
  acIsIssueAllowdOpenBills?: InputMaybe<SortEnumType>;
  acLimitControl?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acStatus?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type TPaSysParam = {
  acCompanyImage?: Maybe<Array<Scalars['Byte']>>;
  acCompanyPrtTextA?: Maybe<Scalars['String']>;
  acCompanyPrtTextB?: Maybe<Scalars['String']>;
  acCustomLogoImage?: Maybe<Array<Scalars['Byte']>>;
  acFiscalServer?: Maybe<Scalars['String']>;
  acOurCompany?: Maybe<Scalars['String']>;
  acPrimCurrency?: Maybe<Scalars['String']>;
  acQtyInCodeCont?: Maybe<Scalars['String']>;
  acVatcodeWithoutTaxInc?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anDocKeyLenDocType?: Maybe<Scalars['Byte']>;
  anDocKeyLenNumber?: Maybe<Scalars['Byte']>;
  anGenerSubjNoFieldLen: Scalars['Int'];
  anGenerSubjNoLen: Scalars['Int'];
  anQtyInCodeLen: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type TPaSysParamFilterInput = {
  acCompanyImage?: InputMaybe<ListComparableByteOperationFilterInput>;
  acCompanyPrtTextA?: InputMaybe<StringOperationFilterInput>;
  acCompanyPrtTextB?: InputMaybe<StringOperationFilterInput>;
  acCustomLogoImage?: InputMaybe<ListComparableByteOperationFilterInput>;
  acFiscalServer?: InputMaybe<StringOperationFilterInput>;
  acOurCompany?: InputMaybe<StringOperationFilterInput>;
  acPrimCurrency?: InputMaybe<StringOperationFilterInput>;
  acQtyInCodeCont?: InputMaybe<StringOperationFilterInput>;
  acVatcodeWithoutTaxInc?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anDocKeyLenDocType?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anDocKeyLenNumber?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  anGenerSubjNoFieldLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  anGenerSubjNoLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQtyInCodeLen?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaSysParamFilterInput>>;
  or?: InputMaybe<Array<TPaSysParamFilterInput>>;
};

export type TPaSysParamSortInput = {
  acCompanyPrtTextA?: InputMaybe<SortEnumType>;
  acCompanyPrtTextB?: InputMaybe<SortEnumType>;
  acFiscalServer?: InputMaybe<SortEnumType>;
  acOurCompany?: InputMaybe<SortEnumType>;
  acPrimCurrency?: InputMaybe<SortEnumType>;
  acQtyInCodeCont?: InputMaybe<SortEnumType>;
  acVatcodeWithoutTaxInc?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anDocKeyLenDocType?: InputMaybe<SortEnumType>;
  anDocKeyLenNumber?: InputMaybe<SortEnumType>;
  anGenerSubjNoFieldLen?: InputMaybe<SortEnumType>;
  anGenerSubjNoLen?: InputMaybe<SortEnumType>;
  anQtyInCodeLen?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type TPaUser = {
  acActive?: Maybe<Scalars['String']>;
  acAgencySignedBy?: Maybe<Scalars['String']>;
  acCerPub?: Maybe<Scalars['String']>;
  acCerTime?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acLangId?: Maybe<Scalars['String']>;
  acProfile?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  acTitle?: Maybe<Scalars['String']>;
  acUserId?: Maybe<Scalars['String']>;
  acWeb?: Maybe<Scalars['String']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId: Scalars['Int'];
  anUserIns?: Maybe<Scalars['Int']>;
};

export type TPaUserFilterInput = {
  acActive?: InputMaybe<StringOperationFilterInput>;
  acAgencySignedBy?: InputMaybe<StringOperationFilterInput>;
  acCerPub?: InputMaybe<StringOperationFilterInput>;
  acCerTime?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acLangId?: InputMaybe<StringOperationFilterInput>;
  acProfile?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  acTitle?: InputMaybe<StringOperationFilterInput>;
  acUserId?: InputMaybe<StringOperationFilterInput>;
  acWeb?: InputMaybe<StringOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaUserFilterInput>>;
  or?: InputMaybe<Array<TPaUserFilterInput>>;
};

/** A connection to a list of items. */
export type TPaUserPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<TPaUserPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TPaUser>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TPaUserPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TPaUser>;
};

export type TPaUserSortInput = {
  acActive?: InputMaybe<SortEnumType>;
  acAgencySignedBy?: InputMaybe<SortEnumType>;
  acCerPub?: InputMaybe<SortEnumType>;
  acCerTime?: InputMaybe<SortEnumType>;
  acDept?: InputMaybe<SortEnumType>;
  acLangId?: InputMaybe<SortEnumType>;
  acProfile?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  acTitle?: InputMaybe<SortEnumType>;
  acUserId?: InputMaybe<SortEnumType>;
  acWeb?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type TPaWorkflowTaskInstance = {
  acComments?: Maybe<Scalars['String']>;
  acCompleted?: Maybe<Scalars['String']>;
  acDescription?: Maybe<Scalars['String']>;
  acModifiedUserId?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acTask?: Maybe<Scalars['String']>;
  acTitle?: Maybe<Scalars['String']>;
  adCreatedOn?: Maybe<Scalars['DateTime']>;
  adModifiedOn?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anId: Scalars['Int'];
  anTaskVersion?: Maybe<Scalars['Int']>;
  anUserChg?: Maybe<Scalars['Int']>;
  anUserId?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWorkflowDefinitionKey?: Maybe<Scalars['Int']>;
  anWorkflowInstanceKey?: Maybe<Scalars['Int']>;
  tMnDocumentMetaData?: Maybe<Array<Maybe<TMnDocumentMetaDatum>>>;
  tMnLinkDocumentsWfs?: Maybe<Array<Maybe<TMnLinkDocumentsWf>>>;
};


export type TPaWorkflowTaskInstanceTMnDocumentMetaDataArgs = {
  where?: InputMaybe<TMnDocumentMetaDatumFilterInput>;
};


export type TPaWorkflowTaskInstanceTMnLinkDocumentsWfsArgs = {
  where?: InputMaybe<TMnLinkDocumentsWfFilterInput>;
};

export type TPaWorkflowTaskInstanceFilterInput = {
  acComments?: InputMaybe<StringOperationFilterInput>;
  acCompleted?: InputMaybe<StringOperationFilterInput>;
  acDescription?: InputMaybe<StringOperationFilterInput>;
  acModifiedUserId?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acTask?: InputMaybe<StringOperationFilterInput>;
  acTitle?: InputMaybe<StringOperationFilterInput>;
  adCreatedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adModifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anId?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTaskVersion?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkflowDefinitionKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWorkflowInstanceKey?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TPaWorkflowTaskInstanceFilterInput>>;
  or?: InputMaybe<Array<TPaWorkflowTaskInstanceFilterInput>>;
  tMnDocumentMetaData?: InputMaybe<ListFilterInputTypeOfTMnDocumentMetaDatumFilterInput>;
  tMnLinkDocumentsWfs?: InputMaybe<ListFilterInputTypeOfTMnLinkDocumentsWfFilterInput>;
};

export type TPaWorkflowTaskInstanceSortInput = {
  acComments?: InputMaybe<SortEnumType>;
  acCompleted?: InputMaybe<SortEnumType>;
  acDescription?: InputMaybe<SortEnumType>;
  acModifiedUserId?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acTask?: InputMaybe<SortEnumType>;
  acTitle?: InputMaybe<SortEnumType>;
  adCreatedOn?: InputMaybe<SortEnumType>;
  adModifiedOn?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anId?: InputMaybe<SortEnumType>;
  anTaskVersion?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserId?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
  anWorkflowDefinitionKey?: InputMaybe<SortEnumType>;
  anWorkflowInstanceKey?: InputMaybe<SortEnumType>;
};

export type TeamViewerSession = {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contactId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  dismissed: Scalars['Boolean'];
  duration: Scalars['TimeSpan'];
  endDate: Scalars['DateTime'];
  groupId?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  supportTicket?: Maybe<SupportTicket>;
  supportTicketId?: Maybe<Scalars['Int']>;
  supportTicketTimeLog?: Maybe<SupportTicketTimeLog>;
  supportTicketTimeLogId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type TeamViewerSessionFilterInput = {
  and?: InputMaybe<Array<TeamViewerSessionFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  billingState?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactId?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  deviceId?: InputMaybe<StringOperationFilterInput>;
  deviceName?: InputMaybe<StringOperationFilterInput>;
  dismissed?: InputMaybe<BooleanOperationFilterInput>;
  duration?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  endDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  groupId?: InputMaybe<StringOperationFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TeamViewerSessionFilterInput>>;
  startDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  supportTicket?: InputMaybe<SupportTicketFilterInput>;
  supportTicketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogFilterInput>;
  supportTicketTimeLogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
};

export type TravelKilometers = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  kilometers?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Decimal']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
};

export type TravelKilometersFilterInput = {
  and?: InputMaybe<Array<TravelKilometersFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  date?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  kilometers?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TravelKilometersFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  price?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type TravelWarrant = {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  coDrivers?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  country?: Maybe<Country>;
  countryAllowance: Scalars['Float'];
  countryAllowanceConversion: Scalars['Float'];
  countryAllowanceCurrency?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  documentNumber: Scalars['Int'];
  downPayment?: Maybe<Scalars['Float']>;
  downPaymentConversion?: Maybe<Scalars['Float']>;
  downPaymentCurrency?: Maybe<Currency>;
  downPaymentCurrencyId?: Maybe<Scalars['Int']>;
  driver?: Maybe<Scalars['String']>;
  expenseBearer?: Maybe<ExpenseBearer>;
  expenseBearerAllowance: Scalars['Float'];
  expenseBearerAllowanceConversion: Scalars['Float'];
  expenseBearerCurrency?: Maybe<Scalars['String']>;
  expenseBearerId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  kilometersTraveled: Scalars['Float'];
  lastClosedAt?: Maybe<Scalars['DateTime']>;
  lastOpenedAt?: Maybe<Scalars['DateTime']>;
  lastSentToFinalizeAt?: Maybe<Scalars['DateTime']>;
  lastSentToPantheonAt?: Maybe<Scalars['DateTime']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  officialVehicle?: Maybe<OfficialVehicle>;
  officialVehicleId?: Maybe<Scalars['Int']>;
  onixPantheonDMSId?: Maybe<Scalars['Int']>;
  pantheonId?: Maybe<Scalars['String']>;
  pantheonStatus?: Maybe<Scalars['String']>;
  perDiems: Scalars['Float'];
  personalVehicle?: Maybe<PersonalVehicle>;
  personalVehicleId?: Maybe<Scalars['Int']>;
  place?: Maybe<Scalars['String']>;
  placeOfDeparture?: Maybe<Scalars['String']>;
  returnNote?: Maybe<Scalars['String']>;
  status: TravelWarrantStatus;
  syncErrorStack?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  travelEndDateTime?: Maybe<Scalars['DateTime']>;
  travelEndMeter?: Maybe<Scalars['Float']>;
  travelHours: Scalars['Float'];
  travelKilometersConversion: Scalars['Float'];
  travelStartDateTime?: Maybe<Scalars['DateTime']>;
  travelStartMeter?: Maybe<Scalars['Float']>;
  travelWarrantItems?: Maybe<Array<Maybe<TravelWarrantItem>>>;
  vehicle?: Maybe<Scalars['String']>;
};

export type TravelWarrantCostType = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  docType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeactivated: Scalars['Boolean'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  pantheonId?: Maybe<Scalars['String']>;
  syncFailed: Scalars['Boolean'];
  syncStatus?: Maybe<Scalars['String']>;
  synced: Scalars['DateTime'];
  type: Scalars['Int'];
};

export type TravelWarrantCostTypeFilterInput = {
  and?: InputMaybe<Array<TravelWarrantCostTypeFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  docType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeactivated?: InputMaybe<BooleanOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelWarrantCostTypeFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  type?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TravelWarrantCostTypeSortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  docType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeactivated?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type TravelWarrantFilterInput = {
  and?: InputMaybe<Array<TravelWarrantFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  coDrivers?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryAllowance?: InputMaybe<ComparableDoubleOperationFilterInput>;
  countryAllowanceConversion?: InputMaybe<ComparableDoubleOperationFilterInput>;
  countryAllowanceCurrency?: InputMaybe<StringOperationFilterInput>;
  countryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  documentNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  downPayment?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  downPaymentConversion?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  downPaymentCurrency?: InputMaybe<CurrencyFilterInput>;
  downPaymentCurrencyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  driver?: InputMaybe<StringOperationFilterInput>;
  expenseBearer?: InputMaybe<ExpenseBearerFilterInput>;
  expenseBearerAllowance?: InputMaybe<ComparableDoubleOperationFilterInput>;
  expenseBearerAllowanceConversion?: InputMaybe<ComparableDoubleOperationFilterInput>;
  expenseBearerCurrency?: InputMaybe<StringOperationFilterInput>;
  expenseBearerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  kilometersTraveled?: InputMaybe<ComparableDoubleOperationFilterInput>;
  lastClosedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastOpenedAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastSentToFinalizeAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastSentToPantheonAt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  officialVehicle?: InputMaybe<OfficialVehicleFilterInput>;
  officialVehicleId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  onixPantheonDMSId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<TravelWarrantFilterInput>>;
  pantheonId?: InputMaybe<StringOperationFilterInput>;
  pantheonStatus?: InputMaybe<StringOperationFilterInput>;
  perDiems?: InputMaybe<ComparableDoubleOperationFilterInput>;
  personalVehicle?: InputMaybe<PersonalVehicleFilterInput>;
  personalVehicleId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  place?: InputMaybe<StringOperationFilterInput>;
  placeOfDeparture?: InputMaybe<StringOperationFilterInput>;
  returnNote?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<TravelWarrantStatusOperationFilterInput>;
  syncErrorStack?: InputMaybe<StringOperationFilterInput>;
  syncFailed?: InputMaybe<BooleanOperationFilterInput>;
  syncStatus?: InputMaybe<StringOperationFilterInput>;
  synced?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  travelEndDateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  travelEndMeter?: InputMaybe<ComparableNullableOfSingleOperationFilterInput>;
  travelHours?: InputMaybe<ComparableDoubleOperationFilterInput>;
  travelKilometersConversion?: InputMaybe<ComparableDoubleOperationFilterInput>;
  travelStartDateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  travelStartMeter?: InputMaybe<ComparableNullableOfSingleOperationFilterInput>;
  travelWarrantItems?: InputMaybe<ListFilterInputTypeOfTravelWarrantItemFilterInput>;
  vehicle?: InputMaybe<StringOperationFilterInput>;
};

export type TravelWarrantItem = {
  anCostNo?: Maybe<Scalars['Int']>;
  anNo?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  conversion: Scalars['Float'];
  costType?: Maybe<TravelWarrantCostType>;
  costTypeId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  currencyId: Scalars['Int'];
  date: Scalars['DateTime'];
  files?: Maybe<Array<Maybe<SavedFile>>>;
  forPeriod?: Maybe<Scalars['DateTime']>;
  hasBackingInvoice: Scalars['Boolean'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  notForPayment: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  travelWarrant?: Maybe<TravelWarrant>;
  travelWarrantId?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
};

export type TravelWarrantItemFilterInput = {
  anCostNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TravelWarrantItemFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  conversion?: InputMaybe<ComparableDoubleOperationFilterInput>;
  costType?: InputMaybe<TravelWarrantCostTypeFilterInput>;
  costTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currency?: InputMaybe<CurrencyFilterInput>;
  currencyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  files?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  forPeriod?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  hasBackingInvoice?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  notForPayment?: InputMaybe<BooleanOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TravelWarrantItemFilterInput>>;
  travelWarrant?: InputMaybe<TravelWarrantFilterInput>;
  travelWarrantId?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<ComparableDecimalOperationFilterInput>;
};

export type TravelWarrantItemSortInput = {
  anCostNo?: InputMaybe<SortEnumType>;
  anNo?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  conversion?: InputMaybe<SortEnumType>;
  costType?: InputMaybe<TravelWarrantCostTypeSortInput>;
  costTypeId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<CurrencySortInput>;
  currencyId?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  forPeriod?: InputMaybe<SortEnumType>;
  hasBackingInvoice?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  notForPayment?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  travelWarrant?: InputMaybe<TravelWarrantSortInput>;
  travelWarrantId?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type TravelWarrantSortInput = {
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  coDrivers?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountrySortInput>;
  countryAllowance?: InputMaybe<SortEnumType>;
  countryAllowanceConversion?: InputMaybe<SortEnumType>;
  countryAllowanceCurrency?: InputMaybe<SortEnumType>;
  countryId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  documentNumber?: InputMaybe<SortEnumType>;
  downPayment?: InputMaybe<SortEnumType>;
  downPaymentConversion?: InputMaybe<SortEnumType>;
  downPaymentCurrency?: InputMaybe<CurrencySortInput>;
  downPaymentCurrencyId?: InputMaybe<SortEnumType>;
  driver?: InputMaybe<SortEnumType>;
  expenseBearer?: InputMaybe<ExpenseBearerSortInput>;
  expenseBearerAllowance?: InputMaybe<SortEnumType>;
  expenseBearerAllowanceConversion?: InputMaybe<SortEnumType>;
  expenseBearerCurrency?: InputMaybe<SortEnumType>;
  expenseBearerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  kilometersTraveled?: InputMaybe<SortEnumType>;
  lastClosedAt?: InputMaybe<SortEnumType>;
  lastOpenedAt?: InputMaybe<SortEnumType>;
  lastSentToFinalizeAt?: InputMaybe<SortEnumType>;
  lastSentToPantheonAt?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  officialVehicle?: InputMaybe<OfficialVehicleSortInput>;
  officialVehicleId?: InputMaybe<SortEnumType>;
  onixPantheonDMSId?: InputMaybe<SortEnumType>;
  pantheonId?: InputMaybe<SortEnumType>;
  pantheonStatus?: InputMaybe<SortEnumType>;
  perDiems?: InputMaybe<SortEnumType>;
  personalVehicle?: InputMaybe<PersonalVehicleSortInput>;
  personalVehicleId?: InputMaybe<SortEnumType>;
  place?: InputMaybe<SortEnumType>;
  placeOfDeparture?: InputMaybe<SortEnumType>;
  returnNote?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  syncErrorStack?: InputMaybe<SortEnumType>;
  syncFailed?: InputMaybe<SortEnumType>;
  syncStatus?: InputMaybe<SortEnumType>;
  synced?: InputMaybe<SortEnumType>;
  travelEndDateTime?: InputMaybe<SortEnumType>;
  travelEndMeter?: InputMaybe<SortEnumType>;
  travelHours?: InputMaybe<SortEnumType>;
  travelKilometersConversion?: InputMaybe<SortEnumType>;
  travelStartDateTime?: InputMaybe<SortEnumType>;
  travelStartMeter?: InputMaybe<SortEnumType>;
  vehicle?: InputMaybe<SortEnumType>;
};

export enum TravelWarrantStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  SentToFinalize = 'SENT_TO_FINALIZE',
  SentToPantheon = 'SENT_TO_PANTHEON'
}

export type TravelWarrantStatusOperationFilterInput = {
  eq?: InputMaybe<TravelWarrantStatus>;
  in?: InputMaybe<Array<TravelWarrantStatus>>;
  neq?: InputMaybe<TravelWarrantStatus>;
  nin?: InputMaybe<Array<TravelWarrantStatus>>;
};

export type TrimTHeMoveRmaworkSpec = {
  _AcNote2?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyNavigation?: Maybe<THeMove>;
  acNote?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  adTravelEnd?: Maybe<Scalars['DateTime']>;
  adTravelStart?: Maybe<Scalars['DateTime']>;
  adWorkEnd?: Maybe<Scalars['DateTime']>;
  adWorkStart?: Maybe<Scalars['DateTime']>;
  anMileage?: Maybe<Scalars['Decimal']>;
  anNo: Scalars['Int'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anWork?: Maybe<Scalars['Decimal']>;
};

export type TrimTHeMoveRmaworkSpecFilterInput = {
  _AcNote2?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyNavigation?: InputMaybe<THeMoveFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acWorker?: InputMaybe<StringOperationFilterInput>;
  adTravelEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTravelStart?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adWorkEnd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adWorkStart?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anMileage?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anWork?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<TrimTHeMoveRmaworkSpecFilterInput>>;
  or?: InputMaybe<Array<TrimTHeMoveRmaworkSpecFilterInput>>;
};

export type TrimWorkOrderImageQuery = {
  _AcPicture?: Maybe<Array<Scalars['Byte']>>;
  acLnkKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  anKey?: Maybe<Scalars['Long']>;
};

export type TrimWorkOrderImageQueryInput = {
  _AcPicture?: InputMaybe<Array<Scalars['Byte']>>;
  acLnkKey?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  anKey?: InputMaybe<Scalars['Long']>;
};

export type TrimWorkOrderMaterialQuery = {
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anNo: Scalars['Int'];
  anQty: Scalars['Decimal'];
};

export type TrimWorkOrderQuery = {
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acContactPrsn3Email?: Maybe<Scalars['String']>;
  acContactPrsnEmail?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acFieldSA?: Maybe<Scalars['String']>;
  acFieldSF?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adFieldDA?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anClerk?: Maybe<Scalars['Int']>;
  anClerkAcName?: Maybe<Scalars['String']>;
  anClerkAcSurname?: Maybe<Scalars['String']>;
  anFieldNA?: Maybe<Scalars['Decimal']>;
  anFieldNB?: Maybe<Scalars['Decimal']>;
  bearerAddress?: Maybe<Scalars['String']>;
  bearerName?: Maybe<Scalars['String']>;
  bearerPIN?: Maybe<Scalars['String']>;
  bearerPost?: Maybe<Scalars['String']>;
  bearerPostName?: Maybe<Scalars['String']>;
  customerAddress?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerPIN?: Maybe<Scalars['String']>;
  customerPost?: Maybe<Scalars['String']>;
  customerPostName?: Maybe<Scalars['String']>;
  receiverAddress?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  receiverPIN?: Maybe<Scalars['String']>;
  receiverPost?: Maybe<Scalars['String']>;
  receiverPostName?: Maybe<Scalars['String']>;
  signature?: Maybe<Array<Scalars['Byte']>>;
  workOrderTotal?: Maybe<Scalars['Decimal']>;
};

export type TrimWorkOrderReceptionQuery = {
  _OxInventoryNumber?: Maybe<Scalars['String']>;
  acDescr?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acSerialNo?: Maybe<Scalars['String']>;
  acSetOfItem?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anNo?: Maybe<Scalars['Int']>;
  anQty: Scalars['Decimal'];
};

export type TrimWorkOrderReceptionQueryInput = {
  _OxInventoryNumber?: InputMaybe<Scalars['String']>;
  acDescr?: InputMaybe<Scalars['String']>;
  acIdent?: InputMaybe<Scalars['String']>;
  acKey?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  acSerialNo?: InputMaybe<Scalars['String']>;
  acSetOfItem?: InputMaybe<Scalars['String']>;
  acUm?: InputMaybe<Scalars['String']>;
  anNo?: InputMaybe<Scalars['Int']>;
  anQty: Scalars['Decimal'];
};

export type TrimWorkOrderReclamationQuery = {
  _OxInventoryNumber?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anNo: Scalars['Int'];
  anQty: Scalars['Decimal'];
};

export type TrimWorkOrderServiceQuery = {
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acUm?: Maybe<Scalars['String']>;
  anNo: Scalars['Int'];
  anQty: Scalars['Decimal'];
};

export type TrimWorkOrderSpecQuery = {
  _AcNote2?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acWorker?: Maybe<Scalars['String']>;
  adWorkEnd?: Maybe<Scalars['DateTime']>;
  adWorkStart?: Maybe<Scalars['DateTime']>;
  anMileage?: Maybe<Scalars['Decimal']>;
  anNo: Scalars['Int'];
  anWork?: Maybe<Scalars['Decimal']>;
};

export type TrimWorkOrderTHeDocs = {
  _AcPicture?: Maybe<Array<Scalars['Byte']>>;
  acAppl?: Maybe<Scalars['String']>;
  acForeignIdentifier?: Maybe<Scalars['String']>;
  acLnkKey?: Maybe<Scalars['String']>;
  acLnkKeyOrd?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acPerKey?: Maybe<Scalars['String']>;
  acPhoneUID?: Maybe<Scalars['String']>;
  acTypeDocu?: Maybe<Scalars['String']>;
  acUrl?: Maybe<Scalars['String']>;
  adDateValid?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  anKey: Scalars['Long'];
  anQid: Scalars['Int'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
};

export type TrimWorkOrderTHeDocsFilterInput = {
  _AcPicture?: InputMaybe<ListComparableByteOperationFilterInput>;
  acAppl?: InputMaybe<StringOperationFilterInput>;
  acForeignIdentifier?: InputMaybe<StringOperationFilterInput>;
  acLnkKey?: InputMaybe<StringOperationFilterInput>;
  acLnkKeyOrd?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acPerKey?: InputMaybe<StringOperationFilterInput>;
  acPhoneUID?: InputMaybe<StringOperationFilterInput>;
  acTypeDocu?: InputMaybe<StringOperationFilterInput>;
  acUrl?: InputMaybe<StringOperationFilterInput>;
  adDateValid?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anKey?: InputMaybe<ComparableInt64OperationFilterInput>;
  anQid?: InputMaybe<ComparableInt32OperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<TrimWorkOrderTHeDocsFilterInput>>;
  or?: InputMaybe<Array<TrimWorkOrderTHeDocsFilterInput>>;
};

export type TrimWorkOrderTHeDocsSortInput = {
  acAppl?: InputMaybe<SortEnumType>;
  acForeignIdentifier?: InputMaybe<SortEnumType>;
  acLnkKey?: InputMaybe<SortEnumType>;
  acLnkKeyOrd?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acPerKey?: InputMaybe<SortEnumType>;
  acPhoneUID?: InputMaybe<SortEnumType>;
  acTypeDocu?: InputMaybe<SortEnumType>;
  acUrl?: InputMaybe<SortEnumType>;
  adDateValid?: InputMaybe<SortEnumType>;
  adTimeChg?: InputMaybe<SortEnumType>;
  adTimeIns?: InputMaybe<SortEnumType>;
  anKey?: InputMaybe<SortEnumType>;
  anQid?: InputMaybe<SortEnumType>;
  anUserChg?: InputMaybe<SortEnumType>;
  anUserIns?: InputMaybe<SortEnumType>;
};

export type UnreadUserSupportTicketMessage = {
  message?: Maybe<SupportTicketMessage>;
  messageId: Scalars['Int'];
  type: NotificationType;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
};

export type UnreadUserSupportTicketMessageFilterInput = {
  and?: InputMaybe<Array<UnreadUserSupportTicketMessageFilterInput>>;
  message?: InputMaybe<SupportTicketMessageFilterInput>;
  messageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UnreadUserSupportTicketMessageFilterInput>>;
  type?: InputMaybe<NotificationTypeOperationFilterInput>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type UpdateOxDmsxmlitemDtoInput = {
  acCostBearer?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acIdent?: InputMaybe<Scalars['String']>;
  anDocumentQId: Scalars['Int'];
  anId: Scalars['Int'];
};

export type UpdateSubjectDtoInput = {
  acAddress?: InputMaybe<Scalars['String']>;
  acBuyer?: InputMaybe<Scalars['String']>;
  acEmail?: InputMaybe<Scalars['String']>;
  acFax?: InputMaybe<Scalars['String']>;
  acHttpPath?: InputMaybe<Scalars['String']>;
  acName2?: InputMaybe<Scalars['String']>;
  acPayMethod?: InputMaybe<Scalars['String']>;
  acPayer?: InputMaybe<Scalars['String']>;
  acPhone?: InputMaybe<Scalars['String']>;
  acPin?: InputMaybe<Scalars['String']>;
  acPost?: InputMaybe<Scalars['String']>;
  acSkis?: InputMaybe<Scalars['String']>;
  acSubject: Scalars['String'];
  acSupplier?: InputMaybe<Scalars['String']>;
  acWayOfSale?: InputMaybe<Scalars['String']>;
  anClerk?: InputMaybe<Scalars['Int']>;
  anDaysForPayment?: InputMaybe<Scalars['Int']>;
  docId?: InputMaybe<Scalars['Int']>;
};

export type UpdateTHeSetSubjContactAddressDtoInput = {
  acNote?: InputMaybe<Scalars['String']>;
  acPhone?: InputMaybe<Scalars['String']>;
  acType?: InputMaybe<Scalars['String']>;
};

export type UpdateTHeSetSubjContactDtoInput = {
  acActive?: InputMaybe<Scalars['String']>;
  acFunction?: InputMaybe<Scalars['String']>;
  acName?: InputMaybe<Scalars['String']>;
  acSubject?: InputMaybe<Scalars['String']>;
  acSurname?: InputMaybe<Scalars['String']>;
};

export type UpdateTMnDocumentDtoInput = {
  acStatus?: InputMaybe<Scalars['String']>;
  anClassifIcationQid?: InputMaybe<Scalars['Int']>;
  anMailBoxQid?: InputMaybe<Scalars['Int']>;
  anStorageQid?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>;
  note?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTMnFileDtoInput = {
  fileContent?: InputMaybe<Array<Scalars['Byte']>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  tMnDocumentId: Scalars['Int'];
};

export type UpdateWorkOrderDtoInput = {
  acContactPrsn?: InputMaybe<Scalars['String']>;
  acContactPrsn3?: InputMaybe<Scalars['String']>;
  acDoc1?: InputMaybe<Scalars['String']>;
  acDoc1Date?: InputMaybe<Scalars['DateTime']>;
  acDoc2?: InputMaybe<Scalars['String']>;
  acDoc2Date?: InputMaybe<Scalars['DateTime']>;
  acFieldSF?: InputMaybe<Scalars['String']>;
  acKey?: InputMaybe<Scalars['String']>;
  acNote?: InputMaybe<Scalars['String']>;
  anFieldNA?: InputMaybe<Scalars['Decimal']>;
  anFieldNB?: InputMaybe<Scalars['Decimal']>;
  documentType?: InputMaybe<Scalars['Int']>;
  otherAcWorkers?: InputMaybe<Array<Scalars['String']>>;
  receiver?: InputMaybe<Scalars['String']>;
  uID?: InputMaybe<Scalars['String']>;
};

export type UserArbitrarySetting = {
  alsoIncludeThisPantheonUserOfflineCodebooks?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  user?: Maybe<ApplicationUser>;
  userId?: Maybe<Scalars['String']>;
};

export type UserArbitrarySettingFilterInput = {
  alsoIncludeThisPantheonUserOfflineCodebooks?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<UserArbitrarySettingFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<UserArbitrarySettingFilterInput>>;
  user?: InputMaybe<ApplicationUserFilterInput>;
  userId?: InputMaybe<StringOperationFilterInput>;
};

export type UserArbitrarySettingSortInput = {
  alsoIncludeThisPantheonUserOfflineCodebooks?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  user?: InputMaybe<ApplicationUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type VHeMove = {
  acAcctClaimLiab?: Maybe<Scalars['String']>;
  acCode1?: Maybe<Scalars['String']>;
  acCode2?: Maybe<Scalars['String']>;
  acCode3?: Maybe<Scalars['String']>;
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acContractNo?: Maybe<Scalars['String']>;
  acCostDrvOut?: Maybe<Scalars['String']>;
  acCreatFromWo?: Maybe<Scalars['String']>;
  acCreatePayOrd?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDeliveryUnderArt163a?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDeptOut?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypePayOrd?: Maybe<Scalars['String']>;
  acDocTypePayOrdFgn?: Maybe<Scalars['String']>;
  acDocTypeStatusName?: Maybe<Scalars['String']>;
  acDutyTran?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acFiscSalesBookDocNo?: Maybe<Scalars['String']>;
  acFiscSalesBookSerNo?: Maybe<Scalars['String']>;
  acFiscSalesBookSetNo?: Maybe<Scalars['String']>;
  acFiscStatus?: Maybe<Scalars['String']>;
  acFiskPrintNo?: Maybe<Scalars['String']>;
  acFiskPrintNoS?: Maybe<Scalars['String']>;
  acForm?: Maybe<Scalars['String']>;
  acInternalNote?: Maybe<Scalars['String']>;
  acInvoiceForm?: Maybe<Scalars['String']>;
  acIsocountry?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName2?: Maybe<Scalars['String']>;
  acIssuerStock?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acLimitDuty?: Maybe<Scalars['String']>;
  acLoyaltyCard?: Maybe<Scalars['String']>;
  acNaturalPerson3?: Maybe<Scalars['String']>;
  acNaturalPersonI?: Maybe<Scalars['String']>;
  acNaturalPersonR?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acNote2?: Maybe<Scalars['String']>;
  acNote3?: Maybe<Scalars['String']>;
  acNoteClerkName?: Maybe<Scalars['String']>;
  acPackNum?: Maybe<Scalars['String']>;
  acParity?: Maybe<Scalars['String']>;
  acParityPost?: Maybe<Scalars['String']>;
  acParityType?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayPurpose1?: Maybe<Scalars['String']>;
  acPayPurpose2?: Maybe<Scalars['String']>;
  acPayPurpose3?: Maybe<Scalars['String']>;
  acPosted?: Maybe<Scalars['String']>;
  acPriceRate?: Maybe<Scalars['String']>;
  acProc?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acPrsn3Name2?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName2?: Maybe<Scalars['String']>;
  acReceiverStock?: Maybe<Scalars['String']>;
  acRefNo1?: Maybe<Scalars['String']>;
  acRefNo2?: Maybe<Scalars['String']>;
  acRefNo3?: Maybe<Scalars['String']>;
  acRefNo4?: Maybe<Scalars['String']>;
  acRetailSale?: Maybe<Scalars['String']>;
  acRoundVatonDoc?: Maybe<Scalars['String']>;
  acStatement?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acTransPaperForm?: Maybe<Scalars['String']>;
  acTransportCalcType?: Maybe<Scalars['String']>;
  acTriangTrans?: Maybe<Scalars['String']>;
  acUjpdocId?: Maybe<Scalars['String']>;
  acUpncode?: Maybe<Scalars['String']>;
  acUpncontrolNum?: Maybe<Scalars['String']>;
  acUpnreference?: Maybe<Scalars['String']>;
  acUserChgName?: Maybe<Scalars['String']>;
  acVatattType?: Maybe<Scalars['String']>;
  acVerifiedPrices?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  acWayOfSale?: Maybe<Scalars['String']>;
  acWayOfSale3?: Maybe<Scalars['String']>;
  acWayOfSaleI?: Maybe<Scalars['String']>;
  acWayOfSaleR?: Maybe<Scalars['String']>;
  acXmldocType?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateBeforeVat?: Maybe<Scalars['DateTime']>;
  adDateDdvpay?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adDateDue?: Maybe<Scalars['DateTime']>;
  adDateInv?: Maybe<Scalars['DateTime']>;
  adDateVat?: Maybe<Scalars['DateTime']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adSigned1?: Maybe<Scalars['DateTime']>;
  adSigned2?: Maybe<Scalars['DateTime']>;
  adSigned3?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  adVatattDate?: Maybe<Scalars['DateTime']>;
  anBnkAcctNo: Scalars['Int'];
  anClerk?: Maybe<Scalars['Int']>;
  anCurrValue: Scalars['Decimal'];
  anDaysForPayment: Scalars['Int'];
  anDirectCost: Scalars['Float'];
  anDiscount: Scalars['Decimal'];
  anDuty: Scalars['Decimal'];
  anFgnBankNo?: Maybe<Scalars['Int']>;
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anFieldNb?: Maybe<Scalars['Decimal']>;
  anFieldNc?: Maybe<Scalars['Decimal']>;
  anFieldNd?: Maybe<Scalars['Decimal']>;
  anFieldNe?: Maybe<Scalars['Decimal']>;
  anFieldNf?: Maybe<Scalars['Decimal']>;
  anFieldNg?: Maybe<Scalars['Decimal']>;
  anFieldNh?: Maybe<Scalars['Decimal']>;
  anFieldNi?: Maybe<Scalars['Decimal']>;
  anFieldNj?: Maybe<Scalars['Decimal']>;
  anForPay: Scalars['Decimal'];
  anFxrate: Scalars['Decimal'];
  anIncTax: Scalars['Decimal'];
  anLicensesBase?: Maybe<Scalars['Decimal']>;
  anLicensesVat?: Maybe<Scalars['Decimal']>;
  anNoteClerk?: Maybe<Scalars['Int']>;
  anOurBankAcctNo?: Maybe<Scalars['Int']>;
  anOurBankAcctNoFgn?: Maybe<Scalars['Int']>;
  anPermissionSelect: Scalars['Boolean'];
  anQidGdprlogS0?: Maybe<Scalars['Int']>;
  anQidGdprlogS1?: Maybe<Scalars['Int']>;
  anQidGdprlogS2?: Maybe<Scalars['Int']>;
  anRebate: Scalars['Decimal'];
  anReverseChargeCoefficient?: Maybe<Scalars['Float']>;
  anRoundItem: Scalars['Decimal'];
  anRoundItemFc: Scalars['Decimal'];
  anRoundPrice: Scalars['Decimal'];
  anRoundValue: Scalars['Decimal'];
  anRoundValueOc: Scalars['Decimal'];
  anSeqWhNoIn?: Maybe<Scalars['Int']>;
  anSeqWhNoOut?: Maybe<Scalars['Int']>;
  anSigner1?: Maybe<Scalars['Int']>;
  anSigner2?: Maybe<Scalars['Int']>;
  anSigner3?: Maybe<Scalars['Int']>;
  anState: Scalars['Int'];
  anTransport: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  anVat: Scalars['Decimal'];
  anVatbase: Scalars['Decimal'];
  anVatin: Scalars['Decimal'];
};

export type VHeMoveFilterInput = {
  acAcctClaimLiab?: InputMaybe<StringOperationFilterInput>;
  acCode1?: InputMaybe<StringOperationFilterInput>;
  acCode2?: InputMaybe<StringOperationFilterInput>;
  acCode3?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn3?: InputMaybe<StringOperationFilterInput>;
  acContractNo?: InputMaybe<StringOperationFilterInput>;
  acCostDrvOut?: InputMaybe<StringOperationFilterInput>;
  acCreatFromWo?: InputMaybe<StringOperationFilterInput>;
  acCreatePayOrd?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDeliveryUnderArt163a?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptOut?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypePayOrd?: InputMaybe<StringOperationFilterInput>;
  acDocTypePayOrdFgn?: InputMaybe<StringOperationFilterInput>;
  acDocTypeStatusName?: InputMaybe<StringOperationFilterInput>;
  acDutyTran?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookDocNo?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookSerNo?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookSetNo?: InputMaybe<StringOperationFilterInput>;
  acFiscStatus?: InputMaybe<StringOperationFilterInput>;
  acFiskPrintNo?: InputMaybe<StringOperationFilterInput>;
  acFiskPrintNoS?: InputMaybe<StringOperationFilterInput>;
  acForm?: InputMaybe<StringOperationFilterInput>;
  acInternalNote?: InputMaybe<StringOperationFilterInput>;
  acInvoiceForm?: InputMaybe<StringOperationFilterInput>;
  acIsocountry?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName2?: InputMaybe<StringOperationFilterInput>;
  acIssuerStock?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acLimitDuty?: InputMaybe<StringOperationFilterInput>;
  acLoyaltyCard?: InputMaybe<StringOperationFilterInput>;
  acNaturalPerson3?: InputMaybe<StringOperationFilterInput>;
  acNaturalPersonI?: InputMaybe<StringOperationFilterInput>;
  acNaturalPersonR?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acNote2?: InputMaybe<StringOperationFilterInput>;
  acNote3?: InputMaybe<StringOperationFilterInput>;
  acNoteClerkName?: InputMaybe<StringOperationFilterInput>;
  acPackNum?: InputMaybe<StringOperationFilterInput>;
  acParity?: InputMaybe<StringOperationFilterInput>;
  acParityPost?: InputMaybe<StringOperationFilterInput>;
  acParityType?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose1?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose2?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose3?: InputMaybe<StringOperationFilterInput>;
  acPosted?: InputMaybe<StringOperationFilterInput>;
  acPriceRate?: InputMaybe<StringOperationFilterInput>;
  acProc?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Name2?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName2?: InputMaybe<StringOperationFilterInput>;
  acReceiverStock?: InputMaybe<StringOperationFilterInput>;
  acRefNo1?: InputMaybe<StringOperationFilterInput>;
  acRefNo2?: InputMaybe<StringOperationFilterInput>;
  acRefNo3?: InputMaybe<StringOperationFilterInput>;
  acRefNo4?: InputMaybe<StringOperationFilterInput>;
  acRetailSale?: InputMaybe<StringOperationFilterInput>;
  acRoundVatonDoc?: InputMaybe<StringOperationFilterInput>;
  acStatement?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acTransPaperForm?: InputMaybe<StringOperationFilterInput>;
  acTransportCalcType?: InputMaybe<StringOperationFilterInput>;
  acTriangTrans?: InputMaybe<StringOperationFilterInput>;
  acUjpdocId?: InputMaybe<StringOperationFilterInput>;
  acUpncode?: InputMaybe<StringOperationFilterInput>;
  acUpncontrolNum?: InputMaybe<StringOperationFilterInput>;
  acUpnreference?: InputMaybe<StringOperationFilterInput>;
  acUserChgName?: InputMaybe<StringOperationFilterInput>;
  acVatattType?: InputMaybe<StringOperationFilterInput>;
  acVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  acVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale3?: InputMaybe<StringOperationFilterInput>;
  acWayOfSaleI?: InputMaybe<StringOperationFilterInput>;
  acWayOfSaleR?: InputMaybe<StringOperationFilterInput>;
  acXmldocType?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateBeforeVat?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDdvpay?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateInv?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateVat?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned3?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adVatattDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anBnkAcctNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anCurrValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDaysForPayment?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDirectCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDuty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFgnBankNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFxrate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anIncTax?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anLicensesBase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anLicensesVat?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anNoteClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOurBankAcctNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOurBankAcctNoFgn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPermissionSelect?: InputMaybe<BooleanOperationFilterInput>;
  anQidGdprlogS0?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidGdprlogS1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidGdprlogS2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anReverseChargeCoefficient?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anRoundItem?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundItemFc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundValueOc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSeqWhNoIn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSeqWhNoOut?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anState?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTransport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatbase?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatin?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<VHeMoveFilterInput>>;
  or?: InputMaybe<Array<VHeMoveFilterInput>>;
};

export type VHeMoveFiscalisation = {
  acError?: Maybe<Scalars['String']>;
  acHrfiskalNumber?: Maybe<Scalars['String']>;
  acJir?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acSifiskalNumber?: Maybe<Scalars['String']>;
  acYearInv?: Maybe<Scalars['String']>;
  acZik?: Maybe<Scalars['String']>;
  adFiscalDate?: Maybe<Scalars['DateTime']>;
};

export type VHeMoveFiscalisationFilterInput = {
  acError?: InputMaybe<StringOperationFilterInput>;
  acHrfiskalNumber?: InputMaybe<StringOperationFilterInput>;
  acJir?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acSifiskalNumber?: InputMaybe<StringOperationFilterInput>;
  acYearInv?: InputMaybe<StringOperationFilterInput>;
  acZik?: InputMaybe<StringOperationFilterInput>;
  adFiscalDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<VHeMoveFiscalisationFilterInput>>;
  or?: InputMaybe<Array<VHeMoveFiscalisationFilterInput>>;
};

export type VHeMoveOut = {
  acAcctClaimLiab?: Maybe<Scalars['String']>;
  acCode1?: Maybe<Scalars['String']>;
  acCode2?: Maybe<Scalars['String']>;
  acCode3?: Maybe<Scalars['String']>;
  acContactPrsn?: Maybe<Scalars['String']>;
  acContactPrsn3?: Maybe<Scalars['String']>;
  acContractNo?: Maybe<Scalars['String']>;
  acCostDrvOut?: Maybe<Scalars['String']>;
  acCreatFromWo?: Maybe<Scalars['String']>;
  acCreatePayOrd?: Maybe<Scalars['String']>;
  acCurrency?: Maybe<Scalars['String']>;
  acDelivery?: Maybe<Scalars['String']>;
  acDeliveryUnderArt163a?: Maybe<Scalars['String']>;
  acDept?: Maybe<Scalars['String']>;
  acDeptOut?: Maybe<Scalars['String']>;
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType?: Maybe<Scalars['String']>;
  acDocTypeStatusName?: Maybe<Scalars['String']>;
  acFieldSa?: Maybe<Scalars['String']>;
  acFieldSb?: Maybe<Scalars['String']>;
  acFieldSc?: Maybe<Scalars['String']>;
  acFieldSd?: Maybe<Scalars['String']>;
  acFieldSe?: Maybe<Scalars['String']>;
  acFieldSf?: Maybe<Scalars['String']>;
  acFieldSg?: Maybe<Scalars['String']>;
  acFieldSh?: Maybe<Scalars['String']>;
  acFieldSi?: Maybe<Scalars['String']>;
  acFieldSj?: Maybe<Scalars['String']>;
  acFiscSalesBookDocNo?: Maybe<Scalars['String']>;
  acFiscSalesBookSerNo?: Maybe<Scalars['String']>;
  acFiscSalesBookSetNo?: Maybe<Scalars['String']>;
  acFiscStatus?: Maybe<Scalars['String']>;
  acFiscalNumber?: Maybe<Scalars['String']>;
  acFiskPrintNo?: Maybe<Scalars['String']>;
  acFiskPrintNoS?: Maybe<Scalars['String']>;
  acForm?: Maybe<Scalars['String']>;
  acIdbcstate?: Maybe<Scalars['String']>;
  acInternalNote?: Maybe<Scalars['String']>;
  acInvoiceForm?: Maybe<Scalars['String']>;
  acIsocountry?: Maybe<Scalars['String']>;
  acIssuer?: Maybe<Scalars['String']>;
  acIssuerName2?: Maybe<Scalars['String']>;
  acIssuerStock?: Maybe<Scalars['String']>;
  acJir?: Maybe<Scalars['String']>;
  acKey?: Maybe<Scalars['String']>;
  acKeyView?: Maybe<Scalars['String']>;
  acLimitDuty?: Maybe<Scalars['String']>;
  acLoyaltyCard?: Maybe<Scalars['String']>;
  acNaturalPerson3?: Maybe<Scalars['String']>;
  acNaturalPersonI?: Maybe<Scalars['String']>;
  acNaturalPersonR?: Maybe<Scalars['String']>;
  acNote?: Maybe<Scalars['String']>;
  acNote2?: Maybe<Scalars['String']>;
  acNote3?: Maybe<Scalars['String']>;
  acNoteClerkName?: Maybe<Scalars['String']>;
  acPackNum?: Maybe<Scalars['String']>;
  acParity?: Maybe<Scalars['String']>;
  acParityPost?: Maybe<Scalars['String']>;
  acParityType?: Maybe<Scalars['String']>;
  acPayMethod?: Maybe<Scalars['String']>;
  acPayPurpose1?: Maybe<Scalars['String']>;
  acPayPurpose2?: Maybe<Scalars['String']>;
  acPayPurpose3?: Maybe<Scalars['String']>;
  acPosted?: Maybe<Scalars['String']>;
  acPriceRate?: Maybe<Scalars['String']>;
  acProc?: Maybe<Scalars['String']>;
  acPrsn3?: Maybe<Scalars['String']>;
  acPrsn3Name2?: Maybe<Scalars['String']>;
  acReceiver?: Maybe<Scalars['String']>;
  acReceiverName2?: Maybe<Scalars['String']>;
  acReceiverStock?: Maybe<Scalars['String']>;
  acRefNo1?: Maybe<Scalars['String']>;
  acRefNo2?: Maybe<Scalars['String']>;
  acRefNo3?: Maybe<Scalars['String']>;
  acRefNo4?: Maybe<Scalars['String']>;
  acRetailSale?: Maybe<Scalars['String']>;
  acRoundVatonDoc?: Maybe<Scalars['String']>;
  acStatement?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  acTrailerRegistrationNumber?: Maybe<Scalars['String']>;
  acTransPaperForm?: Maybe<Scalars['String']>;
  acTransportCalcType?: Maybe<Scalars['String']>;
  acTransporter?: Maybe<Scalars['String']>;
  acTriangTrans?: Maybe<Scalars['String']>;
  acUjpdocId?: Maybe<Scalars['String']>;
  acUserChgName?: Maybe<Scalars['String']>;
  acVatattType?: Maybe<Scalars['String']>;
  acVehicleRegistrationNumber?: Maybe<Scalars['String']>;
  acVerifiedPrices?: Maybe<Scalars['String']>;
  acVerifyStatus?: Maybe<Scalars['String']>;
  acWayOfSale?: Maybe<Scalars['String']>;
  acWayOfSale3?: Maybe<Scalars['String']>;
  acWayOfSaleR?: Maybe<Scalars['String']>;
  acXmldocType?: Maybe<Scalars['String']>;
  acZik?: Maybe<Scalars['String']>;
  adDate?: Maybe<Scalars['DateTime']>;
  adDateBeforeVat?: Maybe<Scalars['DateTime']>;
  adDateDdvpay?: Maybe<Scalars['DateTime']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  adDateDue?: Maybe<Scalars['DateTime']>;
  adDateInv?: Maybe<Scalars['DateTime']>;
  adDateTimePrint?: Maybe<Scalars['DateTime']>;
  adDateVat?: Maybe<Scalars['DateTime']>;
  adFieldDa?: Maybe<Scalars['DateTime']>;
  adFieldDb?: Maybe<Scalars['DateTime']>;
  adFieldDc?: Maybe<Scalars['DateTime']>;
  adFieldDd?: Maybe<Scalars['DateTime']>;
  adSigned1?: Maybe<Scalars['DateTime']>;
  adSigned2?: Maybe<Scalars['DateTime']>;
  adSigned3?: Maybe<Scalars['DateTime']>;
  adTimeChg?: Maybe<Scalars['DateTime']>;
  adTimeFiscal?: Maybe<Scalars['DateTime']>;
  adTimeIns?: Maybe<Scalars['DateTime']>;
  adVatattDate?: Maybe<Scalars['DateTime']>;
  anBnkAcctNo: Scalars['Int'];
  anCalcDiscPrc?: Maybe<Scalars['Float']>;
  anCalcSum?: Maybe<Scalars['Decimal']>;
  anClerk?: Maybe<Scalars['Int']>;
  anCurrValue: Scalars['Decimal'];
  anDaysForPayment: Scalars['Int'];
  anDirectCost: Scalars['Float'];
  anDiscount: Scalars['Decimal'];
  anDuty: Scalars['Decimal'];
  anFieldNa?: Maybe<Scalars['Decimal']>;
  anFieldNb?: Maybe<Scalars['Decimal']>;
  anFieldNc?: Maybe<Scalars['Decimal']>;
  anFieldNd?: Maybe<Scalars['Decimal']>;
  anFieldNe?: Maybe<Scalars['Decimal']>;
  anFieldNf?: Maybe<Scalars['Decimal']>;
  anFieldNg?: Maybe<Scalars['Decimal']>;
  anFieldNh?: Maybe<Scalars['Decimal']>;
  anFieldNi?: Maybe<Scalars['Decimal']>;
  anFieldNj?: Maybe<Scalars['Decimal']>;
  anForPay: Scalars['Decimal'];
  anFxrate: Scalars['Decimal'];
  anIncTax: Scalars['Decimal'];
  anNoteClerk?: Maybe<Scalars['Int']>;
  anOurBankAcctNo?: Maybe<Scalars['Int']>;
  anOurBankAcctNoFgn?: Maybe<Scalars['Int']>;
  anPermissionSelect: Scalars['Boolean'];
  anQidGdprlogS0?: Maybe<Scalars['Int']>;
  anQidGdprlogS1?: Maybe<Scalars['Int']>;
  anQidGdprlogS2?: Maybe<Scalars['Int']>;
  anRebate: Scalars['Decimal'];
  anReverseChargeCoefficient?: Maybe<Scalars['Float']>;
  anRoundItem: Scalars['Decimal'];
  anRoundItemFc: Scalars['Decimal'];
  anRoundPrice: Scalars['Decimal'];
  anRoundValue: Scalars['Decimal'];
  anRoundValueOc: Scalars['Decimal'];
  anSeqWhNoIn?: Maybe<Scalars['Int']>;
  anSeqWhNoOut?: Maybe<Scalars['Int']>;
  anSigner1?: Maybe<Scalars['Int']>;
  anSigner2?: Maybe<Scalars['Int']>;
  anSigner3?: Maybe<Scalars['Int']>;
  anState: Scalars['Int'];
  anTransport: Scalars['Decimal'];
  anUserChg?: Maybe<Scalars['Int']>;
  anUserIns?: Maybe<Scalars['Int']>;
  anValue: Scalars['Decimal'];
  anVat: Scalars['Decimal'];
  anVatbase: Scalars['Decimal'];
  anVatin: Scalars['Decimal'];
};

export type VHeMoveOutFilterInput = {
  acAcctClaimLiab?: InputMaybe<StringOperationFilterInput>;
  acCode1?: InputMaybe<StringOperationFilterInput>;
  acCode2?: InputMaybe<StringOperationFilterInput>;
  acCode3?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn?: InputMaybe<StringOperationFilterInput>;
  acContactPrsn3?: InputMaybe<StringOperationFilterInput>;
  acContractNo?: InputMaybe<StringOperationFilterInput>;
  acCostDrvOut?: InputMaybe<StringOperationFilterInput>;
  acCreatFromWo?: InputMaybe<StringOperationFilterInput>;
  acCreatePayOrd?: InputMaybe<StringOperationFilterInput>;
  acCurrency?: InputMaybe<StringOperationFilterInput>;
  acDelivery?: InputMaybe<StringOperationFilterInput>;
  acDeliveryUnderArt163a?: InputMaybe<StringOperationFilterInput>;
  acDept?: InputMaybe<StringOperationFilterInput>;
  acDeptOut?: InputMaybe<StringOperationFilterInput>;
  acDoc1?: InputMaybe<StringOperationFilterInput>;
  acDoc2?: InputMaybe<StringOperationFilterInput>;
  acDocType?: InputMaybe<StringOperationFilterInput>;
  acDocTypeStatusName?: InputMaybe<StringOperationFilterInput>;
  acFieldSa?: InputMaybe<StringOperationFilterInput>;
  acFieldSb?: InputMaybe<StringOperationFilterInput>;
  acFieldSc?: InputMaybe<StringOperationFilterInput>;
  acFieldSd?: InputMaybe<StringOperationFilterInput>;
  acFieldSe?: InputMaybe<StringOperationFilterInput>;
  acFieldSf?: InputMaybe<StringOperationFilterInput>;
  acFieldSg?: InputMaybe<StringOperationFilterInput>;
  acFieldSh?: InputMaybe<StringOperationFilterInput>;
  acFieldSi?: InputMaybe<StringOperationFilterInput>;
  acFieldSj?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookDocNo?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookSerNo?: InputMaybe<StringOperationFilterInput>;
  acFiscSalesBookSetNo?: InputMaybe<StringOperationFilterInput>;
  acFiscStatus?: InputMaybe<StringOperationFilterInput>;
  acFiscalNumber?: InputMaybe<StringOperationFilterInput>;
  acFiskPrintNo?: InputMaybe<StringOperationFilterInput>;
  acFiskPrintNoS?: InputMaybe<StringOperationFilterInput>;
  acForm?: InputMaybe<StringOperationFilterInput>;
  acIdbcstate?: InputMaybe<StringOperationFilterInput>;
  acInternalNote?: InputMaybe<StringOperationFilterInput>;
  acInvoiceForm?: InputMaybe<StringOperationFilterInput>;
  acIsocountry?: InputMaybe<StringOperationFilterInput>;
  acIssuer?: InputMaybe<StringOperationFilterInput>;
  acIssuerName2?: InputMaybe<StringOperationFilterInput>;
  acIssuerStock?: InputMaybe<StringOperationFilterInput>;
  acJir?: InputMaybe<StringOperationFilterInput>;
  acKey?: InputMaybe<StringOperationFilterInput>;
  acKeyView?: InputMaybe<StringOperationFilterInput>;
  acLimitDuty?: InputMaybe<StringOperationFilterInput>;
  acLoyaltyCard?: InputMaybe<StringOperationFilterInput>;
  acNaturalPerson3?: InputMaybe<StringOperationFilterInput>;
  acNaturalPersonI?: InputMaybe<StringOperationFilterInput>;
  acNaturalPersonR?: InputMaybe<StringOperationFilterInput>;
  acNote?: InputMaybe<StringOperationFilterInput>;
  acNote2?: InputMaybe<StringOperationFilterInput>;
  acNote3?: InputMaybe<StringOperationFilterInput>;
  acNoteClerkName?: InputMaybe<StringOperationFilterInput>;
  acPackNum?: InputMaybe<StringOperationFilterInput>;
  acParity?: InputMaybe<StringOperationFilterInput>;
  acParityPost?: InputMaybe<StringOperationFilterInput>;
  acParityType?: InputMaybe<StringOperationFilterInput>;
  acPayMethod?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose1?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose2?: InputMaybe<StringOperationFilterInput>;
  acPayPurpose3?: InputMaybe<StringOperationFilterInput>;
  acPosted?: InputMaybe<StringOperationFilterInput>;
  acPriceRate?: InputMaybe<StringOperationFilterInput>;
  acProc?: InputMaybe<StringOperationFilterInput>;
  acPrsn3?: InputMaybe<StringOperationFilterInput>;
  acPrsn3Name2?: InputMaybe<StringOperationFilterInput>;
  acReceiver?: InputMaybe<StringOperationFilterInput>;
  acReceiverName2?: InputMaybe<StringOperationFilterInput>;
  acReceiverStock?: InputMaybe<StringOperationFilterInput>;
  acRefNo1?: InputMaybe<StringOperationFilterInput>;
  acRefNo2?: InputMaybe<StringOperationFilterInput>;
  acRefNo3?: InputMaybe<StringOperationFilterInput>;
  acRefNo4?: InputMaybe<StringOperationFilterInput>;
  acRetailSale?: InputMaybe<StringOperationFilterInput>;
  acRoundVatonDoc?: InputMaybe<StringOperationFilterInput>;
  acStatement?: InputMaybe<StringOperationFilterInput>;
  acStatus?: InputMaybe<StringOperationFilterInput>;
  acTrailerRegistrationNumber?: InputMaybe<StringOperationFilterInput>;
  acTransPaperForm?: InputMaybe<StringOperationFilterInput>;
  acTransportCalcType?: InputMaybe<StringOperationFilterInput>;
  acTransporter?: InputMaybe<StringOperationFilterInput>;
  acTriangTrans?: InputMaybe<StringOperationFilterInput>;
  acUjpdocId?: InputMaybe<StringOperationFilterInput>;
  acUserChgName?: InputMaybe<StringOperationFilterInput>;
  acVatattType?: InputMaybe<StringOperationFilterInput>;
  acVehicleRegistrationNumber?: InputMaybe<StringOperationFilterInput>;
  acVerifiedPrices?: InputMaybe<StringOperationFilterInput>;
  acVerifyStatus?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale?: InputMaybe<StringOperationFilterInput>;
  acWayOfSale3?: InputMaybe<StringOperationFilterInput>;
  acWayOfSaleR?: InputMaybe<StringOperationFilterInput>;
  acXmldocType?: InputMaybe<StringOperationFilterInput>;
  acZik?: InputMaybe<StringOperationFilterInput>;
  adDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateBeforeVat?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDdvpay?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDoc2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateDue?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateInv?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateTimePrint?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adDateVat?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDa?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDb?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adFieldDd?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned1?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned2?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adSigned3?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeChg?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeFiscal?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adTimeIns?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  adVatattDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anBnkAcctNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  anCalcDiscPrc?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anCalcSum?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anCurrValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDaysForPayment?: InputMaybe<ComparableInt32OperationFilterInput>;
  anDirectCost?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anDiscount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anDuty?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFieldNa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNb?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNc?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNd?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNe?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNf?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNh?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anFieldNj?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anForPay?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anFxrate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anIncTax?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anNoteClerk?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOurBankAcctNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anOurBankAcctNoFgn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anPermissionSelect?: InputMaybe<BooleanOperationFilterInput>;
  anQidGdprlogS0?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidGdprlogS1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anQidGdprlogS2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anRebate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anReverseChargeCoefficient?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  anRoundItem?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundItemFc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anRoundValueOc?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anSeqWhNoIn?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSeqWhNoOut?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anSigner3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anState?: InputMaybe<ComparableInt32OperationFilterInput>;
  anTransport?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anUserChg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anUserIns?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  anValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVat?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatbase?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVatin?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<VHeMoveOutFilterInput>>;
  or?: InputMaybe<Array<VHeMoveOutFilterInput>>;
};

export type VopSetDept = {
  acSubject?: Maybe<Scalars['String']>;
};

export type VopSetDeptFilterInput = {
  acSubject?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<VopSetDeptFilterInput>>;
  or?: InputMaybe<Array<VopSetDeptFilterInput>>;
};

export type VopSetDeptSortInput = {
  acSubject?: InputMaybe<SortEnumType>;
};

export type VopSetItem = {
  acClassif?: Maybe<Scalars['String']>;
  acCustTariff?: Maybe<Scalars['String']>;
  acIdent?: Maybe<Scalars['String']>;
  acName?: Maybe<Scalars['String']>;
  acShowDays?: Maybe<Scalars['String']>;
  acdept?: Maybe<Scalars['String']>;
  anExcise: Scalars['Float'];
  anExciseP: Scalars['Float'];
  anExcisePercent?: Maybe<Scalars['Decimal']>;
  anExciseValue?: Maybe<Scalars['Decimal']>;
  anRtprice: Scalars['Float'];
  anSaleprice: Scalars['Decimal'];
  anVAT: Scalars['Decimal'];
  dutyAcSetOfTax?: Maybe<Scalars['String']>;
  dutyName?: Maybe<Scalars['String']>;
};

export type VopSetItemCateg = {
  acClassif?: Maybe<Scalars['String']>;
  acdept?: Maybe<Scalars['String']>;
};

export type VopSetItemCategFilterInput = {
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acdept?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<VopSetItemCategFilterInput>>;
  or?: InputMaybe<Array<VopSetItemCategFilterInput>>;
};

export type VopSetItemCategSortInput = {
  acClassif?: InputMaybe<SortEnumType>;
  acdept?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VopSetItemCategsPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<VopSetItemCategsPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<VopSetItemCateg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VopSetItemCategsPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VopSetItemCateg>;
};

export type VopSetItemFilterInput = {
  acClassif?: InputMaybe<StringOperationFilterInput>;
  acCustTariff?: InputMaybe<StringOperationFilterInput>;
  acIdent?: InputMaybe<StringOperationFilterInput>;
  acName?: InputMaybe<StringOperationFilterInput>;
  acShowDays?: InputMaybe<StringOperationFilterInput>;
  acdept?: InputMaybe<StringOperationFilterInput>;
  anExcise?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExciseP?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anExcisePercent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anExciseValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  anRtprice?: InputMaybe<ComparableDoubleOperationFilterInput>;
  anSaleprice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  anVAT?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<VopSetItemFilterInput>>;
  dutyAcSetOfTax?: InputMaybe<StringOperationFilterInput>;
  dutyName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VopSetItemFilterInput>>;
};

export type VopSetItemSortInput = {
  acClassif?: InputMaybe<SortEnumType>;
  acCustTariff?: InputMaybe<SortEnumType>;
  acIdent?: InputMaybe<SortEnumType>;
  acName?: InputMaybe<SortEnumType>;
  acShowDays?: InputMaybe<SortEnumType>;
  acdept?: InputMaybe<SortEnumType>;
  anExcise?: InputMaybe<SortEnumType>;
  anExciseP?: InputMaybe<SortEnumType>;
  anExcisePercent?: InputMaybe<SortEnumType>;
  anExciseValue?: InputMaybe<SortEnumType>;
  anRtprice?: InputMaybe<SortEnumType>;
  anSaleprice?: InputMaybe<SortEnumType>;
  anVAT?: InputMaybe<SortEnumType>;
  dutyAcSetOfTax?: InputMaybe<SortEnumType>;
  dutyName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VopSetItemsPagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<VopSetItemsPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<VopSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VopSetItemsPagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VopSetItem>;
};

export type VOpCashReg = {
  acDoctype?: Maybe<Scalars['String']>;
  acSubject?: Maybe<Scalars['String']>;
  ackey?: Maybe<Scalars['String']>;
  addate?: Maybe<Scalars['DateTime']>;
  anPaid: Scalars['Decimal'];
};

/** A connection to a list of items. */
export type VOpCashRegConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<VOpCashRegEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<VOpCashReg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VOpCashRegEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VOpCashReg>;
};

export type VOpCashRegFilterInput = {
  acDoctype?: InputMaybe<StringOperationFilterInput>;
  acSubject?: InputMaybe<StringOperationFilterInput>;
  ackey?: InputMaybe<StringOperationFilterInput>;
  addate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  anPaid?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<VOpCashRegFilterInput>>;
  or?: InputMaybe<Array<VOpCashRegFilterInput>>;
};

export type VOpCashRegSortInput = {
  acDoctype?: InputMaybe<SortEnumType>;
  acSubject?: InputMaybe<SortEnumType>;
  ackey?: InputMaybe<SortEnumType>;
  addate?: InputMaybe<SortEnumType>;
  anPaid?: InputMaybe<SortEnumType>;
};

export type VOpMoveBank = {
  ackey?: Maybe<Scalars['String']>;
  payerAddress?: Maybe<Scalars['String']>;
  payerNameAndSurname?: Maybe<Scalars['String']>;
  payerPostNumAndPlace?: Maybe<Scalars['String']>;
  purposeText?: Maybe<Scalars['String']>;
  receiverAddress?: Maybe<Scalars['String']>;
  receiverBank?: Maybe<Scalars['String']>;
  receiverCallOnNum?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  receiverPostNumAndPlace?: Maybe<Scalars['String']>;
  total: Scalars['Decimal'];
};

export type VOpSetBoatName = {
  acBoatName?: Maybe<Scalars['String']>;
  acsubject?: Maybe<Scalars['String']>;
  anLenght?: Maybe<Scalars['Float']>;
};

export type VOpSetBoatNameFilterInput = {
  acBoatName?: InputMaybe<StringOperationFilterInput>;
  acsubject?: InputMaybe<StringOperationFilterInput>;
  anLenght?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  and?: InputMaybe<Array<VOpSetBoatNameFilterInput>>;
  or?: InputMaybe<Array<VOpSetBoatNameFilterInput>>;
};

/** A connection to a list of items. */
export type VOpSetBoatNamePagedConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<VOpSetBoatNamePagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<VOpSetBoatName>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type VOpSetBoatNamePagedEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VOpSetBoatName>;
};

export type VOpSetBoatNameSortInput = {
  acBoatName?: InputMaybe<SortEnumType>;
  acsubject?: InputMaybe<SortEnumType>;
  anLenght?: InputMaybe<SortEnumType>;
};

export enum WakaTimeAuthorKind {
  Email = 'EMAIL',
  Name = 'NAME',
  Username = 'USERNAME'
}

export type WakaTimeAuthorKindOperationFilterInput = {
  eq?: InputMaybe<WakaTimeAuthorKind>;
  in?: InputMaybe<Array<WakaTimeAuthorKind>>;
  neq?: InputMaybe<WakaTimeAuthorKind>;
  nin?: InputMaybe<Array<WakaTimeAuthorKind>>;
};

export type WakaTimeCommit = {
  applicationUser: ApplicationUser;
  applicationUserId: Scalars['String'];
  authorDate?: Maybe<Scalars['DateTime']>;
  authorEmail?: Maybe<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  authorUsername?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  committerDate?: Maybe<Scalars['DateTime']>;
  committerEmail?: Maybe<Scalars['String']>;
  committerName?: Maybe<Scalars['String']>;
  committerUsername?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contextOnly: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  externalProjectName: Scalars['String'];
  hash: Scalars['String'];
  htmlUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  internalProject?: Maybe<Project>;
  internalProjectId?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  repositoryFullName?: Maybe<Scalars['String']>;
  repositoryProvider?: Maybe<Scalars['String']>;
  totalSeconds: Scalars['Int'];
  wakaTimeWorklog?: Maybe<WakaTimeWorklog>;
  wakaTimeWorklogId?: Maybe<Scalars['Int']>;
};

export type WakaTimeCommitFilterInput = {
  and?: InputMaybe<Array<WakaTimeCommitFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  authorDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  authorEmail?: InputMaybe<StringOperationFilterInput>;
  authorName?: InputMaybe<StringOperationFilterInput>;
  authorUsername?: InputMaybe<StringOperationFilterInput>;
  branch?: InputMaybe<StringOperationFilterInput>;
  committerDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  committerEmail?: InputMaybe<StringOperationFilterInput>;
  committerName?: InputMaybe<StringOperationFilterInput>;
  committerUsername?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contextOnly?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  externalProjectName?: InputMaybe<StringOperationFilterInput>;
  hash?: InputMaybe<StringOperationFilterInput>;
  htmlUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  internalProject?: InputMaybe<ProjectFilterInput>;
  internalProjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WakaTimeCommitFilterInput>>;
  repositoryFullName?: InputMaybe<StringOperationFilterInput>;
  repositoryProvider?: InputMaybe<StringOperationFilterInput>;
  totalSeconds?: InputMaybe<ComparableInt32OperationFilterInput>;
  wakaTimeWorklog?: InputMaybe<WakaTimeWorklogFilterInput>;
  wakaTimeWorklogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type WakaTimeWorklog = {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  commitCount: Scalars['Int'];
  commits?: Maybe<Array<Maybe<WakaTimeCommit>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  dismissed: Scalars['Boolean'];
  duration: Scalars['TimeSpan'];
  externalKey?: Maybe<Scalars['String']>;
  externalProjectName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  internalProject?: Maybe<Project>;
  internalProjectId?: Maybe<Scalars['Int']>;
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  sourceType: WakaTimeWorklogSourceType;
  summary?: Maybe<Scalars['String']>;
  supportTicket?: Maybe<SupportTicket>;
  supportTicketId?: Maybe<Scalars['Int']>;
  supportTicketTimeLog?: Maybe<SupportTicketTimeLog>;
  supportTicketTimeLogId?: Maybe<Scalars['Int']>;
  technicalNote?: Maybe<Scalars['String']>;
};

export type WakaTimeWorklogFilterInput = {
  and?: InputMaybe<Array<WakaTimeWorklogFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  commitCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  commits?: InputMaybe<ListFilterInputTypeOfWakaTimeCommitFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dismissed?: InputMaybe<BooleanOperationFilterInput>;
  duration?: InputMaybe<ComparableTimeSpanOperationFilterInput>;
  externalKey?: InputMaybe<StringOperationFilterInput>;
  externalProjectName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  internalProject?: InputMaybe<ProjectFilterInput>;
  internalProjectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WakaTimeWorklogFilterInput>>;
  sourceType?: InputMaybe<WakaTimeWorklogSourceTypeOperationFilterInput>;
  summary?: InputMaybe<StringOperationFilterInput>;
  supportTicket?: InputMaybe<SupportTicketFilterInput>;
  supportTicketId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supportTicketTimeLog?: InputMaybe<SupportTicketTimeLogFilterInput>;
  supportTicketTimeLogId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  technicalNote?: InputMaybe<StringOperationFilterInput>;
};

export enum WakaTimeWorklogSourceType {
  Activity = 'ACTIVITY',
  CodexTask = 'CODEX_TASK',
  Commit = 'COMMIT',
  Remainder = 'REMAINDER'
}

export type WakaTimeWorklogSourceTypeOperationFilterInput = {
  eq?: InputMaybe<WakaTimeWorklogSourceType>;
  in?: InputMaybe<Array<WakaTimeWorklogSourceType>>;
  neq?: InputMaybe<WakaTimeWorklogSourceType>;
  nin?: InputMaybe<Array<WakaTimeWorklogSourceType>>;
};

export enum WebAppMode {
  Portal = 'PORTAL',
  Standard = 'STANDARD'
}

export type WebAppRoutingDto = {
  autoRedirect: Scalars['Boolean'];
  hasClassicAccess: Scalars['Boolean'];
  hasTickets: Scalars['Boolean'];
  hasWebAppAccess: Scalars['Boolean'];
  mode: WebAppMode;
};

export enum WebBalanceState {
  NotConfigured = 'NOT_CONFIGURED',
  Ok = 'OK',
  Unavailable = 'UNAVAILABLE'
}

export type WebCustomerBalanceDto = {
  due?: Maybe<Scalars['Decimal']>;
  open?: Maybe<Scalars['Decimal']>;
  state: WebBalanceState;
};

export type WebDailyIncomeDayDto = {
  day?: Maybe<Scalars['String']>;
  total: Scalars['Decimal'];
};

export type WebDailyIncomeDto = {
  days?: Maybe<Array<Maybe<WebDailyIncomeDayDto>>>;
  documentTypeId: Scalars['Int'];
  openByPaymentMethod?: Maybe<Array<Maybe<WebDailyIncomePaymentDto>>>;
  openFromFiscalNumber?: Maybe<Scalars['Int']>;
  openToFiscalNumber?: Maybe<Scalars['Int']>;
  openTotal: Scalars['Decimal'];
};

export type WebDailyIncomePaymentDto = {
  amount: Scalars['Decimal'];
  paymentMethod?: Maybe<Scalars['String']>;
};

export type WebDmsStatusCountDto = {
  acName?: Maybe<Scalars['String']>;
  acStatus?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
};

export type WebDocumentDetailDto = {
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  acDocType: Scalars['String'];
  acKey: Scalars['String'];
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  canModify: Scalars['Boolean'];
  canVerify: Scalars['Boolean'];
  contact?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  customerAcSubject?: Maybe<Scalars['String']>;
  customerAddress?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerPost?: Maybe<Scalars['String']>;
  customerTaxNumber?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryDeadlineDays?: Maybe<Scalars['Int']>;
  deliveryMethodCode?: Maybe<Scalars['String']>;
  deliveryMethodName?: Maybe<Scalars['String']>;
  departmentAcSubject?: Maybe<Scalars['String']>;
  discount: Scalars['Decimal'];
  documentTypeId: Scalars['Int'];
  dueDate?: Maybe<Scalars['DateTime']>;
  eInvoiceReasonCode?: Maybe<Scalars['String']>;
  eInvoiceState?: Maybe<Scalars['String']>;
  emails: Array<WebDocumentEmailDto>;
  fields: Array<WebDocumentFieldDto>;
  fiscalError?: Maybe<Scalars['String']>;
  fiscalNumber?: Maybe<Scalars['String']>;
  fiscalPending: Scalars['Boolean'];
  fiscalized: Scalars['Boolean'];
  forPay: Scalars['Decimal'];
  jir?: Maybe<Scalars['String']>;
  lines: Array<WebDocumentLineDto>;
  note?: Maybe<Scalars['String']>;
  paymentMethodCode?: Maybe<Scalars['String']>;
  paymentMethodName?: Maybe<Scalars['String']>;
  relations: Array<WebDocumentRelationDto>;
  status?: Maybe<Scalars['String']>;
  thirdPartyAcSubject?: Maybe<Scalars['String']>;
  thirdPartyName?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
  vat: Scalars['Decimal'];
  warehouseAcSubject?: Maybe<Scalars['String']>;
  zki?: Maybe<Scalars['String']>;
};

export type WebDocumentEmailDto = {
  cc?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  sentAt?: Maybe<Scalars['DateTime']>;
  status: DocumentEmailDispatchStatus;
  subject?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type WebDocumentEmailInput = {
  acKey?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  copyToSender: Scalars['Boolean'];
  documentTypeId: Scalars['Int'];
  message?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type WebDocumentFieldDto = {
  arbitraryFieldId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type WebDocumentLineDto = {
  acIdent: Scalars['String'];
  anNo: Scalars['Int'];
  forPay: Scalars['Decimal'];
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  packageQuantity: Scalars['Decimal'];
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  rebate: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  unit?: Maybe<Scalars['String']>;
  unit2?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
  vatRate: Scalars['Decimal'];
};

export type WebDocumentListFilterInput = {
  customerAcSubject?: InputMaybe<Scalars['String']>;
  departmentAcSubject?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  fromAcKey?: InputMaybe<Scalars['String']>;
  onlyMine?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  toAcKey?: InputMaybe<Scalars['String']>;
};

export type WebDocumentRelationDto = {
  createdAt: Scalars['DateTime'];
  relation: DocumentRelationKind;
  sourceAcKey?: Maybe<Scalars['String']>;
  targetAcKey?: Maybe<Scalars['String']>;
  thisIsSource: Scalars['Boolean'];
};

export type WebDocumentStatusDto = {
  acKey?: Maybe<Scalars['String']>;
  eInvoiceState?: Maybe<Scalars['String']>;
  fiscalPending: Scalars['Boolean'];
  fiscalized: Scalars['Boolean'];
};

export type WebDraftDto = {
  acDoc1?: Maybe<Scalars['String']>;
  acDoc2?: Maybe<Scalars['String']>;
  adDateDoc1?: Maybe<Scalars['DateTime']>;
  adDateDoc2?: Maybe<Scalars['DateTime']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactEmailAuto: Scalars['Boolean'];
  contactName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerAcSubject?: Maybe<Scalars['String']>;
  deliveryDeadlineDays?: Maybe<Scalars['Int']>;
  deliveryMethodCode?: Maybe<Scalars['String']>;
  departmentAcSubject?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentPairId?: Maybe<Scalars['Int']>;
  documentTypeId: Scalars['Int'];
  dueDate?: Maybe<Scalars['DateTime']>;
  dueDateManual: Scalars['Boolean'];
  expectedTotal?: Maybe<Scalars['Decimal']>;
  fieldValues: Array<WebDraftFieldValueDto>;
  hiddenFromOtvoreno: Scalars['Boolean'];
  id: Scalars['UUID'];
  issuedAcKey?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  items: Array<WebDraftItemDto>;
  kind: DocumentDraftKind;
  lastError?: Maybe<Scalars['String']>;
  lastErrorCode?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  origin: DocumentDraftOrigin;
  paymentMethodCode?: Maybe<Scalars['String']>;
  sourceAcKey?: Maybe<Scalars['String']>;
  sourceRelation: DocumentRelationKind;
  status: DocumentDraftStatus;
  submissionUid: Scalars['UUID'];
  syncPackaging: Scalars['Boolean'];
  thirdPartyAcSubject?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Long'];
  warehouseAcSubject?: Maybe<Scalars['String']>;
};

export type WebDraftFieldValueDto = {
  arbitraryFieldId: Scalars['Int'];
  boolValue?: Maybe<Scalars['Boolean']>;
  dateValue?: Maybe<Scalars['DateTime']>;
  fieldNameSnapshot?: Maybe<Scalars['String']>;
  numberValue?: Maybe<Scalars['Decimal']>;
  textValue?: Maybe<Scalars['String']>;
};

export type WebDraftFieldValueInput = {
  arbitraryFieldId: Scalars['Int'];
  boolValue?: InputMaybe<Scalars['Boolean']>;
  dateValue?: InputMaybe<Scalars['DateTime']>;
  numberValue?: InputMaybe<Scalars['Decimal']>;
  textValue?: InputMaybe<Scalars['String']>;
};

export type WebDraftInput = {
  acDoc1?: InputMaybe<Scalars['String']>;
  acDoc2?: InputMaybe<Scalars['String']>;
  adDateDoc1?: InputMaybe<Scalars['DateTime']>;
  adDateDoc2?: InputMaybe<Scalars['DateTime']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactEmailAuto: Scalars['Boolean'];
  contactName?: InputMaybe<Scalars['String']>;
  customerAcSubject?: InputMaybe<Scalars['String']>;
  deliveryDeadlineDays?: InputMaybe<Scalars['Int']>;
  deliveryMethodCode?: InputMaybe<Scalars['String']>;
  departmentAcSubject?: InputMaybe<Scalars['String']>;
  documentDate?: InputMaybe<Scalars['DateTime']>;
  documentTypeId: Scalars['Int'];
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateManual: Scalars['Boolean'];
  fieldValues: Array<WebDraftFieldValueInput>;
  id?: InputMaybe<Scalars['UUID']>;
  items: Array<WebDraftItemInput>;
  note?: InputMaybe<Scalars['String']>;
  paymentMethodCode?: InputMaybe<Scalars['String']>;
  previewTotal?: InputMaybe<Scalars['Decimal']>;
  syncPackaging: Scalars['Boolean'];
  thirdPartyAcSubject?: InputMaybe<Scalars['String']>;
  warehouseAcSubject?: InputMaybe<Scalars['String']>;
};

export type WebDraftItemDto = {
  acIdent: Scalars['String'];
  id: Scalars['UUID'];
  lineNo: Scalars['Int'];
  nameSnapshot?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  packageQuantity?: Maybe<Scalars['Decimal']>;
  price: Scalars['Decimal'];
  priceIsGross: Scalars['Boolean'];
  priceSource: DocumentDraftPriceSource;
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  unit?: Maybe<Scalars['String']>;
  unit2?: Maybe<Scalars['String']>;
  unitToUnit2?: Maybe<Scalars['Decimal']>;
};

export type WebDraftItemInput = {
  acIdent: Scalars['String'];
  nameSnapshot?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  packageQuantity?: InputMaybe<Scalars['Decimal']>;
  price: Scalars['Decimal'];
  priceIsGross: Scalars['Boolean'];
  priceSource: DocumentDraftPriceSource;
  quantity: Scalars['Decimal'];
  rebate1: Scalars['Decimal'];
  rebate2: Scalars['Decimal'];
  rebate3: Scalars['Decimal'];
  unit?: InputMaybe<Scalars['String']>;
  unit2?: InputMaybe<Scalars['String']>;
  unitToUnit2?: InputMaybe<Scalars['Decimal']>;
};

export type WebDraftSaveResult = {
  conflict: Scalars['Boolean'];
  draft?: Maybe<WebDraftDto>;
};

export type WebDraftSummaryDto = {
  customerAcSubject?: Maybe<Scalars['String']>;
  expectedTotal?: Maybe<Scalars['Decimal']>;
  id: Scalars['UUID'];
  lastError?: Maybe<Scalars['String']>;
  lastErrorCode?: Maybe<Scalars['String']>;
  lineCount: Scalars['Int'];
  origin: DocumentDraftOrigin;
  sourceAcKey?: Maybe<Scalars['String']>;
  sourceRelation: DocumentRelationKind;
  status: DocumentDraftStatus;
  updatedAt: Scalars['DateTime'];
};

export type WebEmailSettingsDto = {
  canCopyToSender: Scalars['Boolean'];
  configured: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  senderEmail?: Maybe<Scalars['String']>;
};

export type WebFiscalRetryResult = {
  error?: Maybe<Scalars['String']>;
  fiscalized: Scalars['Boolean'];
  inProgress: Scalars['Boolean'];
  jir?: Maybe<Scalars['String']>;
};

export enum WebIssueOutcome {
  InProgress = 'IN_PROGRESS',
  Issued = 'ISSUED',
  Rejected = 'REJECTED',
  TotalMismatch = 'TOTAL_MISMATCH'
}

export type WebIssueProblem = {
  code?: Maybe<Scalars['String']>;
  fieldId?: Maybe<Scalars['Int']>;
  lineNo?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type WebIssueResult = {
  acKey?: Maybe<Scalars['String']>;
  draft?: Maybe<WebDraftDto>;
  outcome: WebIssueOutcome;
  problems?: Maybe<Array<Maybe<WebIssueProblem>>>;
  serverTotal?: Maybe<Scalars['Decimal']>;
};

export type WebItemClassificationDto = {
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type WebItemPrice = {
  acIdent?: Maybe<Scalars['String']>;
  gross: Scalars['Decimal'];
  net: Scalars['Decimal'];
  rebateDefault: Scalars['Decimal'];
  source: WebItemPriceSource;
};

export enum WebItemPriceSource {
  Contract = 'CONTRACT',
  None = 'NONE',
  PriceRate = 'PRICE_RATE',
  SubjectPriceList = 'SUBJECT_PRICE_LIST',
  WarehousePrice = 'WAREHOUSE_PRICE'
}

/** A connection to a list of items. */
export type WebItemSearchConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<WebItemSearchEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WebItemSearchEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetItem>;
};

export type WebItemSearchInput = {
  allWarehouses?: InputMaybe<Scalars['Boolean']>;
  classification?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Scalars['String']>;
  minStock?: InputMaybe<Scalars['Decimal']>;
  onlyContractPrices?: InputMaybe<Scalars['Boolean']>;
  onlyInStock?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  warehouse?: InputMaybe<Scalars['String']>;
};

export type WebListPreferenceDto = {
  customerAcSubject?: Maybe<Scalars['String']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateRange?: Maybe<DateFilterType>;
  dateTo?: Maybe<Scalars['DateTime']>;
  departmentAcSubject?: Maybe<Scalars['String']>;
  documentTypeId: Scalars['Int'];
  keyFrom?: Maybe<Scalars['String']>;
  keyTo?: Maybe<Scalars['String']>;
  lastOpenedAt?: Maybe<Scalars['DateTime']>;
  onlyMine?: Maybe<Scalars['Boolean']>;
};

/** A connection to a list of items. */
export type WebMoveListConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<WebMoveListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WebMoveListEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
};

/** A connection to a list of items. */
export type WebOrderListConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<WebOrderListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WebOrderListEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeOrder>;
};

export type WebPreferencesDto = {
  language?: Maybe<Scalars['String']>;
  lists?: Maybe<Array<Maybe<WebListPreferenceDto>>>;
  sidebarCollapsed: Scalars['Boolean'];
  sidebarMode: WebSidebarMode;
  theme?: Maybe<WebThemePreference>;
};

export enum WebSidebarMode {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

/** A connection to a list of items. */
export type WebSubjectHistoryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<WebSubjectHistoryEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeMove>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WebSubjectHistoryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeMove>;
};

export enum WebSubjectRole {
  All = 'ALL',
  Buyer = 'BUYER',
  Department = 'DEPARTMENT',
  Supplier = 'SUPPLIER',
  Warehouse = 'WAREHOUSE'
}

/** A connection to a list of items. */
export type WebSubjectSearchConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<WebSubjectSearchEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<THeSetSubj>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WebSubjectSearchEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<THeSetSubj>;
};

export type WebSubjectSearchInput = {
  onlyMine?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<WebSubjectRole>;
  search?: InputMaybe<Scalars['String']>;
  usedAs?: InputMaybe<WebSubjectUse>;
  usedOnThisType?: InputMaybe<Scalars['Boolean']>;
};

export enum WebSubjectUse {
  Department = 'DEPARTMENT',
  Receiver = 'RECEIVER',
  ThirdParty = 'THIRD_PARTY'
}

export enum WebThemePreference {
  Dark = 'DARK',
  Light = 'LIGHT',
  System = 'SYSTEM'
}

export type WikiEntry = {
  category?: Maybe<WikiEntryCategory>;
  categoryId?: Maybe<Scalars['Int']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  contentId: Scalars['Int'];
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  files?: Maybe<Array<Maybe<SavedFile>>>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Maybe<WikiEntryTag>>>;
  title?: Maybe<Scalars['String']>;
};

export type WikiEntryCategory = {
  children?: Maybe<Array<Maybe<WikiEntryCategory>>>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parent?: Maybe<WikiEntryCategory>;
  parentId?: Maybe<Scalars['Int']>;
  wikiEntries?: Maybe<Array<Maybe<WikiEntry>>>;
};

export type WikiEntryCategoryFilterInput = {
  and?: InputMaybe<Array<WikiEntryCategoryFilterInput>>;
  children?: InputMaybe<ListFilterInputTypeOfWikiEntryCategoryFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WikiEntryCategoryFilterInput>>;
  order?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  parent?: InputMaybe<WikiEntryCategoryFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  wikiEntries?: InputMaybe<ListFilterInputTypeOfWikiEntryFilterInput>;
};

export type WikiEntryCategorySortInput = {
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<WikiEntryCategorySortInput>;
  parentId?: InputMaybe<SortEnumType>;
};

export type WikiEntryFilterInput = {
  and?: InputMaybe<Array<WikiEntryFilterInput>>;
  category?: InputMaybe<WikiEntryCategoryFilterInput>;
  categoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  files?: InputMaybe<ListFilterInputTypeOfSavedFileFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WikiEntryFilterInput>>;
  tags?: InputMaybe<ListFilterInputTypeOfWikiEntryTagFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type WikiEntrySortInput = {
  category?: InputMaybe<WikiEntryCategorySortInput>;
  categoryId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  contentId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

export type WikiEntryTag = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  wikiEntries?: Maybe<Array<Maybe<WikiEntry>>>;
};

export type WikiEntryTagFilterInput = {
  and?: InputMaybe<Array<WikiEntryTagFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WikiEntryTagFilterInput>>;
  wikiEntries?: InputMaybe<ListFilterInputTypeOfWikiEntryFilterInput>;
};

export type WorkOrderStateViewModel = {
  workImages?: Maybe<Array<Maybe<TrimWorkOrderImageQuery>>>;
  workMaterial?: Maybe<Array<Maybe<TrimWorkOrderMaterialQuery>>>;
  workMove?: Maybe<TrimWorkOrderQuery>;
  workReceptions?: Maybe<Array<Maybe<TrimWorkOrderReceptionQuery>>>;
  workReclamations?: Maybe<Array<Maybe<TrimWorkOrderReclamationQuery>>>;
  workServices?: Maybe<Array<Maybe<TrimWorkOrderServiceQuery>>>;
  workSpec?: Maybe<Array<Maybe<TrimWorkOrderSpecQuery>>>;
};

export type WorkRecord = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  costBearer?: Maybe<Scalars['String']>;
  costBearerName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  subject?: Maybe<Scalars['String']>;
  workHours?: Maybe<Array<Maybe<WorkRecordWorkHours>>>;
  workRecordCostType?: Maybe<WorkRecordCostType>;
  workRecordCostTypeId?: Maybe<Scalars['Int']>;
  workRecordPeriod?: Maybe<WorkRecordPeriod>;
  workRecordPeriodId?: Maybe<Scalars['Int']>;
};

export type WorkRecordCostType = {
  active: Scalars['Boolean'];
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  costType?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  pantheonCostGroup?: Maybe<Scalars['String']>;
  pantheonCostGroupName?: Maybe<Scalars['String']>;
  pantheonCostType?: Maybe<Scalars['String']>;
  pantheonName?: Maybe<Scalars['String']>;
};

export type WorkRecordCostTypeFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<WorkRecordCostTypeFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  costType?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WorkRecordCostTypeFilterInput>>;
  pantheonCostGroup?: InputMaybe<StringOperationFilterInput>;
  pantheonCostGroupName?: InputMaybe<StringOperationFilterInput>;
  pantheonCostType?: InputMaybe<StringOperationFilterInput>;
  pantheonName?: InputMaybe<StringOperationFilterInput>;
};

export type WorkRecordFilterInput = {
  and?: InputMaybe<Array<WorkRecordFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  costBearer?: InputMaybe<StringOperationFilterInput>;
  costBearerName?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WorkRecordFilterInput>>;
  subject?: InputMaybe<StringOperationFilterInput>;
  workHours?: InputMaybe<ListFilterInputTypeOfWorkRecordWorkHoursFilterInput>;
  workRecordCostType?: InputMaybe<WorkRecordCostTypeFilterInput>;
  workRecordCostTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  workRecordPeriod?: InputMaybe<WorkRecordPeriodFilterInput>;
  workRecordPeriodId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type WorkRecordPeriod = {
  applicationUser?: Maybe<ApplicationUser>;
  applicationUserId?: Maybe<Scalars['String']>;
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  finalized: Scalars['Boolean'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  month: Scalars['Int'];
  readyToFinalize: Scalars['Boolean'];
  workRecords?: Maybe<Array<Maybe<WorkRecord>>>;
  year: Scalars['Int'];
};

export type WorkRecordPeriodFilterInput = {
  and?: InputMaybe<Array<WorkRecordPeriodFilterInput>>;
  applicationUser?: InputMaybe<ApplicationUserFilterInput>;
  applicationUserId?: InputMaybe<StringOperationFilterInput>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  finalized?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  month?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<WorkRecordPeriodFilterInput>>;
  readyToFinalize?: InputMaybe<BooleanOperationFilterInput>;
  workRecords?: InputMaybe<ListFilterInputTypeOfWorkRecordFilterInput>;
  year?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type WorkRecordPeriodSortInput = {
  applicationUser?: InputMaybe<ApplicationUserSortInput>;
  applicationUserId?: InputMaybe<SortEnumType>;
  companySettings?: InputMaybe<CompanySettingsSortInput>;
  companySettingsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdById?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  finalized?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modifiedBy?: InputMaybe<SortEnumType>;
  modifiedById?: InputMaybe<SortEnumType>;
  modifiedOn?: InputMaybe<SortEnumType>;
  month?: InputMaybe<SortEnumType>;
  readyToFinalize?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export type WorkRecordWorkHours = {
  companySettings?: Maybe<CompanySettings>;
  companySettingsId?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  createdById?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  day: Scalars['Byte'];
  id: Scalars['Int'];
  modifiedBy?: Maybe<Scalars['String']>;
  modifiedById?: Maybe<Scalars['String']>;
  modifiedOn?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['TimeSpan']>;
  workHours: Scalars['Byte'];
  workMinutes: Scalars['Byte'];
  workRecord?: Maybe<WorkRecord>;
  workRecordId?: Maybe<Scalars['Int']>;
};

export type WorkRecordWorkHoursFilterInput = {
  and?: InputMaybe<Array<WorkRecordWorkHoursFilterInput>>;
  companySettings?: InputMaybe<CompanySettingsFilterInput>;
  companySettingsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdById?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  day?: InputMaybe<ComparableByteOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifiedBy?: InputMaybe<StringOperationFilterInput>;
  modifiedById?: InputMaybe<StringOperationFilterInput>;
  modifiedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WorkRecordWorkHoursFilterInput>>;
  startTime?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  workHours?: InputMaybe<ComparableByteOperationFilterInput>;
  workMinutes?: InputMaybe<ComparableByteOperationFilterInput>;
  workRecord?: InputMaybe<WorkRecordFilterInput>;
  workRecordId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

/** A connection to a list of items. */
export type WorkflowTasksConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<WorkflowTasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TPaWorkflowTaskInstance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type WorkflowTasksEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TPaWorkflowTaskInstance>;
};

export type PHe_SearchContrctPriceDto = {
  acClassif?: Maybe<Scalars['String']>;
  acClassif2?: Maybe<Scalars['String']>;
  cIdent?: Maybe<Scalars['String']>;
  cKlasif?: Maybe<Scalars['String']>;
  cRetDobavniRok?: Maybe<Scalars['Int']>;
  cRetFormula?: Maybe<Scalars['String']>;
  cRetResult?: Maybe<Scalars['String']>;
  cRetRokPlacila?: Maybe<Scalars['Int']>;
  cRetSubjekt?: Maybe<Scalars['String']>;
  cRetTip?: Maybe<Scalars['String']>;
  cRetValuta?: Maybe<Scalars['String']>;
  cSubjekt?: Maybe<Scalars['String']>;
  cTipCenik?: Maybe<Scalars['String']>;
  cTipPartnerja?: Maybe<Scalars['String']>;
  classif2: Scalars['Boolean'];
  dDatum: Scalars['DateTime'];
  dRetDatumDO?: Maybe<Scalars['DateTime']>;
  dRetDatumOD?: Maybe<Scalars['DateTime']>;
  nRetCena?: Maybe<Scalars['Float']>;
  nRetCenaMP?: Maybe<Scalars['Float']>;
  nRetRabat?: Maybe<Scalars['Decimal']>;
  nRetRabat2?: Maybe<Scalars['Decimal']>;
  nRetRabat3?: Maybe<Scalars['Decimal']>;
  p_nRetDeliveryDeadline?: Maybe<Scalars['Int']>;
};

export type AddLurInvoiceMutationVariables = Exact<{
  invoice?: InputMaybe<SubmittingLurInvoiceViewModelInput>;
  docType: Scalars['Int'];
}>;


export type AddLurInvoiceMutation = { submitLURInvoice?: string };

export type AddSavedFileMutationVariables = Exact<{
  file: SavedFileDtoInput;
}>;


export type AddSavedFileMutation = { createSavedFile?: { id: number, name?: string, description?: string, uniqueClientId?: string } };

export type AddSingleTHeOrderMutationVariables = Exact<{
  docId: Scalars['Int'];
  acKey: Scalars['String'];
  item: CreateGenericDocumentItemDtoInput;
}>;


export type AddSingleTHeOrderMutation = { addSingleTHeOrderItem?: { acIdent?: string, anNo: number } };

export type AddTHeMoveWithFixedRebatesMutationVariables = Exact<{
  move: SubmittingMoveViewModelInput;
  docType: Scalars['Int'];
}>;


export type AddTHeMoveWithFixedRebatesMutation = { addTHeMoveWithFixedRebates?: string };

export type AddTHeOrderWithFixedRebatesMutationVariables = Exact<{
  order: SubmittingOrderViewModelInput;
  docType: Scalars['Int'];
}>;


export type AddTHeOrderWithFixedRebatesMutation = { addTHeOrderWithFixedRebates?: string };

export type AddWorkOrderImageMutationVariables = Exact<{
  data: TrimWorkOrderImageQueryInput;
}>;


export type AddWorkOrderImageMutation = { addWorkOrderImage?: { acKey?: string, anKey: any } };

export type AddWorkOrderMaterialMutationVariables = Exact<{
  data: SubmittingWorkOrderMaterialViewModelInput;
}>;


export type AddWorkOrderMaterialMutation = { addWorkOrderMaterial?: { acKey?: string, anNo: number } };

export type AddWorkOrderReceptionMutationVariables = Exact<{
  data: TrimWorkOrderReceptionQueryInput;
}>;


export type AddWorkOrderReceptionMutation = { addWorkOrderReception?: { acKey?: string, anNo: number } };

export type AddWorkOrderReclamationMutationVariables = Exact<{
  data: SubmittingWorkOrderMaterialViewModelInput;
}>;


export type AddWorkOrderReclamationMutation = { addWorkOrderReclamation?: { acKey?: string, anNo: number } };

export type AddWorkOrderServiceMutationVariables = Exact<{
  data: SubmittingWorkOrderMaterialViewModelInput;
}>;


export type AddWorkOrderServiceMutation = { addWorkOrderService?: { acKey?: string, anNo: number } };

export type AddWorkOrderSpecMutationVariables = Exact<{
  data: SubmittingWorkOrderWorkSpecViewModelInput;
}>;


export type AddWorkOrderSpecMutation = { addWorkOrderSpec?: { acKey?: string, anNo: number } };

export type AllAppUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AllAppUsersQuery = { users?: Array<{ id: string, userName?: string, firstName?: string, lastName?: string, fullName?: string, lastTokenRefresh: any, lastLogin: any, culture?: string, language?: string, companySettingsId?: number, timeZone?: string, lastDevice?: string, companySettings?: { id: number, pantheonCompanyName?: string } }> };

export type AnalysisActiveAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalysisActiveAccountsQuery = { allActiveAccounts?: { customer?: Array<{ code?: string, id: number, name?: string, type: AccountType }>, money?: Array<{ code?: string, id: number, name?: string, type: AccountType }>, supplier?: Array<{ code?: string, id: number, name?: string, type: AccountType }> } };

export type AnalysisBalanceForCustomerQueryVariables = Exact<{
  customer: Scalars['String'];
}>;


export type AnalysisBalanceForCustomerQuery = { analysisBalanceForCustomer?: { due: any, period: any } };

export type AnalysisCreateAccountMutationVariables = Exact<{
  dto: AccountDtoInput;
}>;


export type AnalysisCreateAccountMutation = { createAccount: boolean };

export type AnalysisDocumentsForCustomerQueryVariables = Exact<{
  customer: Scalars['String'];
  accountId: Scalars['Int'];
}>;


export type AnalysisDocumentsForCustomerQuery = { analysisDocumentsForCustomer?: Array<{ document?: string, value: any, date: any }> };

export type AnalysisMainPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalysisMainPageQueryQuery = { analysisTotals?: { customer?: Array<{ currency?: string, credit: any, creditInCurrency: any, debit: any, debitInCurrency: any, value: any, valueInCurrency: any }>, money?: Array<{ currency?: string, credit: any, creditInCurrency: any, debit: any, debitInCurrency: any, value: any, valueInCurrency: any }>, supplier?: Array<{ currency?: string, credit: any, creditInCurrency: any, debit: any, debitInCurrency: any, value: any, valueInCurrency: any }> } };

export type AnalysisPerAccountForTypeQueryVariables = Exact<{
  type: AccountType;
}>;


export type AnalysisPerAccountForTypeQuery = { analysisPerAccountForType?: Array<{ account?: string, name?: string, id: number, value?: Array<{ currency?: string, credit: any, creditInCurrency: any, debit: any, debitInCurrency: any, value: any, valueInCurrency: any }> }> };

export type AnalysisPerCustomerForAccountQueryVariables = Exact<{
  accountId: Scalars['Int'];
}>;


export type AnalysisPerCustomerForAccountQuery = { analysisPerCustomerForAccount?: Array<{ customer?: string, customerName?: string, value?: Array<{ currency?: string, credit: any, creditInCurrency: any, debit: any, debitInCurrency: any, value: any, valueInCurrency: any }> }> };

export type AnalysisRemoveAccountMutationVariables = Exact<{
  dto: AccountDtoInput;
}>;


export type AnalysisRemoveAccountMutation = { deleteAccount: boolean };

export type AnalysisTotalsForTypeQueryVariables = Exact<{
  type: AccountType;
}>;


export type AnalysisTotalsForTypeQuery = { analysisTotalsForType?: Array<{ currency?: string, value: any, valueInCurrency: any }> };

export type AttachBarcodeToIdentMutationVariables = Exact<{
  acIdent: Scalars['String'];
  barcode: Scalars['String'];
  acSubject: Scalars['String'];
}>;


export type AttachBarcodeToIdentMutation = { attachBarcodeToIdent: boolean };

export type CreateMoveFromAnotherDocumentMutationVariables = Exact<{
  dto?: InputMaybe<CreateGenericDocumentFromAnotherDtoInput>;
}>;


export type CreateMoveFromAnotherDocumentMutation = { createMoveFromAnotherDocument?: { acKey?: string } };

export type CreateMoveFromGenericDocumentMutationVariables = Exact<{
  dto?: InputMaybe<CreateGenericDocumentDtoInput>;
}>;


export type CreateMoveFromGenericDocumentMutation = { createMoveFromGenericDocument?: { acKey?: string } };

export type CreateOrderFromGenericDocumentMutationVariables = Exact<{
  dto?: InputMaybe<CreateGenericDocumentDtoInput>;
}>;


export type CreateOrderFromGenericDocumentMutation = { createOrderFromGenericDocument?: { acKey?: string } };

export type DailyRecapQueryVariables = Exact<{
  docType: Scalars['String'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type DailyRecapQuery = { dailyRecap: { fromDoc?: string, toDoc?: string, fromDate?: any, toDate?: any, items?: Array<{ paid: any, paymentType?: string }> } };

export type DeleteWorkOrderImageMutationVariables = Exact<{
  acKey: Scalars['String'];
  anKey: Scalars['Int'];
}>;


export type DeleteWorkOrderImageMutation = { deleteWorkOrderImage?: { acKey?: string, anKey: any } };

export type DeleteWorkOrderMaterialMutationVariables = Exact<{
  acKey: Scalars['String'];
  anNo: Scalars['Int'];
}>;


export type DeleteWorkOrderMaterialMutation = { deleteWorkOrderMaterial?: { acKey?: string, anNo: number } };

export type DeleteWorkOrderReceptionMutationVariables = Exact<{
  acKey: Scalars['String'];
  anNo: Scalars['Int'];
}>;


export type DeleteWorkOrderReceptionMutation = { deleteWorkOrderReception?: { acKey?: string, anNo: number } };

export type DeleteWorkOrderReclamationMutationVariables = Exact<{
  acKey: Scalars['String'];
  anNo: Scalars['Int'];
}>;


export type DeleteWorkOrderReclamationMutation = { deleteWorkOrderReclamation?: { acKey?: string, anNo: number } };

export type DeleteWorkOrderServiceMutationVariables = Exact<{
  acKey: Scalars['String'];
  anNo: Scalars['Int'];
}>;


export type DeleteWorkOrderServiceMutation = { deleteWorkOrderService?: { acKey?: string, anNo: number } };

export type DeleteWorkOrderSpecMutationVariables = Exact<{
  acKey: Scalars['String'];
  anNo: Scalars['Int'];
}>;


export type DeleteWorkOrderSpecMutation = { deleteWorkOrderSpec?: { acKey?: string, anNo: number } };

export type DeliveryNoteControlItemsQueryVariables = Exact<{
  acKey: Scalars['String'];
}>;


export type DeliveryNoteControlItemsQuery = { tHeMoveItem?: Array<{ acIdent?: string, anQty: any, acName?: string, acUm?: string, acNote?: string, anNo: number, anPackQty: any, acIdentNavigation?: { tHeSetItemExtItemSubj?: Array<{ acCode?: string }> } }> };

export type DeliveryNotesControlPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  docType: Scalars['String'];
  fromDate: Scalars['DateTime'];
  toDate: Scalars['DateTime'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type DeliveryNotesControlPagedQuery = { tHeMovePaged?: { nodes?: Array<{ acKey?: string, acNote?: string, acDoc2?: string, adTimeIns?: any, acPrsn3?: string, acCurrency?: string, acReceiver?: string, acDocType?: string }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type DemoLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type DemoLoginMutation = { demoLogin?: string };

export type DepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type DepartmentsQuery = { tHeSetSubj?: Array<{ acSubject?: string, acName2?: string }> };

export type EndWorkOrderMutationVariables = Exact<{
  data: SubmittingWorkOrderEndViewModelInput;
}>;


export type EndWorkOrderMutation = { endWorkOrder?: { acKey?: string } };

export type FinalizeDailyIncomeMutationVariables = Exact<{
  acDocType: Scalars['String'];
}>;


export type FinalizeDailyIncomeMutation = { finalizeDailyIncome: boolean };

export type FinishDeliveryNotesControlMutationVariables = Exact<{
  acKey: Scalars['String'];
}>;


export type FinishDeliveryNotesControlMutation = { finishDeliveryNotesControl: boolean };

export type FinishDeliveryNotesControlPartialMutationVariables = Exact<{
  acKey: Scalars['String'];
  items: Array<InputMaybe<PartialFinishDeliveryNotesItemDtoInput>> | InputMaybe<PartialFinishDeliveryNotesItemDtoInput>;
}>;


export type FinishDeliveryNotesControlPartialMutation = { finishDeliveryNotesControlPartial: boolean };

export type GetMarservisUserWorkOrderItemWorksQueryVariables = Exact<{
  itemId: Scalars['Int'];
}>;


export type GetMarservisUserWorkOrderItemWorksQuery = { marservisWorkOrderItemWorks?: Array<{ id: number, workOrderItemId: number, time: any, date: any, cause?: string, remedy?: string, note?: string, materials?: string }> };

export type GetMarservisUserWorkOrderItemsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
}>;


export type GetMarservisUserWorkOrderItemsQuery = { marservisUserWorkOrderItems?: { nodes?: Array<{ id: number, subjectId?: number, projectName?: string, subjectShortName?: string, subjectLongName?: string, workOrderStatus?: MarservisWorkOrderStatusEnum, workOrderLocation?: string, workOrderDateEnd?: any, workOrderId?: string, deadlineDate?: any, note?: string, itemName?: string, itemCode?: string, itemId?: number, status: MarservisWorkOrderItemStatusEnum }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type GetMarservisWorkOrderItemStatusQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetMarservisWorkOrderItemStatusQuery = { marservisWorkOrderItemStatus: MarservisWorkOrderItemStatusEnum };

export type GetMarservisWorkOrderItemsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
  workOrderId: Scalars['String'];
}>;


export type GetMarservisWorkOrderItemsQuery = { marservisUserWorkOrderItems?: { nodes?: Array<{ id: number, subjectId?: number, projectName?: string, subjectShortName?: string, subjectLongName?: string, workOrderStatus?: MarservisWorkOrderStatusEnum, workOrderLocation?: string, workOrderDateEnd?: any, workOrderId?: string, deadlineDate?: any, note?: string, itemName?: string, itemCode?: string, itemId?: number, status: MarservisWorkOrderItemStatusEnum }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type GetMarservisWorkOrdersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetMarservisWorkOrdersQuery = { marservisUserWorkOrders?: { nodes?: Array<{ id?: string, dateEnd: any, hasFiles: boolean, documentNumber: number, date: any, note?: string, status: MarservisWorkOrderStatusEnum, location?: string, project?: { name?: string }, subject?: { shortName?: string, longName?: string } }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type GetTHeOrdersQueryVariables = Exact<{
  where?: InputMaybe<THeOrderFilterInput>;
  order?: InputMaybe<Array<THeOrderSortInput> | THeOrderSortInput>;
}>;


export type GetTHeOrdersQuery = { tHeOrder?: Array<{ acKey?: string, acConsignee?: string, acReceiver?: string, acWarehouse?: string, acStatus?: string, adDate?: any, acNote?: string, acContactPrsn?: string, acContactPrsn3?: string, anForPay: any, acStatusNavigation?: { acName?: string }, tHeOrderItem?: Array<{ anNo: number, acName?: string, acIdent?: string, acNote?: string }> }> };

export type GetUserTokenQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserTokenQuery = { loginAsUser?: string };

export type GetWorkOrderQueryVariables = Exact<{
  acKey: Scalars['String'];
}>;


export type GetWorkOrderQuery = { workOrder?: { workImages?: Array<{ acLnkKey?: string, acName?: string, anKey?: any }>, workMaterial?: Array<{ acIdent?: string, acKey?: string, acName?: string, acNote?: string, acSerialNo?: string, acUm?: string, anNo: number, anQty: any }>, workMove?: { acContactPrsn?: string, acContactPrsn3?: string, acDept?: string, acDocType?: string, acFieldSA?: string, acIssuer?: string, acKey?: string, acNote?: string, acVerifyStatus?: string, adDate?: any, adFieldDA?: any, adTimeIns?: any, anClerkAcName?: string, anClerkAcSurname?: string, anFieldNA?: any, anFieldNB?: any, bearerAddress?: string, bearerName?: string, bearerPIN?: string, bearerPostName?: string, bearerPost?: string, customerAddress?: string, customerName?: string, customerPIN?: string, customerPostName?: string, customerPost?: string }, workReceptions?: Array<{ acIdent?: string, acKey?: string, acName?: string, acNote?: string, acSerialNo?: string, acSetOfItem?: string, acUm?: string, anNo?: number, anQty: any }>, workReclamations?: Array<{ acIdent?: string, acKey?: string, acName?: string, acNote?: string, acUm?: string, anNo: number, anQty: any }>, workServices?: Array<{ acIdent?: string, acKey?: string, acName?: string, acNote?: string, acUm?: string, anNo: number, anQty: any }>, workSpec?: Array<{ _AcNote2?: string, acIdent?: string, acKey?: string, acName?: string, acWorker?: string, adWorkEnd?: any, adWorkStart?: any, anMileage?: any, anNo: number, anWork?: any }> } };

export type GetWorkOrderPdfQueryVariables = Exact<{
  acKey: Scalars['String'];
}>;


export type GetWorkOrderPdfQuery = { workOrderPDF?: { data?: Array<any> } };

export type LastTHeMoveAcKeyQueryVariables = Exact<{
  acDocType: Scalars['String'];
}>;


export type LastTHeMoveAcKeyQuery = { singleTHeMoveSortable?: { acKey?: string } };

export type LicenseTakeOverMutationVariables = Exact<{ [key: string]: never; }>;


export type LicenseTakeOverMutation = { licenseTakeOver?: string };

export type LoginMutationVariables = Exact<{
  userNameOrEmail: Scalars['String'];
  password: Scalars['String'];
  takeLicense?: InputMaybe<Scalars['Boolean']>;
}>;


export type LoginMutation = { login?: string };

export type LurInvoiceItemsQueryVariables = Exact<{
  ackey: Scalars['String'];
}>;


export type LurInvoiceItemsQuery = { tHeMoveItem?: Array<{ acName?: string, acIdent?: string, anRebate: number, anPrice: number, anQty: any, anPackQty: any, acUm?: string, acNote?: string, anNo: number, acUM2?: string, acKey?: string, anRebate1: number, anRebate2: number, anRebate3: number, anWarrenty: number, anPvforPay: any, anPvvat: any, acVatcode?: string, anPvocvat: any, anDimWeight: number, acIdentNavigation?: { acIdent?: string, acCode?: string, anUmtoUm2: any, acDescr?: string } }> };

export type LurInvoiceListPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  docTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  fromDate: Scalars['DateTime'];
  toDate: Scalars['DateTime'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type LurInvoiceListPagedQuery = { lURInvoiceListItems?: { nodes?: Array<{ acKey?: string, acNote?: string, adTimeIns?: any, acPrsn3?: string, anForPay: any, acVerifiedPrices?: string, acHrFiskalNumber?: string, acPayMethod?: string, acDept?: string, acDoc1?: string, acDoc2?: string, acCurrency?: string, acReceiver?: string }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type LurInvoicePdfQueryVariables = Exact<{
  ackey: Scalars['String'];
}>;


export type LurInvoicePdfQuery = { lURInvoicePDF?: { acKey?: string, adDate?: any, acReceiver?: string, acNote?: string, adDateTimePrint?: any, anFieldNB?: any, acDocType?: string, acPrsn3?: string, acCurrency?: string, anValue: any, anDiscount: any, anVat: any, anForPay: any, acDoc1?: string, acDoc2?: string, acDept?: string, acReceiverNavigation?: { acPin?: string, acName2?: string, acAddress?: string, acPostNavigation?: { acPost?: string, acName?: string } }, acPrsn3Navigation?: { acAddress?: string, acPost?: string, acName2?: string, acPostNavigation?: { acPost?: string, acName?: string } }, tHeMoveItem?: Array<{ acUm?: string, anQty: any, acName?: string, acIdent?: string, anPrice: number, anRebate: number, acNote?: string, anPvforPay: any, anPvvat: any, acVatcode?: string, anPvocvat: any, acIdentNavigation?: { acCode?: string, acClassif?: string, acDescr?: string }, tHeMoveItemSerialNo?: Array<{ acSerialNo?: string, anQty: any }>, acVatcodeNavigation?: { acVatcode?: string, anVat: any } }>, anNoteClerkNavigation?: { acName?: string, acSurname?: string }, acDeliveryNavigation?: { acName?: string }, acPayMethodNavigation?: { acName?: string, acFiscalGroup?: string }, anClerkNavigation?: { acName?: string, acSurname?: string } }, singleVHeMoveFiscalisation?: { acHrfiskalNumber?: string } };

export type MarkOnixPhoneUserTaskQueueMutationVariables = Exact<{
  taskId: Scalars['Int'];
  response?: InputMaybe<Scalars['String']>;
  failed: Scalars['Boolean'];
}>;


export type MarkOnixPhoneUserTaskQueueMutation = { markOnixPhoneUserTaskQueue: boolean };

export type MarservisAddWorkMutationVariables = Exact<{
  work: MarservisWorkOrderItemWorkDtoInput;
}>;


export type MarservisAddWorkMutation = { createMarservisWorkOrderItemWork: boolean };

export type MarservisDeleteWorkMutationVariables = Exact<{
  work: MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput;
}>;


export type MarservisDeleteWorkMutation = { deleteMarservisWorkOrderItemWork: boolean };

export type MarservisUpdateWorkMutationVariables = Exact<{
  work: MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput;
}>;


export type MarservisUpdateWorkMutation = { updateMarservisWorkOrderItemWork: boolean };

export type MarservisWorkOrderItemSavedFilesQueryVariables = Exact<{
  workOrderId: Scalars['String'];
}>;


export type MarservisWorkOrderItemSavedFilesQuery = { marservisWorkOrderSavedFiles?: Array<{ id: number, workOrderId?: string, name?: string, description?: string }> };

export type MarservisWorkOrderItemWorkSavedFilesQueryVariables = Exact<{
  workOrderWorkId: Scalars['Int'];
  uniqueClientId: Scalars['String'];
}>;


export type MarservisWorkOrderItemWorkSavedFilesQuery = { savedFiles?: Array<{ id: number, workOrderId?: string, name?: string, description?: string }> };

export type MoneyAccountsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type MoneyAccountsQuery = { tDeSetAccountPaged?: { nodes?: Array<{ acAcct?: string, acName?: string, acPermitPost?: string }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type NullWorkOrdersPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  anClerk: Scalars['Int'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type NullWorkOrdersPagedQuery = { tHeMovePaged?: { nodes?: Array<{ acKey?: string, adTimeIns?: any, acFieldSA?: string, acIssuer?: string, acNote?: string, acContactPrsn?: string }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type OnixPhoneUserTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type OnixPhoneUserTasksQuery = { onixPhoneUserTaskQueue?: Array<{ id: number, task: OnixPhoneUserTaskEnum, taskData?: string, isCompleted: boolean }> };

export type PickingOrderQueryVariables = Exact<{
  acKey: Scalars['String'];
  warehouse?: InputMaybe<Scalars['String']>;
}>;


export type PickingOrderQuery = { singleTHeOrder?: { acKey?: string, acConsignee?: string, acReceiver?: string, acStatus?: string, acNote?: string, tHeOrderItem?: Array<{ anNo: number, acIdent?: string, acName?: string, anQty: any, anRebate: number, anRebate1: number, anRebate2: number, anRebate3: number, anPrice: number, anPackQty: any, acNote?: string, anReserved: any, anQtyDispDoc: any, acIdentNavigation?: { acQtyInCode?: string, anQtyInCodeDecPlace: number, acSerialNo?: string, acFieldsA?: string, acFieldSb?: string, acFieldSc?: string, acFieldSd?: string, acFieldSe?: string, acFieldSf?: string, acFieldSg?: string, acFieldSh?: string, acFieldSi?: string, acFieldSj?: string, tHeSetItemExtItemSubj?: Array<{ acCode?: string }>, tHeStock?: Array<{ anStock: any, anReserved: any }> } }>, acConsigneeNavigation?: { acSubject?: string, acPin?: string, acName2?: string, acPost?: string, acAddress?: string, anRebate: any, acPayer?: string, acPriceRate?: string, acPostNavigation?: { acName?: string }, acPayerNavigation?: { acPayer?: string, anRebate: any, acPin?: string, acName2?: string, acPost?: string, acAddress?: string, acPriceRate?: string, acPostNavigation?: { acName?: string } } } } };

export type ReceptionsPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type ReceptionsPagedQuery = { tHeSetItemPaged?: { nodes?: Array<{ acIdent?: string, acName?: string, acNote?: string, acUm?: string, acSetOfItem?: string }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { refreshToken?: string };

export type RegisterNewVersionMutationVariables = Exact<{
  register?: InputMaybe<NewVersionDtoInput>;
}>;


export type RegisterNewVersionMutation = { registerNewVersion?: { platform?: string, version?: string } };

export type RemoveSavedFileMutationVariables = Exact<{
  fileId: Scalars['Int'];
}>;


export type RemoveSavedFileMutation = { deleteSavedFile: number };

export type RemoveTHeMoveItemMutationVariables = Exact<{
  acKey: Scalars['String'];
  anNo: Scalars['Int'];
  docType: Scalars['Int'];
}>;


export type RemoveTHeMoveItemMutation = { removeTHeMoveItem: boolean };

export type RemoveTHeOrderItemMutationVariables = Exact<{
  acKey: Scalars['String'];
  anNo: Scalars['Int'];
  docType: Scalars['Int'];
}>;


export type RemoveTHeOrderItemMutation = { removeTHeOrderItem: boolean };

export type SaveMobileSettingsMutationVariables = Exact<{
  settings: MobileSettingsUpdateDtoInput;
}>;


export type SaveMobileSettingsMutation = { updateMobileSettings?: { bluetoothPrinterAddress?: string, bluetoothPrinterName?: string, bluetoothPrinterPaperWidth?: number, bluetoothPrinterType?: string, createdOn?: any, modifiedBy?: string, modifiedOn?: any, useDarkTheme: boolean, useListViewOnPickers: boolean, useTabletMode?: boolean, useOnlyShortcuts: boolean } };

export type SavedFilesQueryVariables = Exact<{
  workOrderItemWorkId?: InputMaybe<Scalars['Int']>;
  uniqueClientId?: InputMaybe<Scalars['String']>;
}>;


export type SavedFilesQuery = { savedFiles?: Array<{ id: number, name?: string, description?: string }> };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type SetPasswordMutation = { setPassword: boolean };

export type SingleTHeFaQueryVariables = Exact<{
  inventNum: Scalars['String'];
  acType: Scalars['String'];
}>;


export type SingleTHeFaQuery = { singleTHeFa?: { acActive?: string, acInventNum?: string, acName?: string, acNote?: string, acType?: string, adDateOfAcq?: any, anQty: any } };

export type SingleTHeMoveQueryVariables = Exact<{
  acKey: Scalars['String'];
}>;


export type SingleTHeMoveQuery = { singleTHeMove?: { acKey?: string, acNote?: string, acDoc2?: string, adTimeIns?: any, acPrsn3?: string, acCurrency?: string, acReceiver?: string, acDocType?: string, anForPay: any, acVerifiedPrices?: string, acPayMethod?: string, acPayMethodNavigation?: { acName?: string } } };

export type SingleTHeOrderQueryVariables = Exact<{
  acKey: Scalars['String'];
}>;


export type SingleTHeOrderQuery = { singleTHeOrder?: { acKey?: string, acNote?: string, adDate?: any, acConsignee?: string, acReceiver?: string, adTimeIns?: any, acCurrency?: string, anForPay: any, acDoc2?: string, acDocType?: string, acPayMethod?: string, acPayMethodNavigation?: { acName?: string } } };

export type SingleTHeSetSubjQueryVariables = Exact<{
  acSubject: Scalars['String'];
}>;


export type SingleTHeSetSubjQuery = { singleTHeSetSubj?: { acSubject?: string, acName2?: string, anRebate: any, acPin?: string } };

export type StartWorkOrderMutationVariables = Exact<{
  data: SubmittingWorkOrderViewModelInput;
  docType: Scalars['Int'];
}>;


export type StartWorkOrderMutation = { startWorkOrder?: { acKey?: string } };

export type TDeSetAccountPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  codeLike: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type TDeSetAccountPagedQuery = { tDeSetAccountPaged?: { nodes?: Array<{ acAcct?: string, acName?: string }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type THeCashRegPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type THeCashRegPagedQuery = { tHeCashRegPaged?: { nodes?: Array<{ acKey?: string, anRefund: any, adDateDoc1?: any, adDateDoc2?: any, tHeCashRegItems?: Array<{ acPayMethod?: string }> }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type THeCashRegItemQueryVariables = Exact<{
  acKey: Scalars['String'];
}>;


export type THeCashRegItemQuery = { tHeCashRegItems?: Array<{ anAmount: any, acPayMethodNavigation?: { acName?: string } }> };

export type THeCostDrvPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type THeCostDrvPagedQuery = { tHeCostDrvPaged?: { nodes?: Array<{ acCostDrv?: string, acName?: string, acConsignee?: string, acStatus?: string }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type THeFaPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type THeFaPagedQuery = { tHeFaPaged?: { nodes?: Array<{ acActive?: string, acInventNum?: string, acName?: string, acNote?: string }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type THeMoveDailyIncomeQueryVariables = Exact<{
  acDocType: Scalars['String'];
}>;


export type THeMoveDailyIncomeQuery = { tHeMoveDailyIncomeSummary?: { fromDate?: any, toDate?: any, fromDoc?: number, toDoc?: number, items?: Array<{ anForPay: any, payMethodName?: string }> } };

export type THeMoveItemsQueryVariables = Exact<{
  ackey: Scalars['String'];
  warehouse: Scalars['String'];
}>;


export type THeMoveItemsQuery = { tHeMoveItem?: Array<{ acName?: string, acIdent?: string, anRebate: number, anPrice: number, anQty: any, anPackQty: any, acUm?: string, acNote?: string, anNo: number, acUM2?: string, acKey?: string, anRebate1: number, anRebate2: number, anRebate3: number, acIdentNavigation?: { acIdent?: string, acName?: string, acUm?: string, acCode?: string, acNote?: string, acSetOfItem?: string, anRtPrice: number, anWsprice: number, acUm2?: string, anUmtoUm2: any, acActive?: string, anWsprice2: number, anExcise: number, anQtyInCodeDecPlace: number, acQtyInCode?: string, tHeStock?: Array<{ anStock: any, anReserved: any }> } }> };

export type THeMovePagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  docTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  cursor?: InputMaybe<Scalars['String']>;
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acVerifiedPrices?: InputMaybe<Scalars['String']>;
  acVerifyStatus?: InputMaybe<Scalars['String']>;
}>;


export type THeMovePagedQuery = { tHeMovePagedParametrized?: { nodes?: Array<{ acKey?: string, acNote?: string, acDoc2?: string, adTimeIns?: any, acPrsn3?: string, acCurrency?: string, acReceiver?: string, acDocType?: string, anForPay: any, acVerifiedPrices?: string, acPayMethod?: string, adDate?: any, adDateTimePrint?: any, adDateDue?: any, acPayMethodNavigation?: { acName?: string } }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type THeMovePdfQueryVariables = Exact<{
  ackey: Scalars['String'];
}>;


export type THeMovePdfQuery = { tHeMoveSignature?: Array<any>, singleTHeMove?: { acKey?: string, adDate?: any, adDateDue?: any, acReceiver?: string, acNote?: string, adDateTimePrint?: any, acPrsn3?: string, acCurrency?: string, anValue: any, anDiscount: any, anVat: any, anForPay: any, acDoc1?: string, acDoc2?: string, acDept?: string, acDocType?: string, acReceiverNavigation?: { acPin?: string, acName2?: string, acAddress?: string, acPostNavigation?: { acPost?: string, acName?: string } }, acPrsn3Navigation?: { acAddress?: string, acPost?: string, acName2?: string, acPin?: string, acPostNavigation?: { acPost?: string, acName?: string } }, tHeMoveItem?: Array<{ acUm?: string, anQty: any, acName?: string, acIdent?: string, anPrice: number, anRebate: number, acNote?: string, anPvforPay: any, anPvvat: any, acVatcode?: string, anPvocvat: any, anPvexcise: any, acIdentNavigation?: { acCode?: string, acClassif?: string }, tHeMoveItemSerialNo?: Array<{ acSerialNo?: string, anQty: any }>, acVatcodeNavigation?: { acVatcode?: string, anVat: any } }>, anNoteClerkNavigation?: { acName?: string, acSurname?: string }, acDeliveryNavigation?: { acName?: string }, acPayMethodNavigation?: { acName?: string, acFiscalGroup?: string }, anClerkNavigation?: { acName?: string, acSurname?: string } }, singleVHeMoveFiscalisation?: { acHrfiskalNumber?: string } };

export type THeMoveWorkOrdersPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  docTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  anUserId: Scalars['Int'];
  fromDate: Scalars['DateTime'];
  toDate: Scalars['DateTime'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type THeMoveWorkOrdersPagedQuery = { tHeMovePaged?: { nodes?: Array<{ acKey?: string, adTimeIns?: any, adFieldDA?: any, acFieldSA?: string, acIssuer?: string, acNote?: string, anClerk?: number, acDocType?: string }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type THeOrderItemsQueryVariables = Exact<{
  ackey: Scalars['String'];
  warehouse: Scalars['String'];
}>;


export type THeOrderItemsQuery = { tHeOrderItem?: Array<{ acName?: string, acIdent?: string, anRebate: number, anPrice: number, acUm?: string, acNote?: string, anQty: any, anNo: number, acKey?: string, anRebate1: number, anRebate2: number, anRebate3: number, anPackQty: any, acUM2?: string, anSalePrice: any, anRetailPrice: any, anRtprice?: any, acIdentNavigation?: { acIdent?: string, acName?: string, acUm?: string, acCode?: string, acNote?: string, acSetOfItem?: string, anRtPrice: number, anWsprice: number, acUm2?: string, anUmtoUm2: any, acActive?: string, anWsprice2: number, anExcise: number, anQtyInCodeDecPlace: number, acQtyInCode?: string, tHeStock?: Array<{ anStock: any, anReserved: any }> } }> };

export type THeOrderPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  docTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  cursor?: InputMaybe<Scalars['String']>;
  acDelivery?: InputMaybe<Scalars['String']>;
  acDept?: InputMaybe<Scalars['String']>;
  acStatus?: InputMaybe<Scalars['String']>;
  useDeliveryDeadline: Scalars['Boolean'];
  acStatusNotIn?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  acStatusIn?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type THeOrderPagedQuery = { tHeOrderPagedParametrized?: { nodes?: Array<{ acKey?: string, acNote?: string, adDate?: any, acConsignee?: string, acReceiver?: string, adTimeIns?: any, acCurrency?: string, anForPay: any, acDoc2?: string, acDocType?: string, adDeliveryDeadline?: any, acPayMethod?: string, acStatus?: string, acPayMethodNavigation?: { acName?: string } }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type THeOrderPdfQueryVariables = Exact<{
  ackey: Scalars['String'];
}>;


export type THeOrderPdfQuery = { singleTHeOrder?: { acKey?: string, adDate?: any, adTimeIns?: any, anValue: any, anDiscount: any, anVat: any, acCurrency?: string, anForPay: any, acDoc2?: string, acNote?: string, acDocType?: string, anClerkNavigation?: { acName?: string, acSurname?: string }, acConsigneeNavigation?: { acName2?: string, acPin?: string, acAddress?: string, acPost?: string, acPostNavigation?: { acName?: string, acPost?: string } }, tHeOrderItem?: Array<{ acIdent?: string, acName?: string, anQty: any, anPrice: number, acNote?: string, acUm?: string, anRebate: number, anVat: number }>, acDeliveryNavigation?: { acName?: string }, acPayMethodNavigation?: { acName?: string } } };

export type THeSetDelMetsQueryVariables = Exact<{ [key: string]: never; }>;


export type THeSetDelMetsQuery = { tHeSetDelMet?: Array<{ acDelivery?: string, acName?: string }> };

export type THeSetItemQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  acWarehouse: Scalars['String'];
  minStock: Scalars['Decimal'];
}>;


export type THeSetItemQuery = { tHeSetItem?: Array<{ acIdent?: string, acName?: string, acUm?: string, acCode?: string, acNote?: string, acSetOfItem?: string, anRtPrice: number, anWsprice: number, acActive?: string, tHeStock?: Array<{ anStock: any, anReserved: any, acWarehouse?: string }> }> };

export type THeSetItemOnlyOptionalFieldsQueryVariables = Exact<{
  acIdent: Scalars['String'];
}>;


export type THeSetItemOnlyOptionalFieldsQuery = { singleTHeSetItem?: { acFieldsA?: string, acFieldSb?: string, acFieldSc?: string, acFieldSd?: string, acFieldSe?: string, acFieldSf?: string, acFieldSg?: string, acFieldSh?: string, acFieldSi?: string, acFieldSj?: string } };

export type THeSetItemPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  acWarehouse: Scalars['String'];
  minStock: Scalars['Decimal'];
  subject?: InputMaybe<Scalars['String']>;
  acFieldsAContains: Scalars['String'];
  acClassif: Scalars['String'];
  dateNow: Scalars['DateTime'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type THeSetItemPagedQuery = { tHeSetItemPagedParametrizedV2?: { nodes?: Array<{ acIdent?: string, acName?: string, acUm?: string, acCode?: string, acNote?: string, acSetOfItem?: string, anRtPrice: number, anWsprice: number, acClassif?: string, acClassif2?: string, acUm2?: string, acColumn?: string, acSerialNo?: string, anUmtoUm2: any, acActive?: string, anWsprice2: number, anExcise: number, acQtyInCode?: string, anQtyInCodeDecPlace: number, tHeStock?: Array<{ anStock: any, anReserved: any, acWarehouse?: string }>, tHeSetSubjPriceItem?: Array<{ anPrice: any, acSubject?: string, anRebate: any }>, tHeSetItemPriceForWrh?: Array<{ anRtprice: number, acWarehouse?: string }>, acClassifNavigation?: { acName?: string }, tHeSetItemExtItemSubj?: Array<{ acCode?: string, acSubject?: string }>, pHE_SearchContrctPriceAcClassif?: { cRetResult?: string, nRetRabat?: any, nRetRabat2?: any, nRetRabat3?: any, nRetCena?: number, nRetCenaMP?: number }, pHE_SearchContrctPriceAcClassif2?: { cRetResult?: string, nRetRabat?: any, nRetRabat2?: any, nRetRabat3?: any, nRetCena?: number, nRetCenaMP?: number } }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type THeSetItemCategPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  acFieldsAContains: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type THeSetItemCategPagedQuery = { tHeSetItemCategPagedParametrized?: { nodes?: Array<{ acName?: string, acClassif?: string, tHeSetItemAcClassifNavigations?: Array<{ acFieldSa?: string, acActive?: string }> }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type THeSetItemExtItemSubjByBarcodeQueryVariables = Exact<{
  barcode: Scalars['String'];
  acWarehouse: Scalars['String'];
  subject: Scalars['String'];
  dateNow: Scalars['DateTime'];
}>;


export type THeSetItemExtItemSubjByBarcodeQuery = { singleTHeSetItem?: { acIdent?: string, acName?: string, acUm?: string, acCode?: string, acNote?: string, acSetOfItem?: string, anRtPrice: number, anWsprice: number, acUm2?: string, anUmtoUm2: any, acActive?: string, anWsprice2: number, anExcise: number, acQtyInCode?: string, anQtyInCodeDecPlace: number, tHeStock?: Array<{ anStock: any, anReserved: any, acWarehouse?: string }>, tHeSetSubjPriceItem?: Array<{ anPrice: any, acSubject?: string, anRebate: any }>, tHeSetItemPriceForWrh?: Array<{ anRtprice: number, acWarehouse?: string }>, acClassifNavigation?: { acName?: string }, tHeSetItemExtItemSubj?: Array<{ acCode?: string }> } };

export type THeSetPayMetsQueryVariables = Exact<{ [key: string]: never; }>;


export type THeSetPayMetsQuery = { tHeSetPayMets?: Array<{ acPayMethod?: string, acFiscalGroup?: string, acName?: string }> };

export type THeSetSubjPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  acFieldSa?: InputMaybe<Scalars['String']>;
  acSupplier?: InputMaybe<Scalars['String']>;
  acBuyer?: InputMaybe<Scalars['String']>;
}>;


export type THeSetSubjPagedQuery = { tHeSetSubjPagedParametrized?: { nodes?: Array<{ acSubject?: string, acPin?: string, acName2?: string, acPost?: string, acAddress?: string, anRebate: any, acPayer?: string, acPriceRate?: string, acPostNavigation?: { acName?: string }, acPayerNavigation?: { acPayer?: string, anRebate: any, acPin?: string, acName2?: string, acPost?: string, acAddress?: string, acPriceRate?: string, acPostNavigation?: { acName?: string } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type THrPrsnPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type THrPrsnPagedQuery = { tHrPrsnPaged?: { nodes?: Array<{ acName?: string, acWorker?: string, acActive?: string }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type ToggleMarservisItemStatusMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ToggleMarservisItemStatusMutation = { markMarservisWorkOrderItemAsFinished: MarservisWorkOrderItemStatusEnum };

export type UpdateDocumentTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  documentType: DocumentTypeUpdateDtoV2Input;
}>;


export type UpdateDocumentTypeMutation = { updateDocumentTypeV2: boolean };

export type UpdateTHeSetItemMutationVariables = Exact<{
  acIdent: Scalars['String'];
  updates?: InputMaybe<Scalars['Any']>;
}>;


export type UpdateTHeSetItemMutation = { updateTHeSetItem?: { acIdent?: string, acFieldsA?: string, acFieldSb?: string, acFieldSc?: string, acFieldSd?: string, acFieldSe?: string, acFieldSf?: string, acFieldSg?: string, acFieldSh?: string, acFieldSi?: string, acFieldSj?: string } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { user?: { id: string, userName?: string, culture?: string, email?: string, emailConfirmed: boolean, firstName?: string, lastName?: string, fullName?: string, isDeleted: boolean, language?: string, alternativeUserId?: string, onixDesktopPantheonExePath?: string, onixDesktopPantheonIniPath?: string, onixDesktopPantheonExePathMac?: string, onixDesktopPantheonIniPathMac?: string, supportTimeLogsAlwaysNonBillable: boolean, supportTopBarCountersOpenTicketList?: boolean, supportTimeLogRoundingMinutes?: number, webAppRouting?: { hasClassicAccess: boolean, hasWebAppAccess: boolean, autoRedirect: boolean, hasTickets: boolean }, pantheonUser?: { pantheonAcName?: string, pantheonAcRegNo?: string, pantheonAcUserId?: string, pantheonAcWorker?: string, pantheonAnUserId: number, pantheonAcDelivery?: string }, mobileSettings?: { bluetoothPrinterAddress?: string, bluetoothPrinterName?: string, bluetoothPrinterPaperWidth?: number, bluetoothPrinterType?: string, useDarkTheme: boolean, useListViewOnPickers: boolean, useTabletMode?: boolean, useOnlyShortcuts: boolean, useDocumentTypeCodesInTitles?: boolean }, userRoles?: Array<{ role?: { name?: string } }>, documentTypes?: Array<{ addingItemWarnIfQuantityMoreThanAvailable: boolean, adminAllowChangingItemPrice: boolean, adminDocumentOnCreateMakeWarehouseReservation: boolean, adminItemQuantityMustBeInStock: boolean, articleSearchShowOnlyInStock: boolean, bluetoothPrintCopiesNumber: number, documentOnCreateMakeBluetoothPrint: boolean, documentOnCreateMakePDF: boolean, functionality: DocumentFunctionalityEnum, itemListShowDetailed: boolean, stockViewShowOnlyInStock: boolean, type?: string, warehouseName?: string, warehouseOverviewShowOnlyInStock: boolean, id: number, workOrderPrintSpecificationDuration: boolean, syncPackagingWhenAddingNewItem: boolean, articleSearchShowOnlyWhereAcFieldsAIs?: string, articleSearchAllowSearchingByClassification: boolean, quantityDecimalPlaces: number, create: boolean, read: boolean, update: boolean, delete: boolean, adminIgnoreRebate1: boolean, adminIgnoreRebate2: boolean, adminIgnoreRebate3: boolean, adminEmphasizeInStock: boolean, adminShowDailyIncome: boolean, acWorkPlace?: string, acFiscalDevice?: string, adminDefaultAcPriceRate?: string, skipConfirmationOnShortcuts: boolean, acName?: string, filterByAcDelivery: boolean, filterByAcVerifyStatus?: string, filterByAcVerifiedPrices?: string, filterByAcDept?: string, printTicketNameOverride?: string, showDeliveryDeadlineDays: boolean, showDeliveryMethod: boolean, showPaymentMethod: boolean, showAcDeliveryMobileFilterOnDocumentList: boolean, showAcDeptMobileFilterOnDocumentList: boolean, disallowChangingCustomer: boolean, filterReceiversByAcFieldSa?: string, useDeadlineDateOnOverview: boolean, dateFilterType?: DateFilterType, groupAllDocumentTypesAtThisPoint: boolean, filterByAcType?: string, jumpToEditAfterScanningItemWithBarcode: boolean, forceShowAvailableOnStock: boolean, warehousePositionTHeSetItemFieldName?: string, hideWarehouseOverview?: boolean, requireASignature: boolean, acStatusIn?: string, acIssuerName?: string, acReceiverName?: string, acName3?: string }>, companySettings?: { pantheonCompanyName?: string, pantheonAcCompanyPrtTextA?: string, pantheonAcCompanyPrtTextB?: string, pantheonAnDocKeyLenNumber: number, pantheonCompanyImage?: Array<any>, pantheonAnDocKeyLenDocType: number, pantheonAnQtyInCodeLen: number, pantheonAcQtyInCodeCont?: string, connectionName?: string, bookStackUrl?: string, primaryCurrency?: string, useSecondaryCurrency: boolean, applicationPackets?: Array<{ packet: ApplicationPacketEnum }> }, documentTypePairs?: Array<{ fromId: number, toId: number, functionality: DocumentPairFunctionalityEnum }> } };

export type UserInfoVersionHashQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoVersionHashQuery = { userInfoVersionHash?: string };

export type VopCashRegsPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  acDocType: Scalars['String'];
  subject: Scalars['String'];
}>;


export type VopCashRegsPagedQuery = { vOpCashReg?: { nodes?: Array<{ acDoctype?: string, ackey?: string, addate?: any, acSubject?: string, anPaid: any }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type VopSetBoatNamesQueryVariables = Exact<{
  subject: Scalars['String'];
}>;


export type VopSetBoatNamesQuery = { vOpSetBoatNames?: Array<{ acsubject?: string, acBoatName?: string, anLenght?: number }> };

export type VopSetBoatNamesPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type VopSetBoatNamesPagedQuery = { vOpSetBoatNamePaged?: { nodes?: Array<{ acsubject?: string, acBoatName?: string, anLenght?: number }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type VopSetDeptsQueryVariables = Exact<{ [key: string]: never; }>;


export type VopSetDeptsQuery = { vOPSetDepts?: Array<{ acSubject?: string }> };

export type VopSetItemCategsQueryVariables = Exact<{ [key: string]: never; }>;


export type VopSetItemCategsQuery = { vOPSetItemCategs?: Array<{ acClassif?: string, acdept?: string }> };

export type VopSetItemCategsPagedQueryVariables = Exact<{
  cursor: Scalars['String'];
}>;


export type VopSetItemCategsPagedQuery = { vOPSetItemCategsPaged?: { nodes?: Array<{ acClassif?: string, acdept?: string }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type VopSetItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type VopSetItemsQuery = { vOPSetItems?: Array<{ acIdent?: string, acName?: string, acClassif?: string, anSaleprice: any, anRtprice: number, acdept?: string, anVAT: any, acShowDays?: string }> };

export type VopSetItemsPagedQueryVariables = Exact<{
  cursor: Scalars['String'];
}>;


export type VopSetItemsPagedQuery = { vOPSetItemsPaged?: { nodes?: Array<{ acIdent?: string, acName?: string, acClassif?: string, anSaleprice: any, anRtprice: number, acdept?: string, anVAT: any }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type WarehousesListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type WarehousesListQuery = { tHeSetSubjPaged?: { nodes?: Array<{ acSubject?: string, acName2?: string }>, pageInfo: { hasNextPage: boolean, endCursor?: string } } };

export type WorkOrderBearerContactsQueryVariables = Exact<{
  buyer: Scalars['String'];
}>;


export type WorkOrderBearerContactsQuery = { tHeSetSubjContact?: Array<{ acName?: string, acSurname?: string }> };

export type WorkOrderMaterialsPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  warehouse: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type WorkOrderMaterialsPagedQuery = { tHeSetItemPaged?: { nodes?: Array<{ acName?: string, acIdent?: string, acUm?: string, acSetOfItem?: string, tHeStock?: Array<{ anStock: any, acWarehouse?: string }>, tHeStockSerialNos?: Array<{ acSerialNo?: string, acWarehouse?: string }> }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type WorkOrderServiceSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type WorkOrderServiceSearchQuery = { tHeSetItem?: Array<{ acName?: string, acIdent?: string, acClassif?: string, acClassif2?: string, acNote?: string, acUm?: string, acSetOfItem?: string }> };

export type WorkOrderSpecPagedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type WorkOrderSpecPagedQuery = { tHeSetItemPaged?: { nodes?: Array<{ acIdent?: string, acName?: string, acNote?: string, acSetOfItem?: string }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type WorkflowTasksQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
}>;


export type WorkflowTasksQuery = { workflowTasks?: { nodes?: Array<{ acName?: string, acComments?: string, acTitle?: string, acDescription?: string, acTask?: string, adTimeIns?: any, adCreatedOn?: any }>, pageInfo: { endCursor?: string, hasNextPage: boolean } } };

export type WorkflowTasksCountQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowTasksCountQuery = { workflowTasksCount: number };


export const AddLurInvoiceDocument = gql`
    mutation AddLURInvoice($invoice: SubmittingLURInvoiceViewModelInput, $docType: Int!) {
  submitLURInvoice(invoice: $invoice, docType: $docType)
}
    `;
export type AddLurInvoiceMutationFn = Apollo.MutationFunction<AddLurInvoiceMutation, AddLurInvoiceMutationVariables>;

/**
 * __useAddLurInvoiceMutation__
 *
 * To run a mutation, you first call `useAddLurInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLurInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLurInvoiceMutation, { data, loading, error }] = useAddLurInvoiceMutation({
 *   variables: {
 *      invoice: // value for 'invoice'
 *      docType: // value for 'docType'
 *   },
 * });
 */
export function useAddLurInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<AddLurInvoiceMutation, AddLurInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLurInvoiceMutation, AddLurInvoiceMutationVariables>(AddLurInvoiceDocument, options);
      }
export type AddLurInvoiceMutationHookResult = ReturnType<typeof useAddLurInvoiceMutation>;
export type AddLurInvoiceMutationResult = Apollo.MutationResult<AddLurInvoiceMutation>;
export type AddLurInvoiceMutationOptions = Apollo.BaseMutationOptions<AddLurInvoiceMutation, AddLurInvoiceMutationVariables>;
export const AddSavedFileDocument = gql`
    mutation AddSavedFile($file: SavedFileDtoInput!) {
  createSavedFile(file: $file) {
    id
    name
    description
    uniqueClientId
  }
}
    `;
export type AddSavedFileMutationFn = Apollo.MutationFunction<AddSavedFileMutation, AddSavedFileMutationVariables>;

/**
 * __useAddSavedFileMutation__
 *
 * To run a mutation, you first call `useAddSavedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSavedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSavedFileMutation, { data, loading, error }] = useAddSavedFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useAddSavedFileMutation(baseOptions?: Apollo.MutationHookOptions<AddSavedFileMutation, AddSavedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSavedFileMutation, AddSavedFileMutationVariables>(AddSavedFileDocument, options);
      }
export type AddSavedFileMutationHookResult = ReturnType<typeof useAddSavedFileMutation>;
export type AddSavedFileMutationResult = Apollo.MutationResult<AddSavedFileMutation>;
export type AddSavedFileMutationOptions = Apollo.BaseMutationOptions<AddSavedFileMutation, AddSavedFileMutationVariables>;
export const AddSingleTHeOrderDocument = gql`
    mutation AddSingleTHeOrder($docId: Int!, $acKey: String!, $item: CreateGenericDocumentItemDtoInput!) {
  addSingleTHeOrderItem(documentTypeId: $docId, acKey: $acKey, item: $item) {
    acIdent
    anNo
  }
}
    `;
export type AddSingleTHeOrderMutationFn = Apollo.MutationFunction<AddSingleTHeOrderMutation, AddSingleTHeOrderMutationVariables>;

/**
 * __useAddSingleTHeOrderMutation__
 *
 * To run a mutation, you first call `useAddSingleTHeOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSingleTHeOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSingleTHeOrderMutation, { data, loading, error }] = useAddSingleTHeOrderMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      acKey: // value for 'acKey'
 *      item: // value for 'item'
 *   },
 * });
 */
export function useAddSingleTHeOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddSingleTHeOrderMutation, AddSingleTHeOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSingleTHeOrderMutation, AddSingleTHeOrderMutationVariables>(AddSingleTHeOrderDocument, options);
      }
export type AddSingleTHeOrderMutationHookResult = ReturnType<typeof useAddSingleTHeOrderMutation>;
export type AddSingleTHeOrderMutationResult = Apollo.MutationResult<AddSingleTHeOrderMutation>;
export type AddSingleTHeOrderMutationOptions = Apollo.BaseMutationOptions<AddSingleTHeOrderMutation, AddSingleTHeOrderMutationVariables>;
export const AddTHeMoveWithFixedRebatesDocument = gql`
    mutation AddTHeMoveWithFixedRebates($move: SubmittingMoveViewModelInput!, $docType: Int!) {
  addTHeMoveWithFixedRebates(move: $move, docType: $docType)
}
    `;
export type AddTHeMoveWithFixedRebatesMutationFn = Apollo.MutationFunction<AddTHeMoveWithFixedRebatesMutation, AddTHeMoveWithFixedRebatesMutationVariables>;

/**
 * __useAddTHeMoveWithFixedRebatesMutation__
 *
 * To run a mutation, you first call `useAddTHeMoveWithFixedRebatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTHeMoveWithFixedRebatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTHeMoveWithFixedRebatesMutation, { data, loading, error }] = useAddTHeMoveWithFixedRebatesMutation({
 *   variables: {
 *      move: // value for 'move'
 *      docType: // value for 'docType'
 *   },
 * });
 */
export function useAddTHeMoveWithFixedRebatesMutation(baseOptions?: Apollo.MutationHookOptions<AddTHeMoveWithFixedRebatesMutation, AddTHeMoveWithFixedRebatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTHeMoveWithFixedRebatesMutation, AddTHeMoveWithFixedRebatesMutationVariables>(AddTHeMoveWithFixedRebatesDocument, options);
      }
export type AddTHeMoveWithFixedRebatesMutationHookResult = ReturnType<typeof useAddTHeMoveWithFixedRebatesMutation>;
export type AddTHeMoveWithFixedRebatesMutationResult = Apollo.MutationResult<AddTHeMoveWithFixedRebatesMutation>;
export type AddTHeMoveWithFixedRebatesMutationOptions = Apollo.BaseMutationOptions<AddTHeMoveWithFixedRebatesMutation, AddTHeMoveWithFixedRebatesMutationVariables>;
export const AddTHeOrderWithFixedRebatesDocument = gql`
    mutation AddTHeOrderWithFixedRebates($order: SubmittingOrderViewModelInput!, $docType: Int!) {
  addTHeOrderWithFixedRebates(order: $order, docType: $docType)
}
    `;
export type AddTHeOrderWithFixedRebatesMutationFn = Apollo.MutationFunction<AddTHeOrderWithFixedRebatesMutation, AddTHeOrderWithFixedRebatesMutationVariables>;

/**
 * __useAddTHeOrderWithFixedRebatesMutation__
 *
 * To run a mutation, you first call `useAddTHeOrderWithFixedRebatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTHeOrderWithFixedRebatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTHeOrderWithFixedRebatesMutation, { data, loading, error }] = useAddTHeOrderWithFixedRebatesMutation({
 *   variables: {
 *      order: // value for 'order'
 *      docType: // value for 'docType'
 *   },
 * });
 */
export function useAddTHeOrderWithFixedRebatesMutation(baseOptions?: Apollo.MutationHookOptions<AddTHeOrderWithFixedRebatesMutation, AddTHeOrderWithFixedRebatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTHeOrderWithFixedRebatesMutation, AddTHeOrderWithFixedRebatesMutationVariables>(AddTHeOrderWithFixedRebatesDocument, options);
      }
export type AddTHeOrderWithFixedRebatesMutationHookResult = ReturnType<typeof useAddTHeOrderWithFixedRebatesMutation>;
export type AddTHeOrderWithFixedRebatesMutationResult = Apollo.MutationResult<AddTHeOrderWithFixedRebatesMutation>;
export type AddTHeOrderWithFixedRebatesMutationOptions = Apollo.BaseMutationOptions<AddTHeOrderWithFixedRebatesMutation, AddTHeOrderWithFixedRebatesMutationVariables>;
export const AddWorkOrderImageDocument = gql`
    mutation AddWorkOrderImage($data: TrimWorkOrderImageQueryInput!) {
  addWorkOrderImage(data: $data) {
    acKey
    anKey
  }
}
    `;
export type AddWorkOrderImageMutationFn = Apollo.MutationFunction<AddWorkOrderImageMutation, AddWorkOrderImageMutationVariables>;

/**
 * __useAddWorkOrderImageMutation__
 *
 * To run a mutation, you first call `useAddWorkOrderImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkOrderImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkOrderImageMutation, { data, loading, error }] = useAddWorkOrderImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddWorkOrderImageMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkOrderImageMutation, AddWorkOrderImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkOrderImageMutation, AddWorkOrderImageMutationVariables>(AddWorkOrderImageDocument, options);
      }
export type AddWorkOrderImageMutationHookResult = ReturnType<typeof useAddWorkOrderImageMutation>;
export type AddWorkOrderImageMutationResult = Apollo.MutationResult<AddWorkOrderImageMutation>;
export type AddWorkOrderImageMutationOptions = Apollo.BaseMutationOptions<AddWorkOrderImageMutation, AddWorkOrderImageMutationVariables>;
export const AddWorkOrderMaterialDocument = gql`
    mutation AddWorkOrderMaterial($data: SubmittingWorkOrderMaterialViewModelInput!) {
  addWorkOrderMaterial(data: $data) {
    acKey
    anNo
  }
}
    `;
export type AddWorkOrderMaterialMutationFn = Apollo.MutationFunction<AddWorkOrderMaterialMutation, AddWorkOrderMaterialMutationVariables>;

/**
 * __useAddWorkOrderMaterialMutation__
 *
 * To run a mutation, you first call `useAddWorkOrderMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkOrderMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkOrderMaterialMutation, { data, loading, error }] = useAddWorkOrderMaterialMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddWorkOrderMaterialMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkOrderMaterialMutation, AddWorkOrderMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkOrderMaterialMutation, AddWorkOrderMaterialMutationVariables>(AddWorkOrderMaterialDocument, options);
      }
export type AddWorkOrderMaterialMutationHookResult = ReturnType<typeof useAddWorkOrderMaterialMutation>;
export type AddWorkOrderMaterialMutationResult = Apollo.MutationResult<AddWorkOrderMaterialMutation>;
export type AddWorkOrderMaterialMutationOptions = Apollo.BaseMutationOptions<AddWorkOrderMaterialMutation, AddWorkOrderMaterialMutationVariables>;
export const AddWorkOrderReceptionDocument = gql`
    mutation AddWorkOrderReception($data: TrimWorkOrderReceptionQueryInput!) {
  addWorkOrderReception(data: $data) {
    acKey
    anNo
  }
}
    `;
export type AddWorkOrderReceptionMutationFn = Apollo.MutationFunction<AddWorkOrderReceptionMutation, AddWorkOrderReceptionMutationVariables>;

/**
 * __useAddWorkOrderReceptionMutation__
 *
 * To run a mutation, you first call `useAddWorkOrderReceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkOrderReceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkOrderReceptionMutation, { data, loading, error }] = useAddWorkOrderReceptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddWorkOrderReceptionMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkOrderReceptionMutation, AddWorkOrderReceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkOrderReceptionMutation, AddWorkOrderReceptionMutationVariables>(AddWorkOrderReceptionDocument, options);
      }
export type AddWorkOrderReceptionMutationHookResult = ReturnType<typeof useAddWorkOrderReceptionMutation>;
export type AddWorkOrderReceptionMutationResult = Apollo.MutationResult<AddWorkOrderReceptionMutation>;
export type AddWorkOrderReceptionMutationOptions = Apollo.BaseMutationOptions<AddWorkOrderReceptionMutation, AddWorkOrderReceptionMutationVariables>;
export const AddWorkOrderReclamationDocument = gql`
    mutation AddWorkOrderReclamation($data: SubmittingWorkOrderMaterialViewModelInput!) {
  addWorkOrderReclamation(data: $data) {
    acKey
    anNo
  }
}
    `;
export type AddWorkOrderReclamationMutationFn = Apollo.MutationFunction<AddWorkOrderReclamationMutation, AddWorkOrderReclamationMutationVariables>;

/**
 * __useAddWorkOrderReclamationMutation__
 *
 * To run a mutation, you first call `useAddWorkOrderReclamationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkOrderReclamationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkOrderReclamationMutation, { data, loading, error }] = useAddWorkOrderReclamationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddWorkOrderReclamationMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkOrderReclamationMutation, AddWorkOrderReclamationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkOrderReclamationMutation, AddWorkOrderReclamationMutationVariables>(AddWorkOrderReclamationDocument, options);
      }
export type AddWorkOrderReclamationMutationHookResult = ReturnType<typeof useAddWorkOrderReclamationMutation>;
export type AddWorkOrderReclamationMutationResult = Apollo.MutationResult<AddWorkOrderReclamationMutation>;
export type AddWorkOrderReclamationMutationOptions = Apollo.BaseMutationOptions<AddWorkOrderReclamationMutation, AddWorkOrderReclamationMutationVariables>;
export const AddWorkOrderServiceDocument = gql`
    mutation AddWorkOrderService($data: SubmittingWorkOrderMaterialViewModelInput!) {
  addWorkOrderService(data: $data) {
    acKey
    anNo
  }
}
    `;
export type AddWorkOrderServiceMutationFn = Apollo.MutationFunction<AddWorkOrderServiceMutation, AddWorkOrderServiceMutationVariables>;

/**
 * __useAddWorkOrderServiceMutation__
 *
 * To run a mutation, you first call `useAddWorkOrderServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkOrderServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkOrderServiceMutation, { data, loading, error }] = useAddWorkOrderServiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddWorkOrderServiceMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkOrderServiceMutation, AddWorkOrderServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkOrderServiceMutation, AddWorkOrderServiceMutationVariables>(AddWorkOrderServiceDocument, options);
      }
export type AddWorkOrderServiceMutationHookResult = ReturnType<typeof useAddWorkOrderServiceMutation>;
export type AddWorkOrderServiceMutationResult = Apollo.MutationResult<AddWorkOrderServiceMutation>;
export type AddWorkOrderServiceMutationOptions = Apollo.BaseMutationOptions<AddWorkOrderServiceMutation, AddWorkOrderServiceMutationVariables>;
export const AddWorkOrderSpecDocument = gql`
    mutation AddWorkOrderSpec($data: SubmittingWorkOrderWorkSpecViewModelInput!) {
  addWorkOrderSpec(data: $data) {
    acKey
    anNo
  }
}
    `;
export type AddWorkOrderSpecMutationFn = Apollo.MutationFunction<AddWorkOrderSpecMutation, AddWorkOrderSpecMutationVariables>;

/**
 * __useAddWorkOrderSpecMutation__
 *
 * To run a mutation, you first call `useAddWorkOrderSpecMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkOrderSpecMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkOrderSpecMutation, { data, loading, error }] = useAddWorkOrderSpecMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddWorkOrderSpecMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkOrderSpecMutation, AddWorkOrderSpecMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkOrderSpecMutation, AddWorkOrderSpecMutationVariables>(AddWorkOrderSpecDocument, options);
      }
export type AddWorkOrderSpecMutationHookResult = ReturnType<typeof useAddWorkOrderSpecMutation>;
export type AddWorkOrderSpecMutationResult = Apollo.MutationResult<AddWorkOrderSpecMutation>;
export type AddWorkOrderSpecMutationOptions = Apollo.BaseMutationOptions<AddWorkOrderSpecMutation, AddWorkOrderSpecMutationVariables>;
export const AllAppUsersDocument = gql`
    query AllAppUsers($search: String = "") {
  users(
    where: {or: [{firstName: {contains: $search}}, {lastName: {contains: $search}}, {userName: {contains: $search}}]}
    order: {companySettingsId: DESC}
  ) {
    id
    userName
    firstName
    lastName
    fullName
    lastTokenRefresh
    lastLogin
    culture
    language
    companySettingsId
    timeZone
    lastDevice
    companySettings {
      id
      pantheonCompanyName
    }
  }
}
    `;

/**
 * __useAllAppUsersQuery__
 *
 * To run a query within a React component, call `useAllAppUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAppUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAppUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAllAppUsersQuery(baseOptions?: Apollo.QueryHookOptions<AllAppUsersQuery, AllAppUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAppUsersQuery, AllAppUsersQueryVariables>(AllAppUsersDocument, options);
      }
export function useAllAppUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAppUsersQuery, AllAppUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAppUsersQuery, AllAppUsersQueryVariables>(AllAppUsersDocument, options);
        }
export type AllAppUsersQueryHookResult = ReturnType<typeof useAllAppUsersQuery>;
export type AllAppUsersLazyQueryHookResult = ReturnType<typeof useAllAppUsersLazyQuery>;
export type AllAppUsersQueryResult = Apollo.QueryResult<AllAppUsersQuery, AllAppUsersQueryVariables>;
export function refetchAllAppUsersQuery(variables?: AllAppUsersQueryVariables) {
      return { query: AllAppUsersDocument, variables: variables }
    }
export const AnalysisActiveAccountsDocument = gql`
    query AnalysisActiveAccounts {
  allActiveAccounts {
    customer {
      code
      id
      name
      type
    }
    money {
      code
      id
      name
      type
    }
    supplier {
      code
      id
      name
      type
    }
  }
}
    `;

/**
 * __useAnalysisActiveAccountsQuery__
 *
 * To run a query within a React component, call `useAnalysisActiveAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisActiveAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisActiveAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalysisActiveAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AnalysisActiveAccountsQuery, AnalysisActiveAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisActiveAccountsQuery, AnalysisActiveAccountsQueryVariables>(AnalysisActiveAccountsDocument, options);
      }
export function useAnalysisActiveAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisActiveAccountsQuery, AnalysisActiveAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisActiveAccountsQuery, AnalysisActiveAccountsQueryVariables>(AnalysisActiveAccountsDocument, options);
        }
export type AnalysisActiveAccountsQueryHookResult = ReturnType<typeof useAnalysisActiveAccountsQuery>;
export type AnalysisActiveAccountsLazyQueryHookResult = ReturnType<typeof useAnalysisActiveAccountsLazyQuery>;
export type AnalysisActiveAccountsQueryResult = Apollo.QueryResult<AnalysisActiveAccountsQuery, AnalysisActiveAccountsQueryVariables>;
export function refetchAnalysisActiveAccountsQuery(variables?: AnalysisActiveAccountsQueryVariables) {
      return { query: AnalysisActiveAccountsDocument, variables: variables }
    }
export const AnalysisBalanceForCustomerDocument = gql`
    query AnalysisBalanceForCustomer($customer: String!) {
  analysisBalanceForCustomer(customer: $customer) {
    due
    period
  }
}
    `;

/**
 * __useAnalysisBalanceForCustomerQuery__
 *
 * To run a query within a React component, call `useAnalysisBalanceForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisBalanceForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisBalanceForCustomerQuery({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useAnalysisBalanceForCustomerQuery(baseOptions: Apollo.QueryHookOptions<AnalysisBalanceForCustomerQuery, AnalysisBalanceForCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisBalanceForCustomerQuery, AnalysisBalanceForCustomerQueryVariables>(AnalysisBalanceForCustomerDocument, options);
      }
export function useAnalysisBalanceForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisBalanceForCustomerQuery, AnalysisBalanceForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisBalanceForCustomerQuery, AnalysisBalanceForCustomerQueryVariables>(AnalysisBalanceForCustomerDocument, options);
        }
export type AnalysisBalanceForCustomerQueryHookResult = ReturnType<typeof useAnalysisBalanceForCustomerQuery>;
export type AnalysisBalanceForCustomerLazyQueryHookResult = ReturnType<typeof useAnalysisBalanceForCustomerLazyQuery>;
export type AnalysisBalanceForCustomerQueryResult = Apollo.QueryResult<AnalysisBalanceForCustomerQuery, AnalysisBalanceForCustomerQueryVariables>;
export function refetchAnalysisBalanceForCustomerQuery(variables: AnalysisBalanceForCustomerQueryVariables) {
      return { query: AnalysisBalanceForCustomerDocument, variables: variables }
    }
export const AnalysisCreateAccountDocument = gql`
    mutation AnalysisCreateAccount($dto: AccountDtoInput!) {
  createAccount(dto: $dto)
}
    `;
export type AnalysisCreateAccountMutationFn = Apollo.MutationFunction<AnalysisCreateAccountMutation, AnalysisCreateAccountMutationVariables>;

/**
 * __useAnalysisCreateAccountMutation__
 *
 * To run a mutation, you first call `useAnalysisCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalysisCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analysisCreateAccountMutation, { data, loading, error }] = useAnalysisCreateAccountMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useAnalysisCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<AnalysisCreateAccountMutation, AnalysisCreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalysisCreateAccountMutation, AnalysisCreateAccountMutationVariables>(AnalysisCreateAccountDocument, options);
      }
export type AnalysisCreateAccountMutationHookResult = ReturnType<typeof useAnalysisCreateAccountMutation>;
export type AnalysisCreateAccountMutationResult = Apollo.MutationResult<AnalysisCreateAccountMutation>;
export type AnalysisCreateAccountMutationOptions = Apollo.BaseMutationOptions<AnalysisCreateAccountMutation, AnalysisCreateAccountMutationVariables>;
export const AnalysisDocumentsForCustomerDocument = gql`
    query AnalysisDocumentsForCustomer($customer: String!, $accountId: Int!) {
  analysisDocumentsForCustomer(customer: $customer, accountId: $accountId) {
    document
    value
    date
  }
}
    `;

/**
 * __useAnalysisDocumentsForCustomerQuery__
 *
 * To run a query within a React component, call `useAnalysisDocumentsForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisDocumentsForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisDocumentsForCustomerQuery({
 *   variables: {
 *      customer: // value for 'customer'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAnalysisDocumentsForCustomerQuery(baseOptions: Apollo.QueryHookOptions<AnalysisDocumentsForCustomerQuery, AnalysisDocumentsForCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisDocumentsForCustomerQuery, AnalysisDocumentsForCustomerQueryVariables>(AnalysisDocumentsForCustomerDocument, options);
      }
export function useAnalysisDocumentsForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisDocumentsForCustomerQuery, AnalysisDocumentsForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisDocumentsForCustomerQuery, AnalysisDocumentsForCustomerQueryVariables>(AnalysisDocumentsForCustomerDocument, options);
        }
export type AnalysisDocumentsForCustomerQueryHookResult = ReturnType<typeof useAnalysisDocumentsForCustomerQuery>;
export type AnalysisDocumentsForCustomerLazyQueryHookResult = ReturnType<typeof useAnalysisDocumentsForCustomerLazyQuery>;
export type AnalysisDocumentsForCustomerQueryResult = Apollo.QueryResult<AnalysisDocumentsForCustomerQuery, AnalysisDocumentsForCustomerQueryVariables>;
export function refetchAnalysisDocumentsForCustomerQuery(variables: AnalysisDocumentsForCustomerQueryVariables) {
      return { query: AnalysisDocumentsForCustomerDocument, variables: variables }
    }
export const AnalysisMainPageQueryDocument = gql`
    query AnalysisMainPageQuery {
  analysisTotals {
    customer {
      currency
      credit
      creditInCurrency
      debit
      debitInCurrency
      value
      valueInCurrency
    }
    money {
      currency
      credit
      creditInCurrency
      debit
      debitInCurrency
      value
      valueInCurrency
    }
    supplier {
      currency
      credit
      creditInCurrency
      debit
      debitInCurrency
      value
      valueInCurrency
    }
  }
}
    `;

/**
 * __useAnalysisMainPageQueryQuery__
 *
 * To run a query within a React component, call `useAnalysisMainPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisMainPageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisMainPageQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalysisMainPageQueryQuery(baseOptions?: Apollo.QueryHookOptions<AnalysisMainPageQueryQuery, AnalysisMainPageQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisMainPageQueryQuery, AnalysisMainPageQueryQueryVariables>(AnalysisMainPageQueryDocument, options);
      }
export function useAnalysisMainPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisMainPageQueryQuery, AnalysisMainPageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisMainPageQueryQuery, AnalysisMainPageQueryQueryVariables>(AnalysisMainPageQueryDocument, options);
        }
export type AnalysisMainPageQueryQueryHookResult = ReturnType<typeof useAnalysisMainPageQueryQuery>;
export type AnalysisMainPageQueryLazyQueryHookResult = ReturnType<typeof useAnalysisMainPageQueryLazyQuery>;
export type AnalysisMainPageQueryQueryResult = Apollo.QueryResult<AnalysisMainPageQueryQuery, AnalysisMainPageQueryQueryVariables>;
export function refetchAnalysisMainPageQueryQuery(variables?: AnalysisMainPageQueryQueryVariables) {
      return { query: AnalysisMainPageQueryDocument, variables: variables }
    }
export const AnalysisPerAccountForTypeDocument = gql`
    query AnalysisPerAccountForType($type: AccountType!) {
  analysisPerAccountForType(type: $type) {
    account
    name
    id
    value {
      currency
      credit
      creditInCurrency
      debit
      debitInCurrency
      value
      valueInCurrency
    }
  }
}
    `;

/**
 * __useAnalysisPerAccountForTypeQuery__
 *
 * To run a query within a React component, call `useAnalysisPerAccountForTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisPerAccountForTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisPerAccountForTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAnalysisPerAccountForTypeQuery(baseOptions: Apollo.QueryHookOptions<AnalysisPerAccountForTypeQuery, AnalysisPerAccountForTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisPerAccountForTypeQuery, AnalysisPerAccountForTypeQueryVariables>(AnalysisPerAccountForTypeDocument, options);
      }
export function useAnalysisPerAccountForTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisPerAccountForTypeQuery, AnalysisPerAccountForTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisPerAccountForTypeQuery, AnalysisPerAccountForTypeQueryVariables>(AnalysisPerAccountForTypeDocument, options);
        }
export type AnalysisPerAccountForTypeQueryHookResult = ReturnType<typeof useAnalysisPerAccountForTypeQuery>;
export type AnalysisPerAccountForTypeLazyQueryHookResult = ReturnType<typeof useAnalysisPerAccountForTypeLazyQuery>;
export type AnalysisPerAccountForTypeQueryResult = Apollo.QueryResult<AnalysisPerAccountForTypeQuery, AnalysisPerAccountForTypeQueryVariables>;
export function refetchAnalysisPerAccountForTypeQuery(variables: AnalysisPerAccountForTypeQueryVariables) {
      return { query: AnalysisPerAccountForTypeDocument, variables: variables }
    }
export const AnalysisPerCustomerForAccountDocument = gql`
    query AnalysisPerCustomerForAccount($accountId: Int!) {
  analysisPerCustomerForAccount(accountId: $accountId) {
    customer
    customerName
    value {
      currency
      credit
      creditInCurrency
      debit
      debitInCurrency
      value
      valueInCurrency
    }
  }
}
    `;

/**
 * __useAnalysisPerCustomerForAccountQuery__
 *
 * To run a query within a React component, call `useAnalysisPerCustomerForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisPerCustomerForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisPerCustomerForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAnalysisPerCustomerForAccountQuery(baseOptions: Apollo.QueryHookOptions<AnalysisPerCustomerForAccountQuery, AnalysisPerCustomerForAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisPerCustomerForAccountQuery, AnalysisPerCustomerForAccountQueryVariables>(AnalysisPerCustomerForAccountDocument, options);
      }
export function useAnalysisPerCustomerForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisPerCustomerForAccountQuery, AnalysisPerCustomerForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisPerCustomerForAccountQuery, AnalysisPerCustomerForAccountQueryVariables>(AnalysisPerCustomerForAccountDocument, options);
        }
export type AnalysisPerCustomerForAccountQueryHookResult = ReturnType<typeof useAnalysisPerCustomerForAccountQuery>;
export type AnalysisPerCustomerForAccountLazyQueryHookResult = ReturnType<typeof useAnalysisPerCustomerForAccountLazyQuery>;
export type AnalysisPerCustomerForAccountQueryResult = Apollo.QueryResult<AnalysisPerCustomerForAccountQuery, AnalysisPerCustomerForAccountQueryVariables>;
export function refetchAnalysisPerCustomerForAccountQuery(variables: AnalysisPerCustomerForAccountQueryVariables) {
      return { query: AnalysisPerCustomerForAccountDocument, variables: variables }
    }
export const AnalysisRemoveAccountDocument = gql`
    mutation AnalysisRemoveAccount($dto: AccountDtoInput!) {
  deleteAccount(dto: $dto)
}
    `;
export type AnalysisRemoveAccountMutationFn = Apollo.MutationFunction<AnalysisRemoveAccountMutation, AnalysisRemoveAccountMutationVariables>;

/**
 * __useAnalysisRemoveAccountMutation__
 *
 * To run a mutation, you first call `useAnalysisRemoveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalysisRemoveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analysisRemoveAccountMutation, { data, loading, error }] = useAnalysisRemoveAccountMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useAnalysisRemoveAccountMutation(baseOptions?: Apollo.MutationHookOptions<AnalysisRemoveAccountMutation, AnalysisRemoveAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalysisRemoveAccountMutation, AnalysisRemoveAccountMutationVariables>(AnalysisRemoveAccountDocument, options);
      }
export type AnalysisRemoveAccountMutationHookResult = ReturnType<typeof useAnalysisRemoveAccountMutation>;
export type AnalysisRemoveAccountMutationResult = Apollo.MutationResult<AnalysisRemoveAccountMutation>;
export type AnalysisRemoveAccountMutationOptions = Apollo.BaseMutationOptions<AnalysisRemoveAccountMutation, AnalysisRemoveAccountMutationVariables>;
export const AnalysisTotalsForTypeDocument = gql`
    query AnalysisTotalsForType($type: AccountType!) {
  analysisTotalsForType(type: $type) {
    currency
    value
    valueInCurrency
  }
}
    `;

/**
 * __useAnalysisTotalsForTypeQuery__
 *
 * To run a query within a React component, call `useAnalysisTotalsForTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisTotalsForTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisTotalsForTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAnalysisTotalsForTypeQuery(baseOptions: Apollo.QueryHookOptions<AnalysisTotalsForTypeQuery, AnalysisTotalsForTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisTotalsForTypeQuery, AnalysisTotalsForTypeQueryVariables>(AnalysisTotalsForTypeDocument, options);
      }
export function useAnalysisTotalsForTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisTotalsForTypeQuery, AnalysisTotalsForTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisTotalsForTypeQuery, AnalysisTotalsForTypeQueryVariables>(AnalysisTotalsForTypeDocument, options);
        }
export type AnalysisTotalsForTypeQueryHookResult = ReturnType<typeof useAnalysisTotalsForTypeQuery>;
export type AnalysisTotalsForTypeLazyQueryHookResult = ReturnType<typeof useAnalysisTotalsForTypeLazyQuery>;
export type AnalysisTotalsForTypeQueryResult = Apollo.QueryResult<AnalysisTotalsForTypeQuery, AnalysisTotalsForTypeQueryVariables>;
export function refetchAnalysisTotalsForTypeQuery(variables: AnalysisTotalsForTypeQueryVariables) {
      return { query: AnalysisTotalsForTypeDocument, variables: variables }
    }
export const AttachBarcodeToIdentDocument = gql`
    mutation AttachBarcodeToIdent($acIdent: String!, $barcode: String!, $acSubject: String!) {
  attachBarcodeToIdent(
    acIdent: $acIdent
    barcode: $barcode
    acSubject: $acSubject
  )
}
    `;
export type AttachBarcodeToIdentMutationFn = Apollo.MutationFunction<AttachBarcodeToIdentMutation, AttachBarcodeToIdentMutationVariables>;

/**
 * __useAttachBarcodeToIdentMutation__
 *
 * To run a mutation, you first call `useAttachBarcodeToIdentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachBarcodeToIdentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachBarcodeToIdentMutation, { data, loading, error }] = useAttachBarcodeToIdentMutation({
 *   variables: {
 *      acIdent: // value for 'acIdent'
 *      barcode: // value for 'barcode'
 *      acSubject: // value for 'acSubject'
 *   },
 * });
 */
export function useAttachBarcodeToIdentMutation(baseOptions?: Apollo.MutationHookOptions<AttachBarcodeToIdentMutation, AttachBarcodeToIdentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachBarcodeToIdentMutation, AttachBarcodeToIdentMutationVariables>(AttachBarcodeToIdentDocument, options);
      }
export type AttachBarcodeToIdentMutationHookResult = ReturnType<typeof useAttachBarcodeToIdentMutation>;
export type AttachBarcodeToIdentMutationResult = Apollo.MutationResult<AttachBarcodeToIdentMutation>;
export type AttachBarcodeToIdentMutationOptions = Apollo.BaseMutationOptions<AttachBarcodeToIdentMutation, AttachBarcodeToIdentMutationVariables>;
export const CreateMoveFromAnotherDocumentDocument = gql`
    mutation CreateMoveFromAnotherDocument($dto: CreateGenericDocumentFromAnotherDtoInput) {
  createMoveFromAnotherDocument(dto: $dto) {
    acKey
  }
}
    `;
export type CreateMoveFromAnotherDocumentMutationFn = Apollo.MutationFunction<CreateMoveFromAnotherDocumentMutation, CreateMoveFromAnotherDocumentMutationVariables>;

/**
 * __useCreateMoveFromAnotherDocumentMutation__
 *
 * To run a mutation, you first call `useCreateMoveFromAnotherDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMoveFromAnotherDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMoveFromAnotherDocumentMutation, { data, loading, error }] = useCreateMoveFromAnotherDocumentMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateMoveFromAnotherDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMoveFromAnotherDocumentMutation, CreateMoveFromAnotherDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMoveFromAnotherDocumentMutation, CreateMoveFromAnotherDocumentMutationVariables>(CreateMoveFromAnotherDocumentDocument, options);
      }
export type CreateMoveFromAnotherDocumentMutationHookResult = ReturnType<typeof useCreateMoveFromAnotherDocumentMutation>;
export type CreateMoveFromAnotherDocumentMutationResult = Apollo.MutationResult<CreateMoveFromAnotherDocumentMutation>;
export type CreateMoveFromAnotherDocumentMutationOptions = Apollo.BaseMutationOptions<CreateMoveFromAnotherDocumentMutation, CreateMoveFromAnotherDocumentMutationVariables>;
export const CreateMoveFromGenericDocumentDocument = gql`
    mutation CreateMoveFromGenericDocument($dto: CreateGenericDocumentDtoInput) {
  createMoveFromGenericDocument(dto: $dto) {
    acKey
  }
}
    `;
export type CreateMoveFromGenericDocumentMutationFn = Apollo.MutationFunction<CreateMoveFromGenericDocumentMutation, CreateMoveFromGenericDocumentMutationVariables>;

/**
 * __useCreateMoveFromGenericDocumentMutation__
 *
 * To run a mutation, you first call `useCreateMoveFromGenericDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMoveFromGenericDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMoveFromGenericDocumentMutation, { data, loading, error }] = useCreateMoveFromGenericDocumentMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateMoveFromGenericDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMoveFromGenericDocumentMutation, CreateMoveFromGenericDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMoveFromGenericDocumentMutation, CreateMoveFromGenericDocumentMutationVariables>(CreateMoveFromGenericDocumentDocument, options);
      }
export type CreateMoveFromGenericDocumentMutationHookResult = ReturnType<typeof useCreateMoveFromGenericDocumentMutation>;
export type CreateMoveFromGenericDocumentMutationResult = Apollo.MutationResult<CreateMoveFromGenericDocumentMutation>;
export type CreateMoveFromGenericDocumentMutationOptions = Apollo.BaseMutationOptions<CreateMoveFromGenericDocumentMutation, CreateMoveFromGenericDocumentMutationVariables>;
export const CreateOrderFromGenericDocumentDocument = gql`
    mutation CreateOrderFromGenericDocument($dto: CreateGenericDocumentDtoInput) {
  createOrderFromGenericDocument(dto: $dto) {
    acKey
  }
}
    `;
export type CreateOrderFromGenericDocumentMutationFn = Apollo.MutationFunction<CreateOrderFromGenericDocumentMutation, CreateOrderFromGenericDocumentMutationVariables>;

/**
 * __useCreateOrderFromGenericDocumentMutation__
 *
 * To run a mutation, you first call `useCreateOrderFromGenericDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderFromGenericDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderFromGenericDocumentMutation, { data, loading, error }] = useCreateOrderFromGenericDocumentMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useCreateOrderFromGenericDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderFromGenericDocumentMutation, CreateOrderFromGenericDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderFromGenericDocumentMutation, CreateOrderFromGenericDocumentMutationVariables>(CreateOrderFromGenericDocumentDocument, options);
      }
export type CreateOrderFromGenericDocumentMutationHookResult = ReturnType<typeof useCreateOrderFromGenericDocumentMutation>;
export type CreateOrderFromGenericDocumentMutationResult = Apollo.MutationResult<CreateOrderFromGenericDocumentMutation>;
export type CreateOrderFromGenericDocumentMutationOptions = Apollo.BaseMutationOptions<CreateOrderFromGenericDocumentMutation, CreateOrderFromGenericDocumentMutationVariables>;
export const DailyRecapDocument = gql`
    query DailyRecap($docType: String!, $from: DateTime!, $to: DateTime!) {
  dailyRecap(docType: $docType, from: $from, to: $to) {
    fromDoc
    toDoc
    fromDate
    toDate
    items {
      paid
      paymentType
    }
  }
}
    `;

/**
 * __useDailyRecapQuery__
 *
 * To run a query within a React component, call `useDailyRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyRecapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyRecapQuery({
 *   variables: {
 *      docType: // value for 'docType'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useDailyRecapQuery(baseOptions: Apollo.QueryHookOptions<DailyRecapQuery, DailyRecapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyRecapQuery, DailyRecapQueryVariables>(DailyRecapDocument, options);
      }
export function useDailyRecapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyRecapQuery, DailyRecapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyRecapQuery, DailyRecapQueryVariables>(DailyRecapDocument, options);
        }
export type DailyRecapQueryHookResult = ReturnType<typeof useDailyRecapQuery>;
export type DailyRecapLazyQueryHookResult = ReturnType<typeof useDailyRecapLazyQuery>;
export type DailyRecapQueryResult = Apollo.QueryResult<DailyRecapQuery, DailyRecapQueryVariables>;
export function refetchDailyRecapQuery(variables: DailyRecapQueryVariables) {
      return { query: DailyRecapDocument, variables: variables }
    }
export const DeleteWorkOrderImageDocument = gql`
    mutation DeleteWorkOrderImage($acKey: String!, $anKey: Int!) {
  deleteWorkOrderImage(acKey: $acKey, anKey: $anKey) {
    acKey
    anKey
  }
}
    `;
export type DeleteWorkOrderImageMutationFn = Apollo.MutationFunction<DeleteWorkOrderImageMutation, DeleteWorkOrderImageMutationVariables>;

/**
 * __useDeleteWorkOrderImageMutation__
 *
 * To run a mutation, you first call `useDeleteWorkOrderImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkOrderImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkOrderImageMutation, { data, loading, error }] = useDeleteWorkOrderImageMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      anKey: // value for 'anKey'
 *   },
 * });
 */
export function useDeleteWorkOrderImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkOrderImageMutation, DeleteWorkOrderImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkOrderImageMutation, DeleteWorkOrderImageMutationVariables>(DeleteWorkOrderImageDocument, options);
      }
export type DeleteWorkOrderImageMutationHookResult = ReturnType<typeof useDeleteWorkOrderImageMutation>;
export type DeleteWorkOrderImageMutationResult = Apollo.MutationResult<DeleteWorkOrderImageMutation>;
export type DeleteWorkOrderImageMutationOptions = Apollo.BaseMutationOptions<DeleteWorkOrderImageMutation, DeleteWorkOrderImageMutationVariables>;
export const DeleteWorkOrderMaterialDocument = gql`
    mutation DeleteWorkOrderMaterial($acKey: String!, $anNo: Int!) {
  deleteWorkOrderMaterial(acKey: $acKey, anNo: $anNo) {
    acKey
    anNo
  }
}
    `;
export type DeleteWorkOrderMaterialMutationFn = Apollo.MutationFunction<DeleteWorkOrderMaterialMutation, DeleteWorkOrderMaterialMutationVariables>;

/**
 * __useDeleteWorkOrderMaterialMutation__
 *
 * To run a mutation, you first call `useDeleteWorkOrderMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkOrderMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkOrderMaterialMutation, { data, loading, error }] = useDeleteWorkOrderMaterialMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      anNo: // value for 'anNo'
 *   },
 * });
 */
export function useDeleteWorkOrderMaterialMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkOrderMaterialMutation, DeleteWorkOrderMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkOrderMaterialMutation, DeleteWorkOrderMaterialMutationVariables>(DeleteWorkOrderMaterialDocument, options);
      }
export type DeleteWorkOrderMaterialMutationHookResult = ReturnType<typeof useDeleteWorkOrderMaterialMutation>;
export type DeleteWorkOrderMaterialMutationResult = Apollo.MutationResult<DeleteWorkOrderMaterialMutation>;
export type DeleteWorkOrderMaterialMutationOptions = Apollo.BaseMutationOptions<DeleteWorkOrderMaterialMutation, DeleteWorkOrderMaterialMutationVariables>;
export const DeleteWorkOrderReceptionDocument = gql`
    mutation DeleteWorkOrderReception($acKey: String!, $anNo: Int!) {
  deleteWorkOrderReception(acKey: $acKey, anNo: $anNo) {
    acKey
    anNo
  }
}
    `;
export type DeleteWorkOrderReceptionMutationFn = Apollo.MutationFunction<DeleteWorkOrderReceptionMutation, DeleteWorkOrderReceptionMutationVariables>;

/**
 * __useDeleteWorkOrderReceptionMutation__
 *
 * To run a mutation, you first call `useDeleteWorkOrderReceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkOrderReceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkOrderReceptionMutation, { data, loading, error }] = useDeleteWorkOrderReceptionMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      anNo: // value for 'anNo'
 *   },
 * });
 */
export function useDeleteWorkOrderReceptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkOrderReceptionMutation, DeleteWorkOrderReceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkOrderReceptionMutation, DeleteWorkOrderReceptionMutationVariables>(DeleteWorkOrderReceptionDocument, options);
      }
export type DeleteWorkOrderReceptionMutationHookResult = ReturnType<typeof useDeleteWorkOrderReceptionMutation>;
export type DeleteWorkOrderReceptionMutationResult = Apollo.MutationResult<DeleteWorkOrderReceptionMutation>;
export type DeleteWorkOrderReceptionMutationOptions = Apollo.BaseMutationOptions<DeleteWorkOrderReceptionMutation, DeleteWorkOrderReceptionMutationVariables>;
export const DeleteWorkOrderReclamationDocument = gql`
    mutation DeleteWorkOrderReclamation($acKey: String!, $anNo: Int!) {
  deleteWorkOrderReclamation(acKey: $acKey, anNo: $anNo) {
    acKey
    anNo
  }
}
    `;
export type DeleteWorkOrderReclamationMutationFn = Apollo.MutationFunction<DeleteWorkOrderReclamationMutation, DeleteWorkOrderReclamationMutationVariables>;

/**
 * __useDeleteWorkOrderReclamationMutation__
 *
 * To run a mutation, you first call `useDeleteWorkOrderReclamationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkOrderReclamationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkOrderReclamationMutation, { data, loading, error }] = useDeleteWorkOrderReclamationMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      anNo: // value for 'anNo'
 *   },
 * });
 */
export function useDeleteWorkOrderReclamationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkOrderReclamationMutation, DeleteWorkOrderReclamationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkOrderReclamationMutation, DeleteWorkOrderReclamationMutationVariables>(DeleteWorkOrderReclamationDocument, options);
      }
export type DeleteWorkOrderReclamationMutationHookResult = ReturnType<typeof useDeleteWorkOrderReclamationMutation>;
export type DeleteWorkOrderReclamationMutationResult = Apollo.MutationResult<DeleteWorkOrderReclamationMutation>;
export type DeleteWorkOrderReclamationMutationOptions = Apollo.BaseMutationOptions<DeleteWorkOrderReclamationMutation, DeleteWorkOrderReclamationMutationVariables>;
export const DeleteWorkOrderServiceDocument = gql`
    mutation DeleteWorkOrderService($acKey: String!, $anNo: Int!) {
  deleteWorkOrderService(acKey: $acKey, anNo: $anNo) {
    acKey
    anNo
  }
}
    `;
export type DeleteWorkOrderServiceMutationFn = Apollo.MutationFunction<DeleteWorkOrderServiceMutation, DeleteWorkOrderServiceMutationVariables>;

/**
 * __useDeleteWorkOrderServiceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkOrderServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkOrderServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkOrderServiceMutation, { data, loading, error }] = useDeleteWorkOrderServiceMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      anNo: // value for 'anNo'
 *   },
 * });
 */
export function useDeleteWorkOrderServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkOrderServiceMutation, DeleteWorkOrderServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkOrderServiceMutation, DeleteWorkOrderServiceMutationVariables>(DeleteWorkOrderServiceDocument, options);
      }
export type DeleteWorkOrderServiceMutationHookResult = ReturnType<typeof useDeleteWorkOrderServiceMutation>;
export type DeleteWorkOrderServiceMutationResult = Apollo.MutationResult<DeleteWorkOrderServiceMutation>;
export type DeleteWorkOrderServiceMutationOptions = Apollo.BaseMutationOptions<DeleteWorkOrderServiceMutation, DeleteWorkOrderServiceMutationVariables>;
export const DeleteWorkOrderSpecDocument = gql`
    mutation DeleteWorkOrderSpec($acKey: String!, $anNo: Int!) {
  deleteWorkOrderSpec(acKey: $acKey, anNo: $anNo) {
    acKey
    anNo
  }
}
    `;
export type DeleteWorkOrderSpecMutationFn = Apollo.MutationFunction<DeleteWorkOrderSpecMutation, DeleteWorkOrderSpecMutationVariables>;

/**
 * __useDeleteWorkOrderSpecMutation__
 *
 * To run a mutation, you first call `useDeleteWorkOrderSpecMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkOrderSpecMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkOrderSpecMutation, { data, loading, error }] = useDeleteWorkOrderSpecMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      anNo: // value for 'anNo'
 *   },
 * });
 */
export function useDeleteWorkOrderSpecMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkOrderSpecMutation, DeleteWorkOrderSpecMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkOrderSpecMutation, DeleteWorkOrderSpecMutationVariables>(DeleteWorkOrderSpecDocument, options);
      }
export type DeleteWorkOrderSpecMutationHookResult = ReturnType<typeof useDeleteWorkOrderSpecMutation>;
export type DeleteWorkOrderSpecMutationResult = Apollo.MutationResult<DeleteWorkOrderSpecMutation>;
export type DeleteWorkOrderSpecMutationOptions = Apollo.BaseMutationOptions<DeleteWorkOrderSpecMutation, DeleteWorkOrderSpecMutationVariables>;
export const DeliveryNoteControlItemsDocument = gql`
    query DeliveryNoteControlItems($acKey: String!) {
  tHeMoveItem(where: {acKey: {eq: $acKey}}) {
    acIdent
    anQty
    acName
    acUm
    acNote
    anNo
    anPackQty
    acIdentNavigation {
      tHeSetItemExtItemSubj {
        acCode
      }
    }
  }
}
    `;

/**
 * __useDeliveryNoteControlItemsQuery__
 *
 * To run a query within a React component, call `useDeliveryNoteControlItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryNoteControlItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryNoteControlItemsQuery({
 *   variables: {
 *      acKey: // value for 'acKey'
 *   },
 * });
 */
export function useDeliveryNoteControlItemsQuery(baseOptions: Apollo.QueryHookOptions<DeliveryNoteControlItemsQuery, DeliveryNoteControlItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryNoteControlItemsQuery, DeliveryNoteControlItemsQueryVariables>(DeliveryNoteControlItemsDocument, options);
      }
export function useDeliveryNoteControlItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryNoteControlItemsQuery, DeliveryNoteControlItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryNoteControlItemsQuery, DeliveryNoteControlItemsQueryVariables>(DeliveryNoteControlItemsDocument, options);
        }
export type DeliveryNoteControlItemsQueryHookResult = ReturnType<typeof useDeliveryNoteControlItemsQuery>;
export type DeliveryNoteControlItemsLazyQueryHookResult = ReturnType<typeof useDeliveryNoteControlItemsLazyQuery>;
export type DeliveryNoteControlItemsQueryResult = Apollo.QueryResult<DeliveryNoteControlItemsQuery, DeliveryNoteControlItemsQueryVariables>;
export function refetchDeliveryNoteControlItemsQuery(variables: DeliveryNoteControlItemsQueryVariables) {
      return { query: DeliveryNoteControlItemsDocument, variables: variables }
    }
export const DeliveryNotesControlPagedDocument = gql`
    query DeliveryNotesControlPaged($search: String = "", $docType: String!, $fromDate: DateTime!, $toDate: DateTime!, $cursor: String) {
  tHeMovePaged(
    where: {acDocType: {eq: $docType}, adTimeIns: {gte: $fromDate, lte: $toDate}, or: [{acKey: {contains: $search}}, {acNote: {contains: $search}}, {acPrsn3: {contains: $search}}, {acReceiver: {contains: $search}}, {acDoc2: {contains: $search}}], acVerifyStatus: {eq: "N"}, acVerifiedPrices: {eq: "F"}}
    order: {acKey: DESC}
    after: $cursor
  ) {
    nodes {
      acKey
      acNote
      acDoc2
      adTimeIns
      acPrsn3
      acCurrency
      acReceiver
      acDocType
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useDeliveryNotesControlPagedQuery__
 *
 * To run a query within a React component, call `useDeliveryNotesControlPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryNotesControlPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryNotesControlPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      docType: // value for 'docType'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useDeliveryNotesControlPagedQuery(baseOptions: Apollo.QueryHookOptions<DeliveryNotesControlPagedQuery, DeliveryNotesControlPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryNotesControlPagedQuery, DeliveryNotesControlPagedQueryVariables>(DeliveryNotesControlPagedDocument, options);
      }
export function useDeliveryNotesControlPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryNotesControlPagedQuery, DeliveryNotesControlPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryNotesControlPagedQuery, DeliveryNotesControlPagedQueryVariables>(DeliveryNotesControlPagedDocument, options);
        }
export type DeliveryNotesControlPagedQueryHookResult = ReturnType<typeof useDeliveryNotesControlPagedQuery>;
export type DeliveryNotesControlPagedLazyQueryHookResult = ReturnType<typeof useDeliveryNotesControlPagedLazyQuery>;
export type DeliveryNotesControlPagedQueryResult = Apollo.QueryResult<DeliveryNotesControlPagedQuery, DeliveryNotesControlPagedQueryVariables>;
export function refetchDeliveryNotesControlPagedQuery(variables: DeliveryNotesControlPagedQueryVariables) {
      return { query: DeliveryNotesControlPagedDocument, variables: variables }
    }
export const DemoLoginDocument = gql`
    mutation DemoLogin {
  demoLogin
}
    `;
export type DemoLoginMutationFn = Apollo.MutationFunction<DemoLoginMutation, DemoLoginMutationVariables>;

/**
 * __useDemoLoginMutation__
 *
 * To run a mutation, you first call `useDemoLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDemoLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [demoLoginMutation, { data, loading, error }] = useDemoLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useDemoLoginMutation(baseOptions?: Apollo.MutationHookOptions<DemoLoginMutation, DemoLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DemoLoginMutation, DemoLoginMutationVariables>(DemoLoginDocument, options);
      }
export type DemoLoginMutationHookResult = ReturnType<typeof useDemoLoginMutation>;
export type DemoLoginMutationResult = Apollo.MutationResult<DemoLoginMutation>;
export type DemoLoginMutationOptions = Apollo.BaseMutationOptions<DemoLoginMutation, DemoLoginMutationVariables>;
export const DepartmentsDocument = gql`
    query Departments {
  tHeSetSubj(where: {acDept: {eq: "T"}, acActive: {eq: "T"}}) {
    acSubject
    acName2
  }
}
    `;

/**
 * __useDepartmentsQuery__
 *
 * To run a query within a React component, call `useDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
      }
export function useDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
        }
export type DepartmentsQueryHookResult = ReturnType<typeof useDepartmentsQuery>;
export type DepartmentsLazyQueryHookResult = ReturnType<typeof useDepartmentsLazyQuery>;
export type DepartmentsQueryResult = Apollo.QueryResult<DepartmentsQuery, DepartmentsQueryVariables>;
export function refetchDepartmentsQuery(variables?: DepartmentsQueryVariables) {
      return { query: DepartmentsDocument, variables: variables }
    }
export const EndWorkOrderDocument = gql`
    mutation EndWorkOrder($data: SubmittingWorkOrderEndViewModelInput!) {
  endWorkOrder(data: $data) {
    acKey
  }
}
    `;
export type EndWorkOrderMutationFn = Apollo.MutationFunction<EndWorkOrderMutation, EndWorkOrderMutationVariables>;

/**
 * __useEndWorkOrderMutation__
 *
 * To run a mutation, you first call `useEndWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endWorkOrderMutation, { data, loading, error }] = useEndWorkOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEndWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<EndWorkOrderMutation, EndWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndWorkOrderMutation, EndWorkOrderMutationVariables>(EndWorkOrderDocument, options);
      }
export type EndWorkOrderMutationHookResult = ReturnType<typeof useEndWorkOrderMutation>;
export type EndWorkOrderMutationResult = Apollo.MutationResult<EndWorkOrderMutation>;
export type EndWorkOrderMutationOptions = Apollo.BaseMutationOptions<EndWorkOrderMutation, EndWorkOrderMutationVariables>;
export const FinalizeDailyIncomeDocument = gql`
    mutation FinalizeDailyIncome($acDocType: String!) {
  finalizeDailyIncome(acDocType: $acDocType)
}
    `;
export type FinalizeDailyIncomeMutationFn = Apollo.MutationFunction<FinalizeDailyIncomeMutation, FinalizeDailyIncomeMutationVariables>;

/**
 * __useFinalizeDailyIncomeMutation__
 *
 * To run a mutation, you first call `useFinalizeDailyIncomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeDailyIncomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeDailyIncomeMutation, { data, loading, error }] = useFinalizeDailyIncomeMutation({
 *   variables: {
 *      acDocType: // value for 'acDocType'
 *   },
 * });
 */
export function useFinalizeDailyIncomeMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeDailyIncomeMutation, FinalizeDailyIncomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeDailyIncomeMutation, FinalizeDailyIncomeMutationVariables>(FinalizeDailyIncomeDocument, options);
      }
export type FinalizeDailyIncomeMutationHookResult = ReturnType<typeof useFinalizeDailyIncomeMutation>;
export type FinalizeDailyIncomeMutationResult = Apollo.MutationResult<FinalizeDailyIncomeMutation>;
export type FinalizeDailyIncomeMutationOptions = Apollo.BaseMutationOptions<FinalizeDailyIncomeMutation, FinalizeDailyIncomeMutationVariables>;
export const FinishDeliveryNotesControlDocument = gql`
    mutation FinishDeliveryNotesControl($acKey: String!) {
  finishDeliveryNotesControl(acKey: $acKey)
}
    `;
export type FinishDeliveryNotesControlMutationFn = Apollo.MutationFunction<FinishDeliveryNotesControlMutation, FinishDeliveryNotesControlMutationVariables>;

/**
 * __useFinishDeliveryNotesControlMutation__
 *
 * To run a mutation, you first call `useFinishDeliveryNotesControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishDeliveryNotesControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishDeliveryNotesControlMutation, { data, loading, error }] = useFinishDeliveryNotesControlMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *   },
 * });
 */
export function useFinishDeliveryNotesControlMutation(baseOptions?: Apollo.MutationHookOptions<FinishDeliveryNotesControlMutation, FinishDeliveryNotesControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishDeliveryNotesControlMutation, FinishDeliveryNotesControlMutationVariables>(FinishDeliveryNotesControlDocument, options);
      }
export type FinishDeliveryNotesControlMutationHookResult = ReturnType<typeof useFinishDeliveryNotesControlMutation>;
export type FinishDeliveryNotesControlMutationResult = Apollo.MutationResult<FinishDeliveryNotesControlMutation>;
export type FinishDeliveryNotesControlMutationOptions = Apollo.BaseMutationOptions<FinishDeliveryNotesControlMutation, FinishDeliveryNotesControlMutationVariables>;
export const FinishDeliveryNotesControlPartialDocument = gql`
    mutation FinishDeliveryNotesControlPartial($acKey: String!, $items: [PartialFinishDeliveryNotesItemDtoInput]!) {
  finishDeliveryNotesControlPartial(acKey: $acKey, items: $items)
}
    `;
export type FinishDeliveryNotesControlPartialMutationFn = Apollo.MutationFunction<FinishDeliveryNotesControlPartialMutation, FinishDeliveryNotesControlPartialMutationVariables>;

/**
 * __useFinishDeliveryNotesControlPartialMutation__
 *
 * To run a mutation, you first call `useFinishDeliveryNotesControlPartialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishDeliveryNotesControlPartialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishDeliveryNotesControlPartialMutation, { data, loading, error }] = useFinishDeliveryNotesControlPartialMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useFinishDeliveryNotesControlPartialMutation(baseOptions?: Apollo.MutationHookOptions<FinishDeliveryNotesControlPartialMutation, FinishDeliveryNotesControlPartialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishDeliveryNotesControlPartialMutation, FinishDeliveryNotesControlPartialMutationVariables>(FinishDeliveryNotesControlPartialDocument, options);
      }
export type FinishDeliveryNotesControlPartialMutationHookResult = ReturnType<typeof useFinishDeliveryNotesControlPartialMutation>;
export type FinishDeliveryNotesControlPartialMutationResult = Apollo.MutationResult<FinishDeliveryNotesControlPartialMutation>;
export type FinishDeliveryNotesControlPartialMutationOptions = Apollo.BaseMutationOptions<FinishDeliveryNotesControlPartialMutation, FinishDeliveryNotesControlPartialMutationVariables>;
export const GetMarservisUserWorkOrderItemWorksDocument = gql`
    query GetMarservisUserWorkOrderItemWorks($itemId: Int!) {
  marservisWorkOrderItemWorks(where: {workOrderItemId: {eq: $itemId}}) {
    id
    workOrderItemId
    time
    date
    cause
    remedy
    note
    materials
  }
}
    `;

/**
 * __useGetMarservisUserWorkOrderItemWorksQuery__
 *
 * To run a query within a React component, call `useGetMarservisUserWorkOrderItemWorksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarservisUserWorkOrderItemWorksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarservisUserWorkOrderItemWorksQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useGetMarservisUserWorkOrderItemWorksQuery(baseOptions: Apollo.QueryHookOptions<GetMarservisUserWorkOrderItemWorksQuery, GetMarservisUserWorkOrderItemWorksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarservisUserWorkOrderItemWorksQuery, GetMarservisUserWorkOrderItemWorksQueryVariables>(GetMarservisUserWorkOrderItemWorksDocument, options);
      }
export function useGetMarservisUserWorkOrderItemWorksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarservisUserWorkOrderItemWorksQuery, GetMarservisUserWorkOrderItemWorksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarservisUserWorkOrderItemWorksQuery, GetMarservisUserWorkOrderItemWorksQueryVariables>(GetMarservisUserWorkOrderItemWorksDocument, options);
        }
export type GetMarservisUserWorkOrderItemWorksQueryHookResult = ReturnType<typeof useGetMarservisUserWorkOrderItemWorksQuery>;
export type GetMarservisUserWorkOrderItemWorksLazyQueryHookResult = ReturnType<typeof useGetMarservisUserWorkOrderItemWorksLazyQuery>;
export type GetMarservisUserWorkOrderItemWorksQueryResult = Apollo.QueryResult<GetMarservisUserWorkOrderItemWorksQuery, GetMarservisUserWorkOrderItemWorksQueryVariables>;
export function refetchGetMarservisUserWorkOrderItemWorksQuery(variables: GetMarservisUserWorkOrderItemWorksQueryVariables) {
      return { query: GetMarservisUserWorkOrderItemWorksDocument, variables: variables }
    }
export const GetMarservisUserWorkOrderItemsDocument = gql`
    query GetMarservisUserWorkOrderItems($search: String = "", $cursor: String, $userId: String!) {
  marservisUserWorkOrderItems(
    where: {or: [{subjectLongName: {contains: $search}}, {subjectShortName: {contains: $search}}, {projectName: {contains: $search}}, {workOrderLocation: {contains: $search}}, {itemName: {contains: $search}}], userId: {eq: $userId}}
    after: $cursor
    order: {deadlineDate: DESC}
  ) {
    nodes {
      id
      subjectId
      projectName
      subjectShortName
      subjectLongName
      workOrderStatus
      workOrderLocation
      workOrderDateEnd
      workOrderId
      deadlineDate
      note
      itemName
      itemCode
      itemId
      status
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetMarservisUserWorkOrderItemsQuery__
 *
 * To run a query within a React component, call `useGetMarservisUserWorkOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarservisUserWorkOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarservisUserWorkOrderItemsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMarservisUserWorkOrderItemsQuery(baseOptions: Apollo.QueryHookOptions<GetMarservisUserWorkOrderItemsQuery, GetMarservisUserWorkOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarservisUserWorkOrderItemsQuery, GetMarservisUserWorkOrderItemsQueryVariables>(GetMarservisUserWorkOrderItemsDocument, options);
      }
export function useGetMarservisUserWorkOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarservisUserWorkOrderItemsQuery, GetMarservisUserWorkOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarservisUserWorkOrderItemsQuery, GetMarservisUserWorkOrderItemsQueryVariables>(GetMarservisUserWorkOrderItemsDocument, options);
        }
export type GetMarservisUserWorkOrderItemsQueryHookResult = ReturnType<typeof useGetMarservisUserWorkOrderItemsQuery>;
export type GetMarservisUserWorkOrderItemsLazyQueryHookResult = ReturnType<typeof useGetMarservisUserWorkOrderItemsLazyQuery>;
export type GetMarservisUserWorkOrderItemsQueryResult = Apollo.QueryResult<GetMarservisUserWorkOrderItemsQuery, GetMarservisUserWorkOrderItemsQueryVariables>;
export function refetchGetMarservisUserWorkOrderItemsQuery(variables: GetMarservisUserWorkOrderItemsQueryVariables) {
      return { query: GetMarservisUserWorkOrderItemsDocument, variables: variables }
    }
export const GetMarservisWorkOrderItemStatusDocument = gql`
    query GetMarservisWorkOrderItemStatus($id: Int!) {
  marservisWorkOrderItemStatus(id: $id)
}
    `;

/**
 * __useGetMarservisWorkOrderItemStatusQuery__
 *
 * To run a query within a React component, call `useGetMarservisWorkOrderItemStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarservisWorkOrderItemStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarservisWorkOrderItemStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMarservisWorkOrderItemStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMarservisWorkOrderItemStatusQuery, GetMarservisWorkOrderItemStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarservisWorkOrderItemStatusQuery, GetMarservisWorkOrderItemStatusQueryVariables>(GetMarservisWorkOrderItemStatusDocument, options);
      }
export function useGetMarservisWorkOrderItemStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarservisWorkOrderItemStatusQuery, GetMarservisWorkOrderItemStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarservisWorkOrderItemStatusQuery, GetMarservisWorkOrderItemStatusQueryVariables>(GetMarservisWorkOrderItemStatusDocument, options);
        }
export type GetMarservisWorkOrderItemStatusQueryHookResult = ReturnType<typeof useGetMarservisWorkOrderItemStatusQuery>;
export type GetMarservisWorkOrderItemStatusLazyQueryHookResult = ReturnType<typeof useGetMarservisWorkOrderItemStatusLazyQuery>;
export type GetMarservisWorkOrderItemStatusQueryResult = Apollo.QueryResult<GetMarservisWorkOrderItemStatusQuery, GetMarservisWorkOrderItemStatusQueryVariables>;
export function refetchGetMarservisWorkOrderItemStatusQuery(variables: GetMarservisWorkOrderItemStatusQueryVariables) {
      return { query: GetMarservisWorkOrderItemStatusDocument, variables: variables }
    }
export const GetMarservisWorkOrderItemsDocument = gql`
    query GetMarservisWorkOrderItems($search: String = "", $cursor: String, $userId: String!, $workOrderId: String!) {
  marservisUserWorkOrderItems(
    where: {or: [{subjectLongName: {contains: $search}}, {subjectShortName: {contains: $search}}, {projectName: {contains: $search}}, {workOrderLocation: {contains: $search}}, {itemName: {contains: $search}}], userId: {eq: $userId}, workOrderId: {eq: $workOrderId}}
    after: $cursor
    order: {deadlineDate: DESC}
  ) {
    nodes {
      id
      subjectId
      projectName
      subjectShortName
      subjectLongName
      workOrderStatus
      workOrderLocation
      workOrderDateEnd
      workOrderId
      deadlineDate
      note
      itemName
      itemCode
      itemId
      status
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetMarservisWorkOrderItemsQuery__
 *
 * To run a query within a React component, call `useGetMarservisWorkOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarservisWorkOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarservisWorkOrderItemsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      userId: // value for 'userId'
 *      workOrderId: // value for 'workOrderId'
 *   },
 * });
 */
export function useGetMarservisWorkOrderItemsQuery(baseOptions: Apollo.QueryHookOptions<GetMarservisWorkOrderItemsQuery, GetMarservisWorkOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarservisWorkOrderItemsQuery, GetMarservisWorkOrderItemsQueryVariables>(GetMarservisWorkOrderItemsDocument, options);
      }
export function useGetMarservisWorkOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarservisWorkOrderItemsQuery, GetMarservisWorkOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarservisWorkOrderItemsQuery, GetMarservisWorkOrderItemsQueryVariables>(GetMarservisWorkOrderItemsDocument, options);
        }
export type GetMarservisWorkOrderItemsQueryHookResult = ReturnType<typeof useGetMarservisWorkOrderItemsQuery>;
export type GetMarservisWorkOrderItemsLazyQueryHookResult = ReturnType<typeof useGetMarservisWorkOrderItemsLazyQuery>;
export type GetMarservisWorkOrderItemsQueryResult = Apollo.QueryResult<GetMarservisWorkOrderItemsQuery, GetMarservisWorkOrderItemsQueryVariables>;
export function refetchGetMarservisWorkOrderItemsQuery(variables: GetMarservisWorkOrderItemsQueryVariables) {
      return { query: GetMarservisWorkOrderItemsDocument, variables: variables }
    }
export const GetMarservisWorkOrdersDocument = gql`
    query GetMarservisWorkOrders($search: String = "", $cursor: String) {
  marservisUserWorkOrders(
    where: {id: {contains: $search}}
    after: $cursor
    order: {date: DESC}
  ) {
    nodes {
      id
      dateEnd
      hasFiles
      documentNumber
      date
      project {
        name
      }
      subject {
        shortName
        longName
      }
      note
      status
      location
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetMarservisWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetMarservisWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarservisWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarservisWorkOrdersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetMarservisWorkOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetMarservisWorkOrdersQuery, GetMarservisWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarservisWorkOrdersQuery, GetMarservisWorkOrdersQueryVariables>(GetMarservisWorkOrdersDocument, options);
      }
export function useGetMarservisWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarservisWorkOrdersQuery, GetMarservisWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarservisWorkOrdersQuery, GetMarservisWorkOrdersQueryVariables>(GetMarservisWorkOrdersDocument, options);
        }
export type GetMarservisWorkOrdersQueryHookResult = ReturnType<typeof useGetMarservisWorkOrdersQuery>;
export type GetMarservisWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetMarservisWorkOrdersLazyQuery>;
export type GetMarservisWorkOrdersQueryResult = Apollo.QueryResult<GetMarservisWorkOrdersQuery, GetMarservisWorkOrdersQueryVariables>;
export function refetchGetMarservisWorkOrdersQuery(variables?: GetMarservisWorkOrdersQueryVariables) {
      return { query: GetMarservisWorkOrdersDocument, variables: variables }
    }
export const GetTHeOrdersDocument = gql`
    query getTHeOrders($where: THeOrderFilterInput, $order: [THeOrderSortInput!]) {
  tHeOrder(where: $where, order: $order) {
    acKey
    acConsignee
    acReceiver
    acWarehouse
    acStatus
    acStatusNavigation {
      acName
    }
    adDate
    acNote
    acContactPrsn
    acContactPrsn3
    anForPay
    tHeOrderItem {
      anNo
      acName
      acIdent
      acNote
    }
  }
}
    `;

/**
 * __useGetTHeOrdersQuery__
 *
 * To run a query within a React component, call `useGetTHeOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTHeOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTHeOrdersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetTHeOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetTHeOrdersQuery, GetTHeOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTHeOrdersQuery, GetTHeOrdersQueryVariables>(GetTHeOrdersDocument, options);
      }
export function useGetTHeOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTHeOrdersQuery, GetTHeOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTHeOrdersQuery, GetTHeOrdersQueryVariables>(GetTHeOrdersDocument, options);
        }
export type GetTHeOrdersQueryHookResult = ReturnType<typeof useGetTHeOrdersQuery>;
export type GetTHeOrdersLazyQueryHookResult = ReturnType<typeof useGetTHeOrdersLazyQuery>;
export type GetTHeOrdersQueryResult = Apollo.QueryResult<GetTHeOrdersQuery, GetTHeOrdersQueryVariables>;
export function refetchGetTHeOrdersQuery(variables?: GetTHeOrdersQueryVariables) {
      return { query: GetTHeOrdersDocument, variables: variables }
    }
export const GetUserTokenDocument = gql`
    query GetUserToken($userId: String!) {
  loginAsUser(userId: $userId)
}
    `;

/**
 * __useGetUserTokenQuery__
 *
 * To run a query within a React component, call `useGetUserTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTokenQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserTokenQuery(baseOptions: Apollo.QueryHookOptions<GetUserTokenQuery, GetUserTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTokenQuery, GetUserTokenQueryVariables>(GetUserTokenDocument, options);
      }
export function useGetUserTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTokenQuery, GetUserTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTokenQuery, GetUserTokenQueryVariables>(GetUserTokenDocument, options);
        }
export type GetUserTokenQueryHookResult = ReturnType<typeof useGetUserTokenQuery>;
export type GetUserTokenLazyQueryHookResult = ReturnType<typeof useGetUserTokenLazyQuery>;
export type GetUserTokenQueryResult = Apollo.QueryResult<GetUserTokenQuery, GetUserTokenQueryVariables>;
export function refetchGetUserTokenQuery(variables: GetUserTokenQueryVariables) {
      return { query: GetUserTokenDocument, variables: variables }
    }
export const GetWorkOrderDocument = gql`
    query GetWorkOrder($acKey: String!) {
  workOrder(acKey: $acKey) {
    workImages {
      acLnkKey
      acName
      anKey
    }
    workMaterial {
      acIdent
      acKey
      acName
      acNote
      acSerialNo
      acUm
      anNo
      anQty
    }
    workMove {
      acContactPrsn
      acContactPrsn3
      acDept
      acDocType
      acFieldSA
      acIssuer
      acKey
      acNote
      acVerifyStatus
      adDate
      adFieldDA
      adTimeIns
      anClerkAcName
      anClerkAcSurname
      anFieldNA
      anFieldNB
      bearerAddress
      bearerName
      bearerPIN
      bearerPostName
      bearerPost
      customerAddress
      customerName
      customerPIN
      customerPostName
      customerPost
    }
    workReceptions {
      acIdent
      acKey
      acName
      acNote
      acSerialNo
      acSetOfItem
      acUm
      anNo
      anQty
    }
    workReclamations {
      acIdent
      acKey
      acName
      acNote
      acUm
      anNo
      anQty
    }
    workServices {
      acIdent
      acKey
      acName
      acNote
      acUm
      anNo
      anQty
    }
    workSpec {
      _AcNote2
      acIdent
      acKey
      acName
      acWorker
      adWorkEnd
      adWorkStart
      anMileage
      anNo
      anWork
    }
  }
}
    `;

/**
 * __useGetWorkOrderQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderQuery({
 *   variables: {
 *      acKey: // value for 'acKey'
 *   },
 * });
 */
export function useGetWorkOrderQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderQuery, GetWorkOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderQuery, GetWorkOrderQueryVariables>(GetWorkOrderDocument, options);
      }
export function useGetWorkOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderQuery, GetWorkOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderQuery, GetWorkOrderQueryVariables>(GetWorkOrderDocument, options);
        }
export type GetWorkOrderQueryHookResult = ReturnType<typeof useGetWorkOrderQuery>;
export type GetWorkOrderLazyQueryHookResult = ReturnType<typeof useGetWorkOrderLazyQuery>;
export type GetWorkOrderQueryResult = Apollo.QueryResult<GetWorkOrderQuery, GetWorkOrderQueryVariables>;
export function refetchGetWorkOrderQuery(variables: GetWorkOrderQueryVariables) {
      return { query: GetWorkOrderDocument, variables: variables }
    }
export const GetWorkOrderPdfDocument = gql`
    query GetWorkOrderPDF($acKey: String!) {
  workOrderPDF(acKey: $acKey) {
    data
  }
}
    `;

/**
 * __useGetWorkOrderPdfQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderPdfQuery({
 *   variables: {
 *      acKey: // value for 'acKey'
 *   },
 * });
 */
export function useGetWorkOrderPdfQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderPdfQuery, GetWorkOrderPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderPdfQuery, GetWorkOrderPdfQueryVariables>(GetWorkOrderPdfDocument, options);
      }
export function useGetWorkOrderPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderPdfQuery, GetWorkOrderPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderPdfQuery, GetWorkOrderPdfQueryVariables>(GetWorkOrderPdfDocument, options);
        }
export type GetWorkOrderPdfQueryHookResult = ReturnType<typeof useGetWorkOrderPdfQuery>;
export type GetWorkOrderPdfLazyQueryHookResult = ReturnType<typeof useGetWorkOrderPdfLazyQuery>;
export type GetWorkOrderPdfQueryResult = Apollo.QueryResult<GetWorkOrderPdfQuery, GetWorkOrderPdfQueryVariables>;
export function refetchGetWorkOrderPdfQuery(variables: GetWorkOrderPdfQueryVariables) {
      return { query: GetWorkOrderPdfDocument, variables: variables }
    }
export const LastTHeMoveAcKeyDocument = gql`
    query LastTHeMoveAcKey($acDocType: String!) {
  singleTHeMoveSortable(
    order: {acKey: DESC}
    where: {acDocType: {eq: $acDocType}}
  ) {
    acKey
  }
}
    `;

/**
 * __useLastTHeMoveAcKeyQuery__
 *
 * To run a query within a React component, call `useLastTHeMoveAcKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastTHeMoveAcKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastTHeMoveAcKeyQuery({
 *   variables: {
 *      acDocType: // value for 'acDocType'
 *   },
 * });
 */
export function useLastTHeMoveAcKeyQuery(baseOptions: Apollo.QueryHookOptions<LastTHeMoveAcKeyQuery, LastTHeMoveAcKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastTHeMoveAcKeyQuery, LastTHeMoveAcKeyQueryVariables>(LastTHeMoveAcKeyDocument, options);
      }
export function useLastTHeMoveAcKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastTHeMoveAcKeyQuery, LastTHeMoveAcKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastTHeMoveAcKeyQuery, LastTHeMoveAcKeyQueryVariables>(LastTHeMoveAcKeyDocument, options);
        }
export type LastTHeMoveAcKeyQueryHookResult = ReturnType<typeof useLastTHeMoveAcKeyQuery>;
export type LastTHeMoveAcKeyLazyQueryHookResult = ReturnType<typeof useLastTHeMoveAcKeyLazyQuery>;
export type LastTHeMoveAcKeyQueryResult = Apollo.QueryResult<LastTHeMoveAcKeyQuery, LastTHeMoveAcKeyQueryVariables>;
export function refetchLastTHeMoveAcKeyQuery(variables: LastTHeMoveAcKeyQueryVariables) {
      return { query: LastTHeMoveAcKeyDocument, variables: variables }
    }
export const LicenseTakeOverDocument = gql`
    mutation LicenseTakeOver {
  licenseTakeOver
}
    `;
export type LicenseTakeOverMutationFn = Apollo.MutationFunction<LicenseTakeOverMutation, LicenseTakeOverMutationVariables>;

/**
 * __useLicenseTakeOverMutation__
 *
 * To run a mutation, you first call `useLicenseTakeOverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLicenseTakeOverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [licenseTakeOverMutation, { data, loading, error }] = useLicenseTakeOverMutation({
 *   variables: {
 *   },
 * });
 */
export function useLicenseTakeOverMutation(baseOptions?: Apollo.MutationHookOptions<LicenseTakeOverMutation, LicenseTakeOverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LicenseTakeOverMutation, LicenseTakeOverMutationVariables>(LicenseTakeOverDocument, options);
      }
export type LicenseTakeOverMutationHookResult = ReturnType<typeof useLicenseTakeOverMutation>;
export type LicenseTakeOverMutationResult = Apollo.MutationResult<LicenseTakeOverMutation>;
export type LicenseTakeOverMutationOptions = Apollo.BaseMutationOptions<LicenseTakeOverMutation, LicenseTakeOverMutationVariables>;
export const LoginDocument = gql`
    mutation Login($userNameOrEmail: String!, $password: String!, $takeLicense: Boolean = false) {
  login(
    loginModel: {password: $password, userNameOrEmail: $userNameOrEmail, takeLicense: $takeLicense}
  )
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      userNameOrEmail: // value for 'userNameOrEmail'
 *      password: // value for 'password'
 *      takeLicense: // value for 'takeLicense'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LurInvoiceItemsDocument = gql`
    query LURInvoiceItems($ackey: String!) {
  tHeMoveItem(where: {acKey: {eq: $ackey}}) {
    acName
    acIdent
    anRebate
    anPrice
    anQty
    anPackQty
    acUm
    acNote
    anNo
    acUM2
    acKey
    anRebate1
    anRebate2
    anRebate3
    anWarrenty
    anPvforPay
    anPvvat
    acVatcode
    anPvocvat
    anDimWeight
    acIdentNavigation {
      acIdent
      acCode
      anUmtoUm2
      acDescr
    }
  }
}
    `;

/**
 * __useLurInvoiceItemsQuery__
 *
 * To run a query within a React component, call `useLurInvoiceItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLurInvoiceItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLurInvoiceItemsQuery({
 *   variables: {
 *      ackey: // value for 'ackey'
 *   },
 * });
 */
export function useLurInvoiceItemsQuery(baseOptions: Apollo.QueryHookOptions<LurInvoiceItemsQuery, LurInvoiceItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LurInvoiceItemsQuery, LurInvoiceItemsQueryVariables>(LurInvoiceItemsDocument, options);
      }
export function useLurInvoiceItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LurInvoiceItemsQuery, LurInvoiceItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LurInvoiceItemsQuery, LurInvoiceItemsQueryVariables>(LurInvoiceItemsDocument, options);
        }
export type LurInvoiceItemsQueryHookResult = ReturnType<typeof useLurInvoiceItemsQuery>;
export type LurInvoiceItemsLazyQueryHookResult = ReturnType<typeof useLurInvoiceItemsLazyQuery>;
export type LurInvoiceItemsQueryResult = Apollo.QueryResult<LurInvoiceItemsQuery, LurInvoiceItemsQueryVariables>;
export function refetchLurInvoiceItemsQuery(variables: LurInvoiceItemsQueryVariables) {
      return { query: LurInvoiceItemsDocument, variables: variables }
    }
export const LurInvoiceListPagedDocument = gql`
    query LURInvoiceListPaged($search: String = "", $docTypes: [String], $fromDate: DateTime!, $toDate: DateTime!, $cursor: String) {
  lURInvoiceListItems(
    where: {acDocType: {in: $docTypes}, adTimeIns: {gte: $fromDate, lte: $toDate}, or: [{acKey: {contains: $search}}, {acNote: {contains: $search}}, {acPrsn3: {contains: $search}}]}
    order: {acKey: DESC}
    after: $cursor
  ) {
    nodes {
      acKey
      acNote
      adTimeIns
      acPrsn3
      anForPay
      acVerifiedPrices
      acHrFiskalNumber
      acPayMethod
      acDept
      acDoc1
      acDoc2
      acCurrency
      acReceiver
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useLurInvoiceListPagedQuery__
 *
 * To run a query within a React component, call `useLurInvoiceListPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLurInvoiceListPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLurInvoiceListPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      docTypes: // value for 'docTypes'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useLurInvoiceListPagedQuery(baseOptions: Apollo.QueryHookOptions<LurInvoiceListPagedQuery, LurInvoiceListPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LurInvoiceListPagedQuery, LurInvoiceListPagedQueryVariables>(LurInvoiceListPagedDocument, options);
      }
export function useLurInvoiceListPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LurInvoiceListPagedQuery, LurInvoiceListPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LurInvoiceListPagedQuery, LurInvoiceListPagedQueryVariables>(LurInvoiceListPagedDocument, options);
        }
export type LurInvoiceListPagedQueryHookResult = ReturnType<typeof useLurInvoiceListPagedQuery>;
export type LurInvoiceListPagedLazyQueryHookResult = ReturnType<typeof useLurInvoiceListPagedLazyQuery>;
export type LurInvoiceListPagedQueryResult = Apollo.QueryResult<LurInvoiceListPagedQuery, LurInvoiceListPagedQueryVariables>;
export function refetchLurInvoiceListPagedQuery(variables: LurInvoiceListPagedQueryVariables) {
      return { query: LurInvoiceListPagedDocument, variables: variables }
    }
export const LurInvoicePdfDocument = gql`
    query LURInvoicePDF($ackey: String!) {
  lURInvoicePDF(acKey: $ackey) {
    acKey
    adDate
    acReceiver
    acNote
    adDateTimePrint
    anFieldNB
    acDocType
    acReceiverNavigation: acReceiverNavigation {
      acPin
      acName2
      acAddress
      acPostNavigation {
        acPost
        acName
      }
    }
    acPrsn3
    acPrsn3Navigation {
      acAddress
      acPost
      acName2
      acPostNavigation {
        acPost
        acName
      }
    }
    tHeMoveItem {
      acUm
      anQty
      acName
      acIdent
      acIdentNavigation {
        acCode
        acClassif
        acDescr
      }
      anPrice
      anRebate
      acNote
      tHeMoveItemSerialNo {
        acSerialNo
        anQty
      }
      anPvforPay
      anPvvat
      acVatcode
      anPvocvat
      acVatcodeNavigation {
        acVatcode
        anVat
      }
    }
    acCurrency
    anValue
    anDiscount
    anVat
    anForPay
    anNoteClerkNavigation {
      acName
      acSurname
    }
    acDeliveryNavigation {
      acName
    }
    acPayMethodNavigation {
      acName
      acFiscalGroup
    }
    anClerkNavigation {
      acName
      acSurname
    }
    acDoc1
    acDoc2
    acDept
  }
  singleVHeMoveFiscalisation(where: {acKey: {eq: $ackey}}) {
    acHrfiskalNumber
  }
}
    `;

/**
 * __useLurInvoicePdfQuery__
 *
 * To run a query within a React component, call `useLurInvoicePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useLurInvoicePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLurInvoicePdfQuery({
 *   variables: {
 *      ackey: // value for 'ackey'
 *   },
 * });
 */
export function useLurInvoicePdfQuery(baseOptions: Apollo.QueryHookOptions<LurInvoicePdfQuery, LurInvoicePdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LurInvoicePdfQuery, LurInvoicePdfQueryVariables>(LurInvoicePdfDocument, options);
      }
export function useLurInvoicePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LurInvoicePdfQuery, LurInvoicePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LurInvoicePdfQuery, LurInvoicePdfQueryVariables>(LurInvoicePdfDocument, options);
        }
export type LurInvoicePdfQueryHookResult = ReturnType<typeof useLurInvoicePdfQuery>;
export type LurInvoicePdfLazyQueryHookResult = ReturnType<typeof useLurInvoicePdfLazyQuery>;
export type LurInvoicePdfQueryResult = Apollo.QueryResult<LurInvoicePdfQuery, LurInvoicePdfQueryVariables>;
export function refetchLurInvoicePdfQuery(variables: LurInvoicePdfQueryVariables) {
      return { query: LurInvoicePdfDocument, variables: variables }
    }
export const MarkOnixPhoneUserTaskQueueDocument = gql`
    mutation MarkOnixPhoneUserTaskQueue($taskId: Int!, $response: String, $failed: Boolean!) {
  markOnixPhoneUserTaskQueue(
    taskId: $taskId
    response: $response
    failed: $failed
  )
}
    `;
export type MarkOnixPhoneUserTaskQueueMutationFn = Apollo.MutationFunction<MarkOnixPhoneUserTaskQueueMutation, MarkOnixPhoneUserTaskQueueMutationVariables>;

/**
 * __useMarkOnixPhoneUserTaskQueueMutation__
 *
 * To run a mutation, you first call `useMarkOnixPhoneUserTaskQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOnixPhoneUserTaskQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOnixPhoneUserTaskQueueMutation, { data, loading, error }] = useMarkOnixPhoneUserTaskQueueMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      response: // value for 'response'
 *      failed: // value for 'failed'
 *   },
 * });
 */
export function useMarkOnixPhoneUserTaskQueueMutation(baseOptions?: Apollo.MutationHookOptions<MarkOnixPhoneUserTaskQueueMutation, MarkOnixPhoneUserTaskQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkOnixPhoneUserTaskQueueMutation, MarkOnixPhoneUserTaskQueueMutationVariables>(MarkOnixPhoneUserTaskQueueDocument, options);
      }
export type MarkOnixPhoneUserTaskQueueMutationHookResult = ReturnType<typeof useMarkOnixPhoneUserTaskQueueMutation>;
export type MarkOnixPhoneUserTaskQueueMutationResult = Apollo.MutationResult<MarkOnixPhoneUserTaskQueueMutation>;
export type MarkOnixPhoneUserTaskQueueMutationOptions = Apollo.BaseMutationOptions<MarkOnixPhoneUserTaskQueueMutation, MarkOnixPhoneUserTaskQueueMutationVariables>;
export const MarservisAddWorkDocument = gql`
    mutation MarservisAddWork($work: MarservisWorkOrderItemWorkDtoInput!) {
  createMarservisWorkOrderItemWork(work: $work)
}
    `;
export type MarservisAddWorkMutationFn = Apollo.MutationFunction<MarservisAddWorkMutation, MarservisAddWorkMutationVariables>;

/**
 * __useMarservisAddWorkMutation__
 *
 * To run a mutation, you first call `useMarservisAddWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarservisAddWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marservisAddWorkMutation, { data, loading, error }] = useMarservisAddWorkMutation({
 *   variables: {
 *      work: // value for 'work'
 *   },
 * });
 */
export function useMarservisAddWorkMutation(baseOptions?: Apollo.MutationHookOptions<MarservisAddWorkMutation, MarservisAddWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarservisAddWorkMutation, MarservisAddWorkMutationVariables>(MarservisAddWorkDocument, options);
      }
export type MarservisAddWorkMutationHookResult = ReturnType<typeof useMarservisAddWorkMutation>;
export type MarservisAddWorkMutationResult = Apollo.MutationResult<MarservisAddWorkMutation>;
export type MarservisAddWorkMutationOptions = Apollo.BaseMutationOptions<MarservisAddWorkMutation, MarservisAddWorkMutationVariables>;
export const MarservisDeleteWorkDocument = gql`
    mutation MarservisDeleteWork($work: MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput!) {
  deleteMarservisWorkOrderItemWork(work: $work)
}
    `;
export type MarservisDeleteWorkMutationFn = Apollo.MutationFunction<MarservisDeleteWorkMutation, MarservisDeleteWorkMutationVariables>;

/**
 * __useMarservisDeleteWorkMutation__
 *
 * To run a mutation, you first call `useMarservisDeleteWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarservisDeleteWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marservisDeleteWorkMutation, { data, loading, error }] = useMarservisDeleteWorkMutation({
 *   variables: {
 *      work: // value for 'work'
 *   },
 * });
 */
export function useMarservisDeleteWorkMutation(baseOptions?: Apollo.MutationHookOptions<MarservisDeleteWorkMutation, MarservisDeleteWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarservisDeleteWorkMutation, MarservisDeleteWorkMutationVariables>(MarservisDeleteWorkDocument, options);
      }
export type MarservisDeleteWorkMutationHookResult = ReturnType<typeof useMarservisDeleteWorkMutation>;
export type MarservisDeleteWorkMutationResult = Apollo.MutationResult<MarservisDeleteWorkMutation>;
export type MarservisDeleteWorkMutationOptions = Apollo.BaseMutationOptions<MarservisDeleteWorkMutation, MarservisDeleteWorkMutationVariables>;
export const MarservisUpdateWorkDocument = gql`
    mutation MarservisUpdateWork($work: MarservisWorkOrderItemWorkWithoutFilesReturnDtoInput!) {
  updateMarservisWorkOrderItemWork(work: $work)
}
    `;
export type MarservisUpdateWorkMutationFn = Apollo.MutationFunction<MarservisUpdateWorkMutation, MarservisUpdateWorkMutationVariables>;

/**
 * __useMarservisUpdateWorkMutation__
 *
 * To run a mutation, you first call `useMarservisUpdateWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarservisUpdateWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [marservisUpdateWorkMutation, { data, loading, error }] = useMarservisUpdateWorkMutation({
 *   variables: {
 *      work: // value for 'work'
 *   },
 * });
 */
export function useMarservisUpdateWorkMutation(baseOptions?: Apollo.MutationHookOptions<MarservisUpdateWorkMutation, MarservisUpdateWorkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarservisUpdateWorkMutation, MarservisUpdateWorkMutationVariables>(MarservisUpdateWorkDocument, options);
      }
export type MarservisUpdateWorkMutationHookResult = ReturnType<typeof useMarservisUpdateWorkMutation>;
export type MarservisUpdateWorkMutationResult = Apollo.MutationResult<MarservisUpdateWorkMutation>;
export type MarservisUpdateWorkMutationOptions = Apollo.BaseMutationOptions<MarservisUpdateWorkMutation, MarservisUpdateWorkMutationVariables>;
export const MarservisWorkOrderItemSavedFilesDocument = gql`
    query MarservisWorkOrderItemSavedFiles($workOrderId: String!) {
  marservisWorkOrderSavedFiles(where: {workOrderId: {eq: $workOrderId}}) {
    id
    workOrderId
    name
    description
  }
}
    `;

/**
 * __useMarservisWorkOrderItemSavedFilesQuery__
 *
 * To run a query within a React component, call `useMarservisWorkOrderItemSavedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarservisWorkOrderItemSavedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarservisWorkOrderItemSavedFilesQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *   },
 * });
 */
export function useMarservisWorkOrderItemSavedFilesQuery(baseOptions: Apollo.QueryHookOptions<MarservisWorkOrderItemSavedFilesQuery, MarservisWorkOrderItemSavedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarservisWorkOrderItemSavedFilesQuery, MarservisWorkOrderItemSavedFilesQueryVariables>(MarservisWorkOrderItemSavedFilesDocument, options);
      }
export function useMarservisWorkOrderItemSavedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarservisWorkOrderItemSavedFilesQuery, MarservisWorkOrderItemSavedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarservisWorkOrderItemSavedFilesQuery, MarservisWorkOrderItemSavedFilesQueryVariables>(MarservisWorkOrderItemSavedFilesDocument, options);
        }
export type MarservisWorkOrderItemSavedFilesQueryHookResult = ReturnType<typeof useMarservisWorkOrderItemSavedFilesQuery>;
export type MarservisWorkOrderItemSavedFilesLazyQueryHookResult = ReturnType<typeof useMarservisWorkOrderItemSavedFilesLazyQuery>;
export type MarservisWorkOrderItemSavedFilesQueryResult = Apollo.QueryResult<MarservisWorkOrderItemSavedFilesQuery, MarservisWorkOrderItemSavedFilesQueryVariables>;
export function refetchMarservisWorkOrderItemSavedFilesQuery(variables: MarservisWorkOrderItemSavedFilesQueryVariables) {
      return { query: MarservisWorkOrderItemSavedFilesDocument, variables: variables }
    }
export const MarservisWorkOrderItemWorkSavedFilesDocument = gql`
    query MarservisWorkOrderItemWorkSavedFiles($workOrderWorkId: Int!, $uniqueClientId: String!) {
  savedFiles(
    where: {or: [{workOrderItemWorkId: {eq: $workOrderWorkId}}, {uniqueClientId: {eq: $uniqueClientId}}]}
  ) {
    id
    workOrderId
    name
    description
  }
}
    `;

/**
 * __useMarservisWorkOrderItemWorkSavedFilesQuery__
 *
 * To run a query within a React component, call `useMarservisWorkOrderItemWorkSavedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarservisWorkOrderItemWorkSavedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarservisWorkOrderItemWorkSavedFilesQuery({
 *   variables: {
 *      workOrderWorkId: // value for 'workOrderWorkId'
 *      uniqueClientId: // value for 'uniqueClientId'
 *   },
 * });
 */
export function useMarservisWorkOrderItemWorkSavedFilesQuery(baseOptions: Apollo.QueryHookOptions<MarservisWorkOrderItemWorkSavedFilesQuery, MarservisWorkOrderItemWorkSavedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarservisWorkOrderItemWorkSavedFilesQuery, MarservisWorkOrderItemWorkSavedFilesQueryVariables>(MarservisWorkOrderItemWorkSavedFilesDocument, options);
      }
export function useMarservisWorkOrderItemWorkSavedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarservisWorkOrderItemWorkSavedFilesQuery, MarservisWorkOrderItemWorkSavedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarservisWorkOrderItemWorkSavedFilesQuery, MarservisWorkOrderItemWorkSavedFilesQueryVariables>(MarservisWorkOrderItemWorkSavedFilesDocument, options);
        }
export type MarservisWorkOrderItemWorkSavedFilesQueryHookResult = ReturnType<typeof useMarservisWorkOrderItemWorkSavedFilesQuery>;
export type MarservisWorkOrderItemWorkSavedFilesLazyQueryHookResult = ReturnType<typeof useMarservisWorkOrderItemWorkSavedFilesLazyQuery>;
export type MarservisWorkOrderItemWorkSavedFilesQueryResult = Apollo.QueryResult<MarservisWorkOrderItemWorkSavedFilesQuery, MarservisWorkOrderItemWorkSavedFilesQueryVariables>;
export function refetchMarservisWorkOrderItemWorkSavedFilesQuery(variables: MarservisWorkOrderItemWorkSavedFilesQueryVariables) {
      return { query: MarservisWorkOrderItemWorkSavedFilesDocument, variables: variables }
    }
export const MoneyAccountsDocument = gql`
    query MoneyAccounts($cursor: String, $search: String = "") {
  tDeSetAccountPaged(
    after: $cursor
    order: {acAcct: ASC}
    where: {acAcct: {startsWith: "10"}, or: {acName: {contains: $search}, acAcct: {contains: $search}}}
  ) {
    nodes {
      acAcct
      acName
      acPermitPost
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useMoneyAccountsQuery__
 *
 * To run a query within a React component, call `useMoneyAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoneyAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoneyAccountsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMoneyAccountsQuery(baseOptions?: Apollo.QueryHookOptions<MoneyAccountsQuery, MoneyAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoneyAccountsQuery, MoneyAccountsQueryVariables>(MoneyAccountsDocument, options);
      }
export function useMoneyAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoneyAccountsQuery, MoneyAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoneyAccountsQuery, MoneyAccountsQueryVariables>(MoneyAccountsDocument, options);
        }
export type MoneyAccountsQueryHookResult = ReturnType<typeof useMoneyAccountsQuery>;
export type MoneyAccountsLazyQueryHookResult = ReturnType<typeof useMoneyAccountsLazyQuery>;
export type MoneyAccountsQueryResult = Apollo.QueryResult<MoneyAccountsQuery, MoneyAccountsQueryVariables>;
export function refetchMoneyAccountsQuery(variables?: MoneyAccountsQueryVariables) {
      return { query: MoneyAccountsDocument, variables: variables }
    }
export const NullWorkOrdersPagedDocument = gql`
    query NullWorkOrdersPaged($search: String = "", $anClerk: Int!, $cursor: String) {
  tHeMovePaged(
    where: {acVerifyStatus: {eq: "1"}, anClerk: {eq: $anClerk}, acDocType: {eq: "1320"}, acKey: {contains: $search}}
    after: $cursor
  ) {
    nodes {
      acKey
      adTimeIns
      acFieldSA
      acIssuer
      acNote
      acContactPrsn
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useNullWorkOrdersPagedQuery__
 *
 * To run a query within a React component, call `useNullWorkOrdersPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useNullWorkOrdersPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNullWorkOrdersPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      anClerk: // value for 'anClerk'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useNullWorkOrdersPagedQuery(baseOptions: Apollo.QueryHookOptions<NullWorkOrdersPagedQuery, NullWorkOrdersPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NullWorkOrdersPagedQuery, NullWorkOrdersPagedQueryVariables>(NullWorkOrdersPagedDocument, options);
      }
export function useNullWorkOrdersPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NullWorkOrdersPagedQuery, NullWorkOrdersPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NullWorkOrdersPagedQuery, NullWorkOrdersPagedQueryVariables>(NullWorkOrdersPagedDocument, options);
        }
export type NullWorkOrdersPagedQueryHookResult = ReturnType<typeof useNullWorkOrdersPagedQuery>;
export type NullWorkOrdersPagedLazyQueryHookResult = ReturnType<typeof useNullWorkOrdersPagedLazyQuery>;
export type NullWorkOrdersPagedQueryResult = Apollo.QueryResult<NullWorkOrdersPagedQuery, NullWorkOrdersPagedQueryVariables>;
export function refetchNullWorkOrdersPagedQuery(variables: NullWorkOrdersPagedQueryVariables) {
      return { query: NullWorkOrdersPagedDocument, variables: variables }
    }
export const OnixPhoneUserTasksDocument = gql`
    query OnixPhoneUserTasks {
  onixPhoneUserTaskQueue(where: {isCompleted: {eq: false}}) {
    id
    task
    taskData
    isCompleted
  }
}
    `;

/**
 * __useOnixPhoneUserTasksQuery__
 *
 * To run a query within a React component, call `useOnixPhoneUserTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnixPhoneUserTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnixPhoneUserTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnixPhoneUserTasksQuery(baseOptions?: Apollo.QueryHookOptions<OnixPhoneUserTasksQuery, OnixPhoneUserTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnixPhoneUserTasksQuery, OnixPhoneUserTasksQueryVariables>(OnixPhoneUserTasksDocument, options);
      }
export function useOnixPhoneUserTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnixPhoneUserTasksQuery, OnixPhoneUserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnixPhoneUserTasksQuery, OnixPhoneUserTasksQueryVariables>(OnixPhoneUserTasksDocument, options);
        }
export type OnixPhoneUserTasksQueryHookResult = ReturnType<typeof useOnixPhoneUserTasksQuery>;
export type OnixPhoneUserTasksLazyQueryHookResult = ReturnType<typeof useOnixPhoneUserTasksLazyQuery>;
export type OnixPhoneUserTasksQueryResult = Apollo.QueryResult<OnixPhoneUserTasksQuery, OnixPhoneUserTasksQueryVariables>;
export function refetchOnixPhoneUserTasksQuery(variables?: OnixPhoneUserTasksQueryVariables) {
      return { query: OnixPhoneUserTasksDocument, variables: variables }
    }
export const PickingOrderDocument = gql`
    query PickingOrder($acKey: String!, $warehouse: String = "") {
  singleTHeOrder(where: {acKey: {eq: $acKey}}) {
    acKey
    acConsignee
    acReceiver
    acStatus
    acNote
    tHeOrderItem(order: {acIdent: ASC}) {
      anNo
      acIdent
      acName
      anQty
      anRebate
      anRebate1
      anRebate2
      anRebate3
      anPrice
      anPackQty
      acNote
      anReserved
      anQtyDispDoc
      acIdentNavigation {
        acQtyInCode
        anQtyInCodeDecPlace
        tHeSetItemExtItemSubj {
          acCode
        }
        tHeStock(where: {acWarehouse: {eq: $warehouse}}) {
          anStock
          anReserved
        }
        acSerialNo
        acFieldsA
        acFieldSb
        acFieldSc
        acFieldSd
        acFieldSe
        acFieldSf
        acFieldSg
        acFieldSh
        acFieldSi
        acFieldSj
      }
    }
    acConsigneeNavigation {
      acSubject
      acPin
      acName2
      acPost
      acAddress
      anRebate
      acPayer
      acPriceRate
      acPostNavigation {
        acName
      }
      acPayerNavigation {
        acPayer
        anRebate
        acPin
        acName2
        acPost
        acAddress
        acPriceRate
        acPostNavigation {
          acName
        }
      }
    }
  }
}
    `;

/**
 * __usePickingOrderQuery__
 *
 * To run a query within a React component, call `usePickingOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickingOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickingOrderQuery({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      warehouse: // value for 'warehouse'
 *   },
 * });
 */
export function usePickingOrderQuery(baseOptions: Apollo.QueryHookOptions<PickingOrderQuery, PickingOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickingOrderQuery, PickingOrderQueryVariables>(PickingOrderDocument, options);
      }
export function usePickingOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickingOrderQuery, PickingOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickingOrderQuery, PickingOrderQueryVariables>(PickingOrderDocument, options);
        }
export type PickingOrderQueryHookResult = ReturnType<typeof usePickingOrderQuery>;
export type PickingOrderLazyQueryHookResult = ReturnType<typeof usePickingOrderLazyQuery>;
export type PickingOrderQueryResult = Apollo.QueryResult<PickingOrderQuery, PickingOrderQueryVariables>;
export function refetchPickingOrderQuery(variables: PickingOrderQueryVariables) {
      return { query: PickingOrderDocument, variables: variables }
    }
export const ReceptionsPagedDocument = gql`
    query ReceptionsPaged($search: String = "", $cursor: String) {
  tHeSetItemPaged(
    where: {acClassif2: {eq: "SERVIS"}, or: [{acName: {contains: $search}, acIdent: {contains: $search}}]}
    after: $cursor
  ) {
    nodes {
      acIdent
      acName
      acNote
      acUm
      acSetOfItem
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useReceptionsPagedQuery__
 *
 * To run a query within a React component, call `useReceptionsPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceptionsPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceptionsPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useReceptionsPagedQuery(baseOptions?: Apollo.QueryHookOptions<ReceptionsPagedQuery, ReceptionsPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReceptionsPagedQuery, ReceptionsPagedQueryVariables>(ReceptionsPagedDocument, options);
      }
export function useReceptionsPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceptionsPagedQuery, ReceptionsPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReceptionsPagedQuery, ReceptionsPagedQueryVariables>(ReceptionsPagedDocument, options);
        }
export type ReceptionsPagedQueryHookResult = ReturnType<typeof useReceptionsPagedQuery>;
export type ReceptionsPagedLazyQueryHookResult = ReturnType<typeof useReceptionsPagedLazyQuery>;
export type ReceptionsPagedQueryResult = Apollo.QueryResult<ReceptionsPagedQuery, ReceptionsPagedQueryVariables>;
export function refetchReceptionsPagedQuery(variables?: ReceptionsPagedQueryVariables) {
      return { query: ReceptionsPagedDocument, variables: variables }
    }
export const RefreshTokenDocument = gql`
    mutation RefreshToken {
  refreshToken
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const RegisterNewVersionDocument = gql`
    mutation RegisterNewVersion($register: NewVersionDtoInput) {
  registerNewVersion(newVersionDto: $register) {
    platform
    version
  }
}
    `;
export type RegisterNewVersionMutationFn = Apollo.MutationFunction<RegisterNewVersionMutation, RegisterNewVersionMutationVariables>;

/**
 * __useRegisterNewVersionMutation__
 *
 * To run a mutation, you first call `useRegisterNewVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterNewVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerNewVersionMutation, { data, loading, error }] = useRegisterNewVersionMutation({
 *   variables: {
 *      register: // value for 'register'
 *   },
 * });
 */
export function useRegisterNewVersionMutation(baseOptions?: Apollo.MutationHookOptions<RegisterNewVersionMutation, RegisterNewVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterNewVersionMutation, RegisterNewVersionMutationVariables>(RegisterNewVersionDocument, options);
      }
export type RegisterNewVersionMutationHookResult = ReturnType<typeof useRegisterNewVersionMutation>;
export type RegisterNewVersionMutationResult = Apollo.MutationResult<RegisterNewVersionMutation>;
export type RegisterNewVersionMutationOptions = Apollo.BaseMutationOptions<RegisterNewVersionMutation, RegisterNewVersionMutationVariables>;
export const RemoveSavedFileDocument = gql`
    mutation RemoveSavedFile($fileId: Int!) {
  deleteSavedFile(fileId: $fileId)
}
    `;
export type RemoveSavedFileMutationFn = Apollo.MutationFunction<RemoveSavedFileMutation, RemoveSavedFileMutationVariables>;

/**
 * __useRemoveSavedFileMutation__
 *
 * To run a mutation, you first call `useRemoveSavedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSavedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSavedFileMutation, { data, loading, error }] = useRemoveSavedFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useRemoveSavedFileMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSavedFileMutation, RemoveSavedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSavedFileMutation, RemoveSavedFileMutationVariables>(RemoveSavedFileDocument, options);
      }
export type RemoveSavedFileMutationHookResult = ReturnType<typeof useRemoveSavedFileMutation>;
export type RemoveSavedFileMutationResult = Apollo.MutationResult<RemoveSavedFileMutation>;
export type RemoveSavedFileMutationOptions = Apollo.BaseMutationOptions<RemoveSavedFileMutation, RemoveSavedFileMutationVariables>;
export const RemoveTHeMoveItemDocument = gql`
    mutation RemoveTHeMoveItem($acKey: String!, $anNo: Int!, $docType: Int!) {
  removeTHeMoveItem(acKey: $acKey, anNo: $anNo, docType: $docType)
}
    `;
export type RemoveTHeMoveItemMutationFn = Apollo.MutationFunction<RemoveTHeMoveItemMutation, RemoveTHeMoveItemMutationVariables>;

/**
 * __useRemoveTHeMoveItemMutation__
 *
 * To run a mutation, you first call `useRemoveTHeMoveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTHeMoveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTHeMoveItemMutation, { data, loading, error }] = useRemoveTHeMoveItemMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      anNo: // value for 'anNo'
 *      docType: // value for 'docType'
 *   },
 * });
 */
export function useRemoveTHeMoveItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTHeMoveItemMutation, RemoveTHeMoveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTHeMoveItemMutation, RemoveTHeMoveItemMutationVariables>(RemoveTHeMoveItemDocument, options);
      }
export type RemoveTHeMoveItemMutationHookResult = ReturnType<typeof useRemoveTHeMoveItemMutation>;
export type RemoveTHeMoveItemMutationResult = Apollo.MutationResult<RemoveTHeMoveItemMutation>;
export type RemoveTHeMoveItemMutationOptions = Apollo.BaseMutationOptions<RemoveTHeMoveItemMutation, RemoveTHeMoveItemMutationVariables>;
export const RemoveTHeOrderItemDocument = gql`
    mutation RemoveTHeOrderItem($acKey: String!, $anNo: Int!, $docType: Int!) {
  removeTHeOrderItem(acKey: $acKey, anNo: $anNo, docType: $docType)
}
    `;
export type RemoveTHeOrderItemMutationFn = Apollo.MutationFunction<RemoveTHeOrderItemMutation, RemoveTHeOrderItemMutationVariables>;

/**
 * __useRemoveTHeOrderItemMutation__
 *
 * To run a mutation, you first call `useRemoveTHeOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTHeOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTHeOrderItemMutation, { data, loading, error }] = useRemoveTHeOrderItemMutation({
 *   variables: {
 *      acKey: // value for 'acKey'
 *      anNo: // value for 'anNo'
 *      docType: // value for 'docType'
 *   },
 * });
 */
export function useRemoveTHeOrderItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTHeOrderItemMutation, RemoveTHeOrderItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTHeOrderItemMutation, RemoveTHeOrderItemMutationVariables>(RemoveTHeOrderItemDocument, options);
      }
export type RemoveTHeOrderItemMutationHookResult = ReturnType<typeof useRemoveTHeOrderItemMutation>;
export type RemoveTHeOrderItemMutationResult = Apollo.MutationResult<RemoveTHeOrderItemMutation>;
export type RemoveTHeOrderItemMutationOptions = Apollo.BaseMutationOptions<RemoveTHeOrderItemMutation, RemoveTHeOrderItemMutationVariables>;
export const SaveMobileSettingsDocument = gql`
    mutation SaveMobileSettings($settings: MobileSettingsUpdateDtoInput!) {
  updateMobileSettings(mobileSettings: $settings) {
    bluetoothPrinterAddress
    bluetoothPrinterName
    bluetoothPrinterPaperWidth
    bluetoothPrinterType
    createdOn
    modifiedBy
    modifiedOn
    useDarkTheme
    useListViewOnPickers
    useTabletMode
    useOnlyShortcuts
  }
}
    `;
export type SaveMobileSettingsMutationFn = Apollo.MutationFunction<SaveMobileSettingsMutation, SaveMobileSettingsMutationVariables>;

/**
 * __useSaveMobileSettingsMutation__
 *
 * To run a mutation, you first call `useSaveMobileSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMobileSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMobileSettingsMutation, { data, loading, error }] = useSaveMobileSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveMobileSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveMobileSettingsMutation, SaveMobileSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMobileSettingsMutation, SaveMobileSettingsMutationVariables>(SaveMobileSettingsDocument, options);
      }
export type SaveMobileSettingsMutationHookResult = ReturnType<typeof useSaveMobileSettingsMutation>;
export type SaveMobileSettingsMutationResult = Apollo.MutationResult<SaveMobileSettingsMutation>;
export type SaveMobileSettingsMutationOptions = Apollo.BaseMutationOptions<SaveMobileSettingsMutation, SaveMobileSettingsMutationVariables>;
export const SavedFilesDocument = gql`
    query SavedFiles($workOrderItemWorkId: Int, $uniqueClientId: String) {
  savedFiles(
    where: {or: [{workOrderItemWorkId: {eq: $workOrderItemWorkId}}, {uniqueClientId: {eq: $uniqueClientId}}]}
    order: {createdOn: DESC}
  ) {
    id
    name
    description
  }
}
    `;

/**
 * __useSavedFilesQuery__
 *
 * To run a query within a React component, call `useSavedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedFilesQuery({
 *   variables: {
 *      workOrderItemWorkId: // value for 'workOrderItemWorkId'
 *      uniqueClientId: // value for 'uniqueClientId'
 *   },
 * });
 */
export function useSavedFilesQuery(baseOptions?: Apollo.QueryHookOptions<SavedFilesQuery, SavedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedFilesQuery, SavedFilesQueryVariables>(SavedFilesDocument, options);
      }
export function useSavedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedFilesQuery, SavedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedFilesQuery, SavedFilesQueryVariables>(SavedFilesDocument, options);
        }
export type SavedFilesQueryHookResult = ReturnType<typeof useSavedFilesQuery>;
export type SavedFilesLazyQueryHookResult = ReturnType<typeof useSavedFilesLazyQuery>;
export type SavedFilesQueryResult = Apollo.QueryResult<SavedFilesQuery, SavedFilesQueryVariables>;
export function refetchSavedFilesQuery(variables?: SavedFilesQueryVariables) {
      return { query: SavedFilesDocument, variables: variables }
    }
export const SetPasswordDocument = gql`
    mutation SetPassword($password: String!) {
  setPassword(password: $password)
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const SingleTHeFaDocument = gql`
    query SingleTHeFa($inventNum: String!, $acType: String!) {
  singleTHeFa(where: {acType: {eq: $acType}, acInventNum: {eq: $inventNum}}) {
    acActive
    acInventNum
    acName
    acNote
    acType
    adDateOfAcq
    anQty
  }
}
    `;

/**
 * __useSingleTHeFaQuery__
 *
 * To run a query within a React component, call `useSingleTHeFaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTHeFaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTHeFaQuery({
 *   variables: {
 *      inventNum: // value for 'inventNum'
 *      acType: // value for 'acType'
 *   },
 * });
 */
export function useSingleTHeFaQuery(baseOptions: Apollo.QueryHookOptions<SingleTHeFaQuery, SingleTHeFaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTHeFaQuery, SingleTHeFaQueryVariables>(SingleTHeFaDocument, options);
      }
export function useSingleTHeFaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTHeFaQuery, SingleTHeFaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTHeFaQuery, SingleTHeFaQueryVariables>(SingleTHeFaDocument, options);
        }
export type SingleTHeFaQueryHookResult = ReturnType<typeof useSingleTHeFaQuery>;
export type SingleTHeFaLazyQueryHookResult = ReturnType<typeof useSingleTHeFaLazyQuery>;
export type SingleTHeFaQueryResult = Apollo.QueryResult<SingleTHeFaQuery, SingleTHeFaQueryVariables>;
export function refetchSingleTHeFaQuery(variables: SingleTHeFaQueryVariables) {
      return { query: SingleTHeFaDocument, variables: variables }
    }
export const SingleTHeMoveDocument = gql`
    query SingleTHeMove($acKey: String!) {
  singleTHeMove(where: {acKey: {eq: $acKey}}) {
    acKey
    acNote
    acDoc2
    adTimeIns
    acPrsn3
    acCurrency
    acReceiver
    acDocType
    anForPay
    acVerifiedPrices
    acPayMethod
    acPayMethodNavigation {
      acName
    }
  }
}
    `;

/**
 * __useSingleTHeMoveQuery__
 *
 * To run a query within a React component, call `useSingleTHeMoveQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTHeMoveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTHeMoveQuery({
 *   variables: {
 *      acKey: // value for 'acKey'
 *   },
 * });
 */
export function useSingleTHeMoveQuery(baseOptions: Apollo.QueryHookOptions<SingleTHeMoveQuery, SingleTHeMoveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTHeMoveQuery, SingleTHeMoveQueryVariables>(SingleTHeMoveDocument, options);
      }
export function useSingleTHeMoveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTHeMoveQuery, SingleTHeMoveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTHeMoveQuery, SingleTHeMoveQueryVariables>(SingleTHeMoveDocument, options);
        }
export type SingleTHeMoveQueryHookResult = ReturnType<typeof useSingleTHeMoveQuery>;
export type SingleTHeMoveLazyQueryHookResult = ReturnType<typeof useSingleTHeMoveLazyQuery>;
export type SingleTHeMoveQueryResult = Apollo.QueryResult<SingleTHeMoveQuery, SingleTHeMoveQueryVariables>;
export function refetchSingleTHeMoveQuery(variables: SingleTHeMoveQueryVariables) {
      return { query: SingleTHeMoveDocument, variables: variables }
    }
export const SingleTHeOrderDocument = gql`
    query SingleTHeOrder($acKey: String!) {
  singleTHeOrder(where: {acKey: {eq: $acKey}}) {
    acKey
    acNote
    adDate
    acConsignee
    acReceiver
    adTimeIns
    acCurrency
    anForPay
    acDoc2
    acDocType
    acPayMethod
    acPayMethodNavigation {
      acName
    }
  }
}
    `;

/**
 * __useSingleTHeOrderQuery__
 *
 * To run a query within a React component, call `useSingleTHeOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTHeOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTHeOrderQuery({
 *   variables: {
 *      acKey: // value for 'acKey'
 *   },
 * });
 */
export function useSingleTHeOrderQuery(baseOptions: Apollo.QueryHookOptions<SingleTHeOrderQuery, SingleTHeOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTHeOrderQuery, SingleTHeOrderQueryVariables>(SingleTHeOrderDocument, options);
      }
export function useSingleTHeOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTHeOrderQuery, SingleTHeOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTHeOrderQuery, SingleTHeOrderQueryVariables>(SingleTHeOrderDocument, options);
        }
export type SingleTHeOrderQueryHookResult = ReturnType<typeof useSingleTHeOrderQuery>;
export type SingleTHeOrderLazyQueryHookResult = ReturnType<typeof useSingleTHeOrderLazyQuery>;
export type SingleTHeOrderQueryResult = Apollo.QueryResult<SingleTHeOrderQuery, SingleTHeOrderQueryVariables>;
export function refetchSingleTHeOrderQuery(variables: SingleTHeOrderQueryVariables) {
      return { query: SingleTHeOrderDocument, variables: variables }
    }
export const SingleTHeSetSubjDocument = gql`
    query SingleTHeSetSubj($acSubject: String!) {
  singleTHeSetSubj(where: {acSubject: {eq: $acSubject}}) {
    acSubject
    acName2
    anRebate
    acPin
  }
}
    `;

/**
 * __useSingleTHeSetSubjQuery__
 *
 * To run a query within a React component, call `useSingleTHeSetSubjQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTHeSetSubjQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTHeSetSubjQuery({
 *   variables: {
 *      acSubject: // value for 'acSubject'
 *   },
 * });
 */
export function useSingleTHeSetSubjQuery(baseOptions: Apollo.QueryHookOptions<SingleTHeSetSubjQuery, SingleTHeSetSubjQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTHeSetSubjQuery, SingleTHeSetSubjQueryVariables>(SingleTHeSetSubjDocument, options);
      }
export function useSingleTHeSetSubjLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTHeSetSubjQuery, SingleTHeSetSubjQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTHeSetSubjQuery, SingleTHeSetSubjQueryVariables>(SingleTHeSetSubjDocument, options);
        }
export type SingleTHeSetSubjQueryHookResult = ReturnType<typeof useSingleTHeSetSubjQuery>;
export type SingleTHeSetSubjLazyQueryHookResult = ReturnType<typeof useSingleTHeSetSubjLazyQuery>;
export type SingleTHeSetSubjQueryResult = Apollo.QueryResult<SingleTHeSetSubjQuery, SingleTHeSetSubjQueryVariables>;
export function refetchSingleTHeSetSubjQuery(variables: SingleTHeSetSubjQueryVariables) {
      return { query: SingleTHeSetSubjDocument, variables: variables }
    }
export const StartWorkOrderDocument = gql`
    mutation StartWorkOrder($data: SubmittingWorkOrderViewModelInput!, $docType: Int!) {
  startWorkOrder(data: $data, docType: $docType) {
    acKey
  }
}
    `;
export type StartWorkOrderMutationFn = Apollo.MutationFunction<StartWorkOrderMutation, StartWorkOrderMutationVariables>;

/**
 * __useStartWorkOrderMutation__
 *
 * To run a mutation, you first call `useStartWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startWorkOrderMutation, { data, loading, error }] = useStartWorkOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *      docType: // value for 'docType'
 *   },
 * });
 */
export function useStartWorkOrderMutation(baseOptions?: Apollo.MutationHookOptions<StartWorkOrderMutation, StartWorkOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartWorkOrderMutation, StartWorkOrderMutationVariables>(StartWorkOrderDocument, options);
      }
export type StartWorkOrderMutationHookResult = ReturnType<typeof useStartWorkOrderMutation>;
export type StartWorkOrderMutationResult = Apollo.MutationResult<StartWorkOrderMutation>;
export type StartWorkOrderMutationOptions = Apollo.BaseMutationOptions<StartWorkOrderMutation, StartWorkOrderMutationVariables>;
export const TDeSetAccountPagedDocument = gql`
    query TDeSetAccountPaged($search: String = "", $codeLike: String!, $cursor: String) {
  tDeSetAccountPaged(
    where: {and: {acAcct: {startsWith: $codeLike}, or: [{acName: {contains: $search}}, {acAcct: {contains: $search}}]}}
    after: $cursor
  ) {
    nodes {
      acAcct
      acName
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useTDeSetAccountPagedQuery__
 *
 * To run a query within a React component, call `useTDeSetAccountPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTDeSetAccountPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTDeSetAccountPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      codeLike: // value for 'codeLike'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useTDeSetAccountPagedQuery(baseOptions: Apollo.QueryHookOptions<TDeSetAccountPagedQuery, TDeSetAccountPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TDeSetAccountPagedQuery, TDeSetAccountPagedQueryVariables>(TDeSetAccountPagedDocument, options);
      }
export function useTDeSetAccountPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TDeSetAccountPagedQuery, TDeSetAccountPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TDeSetAccountPagedQuery, TDeSetAccountPagedQueryVariables>(TDeSetAccountPagedDocument, options);
        }
export type TDeSetAccountPagedQueryHookResult = ReturnType<typeof useTDeSetAccountPagedQuery>;
export type TDeSetAccountPagedLazyQueryHookResult = ReturnType<typeof useTDeSetAccountPagedLazyQuery>;
export type TDeSetAccountPagedQueryResult = Apollo.QueryResult<TDeSetAccountPagedQuery, TDeSetAccountPagedQueryVariables>;
export function refetchTDeSetAccountPagedQuery(variables: TDeSetAccountPagedQueryVariables) {
      return { query: TDeSetAccountPagedDocument, variables: variables }
    }
export const THeCashRegPagedDocument = gql`
    query THeCashRegPaged($search: String = "", $cursor: String) {
  tHeCashRegPaged(where: {acKey: {contains: $search}}, after: $cursor) {
    nodes {
      acKey
      anRefund
      adDateDoc1
      adDateDoc2
      tHeCashRegItems {
        acPayMethod
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useTHeCashRegPagedQuery__
 *
 * To run a query within a React component, call `useTHeCashRegPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeCashRegPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeCashRegPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useTHeCashRegPagedQuery(baseOptions?: Apollo.QueryHookOptions<THeCashRegPagedQuery, THeCashRegPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeCashRegPagedQuery, THeCashRegPagedQueryVariables>(THeCashRegPagedDocument, options);
      }
export function useTHeCashRegPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeCashRegPagedQuery, THeCashRegPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeCashRegPagedQuery, THeCashRegPagedQueryVariables>(THeCashRegPagedDocument, options);
        }
export type THeCashRegPagedQueryHookResult = ReturnType<typeof useTHeCashRegPagedQuery>;
export type THeCashRegPagedLazyQueryHookResult = ReturnType<typeof useTHeCashRegPagedLazyQuery>;
export type THeCashRegPagedQueryResult = Apollo.QueryResult<THeCashRegPagedQuery, THeCashRegPagedQueryVariables>;
export function refetchTHeCashRegPagedQuery(variables?: THeCashRegPagedQueryVariables) {
      return { query: THeCashRegPagedDocument, variables: variables }
    }
export const THeCashRegItemDocument = gql`
    query THeCashRegItem($acKey: String!) {
  tHeCashRegItems(where: {acKey: {eq: $acKey}}) {
    acPayMethodNavigation {
      acName
    }
    anAmount
  }
}
    `;

/**
 * __useTHeCashRegItemQuery__
 *
 * To run a query within a React component, call `useTHeCashRegItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeCashRegItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeCashRegItemQuery({
 *   variables: {
 *      acKey: // value for 'acKey'
 *   },
 * });
 */
export function useTHeCashRegItemQuery(baseOptions: Apollo.QueryHookOptions<THeCashRegItemQuery, THeCashRegItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeCashRegItemQuery, THeCashRegItemQueryVariables>(THeCashRegItemDocument, options);
      }
export function useTHeCashRegItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeCashRegItemQuery, THeCashRegItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeCashRegItemQuery, THeCashRegItemQueryVariables>(THeCashRegItemDocument, options);
        }
export type THeCashRegItemQueryHookResult = ReturnType<typeof useTHeCashRegItemQuery>;
export type THeCashRegItemLazyQueryHookResult = ReturnType<typeof useTHeCashRegItemLazyQuery>;
export type THeCashRegItemQueryResult = Apollo.QueryResult<THeCashRegItemQuery, THeCashRegItemQueryVariables>;
export function refetchTHeCashRegItemQuery(variables: THeCashRegItemQueryVariables) {
      return { query: THeCashRegItemDocument, variables: variables }
    }
export const THeCostDrvPagedDocument = gql`
    query THeCostDrvPaged($search: String = "", $cursor: String) {
  tHeCostDrvPaged(
    where: {acStatus: {eq: "I"}, acCostDrv: {contains: $search}}
    after: $cursor
  ) {
    nodes {
      acCostDrv
      acName
      acConsignee
      acStatus
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useTHeCostDrvPagedQuery__
 *
 * To run a query within a React component, call `useTHeCostDrvPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeCostDrvPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeCostDrvPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useTHeCostDrvPagedQuery(baseOptions?: Apollo.QueryHookOptions<THeCostDrvPagedQuery, THeCostDrvPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeCostDrvPagedQuery, THeCostDrvPagedQueryVariables>(THeCostDrvPagedDocument, options);
      }
export function useTHeCostDrvPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeCostDrvPagedQuery, THeCostDrvPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeCostDrvPagedQuery, THeCostDrvPagedQueryVariables>(THeCostDrvPagedDocument, options);
        }
export type THeCostDrvPagedQueryHookResult = ReturnType<typeof useTHeCostDrvPagedQuery>;
export type THeCostDrvPagedLazyQueryHookResult = ReturnType<typeof useTHeCostDrvPagedLazyQuery>;
export type THeCostDrvPagedQueryResult = Apollo.QueryResult<THeCostDrvPagedQuery, THeCostDrvPagedQueryVariables>;
export function refetchTHeCostDrvPagedQuery(variables?: THeCostDrvPagedQueryVariables) {
      return { query: THeCostDrvPagedDocument, variables: variables }
    }
export const THeFaPagedDocument = gql`
    query THeFaPaged($search: String, $cursor: String) {
  tHeFaPaged(
    where: {acType: {eq: "0"}, or: {acInventNum: {contains: $search}, acName: {contains: $search}, acNote: {contains: $search}}}
    after: $cursor
  ) {
    nodes {
      acActive
      acInventNum
      acName
      acNote
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useTHeFaPagedQuery__
 *
 * To run a query within a React component, call `useTHeFaPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeFaPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeFaPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useTHeFaPagedQuery(baseOptions?: Apollo.QueryHookOptions<THeFaPagedQuery, THeFaPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeFaPagedQuery, THeFaPagedQueryVariables>(THeFaPagedDocument, options);
      }
export function useTHeFaPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeFaPagedQuery, THeFaPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeFaPagedQuery, THeFaPagedQueryVariables>(THeFaPagedDocument, options);
        }
export type THeFaPagedQueryHookResult = ReturnType<typeof useTHeFaPagedQuery>;
export type THeFaPagedLazyQueryHookResult = ReturnType<typeof useTHeFaPagedLazyQuery>;
export type THeFaPagedQueryResult = Apollo.QueryResult<THeFaPagedQuery, THeFaPagedQueryVariables>;
export function refetchTHeFaPagedQuery(variables?: THeFaPagedQueryVariables) {
      return { query: THeFaPagedDocument, variables: variables }
    }
export const THeMoveDailyIncomeDocument = gql`
    query THeMoveDailyIncome($acDocType: String!) {
  tHeMoveDailyIncomeSummary(acDocType: $acDocType) {
    fromDate
    toDate
    fromDoc
    toDoc
    items {
      anForPay
      payMethodName
    }
  }
}
    `;

/**
 * __useTHeMoveDailyIncomeQuery__
 *
 * To run a query within a React component, call `useTHeMoveDailyIncomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeMoveDailyIncomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeMoveDailyIncomeQuery({
 *   variables: {
 *      acDocType: // value for 'acDocType'
 *   },
 * });
 */
export function useTHeMoveDailyIncomeQuery(baseOptions: Apollo.QueryHookOptions<THeMoveDailyIncomeQuery, THeMoveDailyIncomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeMoveDailyIncomeQuery, THeMoveDailyIncomeQueryVariables>(THeMoveDailyIncomeDocument, options);
      }
export function useTHeMoveDailyIncomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeMoveDailyIncomeQuery, THeMoveDailyIncomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeMoveDailyIncomeQuery, THeMoveDailyIncomeQueryVariables>(THeMoveDailyIncomeDocument, options);
        }
export type THeMoveDailyIncomeQueryHookResult = ReturnType<typeof useTHeMoveDailyIncomeQuery>;
export type THeMoveDailyIncomeLazyQueryHookResult = ReturnType<typeof useTHeMoveDailyIncomeLazyQuery>;
export type THeMoveDailyIncomeQueryResult = Apollo.QueryResult<THeMoveDailyIncomeQuery, THeMoveDailyIncomeQueryVariables>;
export function refetchTHeMoveDailyIncomeQuery(variables: THeMoveDailyIncomeQueryVariables) {
      return { query: THeMoveDailyIncomeDocument, variables: variables }
    }
export const THeMoveItemsDocument = gql`
    query THeMoveItems($ackey: String!, $warehouse: String!) {
  tHeMoveItem(where: {acKey: {eq: $ackey}}) {
    acName
    acIdent
    anRebate
    anPrice
    anQty
    anPackQty
    acUm
    acNote
    anNo
    acUM2
    acKey
    anRebate1
    anRebate2
    anRebate3
    acIdentNavigation {
      acIdent
      acName
      acUm
      acCode
      acNote
      acSetOfItem
      anRtPrice
      anWsprice
      acUm2
      anUmtoUm2
      acActive
      anWsprice2
      anExcise
      anQtyInCodeDecPlace
      acQtyInCode
      tHeStock(where: {acWarehouse: {eq: $warehouse}}) {
        anStock
        anReserved
      }
    }
  }
}
    `;

/**
 * __useTHeMoveItemsQuery__
 *
 * To run a query within a React component, call `useTHeMoveItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeMoveItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeMoveItemsQuery({
 *   variables: {
 *      ackey: // value for 'ackey'
 *      warehouse: // value for 'warehouse'
 *   },
 * });
 */
export function useTHeMoveItemsQuery(baseOptions: Apollo.QueryHookOptions<THeMoveItemsQuery, THeMoveItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeMoveItemsQuery, THeMoveItemsQueryVariables>(THeMoveItemsDocument, options);
      }
export function useTHeMoveItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeMoveItemsQuery, THeMoveItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeMoveItemsQuery, THeMoveItemsQueryVariables>(THeMoveItemsDocument, options);
        }
export type THeMoveItemsQueryHookResult = ReturnType<typeof useTHeMoveItemsQuery>;
export type THeMoveItemsLazyQueryHookResult = ReturnType<typeof useTHeMoveItemsLazyQuery>;
export type THeMoveItemsQueryResult = Apollo.QueryResult<THeMoveItemsQuery, THeMoveItemsQueryVariables>;
export function refetchTHeMoveItemsQuery(variables: THeMoveItemsQueryVariables) {
      return { query: THeMoveItemsDocument, variables: variables }
    }
export const THeMovePagedDocument = gql`
    query THeMovePaged($search: String = "", $docTypes: [String], $fromDate: DateTime, $toDate: DateTime, $cursor: String, $acDelivery: String, $acDept: String, $acVerifiedPrices: String, $acVerifyStatus: String) {
  tHeMovePagedParametrized(
    where: {and: [{acDocType: {in: $docTypes}}], or: [{acKey: {contains: $search}}, {acNote: {contains: $search}}, {acPrsn3: {contains: $search}}, {acReceiver: {contains: $search}}, {acDoc2: {contains: $search}}]}
    order: {acKey: DESC}
    after: $cursor
    acDelivery: $acDelivery
    acDept: $acDept
    acVerifiedPrices: $acVerifiedPrices
    acVerifyStatus: $acVerifyStatus
    from: $fromDate
    to: $toDate
  ) {
    nodes {
      acKey
      acNote
      acDoc2
      adTimeIns
      acPrsn3
      acCurrency
      acReceiver
      acDocType
      anForPay
      acVerifiedPrices
      acPayMethod
      acPayMethodNavigation {
        acName
      }
      adDate
      adDateTimePrint
      adDateDue
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useTHeMovePagedQuery__
 *
 * To run a query within a React component, call `useTHeMovePagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeMovePagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeMovePagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      docTypes: // value for 'docTypes'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      cursor: // value for 'cursor'
 *      acDelivery: // value for 'acDelivery'
 *      acDept: // value for 'acDept'
 *      acVerifiedPrices: // value for 'acVerifiedPrices'
 *      acVerifyStatus: // value for 'acVerifyStatus'
 *   },
 * });
 */
export function useTHeMovePagedQuery(baseOptions?: Apollo.QueryHookOptions<THeMovePagedQuery, THeMovePagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeMovePagedQuery, THeMovePagedQueryVariables>(THeMovePagedDocument, options);
      }
export function useTHeMovePagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeMovePagedQuery, THeMovePagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeMovePagedQuery, THeMovePagedQueryVariables>(THeMovePagedDocument, options);
        }
export type THeMovePagedQueryHookResult = ReturnType<typeof useTHeMovePagedQuery>;
export type THeMovePagedLazyQueryHookResult = ReturnType<typeof useTHeMovePagedLazyQuery>;
export type THeMovePagedQueryResult = Apollo.QueryResult<THeMovePagedQuery, THeMovePagedQueryVariables>;
export function refetchTHeMovePagedQuery(variables?: THeMovePagedQueryVariables) {
      return { query: THeMovePagedDocument, variables: variables }
    }
export const THeMovePdfDocument = gql`
    query THeMovePDF($ackey: String!) {
  singleTHeMove(where: {acKey: {eq: $ackey}}) {
    acKey
    adDate
    adDateDue
    acReceiver
    acNote
    adDateTimePrint
    acReceiverNavigation: acReceiverNavigation {
      acPin
      acName2
      acAddress
      acPostNavigation {
        acPost
        acName
      }
    }
    acPrsn3
    acPrsn3Navigation {
      acAddress
      acPost
      acName2
      acPostNavigation {
        acPost
        acName
      }
      acPin
    }
    tHeMoveItem {
      acUm
      anQty
      acName
      acIdent
      acIdentNavigation {
        acCode
        acClassif
      }
      anPrice
      anRebate
      acNote
      tHeMoveItemSerialNo {
        acSerialNo
        anQty
      }
      anPvforPay
      anPvvat
      acVatcode
      anPvocvat
      acVatcodeNavigation {
        acVatcode
        anVat
      }
      anPvexcise
    }
    acCurrency
    anValue
    anDiscount
    anVat
    anForPay
    anNoteClerkNavigation {
      acName
      acSurname
    }
    acDeliveryNavigation {
      acName
    }
    acPayMethodNavigation {
      acName
      acFiscalGroup
    }
    anClerkNavigation {
      acName
      acSurname
    }
    acDoc1
    acDoc2
    acDept
    acDocType
  }
  singleVHeMoveFiscalisation(where: {acKey: {eq: $ackey}}) {
    acHrfiskalNumber
  }
  tHeMoveSignature(acKey: $ackey)
}
    `;

/**
 * __useTHeMovePdfQuery__
 *
 * To run a query within a React component, call `useTHeMovePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeMovePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeMovePdfQuery({
 *   variables: {
 *      ackey: // value for 'ackey'
 *   },
 * });
 */
export function useTHeMovePdfQuery(baseOptions: Apollo.QueryHookOptions<THeMovePdfQuery, THeMovePdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeMovePdfQuery, THeMovePdfQueryVariables>(THeMovePdfDocument, options);
      }
export function useTHeMovePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeMovePdfQuery, THeMovePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeMovePdfQuery, THeMovePdfQueryVariables>(THeMovePdfDocument, options);
        }
export type THeMovePdfQueryHookResult = ReturnType<typeof useTHeMovePdfQuery>;
export type THeMovePdfLazyQueryHookResult = ReturnType<typeof useTHeMovePdfLazyQuery>;
export type THeMovePdfQueryResult = Apollo.QueryResult<THeMovePdfQuery, THeMovePdfQueryVariables>;
export function refetchTHeMovePdfQuery(variables: THeMovePdfQueryVariables) {
      return { query: THeMovePdfDocument, variables: variables }
    }
export const THeMoveWorkOrdersPagedDocument = gql`
    query THeMoveWorkOrdersPaged($search: String = "", $docTypes: [String], $anUserId: Int!, $fromDate: DateTime!, $toDate: DateTime!, $cursor: String) {
  tHeMovePaged(
    where: {acDocType: {in: $docTypes}, anClerk: {eq: $anUserId}, adTimeIns: {gte: $fromDate, lte: $toDate}, or: [{acKey: {contains: $search}}, {acFieldSA: {contains: $search}}, {acIssuer: {contains: $search}}, {acNote: {contains: $search}}]}
    order: {acKey: DESC}
    after: $cursor
  ) {
    nodes {
      acKey
      adTimeIns
      adFieldDA
      acFieldSA
      acIssuer
      acNote
      anClerk
      acDocType
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useTHeMoveWorkOrdersPagedQuery__
 *
 * To run a query within a React component, call `useTHeMoveWorkOrdersPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeMoveWorkOrdersPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeMoveWorkOrdersPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      docTypes: // value for 'docTypes'
 *      anUserId: // value for 'anUserId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useTHeMoveWorkOrdersPagedQuery(baseOptions: Apollo.QueryHookOptions<THeMoveWorkOrdersPagedQuery, THeMoveWorkOrdersPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeMoveWorkOrdersPagedQuery, THeMoveWorkOrdersPagedQueryVariables>(THeMoveWorkOrdersPagedDocument, options);
      }
export function useTHeMoveWorkOrdersPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeMoveWorkOrdersPagedQuery, THeMoveWorkOrdersPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeMoveWorkOrdersPagedQuery, THeMoveWorkOrdersPagedQueryVariables>(THeMoveWorkOrdersPagedDocument, options);
        }
export type THeMoveWorkOrdersPagedQueryHookResult = ReturnType<typeof useTHeMoveWorkOrdersPagedQuery>;
export type THeMoveWorkOrdersPagedLazyQueryHookResult = ReturnType<typeof useTHeMoveWorkOrdersPagedLazyQuery>;
export type THeMoveWorkOrdersPagedQueryResult = Apollo.QueryResult<THeMoveWorkOrdersPagedQuery, THeMoveWorkOrdersPagedQueryVariables>;
export function refetchTHeMoveWorkOrdersPagedQuery(variables: THeMoveWorkOrdersPagedQueryVariables) {
      return { query: THeMoveWorkOrdersPagedDocument, variables: variables }
    }
export const THeOrderItemsDocument = gql`
    query THeOrderItems($ackey: String!, $warehouse: String!) {
  tHeOrderItem(where: {acKey: {eq: $ackey}}) {
    acName
    acIdent
    anRebate
    anPrice
    acUm
    acNote
    anQty
    anNo
    acKey
    anRebate1
    anRebate2
    anRebate3
    anPackQty
    acUM2
    anSalePrice
    anRetailPrice
    anRtprice
    acIdentNavigation {
      acIdent
      acName
      acUm
      acCode
      acNote
      acSetOfItem
      anRtPrice
      anWsprice
      acUm2
      anUmtoUm2
      acActive
      anWsprice2
      anExcise
      anQtyInCodeDecPlace
      acQtyInCode
      tHeStock(where: {acWarehouse: {eq: $warehouse}}) {
        anStock
        anReserved
      }
    }
  }
}
    `;

/**
 * __useTHeOrderItemsQuery__
 *
 * To run a query within a React component, call `useTHeOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeOrderItemsQuery({
 *   variables: {
 *      ackey: // value for 'ackey'
 *      warehouse: // value for 'warehouse'
 *   },
 * });
 */
export function useTHeOrderItemsQuery(baseOptions: Apollo.QueryHookOptions<THeOrderItemsQuery, THeOrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeOrderItemsQuery, THeOrderItemsQueryVariables>(THeOrderItemsDocument, options);
      }
export function useTHeOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeOrderItemsQuery, THeOrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeOrderItemsQuery, THeOrderItemsQueryVariables>(THeOrderItemsDocument, options);
        }
export type THeOrderItemsQueryHookResult = ReturnType<typeof useTHeOrderItemsQuery>;
export type THeOrderItemsLazyQueryHookResult = ReturnType<typeof useTHeOrderItemsLazyQuery>;
export type THeOrderItemsQueryResult = Apollo.QueryResult<THeOrderItemsQuery, THeOrderItemsQueryVariables>;
export function refetchTHeOrderItemsQuery(variables: THeOrderItemsQueryVariables) {
      return { query: THeOrderItemsDocument, variables: variables }
    }
export const THeOrderPagedDocument = gql`
    query THeOrderPaged($search: String = "", $docTypes: [String], $fromDate: DateTime, $toDate: DateTime, $cursor: String, $acDelivery: String, $acDept: String, $acStatus: String, $useDeliveryDeadline: Boolean!, $acStatusNotIn: [String!], $acStatusIn: [String!]) {
  tHeOrderPagedParametrized(
    where: {acDocType: {in: $docTypes}, or: [{acKey: {contains: $search}}, {acNote: {contains: $search}}, {acConsignee: {contains: $search}}, {acReceiver: {contains: $search}}, {acDoc2: {contains: $search}}]}
    order: {acKey: DESC}
    after: $cursor
    acDept: $acDept
    acDelivery: $acDelivery
    acStatus: $acStatus
    from: $fromDate
    to: $toDate
    useDeliveryDeadline: $useDeliveryDeadline
    acStatusNotIn: $acStatusNotIn
    acStatusIn: $acStatusIn
  ) {
    nodes {
      acKey
      acNote
      adDate
      acConsignee
      acReceiver
      adTimeIns
      acCurrency
      anForPay
      acDoc2
      acDocType
      adDeliveryDeadline
      acPayMethod
      acPayMethodNavigation {
        acName
      }
      acStatus
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useTHeOrderPagedQuery__
 *
 * To run a query within a React component, call `useTHeOrderPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeOrderPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeOrderPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      docTypes: // value for 'docTypes'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      cursor: // value for 'cursor'
 *      acDelivery: // value for 'acDelivery'
 *      acDept: // value for 'acDept'
 *      acStatus: // value for 'acStatus'
 *      useDeliveryDeadline: // value for 'useDeliveryDeadline'
 *      acStatusNotIn: // value for 'acStatusNotIn'
 *      acStatusIn: // value for 'acStatusIn'
 *   },
 * });
 */
export function useTHeOrderPagedQuery(baseOptions: Apollo.QueryHookOptions<THeOrderPagedQuery, THeOrderPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeOrderPagedQuery, THeOrderPagedQueryVariables>(THeOrderPagedDocument, options);
      }
export function useTHeOrderPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeOrderPagedQuery, THeOrderPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeOrderPagedQuery, THeOrderPagedQueryVariables>(THeOrderPagedDocument, options);
        }
export type THeOrderPagedQueryHookResult = ReturnType<typeof useTHeOrderPagedQuery>;
export type THeOrderPagedLazyQueryHookResult = ReturnType<typeof useTHeOrderPagedLazyQuery>;
export type THeOrderPagedQueryResult = Apollo.QueryResult<THeOrderPagedQuery, THeOrderPagedQueryVariables>;
export function refetchTHeOrderPagedQuery(variables: THeOrderPagedQueryVariables) {
      return { query: THeOrderPagedDocument, variables: variables }
    }
export const THeOrderPdfDocument = gql`
    query THeOrderPDF($ackey: String!) {
  singleTHeOrder(where: {acKey: {eq: $ackey}}) {
    acKey
    anClerkNavigation {
      acName
      acSurname
    }
    acConsigneeNavigation {
      acName2
      acPin
      acAddress
      acPost
      acPostNavigation {
        acName
        acPost
      }
    }
    adDate
    adTimeIns
    tHeOrderItem {
      acIdent
      acName
      anQty
      anPrice
      acNote
      acUm
      anRebate
      anVat
    }
    anValue
    anDiscount
    anVat
    acCurrency
    anForPay
    acDeliveryNavigation {
      acName
    }
    acPayMethodNavigation {
      acName
    }
    acDoc2
    acNote
    acDocType
  }
}
    `;

/**
 * __useTHeOrderPdfQuery__
 *
 * To run a query within a React component, call `useTHeOrderPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeOrderPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeOrderPdfQuery({
 *   variables: {
 *      ackey: // value for 'ackey'
 *   },
 * });
 */
export function useTHeOrderPdfQuery(baseOptions: Apollo.QueryHookOptions<THeOrderPdfQuery, THeOrderPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeOrderPdfQuery, THeOrderPdfQueryVariables>(THeOrderPdfDocument, options);
      }
export function useTHeOrderPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeOrderPdfQuery, THeOrderPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeOrderPdfQuery, THeOrderPdfQueryVariables>(THeOrderPdfDocument, options);
        }
export type THeOrderPdfQueryHookResult = ReturnType<typeof useTHeOrderPdfQuery>;
export type THeOrderPdfLazyQueryHookResult = ReturnType<typeof useTHeOrderPdfLazyQuery>;
export type THeOrderPdfQueryResult = Apollo.QueryResult<THeOrderPdfQuery, THeOrderPdfQueryVariables>;
export function refetchTHeOrderPdfQuery(variables: THeOrderPdfQueryVariables) {
      return { query: THeOrderPdfDocument, variables: variables }
    }
export const THeSetDelMetsDocument = gql`
    query THeSetDelMets {
  tHeSetDelMet(where: {acActive: {eq: "T"}}) {
    acDelivery
    acName
  }
}
    `;

/**
 * __useTHeSetDelMetsQuery__
 *
 * To run a query within a React component, call `useTHeSetDelMetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeSetDelMetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeSetDelMetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTHeSetDelMetsQuery(baseOptions?: Apollo.QueryHookOptions<THeSetDelMetsQuery, THeSetDelMetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeSetDelMetsQuery, THeSetDelMetsQueryVariables>(THeSetDelMetsDocument, options);
      }
export function useTHeSetDelMetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeSetDelMetsQuery, THeSetDelMetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeSetDelMetsQuery, THeSetDelMetsQueryVariables>(THeSetDelMetsDocument, options);
        }
export type THeSetDelMetsQueryHookResult = ReturnType<typeof useTHeSetDelMetsQuery>;
export type THeSetDelMetsLazyQueryHookResult = ReturnType<typeof useTHeSetDelMetsLazyQuery>;
export type THeSetDelMetsQueryResult = Apollo.QueryResult<THeSetDelMetsQuery, THeSetDelMetsQueryVariables>;
export function refetchTHeSetDelMetsQuery(variables?: THeSetDelMetsQueryVariables) {
      return { query: THeSetDelMetsDocument, variables: variables }
    }
export const THeSetItemDocument = gql`
    query THeSetItem($search: String = "", $acWarehouse: String!, $minStock: Decimal!) {
  tHeSetItem(
    where: {and: {tHeStock: {some: {acWarehouse: {eq: $acWarehouse}, anStock: {gt: $minStock}}}, or: [{acName: {contains: $search}}, {acIdent: {contains: $search}}, {tHeSetItemExtItemSubj: {some: {acCode: {contains: $search}}}}, {acCode: {contains: $search}}], acActive: {eq: "T"}}}
    order: {acSetOfItem: ASC, acName: ASC}
  ) {
    acIdent
    acName
    acUm
    acCode
    acNote
    acSetOfItem
    anRtPrice
    anWsprice
    acActive
    tHeStock(where: {acWarehouse: {eq: $acWarehouse}, anStock: {gt: $minStock}}) {
      anStock
      anReserved
      acWarehouse
    }
  }
}
    `;

/**
 * __useTHeSetItemQuery__
 *
 * To run a query within a React component, call `useTHeSetItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeSetItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeSetItemQuery({
 *   variables: {
 *      search: // value for 'search'
 *      acWarehouse: // value for 'acWarehouse'
 *      minStock: // value for 'minStock'
 *   },
 * });
 */
export function useTHeSetItemQuery(baseOptions: Apollo.QueryHookOptions<THeSetItemQuery, THeSetItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeSetItemQuery, THeSetItemQueryVariables>(THeSetItemDocument, options);
      }
export function useTHeSetItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeSetItemQuery, THeSetItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeSetItemQuery, THeSetItemQueryVariables>(THeSetItemDocument, options);
        }
export type THeSetItemQueryHookResult = ReturnType<typeof useTHeSetItemQuery>;
export type THeSetItemLazyQueryHookResult = ReturnType<typeof useTHeSetItemLazyQuery>;
export type THeSetItemQueryResult = Apollo.QueryResult<THeSetItemQuery, THeSetItemQueryVariables>;
export function refetchTHeSetItemQuery(variables: THeSetItemQueryVariables) {
      return { query: THeSetItemDocument, variables: variables }
    }
export const THeSetItemOnlyOptionalFieldsDocument = gql`
    query THeSetItemOnlyOptionalFields($acIdent: String!) {
  singleTHeSetItem(where: {acIdent: {eq: $acIdent}}) {
    acFieldsA
    acFieldSb
    acFieldSc
    acFieldSd
    acFieldSe
    acFieldSf
    acFieldSg
    acFieldSh
    acFieldSi
    acFieldSj
  }
}
    `;

/**
 * __useTHeSetItemOnlyOptionalFieldsQuery__
 *
 * To run a query within a React component, call `useTHeSetItemOnlyOptionalFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeSetItemOnlyOptionalFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeSetItemOnlyOptionalFieldsQuery({
 *   variables: {
 *      acIdent: // value for 'acIdent'
 *   },
 * });
 */
export function useTHeSetItemOnlyOptionalFieldsQuery(baseOptions: Apollo.QueryHookOptions<THeSetItemOnlyOptionalFieldsQuery, THeSetItemOnlyOptionalFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeSetItemOnlyOptionalFieldsQuery, THeSetItemOnlyOptionalFieldsQueryVariables>(THeSetItemOnlyOptionalFieldsDocument, options);
      }
export function useTHeSetItemOnlyOptionalFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeSetItemOnlyOptionalFieldsQuery, THeSetItemOnlyOptionalFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeSetItemOnlyOptionalFieldsQuery, THeSetItemOnlyOptionalFieldsQueryVariables>(THeSetItemOnlyOptionalFieldsDocument, options);
        }
export type THeSetItemOnlyOptionalFieldsQueryHookResult = ReturnType<typeof useTHeSetItemOnlyOptionalFieldsQuery>;
export type THeSetItemOnlyOptionalFieldsLazyQueryHookResult = ReturnType<typeof useTHeSetItemOnlyOptionalFieldsLazyQuery>;
export type THeSetItemOnlyOptionalFieldsQueryResult = Apollo.QueryResult<THeSetItemOnlyOptionalFieldsQuery, THeSetItemOnlyOptionalFieldsQueryVariables>;
export function refetchTHeSetItemOnlyOptionalFieldsQuery(variables: THeSetItemOnlyOptionalFieldsQueryVariables) {
      return { query: THeSetItemOnlyOptionalFieldsDocument, variables: variables }
    }
export const THeSetItemPagedDocument = gql`
    query THeSetItemPaged($search: String = "", $acWarehouse: String!, $minStock: Decimal!, $subject: String, $acFieldsAContains: String!, $acClassif: String!, $dateNow: DateTime!, $cursor: String) {
  tHeSetItemPagedParametrizedV2(
    where: {tHeStock: {some: {and: {acWarehouse: {eq: $acWarehouse}, anStock: {gt: $minStock}}}}}
    after: $cursor
    acFieldsA: $acFieldsAContains
    acClassif: $acClassif
    search: $search
  ) {
    nodes {
      acIdent
      acName
      acUm
      acCode
      acNote
      acSetOfItem
      anRtPrice
      anWsprice
      acClassif
      acClassif2
      acUm2
      acColumn
      acSerialNo
      anUmtoUm2
      acActive
      anWsprice2
      anExcise
      acQtyInCode
      anQtyInCodeDecPlace
      tHeStock(where: {acWarehouse: {eq: $acWarehouse}, anStock: {gt: $minStock}}) {
        anStock
        anReserved
        acWarehouse
      }
      tHeSetSubjPriceItem(
        where: {acSubject: {eq: $subject}, and: {adDateStart: {lte: $dateNow}, or: [{adDateEnd: {eq: null}}, {adDateEnd: {gte: $dateNow}}]}}
        order: [{adDateStart: DESC}]
      ) {
        anPrice
        acSubject
        anRebate
      }
      tHeSetItemPriceForWrh(where: {acWarehouse: {eq: $acWarehouse}}) {
        anRtprice
        acWarehouse
      }
      acClassifNavigation {
        acName
      }
      tHeSetItemExtItemSubj {
        acCode
        acSubject
      }
      pHE_SearchContrctPriceAcClassif: pHE_SearchContrctPrice(
        classif2: false
        date: $dateNow
        priceList: "P"
        subject: $subject
      ) {
        cRetResult
        nRetRabat
        nRetRabat2
        nRetRabat3
        nRetCena
        nRetCenaMP
      }
      pHE_SearchContrctPriceAcClassif2: pHE_SearchContrctPrice(
        classif2: true
        date: $dateNow
        priceList: "P"
        subject: $subject
      ) {
        cRetResult
        nRetRabat
        nRetRabat2
        nRetRabat3
        nRetCena
        nRetCenaMP
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useTHeSetItemPagedQuery__
 *
 * To run a query within a React component, call `useTHeSetItemPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeSetItemPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeSetItemPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      acWarehouse: // value for 'acWarehouse'
 *      minStock: // value for 'minStock'
 *      subject: // value for 'subject'
 *      acFieldsAContains: // value for 'acFieldsAContains'
 *      acClassif: // value for 'acClassif'
 *      dateNow: // value for 'dateNow'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useTHeSetItemPagedQuery(baseOptions: Apollo.QueryHookOptions<THeSetItemPagedQuery, THeSetItemPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeSetItemPagedQuery, THeSetItemPagedQueryVariables>(THeSetItemPagedDocument, options);
      }
export function useTHeSetItemPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeSetItemPagedQuery, THeSetItemPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeSetItemPagedQuery, THeSetItemPagedQueryVariables>(THeSetItemPagedDocument, options);
        }
export type THeSetItemPagedQueryHookResult = ReturnType<typeof useTHeSetItemPagedQuery>;
export type THeSetItemPagedLazyQueryHookResult = ReturnType<typeof useTHeSetItemPagedLazyQuery>;
export type THeSetItemPagedQueryResult = Apollo.QueryResult<THeSetItemPagedQuery, THeSetItemPagedQueryVariables>;
export function refetchTHeSetItemPagedQuery(variables: THeSetItemPagedQueryVariables) {
      return { query: THeSetItemPagedDocument, variables: variables }
    }
export const THeSetItemCategPagedDocument = gql`
    query THeSetItemCategPaged($search: String = "", $acFieldsAContains: String!, $cursor: String) {
  tHeSetItemCategPagedParametrized(
    where: {and: {or: [{acClassif: {contains: $search}}, {acName: {contains: $search}}], acActive: {eq: "T"}}}
    order: {acClassif: ASC, acName: ASC}
    after: $cursor
    acFieldsA: $acFieldsAContains
  ) {
    nodes {
      acName
      acClassif
      tHeSetItemAcClassifNavigations(where: {acActive: {eq: "T"}}) {
        acFieldSa
        acActive
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useTHeSetItemCategPagedQuery__
 *
 * To run a query within a React component, call `useTHeSetItemCategPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeSetItemCategPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeSetItemCategPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      acFieldsAContains: // value for 'acFieldsAContains'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useTHeSetItemCategPagedQuery(baseOptions: Apollo.QueryHookOptions<THeSetItemCategPagedQuery, THeSetItemCategPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeSetItemCategPagedQuery, THeSetItemCategPagedQueryVariables>(THeSetItemCategPagedDocument, options);
      }
export function useTHeSetItemCategPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeSetItemCategPagedQuery, THeSetItemCategPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeSetItemCategPagedQuery, THeSetItemCategPagedQueryVariables>(THeSetItemCategPagedDocument, options);
        }
export type THeSetItemCategPagedQueryHookResult = ReturnType<typeof useTHeSetItemCategPagedQuery>;
export type THeSetItemCategPagedLazyQueryHookResult = ReturnType<typeof useTHeSetItemCategPagedLazyQuery>;
export type THeSetItemCategPagedQueryResult = Apollo.QueryResult<THeSetItemCategPagedQuery, THeSetItemCategPagedQueryVariables>;
export function refetchTHeSetItemCategPagedQuery(variables: THeSetItemCategPagedQueryVariables) {
      return { query: THeSetItemCategPagedDocument, variables: variables }
    }
export const THeSetItemExtItemSubjByBarcodeDocument = gql`
    query THeSetItemExtItemSubjByBarcode($barcode: String!, $acWarehouse: String!, $subject: String!, $dateNow: DateTime!) {
  singleTHeSetItem(
    where: {and: {or: [{tHeSetItemExtItemSubj: {some: {acCode: {eq: $barcode}}}}, {acCode: {eq: $barcode}}]}, tHeStock: {some: {acWarehouse: {eq: $acWarehouse}}}, acActive: {eq: "T"}}
  ) {
    acIdent
    acName
    acUm
    acCode
    acNote
    acSetOfItem
    anRtPrice
    anWsprice
    acUm2
    anUmtoUm2
    acActive
    anWsprice2
    anExcise
    acQtyInCode
    anQtyInCodeDecPlace
    tHeStock(where: {acWarehouse: {eq: $acWarehouse}}) {
      anStock
      anReserved
      acWarehouse
    }
    tHeSetSubjPriceItem(
      where: {acSubject: {eq: $subject}, and: {adDateStart: {lte: $dateNow}, or: [{adDateEnd: {eq: null}}, {adDateEnd: {gte: $dateNow}}]}}
      order: [{adDateStart: DESC}]
    ) {
      anPrice
      acSubject
      anRebate
    }
    tHeSetItemPriceForWrh(where: {acWarehouse: {eq: $acWarehouse}}) {
      anRtprice
      acWarehouse
    }
    acClassifNavigation {
      acName
    }
    tHeSetItemExtItemSubj {
      acCode
    }
  }
}
    `;

/**
 * __useTHeSetItemExtItemSubjByBarcodeQuery__
 *
 * To run a query within a React component, call `useTHeSetItemExtItemSubjByBarcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeSetItemExtItemSubjByBarcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeSetItemExtItemSubjByBarcodeQuery({
 *   variables: {
 *      barcode: // value for 'barcode'
 *      acWarehouse: // value for 'acWarehouse'
 *      subject: // value for 'subject'
 *      dateNow: // value for 'dateNow'
 *   },
 * });
 */
export function useTHeSetItemExtItemSubjByBarcodeQuery(baseOptions: Apollo.QueryHookOptions<THeSetItemExtItemSubjByBarcodeQuery, THeSetItemExtItemSubjByBarcodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeSetItemExtItemSubjByBarcodeQuery, THeSetItemExtItemSubjByBarcodeQueryVariables>(THeSetItemExtItemSubjByBarcodeDocument, options);
      }
export function useTHeSetItemExtItemSubjByBarcodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeSetItemExtItemSubjByBarcodeQuery, THeSetItemExtItemSubjByBarcodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeSetItemExtItemSubjByBarcodeQuery, THeSetItemExtItemSubjByBarcodeQueryVariables>(THeSetItemExtItemSubjByBarcodeDocument, options);
        }
export type THeSetItemExtItemSubjByBarcodeQueryHookResult = ReturnType<typeof useTHeSetItemExtItemSubjByBarcodeQuery>;
export type THeSetItemExtItemSubjByBarcodeLazyQueryHookResult = ReturnType<typeof useTHeSetItemExtItemSubjByBarcodeLazyQuery>;
export type THeSetItemExtItemSubjByBarcodeQueryResult = Apollo.QueryResult<THeSetItemExtItemSubjByBarcodeQuery, THeSetItemExtItemSubjByBarcodeQueryVariables>;
export function refetchTHeSetItemExtItemSubjByBarcodeQuery(variables: THeSetItemExtItemSubjByBarcodeQueryVariables) {
      return { query: THeSetItemExtItemSubjByBarcodeDocument, variables: variables }
    }
export const THeSetPayMetsDocument = gql`
    query THeSetPayMets {
  tHeSetPayMets(where: {acIsPosTerminal: {eq: "T"}}) {
    acPayMethod
    acFiscalGroup
    acName
  }
}
    `;

/**
 * __useTHeSetPayMetsQuery__
 *
 * To run a query within a React component, call `useTHeSetPayMetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeSetPayMetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeSetPayMetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTHeSetPayMetsQuery(baseOptions?: Apollo.QueryHookOptions<THeSetPayMetsQuery, THeSetPayMetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeSetPayMetsQuery, THeSetPayMetsQueryVariables>(THeSetPayMetsDocument, options);
      }
export function useTHeSetPayMetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeSetPayMetsQuery, THeSetPayMetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeSetPayMetsQuery, THeSetPayMetsQueryVariables>(THeSetPayMetsDocument, options);
        }
export type THeSetPayMetsQueryHookResult = ReturnType<typeof useTHeSetPayMetsQuery>;
export type THeSetPayMetsLazyQueryHookResult = ReturnType<typeof useTHeSetPayMetsLazyQuery>;
export type THeSetPayMetsQueryResult = Apollo.QueryResult<THeSetPayMetsQuery, THeSetPayMetsQueryVariables>;
export function refetchTHeSetPayMetsQuery(variables?: THeSetPayMetsQueryVariables) {
      return { query: THeSetPayMetsDocument, variables: variables }
    }
export const THeSetSubjPagedDocument = gql`
    query THeSetSubjPaged($search: String = "", $cursor: String, $acFieldSa: String, $acSupplier: String, $acBuyer: String) {
  tHeSetSubjPagedParametrized(
    where: {or: [{acSubject: {contains: $search}}, {acPin: {contains: $search}}], acActive: {eq: "T"}, acSubject: {neq: ""}}
    after: $cursor
    acFieldSa: $acFieldSa
    acBuyer: $acBuyer
    acSupplier: $acSupplier
  ) {
    nodes {
      acSubject
      acPin
      acName2
      acPost
      acAddress
      anRebate
      acPayer
      acPriceRate
      acPostNavigation {
        acName
      }
      acPayerNavigation {
        acPayer
        anRebate
        acPin
        acName2
        acPost
        acAddress
        acPriceRate
        acPostNavigation {
          acName
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useTHeSetSubjPagedQuery__
 *
 * To run a query within a React component, call `useTHeSetSubjPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHeSetSubjPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHeSetSubjPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      acFieldSa: // value for 'acFieldSa'
 *      acSupplier: // value for 'acSupplier'
 *      acBuyer: // value for 'acBuyer'
 *   },
 * });
 */
export function useTHeSetSubjPagedQuery(baseOptions?: Apollo.QueryHookOptions<THeSetSubjPagedQuery, THeSetSubjPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THeSetSubjPagedQuery, THeSetSubjPagedQueryVariables>(THeSetSubjPagedDocument, options);
      }
export function useTHeSetSubjPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THeSetSubjPagedQuery, THeSetSubjPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THeSetSubjPagedQuery, THeSetSubjPagedQueryVariables>(THeSetSubjPagedDocument, options);
        }
export type THeSetSubjPagedQueryHookResult = ReturnType<typeof useTHeSetSubjPagedQuery>;
export type THeSetSubjPagedLazyQueryHookResult = ReturnType<typeof useTHeSetSubjPagedLazyQuery>;
export type THeSetSubjPagedQueryResult = Apollo.QueryResult<THeSetSubjPagedQuery, THeSetSubjPagedQueryVariables>;
export function refetchTHeSetSubjPagedQuery(variables?: THeSetSubjPagedQueryVariables) {
      return { query: THeSetSubjPagedDocument, variables: variables }
    }
export const THrPrsnPagedDocument = gql`
    query THrPrsnPaged($search: String = "") {
  tHrPrsnPaged(where: {acActive: {eq: "T"}, acWorker: {contains: $search}}) {
    nodes {
      acName
      acWorker
      acActive
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useTHrPrsnPagedQuery__
 *
 * To run a query within a React component, call `useTHrPrsnPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTHrPrsnPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTHrPrsnPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTHrPrsnPagedQuery(baseOptions?: Apollo.QueryHookOptions<THrPrsnPagedQuery, THrPrsnPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<THrPrsnPagedQuery, THrPrsnPagedQueryVariables>(THrPrsnPagedDocument, options);
      }
export function useTHrPrsnPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<THrPrsnPagedQuery, THrPrsnPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<THrPrsnPagedQuery, THrPrsnPagedQueryVariables>(THrPrsnPagedDocument, options);
        }
export type THrPrsnPagedQueryHookResult = ReturnType<typeof useTHrPrsnPagedQuery>;
export type THrPrsnPagedLazyQueryHookResult = ReturnType<typeof useTHrPrsnPagedLazyQuery>;
export type THrPrsnPagedQueryResult = Apollo.QueryResult<THrPrsnPagedQuery, THrPrsnPagedQueryVariables>;
export function refetchTHrPrsnPagedQuery(variables?: THrPrsnPagedQueryVariables) {
      return { query: THrPrsnPagedDocument, variables: variables }
    }
export const ToggleMarservisItemStatusDocument = gql`
    mutation ToggleMarservisItemStatus($id: Int!) {
  markMarservisWorkOrderItemAsFinished(id: $id)
}
    `;
export type ToggleMarservisItemStatusMutationFn = Apollo.MutationFunction<ToggleMarservisItemStatusMutation, ToggleMarservisItemStatusMutationVariables>;

/**
 * __useToggleMarservisItemStatusMutation__
 *
 * To run a mutation, you first call `useToggleMarservisItemStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMarservisItemStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMarservisItemStatusMutation, { data, loading, error }] = useToggleMarservisItemStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleMarservisItemStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleMarservisItemStatusMutation, ToggleMarservisItemStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleMarservisItemStatusMutation, ToggleMarservisItemStatusMutationVariables>(ToggleMarservisItemStatusDocument, options);
      }
export type ToggleMarservisItemStatusMutationHookResult = ReturnType<typeof useToggleMarservisItemStatusMutation>;
export type ToggleMarservisItemStatusMutationResult = Apollo.MutationResult<ToggleMarservisItemStatusMutation>;
export type ToggleMarservisItemStatusMutationOptions = Apollo.BaseMutationOptions<ToggleMarservisItemStatusMutation, ToggleMarservisItemStatusMutationVariables>;
export const UpdateDocumentTypeDocument = gql`
    mutation UpdateDocumentType($id: Int!, $documentType: DocumentTypeUpdateDtoV2Input!) {
  updateDocumentTypeV2(id: $id, documentType: $documentType)
}
    `;
export type UpdateDocumentTypeMutationFn = Apollo.MutationFunction<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>;

/**
 * __useUpdateDocumentTypeMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentTypeMutation, { data, loading, error }] = useUpdateDocumentTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useUpdateDocumentTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>(UpdateDocumentTypeDocument, options);
      }
export type UpdateDocumentTypeMutationHookResult = ReturnType<typeof useUpdateDocumentTypeMutation>;
export type UpdateDocumentTypeMutationResult = Apollo.MutationResult<UpdateDocumentTypeMutation>;
export type UpdateDocumentTypeMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentTypeMutation, UpdateDocumentTypeMutationVariables>;
export const UpdateTHeSetItemDocument = gql`
    mutation UpdateTHeSetItem($acIdent: String!, $updates: Any) {
  updateTHeSetItem(acIdent: $acIdent, updates: $updates) {
    acIdent
    acFieldsA
    acFieldSb
    acFieldSc
    acFieldSd
    acFieldSe
    acFieldSf
    acFieldSg
    acFieldSh
    acFieldSi
    acFieldSj
  }
}
    `;
export type UpdateTHeSetItemMutationFn = Apollo.MutationFunction<UpdateTHeSetItemMutation, UpdateTHeSetItemMutationVariables>;

/**
 * __useUpdateTHeSetItemMutation__
 *
 * To run a mutation, you first call `useUpdateTHeSetItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTHeSetItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTHeSetItemMutation, { data, loading, error }] = useUpdateTHeSetItemMutation({
 *   variables: {
 *      acIdent: // value for 'acIdent'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateTHeSetItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTHeSetItemMutation, UpdateTHeSetItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTHeSetItemMutation, UpdateTHeSetItemMutationVariables>(UpdateTHeSetItemDocument, options);
      }
export type UpdateTHeSetItemMutationHookResult = ReturnType<typeof useUpdateTHeSetItemMutation>;
export type UpdateTHeSetItemMutationResult = Apollo.MutationResult<UpdateTHeSetItemMutation>;
export type UpdateTHeSetItemMutationOptions = Apollo.BaseMutationOptions<UpdateTHeSetItemMutation, UpdateTHeSetItemMutationVariables>;
export const UserDocument = gql`
    query User {
  user {
    id
    userName
    culture
    email
    emailConfirmed
    firstName
    lastName
    fullName
    isDeleted
    language
    alternativeUserId
    onixDesktopPantheonExePath
    onixDesktopPantheonIniPath
    onixDesktopPantheonExePathMac
    onixDesktopPantheonIniPathMac
    supportTimeLogsAlwaysNonBillable
    supportTopBarCountersOpenTicketList
    supportTimeLogRoundingMinutes
    webAppRouting {
      hasClassicAccess
      hasWebAppAccess
      autoRedirect
      hasTickets
    }
    pantheonUser {
      pantheonAcName
      pantheonAcRegNo
      pantheonAcUserId
      pantheonAcWorker
      pantheonAnUserId
      pantheonAcDelivery
    }
    mobileSettings {
      bluetoothPrinterAddress
      bluetoothPrinterName
      bluetoothPrinterPaperWidth
      bluetoothPrinterType
      useDarkTheme
      useListViewOnPickers
      useTabletMode
      useOnlyShortcuts
      useDocumentTypeCodesInTitles
    }
    userRoles {
      role {
        name
      }
    }
    documentTypes(order: {type: ASC}) {
      addingItemWarnIfQuantityMoreThanAvailable
      adminAllowChangingItemPrice
      adminDocumentOnCreateMakeWarehouseReservation
      adminItemQuantityMustBeInStock
      articleSearchShowOnlyInStock
      bluetoothPrintCopiesNumber
      documentOnCreateMakeBluetoothPrint
      documentOnCreateMakePDF
      functionality
      itemListShowDetailed
      stockViewShowOnlyInStock
      type
      warehouseName
      warehouseOverviewShowOnlyInStock
      id
      workOrderPrintSpecificationDuration
      syncPackagingWhenAddingNewItem
      articleSearchShowOnlyWhereAcFieldsAIs
      articleSearchAllowSearchingByClassification
      quantityDecimalPlaces
      create
      read
      update
      delete
      adminIgnoreRebate1
      adminIgnoreRebate2
      adminIgnoreRebate3
      adminEmphasizeInStock
      adminShowDailyIncome
      acWorkPlace
      acFiscalDevice
      adminDefaultAcPriceRate
      skipConfirmationOnShortcuts
      acName
      filterByAcDelivery
      filterByAcVerifyStatus
      filterByAcVerifiedPrices
      filterByAcDept
      printTicketNameOverride
      showDeliveryDeadlineDays
      showDeliveryMethod
      showPaymentMethod
      showAcDeliveryMobileFilterOnDocumentList
      showAcDeptMobileFilterOnDocumentList
      disallowChangingCustomer
      filterReceiversByAcFieldSa
      useDeadlineDateOnOverview
      dateFilterType
      groupAllDocumentTypesAtThisPoint
      filterByAcType
      jumpToEditAfterScanningItemWithBarcode
      forceShowAvailableOnStock
      warehousePositionTHeSetItemFieldName
      hideWarehouseOverview
      requireASignature
      acStatusIn
      acIssuerName
      acReceiverName
      acName3
    }
    companySettings {
      pantheonCompanyName
      pantheonAcCompanyPrtTextA
      pantheonAcCompanyPrtTextB
      pantheonAnDocKeyLenNumber
      pantheonCompanyImage
      pantheonAnDocKeyLenDocType
      pantheonAnQtyInCodeLen
      pantheonAcQtyInCodeCont
      applicationPackets {
        packet
      }
      connectionName
      bookStackUrl
      primaryCurrency
      useSecondaryCurrency
    }
    documentTypePairs {
      fromId
      toId
      functionality
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export function refetchUserQuery(variables?: UserQueryVariables) {
      return { query: UserDocument, variables: variables }
    }
export const UserInfoVersionHashDocument = gql`
    query UserInfoVersionHash {
  userInfoVersionHash
}
    `;

/**
 * __useUserInfoVersionHashQuery__
 *
 * To run a query within a React component, call `useUserInfoVersionHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoVersionHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoVersionHashQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInfoVersionHashQuery(baseOptions?: Apollo.QueryHookOptions<UserInfoVersionHashQuery, UserInfoVersionHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoVersionHashQuery, UserInfoVersionHashQueryVariables>(UserInfoVersionHashDocument, options);
      }
export function useUserInfoVersionHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoVersionHashQuery, UserInfoVersionHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoVersionHashQuery, UserInfoVersionHashQueryVariables>(UserInfoVersionHashDocument, options);
        }
export type UserInfoVersionHashQueryHookResult = ReturnType<typeof useUserInfoVersionHashQuery>;
export type UserInfoVersionHashLazyQueryHookResult = ReturnType<typeof useUserInfoVersionHashLazyQuery>;
export type UserInfoVersionHashQueryResult = Apollo.QueryResult<UserInfoVersionHashQuery, UserInfoVersionHashQueryVariables>;
export function refetchUserInfoVersionHashQuery(variables?: UserInfoVersionHashQueryVariables) {
      return { query: UserInfoVersionHashDocument, variables: variables }
    }
export const VopCashRegsPagedDocument = gql`
    query VOPCashRegsPaged($search: String = "", $cursor: String, $acDocType: String!, $subject: String!) {
  vOpCashReg(
    order: {ackey: DESC}
    after: $cursor
    where: {or: [{ackey: {contains: $search}}, {acSubject: {contains: $search}}], acDoctype: {eq: $acDocType}, acSubject: {eq: $subject}}
  ) {
    nodes {
      acDoctype
      ackey
      addate
      acSubject
      anPaid
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useVopCashRegsPagedQuery__
 *
 * To run a query within a React component, call `useVopCashRegsPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useVopCashRegsPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVopCashRegsPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *      acDocType: // value for 'acDocType'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useVopCashRegsPagedQuery(baseOptions: Apollo.QueryHookOptions<VopCashRegsPagedQuery, VopCashRegsPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VopCashRegsPagedQuery, VopCashRegsPagedQueryVariables>(VopCashRegsPagedDocument, options);
      }
export function useVopCashRegsPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VopCashRegsPagedQuery, VopCashRegsPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VopCashRegsPagedQuery, VopCashRegsPagedQueryVariables>(VopCashRegsPagedDocument, options);
        }
export type VopCashRegsPagedQueryHookResult = ReturnType<typeof useVopCashRegsPagedQuery>;
export type VopCashRegsPagedLazyQueryHookResult = ReturnType<typeof useVopCashRegsPagedLazyQuery>;
export type VopCashRegsPagedQueryResult = Apollo.QueryResult<VopCashRegsPagedQuery, VopCashRegsPagedQueryVariables>;
export function refetchVopCashRegsPagedQuery(variables: VopCashRegsPagedQueryVariables) {
      return { query: VopCashRegsPagedDocument, variables: variables }
    }
export const VopSetBoatNamesDocument = gql`
    query VOPSetBoatNames($subject: String!) {
  vOpSetBoatNames(where: {acsubject: {eq: $subject}}) {
    acsubject
    acBoatName
    anLenght
  }
}
    `;

/**
 * __useVopSetBoatNamesQuery__
 *
 * To run a query within a React component, call `useVopSetBoatNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVopSetBoatNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVopSetBoatNamesQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useVopSetBoatNamesQuery(baseOptions: Apollo.QueryHookOptions<VopSetBoatNamesQuery, VopSetBoatNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VopSetBoatNamesQuery, VopSetBoatNamesQueryVariables>(VopSetBoatNamesDocument, options);
      }
export function useVopSetBoatNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VopSetBoatNamesQuery, VopSetBoatNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VopSetBoatNamesQuery, VopSetBoatNamesQueryVariables>(VopSetBoatNamesDocument, options);
        }
export type VopSetBoatNamesQueryHookResult = ReturnType<typeof useVopSetBoatNamesQuery>;
export type VopSetBoatNamesLazyQueryHookResult = ReturnType<typeof useVopSetBoatNamesLazyQuery>;
export type VopSetBoatNamesQueryResult = Apollo.QueryResult<VopSetBoatNamesQuery, VopSetBoatNamesQueryVariables>;
export function refetchVopSetBoatNamesQuery(variables: VopSetBoatNamesQueryVariables) {
      return { query: VopSetBoatNamesDocument, variables: variables }
    }
export const VopSetBoatNamesPagedDocument = gql`
    query VOPSetBoatNamesPaged($search: String = "", $cursor: String) {
  vOpSetBoatNamePaged(
    where: {or: [{acBoatName: {contains: $search}}, {acsubject: {contains: $search}}]}
    after: $cursor
  ) {
    nodes {
      acsubject
      acBoatName
      anLenght
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useVopSetBoatNamesPagedQuery__
 *
 * To run a query within a React component, call `useVopSetBoatNamesPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useVopSetBoatNamesPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVopSetBoatNamesPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useVopSetBoatNamesPagedQuery(baseOptions?: Apollo.QueryHookOptions<VopSetBoatNamesPagedQuery, VopSetBoatNamesPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VopSetBoatNamesPagedQuery, VopSetBoatNamesPagedQueryVariables>(VopSetBoatNamesPagedDocument, options);
      }
export function useVopSetBoatNamesPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VopSetBoatNamesPagedQuery, VopSetBoatNamesPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VopSetBoatNamesPagedQuery, VopSetBoatNamesPagedQueryVariables>(VopSetBoatNamesPagedDocument, options);
        }
export type VopSetBoatNamesPagedQueryHookResult = ReturnType<typeof useVopSetBoatNamesPagedQuery>;
export type VopSetBoatNamesPagedLazyQueryHookResult = ReturnType<typeof useVopSetBoatNamesPagedLazyQuery>;
export type VopSetBoatNamesPagedQueryResult = Apollo.QueryResult<VopSetBoatNamesPagedQuery, VopSetBoatNamesPagedQueryVariables>;
export function refetchVopSetBoatNamesPagedQuery(variables?: VopSetBoatNamesPagedQueryVariables) {
      return { query: VopSetBoatNamesPagedDocument, variables: variables }
    }
export const VopSetDeptsDocument = gql`
    query VOPSetDepts {
  vOPSetDepts {
    acSubject
  }
}
    `;

/**
 * __useVopSetDeptsQuery__
 *
 * To run a query within a React component, call `useVopSetDeptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVopSetDeptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVopSetDeptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVopSetDeptsQuery(baseOptions?: Apollo.QueryHookOptions<VopSetDeptsQuery, VopSetDeptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VopSetDeptsQuery, VopSetDeptsQueryVariables>(VopSetDeptsDocument, options);
      }
export function useVopSetDeptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VopSetDeptsQuery, VopSetDeptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VopSetDeptsQuery, VopSetDeptsQueryVariables>(VopSetDeptsDocument, options);
        }
export type VopSetDeptsQueryHookResult = ReturnType<typeof useVopSetDeptsQuery>;
export type VopSetDeptsLazyQueryHookResult = ReturnType<typeof useVopSetDeptsLazyQuery>;
export type VopSetDeptsQueryResult = Apollo.QueryResult<VopSetDeptsQuery, VopSetDeptsQueryVariables>;
export function refetchVopSetDeptsQuery(variables?: VopSetDeptsQueryVariables) {
      return { query: VopSetDeptsDocument, variables: variables }
    }
export const VopSetItemCategsDocument = gql`
    query VOPSetItemCategs {
  vOPSetItemCategs {
    acClassif
    acdept
  }
}
    `;

/**
 * __useVopSetItemCategsQuery__
 *
 * To run a query within a React component, call `useVopSetItemCategsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVopSetItemCategsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVopSetItemCategsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVopSetItemCategsQuery(baseOptions?: Apollo.QueryHookOptions<VopSetItemCategsQuery, VopSetItemCategsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VopSetItemCategsQuery, VopSetItemCategsQueryVariables>(VopSetItemCategsDocument, options);
      }
export function useVopSetItemCategsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VopSetItemCategsQuery, VopSetItemCategsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VopSetItemCategsQuery, VopSetItemCategsQueryVariables>(VopSetItemCategsDocument, options);
        }
export type VopSetItemCategsQueryHookResult = ReturnType<typeof useVopSetItemCategsQuery>;
export type VopSetItemCategsLazyQueryHookResult = ReturnType<typeof useVopSetItemCategsLazyQuery>;
export type VopSetItemCategsQueryResult = Apollo.QueryResult<VopSetItemCategsQuery, VopSetItemCategsQueryVariables>;
export function refetchVopSetItemCategsQuery(variables?: VopSetItemCategsQueryVariables) {
      return { query: VopSetItemCategsDocument, variables: variables }
    }
export const VopSetItemCategsPagedDocument = gql`
    query VOPSetItemCategsPaged($cursor: String!) {
  vOPSetItemCategsPaged(after: $cursor) {
    nodes {
      acClassif
      acdept
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useVopSetItemCategsPagedQuery__
 *
 * To run a query within a React component, call `useVopSetItemCategsPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useVopSetItemCategsPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVopSetItemCategsPagedQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useVopSetItemCategsPagedQuery(baseOptions: Apollo.QueryHookOptions<VopSetItemCategsPagedQuery, VopSetItemCategsPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VopSetItemCategsPagedQuery, VopSetItemCategsPagedQueryVariables>(VopSetItemCategsPagedDocument, options);
      }
export function useVopSetItemCategsPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VopSetItemCategsPagedQuery, VopSetItemCategsPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VopSetItemCategsPagedQuery, VopSetItemCategsPagedQueryVariables>(VopSetItemCategsPagedDocument, options);
        }
export type VopSetItemCategsPagedQueryHookResult = ReturnType<typeof useVopSetItemCategsPagedQuery>;
export type VopSetItemCategsPagedLazyQueryHookResult = ReturnType<typeof useVopSetItemCategsPagedLazyQuery>;
export type VopSetItemCategsPagedQueryResult = Apollo.QueryResult<VopSetItemCategsPagedQuery, VopSetItemCategsPagedQueryVariables>;
export function refetchVopSetItemCategsPagedQuery(variables: VopSetItemCategsPagedQueryVariables) {
      return { query: VopSetItemCategsPagedDocument, variables: variables }
    }
export const VopSetItemsDocument = gql`
    query VOPSetItems {
  vOPSetItems(order: {acIdent: ASC}) {
    acIdent
    acName
    acClassif
    anSaleprice
    anRtprice
    acdept
    anVAT
    acShowDays
  }
}
    `;

/**
 * __useVopSetItemsQuery__
 *
 * To run a query within a React component, call `useVopSetItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVopSetItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVopSetItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVopSetItemsQuery(baseOptions?: Apollo.QueryHookOptions<VopSetItemsQuery, VopSetItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VopSetItemsQuery, VopSetItemsQueryVariables>(VopSetItemsDocument, options);
      }
export function useVopSetItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VopSetItemsQuery, VopSetItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VopSetItemsQuery, VopSetItemsQueryVariables>(VopSetItemsDocument, options);
        }
export type VopSetItemsQueryHookResult = ReturnType<typeof useVopSetItemsQuery>;
export type VopSetItemsLazyQueryHookResult = ReturnType<typeof useVopSetItemsLazyQuery>;
export type VopSetItemsQueryResult = Apollo.QueryResult<VopSetItemsQuery, VopSetItemsQueryVariables>;
export function refetchVopSetItemsQuery(variables?: VopSetItemsQueryVariables) {
      return { query: VopSetItemsDocument, variables: variables }
    }
export const VopSetItemsPagedDocument = gql`
    query VOPSetItemsPaged($cursor: String!) {
  vOPSetItemsPaged(after: $cursor) {
    nodes {
      acIdent
      acName
      acClassif
      anSaleprice
      anRtprice
      acdept
      anVAT
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useVopSetItemsPagedQuery__
 *
 * To run a query within a React component, call `useVopSetItemsPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useVopSetItemsPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVopSetItemsPagedQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useVopSetItemsPagedQuery(baseOptions: Apollo.QueryHookOptions<VopSetItemsPagedQuery, VopSetItemsPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VopSetItemsPagedQuery, VopSetItemsPagedQueryVariables>(VopSetItemsPagedDocument, options);
      }
export function useVopSetItemsPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VopSetItemsPagedQuery, VopSetItemsPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VopSetItemsPagedQuery, VopSetItemsPagedQueryVariables>(VopSetItemsPagedDocument, options);
        }
export type VopSetItemsPagedQueryHookResult = ReturnType<typeof useVopSetItemsPagedQuery>;
export type VopSetItemsPagedLazyQueryHookResult = ReturnType<typeof useVopSetItemsPagedLazyQuery>;
export type VopSetItemsPagedQueryResult = Apollo.QueryResult<VopSetItemsPagedQuery, VopSetItemsPagedQueryVariables>;
export function refetchVopSetItemsPagedQuery(variables: VopSetItemsPagedQueryVariables) {
      return { query: VopSetItemsPagedDocument, variables: variables }
    }
export const WarehousesListDocument = gql`
    query WarehousesList($search: String = "", $cursor: String) {
  tHeSetSubjPaged(
    where: {acActive: {eq: "T"}, acWarehouse: {eq: "T"}, or: [{acSubject: {contains: $search}}, {acName2: {contains: $search}}]}
    after: $cursor
  ) {
    nodes {
      acSubject
      acName2
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useWarehousesListQuery__
 *
 * To run a query within a React component, call `useWarehousesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehousesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehousesListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useWarehousesListQuery(baseOptions?: Apollo.QueryHookOptions<WarehousesListQuery, WarehousesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WarehousesListQuery, WarehousesListQueryVariables>(WarehousesListDocument, options);
      }
export function useWarehousesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarehousesListQuery, WarehousesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WarehousesListQuery, WarehousesListQueryVariables>(WarehousesListDocument, options);
        }
export type WarehousesListQueryHookResult = ReturnType<typeof useWarehousesListQuery>;
export type WarehousesListLazyQueryHookResult = ReturnType<typeof useWarehousesListLazyQuery>;
export type WarehousesListQueryResult = Apollo.QueryResult<WarehousesListQuery, WarehousesListQueryVariables>;
export function refetchWarehousesListQuery(variables?: WarehousesListQueryVariables) {
      return { query: WarehousesListDocument, variables: variables }
    }
export const WorkOrderBearerContactsDocument = gql`
    query WorkOrderBearerContacts($buyer: String!) {
  tHeSetSubjContact(where: {acSubject: {eq: $buyer}}) {
    acName
    acSurname
  }
}
    `;

/**
 * __useWorkOrderBearerContactsQuery__
 *
 * To run a query within a React component, call `useWorkOrderBearerContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderBearerContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderBearerContactsQuery({
 *   variables: {
 *      buyer: // value for 'buyer'
 *   },
 * });
 */
export function useWorkOrderBearerContactsQuery(baseOptions: Apollo.QueryHookOptions<WorkOrderBearerContactsQuery, WorkOrderBearerContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderBearerContactsQuery, WorkOrderBearerContactsQueryVariables>(WorkOrderBearerContactsDocument, options);
      }
export function useWorkOrderBearerContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderBearerContactsQuery, WorkOrderBearerContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderBearerContactsQuery, WorkOrderBearerContactsQueryVariables>(WorkOrderBearerContactsDocument, options);
        }
export type WorkOrderBearerContactsQueryHookResult = ReturnType<typeof useWorkOrderBearerContactsQuery>;
export type WorkOrderBearerContactsLazyQueryHookResult = ReturnType<typeof useWorkOrderBearerContactsLazyQuery>;
export type WorkOrderBearerContactsQueryResult = Apollo.QueryResult<WorkOrderBearerContactsQuery, WorkOrderBearerContactsQueryVariables>;
export function refetchWorkOrderBearerContactsQuery(variables: WorkOrderBearerContactsQueryVariables) {
      return { query: WorkOrderBearerContactsDocument, variables: variables }
    }
export const WorkOrderMaterialsPagedDocument = gql`
    query WorkOrderMaterialsPaged($search: String = "", $warehouse: String!, $cursor: String) {
  tHeSetItemPaged(
    where: {tHeStock: {some: {and: {acWarehouse: {eq: $warehouse}, anStock: {gt: 0}}}}, acSetOfItem: {neq: "800"}, or: [{acIdent: {contains: $search}}, {acName: {contains: $search}}]}
    after: $cursor
  ) {
    nodes {
      acName
      acIdent
      acUm
      acSetOfItem
      tHeStock(where: {anStock: {gt: 0}, acWarehouse: {eq: $warehouse}}) {
        anStock
        acWarehouse
      }
      tHeStockSerialNos {
        acSerialNo
        acWarehouse
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useWorkOrderMaterialsPagedQuery__
 *
 * To run a query within a React component, call `useWorkOrderMaterialsPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderMaterialsPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderMaterialsPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *      warehouse: // value for 'warehouse'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useWorkOrderMaterialsPagedQuery(baseOptions: Apollo.QueryHookOptions<WorkOrderMaterialsPagedQuery, WorkOrderMaterialsPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderMaterialsPagedQuery, WorkOrderMaterialsPagedQueryVariables>(WorkOrderMaterialsPagedDocument, options);
      }
export function useWorkOrderMaterialsPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderMaterialsPagedQuery, WorkOrderMaterialsPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderMaterialsPagedQuery, WorkOrderMaterialsPagedQueryVariables>(WorkOrderMaterialsPagedDocument, options);
        }
export type WorkOrderMaterialsPagedQueryHookResult = ReturnType<typeof useWorkOrderMaterialsPagedQuery>;
export type WorkOrderMaterialsPagedLazyQueryHookResult = ReturnType<typeof useWorkOrderMaterialsPagedLazyQuery>;
export type WorkOrderMaterialsPagedQueryResult = Apollo.QueryResult<WorkOrderMaterialsPagedQuery, WorkOrderMaterialsPagedQueryVariables>;
export function refetchWorkOrderMaterialsPagedQuery(variables: WorkOrderMaterialsPagedQueryVariables) {
      return { query: WorkOrderMaterialsPagedDocument, variables: variables }
    }
export const WorkOrderServiceSearchDocument = gql`
    query WorkOrderServiceSearch($search: String = "") {
  tHeSetItem(
    where: {and: {acSetOfItem: {eq: "703"}, or: [{acName: {contains: $search}}, {acIdent: {contains: $search}}]}}
  ) {
    acName
    acIdent
    acClassif
    acClassif2
    acNote
    acUm
    acSetOfItem
  }
}
    `;

/**
 * __useWorkOrderServiceSearchQuery__
 *
 * To run a query within a React component, call `useWorkOrderServiceSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderServiceSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderServiceSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useWorkOrderServiceSearchQuery(baseOptions?: Apollo.QueryHookOptions<WorkOrderServiceSearchQuery, WorkOrderServiceSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderServiceSearchQuery, WorkOrderServiceSearchQueryVariables>(WorkOrderServiceSearchDocument, options);
      }
export function useWorkOrderServiceSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderServiceSearchQuery, WorkOrderServiceSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderServiceSearchQuery, WorkOrderServiceSearchQueryVariables>(WorkOrderServiceSearchDocument, options);
        }
export type WorkOrderServiceSearchQueryHookResult = ReturnType<typeof useWorkOrderServiceSearchQuery>;
export type WorkOrderServiceSearchLazyQueryHookResult = ReturnType<typeof useWorkOrderServiceSearchLazyQuery>;
export type WorkOrderServiceSearchQueryResult = Apollo.QueryResult<WorkOrderServiceSearchQuery, WorkOrderServiceSearchQueryVariables>;
export function refetchWorkOrderServiceSearchQuery(variables?: WorkOrderServiceSearchQueryVariables) {
      return { query: WorkOrderServiceSearchDocument, variables: variables }
    }
export const WorkOrderSpecPagedDocument = gql`
    query WorkOrderSpecPaged($search: String = "") {
  tHeSetItemPaged(
    where: {and: {or: [{acIdent: {contains: $search}}, {acName: {contains: $search}}], acSetOfItem: {eq: "704"}}}
  ) {
    nodes {
      acIdent
      acName
      acNote
      acSetOfItem
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useWorkOrderSpecPagedQuery__
 *
 * To run a query within a React component, call `useWorkOrderSpecPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderSpecPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrderSpecPagedQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useWorkOrderSpecPagedQuery(baseOptions?: Apollo.QueryHookOptions<WorkOrderSpecPagedQuery, WorkOrderSpecPagedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOrderSpecPagedQuery, WorkOrderSpecPagedQueryVariables>(WorkOrderSpecPagedDocument, options);
      }
export function useWorkOrderSpecPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOrderSpecPagedQuery, WorkOrderSpecPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOrderSpecPagedQuery, WorkOrderSpecPagedQueryVariables>(WorkOrderSpecPagedDocument, options);
        }
export type WorkOrderSpecPagedQueryHookResult = ReturnType<typeof useWorkOrderSpecPagedQuery>;
export type WorkOrderSpecPagedLazyQueryHookResult = ReturnType<typeof useWorkOrderSpecPagedLazyQuery>;
export type WorkOrderSpecPagedQueryResult = Apollo.QueryResult<WorkOrderSpecPagedQuery, WorkOrderSpecPagedQueryVariables>;
export function refetchWorkOrderSpecPagedQuery(variables?: WorkOrderSpecPagedQueryVariables) {
      return { query: WorkOrderSpecPagedDocument, variables: variables }
    }
export const WorkflowTasksDocument = gql`
    query WorkflowTasks($cursor: String, $search: String!) {
  workflowTasks(
    after: $cursor
    order: {adCreatedOn: DESC}
    where: {or: [{acName: {contains: $search}}, {acTitle: {contains: $search}}, {acComments: {contains: $search}}, {acDescription: {contains: $search}}]}
  ) {
    nodes {
      acName
      acComments
      acTitle
      acDescription
      acTask
      adTimeIns
      adCreatedOn
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useWorkflowTasksQuery__
 *
 * To run a query within a React component, call `useWorkflowTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowTasksQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useWorkflowTasksQuery(baseOptions: Apollo.QueryHookOptions<WorkflowTasksQuery, WorkflowTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowTasksQuery, WorkflowTasksQueryVariables>(WorkflowTasksDocument, options);
      }
export function useWorkflowTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowTasksQuery, WorkflowTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowTasksQuery, WorkflowTasksQueryVariables>(WorkflowTasksDocument, options);
        }
export type WorkflowTasksQueryHookResult = ReturnType<typeof useWorkflowTasksQuery>;
export type WorkflowTasksLazyQueryHookResult = ReturnType<typeof useWorkflowTasksLazyQuery>;
export type WorkflowTasksQueryResult = Apollo.QueryResult<WorkflowTasksQuery, WorkflowTasksQueryVariables>;
export function refetchWorkflowTasksQuery(variables: WorkflowTasksQueryVariables) {
      return { query: WorkflowTasksDocument, variables: variables }
    }
export const WorkflowTasksCountDocument = gql`
    query WorkflowTasksCount {
  workflowTasksCount
}
    `;

/**
 * __useWorkflowTasksCountQuery__
 *
 * To run a query within a React component, call `useWorkflowTasksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowTasksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowTasksCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkflowTasksCountQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowTasksCountQuery, WorkflowTasksCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowTasksCountQuery, WorkflowTasksCountQueryVariables>(WorkflowTasksCountDocument, options);
      }
export function useWorkflowTasksCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowTasksCountQuery, WorkflowTasksCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowTasksCountQuery, WorkflowTasksCountQueryVariables>(WorkflowTasksCountDocument, options);
        }
export type WorkflowTasksCountQueryHookResult = ReturnType<typeof useWorkflowTasksCountQuery>;
export type WorkflowTasksCountLazyQueryHookResult = ReturnType<typeof useWorkflowTasksCountLazyQuery>;
export type WorkflowTasksCountQueryResult = Apollo.QueryResult<WorkflowTasksCountQuery, WorkflowTasksCountQueryVariables>;
export function refetchWorkflowTasksCountQuery(variables?: WorkflowTasksCountQueryVariables) {
      return { query: WorkflowTasksCountDocument, variables: variables }
    }